export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ArrivalDisplayRegistrationKey: any;
  BigInt: any;
  CurrencyCodeISO4217: any;
  CustomResourceSubCategoryType: any;
  Date: any;
  DateTime: any;
  Decimal: any;
  DocumentBody: any;
  ETag: any;
  IANATimezone: any;
  IPAddress: any;
  IPAddressCIDR: any;
  ISO8601Duration: any;
  ISO8601Timestamp: any;
  ISO8601_Duration: any;
  ISODateTime: any;
  IsoDateOnlyString: any;
  IsoLocalTimeString: any;
  JSON: any;
  Json: any;
  LocalDate: any;
  LocalEndTime: any;
  LocalTime: any;
  Markdown: any;
  MimeType: any;
  QueryOrchestratorPlaceholder: any;
  RecurrenceRule: any;
  TODO: any;
  Time: any;
  UUID: any;
  UUIDv4: any;
  UtcTime: any;
  Void: any;
  WorkflowEmail: any;
};

export type AbstractAnsweredTicketQuestionExpectingChoices = {
  choices: Array<AbstractTicketAnswerChoice>;
  question: AbstractTicketQuestionExpectingChoices;
};

export type AbstractTicketAnswerChoice = TicketAnswerMenuChoice | TicketQuestionOption;

export type AbstractTicketQuestionExpectingChoices = {
  chooseOnlyOneOption: Scalars['Boolean'];
  id: Scalars['ID'];
  options: Array<AbstractTicketQuestionOption>;
  prompt: Scalars['String'];
  required: Scalars['Boolean'];
};

export type AbstractTicketQuestionOption = {
  description: Maybe<Scalars['Markdown']>;
  id: Scalars['ID'];
  imageUrl: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type AccessPassResolvedPlaces = Campus | Level | Location | Organization | Space;

export type AccessPlace = {
  __typename: 'AccessPlace';
  id: Scalars['ID'];
  type: AccessPlaceType;
};

export enum AccessPlaceType {
  CAMPUS = 'CAMPUS',
  LEVEL = 'LEVEL',
  LOCATION = 'LOCATION',
  ORGANIZATION = 'ORGANIZATION',
  SPACE = 'SPACE'
}

export type AccountReservee = {
  __typename: 'AccountReservee';
  email: Scalars['String'];
  participationStatus: Maybe<ParticipationStatus>;
  user: Maybe<AccountUser>;
  visitorId: Maybe<Scalars['ID']>;
};

export type AccountUser = {
  __typename: 'AccountUser';
  assignments: Maybe<Array<Maybe<DraftDeskAssignmentSchedule>>>;
  assignmentsV2: Maybe<Array<Maybe<DraftDeskAssignmentSchedule>>>;
  avatar: Maybe<Scalars['String']>;
  canAndShouldAskForPresencePermissionInMobile: CanAndShouldAskForPresencePermissionInMobileResponse;
  canSelfEdit: Maybe<Scalars['Boolean']>;
  createdAt: Maybe<Scalars['String']>;
  defaultLocation: Maybe<Location>;
  department: Maybe<Scalars['String']>;
  draftAccessLevel: Maybe<DraftAccessLevel>;
  draftAccessLevelV2: Maybe<DraftAccessLevel>;
  email: Maybe<Scalars['String']>;
  familyName: Maybe<Scalars['String']>;
  geofenceFeatureEnabled: Scalars['Boolean'];
  givenName: Maybe<Scalars['String']>;
  groups: Array<Group>;
  id: Scalars['ID'];
  isMyFavorite: Maybe<Scalars['Boolean']>;
  manager: Maybe<AccountUser>;
  managerId: Maybe<Scalars['ID']>;
  name: Maybe<Scalars['String']>;
  primaryEmail: Maybe<Email>;
  reservationsAtLocationGroupedByDateAscending: Array<UserDeskReservationByDate>;
  /** Effective roles: assigned directly or inherited via group membership, deduped by slug. Consistent with the `roleSlug` filter, which also matches either way. Roles inherited via a group the caller may not see (sensitive groups without `groups:manage`) are omitted, mirroring `groups`. */
  roles: Array<Role>;
  slug: Maybe<Scalars['String']>;
  /** Five-state membership status backed by the user_status table. AccountUsers resolved outside the paged-users query (entity references, `manager`) fall back to the binary ACTIVE/DEACTIVATED derived from disabled_at. */
  status: UserStatus;
  timeZone: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['String']>;
  workingHours: Maybe<Array<Maybe<UserWorkingHour>>>;
};


export type AccountUserAssignmentsArgs = {
  draftId: Scalars['ID'];
};


export type AccountUserAssignmentsV2Args = {
  draftId: Scalars['ID'];
};


export type AccountUserDraftAccessLevelArgs = {
  draftId: Scalars['ID'];
};


export type AccountUserDraftAccessLevelV2Args = {
  draftId: Scalars['ID'];
};


export type AccountUserReservationsAtLocationGroupedByDateAscendingArgs = {
  endTime: Scalars['ISODateTime'];
  locationId: Scalars['ID'];
  startTime: Scalars['ISODateTime'];
};

export type ActivitiesByLocation = {
  __typename: 'ActivitiesByLocation';
  activities: Array<ActivityForCurrentUser>;
  locationId: Maybe<Scalars['String']>;
};

export type ActivitiesByLocationForStatusBoard = {
  __typename: 'ActivitiesByLocationForStatusBoard';
  activities: Array<ActivityForStatusBoard>;
  locationId: Maybe<Scalars['String']>;
};

export type ActivitiesForDateByLocationIdsInput = {
  date: Scalars['LocalDate'];
  joinedLimit?: InputMaybe<Scalars['Int']>;
  locationIds: Array<Scalars['String']>;
  timezone: Scalars['String'];
};

export type ActivitiesForDateRangeByLocationIdsInput = {
  endDate: Scalars['LocalDate'];
  joinedLimit?: InputMaybe<Scalars['Int']>;
  locationIds: Array<Scalars['String']>;
  startDate: Scalars['LocalDate'];
  timezone: Scalars['String'];
};

export type ActivitiesForTimeRangeByLocationIdsInput = {
  end: Scalars['ISODateTime'];
  joinedLimit?: InputMaybe<Scalars['Int']>;
  locationIds: Array<Scalars['String']>;
  start: Scalars['ISODateTime'];
  timezone: Scalars['String'];
};

export type ActivitiesForTimeRangeByLocationIdsPagingInput = {
  activityLimitPerDay?: InputMaybe<Scalars['Int']>;
};

export type ActivityCoverImagesObject = {
  __typename: 'ActivityCoverImagesObject';
  birthday: Scalars['String'];
  celebration: Scalars['String'];
  drinks: Scalars['String'];
  funAndGames: Scalars['String'];
  funAndMusic: Scalars['String'];
  gathering: Scalars['String'];
  holiday: Scalars['String'];
  lunch: Scalars['String'];
};

export type ActivityForCurrentUser = {
  __typename: 'ActivityForCurrentUser';
  activityLocation: Maybe<Scalars['String']>;
  audienceLocationId: Scalars['ID'];
  canceledAt: Maybe<Scalars['String']>;
  coverImage: Maybe<ActivityImage>;
  coverImageUrl: Maybe<Scalars['String']>;
  creator: User;
  description: Maybe<Scalars['String']>;
  end: Scalars['ISODateTime'];
  id: Scalars['ID'];
  joined: ActivityJoinersList;
  start: Scalars['ISODateTime'];
  timezone: Scalars['String'];
  title: Scalars['String'];
  userRelationship: ActivityUserRelationship;
  virtualLocation: Maybe<Scalars['String']>;
};

/** A lean Activity view for unattended status boards / kiosks. Excludes user-relative fields (no userRelationship, no joiners, no creator) so it can be served to callers that have no associated user (e.g. a paired board API token). */
export type ActivityForStatusBoard = {
  __typename: 'ActivityForStatusBoard';
  activityLocation: Maybe<Scalars['String']>;
  audienceLocationId: Scalars['ID'];
  canceledAt: Maybe<Scalars['String']>;
  coverImageUrl: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  end: Scalars['ISODateTime'];
  id: Scalars['ID'];
  start: Scalars['ISODateTime'];
  timezone: Scalars['String'];
  title: Scalars['String'];
  virtualLocation: Maybe<Scalars['String']>;
};

export type ActivityImage = {
  __typename: 'ActivityImage';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  isBuiltIn: Scalars['Boolean'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export type ActivityJoinersList = {
  __typename: 'ActivityJoinersList';
  joiners: Array<User>;
  totalCount: Scalars['Int'];
};

export type ActivityUserRelationship = {
  __typename: 'ActivityUserRelationship';
  canManage: Scalars['Boolean'];
  isAttending: Scalars['Boolean'];
};

/** One relationship to record. Every relationship carries a reason and a confidence, including the ones a human creates — an edge with no stated basis cannot be explained back to the next admin who wonders why a camera is in that room, and cannot be ranked against the evidence it competes with. Both are optional here because the common case is an operator acting through a screen, where the honest answer is already known: the reason is the manual rule for that kind and the confidence is total. Supply them when the caller knows better than that default — an importer replaying a decision made elsewhere, or a rule whose strength is computed from data, like the share of an endpoint's calls that landed in one room. */
export type AddEndpointRelationship = {
  /** 0..1. Defaults to the reason's own strength, which for the manual rules is 1.0. Precedence is not a matter of degree: a manual reason outranks every derived one for the same pair and kind, and confidence orders the rest. */
  confidence?: InputMaybe<Scalars['Float']>;
  /** The endpoint the relationship is about. Always an endpoint: a relationship between two places is not a fact about hardware. */
  endpointId: Scalars['ID'];
  kind: EndpointRelationshipKind;
  /** When this was observed. Defaults to now. Set it when replaying something that was true earlier, so recency tie-breaks stay honest. */
  observedAt?: InputMaybe<Scalars['DateTime']>;
  /** Defaults to the manual rule for this kind — MANUAL_LINK for IS_SAME_AS and ATTACHED_TO, MANUAL_ASSIGNMENT for WITHIN. Rejected if it names a rule only the service may assert, so a client cannot forge a SHARED_SERIAL. MANUAL_UNLINK is the one to pass deliberately. It asserts the negative — not the same hardware, not attached, not in that place — and holds against the next crawl re-deriving what the operator just overruled. */
  reason?: InputMaybe<EndpointRelationshipReason>;
  /** The other end. The same relatedTo the reads filter on and a relationship reads back, so one word means the far end everywhere. */
  relatedTo: EndpointOrPlaceInput;
};

export type AddEndpointRelationshipsInput = {
  relationships: Array<AddEndpointRelationship>;
};

export type AddEndpointRelationshipsResponse = {
  __typename: 'AddEndpointRelationshipsResponse';
  relationships: Array<EndpointRelationship>;
};

export type AddLevelToLocationResponse = {
  __typename: 'AddLevelToLocationResponse';
  id: Scalars['Int'];
};

export type AddLevelsToLocationResponse = {
  __typename: 'AddLevelsToLocationResponse';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type AddLevelsWithDetailsToLocationResponse = {
  __typename: 'AddLevelsWithDetailsToLocationResponse';
  id: Scalars['ID'];
  levelNumber: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type AddLocationToOrganizationResponse = {
  __typename: 'AddLocationToOrganizationResponse';
  id: Scalars['Int'];
};

export type AddMeetingServiceErrorResponse = {
  __typename: 'AddMeetingServiceErrorResponse';
  reason: Maybe<AddMeetingServiceErrorResponseReason>;
};

export enum AddMeetingServiceErrorResponseReason {
  CATEGORY_MISSING = 'CATEGORY_MISSING',
  /** This meeting service has kind=SPACE_REQUEST_FORM, and one of the desired spaces already has a request form */
  SPACE_ALREADY_HAS_REQUEST_FORM = 'SPACE_ALREADY_HAS_REQUEST_FORM'
}

export type AddMeetingServiceInput = {
  /** At least one user or group is required when kind is MEETING_SERVICE */
  assignees?: InputMaybe<UsersAndGroupsInput>;
  /** Provide one object per building, describing the spaces where this service is available. Must have permission to manage services in these buildings. */
  availableInSpacesByBuilding?: InputMaybe<Array<MeetingServiceAvailableInSpacesByBuildingInput>>;
  categoryId: Scalars['ID'];
  /** The currency for all monetary amounts in this service, like on menu item unitPrice. Required, but can be omitted for backwards compatibility. Clients should always pick a default currency, even if the logic is "always USD". */
  currencyCode?: InputMaybe<Scalars['CurrencyCodeISO4217']>;
  description?: InputMaybe<Scalars['Markdown']>;
  kind?: TicketWorkflowKind;
  /** The existence of approvers means approval is required before notifying assignees */
  multipleApprovers?: InputMaybe<UsersAndGroupsInput>;
  name: Scalars['String'];
  /** List of questions to ask when this service is requested, in order */
  questions: Array<TicketQuestionInput>;
};

export type AddMeetingServiceResponse = AddMeetingServiceErrorResponse | AddMeetingServiceSuccessResponse;

export type AddMeetingServiceSuccessResponse = {
  __typename: 'AddMeetingServiceSuccessResponse';
  meetingServiceId: Scalars['ID'];
};

export enum AddMeetingServicesCategoryErrorReason {
  NAME_IS_NOT_UNIQUE = 'NAME_IS_NOT_UNIQUE'
}

export type AddMeetingServicesCategoryErrorResponse = {
  __typename: 'AddMeetingServicesCategoryErrorResponse';
  reason: AddMeetingServicesCategoryErrorReason;
};

export type AddMeetingServicesCategoryInput = {
  /** 'CAT', 'TEC', etc. */
  key: Scalars['String'];
  /** Name must be unique in org among meeting services categories */
  name: Scalars['String'];
};

export type AddMeetingServicesCategoryResponse = AddMeetingServicesCategoryErrorResponse | AddMeetingServicesCategorySuccessResponse;

export type AddMeetingServicesCategorySuccessResponse = {
  __typename: 'AddMeetingServicesCategorySuccessResponse';
  meetingServicesCategoryId: Scalars['ID'];
};

export type AddOrganizationResponse = {
  __typename: 'AddOrganizationResponse';
  id: Scalars['Int'];
};

export type AddSpaceToEventRequest = {
  endTime: Scalars['Date'];
  eventId: Scalars['String'];
  spaceId: Scalars['String'];
  startTime: Scalars['Date'];
};

export enum AddTicketIntegrationTargetConfigsErrorReason {
  NOT_ACTIVE = 'NOT_ACTIVE',
  NOT_CONNECTED = 'NOT_CONNECTED',
  NOT_FOUND = 'NOT_FOUND',
  PROVIDER_CAPABILITY_MISSING = 'PROVIDER_CAPABILITY_MISSING',
  PROVIDER_REJECTED = 'PROVIDER_REJECTED',
  PROVIDER_UNREACHABLE = 'PROVIDER_UNREACHABLE',
  /** One or more of the requested targets is not stored, and the last target import did not succeed (it has not run, is queued or running, or failed), so they may still exist; see `unknownTargets` and try again once it succeeds. */
  TARGET_IMPORT_INCOMPLETE = 'TARGET_IMPORT_INCOMPLETE',
  /** The last target import did not find one or more of the requested targets; see `unknownTargets`. */
  TARGET_NOT_FOUND = 'TARGET_NOT_FOUND'
}

export type AddTicketIntegrationTargetConfigsErrorResponse = {
  __typename: 'AddTicketIntegrationTargetConfigsErrorResponse';
  reason: AddTicketIntegrationTargetConfigsErrorReason;
  unknownTargets: Array<Scalars['String']>;
};

export type AddTicketIntegrationTargetConfigsInput = {
  /** `externalTargetObject` values from `listTicketIntegrationAvailableTargets`. */
  externalTargetObjects: Array<Scalars['String']>;
  integrationId: Scalars['ID'];
};

export type AddTicketIntegrationTargetConfigsResponse = AddTicketIntegrationTargetConfigsErrorResponse | AddTicketIntegrationTargetConfigsSuccessResponse;

export type AddTicketIntegrationTargetConfigsSuccessResponse = {
  __typename: 'AddTicketIntegrationTargetConfigsSuccessResponse';
  targetConfigs: Array<TicketIntegrationTargetConfig>;
};

export type AllSchedules = {
  __typename: 'AllSchedules';
  schedules: Maybe<Array<Maybe<WeeklyScheduleResult>>>;
};

export type AllocateStickersToOrgByDisplayCodeRequest = {
  displayCodes: Array<Scalars['Int']>;
  orgId: Scalars['ID'];
};

export type AllocateStickersToOrgRequest = {
  orgId: Scalars['ID'];
  stickerIds: Array<Scalars['ID']>;
};

/** One way of placing a variation's seats across a building's floors. */
export type Allocation = {
  __typename: 'Allocation';
  /** The variation this draft implements, as copied onto it when it was created. */
  allocation: StackPlanAllocation;
  description: Maybe<Scalars['String']>;
  floors: Array<FloorAllocation>;
  id: Scalars['ID'];
  name: Scalars['String'];
  stackPlanId: Scalars['ID'];
  status: DraftStatus;
  /** Business units whose floor split does not add up to the copied variation. Empty when the split is complete. */
  unsatisfied: Array<UnsatisfiedBusinessUnit>;
  /** Pass back when updating, so a concurrent edit is not silently overwritten. */
  version: Scalars['Int'];
};

/** How much of one resource a business unit is allotted, in some scope. */
export type AllocationResource = {
  __typename: 'AllocationResource';
  count: Scalars['Int'];
  type: AllocationResourceType;
};

export type AllocationResourceInput = {
  count: Scalars['Int'];
  type: AllocationResourceType;
};

export enum AllocationResourceType {
  DESK = 'DESK'
}

export type Amenity = {
  __typename: 'Amenity';
  /** If the account ID is null, this means it's a global amenity and available to all orgs */
  accountId: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  name: Scalars['String'];
  ownerTypes: Array<OwnerType>;
  updatedAt: Scalars['Date'];
  /** Stable identifier from robin-api, as 32 lowercase hex characters. Null for records that have not been assigned one yet. */
  uuid: Maybe<Scalars['ID']>;
};

export type AmenitySelectionConfiguration = {
  isDeskAmenity: Scalars['Boolean'];
  isSpaceAmenity: Scalars['Boolean'];
};

/** Splitting away from Amenity to avoid breaking changes. This will resolve to a default if amenity is not found */
export type AmenityWithDefault = {
  __typename: 'AmenityWithDefault';
  /** If the account ID is null, this means it's a global amenity and available to all orgs */
  accountId: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
  ownerTypes: Maybe<Array<OwnerType>>;
  updatedAt: Maybe<Scalars['Date']>;
  /** Stable identifier from robin-api, as 32 lowercase hex characters. Null for records that have not been assigned one yet. */
  uuid: Maybe<Scalars['ID']>;
};

export type AnalyticsAuthorizationResponse = {
  __typename: 'AnalyticsAuthorizationResponse';
  token: Scalars['String'];
};

/** An Announcement is an office message created for given location(s) in an organization. It can be acknowledged by each user in a given org/location, and updated/archived by an admin(?). */
export type Announcement = {
  __typename: 'Announcement';
  /** Datetime of when annoucnement was instantly archived */
  archivedAt: Maybe<Scalars['Date']>;
  /** User that created the announcement */
  author: User;
  /** Current content of the announcement */
  content: Scalars['String'];
  /** Datetime of creation */
  createdAt: Scalars['Date'];
  /** Datetime of end of announcement */
  endAt: Maybe<Scalars['Date']>;
  /** Unique identifier */
  id: Scalars['ID'];
  /** List of locations for which the announcement has been published */
  locations: Array<Maybe<Location>>;
  /** Display name */
  name: Scalars['String'];
  /** Standard or priority announcement */
  priorityStatus: AnnouncementPriorityStatus;
  /** Datetime of start of announcement */
  startAt: Scalars['Date'];
  /** Current status of the announcement */
  status: AnnouncementStatus;
};

/** Acknowledgement of an announcement for a user at a location. */
export type AnnouncementAcknowledgement = {
  __typename: 'AnnouncementAcknowledgement';
  announcementId: Scalars['ID'];
  date: Scalars['ISODateTime'];
  id: Scalars['ID'];
  locationId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type AnnouncementCreateInput = {
  content: Scalars['String'];
  distributions?: InputMaybe<Array<DistributionInput>>;
  endAt?: InputMaybe<Scalars['ISODateTime']>;
  locations: Array<Scalars['ID']>;
  name: Scalars['String'];
  priorityStatus?: InputMaybe<AnnouncementPriorityStatus>;
  shouldSendPushNotification?: InputMaybe<Scalars['Boolean']>;
  startAt?: InputMaybe<Scalars['ISODateTime']>;
};

/** Each announcement distribution will represent a service the announcement is cross posted to along with its recipients. */
export type AnnouncementDistribution = {
  __typename: 'AnnouncementDistribution';
  distributionService: DistributionService;
  id: Scalars['ID'];
  recipients: Array<DistributionRecipient>;
  sentAt: Maybe<Scalars['Date']>;
};

/** Each announcement distribution for location will represent a service the announcement is cross posted to along with its recipients and the announcement with its location. */
export type AnnouncementDistributionForLocation = {
  __typename: 'AnnouncementDistributionForLocation';
  announcement: Maybe<AnnouncementForLocation>;
  distributionService: DistributionService;
  id: Scalars['ID'];
  recipients: Array<DistributionRecipient>;
  sentAt: Maybe<Scalars['Date']>;
};

/** An Announcement within a context of a specific location. */
export type AnnouncementForLocation = {
  __typename: 'AnnouncementForLocation';
  /** Datetime of when annoucnement was instantly archived */
  archivedAt: Maybe<Scalars['Date']>;
  /** User that created the announcement */
  author: User;
  /** Current content of the announcement */
  content: Scalars['String'];
  /** Datetime of creation */
  createdAt: Scalars['Date'];
  /** Datetime of end of announcement */
  endAt: Maybe<Scalars['Date']>;
  /** Unique identifier */
  id: Scalars['ID'];
  /** List of locations for which the announcement has been published */
  locations: Array<Maybe<Location>>;
  /** Display name */
  name: Scalars['String'];
  /** Standard or priority announcement */
  priorityStatus: AnnouncementPriorityStatus;
  /** Datetime of start of announcement */
  startAt: Scalars['Date'];
  /** Current status of the announcement */
  status: AnnouncementStatus;
  /** When the requesting user has first viewed the announcement at this location */
  viewedAt: Maybe<Scalars['String']>;
};

/** A lean Announcement view for unattended status boards / kiosks. Excludes user-relative fields (no viewedAt, no author, no locations) so it can be served to callers that have no associated user (e.g. a paired board API token). */
export type AnnouncementForStatusBoard = {
  __typename: 'AnnouncementForStatusBoard';
  /** Current content of the announcement */
  content: Scalars['String'];
  /** Datetime of end of announcement */
  endAt: Maybe<Scalars['Date']>;
  /** Unique identifier */
  id: Scalars['ID'];
  /** Display name */
  name: Scalars['String'];
  /** Standard or priority announcement */
  priorityStatus: AnnouncementPriorityStatus;
  /** Datetime of start of announcement */
  startAt: Scalars['Date'];
  /** Current status of the announcement */
  status: AnnouncementStatus;
};

export enum AnnouncementPriorityStatus {
  PRIORITY = 'PRIORITY',
  STANDARD = 'STANDARD'
}

export enum AnnouncementStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  SCHEDULED = 'SCHEDULED'
}

export type AnnouncementUpdateInput = {
  content: Scalars['String'];
  endAt?: InputMaybe<Scalars['ISODateTime']>;
  locations: Array<Scalars['ID']>;
  name: Scalars['String'];
  startAt?: InputMaybe<Scalars['ISODateTime']>;
};

/** View of an announcement for a user at a location. */
export type AnnouncementView = {
  __typename: 'AnnouncementView';
  announcementId: Scalars['ID'];
  date: Scalars['ISODateTime'];
  id: Scalars['ID'];
  locationId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type AnnouncementViewAcknowledgeCount = {
  __typename: 'AnnouncementViewAcknowledgeCount';
  acknowledgeCount: Scalars['Int'];
  viewCount: Scalars['Int'];
};

export type AnnouncementViewAcknowledgeCountWithId = {
  __typename: 'AnnouncementViewAcknowledgeCountWithId';
  acknowledgeCount: Scalars['Int'];
  id: Scalars['ID'];
  viewCount: Scalars['Int'];
};

export type AnonymityModeToggleInput = {
  organizationId: Scalars['ID'];
};

export type AnsweredTicketQuestion = {
  question: TicketQuestion;
};

export type AnsweredTicketQuestionExpectingChoices = AbstractAnsweredTicketQuestionExpectingChoices & AnsweredTicketQuestion & {
  __typename: 'AnsweredTicketQuestionExpectingChoices';
  choices: Array<TicketQuestionOption>;
  question: TicketQuestionExpectingChoices;
};

export type AnsweredTicketQuestionExpectingFiles = AnsweredTicketQuestion & {
  __typename: 'AnsweredTicketQuestionExpectingFiles';
  files: Array<TicketFile>;
  question: TicketQuestionExpectingFiles;
};

export type AnsweredTicketQuestionExpectingImages = AnsweredTicketQuestion & {
  __typename: 'AnsweredTicketQuestionExpectingImages';
  images: Array<TicketImage>;
  question: TicketQuestionExpectingImages;
};

export type AnsweredTicketQuestionExpectingMenuChoices = AbstractAnsweredTicketQuestionExpectingChoices & AnsweredTicketQuestion & {
  __typename: 'AnsweredTicketQuestionExpectingMenuChoices';
  choices: Array<TicketAnswerMenuChoice>;
  question: TicketQuestionExpectingMenuChoices;
  /** The total price for everything selected on this menu, after any surcharges/taxes. */
  totalPrice: Maybe<Money>;
};

export type AnsweredTicketQuestionExpectingText = AnsweredTicketQuestion & {
  __typename: 'AnsweredTicketQuestionExpectingText';
  answer: Scalars['String'];
  question: TicketQuestionExpectingText;
};

export type AnsweredTicketQuestionInput = {
  choices?: InputMaybe<TicketAnswerExpectingChoicesInput>;
  files?: InputMaybe<TicketAnswerExpectingFilesInput>;
  images?: InputMaybe<TicketAnswerExpectingImagesInput>;
  menuChoices?: InputMaybe<TicketAnswerExpectingMenuChoicesInput>;
  text?: InputMaybe<TicketAnswerExpectingTextInput>;
  /** Optional questions are allowed to omit their answers entirely, but this is useful if you want to remove an existing answer. */
  unanswered?: InputMaybe<UnansweredTicketQuestionInput>;
};

export type ApiOrganizationExternalAccount = {
  __typename: 'ApiOrganizationExternalAccount';
  accessToken: Maybe<Scalars['String']>;
  accountId: Scalars['ID'];
  domain: Maybe<Scalars['String']>;
  externalId: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  state: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
};

export type App = EventAuditLogActor & {
  __typename: 'App';
  id: Scalars['ID'];
};

export enum ApproveMeetingServiceRequestErrorReason {
  CONFLICT = 'CONFLICT'
}

export type ApproveMeetingServiceRequestErrorResponse = {
  __typename: 'ApproveMeetingServiceRequestErrorResponse';
  reason: ApproveMeetingServiceRequestErrorReason;
};

export type ApproveMeetingServiceRequestInput = {
  latestChangeId: Scalars['ID'];
  meetingServiceRequestId: Scalars['ID'];
};

export type ApproveMeetingServiceRequestResponse = ApproveMeetingServiceRequestErrorResponse | ApproveMeetingServiceRequestSuccessResponse;

export type ApproveMeetingServiceRequestSuccessResponse = {
  __typename: 'ApproveMeetingServiceRequestSuccessResponse';
  _: Maybe<Scalars['Void']>;
};

export type ArrivalDisplay = {
  __typename: 'ArrivalDisplay';
  /** @deprecated No longer supported */
  arrivalDisplayDeviceStatusReport: Maybe<DeviceStatusReport>;
  badgePrinter: Maybe<BadgePrinter>;
  /**
   * the device status of the associated badge printer
   * @deprecated No longer supported
   */
  badgePrinterDeviceStatusReport: Maybe<DeviceStatusReport>;
  /** @deprecated prefer traversing tree to badge printer to get IP address */
  badgePrinterIPAddress: Scalars['String'];
  /** The date this arrival display was created */
  createdAt: Scalars['ISODateTime'];
  id: Scalars['ID'];
  isGuestImageCaptureEnabled: Scalars['Boolean'];
  isGuestSelfRegistrationEnabled: Scalars['Boolean'];
  /** The last time the device reported in */
  lastCheckinTime: Maybe<Scalars['ISODateTime']>;
  /** location where display resides; null if the location has been deleted */
  location: Maybe<Location>;
  /** Name of this arrival display */
  name: Scalars['String'];
  /** True if the registration key has been consumed */
  registrationConsumed: Scalars['Boolean'];
  /** ISO datetime representing when the registration key was consumed */
  registrationConsumedAt: Maybe<Scalars['ISODateTime']>;
  /** ISO datetime encoded expiration of the active device registration key */
  registrationExpiresAt: Maybe<Scalars['ISODateTime']>;
  /** One-time registration key used to connect arrival display for first authentication, nullable */
  registrationKey: Maybe<Scalars['ArrivalDisplayRegistrationKey']>;
};

export type ArrivalDisplayRegistrationResponse = {
  __typename: 'ArrivalDisplayRegistrationResponse';
  authorization: DeviceAuthorizationResponse;
  certKey: Scalars['String'];
  device: ArrivalDisplay;
  id: Scalars['ID'];
};

export type ArrivalDisplayRescueResponse = {
  __typename: 'ArrivalDisplayRescueResponse';
  authorization: Maybe<DeviceAuthorizationResponse>;
  id: Scalars['ID'];
  isPaired: Scalars['Boolean'];
};

export type ArrivalDisplaySettings = {
  __typename: 'ArrivalDisplaySettings';
  badgePrinterIPAddress: Scalars['String'];
  guestImageCaptureEnabled: Scalars['Boolean'];
  guestSelfRegistrationEnabled: Scalars['Boolean'];
};

export type AssignStickerRequest = {
  assignments: Array<StickerAssignmentInput>;
};

export type AssignStickerResponse = {
  __typename: 'AssignStickerResponse';
  assignments: Array<StickerAssignment>;
};

export type AssignStickerToCustomResourceByShortCodeRequest = {
  customResourceInstanceId: Scalars['ID'];
  stickerShortCode: Scalars['String'];
};

export type AssignStickerToCustomResourceByShortCodeResponse = {
  __typename: 'AssignStickerToCustomResourceByShortCodeResponse';
  customResourceInstanceId: Scalars['ID'];
  stickerShortCode: Scalars['String'];
};

export type AssignStickerToDeskByShortCodeRequest = {
  deskId: Scalars['Int'];
  stickerShortCode: Scalars['String'];
};

export type AssignStickerToDeskByShortCodeResponse = {
  __typename: 'AssignStickerToDeskByShortCodeResponse';
  deskId: Scalars['Int'];
  stickerShortCode: Scalars['String'];
};

export type AssignedBookability = {
  __typename: 'AssignedBookability';
  bookable: Maybe<Scalars['Int']>;
  notBookable: Maybe<Scalars['Int']>;
};

export type AssignedUser = {
  __typename: 'AssignedUser';
  email: Maybe<Scalars['String']>;
  familyName: Maybe<Scalars['String']>;
  givenName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
};

export type Assignee = {
  __typename: 'Assignee';
  avatar: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  isDisabled: Maybe<Scalars['Boolean']>;
  name: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['String']>;
};

export type AssigneeInput = {
  email?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type AssigneePayload = {
  __typename: 'AssigneePayload';
  email: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['ID']>;
};

export type Assignment = {
  __typename: 'Assignment';
  assignee: Assignee;
  id: Maybe<Scalars['ID']>;
  recurrence: Scalars['String'];
};

export type AssignmentData = {
  __typename: 'AssignmentData';
  new: Maybe<AssignmentState>;
  previous: Maybe<AssignmentState>;
};

/** Draft-scoped facet for the people list, keyed on a single draft. Provide at least one of: - assignmentStatus → filter to users assigned/unassigned within the draft. - filterQueue: true → restrict to users in the draft's assignment queue. For a building draft, levelId is required (per-floor queues); for a floor draft levelId is ignored. Omit the whole object to apply no draft-scoped filtering. */
export type AssignmentDraftFilter = {
  assignmentStatus?: InputMaybe<DraftAssignmentStatus>;
  draftId: Scalars['ID'];
  filterQueue?: InputMaybe<Scalars['Boolean']>;
  levelId?: InputMaybe<Scalars['ID']>;
};

export type AssignmentInput = {
  assignee: AssigneeInput;
  recurrence: Scalars['String'];
};

export type AssignmentPayload = {
  __typename: 'AssignmentPayload';
  assignee: AssigneePayload;
  recurrence: Scalars['String'];
};

export type AssignmentRecommendationCandidate = {
  __typename: 'AssignmentRecommendationCandidate';
  buildingId: Scalars['ID'];
  buildingName: Scalars['String'];
  levelId: Scalars['ID'];
  levelName: Scalars['String'];
  /** Human-readable signals, e.g. '2 teammate assignment(s) in this zone' */
  reasoning: Array<Scalars['String']>;
  /** Zone-level affinity score this candidate inherited */
  score: Scalars['Float'];
  seatId: Scalars['ID'];
  seatName: Scalars['String'];
  zoneId: Scalars['ID'];
  zoneName: Scalars['String'];
};

export type AssignmentRecommendationResult = {
  __typename: 'AssignmentRecommendationResult';
  alternatives: Array<AssignmentRecommendationCandidate>;
  /** Notes about the calculation: why no recommendation could be made, or which signals were degraded */
  reasoning: Array<Scalars['String']>;
  recommendation: Maybe<AssignmentRecommendationCandidate>;
  /** Persisted recommendation id; null when nothing could be recommended */
  recommendationId: Maybe<Scalars['ID']>;
};

export type AssignmentState = {
  __typename: 'AssignmentState';
  id: Scalars['ID'];
  name: Scalars['String'];
  neighborhood: Maybe<Scalars['String']>;
  recurrence: Scalars['String'];
  zone: Scalars['String'];
};

export type AuditUserObject = {
  __typename: 'AuditUserObject';
  avatar: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Maybe<Scalars['String']>;
};

export type AuditUserWithAccessLevelObject = {
  __typename: 'AuditUserWithAccessLevelObject';
  accessLevel: DraftAccessLevel;
  avatar: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Maybe<Scalars['String']>;
};

export enum AuthContextAccountUserRole {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
  OWNER = 'OWNER'
}

export enum AuthContextAppScope {
  BASIC_READ = 'BASIC_READ',
  BASIC_WRITE = 'BASIC_WRITE',
  PRIVILEGED = 'PRIVILEGED'
}

export enum AuthContextOrganizationScope {
  BASIC_READ = 'BASIC_READ',
  BASIC_WRITE = 'BASIC_WRITE'
}

export type AuthMethod = {
  __typename: 'AuthMethod';
  type: Scalars['String'];
  uri: Maybe<Scalars['String']>;
};

export type AuthorizationResponse = {
  __typename: 'AuthorizationResponse';
  bearerToken: Scalars['String'];
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
  refreshToken: Scalars['String'];
  userId: Scalars['ID'];
};

export type AutoAllocateStickersToOrgRequest = {
  orgId: Scalars['ID'];
  quantity: Scalars['Int'];
  startingDisplayCode: Scalars['Int'];
};

export type AutoDeskBookingAttemptedResponseType = {
  __typename: 'AutoDeskBookingAttemptedResponseType';
  autoDeskBookingAttemptFailed: Scalars['Boolean'];
  id: Scalars['ID'];
  localDate: Scalars['LocalDate'];
};

export type AutoDeskBookingInternalResponse = {
  __typename: 'AutoDeskBookingInternalResponse';
  locationIds: Array<Scalars['ID']>;
  orgId: Scalars['ID'];
};

export type AutoDeskBookingOrgInput = {
  enabled: Scalars['Boolean'];
  locationIds: Array<InputMaybe<Scalars['String']>>;
};

export type AutoDeskBookingOrgResponse = {
  __typename: 'AutoDeskBookingOrgResponse';
  enabled: Scalars['Boolean'];
  locationIds: Array<Scalars['String']>;
};

/** Auto desk booking run failure report */
export type AutoDeskBookingProcessFailureReportCommand = {
  /** Explanation of failure. Open field. Stack trace could also be provided. */
  failureBody: Scalars['String'];
  /** Code for convenient grouping of failures by type. Convention is entirely up to the client software. */
  failureCode: Scalars['String'];
};

export type AutoDeskBookingResponse = {
  __typename: 'AutoDeskBookingResponse';
  autoDeskBooking: Scalars['Boolean'];
};

export type AutoDeskBookingScheduleResponse = {
  __typename: 'AutoDeskBookingScheduleResponse';
  localDate: Scalars['LocalDate'];
  reservation: Maybe<Reservation>;
};

/** Failed booking a user report */
export type AutoDeskBookingUserBatchFailureReportCommand = {
  /** Explanation of failure. Open field. Stack trace could also be provided. */
  failureBody: Scalars['String'];
  /** Code for convenient grouping of failures by type. Convention is entirely up to the client software. */
  failureCode: Scalars['String'];
  /** Date of attempted booking */
  localBookingDate: Scalars['LocalDate'];
  /** ID of failed booking location */
  locationId: Scalars['ID'];
  /** ID of organization */
  tenantId: Scalars['ID'];
  /** ID of user */
  userId: Scalars['ID'];
};

export type AutoUnassignmentAction = {
  __typename: 'AutoUnassignmentAction';
  backwardChange: DeskChangePayload;
  email: Maybe<Scalars['String']>;
  forwardChange: DeskChangePayload;
  newDeskNames: Array<Scalars['String']>;
  previousDeskNames: Array<Scalars['String']>;
  userId: Maybe<Scalars['ID']>;
};

export enum Availability {
  /** Currently available */
  AVAILABLE = 'AVAILABLE',
  /** Resource has been booked */
  BOOKED = 'BOOKED',
  /** Resource marked as unavailable for booking */
  UNAVAILABLE = 'UNAVAILABLE',
  /** Resource marked as unknown due to desk inexistence */
  UNKNOWN = 'UNKNOWN'
}

export type BadgeCsvUploadRow = {
  __typename: 'BadgeCSVUploadRow';
  email: Scalars['String'];
  timestamp: Scalars['Int'];
};

export type BadgeCsvUploadStatusError = {
  __typename: 'BadgeCSVUploadStatusError';
  reason: Scalars['String'];
  row: Maybe<BadgeCsvUploadRow>;
};

/** A connected badge-presence integration for the current tenant. */
export type BadgePresenceConnection = {
  __typename: 'BadgePresenceConnection';
  connectedAt: Scalars['String'];
  integrationUuid: Scalars['ID'];
  isDisabled: Scalars['Boolean'];
  isTestMode: Scalars['Boolean'];
  name: Maybe<Scalars['String']>;
  source: BadgePresenceConnectionSource;
  vendor: Scalars['String'];
};

/** Which kind of badge-presence integration a connection came from. Lets clients distinguish sources without relying on the free-text vendor. */
export enum BadgePresenceConnectionSource {
  UNIVERSAL_CONNECTOR = 'UNIVERSAL_CONNECTOR'
}

/** A single badge-presence record. */
export type BadgePresenceDoorEntryRecord = {
  __typename: 'BadgePresenceDoorEntryRecord';
  email: Scalars['String'];
  failureReason: Maybe<Scalars['String']>;
  integrationName: Maybe<Scalars['String']>;
  integrationUuid: Scalars['ID'];
  location: Maybe<Location>;
  occurredAt: Scalars['String'];
  robinLevelId: Maybe<Scalars['Int']>;
  sourceId: Maybe<Scalars['String']>;
  status: BadgePresenceDoorEntryRecordStatus;
  targetId: Maybe<Scalars['Int']>;
  targetType: Maybe<BadgePresenceDoorEntryRecordTargetType>;
  uuid: Scalars['ID'];
  vendor: Scalars['String'];
};

export enum BadgePresenceDoorEntryRecordStatus {
  FAILED = 'FAILED',
  IGNORED = 'IGNORED',
  PENDING = 'PENDING',
  REPORTED = 'REPORTED',
  SUCCESS = 'SUCCESS'
}

export enum BadgePresenceDoorEntryRecordTargetType {
  LEVEL = 'LEVEL',
  LOCATION = 'LOCATION'
}

export type BadgePrinter = {
  __typename: 'BadgePrinter';
  arrivalDisplays: Maybe<Array<Maybe<ArrivalDisplay>>>;
  /** The date this badge printer was created */
  createdAt: Scalars['ISODateTime'];
  id: Scalars['ID'];
  ipAddress: Scalars['String'];
  location: Location;
  /** Name of this badge printer */
  name: Scalars['String'];
};

export type BatchUnlinkKisiLocksFromRobinLevelsInput = {
  remoteLockIds: Array<Scalars['String']>;
};

export type BatchUnlinkKisiLocksFromRobinLevelsResponse = {
  __typename: 'BatchUnlinkKisiLocksFromRobinLevelsResponse';
  uuid: Maybe<Scalars['ID']>;
};

export type BatchUnlinkKisiLocksFromRobinLocationsInput = {
  remoteLockIds: Array<Scalars['String']>;
};

export type BatchUnlinkKisiLocksFromRobinLocationsResponse = {
  __typename: 'BatchUnlinkKisiLocksFromRobinLocationsResponse';
  uuid: Maybe<Scalars['ID']>;
};

export type BeginFileUploadsForTicketAnswerErrorResponse = {
  __typename: 'BeginFileUploadsForTicketAnswerErrorResponse';
  _: Maybe<Scalars['Void']>;
};

export type BeginFileUploadsForTicketAnswerInput = {
  /** List of files to request upload URLs for */
  files: Array<TicketFileUploadInput>;
  /** The ID of the question being answered */
  questionId: Scalars['ID'];
};

export type BeginFileUploadsForTicketAnswerResponse = BeginFileUploadsForTicketAnswerErrorResponse | BeginFileUploadsForTicketAnswerSuccessResponse;

export type BeginFileUploadsForTicketAnswerSuccessResponse = {
  __typename: 'BeginFileUploadsForTicketAnswerSuccessResponse';
  destinations: Array<TicketFileUploadDestination>;
};

export enum BeginTicketIntegrationOAuthErrorReason {
  NOT_FOUND = 'NOT_FOUND',
  NOT_OAUTH_PROVIDER = 'NOT_OAUTH_PROVIDER',
  /** The provider's OAuth client is not configured for this deployment (e.g. a missing Jira/Zendesk client id). */
  PROVIDER_NOT_CONFIGURED = 'PROVIDER_NOT_CONFIGURED',
  RETURN_URL_NOT_ALLOWED = 'RETURN_URL_NOT_ALLOWED'
}

export type BeginTicketIntegrationOAuthErrorResponse = {
  __typename: 'BeginTicketIntegrationOAuthErrorResponse';
  reason: BeginTicketIntegrationOAuthErrorReason;
};

export type BeginTicketIntegrationOAuthResponse = BeginTicketIntegrationOAuthErrorResponse | BeginTicketIntegrationOAuthSuccessResponse;

export type BeginTicketIntegrationOAuthSuccessResponse = {
  __typename: 'BeginTicketIntegrationOAuthSuccessResponse';
  authorizeUrl: Scalars['String'];
};

export type BookedSchedulingAggregateOfDesks = {
  __typename: 'BookedSchedulingAggregateOfDesks';
  /** Total number of desks of type Assigned that are booked */
  deskAssignedBookedTotal: Scalars['Int'];
  /** Total number of booked desks */
  deskBookedTotal: Scalars['Int'];
  /** Total number of desks of type Hot that are booked */
  deskHotBookedTotal: Scalars['Int'];
  /** Total number of desks of type Hotel that are booked */
  deskHotelBookedTotal: Scalars['Int'];
  /** Total number of desks of type Shared that are booked */
  deskSharedBookedTotal: Scalars['Int'];
  /** Represents the end time window for assessed desk booking status */
  endTime: Scalars['Date'];
  /** Represents the start time window for assessed desk booking status */
  startTime: Scalars['Date'];
};

export enum BookingPolicyType {
  /** Indicate the desk may be indefinitely assigned to a particular user. */
  ASSIGNED = 'ASSIGNED',
  /** Indicate that the desk is available to be booked for short term use. */
  HOT = 'HOT',
  /** Indicate that the desk may be reserved for a defined period duration. */
  HOTELED = 'HOTELED',
  /** Indicate that the desk may be reverse hoteled on an excluded assigned reservation. */
  REVERSE_HOTEL = 'REVERSE_HOTEL',
  /** Indicate that more people can be assigned to a single desk. Only used in combination with either ASSIGNED or HOTELED types */
  SHARED = 'SHARED'
}

export enum BookingStatus {
  APPROVAL_REQUIRED = 'APPROVAL_REQUIRED',
  ASSIGNED = 'ASSIGNED',
  NON_RESERVABLE = 'NON_RESERVABLE',
  ON_DEMAND = 'ON_DEMAND',
  RESERVABLE = 'RESERVABLE'
}

export enum BookingType {
  APPROVAL_REQUIRED = 'APPROVAL_REQUIRED',
  ASSIGNED = 'ASSIGNED',
  NON_RESERVABLE = 'NON_RESERVABLE',
  ON_DEMAND = 'ON_DEMAND',
  RESERVABLE = 'RESERVABLE'
}

export type BookingWindowPolicy = {
  __typename: 'BookingWindowPolicy';
  affectedGroups: Array<BookingWindowPolicyAffectedGroup>;
  affectedUsers: Array<BookingWindowPolicyAffectedUser>;
  defaultDuration: Scalars['ISO8601Duration'];
  id: Scalars['ID'];
  name: Scalars['String'];
  targets: Array<BookingWindowPolicyTarget>;
};

export type BookingWindowPolicyAffectedGroup = {
  __typename: 'BookingWindowPolicyAffectedGroup';
  anchorDays: Array<DayOfWeek>;
  duration: Scalars['ISO8601Duration'];
  group: Group;
};

export type BookingWindowPolicyAffectedGroupInput = {
  anchorDays: Array<DayOfWeek>;
  duration: Scalars['ISO8601Duration'];
  id: Scalars['ID'];
};

export type BookingWindowPolicyAffectedUser = {
  __typename: 'BookingWindowPolicyAffectedUser';
  anchorDays: Array<DayOfWeek>;
  duration: Scalars['ISO8601Duration'];
  user: AccountUser;
};

export type BookingWindowPolicyAffectedUserInput = {
  anchorDays: Array<DayOfWeek>;
  duration: Scalars['ISO8601Duration'];
  id: Scalars['ID'];
};

export type BookingWindowPolicyDefinitionInput = {
  affectedGroups: Array<BookingWindowPolicyAffectedGroupInput>;
  affectedUsers: Array<BookingWindowPolicyAffectedUserInput>;
  defaultDuration: Scalars['ISO8601Duration'];
  name: Scalars['String'];
  targets: Array<BookingWindowPolicyTargetInput>;
};

export type BookingWindowPolicyInfo = {
  __typename: 'BookingWindowPolicyInfo';
  defaultAnchorDays: Maybe<Array<Maybe<DayOfWeek>>>;
  defaultDuration: Maybe<Scalars['String']>;
  policyAnchorDays: Maybe<Array<Maybe<DayOfWeek>>>;
  policyDuration: Maybe<Scalars['String']>;
};

export type BookingWindowPolicyTarget = Level | Zone;

export type BookingWindowPolicyTargetInput = {
  id: Scalars['ID'];
  type: BookingWindowPolicyTargetType;
};

export enum BookingWindowPolicyTargetType {
  LEVEL = 'LEVEL',
  ZONE = 'ZONE'
}

export enum BrivoTenancy {
  EU = 'EU',
  US = 'US'
}

export type Building = {
  __typename: 'Building';
  id: Scalars['ID'];
  label: Scalars['String'];
};

/** A building's durable record of one discovery run: what the crawl found for that building, keyed by run. Deliberately a separate query from endpointDiscoveryStatus rather than more fields on it: that one is tenant-scoped live progress for a polling screen, this is a building-scoped, durable, possibly-historical report — same event stream, different questions, so they stay different shapes. The count field names match the timeline's, so the live view and the report read consistently side by side. */
export type BuildingDiscoveryReport = {
  __typename: 'BuildingDiscoveryReport';
  /** Call-ended events examined across the run's window. Null until the run finishes collecting history — the same indeterminate-during-collection rule as the timeline's baselineCallCount, because this report can default to a run that is still in flight. */
  baselineCallCount: Maybe<Scalars['Int']>;
  /** The Robin spaces this run's correlations placed devices in. Space is resolvable at the gateway, so names resolve there without a join here. */
  correlatedSpaces: Array<Space>;
  /** Correlations that produced a link. Null until the run completes — nothing records a count mid-correlation. */
  correlationSuccessCount: Maybe<Scalars['Int']>;
  /** Hardware problems the run observed, oldest first. */
  hardwareIncidents: Array<HardwareIncident>;
  lastUpdatedAt: Scalars['DateTime'];
  phase: DiscoveryPhase;
  robinLocationId: Scalars['ID'];
  /** Distinct Google Calendar/Meet room resources the run found. Null until the run reaches planning, like the timeline's roomResourceCount. */
  roomResourceCount: Maybe<Scalars['Int']>;
  runId: Scalars['ID'];
  startedAt: Scalars['DateTime'];
};

export type BuildingDiscoveryReportResponse = {
  __typename: 'BuildingDiscoveryReportResponse';
  /** Null when the building has no run — discovery never ran for it, the requested run is not one of its runs, or the building id is not one of this tenant's buildings. */
  report: Maybe<BuildingDiscoveryReport>;
};

/** A building draft the caller can open, and how. Returned by getBuildingDraftsForUser. */
export type BuildingDraftForUser = {
  __typename: 'BuildingDraftForUser';
  /** editor for somebody who can plan the building; otherwise the level the draft was shared with them at. */
  accessLevel: DraftAccessLevel;
  /** The building this draft covers. */
  buildingId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  status: DraftStatus;
};

export type BuildingDraftInput = {
  buildingId: Scalars['ID'];
  /** The allocation draft this scenario implements. Set it to make the draft the fourth level of a stack plan: the allocation says how many seats each business unit gets on each floor, and this draft places the people. A reference, not ownership — the draft keeps its own `parent_id` for its floor children, and no status cascade crosses this edge. The allocation must belong to the same building. */
  derivedFrom?: InputMaybe<Scalars['ID']>;
  /** Create this draft at `live_state` instead of `open`: a copy of the building's live state, absent from every drafts listing and not publishable. For callers that need to READ who sits where without leaving a plan behind — there is one per building, so find the existing one before creating another. A product surface creating a draft somebody will publish should leave this unset. */
  liveState?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type BuildingDraftPublishedMetadata = {
  __typename: 'BuildingDraftPublishedMetadata';
  buildingId: Maybe<Scalars['ID']>;
  buildingName: Maybe<Scalars['String']>;
  draftName: Scalars['String'];
  floors: Array<DraftFloorInfo>;
  publishedAt: Maybe<Scalars['String']>;
  publishedBy: Maybe<Scalars['String']>;
};

export type BuildingFilterOption = {
  __typename: 'BuildingFilterOption';
  /** The location id, suitable for passing back into GlobalSearchFilter.locationIds. */
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type BuildingGeofence = {
  __typename: 'BuildingGeofence';
  buildingId: Scalars['ID'];
  geojson: BuildingGeofenceGeoJson;
  id: Scalars['ID'];
};

export type BuildingGeofenceGeoJson = {
  __typename: 'BuildingGeofenceGeoJSON';
  geometry: BuildingGeofenceGeoJsonGeometry;
  id: Scalars['ID'];
  properties: BuildingGeofenceGeoJsonProperties;
  type: GeoJsonType;
};

export type BuildingGeofenceGeoJsonGeometry = {
  __typename: 'BuildingGeofenceGeoJSONGeometry';
  coordinates: Array<Scalars['Float']>;
  type: BuildingGeofenceGeoJsonGeometryType;
};

export enum BuildingGeofenceGeoJsonGeometryType {
  POINT = 'Point'
}

export type BuildingGeofenceGeoJsonProperties = {
  __typename: 'BuildingGeofenceGeoJSONProperties';
  id: Scalars['ID'];
  radius: Scalars['Float'];
};

/** A built-in entity-type filter (USER, DESK, or SPACE). The `entityType` alone is enough to pass back as an `EntityTypeFilterSelection`. */
export type BuiltInEntityTypeFilterOption = EntityTypeFilterOption & {
  __typename: 'BuiltInEntityTypeFilterOption';
  displayName: Scalars['String'];
  entityType: GlobalSearchEntityType;
};

/** Response for a single reservation in bulk confirmation */
export type BulkResourceReservationConfirmationItem = {
  __typename: 'BulkResourceReservationConfirmationItem';
  reservationId: Scalars['ID'];
  result: ResourceReservationConfirmationResponse;
};

/** Response for bulk reservation confirmation */
export type BulkResourceReservationConfirmationResponse = {
  __typename: 'BulkResourceReservationConfirmationResponse';
  /** Results for each reservation confirmation attempt */
  confirmations: Array<BulkResourceReservationConfirmationItem>;
  /** Number of failed confirmations */
  failureCount: Scalars['Int'];
  /** Number of successful confirmations */
  successCount: Scalars['Int'];
  /** Total number of reservations processed */
  totalProcessed: Scalars['Int'];
};

export type BusinessUnitAllocation = {
  __typename: 'BusinessUnitAllocation';
  businessUnitId: Scalars['ID'];
  resources: Array<AllocationResource>;
};

export type BusinessUnitAllocationInput = {
  businessUnitId: Scalars['ID'];
  resources: Array<AllocationResourceInput>;
};

export type ByWeekDayValue = {
  offset?: InputMaybe<Scalars['Int']>;
  weekday: RecurringReservationDayOfWeek;
};

export type Calendar = {
  __typename: 'Calendar';
  calendarId: Scalars['String'];
  createdAt: Maybe<Scalars['Date']>;
  remoteType: Scalars['String'];
  spaceId: Scalars['ID'];
  spaceResourceEmail: Maybe<Scalars['String']>;
  spaceResourceId: Maybe<Scalars['String']>;
  subscriberExpiresAt: Maybe<Scalars['Date']>;
  subscriberId: Maybe<Scalars['String']>;
  syncToken: Maybe<Scalars['String']>;
};

export enum CalendarHealthEnum {
  /** Calendar is functioning correctly */
  HEALTHY = 'HEALTHY',
  /** Calendar has sync or other issues */
  UNHEALTHY = 'UNHEALTHY'
}

/** A conferencing call that took place in a room. Platform-agnostic core; concrete types (e.g. MeetCall) add the raw per-platform detail behind this contract. */
export type Call = {
  /** How long the call ran, in minutes. */
  durationMinutes: Maybe<Scalars['Int']>;
  /** Stable identifier for this call. */
  id: Scalars['ID'];
  /** The specific problems detected on the call, each typed and graded. Empty for a clean call and when the platform reports no quality numbers: read `quality` to tell those apart (null = nothing reported, GOOD = clean). */
  issues: Array<CallIssue>;
  /** How many devices joined the call, not how many people. The platform audit stream this is derived from counts conferencing hardware, so a room of six people on one Meet unit counts as one. */
  participantCount: Maybe<Scalars['Int']>;
  /** The platform the call ran on. */
  platform: CallPlatform;
  /** Normalized quality, or null when the platform reports no quality numbers. */
  quality: Maybe<CallQuality>;
  /** When the call started. */
  startedAt: Scalars['DateTime'];
};

/** One typed problem detected on a call, at a single severity. */
export type CallIssue = {
  __typename: 'CallIssue';
  /** Which kind of problem this is. */
  code: CallIssueCode;
  /** How bad it was. */
  severity: CallIssueSeverity;
};

/** A specific, typed way a call fell short, for an at-a-glance readout. */
export enum CallIssueCode {
  /** Audio packet loss: choppy or robotic sound. */
  AUDIO_DROPPING = 'AUDIO_DROPPING',
  /** Video packet loss or a low frame rate: choppy or blocky picture. */
  LOW_VIDEO = 'LOW_VIDEO',
  /** High jitter or network congestion: audio and video stutter. */
  NETWORK_SLOW = 'NETWORK_SLOW',
  /** Screen share packet loss: the shared screen tore or froze. */
  SCREEN_SHARE = 'SCREEN_SHARE'
}

/** How much an issue degraded the call. Mirrors the non-good quality bands. */
export enum CallIssueSeverity {
  FAIR = 'FAIR',
  POOR = 'POOR'
}

/** A conferencing platform a call ran on. */
export enum CallPlatform {
  MEET = 'MEET',
  OTHER = 'OTHER',
  TEAMS = 'TEAMS',
  WEBEX = 'WEBEX',
  ZOOM = 'ZOOM'
}

/** Normalized call quality, when the platform reports it. */
export enum CallQuality {
  FAIR = 'FAIR',
  GOOD = 'GOOD',
  POOR = 'POOR'
}

export type Campus = {
  __typename: 'Campus';
  /** Total desks on the floor - excluding inactive. */
  activeDeskCount: Maybe<Scalars['Int']>;
  createdAt: Scalars['Date'];
  /** Total desks within the campus that fit within various scheduling type and status buckets */
  deskSchedulingAggregates: SchedulingAggregateOfDesks;
  id: Scalars['ID'];
  locations: Array<Location>;
  name: Scalars['String'];
  /** @deprecated Use `activeDeskCount` instead */
  totalDesks: Scalars['Int'];
  updatedAt: Scalars['Date'];
  /** Stable identifier from robin-api, as 32 lowercase hex characters. */
  uuid: Scalars['ID'];
};

export type CancelEventV2Error = {
  __typename: 'CancelEventV2Error';
  message: Maybe<Scalars['String']>;
  reason: CancelEventV2FailReason;
};

/** Why the cancel was refused. */
export enum CancelEventV2FailReason {
  /** No event with that ID is visible to the actor. */
  EVENT_NOT_FOUND = 'EVENT_NOT_FOUND',
  /** robin-api rejected the request for another reason; see message. */
  INVALID_INPUT = 'INVALID_INPUT',
  /** The actor may not cancel this event (as the organizer, or as the room when asSpace is true). An actor who may not see the event at all gets a GraphQL error instead. */
  LACKING_PERMISSIONS = 'LACKING_PERMISSIONS',
  /** A series scope was sent for an event that does not recur. */
  NOT_RECURRING = 'NOT_RECURRING',
  /** The calendar provider does not allow this scope on this path. Today that is THIS_AND_FOLLOWING as the room on Google, which does not let a non-organizer shorten a series; cancel THIS_EVENT or ALL_EVENTS instead. */
  SCOPE_NOT_SUPPORTED = 'SCOPE_NOT_SUPPORTED',
  UNKNOWN = 'UNKNOWN'
}

/** Input for cancelEventV2. Nothing here has a default: cancelling a series when one occurrence was meant cannot be undone, and cancelling as the room can mean releasing the room while the meeting goes on, so both choices are the caller's to make explicitly. */
export type CancelEventV2Input = {
  /** Act as the room instead of as the organizer. This is how someone who may not cancel the meeting itself, but manages the room it is booked in, frees the room. When that room's calendar organizes the event the whole event is cancelled; otherwise only the room leaves it and the meeting stays on the attendees' calendars. */
  asSpace: Scalars['Boolean'];
  eventId: Scalars['ID'];
  scope: CancelEventV2Scope;
};

/** Either a completed cancel, or why it was refused. Never both. */
export type CancelEventV2Response = CancelEventV2Error | CancelEventV2Success;

/** Which occurrences of a recurring event a cancel applies to. */
export enum CancelEventV2Scope {
  /** Every occurrence of the series. */
  ALL_EVENTS = 'ALL_EVENTS',
  /** This occurrence and every later one; earlier occurrences stay. */
  THIS_AND_FOLLOWING = 'THIS_AND_FOLLOWING',
  /** Only this occurrence, or the event itself when it does not recur. */
  THIS_EVENT = 'THIS_EVENT'
}

/** The cancel happened. robin-api answers once it is done, so this is not a submission. */
export type CancelEventV2Success = {
  __typename: 'CancelEventV2Success';
  /** The event the cancel was requested for, as sent. */
  eventId: Scalars['ID'];
};

export type CancelResourceReservationCompleteCancelResponseType = {
  __typename: 'CancelResourceReservationCompleteCancelResponseType';
  /** eventType is null when no state is updated but result is still successful */
  eventType: Maybe<Scalars['ID']>;
  reservationId: Scalars['ID'];
  /** value is -1 when no state is updated but result is still successful */
  value: Scalars['Int'];
};

export type CancelledVisitOrReservationResult = {
  __typename: 'CancelledVisitOrReservationResult';
  error: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  success: Scalars['Boolean'];
};

export enum ChangeAnswersOnMeetingServiceRequestErrorReason {
  CONFLICT = 'CONFLICT'
}

export type ChangeAnswersOnMeetingServiceRequestErrorResponse = {
  __typename: 'ChangeAnswersOnMeetingServiceRequestErrorResponse';
  reason: ChangeAnswersOnMeetingServiceRequestErrorReason;
};

export type ChangeAnswersOnMeetingServiceRequestInput = {
  /** The answers to the questions on the MeetingService, like in RequestMeetingServiceForDraftEventAtSpaceInput. Supports partial updates by omitting answers, but it's fine to include unchanged answers. */
  answers: Array<AnsweredTicketQuestionInput>;
  meetingServiceRequestId: Scalars['ID'];
  /** The completed form ID before any changes - for concurrency control. If there was no completed form due to lack of answers, pass in null. Omitting this field is an error. */
  previousCompletedFormId?: InputMaybe<Scalars['ID']>;
};

export type ChangeAnswersOnMeetingServiceRequestResponse = ChangeAnswersOnMeetingServiceRequestErrorResponse | ChangeAnswersOnMeetingServiceRequestSuccessResponse;

/** Clients should refetch affected service request to get the latest data */
export type ChangeAnswersOnMeetingServiceRequestSuccessResponse = {
  __typename: 'ChangeAnswersOnMeetingServiceRequestSuccessResponse';
  _: Maybe<Scalars['Void']>;
};

export type ChangeBrivoLockLinksInput = {
  locks: Array<ChangeBrivoLockLinksInputLocks>;
};

export type ChangeBrivoLockLinksInputLocks = {
  remoteLockId: Scalars['ID'];
  robinLevelId?: InputMaybe<Scalars['Int']>;
  robinLocationId?: InputMaybe<Scalars['Int']>;
};

export type ChangeBrivoLockLinksResponse = {
  __typename: 'ChangeBrivoLockLinksResponse';
  uuid: Scalars['ID'];
};

export type ChangeGallagherDoorLinksForIntegrationInput = {
  doors: Array<ChangeGallagherDoorLinksForIntegrationInputDoors>;
};

export type ChangeGallagherDoorLinksForIntegrationInputDoors = {
  remoteDoorId: Scalars['ID'];
  robinLevelId?: InputMaybe<Scalars['Int']>;
  robinLocationId?: InputMaybe<Scalars['Int']>;
};

export type ChangeGallagherDoorLinksForIntegrationResponse = {
  __typename: 'ChangeGallagherDoorLinksForIntegrationResponse';
  uuid: Scalars['ID'];
};

export type ChangeGeneaDoorLinksInput = {
  doors: Array<ChangeGeneaDoorLinksInputLocks>;
};

export type ChangeGeneaDoorLinksInputLocks = {
  remoteDoorId: Scalars['ID'];
  robinLevelId?: InputMaybe<Scalars['Int']>;
  robinLocationId?: InputMaybe<Scalars['Int']>;
};

export type ChangeGeneaLockLinksResponse = {
  __typename: 'ChangeGeneaLockLinksResponse';
  uuid: Scalars['ID'];
};

export type ChangeGenericConnectorSourceMapping = {
  robinLevelId?: InputMaybe<Scalars['Int']>;
  robinLocationId?: InputMaybe<Scalars['Int']>;
  sourcePattern: Scalars['String'];
};

export type ChangeGenericConnectorSourceMappingsInput = {
  integrationUuid: Scalars['ID'];
  mappings: Array<ChangeGenericConnectorSourceMapping>;
};

export type ChangeGenericConnectorSourceMappingsResponse = {
  __typename: 'ChangeGenericConnectorSourceMappingsResponse';
  uuid: Scalars['ID'];
};

export type ChangeGenetecDoorLinksForIntegrationInput = {
  doors: Array<ChangeGenetecDoorLinksForIntegrationInputDoors>;
};

export type ChangeGenetecDoorLinksForIntegrationInputDoors = {
  remoteDoorId: Scalars['ID'];
  robinLevelId?: InputMaybe<Scalars['Int']>;
  robinLocationId?: InputMaybe<Scalars['Int']>;
};

export type ChangeGenetecDoorLinksForIntegrationResponse = {
  __typename: 'ChangeGenetecDoorLinksForIntegrationResponse';
  uuid: Scalars['ID'];
};

export type ChangeGoogleMeetDeviceLinksInput = {
  links: Array<ChangeGoogleMeetDeviceLinksInputLinks>;
};

export type ChangeGoogleMeetDeviceLinksInputLinks = {
  /** The Robin space to map this Google Meet device to. Omit/null to unlink. */
  robinSpaceId?: InputMaybe<Scalars['Int']>;
  serialNumber: Scalars['ID'];
};

export type ChangeGoogleMeetDeviceLinksResponse = {
  __typename: 'ChangeGoogleMeetDeviceLinksResponse';
  uuid: Scalars['ID'];
};

export type ChangeKisiLockLinkToRobinLevelInput = {
  remoteLockId: Scalars['String'];
  robinLevelId: Scalars['Int'];
};

export type ChangeKisiLockLinkToRobinLevelResponse = {
  __typename: 'ChangeKisiLockLinkToRobinLevelResponse';
  uuid: Maybe<Scalars['ID']>;
};

export type ChangeKisiLockLinkToRobinLocationInput = {
  remoteLockId: Scalars['String'];
  robinLocationId: Scalars['Int'];
};

export type ChangeKisiLockLinkToRobinLocationResponse = {
  __typename: 'ChangeKisiLockLinkToRobinLocationResponse';
  uuid: Maybe<Scalars['ID']>;
};

export type ChangeLogiSyncPlaceLinksInput = {
  links: Array<ChangeLogiSyncPlaceLinksInputLinks>;
};

export type ChangeLogiSyncPlaceLinksInputLinks = {
  placeId: Scalars['ID'];
  /** The Robin space to map this LogiSync place to. Omit/null to unlink. */
  robinSpaceId?: InputMaybe<Scalars['Int']>;
};

export type ChangeLogiSyncPlaceLinksResponse = {
  __typename: 'ChangeLogiSyncPlaceLinksResponse';
  uuid: Scalars['ID'];
};

export type ChangeNeatPulseRoomLinksInput = {
  links: Array<ChangeNeatPulseRoomLinksInputLinks>;
};

export type ChangeNeatPulseRoomLinksInputLinks = {
  /** The Robin space to map this Neat Pulse room to. Omit/null to unlink. */
  robinSpaceId?: InputMaybe<Scalars['Int']>;
  roomId: Scalars['ID'];
};

export type ChangeNeatPulseRoomLinksResponse = {
  __typename: 'ChangeNeatPulseRoomLinksResponse';
  uuid: Scalars['ID'];
};

export type ChangeOpenpathLockLinksInput = {
  locks: Array<ChangeOpenpathLockLinksInputLocks>;
};

export type ChangeOpenpathLockLinksInputLocks = {
  canBeUsedForCredentialProvisioning?: InputMaybe<Scalars['Boolean']>;
  remoteLockId: Scalars['String'];
  robinLevelId?: InputMaybe<Scalars['Int']>;
  robinLocationId?: InputMaybe<Scalars['Int']>;
};

export type ChangeOpenpathLockLinksResponse = {
  __typename: 'ChangeOpenpathLockLinksResponse';
  uuid: Scalars['ID'];
};

export type ChangeVerkadaDoorLinksInput = {
  doors: Array<ChangeVerkadaDoorLinksInputDoors>;
};

export type ChangeVerkadaDoorLinksInputDoors = {
  remoteDoorId: Scalars['ID'];
  robinLevelId?: InputMaybe<Scalars['Int']>;
  robinLocationId?: InputMaybe<Scalars['Int']>;
};

export type ChangeVerkadaLockLinksResponse = {
  __typename: 'ChangeVerkadaLockLinksResponse';
  uuid: Scalars['ID'];
};

export type ChangeZoomRoomsRoomLinksInput = {
  links: Array<ChangeZoomRoomsRoomLinksInputLinks>;
};

export type ChangeZoomRoomsRoomLinksInputLinks = {
  /** The Robin space to map this Zoom Room to. Omit/null to unlink. */
  robinSpaceId?: InputMaybe<Scalars['Int']>;
  /** The Zoom Room to map, as returned by getZoomRoomsRoomsForCurrentTenant. */
  roomId: Scalars['ID'];
};

export type ChangeZoomRoomsRoomLinksResponse = {
  __typename: 'ChangeZoomRoomsRoomLinksResponse';
  uuid: Scalars['ID'];
};

export type ChatMessage = {
  __typename: 'ChatMessage';
  id: Scalars['ID'];
  message: Scalars['String'];
  sentAt: Scalars['ISODateTime'];
  sentByUser: UserWithDefault;
};

export type CheckInStatus = {
  __typename: 'CheckInStatus';
  checkInComplete: Scalars['Boolean'];
  checkInPossibleFuture: Scalars['Boolean'];
  checkInPossibleNow: Scalars['Boolean'];
};

/** Result of a bulk dashboard check-in. */
export type CheckIntoVisitsFromDashboardResult = {
  __typename: 'CheckIntoVisitsFromDashboardResult';
  /** Guest invite IDs that could not be checked in. Empty when every guest was checked in. */
  failedGuestInviteIds: Array<Scalars['ID']>;
};

export type CheckOrganizationNameAvailabilityResponse = {
  __typename: 'CheckOrganizationNameAvailabilityResponse';
  available: Scalars['Boolean'];
};

export enum CheckTicketIntegrationFieldMappingDriftErrorReason {
  NOT_ACTIVE = 'NOT_ACTIVE',
  NOT_CONNECTED = 'NOT_CONNECTED',
  NOT_FOUND = 'NOT_FOUND',
  PROVIDER_CAPABILITY_MISSING = 'PROVIDER_CAPABILITY_MISSING',
  PROVIDER_REJECTED = 'PROVIDER_REJECTED',
  PROVIDER_UNREACHABLE = 'PROVIDER_UNREACHABLE',
  TARGET_CONFIG_NOT_FOUND = 'TARGET_CONFIG_NOT_FOUND',
  WORKFLOW_NOT_FOUND = 'WORKFLOW_NOT_FOUND'
}

export type CheckTicketIntegrationFieldMappingDriftErrorResponse = {
  __typename: 'CheckTicketIntegrationFieldMappingDriftErrorResponse';
  reason: CheckTicketIntegrationFieldMappingDriftErrorReason;
};

export type CheckTicketIntegrationFieldMappingDriftResponse = CheckTicketIntegrationFieldMappingDriftErrorResponse | CheckTicketIntegrationFieldMappingDriftSuccessResponse;

export type CheckTicketIntegrationFieldMappingDriftSuccessResponse = {
  __typename: 'CheckTicketIntegrationFieldMappingDriftSuccessResponse';
  /** Empty when every stored mapping still matches the provider's live fields. */
  driftItems: Array<TicketIntegrationFieldMappingDriftItem>;
};

/** A ChromeOS device from Google's device inventory — a Chromebox, a Chromebase, a Chromebook. GOOGLE_CHROME_OS is a separate source from GOOGLE_MEET: it sees Chromeboxes the Meet API does not, and reports different fields for the ones it shares. Fuses by serial and by MAC: the serial joins it to Meet, Neat and LogiSync records of the same box, and the MACs to LogiSync records. */
export type ChromeOsDevice = Endpoint & {
  __typename: 'ChromeOSDevice';
  firstSeenAt: Scalars['DateTime'];
  id: Scalars['ID'];
  /** The device's own last check-in to Google's Directory, ISO 8601 — Google's `lastSync`, and the "last active" signal for a box that never joins a Meet call. Null when Directory has not reported one. */
  lastActiveAt: Maybe<Scalars['DateTime']>;
  lastSeenAt: Scalars['DateTime'];
  /** Every MAC this device reported. A box with wired and wireless has two, and a match on either is a match on the box. */
  macs: Array<Scalars['String']>;
  /** The device model string, verbatim and stable, so a client can key behavior on it. Null when the Directory reports none. */
  model: Maybe<Scalars['String']>;
  /** The product name, from the collector's product-name table. Google already reports the model as a product name ("ASUS Chromebox 4"), so this is the model as Google reports it. Null when there is no model. */
  modelName: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  placement: Maybe<EndpointPlacement>;
  relationships: Array<EndpointRelationship>;
  remoteId: Scalars['String'];
  /** The manufacturer serial. The strongest identifier there is: it names the hardware where a MAC names one of its interfaces. Null when the Directory reports none; the same nullable source column feeds every implementer's serial, so null is a real state consumers must accept. */
  serial: Maybe<Scalars['String']>;
  source: EndpointSource;
  /** Google's current Directory inventory state for this device — a current snapshot, not a measure of historical availability. */
  status: Maybe<Scalars['String']>;
  vendor: Maybe<Scalars['String']>;
};


/** A ChromeOS device from Google's device inventory — a Chromebox, a Chromebase, a Chromebook. GOOGLE_CHROME_OS is a separate source from GOOGLE_MEET: it sees Chromeboxes the Meet API does not, and reports different fields for the ones it shares. Fuses by serial and by MAC: the serial joins it to Meet, Neat and LogiSync records of the same box, and the MACs to LogiSync records. */
export type ChromeOsDeviceRelationshipsArgs = {
  kinds?: InputMaybe<Array<EndpointRelationshipKind>>;
};

export type ClientOptionsInput = {
  notifyRecipient?: InputMaybe<Scalars['Boolean']>;
};

export enum ClientType {
  DASHBOARD_WEB = 'DASHBOARD_WEB',
  KIOSK = 'KIOSK',
  OTHER = 'OTHER',
  ROBIN_MOBILE = 'ROBIN_MOBILE'
}

export type ColorDefinition = NeighborhoodColorDefinition | PublishedNeighborhoodColorDefinition;

/** Completed onboarding step identifiers; stored as slugs in the org setting. */
export enum CompletedOnboardingStep {
  ADD_RESOURCES = 'ADD_RESOURCES',
  ADD_USERS = 'ADD_USERS',
  CREATE_BUILDINGS = 'CREATE_BUILDINGS',
  ENABLE_INTEGRATIONS = 'ENABLE_INTEGRATIONS',
  INVITE_ADMINS = 'INVITE_ADMINS',
  MANAGE_ORGANIZATION = 'MANAGE_ORGANIZATION',
  UPLOAD_LOGO = 'UPLOAD_LOGO',
  UPLOAD_MAPS = 'UPLOAD_MAPS'
}

export type CompletedTicketForm = {
  __typename: 'CompletedTicketForm';
  id: Scalars['ID'];
  questions: Array<AnsweredTicketQuestion>;
};

export enum ConfirmationClientType {
  BADGE = 'BADGE',
  DASHBOARD_WEB = 'DASHBOARD_WEB',
  KIOSK = 'KIOSK',
  OTHER = 'OTHER',
  QR_SCAN = 'QR_SCAN',
  ROBIN_MOBILE = 'ROBIN_MOBILE',
  SLACK = 'SLACK',
  TEAMS = 'TEAMS',
  WIFI = 'WIFI'
}

export enum ConfirmationMethod {
  LOCAL = 'LOCAL',
  REMOTE = 'REMOTE'
}

export type ConnectGallagherAccountForCurrentTenantInput = {
  apiKey: Scalars['String'];
  emailFieldIdentifier?: InputMaybe<Scalars['String']>;
  tenancy: GallagherTenancy;
};

export type ConnectGallagherAccountForCurrentTenantResponse = {
  __typename: 'ConnectGallagherAccountForCurrentTenantResponse';
  uuid: Scalars['ID'];
};

export type ConnectGeneaAccountForCurrentTenantInput = {
  apiKey: Scalars['String'];
  tenancy?: InputMaybe<GeneaTenancy>;
};

export type ConnectGeneaAccountForCurrentTenantResponse = {
  __typename: 'ConnectGeneaAccountForCurrentTenantResponse';
  uuid: Scalars['ID'];
};

export type ConnectGenericConnectorAccountInput = {
  name: Scalars['String'];
  testing?: Scalars['Boolean'];
  vendor: Scalars['String'];
};

export type ConnectGenericConnectorAccountResponse = {
  __typename: 'ConnectGenericConnectorAccountResponse';
  uuid: Scalars['ID'];
};

export type ConnectGenetecAccountForCurrentTenantInput = {
  apiUrl: Scalars['String'];
  password: Scalars['String'];
  username: Scalars['String'];
};

export type ConnectGenetecAccountForCurrentTenantResponse = {
  __typename: 'ConnectGenetecAccountForCurrentTenantResponse';
  uuid: Scalars['ID'];
};

export type ConnectGoogleAccountForCurrentTenantResponse = {
  __typename: 'ConnectGoogleAccountForCurrentTenantResponse';
  uuid: Scalars['ID'];
};

export type ConnectKisiAccountInput = {
  apiKey: Scalars['String'];
};

export type ConnectKisiAccountResponse = {
  __typename: 'ConnectKisiAccountResponse';
  uuid: Scalars['ID'];
};

export type ConnectLogiSyncAccountInput = {
  certificatePem: Scalars['String'];
  logisyncApiServer: Scalars['String'];
  logisyncOrgId: Scalars['String'];
  privateKeyPem: Scalars['String'];
};

export type ConnectLogiSyncAccountResponse = {
  __typename: 'ConnectLogiSyncAccountResponse';
  uuid: Scalars['ID'];
};

export type ConnectNeatPulseAccountInput = {
  apiKey: Scalars['String'];
  neatPulseApiServer: Scalars['String'];
  neatPulseOrgId: Scalars['String'];
};

export type ConnectNeatPulseAccountResponse = {
  __typename: 'ConnectNeatPulseAccountResponse';
  uuid: Scalars['ID'];
};

export type ConnectOpenpathAccountInput = {
  email: Scalars['String'];
  otp?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
};

export type ConnectOpenpathAccountResponse = {
  __typename: 'ConnectOpenpathAccountResponse';
  uuid: Scalars['ID'];
};

export type ConnectRipplingAccountForOrganizationAuthDataInput = {
  access_token: Scalars['String'];
  account_id: Scalars['String'];
  expires_in: Scalars['Int'];
  id_token: Scalars['String'];
  refresh_token: Scalars['String'];
  scope: Scalars['String'];
  token_type: Scalars['String'];
  uid: Scalars['String'];
};

export type ConnectRipplingAccountForOrganizationInput = {
  authData: ConnectRipplingAccountForOrganizationAuthDataInput;
  organizationId: Scalars['ID'];
};

export type ConnectRipplingAccountForOrganizationResponse = {
  __typename: 'ConnectRipplingAccountForOrganizationResponse';
  id: Scalars['ID'];
};

export type ConnectVerkadaAccountForCurrentTenantInput = {
  apiKey: Scalars['String'];
  tenancy: VerkadaTenancy;
};

export type ConnectVerkadaAccountForCurrentTenantResponse = {
  __typename: 'ConnectVerkadaAccountForCurrentTenantResponse';
  uuid: Scalars['ID'];
};

export type ConvertGroupToExternalRipplingGroupInput = {
  slug: Scalars['ID'];
};

export type ConvertGroupToExternalRipplingGroupResponse = {
  __typename: 'ConvertGroupToExternalRipplingGroupResponse';
  externalId: Scalars['String'];
  id: Scalars['ID'];
  slug: Scalars['String'];
};

export type CountIssueReportsInput = {
  filters?: InputMaybe<ListIssueReportsFiltersInput>;
};

export type CountIssueReportsResponse = {
  __typename: 'CountIssueReportsResponse';
  count: Scalars['Int'];
};

export type CountMeetingServiceRequestsInput = {
  filters?: InputMaybe<ListMeetingServiceRequestsFiltersInput>;
};

export type CountMeetingServiceRequestsResponse = {
  __typename: 'CountMeetingServiceRequestsResponse';
  count: Scalars['Int'];
};

export type CountMeetingServicesCategoriesInput = {
  filters?: InputMaybe<ListMeetingServicesCategoriesFiltersInput>;
};

export type CountMeetingServicesCategoriesResponse = {
  __typename: 'CountMeetingServicesCategoriesResponse';
  count: Scalars['Int'];
};

export type CountMeetingServicesInput = {
  filters?: InputMaybe<ListMeetingServicesFiltersInput>;
};

export type CountMeetingServicesResponse = {
  __typename: 'CountMeetingServicesResponse';
  count: Scalars['Int'];
};

export type CreateActivityInput = {
  activityLocation?: InputMaybe<Scalars['String']>;
  audienceLocationId: Scalars['ID'];
  /** The ID of the image to link to the activity */
  coverImageId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  end: Scalars['ISODateTime'];
  externalEventId?: InputMaybe<Scalars['String']>;
  start: Scalars['ISODateTime'];
  timezone: Scalars['String'];
  title: Scalars['String'];
  /** Should be a URL */
  virtualLocation?: InputMaybe<Scalars['String']>;
};

export type CreateActivityReturnType = {
  __typename: 'CreateActivityReturnType';
  id: Scalars['String'];
};

export type CreateAllocationInput = {
  /** Which of the stack plan's variations this draft implements. Copied onto it. */
  allocationId: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  /** The initial floor split. May be empty and filled in later. */
  floors?: InputMaybe<Array<FloorAllocationInput>>;
  name: Scalars['String'];
  stackPlanId: Scalars['ID'];
};

export type CreateAllocationResponse = {
  __typename: 'CreateAllocationResponse';
  id: Scalars['ID'];
  /** Business units whose floor split does not add up to the variation's totals. Empty when the split is complete; a draft is still created either way, since an unfinished split is a normal state to save. */
  unsatisfied: Array<UnsatisfiedBusinessUnit>;
  /** The new allocation draft's version, which the first updateFloorAllocations call must send. */
  version: Scalars['Int'];
};

export type CreateAndMapBuildingsFromRipplingBuildingsInput = {
  address: Scalars['String'];
  name: Scalars['String'];
  ripplingBuildingId?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
};

export type CreateAndMapBuildingsFromRipplingInput = {
  buildings: Array<CreateAndMapBuildingsFromRipplingBuildingsInput>;
  organizationId: Scalars['ID'];
};

export type CreateAndMapBuildingsFromRipplingResponse = {
  __typename: 'CreateAndMapBuildingsFromRipplingResponse';
  id: Scalars['ID'];
};

export type CreateBadgeCsvUploadLinkInput = {
  locationId: Scalars['Int'];
  vendor: Scalars['String'];
};

export type CreateBadgeCsvUploadLinkResponse = {
  __typename: 'CreateBadgeCSVUploadLinkResponse';
  link: Scalars['String'];
  uuid: Scalars['ID'];
};

export type CreateBookingWindowPolicyInput = {
  locationId: Scalars['ID'];
  policy?: InputMaybe<BookingWindowPolicyDefinitionInput>;
};

export type CreateBuildingDraftResponse = {
  __typename: 'CreateBuildingDraftResponse';
  floorDraftIds: Array<Scalars['ID']>;
  id: Scalars['ID'];
};

export type CreateDeliveryInput = {
  additionalNotes?: InputMaybe<Scalars['String']>;
  base64LabelImage?: InputMaybe<Scalars['String']>;
  carrier?: InputMaybe<Scalars['String']>;
  deliveryZoneId: Scalars['String'];
  recipient?: InputMaybe<RecipientInput>;
  status?: InputMaybe<DeliveryStatus>;
  trackingNumber?: InputMaybe<Scalars['String']>;
};

export type CreateDeliveryZoneInput = {
  levelId?: InputMaybe<Scalars['ID']>;
  locationId: Scalars['String'];
  name: Scalars['String'];
  spaceId?: InputMaybe<Scalars['ID']>;
};

export type CreateDraftResponse = {
  __typename: 'CreateDraftResponse';
  draftCreated: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

export type CreateEventV2Error = {
  __typename: 'CreateEventV2Error';
  message: Maybe<Scalars['String']>;
  reason: CreateEventV2FailReason;
};

/** Why robin-api rejected the create synchronously. Rooms accept or decline the invitation asynchronously after the event exists, so a CreateEventV2Success does not guarantee every room accepted; read the event's space invitees to confirm. */
export enum CreateEventV2FailReason {
  /** robin-api rejected the request body. */
  INVALID_INPUT = 'INVALID_INPUT',
  /** The actor, or their calendar account, may not create this event. */
  LACKING_PERMISSIONS = 'LACKING_PERMISSIONS',
  /** A room is booked or its booking policy forbids this window. */
  SPACE_UNAVAILABLE = 'SPACE_UNAVAILABLE',
  UNKNOWN = 'UNKNOWN'
}

/** Input for createEventV2. Mirrors the event composer's create payload. Every field has exactly one "not set" state: lists and flags default to [] / false, nullable fields default to null. Nullable fields are forwarded to robin-api as null, which it treats like an absent key, so its own defaults apply. GraphQL adds no defaults of its own. */
export type CreateEventV2Input = {
  /** Calendar mailbox the event is created on. When omitted, the composer's precedence applies: the user's first writable personal calendar if the org prefers personal booking, otherwise the first space invitee's calendar. */
  calendarMailboxAddress?: InputMaybe<Scalars['String']>;
  /** Omitted or null → sent as null. */
  description?: InputMaybe<Scalars['String']>;
  end: DateWithTimezone;
  /** Integration IDs (e.g. video conferencing) to attach to the event. */
  integrationIds?: Array<Scalars['ID']>;
  /** Expected attendee count. Required when booking a request-only space; null otherwise. */
  inviteeCount?: InputMaybe<Scalars['Int']>;
  invitees?: Array<CreateEventV2InviteeInput>;
  /** Private events hide their details from other users. Sent as visibility 'private' or 'default'. */
  isPrivate?: Scalars['Boolean'];
  /** Bypass check-in at sync when the actor holds spaces:bypass_autounbook. Omitted or null → sent as null, so robin-api applies its own default (true, and ignored when the actor lacks the permission). The composer sends false for recurring events and when the control is unavailable. */
  preConfirm?: InputMaybe<Scalars['Boolean']>;
  /** Recurrence rules. [] for a one-off event; one or more rules create a series. */
  recurrence?: Array<Scalars['RecurrenceRule']>;
  /** Spaces (rooms) to book. [] is allowed when calendarMailboxAddress is provided or a personal calendar is resolved (see calendarMailboxAddress). */
  spaceInvitees?: Array<CreateEventV2SpaceInviteeInput>;
  /** All-day is derived from the bounds, as the composer sends them: a start and end both at midnight in their time zone, spanning one or more whole days, book an all-day event (end exclusive, so a one-day event ends at the next midnight). Anything else is a timed event. */
  start: DateWithTimezone;
  /** Omitted or null → sent as null; robin-api assigns the title. */
  title?: InputMaybe<Scalars['String']>;
  /** Event UID. Supply one when something else must correlate with the event before it exists, e.g. a meeting service request created alongside it, as the composer does. Omitted → the server mints a v4 UUID. */
  uid?: InputMaybe<Scalars['UUID']>;
};

/** A person to invite to a v2 event: a Robin user by ID, or anyone by email. Exactly one field must be set. */
export type CreateEventV2InviteeInput = {
  email?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

/** Either the created event, or why creation failed. Never both. */
export type CreateEventV2Response = CreateEventV2Error | CreateEventV2Success;

/** A space to book for a v2 event, with optional setup/teardown buffers. */
export type CreateEventV2SpaceInviteeInput = {
  /** Buffer after the event, ISO 8601 duration (e.g. PT15M). On create, omit for none. On update, omit to keep the room's current buffer; null clears it. */
  bufferAfterDuration?: InputMaybe<Scalars['ISO8601Duration']>;
  /** Buffer before the event, ISO 8601 duration (e.g. PT15M). On create, omit for none. On update, omit to keep the room's current buffer; null clears it. */
  bufferBeforeDuration?: InputMaybe<Scalars['ISO8601Duration']>;
  spaceId: Scalars['ID'];
};

export type CreateEventV2Success = {
  __typename: 'CreateEventV2Success';
  /** ID of the created event */
  eventId: Scalars['ID'];
};

export type CreateGenericHealthCheckpointResponse = {
  __typename: 'CreateGenericHealthCheckpointResponse';
  id: Scalars['String'];
};

export type CreateGroupAndMakeItExternalRipplingGroupInput = {
  description: Scalars['String'];
  isPrivate: Scalars['Boolean'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type CreateGroupAndMakeItExternalRipplingGroupResponse = {
  __typename: 'CreateGroupAndMakeItExternalRipplingGroupResponse';
  id: Scalars['ID'];
  slug: Scalars['String'];
};

export type CreateLevelInput = {
  levelNumber?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type CreateNeighborhoodResponse = {
  __typename: 'CreateNeighborhoodResponse';
  id: Scalars['ID'];
};

export type CreateRobinOrganizationFromRipplingOAuthDataInput = {
  code: Scalars['String'];
};

export type CreateRobinOrganizationFromRipplingOAuthDataResponse = {
  __typename: 'CreateRobinOrganizationFromRipplingOAuthDataResponse';
  organizationId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type CreateServiceNowIntegrationInput = {
  /** Per-instance OAuth application credentials. */
  clientId: Scalars['String'];
  clientSecret: Scalars['String'];
  /** ServiceNow instance base URL, e.g. https://acme.service-now.com */
  instanceUrl: Scalars['String'];
  /** External target object/table, e.g. incident. */
  targetObject: Scalars['String'];
};

export type CreateStackPlanAllocationInput = {
  businessUnits: Array<BusinessUnitAllocationInput>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  stackPlanId: Scalars['ID'];
};

export type CreateStackPlanInput = {
  buildingId: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateStackPlanResponse = {
  __typename: 'CreateStackPlanResponse';
  id: Scalars['ID'];
};

export enum CreateTicketIntegrationErrorReason {
  /** The org already has an active or deactivated integration of this provider type: re-authorize or delete it. For ServiceNow on the same instance, create stages the new client and succeeds instead. */
  PROVIDER_ALREADY_CONNECTED = 'PROVIDER_ALREADY_CONNECTED'
}

export type CreateTicketIntegrationErrorResponse = {
  __typename: 'CreateTicketIntegrationErrorResponse';
  reason: CreateTicketIntegrationErrorReason;
};

export enum CreateTicketIntegrationExternalObjectItemFailureReason {
  /** The provider create succeeded but writing the mapping failed; `externalObject` carries the created object. */
  MAPPING_WRITE_FAILED = 'MAPPING_WRITE_FAILED',
  /** This entity type has no create target, and the provider needs one to create (Jira Assets). Set one with upsertTicketIntegrationObjectClassAssignments. */
  NO_CREATE_TARGET = 'NO_CREATE_TARGET',
  /** The provider's creatable representation disappeared mid-batch (plan/config change). */
  PROVIDER_CAPABILITY_MISSING = 'PROVIDER_CAPABILITY_MISSING',
  /** The create POST was sent but its outcome is ambiguous — a 2xx with an unparseable body, or a transport failure (timeout, network drop, unread body) or 5xx after the request left — so the object was likely created with an unknown id. Do NOT re-run this item (it would create a duplicate and orphan the first); recover by mapping the object once found. */
  PROVIDER_CREATED_UNCONFIRMED = 'PROVIDER_CREATED_UNCONFIRMED',
  /** The provider rejected the create (permissions, duplicate name, missing required field, ...). */
  PROVIDER_REJECTED = 'PROVIDER_REJECTED',
  PROVIDER_UNREACHABLE = 'PROVIDER_UNREACHABLE'
}

export type CreateTicketIntegrationExternalObjectItemInput = {
  entityId: Scalars['ID'];
  entityType: TicketIntegrationEntityMappingEntityType;
  /** Parent in the provider; omit to derive from the Robin entity's nearest mapped ancestor. */
  parentExternalObjectId?: InputMaybe<Scalars['ID']>;
};

export type CreateTicketIntegrationExternalObjectItemResult = {
  __typename: 'CreateTicketIntegrationExternalObjectItemResult';
  entityId: Scalars['ID'];
  entityType: TicketIntegrationEntityMappingEntityType;
  /** Set when state is CREATED; on SKIPPED_ALREADY_MAPPED and SKIPPED_MAPPING_BROKEN (the object the place is mapped to); on SKIPPED_PARENT_MAPPING_BROKEN (the ancestor's broken object); and on MAPPING_WRITE_FAILED — the provider object exists, so recover by upserting a mapping to it, never by re-creating. */
  externalObject: Maybe<TicketIntegrationExternalObject>;
  /** Set when state is FAILED. */
  failureReason: Maybe<CreateTicketIntegrationExternalObjectItemFailureReason>;
  state: CreateTicketIntegrationExternalObjectItemState;
};

export enum CreateTicketIntegrationExternalObjectItemState {
  CREATED = 'CREATED',
  FAILED = 'FAILED',
  /** Skipped because the Robin entity already has a mapping. */
  SKIPPED_ALREADY_MAPPED = 'SKIPPED_ALREADY_MAPPED',
  /** Skipped because the batch hit its time budget; re-run with the remaining items. */
  SKIPPED_DEADLINE_EXCEEDED = 'SKIPPED_DEADLINE_EXCEEDED',
  /** Skipped because the Robin entity's mapping is broken: verification could not find its object. Nothing is created over a broken mapping, since the object may only be unreadable. Remove or remap the mapping to create a new object. */
  SKIPPED_MAPPING_BROKEN = 'SKIPPED_MAPPING_BROKEN',
  /** Skipped because an ancestor in the same batch failed to create. */
  SKIPPED_PARENT_FAILED = 'SKIPPED_PARENT_FAILED',
  /** Skipped because the nearest mapped ancestor, which the new object would be created under, has a broken mapping. Fix that ancestor's mapping first, or pass `parentExternalObjectId`. */
  SKIPPED_PARENT_MAPPING_BROKEN = 'SKIPPED_PARENT_MAPPING_BROKEN'
}

export enum CreateTicketIntegrationExternalObjectsErrorReason {
  /** Another request with this idempotencyKey is still running; nothing was created. Retry shortly with the same key. */
  IDEMPOTENCY_KEY_IN_USE = 'IDEMPOTENCY_KEY_IN_USE',
  NOT_ACTIVE = 'NOT_ACTIVE',
  NOT_CONNECTED = 'NOT_CONNECTED',
  NOT_FOUND = 'NOT_FOUND',
  /** The provider has no creatable external-object representation (e.g. Zendesk tags exist implicitly). */
  PROVIDER_CAPABILITY_MISSING = 'PROVIDER_CAPABILITY_MISSING',
  /** The provider was reached and refused the request (auth/permissions) — check the connection's access, not the network. */
  PROVIDER_REJECTED = 'PROVIDER_REJECTED',
  PROVIDER_UNREACHABLE = 'PROVIDER_UNREACHABLE',
  /** More than 200 items in one call. */
  TOO_MANY_ITEMS = 'TOO_MANY_ITEMS'
}

export type CreateTicketIntegrationExternalObjectsErrorResponse = {
  __typename: 'CreateTicketIntegrationExternalObjectsErrorResponse';
  reason: CreateTicketIntegrationExternalObjectsErrorReason;
};

export type CreateTicketIntegrationExternalObjectsInput = {
  /** Per-batch idempotency key, required: provider creates cannot be undone, so every batch holds its key while it runs (a second request with the same key gets IDEMPOTENCY_KEY_IN_USE). A retry with the same key and integration skips re-creating any item that already succeeded on a prior attempt with that key, returning its recorded external object instead; items not yet in that key's ledger are created as normal. Use one key per admin action and reuse it only to retry that action. Not blank, at most 255 characters. */
  idempotencyKey: Scalars['String'];
  integrationId: Scalars['ID'];
  items: Array<CreateTicketIntegrationExternalObjectItemInput>;
};

/** Provider creates cannot be rolled back, so items commit individually as they succeed; a partial failure reports COMPLETED_WITH_ERRORS with per-item states. */
export type CreateTicketIntegrationExternalObjectsOperationResponse = {
  __typename: 'CreateTicketIntegrationExternalObjectsOperationResponse';
  /** Null while the operation is synchronous; set when it becomes asynchronous and pollable. */
  id: Maybe<Scalars['ID']>;
  items: Array<CreateTicketIntegrationExternalObjectItemResult>;
  state: CreateTicketIntegrationExternalObjectsState;
};

export type CreateTicketIntegrationExternalObjectsResponse = CreateTicketIntegrationExternalObjectsErrorResponse | CreateTicketIntegrationExternalObjectsOperationResponse;

/** Operation lifecycle. Synchronous today, so only terminal states are returned; PENDING/RUNNING are reserved so the operation can become asynchronous without a breaking schema change — clients must handle them by re-querying. */
export enum CreateTicketIntegrationExternalObjectsState {
  COMPLETED_WITH_ERRORS = 'COMPLETED_WITH_ERRORS',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
  SUCCEEDED = 'SUCCEEDED'
}

export type CreateTicketIntegrationResponse = CreateTicketIntegrationErrorResponse | CreateTicketIntegrationSuccessResponse;

export type CreateTicketIntegrationSuccessResponse = {
  __typename: 'CreateTicketIntegrationSuccessResponse';
  integration: TicketIntegration;
};

export type CreateWorkAreaInput = {
  deskIds: Array<Scalars['ID']>;
  name: Scalars['String'];
};

export type CreateZendeskIntegrationInput = {
  /** Zendesk subdomain, e.g. acme for acme.zendesk.com. */
  subdomain: Scalars['String'];
};

export type CurrentUserAndOrgs = {
  __typename: 'CurrentUserAndOrgs';
  /** Whether the current user belongs to more than one organization. Rarely true among customers. */
  belongsToMultipleOrgs: Scalars['Boolean'];
  /** If true, user can see approval notifications for the organization specified in the tenant-id header. */
  canSeeApprovalNotificationsForCurrentTenant: Scalars['Boolean'];
  hasActivitiesCreateForCurrentTenant: Scalars['Boolean'];
  hasActivitiesManageForCurrentTenant: Scalars['Boolean'];
  hasAmenitiesManageForCurrentTenant: Scalars['Boolean'];
  hasAnalyticsPermissionForCurrentTenant: Scalars['Boolean'];
  hasAnnouncementsManageForCurrentTenant: Scalars['Boolean'];
  hasBillingPermissionForCurrentTenant: Scalars['Boolean'];
  hasCheckpointsViewPermissionForCurrentTenant: Scalars['Boolean'];
  hasDeliveriesManagePermissionForCurrentTenant: Scalars['Boolean'];
  hasDeliveriesViewPermissionForCurrentTenant: Scalars['Boolean'];
  hasDevicesManageForCurrentTenant: Scalars['Boolean'];
  hasDevicesViewForCurrentTenant: Scalars['Boolean'];
  hasGroupsManageForCurrentTenant: Scalars['Boolean'];
  /** Whether the current user can manage issue reports in the current tenant. Temporarily backed by the tanuki(issue-reporting-FE) feature flag until a dedicated permission exists. */
  hasIssueReportsManagePermissionForCurrentTenant: Scalars['Boolean'];
  hasListUserPermissionForCurrentTenant: Scalars['Boolean'];
  hasManageUserPermissionForCurrentTenant: Scalars['Boolean'];
  hasOfficeAccessManagePermissionForCurrentTenant: Scalars['Boolean'];
  hasOfficeAccessViewPermissionForCurrentTenant: Scalars['Boolean'];
  /** If true, there are pending approval notifications for the organization specified in the tenant-id header. */
  hasPendingApprovalNotificationsForOrganization: Maybe<Scalars['Boolean']>;
  hasPlacesManageForCurrentTenant: Scalars['Boolean'];
  hasRolesManagePermissionForCurrentTenant: Scalars['Boolean'];
  hasScenarioPlanManagePermissionForCurrentTenant: Scalars['Boolean'];
  /** @deprecated Use hasScenarioPlanManagePermissionForCurrentTenant instead. The underlying scenario_planning:manage op is being replaced by the location-hierarchical scenario_plan:manage permission (RFC 0000-scenario-planning-permission-redesign). This field will be removed in Phase 4 of the rollout. */
  hasScenarioPlanningManagePermissionForCurrentTenant: Scalars['Boolean'];
  hasSeatsCoworkingReserveForCurrentTenant: Scalars['Boolean'];
  hasSeatsReservePublicPermissionForCurrentTenant: Scalars['Boolean'];
  hasSpacesReservePublicPermissionForCurrentTenant: Scalars['Boolean'];
  hasViewVisitsTabForCurrentTenant: Scalars['Boolean'];
  hasVisitsManageForCurrentTenant: Scalars['Boolean'];
  hasWorkPoliciesManagePermissionForCurrentTenant: Scalars['Boolean'];
  hasWorkplaceServicesManagePermissionForCurrentTenant: Scalars['Boolean'];
  hasWorkweekViewForCurrentTenant: Scalars['Boolean'];
  id: Scalars['ID'];
  /** Returns a single org by slug among the orgs the user belongs to, or null if not found. Needed for frontends that use slugs alone in their URLs to identify the org. null results or mismatches with tenant-id header should be unusual, but are allowed. Prefer organizationForCurrentTenant if tenant-id is already known. */
  organizationBySlug: Maybe<Organization>;
  /** Returns the organization matching the current tenant-id header. */
  organizationForCurrentTenant: Organization;
  /** @deprecated Use organizationsForSwitcher, organizationBySlug, or organizationForCurrentTenant */
  organizations: Array<Organization>;
  /** Returns a paginated list of organizations the user belongs to, with limited fields. `first` is required and must be 50 or less. DO NOT query this up-front on every page load, the switcher should be hidden by default. */
  organizationsForSwitcher: PagedMeOrganizationResult;
  /** @deprecated Use hasPendingApprovalNotificationsForOrganization instead, only returns 0 or 1 */
  totalPendingApprovalNotificationsForOrganization: Scalars['Int'];
  user: User;
  /** @deprecated This is intended to only be used for Pendo segmentation. Use the other fields on CurrentUserAndOrgs for permissions */
  userDefaultRoleSlugsForCurrentTenant: Array<UserDefaultRoleSlug>;
  userId: Scalars['ID'];
};


export type CurrentUserAndOrgsOrganizationBySlugArgs = {
  slug: Scalars['String'];
};


export type CurrentUserAndOrgsOrganizationsForSwitcherArgs = {
  first: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
};

export type CursoredPaginationResponse = {
  __typename: 'CursoredPaginationResponse';
  cursor: Maybe<Scalars['String']>;
  hasMore: Scalars['Boolean'];
  limit: Scalars['Int'];
};

export type CustomField = {
  __typename: 'CustomField';
  choices: Maybe<Array<CustomFieldChoice>>;
  id: Scalars['ID'];
  label: Scalars['String'];
  required: Maybe<Scalars['Boolean']>;
  showOnBadge: Maybe<Scalars['Boolean']>;
  type: CustomFieldType;
  value: Maybe<Scalars['Json']>;
};

export type CustomFieldChoice = {
  __typename: 'CustomFieldChoice';
  id: Scalars['ID'];
  label: Scalars['String'];
};

export type CustomFieldInput = {
  choices?: InputMaybe<Array<CustomFieldInputChoice>>;
  id: Scalars['ID'];
  label: Scalars['String'];
  required?: InputMaybe<Scalars['Boolean']>;
  showOnBadge?: InputMaybe<Scalars['Boolean']>;
  type: CustomFieldType;
  value?: InputMaybe<Scalars['Json']>;
};

export type CustomFieldInputChoice = {
  id: Scalars['ID'];
  label: Scalars['String'];
};

export enum CustomFieldType {
  LONG_TEXT = 'LONG_TEXT',
  SHORT_TEXT = 'SHORT_TEXT',
  SINGLE_SELECT = 'SINGLE_SELECT'
}

export type CustomResource = {
  __typename: 'CustomResource';
  amenities: Array<Amenity>;
  amenityIds: Array<Scalars['ID']>;
  bookingType: Maybe<WeeklyBookingType>;
  capacity: Scalars['Int'];
  customResourceInstanceId: Scalars['ID'];
  floor: Level;
  floorId: Scalars['ID'];
  icon: Maybe<IconType>;
  imageUrl: Maybe<Scalars['String']>;
  isAccessible: Scalars['Boolean'];
  location: Location;
  locationId: Scalars['ID'];
  name: Scalars['String'];
  note: Maybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  originatingCustomResourceTemplateId: Scalars['ID'];
  policyConfiguration: Maybe<CustomResourcePolicyDocumentType>;
  resourceGroupId: Maybe<Scalars['ID']>;
  resourceGroupName: Maybe<Scalars['String']>;
  stickers: Array<Sticker>;
  subCategory: Scalars['String'];
};

/** A single custom-resource category (template). `entityType` is always CUSTOM_RESOURCE; `categoryTypeId` is the key the frontend passes back as an `EntityTypeFilterSelection` on `GlobalSearchFilter`, and `icon` is the category's icon for rendering the option. */
export type CustomResourceFilterOption = EntityTypeFilterOption & {
  __typename: 'CustomResourceFilterOption';
  /** The resource category (template) id this option filters to. */
  categoryTypeId: Scalars['ID'];
  displayName: Scalars['String'];
  entityType: GlobalSearchEntityType;
  /** The icon of this resource category (template), e.g. "crc-lockers". Null when the category has no icon configured. */
  icon: Maybe<Scalars['String']>;
};

export type CustomResourceInstance = {
  __typename: 'CustomResourceInstance';
  amenityIds: Maybe<Array<Scalars['ID']>>;
  bookingType: Maybe<ResourceWeeklyBookingType>;
  capacity: Maybe<Scalars['Int']>;
  decorId: Scalars['ID'];
  floorId: Maybe<Scalars['ID']>;
  imageUrl: Maybe<Scalars['String']>;
  locationId: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  note: Maybe<Scalars['String']>;
  ownerId: Scalars['ID'];
  ownerType: Scalars['String'];
  policies: Maybe<ResourcePolicy>;
  subCategory: Maybe<Scalars['String']>;
  zoneId: Maybe<Scalars['ID']>;
};

export type CustomResourceInstanceInput = {
  amenityIds?: InputMaybe<Array<Scalars['ID']>>;
  bookingType?: InputMaybe<ResourceWeeklyBookingTypeInput>;
  capacity?: InputMaybe<Scalars['Int']>;
  decorId: Scalars['ID'];
  floorId?: InputMaybe<Scalars['ID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isAccessible?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  ownerId: Scalars['ID'];
  ownerType: Scalars['String'];
  policies?: InputMaybe<LayoutResourcePolicyInput>;
  subCategory?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['ID']>;
};

export type CustomResourceInstancePrePublishChangeType = {
  __typename: 'CustomResourceInstancePrePublishChangeType';
  amenityIds: Array<Scalars['ID']>;
  bookingType: Maybe<WeeklyBookingType>;
  capacity: Scalars['Int'];
  customResourceInstanceId: Scalars['ID'];
  floorId: Scalars['ID'];
  locationId: Scalars['ID'];
  name: Scalars['String'];
  note: Maybe<Scalars['String']>;
  originatingCustomResourceTemplateId: Scalars['ID'];
  policyConfiguration: Maybe<CustomResourcePolicyDocumentType>;
  resourceGroupId: Maybe<Scalars['ID']>;
  resourceGroupName: Maybe<Scalars['String']>;
  subCategory: Scalars['String'];
};

export type CustomResourcePolicyDocument = {
  __typename: 'CustomResourcePolicyDocument';
  abandonedResourceProtection: PolicyEnabledWithDurationType;
  advanceCheckInWindow: PolicyEnabledWithDurationType;
  advancedBookingThreshold: PolicyEnabledWithDurationType;
  allowOverlappingBookings: Scalars['Boolean'];
  bookingPrivacy: Scalars['Boolean'];
  id: Scalars['ID'];
  /** This is true when the policy represents the robin default policy, meaning no user document has been set */
  isDefaultDocument: Scalars['Boolean'];
  localCheckInOnly: Scalars['Boolean'];
  maxBookingLength: PolicyEnabledWithDurationType;
  preventBookingFromKiosk: Scalars['Boolean'];
  recurrence: Scalars['Boolean'];
  /** @deprecated This policy is deprecated */
  requireCheckIn: Scalars['Boolean'];
  resourceSharing: Scalars['Boolean'];
  restrictBookingToWorkingHours: Scalars['Boolean'];
};

export type CustomResourcePolicyDocumentCommand = {
  abandonedResourceProtection: PolicyEnabledWithDurationCommand;
  advanceCheckInWindow: PolicyEnabledWithDurationCommand;
  advancedBookingThreshold: PolicyEnabledWithDurationCommand;
  allowOverlappingBookings: Scalars['Boolean'];
  bookingPrivacy: Scalars['Boolean'];
  localCheckInOnly: Scalars['Boolean'];
  maxBookingLength: PolicyEnabledWithDurationCommand;
  preventBookingFromKiosk: Scalars['Boolean'];
  recurrence: Scalars['Boolean'];
  requireCheckIn?: InputMaybe<Scalars['Boolean']>;
  resourceSharing: Scalars['Boolean'];
  restrictBookingToWorkingHours: Scalars['Boolean'];
};

export type CustomResourcePolicyDocumentType = {
  __typename: 'CustomResourcePolicyDocumentType';
  abandonedResourceProtection: PolicyEnabledWithDurationType;
  advanceCheckInWindow: PolicyEnabledWithDurationType;
  advancedBookingThreshold: PolicyEnabledWithDurationType;
  allowOverlappingBookings: Scalars['Boolean'];
  bookingPrivacy: Scalars['Boolean'];
  localCheckInOnly: Scalars['Boolean'];
  maxBookingLength: PolicyEnabledWithDurationType;
  preventBookingFromKiosk: Scalars['Boolean'];
  recurrence: Scalars['Boolean'];
  requireCheckIn: Scalars['Boolean'];
  resourceSharing: Scalars['Boolean'];
  restrictBookingToWorkingHours: Scalars['Boolean'];
};

export type CustomResourcePublicationSessionStatusType = {
  __typename: 'CustomResourcePublicationSessionStatusType';
  isPublishComplete: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  lastProcessedEventNumber: Maybe<Scalars['Int']>;
  mapId: Scalars['ID'];
  organizationId: Scalars['ID'];
  publicationSessionId: Scalars['ID'];
  publishEventNumber: Maybe<Scalars['Int']>;
};

export type CustomResourceReservationByDateLinkType = {
  __typename: 'CustomResourceReservationByDateLinkType';
  duration: Scalars['ISO8601_Duration'];
  id: Scalars['ID'];
  localDate: Scalars['IsoDateOnlyString'];
  localStartTime: Scalars['IsoLocalTimeString'];
  reservations: Array<ResourceReservation>;
  resourceInstanceId: Scalars['ID'];
};

export type CustomResourceReservationLinkType = {
  __typename: 'CustomResourceReservationLinkType';
  id: Scalars['ID'];
  reservationSummary: Array<ReservationSummary>;
  reservations: Array<ResourceReservation>;
  resourceInstanceId: Scalars['ID'];
};

export type CustomResourceReservationsGroupedByDateResponseType = {
  __typename: 'CustomResourceReservationsGroupedByDateResponseType';
  id: Scalars['ID'];
  resourceReservationsByDate: Array<CustomResourceReservationByDateLinkType>;
};

export type CustomResourceReservationsRangeResponseType = {
  __typename: 'CustomResourceReservationsRangeResponseType';
  id: Scalars['ID'];
  localRangeEndDate: Scalars['IsoDateOnlyString'];
  localRangeStartDate: Scalars['IsoDateOnlyString'];
  resourceReservations: Array<CustomResourceReservationLinkType>;
};

/** A custom resource (e.g. a parking spot or locker) matched by a global search. `entityType` is always CUSTOM_RESOURCE. Includes its building (`locationName`) and floor (`levelName`) when placed, and the category it belongs to (`categoryTypeId` / `categoryName`). */
export type CustomResourceSearchHit = GlobalSearchHit & {
  __typename: 'CustomResourceSearchHit';
  /** The resource category display name, e.g. "Parking spots". */
  categoryName: Maybe<Scalars['String']>;
  /** The resource category (template) id this resource belongs to. */
  categoryTypeId: Scalars['ID'];
  displayName: Scalars['String'];
  entityId: Scalars['ID'];
  entityType: GlobalSearchEntityType;
  id: Scalars['ID'];
  /** The floor (level) id this resource is on, if any. */
  levelId: Maybe<Scalars['ID']>;
  /** The floor this resource is on, if any. */
  levelName: Maybe<Scalars['String']>;
  /** The building (location) id this resource is placed at. Non-null: custom resources without a location are not returned by search today (they'd be modeled separately if/when that case is handled). */
  locationId: Scalars['ID'];
  /** The building this resource is placed at. */
  locationName: Maybe<Scalars['String']>;
  /** The icon of this resource's category (template), e.g. "crc-lockers". */
  resourceIcon: Maybe<Scalars['String']>;
  score: Scalars['Float'];
};

export type CustomResourceTemplate = {
  __typename: 'CustomResourceTemplate';
  amenities: Array<AmenityWithDefault>;
  associatedAmenities: Array<Scalars['ID']>;
  description: Maybe<Scalars['String']>;
  icon: Maybe<IconType>;
  id: Scalars['ID'];
  policyDocument: CustomResourcePolicyDocument;
  resourceCategory: Scalars['String'];
  resourceCategorySingular: Maybe<Scalars['String']>;
  subCategories: Array<Scalars['CustomResourceSubCategoryType']>;
  /** This is true when the template represents a robin default template, such as parking spots and lockers */
  systemDefault: Scalars['Boolean'];
};

export type CustomVisitForm = {
  __typename: 'CustomVisitForm';
  guestInviteFields: Maybe<Array<CustomField>>;
  id: Maybe<Scalars['ID']>;
  locationIds: Maybe<Array<Scalars['ID']>>;
  locations: Maybe<Array<Location>>;
  name: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['ISODateTime']>;
  updatedBy: Maybe<UserWithDefault>;
  visitFields: Maybe<Array<CustomField>>;
};

export type CustomVisitFormInput = {
  guestInviteFields?: InputMaybe<Array<CustomFieldInput>>;
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
  visitFields?: InputMaybe<Array<CustomFieldInput>>;
};

export type CustomVisitFormLocationResponse = {
  __typename: 'CustomVisitFormLocationResponse';
  linkedLocations: Maybe<Array<Location>>;
  unlinkedLocations: Maybe<Array<Location>>;
};

export type CustomVisitFormOrderBy = {
  field?: InputMaybe<CustomVisitFormOrderByField>;
  ordinality?: InputMaybe<Ordinality>;
};

export enum CustomVisitFormOrderByField {
  FORMNAME = 'FormName',
  NUMBEROFLINKEDLOCATIONS = 'NumberOfLinkedLocations',
  UPDATEDAT = 'UpdatedAt'
}

export type CustomWorkingHours = DateSpecificWorkingHours & {
  __typename: 'CustomWorkingHours';
  date: Scalars['Date'];
  id: Scalars['ID'];
  reason: Maybe<Scalars['String']>;
  timeFrames: Array<TimeFrame>;
};

export type CustomWorkingHoursBulkUpdateInput = {
  date: Scalars['LocalDate'];
  end?: InputMaybe<Scalars['LocalEndTime']>;
  id?: InputMaybe<Scalars['ID']>;
  reason?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['LocalEndTime']>;
};

/** `date` is formated as YYYY-MM-DD while `start` and `end` are formated as HH:MM from 00:00 -> 24:00. `start` is inclusive and `end` is exclusive in the time range If `start` and `end` is `null`, that denotes an all day closure */
export type CustomWorkingHoursInput = {
  date: Scalars['LocalDate'];
  end?: InputMaybe<Scalars['LocalEndTime']>;
  locationId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['LocalEndTime']>;
};

/** `date` is formated as YYYY-MM-DD while `start` and `end` are formated as HH:MM from 00:00 -> 24:00. `start` is inclusive and `end` is exclusive in the time range If `start` and `end` is `null`, that denotes an all day closure */
export type CustomWorkingHoursUpdateInput = {
  date: Scalars['LocalDate'];
  end?: InputMaybe<Scalars['LocalEndTime']>;
  reason?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['LocalEndTime']>;
};

export type Customizations = {
  __typename: 'Customizations';
  failBody: Maybe<Scalars['String']>;
  failHeadline: Maybe<Scalars['String']>;
  failureEmails: Array<Scalars['String']>;
  passBody: Maybe<Scalars['String']>;
  passHeadline: Maybe<Scalars['String']>;
};

export enum DeviceType {
  UNKNOWN = 'UNKNOWN',
  VISITOR_ARRIVAL = 'VISITOR_ARRIVAL',
  VISITOR_BADGE_PRINTER = 'VISITOR_BADGE_PRINTER'
}

export type DailyActivitiesSummary = {
  __typename: 'DailyActivitiesSummary';
  activities: Array<ActivityForCurrentUser>;
  date: Scalars['Date'];
  totalActivities: Scalars['Int'];
};

export type DateFilterInput = {
  endTimeInclusive?: InputMaybe<Scalars['ISODateTime']>;
  startTimeExclusive?: InputMaybe<Scalars['ISODateTime']>;
};

export type DateFilterMandatoryInput = {
  endInclusivity?: InputMaybe<TimeInclusivityType>;
  endTime?: InputMaybe<Scalars['ISODateTime']>;
  startInclusivity?: InputMaybe<TimeInclusivityType>;
  startTime?: InputMaybe<Scalars['ISODateTime']>;
};

export type DateFilterOptionalInput = {
  endTime?: InputMaybe<Scalars['ISODateTime']>;
  startTime?: InputMaybe<Scalars['ISODateTime']>;
};

export type DateGroupedUserReservations = {
  __typename: 'DateGroupedUserReservations';
  reservationsByDate: Array<UserDeskReservationByDate>;
  users: Array<Reservee>;
};

export type DateRangeInput = {
  endTime: Scalars['ISODateTime'];
  startTime: Scalars['ISODateTime'];
  timeZone?: InputMaybe<Scalars['String']>;
};

export type DateRangeWithTimeZone = {
  end: DateWithTimezone;
  start: DateWithTimezone;
};

export type DateSpecificWorkingHours = {
  date: Scalars['Date'];
  timeFrames: Array<TimeFrame>;
};

export type DateTimezone = {
  __typename: 'DateTimezone';
  date: Scalars['Date'];
  timezone: Scalars['String'];
};

export type DateWithTimezone = {
  dateTime: Scalars['String'];
  timeZone: Scalars['String'];
};

export enum DayOfWeek {
  FRIDAY = 'FRIDAY',
  MONDAY = 'MONDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
  THURSDAY = 'THURSDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY'
}

export type DaysOfWeekGroupedByResourceReservation = {
  __typename: 'DaysOfWeekGroupedByResourceReservation';
  daysOfWeek: Array<RecurringReservationDayOfWeek>;
  reservationId: Scalars['ID'];
};

export type DefaultLocationAndLevel = {
  __typename: 'DefaultLocationAndLevel';
  /** When the user explicitly confirmed the location we picked -- dismissing the notice in the office app, or saving during onboarding. Merely being shown the notice does not set this: someone who navigates away without responding is still owed it, and will be shown it again. */
  acknowledgedAt: Maybe<Scalars['String']>;
  levelId: Maybe<Scalars['ID']>;
  locationId: Maybe<Scalars['ID']>;
  /** "auto" when this location was inferred from the user's teammates rather than chosen by them. Null for values people set themselves. */
  source: Maybe<Scalars['String']>;
  suggestedLevelId: Maybe<Scalars['ID']>;
  suggestedLocationId: Maybe<Scalars['ID']>;
};

export type DeleteExternalRipplingGroupInput = {
  slug: Scalars['String'];
};

export type DeleteExternalRipplingGroupResponse = {
  __typename: 'DeleteExternalRipplingGroupResponse';
  id: Scalars['ID'];
  slug: Scalars['String'];
};

export type DeleteMeetingServicesCategoryErrorResponse = {
  __typename: 'DeleteMeetingServicesCategoryErrorResponse';
  reason: DeleteMeetingServicesCategoryErrorResponseReason;
};

export enum DeleteMeetingServicesCategoryErrorResponseReason {
  /** The category has meeting services associated with it and cannot be deleted */
  HAS_SERVICES = 'HAS_SERVICES'
}

export type DeleteMeetingServicesCategoryResponse = DeleteMeetingServicesCategoryErrorResponse | DeleteMeetingServicesCategorySuccessResponse;

export type DeleteMeetingServicesCategorySuccessResponse = {
  __typename: 'DeleteMeetingServicesCategorySuccessResponse';
  _: Maybe<Scalars['Void']>;
};

export enum DeleteTicketIntegrationErrorReason {
  NOT_FOUND = 'NOT_FOUND'
}

export type DeleteTicketIntegrationErrorResponse = {
  __typename: 'DeleteTicketIntegrationErrorResponse';
  reason: DeleteTicketIntegrationErrorReason;
};

export type DeleteTicketIntegrationResponse = DeleteTicketIntegrationErrorResponse | DeleteTicketIntegrationSuccessResponse;

export type DeleteTicketIntegrationSuccessResponse = {
  __typename: 'DeleteTicketIntegrationSuccessResponse';
  id: Scalars['ID'];
};

export type DelimiterCandidate = {
  __typename: 'DelimiterCandidate';
  delimiter: Scalars['String'];
  frequency: Scalars['Int'];
  score: Scalars['Float'];
};

export type DeliveriesOrderBy = {
  field?: InputMaybe<DeliveriesOrderByField>;
  ordinality?: InputMaybe<Ordinality>;
};

export enum DeliveriesOrderByField {
  CREATEDAT = 'createdAt',
  DELIVERYZONENAME = 'deliveryZoneName',
  LASTNOTIFIEDAT = 'lastNotifiedAt',
  RECIPIENTNAME = 'recipientName',
  STATUS = 'status'
}

export type DeliveriesPermittedLocations = {
  __typename: 'DeliveriesPermittedLocations';
  canManage: Array<DeliveryLocation>;
  canView: Array<DeliveryLocation>;
};

export type Delivery = {
  __typename: 'Delivery';
  additionalNotes: Maybe<Scalars['String']>;
  carrier: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy: Maybe<User>;
  deletedAt: Maybe<Scalars['Date']>;
  deliveryZone: DeliveryZone;
  id: Scalars['ID'];
  labelImageURL: Maybe<Scalars['String']>;
  lastNotifiedAt: Maybe<Scalars['Date']>;
  magicLink: Maybe<Scalars['String']>;
  pickedUpAt: Maybe<Scalars['Date']>;
  recipient: Maybe<Recipient>;
  signatureImageURL: Maybe<Scalars['String']>;
  status: DeliveryStatus;
  trackingNumber: Maybe<Scalars['String']>;
};

export type DeliveryConfirmationInfo = {
  __typename: 'DeliveryConfirmationInfo';
  requireReleaseSignature: Scalars['Boolean'];
};

export type DeliveryFilterOptions = {
  deliveryZoneIds?: InputMaybe<Array<Scalars['ID']>>;
  endDate?: InputMaybe<Scalars['ISODateTime']>;
  idContains?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
  recipientIds?: InputMaybe<Array<Scalars['ID']>>;
  startDate?: InputMaybe<Scalars['ISODateTime']>;
  statuses?: InputMaybe<Array<DeliveryStatus>>;
};

export type DeliveryLevel = {
  __typename: 'DeliveryLevel';
  id: Scalars['ID'];
  locationId: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  spaces: Array<DeliverySpace>;
};

export type DeliveryLocation = {
  __typename: 'DeliveryLocation';
  id: Scalars['ID'];
  levels: Array<DeliveryLevel>;
  name: Maybe<Scalars['String']>;
  timezone: Maybe<Scalars['String']>;
};

/** Delivery settings for an organization. Always returned; individual fields are null if not configured. */
export type DeliverySettings = {
  __typename: 'DeliverySettings';
  /** ISO8601 duration defining how often to send reminders for uncollected deliveries. Examples: - "P1D" - Every 1 day - "P2D" - Every 2 days - "P1W" - Every 1 week Returns null if no reminder interval is configured. */
  reminderInterval: Maybe<Scalars['ISO8601Duration']>;
  requireReleaseSignature: Scalars['Boolean'];
};

export type DeliverySpace = {
  __typename: 'DeliverySpace';
  id: Scalars['ID'];
  levelId: Maybe<Scalars['String']>;
  locationId: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

export enum DeliveryStatus {
  PENDING = 'PENDING',
  PICKED_UP = 'PICKED_UP',
  UNKNOWN_RECIPIENT = 'UNKNOWN_RECIPIENT',
  WRONG_RECIPIENT = 'WRONG_RECIPIENT'
}

export enum DeliveryTextType {
  PHOTORECOGNIZER = 'PhotoRecognizer'
}

export type DeliveryZone = {
  __typename: 'DeliveryZone';
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  level: Maybe<DeliveryLevel>;
  levelId: Maybe<Scalars['ID']>;
  location: Maybe<DeliveryLocation>;
  locationId: Maybe<Scalars['String']>;
  name: Scalars['String'];
  space: Maybe<DeliverySpace>;
  spaceId: Maybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
};

export type DeliveryZoneFilterOptions = {
  levelIds?: InputMaybe<Array<Scalars['ID']>>;
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
  spaceIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Department = {
  __typename: 'Department';
  createdAt: Scalars['String'];
  departmentString: Maybe<DepartmentString>;
  description: Maybe<Scalars['String']>;
  directMembers: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  parentId: Maybe<Scalars['ID']>;
  slug: Scalars['String'];
  totalMembers: Scalars['Int'];
  updatedAt: Scalars['String'];
};

export type DepartmentDelimiterAnalysis = {
  __typename: 'DepartmentDelimiterAnalysis';
  accountId: Scalars['ID'];
  candidates: Maybe<Array<DelimiterCandidate>>;
  sampleDepartments: Array<Scalars['String']>;
  suggestedDelimiter: Maybe<Scalars['String']>;
  totalDepartmentsAnalyzed: Scalars['Int'];
};

export type DepartmentHierarchyItem = {
  __typename: 'DepartmentHierarchyItem';
  createdAt: Scalars['String'];
  description: Maybe<Scalars['String']>;
  directMembers: Scalars['Int'];
  hasChildren: Scalars['Boolean'];
  id: Scalars['ID'];
  members: Maybe<Array<User>>;
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  parentId: Maybe<Scalars['ID']>;
  slug: Scalars['String'];
  totalMembers: Scalars['Int'];
  updatedAt: Scalars['String'];
};

export type DepartmentHierarchyResult = {
  __typename: 'DepartmentHierarchyResult';
  children: Array<DepartmentHierarchyItem>;
  department: DepartmentHierarchyItem;
};

export type DepartmentString = {
  __typename: 'DepartmentString';
  createdAt: Scalars['String'];
  createdBy: Scalars['ID'];
  departmentString: Scalars['String'];
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
};

export type Desk = {
  __typename: 'Desk';
  amenities: Array<DeskAmenity>;
  assignees: Array<AccountUser>;
  availabilityFor: Maybe<Availability>;
  availabilityWithOverlappingReservations: DeskAvailabilityWithOverlappingReservations;
  /** @deprecated Deprecated in favor of availabilityFor */
  availableAt: Maybe<Availability>;
  canDelegate: Scalars['Boolean'];
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  image: Maybe<Scalars['String']>;
  instantAvailabilityAt: InstantAvailability;
  isDisabled: Maybe<Scalars['Boolean']>;
  /** Indicate whether the desk has been explicitly marked as not available. */
  isReservable: Scalars['Boolean'];
  /** The number of unresolved issue reports regarding this desk (issueReportStatus TODO, IN_PROGRESS, or BLOCKED). Any user who can see the desk can see this count; the reports themselves (description, reporter, etc.) require issue report visibility - see listIssueReports. Finer-grained filtering would come as arguments on this field, not more fields. Intentionally nullable in case Ticket service is down. */
  issueReportCount: Maybe<Scalars['Int']>;
  /** The highest priority among the unresolved issue reports counted by issueReportCount - the one a map pin should take its colour from. Null when there are none, and when Ticket service is down. Same visibility as issueReportCount: anyone who can see the desk can see it. */
  issueReportMaxPriority: Maybe<TicketPriority>;
  level: Maybe<Level>;
  location: Location;
  name: Scalars['String'];
  permissions: Array<Permission>;
  rawType: Array<DeskType>;
  reservationPolicies: Maybe<DeskReservationPolicies>;
  /** Get the shared desk schedule for this desk */
  schedule: Maybe<SharedDeskSchedule>;
  settings: Maybe<Array<Setting>>;
  space: Space;
  state: DeskState;
  stickers: Array<Sticker>;
  /** Specify the type of booking supported for this desk (Assigned, Hot, Hoteled). */
  type: BookingPolicyType;
  updatedAt: Scalars['Date'];
  /** Stable identifier from robin-api, as 32 lowercase hex characters. Null for records that have not been assigned one yet. */
  uuid: Maybe<Scalars['ID']>;
  windowedAvailability: Array<WindowAvailability>;
  zone: Maybe<Zone>;
};


export type DeskAvailabilityForArgs = {
  duration?: InputMaybe<Scalars['Int']>;
  startTime: Scalars['Date'];
  userId: Scalars['ID'];
};


export type DeskAvailabilityWithOverlappingReservationsArgs = {
  durationInMinutes?: InputMaybe<Scalars['Int']>;
  time?: InputMaybe<Scalars['Date']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type DeskAvailableAtArgs = {
  time?: InputMaybe<Scalars['Date']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type DeskCanDelegateArgs = {
  endTime: Scalars['Date'];
  startTime: Scalars['Date'];
};


export type DeskInstantAvailabilityAtArgs = {
  time?: InputMaybe<Scalars['Date']>;
};


export type DeskScheduleArgs = {
  userId?: InputMaybe<Scalars['ID']>;
};


export type DeskStateArgs = {
  endTime: Scalars['Date'];
  recurrence?: InputMaybe<Scalars['String']>;
  startTime: Scalars['Date'];
  userId?: InputMaybe<Scalars['Int']>;
};


export type DeskWindowedAvailabilityArgs = {
  intervalInMinutes: Scalars['Int'];
  numberOfWindows: Scalars['Int'];
  startTime?: InputMaybe<Scalars['Date']>;
};

export type DeskAmenity = {
  __typename: 'DeskAmenity';
  amenityId: Maybe<Scalars['Int']>;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  name: Scalars['String'];
  quantity: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

export type DeskAssignee = {
  __typename: 'DeskAssignee';
  email: Maybe<Scalars['String']>;
  familyName: Maybe<Scalars['String']>;
  givenName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
};

export type DeskAssignmentSchedule = {
  __typename: 'DeskAssignmentSchedule';
  floor: Floor;
  id: Scalars['ID'];
  label: Scalars['String'];
  recurrence: Scalars['String'];
};

export type DeskAvailability = {
  __typename: 'DeskAvailability';
  id: Scalars['ID'];
  nextAvailableMeta: NextAvailableMeta;
  status: Availability;
  unbookableReasons: Array<DeskunbookableReasons>;
};

export type DeskAvailabilityByDate = {
  __typename: 'DeskAvailabilityByDate';
  availability: Availability;
  date: Scalars['LocalDate'];
  deskId: Scalars['ID'];
  overlappingReservations: Array<Reservation>;
  unbookableReasons: Array<Maybe<DeskunbookableReasons>>;
};

export type DeskAvailabilityByLevelId = {
  __typename: 'DeskAvailabilityByLevelId';
  availableDeskIds: Array<Scalars['Int']>;
  busyDeskIds: Array<Scalars['Int']>;
  forbiddenDeskIds: Array<Scalars['Int']>;
};

export type DeskAvailabilityLocalizedDate = {
  __typename: 'DeskAvailabilityLocalizedDate';
  availability: Availability;
  dates: Array<Scalars['LocalDate']>;
  deskId: Scalars['ID'];
  timezone: Scalars['IANATimezone'];
  /** Specify the type of booking supported for this desk (Assigned, Hot, Hoteled). */
  type: BookingPolicyType;
  unbookableReasons: Array<Maybe<DeskunbookableReasons>>;
};

export type DeskAvailabilityMultiDay = {
  __typename: 'DeskAvailabilityMultiDay';
  availabilities: Array<DeskAvailabilityLocalizedDate>;
  deskId: Scalars['ID'];
  timezone: Scalars['IANATimezone'];
  type: BookingPolicyType;
};

export type DeskAvailabilityWithOverlappingReservations = {
  __typename: 'DeskAvailabilityWithOverlappingReservations';
  availability: Availability;
  overlappingReservations: Array<Reservation>;
};

export type DeskChangeInput = {
  id: Scalars['ID'];
  state?: InputMaybe<DeskEntityStateInput>;
  type: EntityType;
};

export type DeskChangePayload = {
  __typename: 'DeskChangePayload';
  id: Scalars['ID'];
  state: Maybe<DeskEntityStatePayload>;
  type: EntityType;
};

export type DeskConfirmation = {
  __typename: 'DeskConfirmation';
  confirmationWindowEnd: Maybe<Scalars['Date']>;
  confirmationWindowStart: Maybe<Scalars['Date']>;
  confirmedAt: Maybe<Scalars['String']>;
  deviceId: Maybe<Scalars['ID']>;
  method: Maybe<ConfirmationMethod>;
  seatReservationId: Scalars['ID'];
  status: DeskConfirmationStatus;
  unconfirmableReasons: Array<UnconfirmableReason>;
  user: Maybe<User>;
};

export enum DeskConfirmationStatus {
  /** Desk reservation cannot be confirmed */
  CANNOT_CONFIRM = 'CANNOT_CONFIRM',
  /** Desk reservation has been confirmed */
  CONFIRMED = 'CONFIRMED',
  /** Desk reservation has been declined */
  DECLINED = 'DECLINED',
  /** Desk reservation has not been confirmed */
  UNCONFIRMED = 'UNCONFIRMED'
}

export enum DeskConfirmationType {
  COMPASS = 'Compass',
  DASHBOARD = 'Dashboard',
  DOORBADGESWIPE = 'DoorBadgeSwipe',
  EMAIL = 'Email',
  GEOFENCE = 'Geofence',
  IP = 'IP',
  NFC = 'NFC',
  QR = 'QR',
  SLACK = 'Slack',
  TEAMS = 'Teams'
}

export type DeskEntity = {
  __typename: 'DeskEntity';
  data: Maybe<DeskEntityData>;
  id: Scalars['ID'];
  previousState: Maybe<DeskEntityState>;
  state: DeskEntityState;
  type: EntityType;
};

export type DeskEntityData = {
  __typename: 'DeskEntityData';
  amenities: Maybe<Array<Maybe<DeskAmenity>>>;
  floor: Maybe<Level>;
  id: Scalars['ID'];
  name: Scalars['String'];
  zone: Zone;
};

export type DeskEntityState = {
  __typename: 'DeskEntityState';
  assignments: Array<Assignment>;
  id: Scalars['ID'];
  isDisabled: Maybe<Scalars['Boolean']>;
  isReservable: Scalars['Boolean'];
  reservationTypes: Array<Scalars['String']>;
};

export type DeskEntityStateInput = {
  assignments: Array<AssignmentInput>;
  isReservable: Scalars['Boolean'];
  reservationTypes: Array<DeskType>;
};

export type DeskEntityStatePayload = {
  __typename: 'DeskEntityStatePayload';
  assignments: Array<AssignmentPayload>;
  isReservable: Scalars['Boolean'];
  reservationTypes: Array<DeskType>;
};

export enum DeskFilters {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED'
}

export type DeskReservabilityChangedAuditMetadata = {
  __typename: 'DeskReservabilityChangedAuditMetadata';
  desk: MetadataDeskObject;
  isReservable: Scalars['Boolean'];
  newDeskIsReservable: Maybe<Scalars['Boolean']>;
  oldDeskIsReservable: Maybe<Scalars['Boolean']>;
};

export type DeskReservationCheckinPolicies = {
  __typename: 'DeskReservationCheckinPolicies';
  assignedCheckInEnabled: Maybe<Scalars['Boolean']>;
  checkInWindow: Maybe<Scalars['String']>;
  /** there are other checkin policies available, but we only expose this one */
  enforceLocalCheckinOnly: Scalars['Boolean'];
  id: Scalars['ID'];
};

export type DeskReservationFilter = {
  types?: InputMaybe<Array<BookingPolicyType>>;
};

export type DeskReservationInstancesBySeriesId = {
  __typename: 'DeskReservationInstancesBySeriesId';
  reservations: Array<Reservation>;
  seriesId: Scalars['ID'];
};

export type DeskReservationPolicies = {
  __typename: 'DeskReservationPolicies';
  abandonedDeskProtectionEnabled: Maybe<Scalars['Boolean']>;
  abandonedDeskProtectionThreshold: Maybe<Scalars['String']>;
  allowExclusions: Maybe<Scalars['Boolean']>;
  allowOverlappingReservations: Maybe<Scalars['Boolean']>;
  bookingWindowPolicyDuration: Maybe<Scalars['String']>;
  bookingWindowPolicyInfo: Maybe<BookingWindowPolicyInfo>;
  /** If this is null, checkin policies are not enabled for the desk */
  checkinPolicies: Maybe<DeskReservationCheckinPolicies>;
  id: Scalars['ID'];
  seatReservationAdvancedBookingThreshold: Maybe<Scalars['String']>;
  seatReservationMaxLength: Maybe<Scalars['String']>;
  seatReservationTypesAllowed: Maybe<Scalars['String']>;
  seatReservationVisibilityEnabled: Maybe<Scalars['Boolean']>;
};


export type DeskReservationPoliciesBookingWindowPolicyDurationArgs = {
  startTime: Scalars['Date'];
};

export enum DeskReservationVisibility {
  EVERYONE = 'EVERYONE',
  JUST_ME = 'JUST_ME'
}

export type DeskSchedule = {
  __typename: 'DeskSchedule';
  avatar: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  lastName: Maybe<Scalars['String']>;
  recurrence: Scalars['String'];
  uniqueId: Scalars['ID'];
  userId: Maybe<Scalars['ID']>;
};

export type DeskSearchHit = GlobalSearchHit & {
  __typename: 'DeskSearchHit';
  displayName: Scalars['String'];
  entityId: Scalars['ID'];
  entityType: GlobalSearchEntityType;
  id: Scalars['ID'];
  levelId: Maybe<Scalars['ID']>;
  levelName: Maybe<Scalars['String']>;
  locationId: Scalars['ID'];
  locationName: Maybe<Scalars['String']>;
  score: Scalars['Float'];
};

export type DeskState = {
  __typename: 'DeskState';
  availability: DeskAvailability;
  exclusions: Array<Exclusion>;
  id: Scalars['ID'];
  primaryReservation: Maybe<Reservation>;
  reservations: Array<Reservation>;
};

export type DeskStatistics = {
  __typename: 'DeskStatistics';
  new: Statistics;
  previous: Statistics;
};

export enum DeskType {
  ASSIGNED = 'assigned',
  HOT = 'hot',
  HOTELED = 'hoteled',
  SHARED = 'shared'
}

export type DeskTypeChangedAuditMetadata = {
  __typename: 'DeskTypeChangedAuditMetadata';
  desk: MetadataDeskObject;
  newDeskType: Maybe<Array<Scalars['String']>>;
  oldDeskType: Maybe<Array<Scalars['String']>>;
  type: Array<Scalars['String']>;
};

export enum DeskUnbookableReasonType {
  BOOKING_WINDOW_POLICY = 'BOOKING_WINDOW_POLICY',
  LACKING_PERMISSIONS = 'LACKING_PERMISSIONS',
  MAX_CAPACITY_REACHED = 'MAX_CAPACITY_REACHED',
  NO_ACCESS = 'NO_ACCESS',
  SCHEDULE_VIOLATED = 'SCHEDULE_VIOLATED',
  SEAT_RESERVATION_ADVANCED_BOOKING_THRESHOLD = 'SEAT_RESERVATION_ADVANCED_BOOKING_THRESHOLD',
  SEAT_RESERVATION_MAX_LENGTH = 'SEAT_RESERVATION_MAX_LENGTH',
  SEAT_RESERVATION_RECURRENCE_ALLOWED = 'SEAT_RESERVATION_RECURRENCE_ALLOWED',
  SEAT_RESERVATION_WORKING_HOURS_RESTRICTED = 'SEAT_RESERVATION_WORKING_HOURS_RESTRICTED',
  UNKNOWN = 'UNKNOWN',
  VIOLATE_HOT_DESK_POLICY = 'VIOLATE_HOT_DESK_POLICY'
}

export type DeskWithAssignees = {
  __typename: 'DeskWithAssignees';
  assignees: Array<DeskAssignee>;
  isDisabled: Scalars['Boolean'];
  isReservable: Scalars['Boolean'];
  permissions: Array<Permission>;
  seatId: Scalars['ID'];
  seatType: Array<BookingPolicyType>;
};

export type DeskunbookableReasons = {
  __typename: 'DeskunbookableReasons';
  reason: DeskUnbookableReasonType;
  value: Maybe<Scalars['String']>;
};

export type Device = EventAuditLogActor & {
  __typename: 'Device';
  id: Scalars['ID'];
};

export type DeviceAuthorizationResponse = {
  __typename: 'DeviceAuthorizationResponse';
  bearerToken: Scalars['String'];
  deviceName: Scalars['String'];
  deviceType: DeviceType;
  /** device ID */
  id: Scalars['ID'];
  location: Location;
  organizationId: Scalars['ID'];
  refreshToken: Scalars['String'];
};

export enum DeviceFeatureFlagType {
  /** Feature flag for enabling badge printing from an arrival display */
  ARRIVAL_DISPLAY_BADGE_PRINTING = 'ARRIVAL_DISPLAY_BADGE_PRINTING',
  /** Enables using custom visit types on devices like the Arrival Display or GuestUI */
  CUSTOM_VISIT_TYPES = 'CUSTOM_VISIT_TYPES',
  /** Enables requiring drawn signatures on visit document agreements */
  DOCUMENT_SIGNATURES = 'DOCUMENT_SIGNATURES',
  /** Language selection feature flag for project global */
  LANGUAGE_SELECTION_ENABLED = 'LANGUAGE_SELECTION_ENABLED',
  /** Language selection feature flag for a location global */
  LOCATION_LANGUAGE_SELECTION_ENABLED = 'LOCATION_LANGUAGE_SELECTION_ENABLED',
  /** Enables the ability to capture images to be used on visitor badges */
  VISITOR_BADGE_IMAGES = 'VISITOR_BADGE_IMAGES'
}

export enum DeviceStatus {
  OFFLINE = 'OFFLINE',
  ONLINE = 'ONLINE',
  UNKNOWN = 'UNKNOWN'
}

export enum DeviceStatusInput {
  OFFLINE = 'OFFLINE',
  ONLINE = 'ONLINE'
}

export type DeviceStatusReport = {
  __typename: 'DeviceStatusReport';
  lastCheckinMessage: Maybe<Scalars['String']>;
  lastCheckinResult: Maybe<DeviceStatusInput>;
  lastCheckinTime: Maybe<Scalars['String']>;
  status: DeviceStatus;
};

export type DisableGeofenceFeatureForBuildingInput = {
  buildingId: Scalars['ID'];
};

export type DisableSpacesResults = {
  __typename: 'DisableSpacesResults';
  failedIds: Array<Scalars['Int']>;
  successfulIds: Array<Scalars['Int']>;
};

export type DiscardStackPlanResponse = {
  __typename: 'DiscardStackPlanResponse';
  /** How many allocation drafts were discarded along with the plan. */
  discardedAllocations: Scalars['Int'];
  id: Scalars['ID'];
};

export type DisconnectBrivoAccountResponse = {
  __typename: 'DisconnectBrivoAccountResponse';
  uuid: Scalars['ID'];
};

export type DisconnectGallagherAccountByIntegrationUuidInput = {
  integrationUuid: Scalars['ID'];
};

export type DisconnectGallagherAccountByIntegrationUuidResponse = {
  __typename: 'DisconnectGallagherAccountByIntegrationUuidResponse';
  uuid: Scalars['ID'];
};

export type DisconnectGeneaAccountByIntegrationUuidInput = {
  integrationUuid: Scalars['ID'];
};

export type DisconnectGeneaAccountByIntegrationUuidResponse = {
  __typename: 'DisconnectGeneaAccountByIntegrationUuidResponse';
  uuid: Scalars['ID'];
};

export type DisconnectGenericConnectorAccountByIntegrationUuidInput = {
  integrationUuid: Scalars['ID'];
};

export type DisconnectGenericConnectorAccountByIntegrationUuidResponse = {
  __typename: 'DisconnectGenericConnectorAccountByIntegrationUuidResponse';
  uuid: Scalars['ID'];
};

export type DisconnectGenetecAccountByIntegrationUuidInput = {
  integrationUuid: Scalars['ID'];
};

export type DisconnectGenetecAccountByIntegrationUuidResponse = {
  __typename: 'DisconnectGenetecAccountByIntegrationUuidResponse';
  uuid: Scalars['ID'];
};

export type DisconnectGoogleAccountByIntegrationUuidInput = {
  integrationUuid: Scalars['ID'];
};

export type DisconnectGoogleAccountByIntegrationUuidResponse = {
  __typename: 'DisconnectGoogleAccountByIntegrationUuidResponse';
  uuid: Scalars['ID'];
};

export type DisconnectLogiSyncAccountByIntegrationUuidInput = {
  integrationUuid: Scalars['ID'];
};

export type DisconnectLogiSyncAccountByIntegrationUuidResponse = {
  __typename: 'DisconnectLogiSyncAccountByIntegrationUuidResponse';
  uuid: Scalars['ID'];
};

export type DisconnectNeatPulseAccountByIntegrationUuidInput = {
  integrationUuid: Scalars['ID'];
};

export type DisconnectNeatPulseAccountByIntegrationUuidResponse = {
  __typename: 'DisconnectNeatPulseAccountByIntegrationUuidResponse';
  uuid: Scalars['ID'];
};

export type DisconnectOpenpathAccountResponse = {
  __typename: 'DisconnectOpenpathAccountResponse';
  uuid: Scalars['ID'];
};

export type DisconnectVerkadaAccountByIntegrationUuidInput = {
  integrationUuid: Scalars['ID'];
};

export type DisconnectVerkadaAccountByIntegrationUuidResponse = {
  __typename: 'DisconnectVerkadaAccountByIntegrationUuidResponse';
  uuid: Scalars['ID'];
};

export type DisconnectZoomRoomsAccountByIntegrationUuidInput = {
  integrationUuid: Scalars['ID'];
};

export type DisconnectZoomRoomsAccountByIntegrationUuidResponse = {
  __typename: 'DisconnectZoomRoomsAccountByIntegrationUuidResponse';
  uuid: Scalars['ID'];
};

export type DisconnnectKisiAccountResponse = {
  __typename: 'DisconnnectKisiAccountResponse';
  uuid: Scalars['ID'];
};

/** Scopes one Google Meet discovery run. Omit everything for the default crawl. */
export type DiscoverGoogleMeetDevicesInput = {
  /** Also import the tenant's ChromeOS inventory snapshot as part of this run. */
  includeChromeOsSnapshot?: InputMaybe<Scalars['Boolean']>;
  /** Robin Space ids, as decimal digit strings, that this run may create correlations against. Bounds which correlations the run may create: a device whose meetings never resolve into one of these spaces is left unplaced rather than placed somewhere the caller did not ask about. Up to 10,000 ids. Omit for the tenant's whole estate. */
  targetRobinSpaceIds?: InputMaybe<Array<Scalars['String']>>;
  /** The call-history window to correlate against. Omit for the job's default lookback. Windows may overlap or be disjoint across runs — the caller decides why; the collector just honours what it is given. */
  timeRange?: InputMaybe<DiscoverGoogleMeetDevicesInputTimeRange>;
};

/** A start/end pair over call history, both ISO 8601 instants. */
export type DiscoverGoogleMeetDevicesInputTimeRange = {
  endAt: Scalars['DateTime'];
  startAt: Scalars['DateTime'];
};

export type DiscoverGoogleMeetDevicesResponse = {
  __typename: 'DiscoverGoogleMeetDevicesResponse';
  /** The run this crawl created, a UUID. The caller persists it into a uuid column and later asks for the run's report by it, so it is non-null: a crawl that produced no run id failed. */
  discoveryRunId: Scalars['ID'];
  /** The Google integration UUID discovery was kicked off for. */
  integrationUuid: Scalars['ID'];
};

/** Where a discovery run is. Closed, and the members are the wire format: the client renders and compares these strings literally, so a reworded value would read as a brand-new phase there. */
export enum DiscoveryPhase {
  /** Reading Google's call history to build the baseline of which rooms hosted meetings and which devices joined them. */
  COLLECTING_HISTORY = 'collecting_history',
  /** The run's work is done. Completion means the crawl ran, not that every device found a room — unplaced devices are a normal outcome. */
  COMPLETED = 'completed',
  /** Correlating devices to spaces, one device at a time. */
  CORRELATING = 'correlating',
  /** The run stopped before finishing. A terminal outcome like completed, but for a crawl that bailed: the run's error column records why, and the activity feed narrates how far it got before it stopped. A screen that polls until the run is over must treat this as done, not keep waiting. */
  FAILED = 'failed',
  /** Sized the correlation pass from the baseline: which room resources exist, and which devices could be correlated. */
  PLANNING_CORRELATIONS = 'planning_correlations'
}

export type DistributionInput = {
  distributionService: DistributionService;
  id?: InputMaybe<Scalars['ID']>;
  recipients: Array<DistributionRecipientInput>;
};

/** display -> what is shown to user (ie slack channel name) value -> identifier data used to cross post (ie slack channel conversationId) */
export type DistributionRecipient = {
  __typename: 'DistributionRecipient';
  display: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  value: Scalars['String'];
};

export type DistributionRecipientInput = {
  display?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  value: Scalars['String'];
};

export enum DistributionService {
  EMAIL = 'EMAIL',
  SLACK = 'SLACK',
  TEAMS = 'TEAMS'
}

export type Draft = {
  __typename: 'Draft';
  floorName: Maybe<Scalars['String']>;
  hasAuditLogs: Maybe<Scalars['Boolean']>;
  hasConflicts: Maybe<Scalars['Boolean']>;
  hasReviewData: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isLocked: Scalars['Boolean'];
  lastUpdated: Maybe<DraftAuditInfo>;
  levelId: Scalars['ID'];
  locationId: Scalars['ID'];
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  owner: Maybe<DraftAuditInfo>;
  reviewVersion: Maybe<Scalars['Int']>;
  settings: Array<DraftSettings>;
  status: DraftStatus;
  version: Scalars['Int'];
};

export enum DraftAccessLevel {
  COLLABORATOR = 'collaborator',
  EDITOR = 'editor',
  VIEWER = 'viewer'
}

export type DraftAccountUser = {
  __typename: 'DraftAccountUser';
  assignments: Maybe<Array<Maybe<DraftDeskAssignmentSchedule>>>;
  avatar: Maybe<Scalars['String']>;
  familyName: Maybe<Scalars['String']>;
  givenName: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Maybe<Scalars['String']>;
  primaryEmail: Maybe<PrimaryEmail>;
  slug: Maybe<Scalars['String']>;
};

/** User/seat classification derived purely from a draft's desk changes (child drafts aggregated). The user service combines this with live state in SQL — see project-docs/ux-improvement-support/2026-06-16-people-list-filter-sort.md. */
export type DraftAssignmentClassification = {
  __typename: 'DraftAssignmentClassification';
  /** Distinct user ids appearing in the new assignee list of any desk change in the draft. */
  assignedUserIds: Array<Scalars['ID']>;
  /** Distinct seat ids that have a desk change in the draft. */
  changedSeatIds: Array<Scalars['ID']>;
};

export enum DraftAssignmentStatus {
  ASSIGNED = 'ASSIGNED',
  UNASSIGNED = 'UNASSIGNED'
}

export enum DraftAuditEntityType {
  COLLABORATOR = 'COLLABORATOR',
  DESK = 'DESK',
  DRAFT = 'DRAFT',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  QUEUE = 'QUEUE',
  SETTINGS = 'SETTINGS',
  USER_ASSIGNMENT = 'USER_ASSIGNMENT'
}

export type DraftAuditInfo = {
  __typename: 'DraftAuditInfo';
  avatar: Maybe<Scalars['String']>;
  date: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  name: Maybe<Scalars['String']>;
  primaryEmail: Maybe<PrimaryEmail>;
  userId: Scalars['ID'];
};

export type DraftAuditLog = {
  __typename: 'DraftAuditLog';
  changeTimestamp: Scalars['String'];
  draftId: Scalars['ID'];
  entityId: Scalars['String'];
  entityType: DraftAuditEntityType;
  floor: Maybe<DraftFloorInfo>;
  id: Scalars['ID'];
  isReleased: Scalars['Boolean'];
  metadata: Maybe<DraftAuditLogMetadata>;
  operationType: DraftAuditOperationType;
  releasedAt: Maybe<Scalars['String']>;
  user: AuditUserObject;
};

export type DraftAuditLogFilters = {
  endDate?: InputMaybe<Scalars['String']>;
  entityTypes?: InputMaybe<Array<DraftAuditEntityType>>;
  isReleased?: InputMaybe<Scalars['Boolean']>;
  operationTypes?: InputMaybe<Array<DraftAuditOperationType>>;
  sortOrder?: InputMaybe<DraftAuditLogSortOrder>;
  startDate?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type DraftAuditLogMetadata = BuildingDraftPublishedMetadata | DeskReservabilityChangedAuditMetadata | DeskTypeChangedAuditMetadata | DraftCollaboratorAccessLevelChangedAuditMetadata | DraftCollaboratorRemovedAuditMetadata | DraftCreatedAuditMetadata | DraftCsvExportSentAuditMetadata | DraftDiscardedAuditMetadata | DraftEmailsSentToAffectedUsersAuditMetadata | DraftLockStatusChangedAuditMetadata | DraftPublishedAuditMetadata | DraftRenamedAuditMetadata | DraftSharedAuditMetadata | DraftShowNeighborhoodColorSettingUpdatedMetadata | NeighborhoodColorChangedAuditMetadata | NeighborhoodCreatedAuditMetadata | NeighborhoodDesksChangedAuditMetadata | NeighborhoodRemovedAuditMetadata | NeighborhoodRenamedAuditMetadata | UserAssignmentChangedAuditMetadata;

export enum DraftAuditLogSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type DraftAuditLogsResponse = {
  __typename: 'DraftAuditLogsResponse';
  auditLogs: Array<DraftAuditLog>;
  draftName: Scalars['String'];
  hasMore: Scalars['Boolean'];
  total: Scalars['Int'];
};

export enum DraftAuditOperationType {
  BUILDING_DRAFT_PUBLISHED = 'BUILDING_DRAFT_PUBLISHED',
  DESKS_ADDED_TO_NEIGHBORHOOD = 'DESKS_ADDED_TO_NEIGHBORHOOD',
  DESKS_REMOVED_FROM_NEIGHBORHOOD = 'DESKS_REMOVED_FROM_NEIGHBORHOOD',
  DESK_AVAILABILITY_CHANGED = 'DESK_AVAILABILITY_CHANGED',
  DESK_TYPE_CHANGED = 'DESK_TYPE_CHANGED',
  DRAFT_ACCESS_LEVEL_CHANGED = 'DRAFT_ACCESS_LEVEL_CHANGED',
  DRAFT_COLLABORATOR_REMOVED = 'DRAFT_COLLABORATOR_REMOVED',
  DRAFT_CREATED = 'DRAFT_CREATED',
  DRAFT_CSV_EXPORT_SENT = 'DRAFT_CSV_EXPORT_SENT',
  DRAFT_DISCARDED = 'DRAFT_DISCARDED',
  DRAFT_EMAILS_SENT_TO_AFFECTED_USERS = 'DRAFT_EMAILS_SENT_TO_AFFECTED_USERS',
  DRAFT_LOCK_STATUS_CHANGED = 'DRAFT_LOCK_STATUS_CHANGED',
  DRAFT_PUBLISHED = 'DRAFT_PUBLISHED',
  DRAFT_RENAMED = 'DRAFT_RENAMED',
  DRAFT_SHARED = 'DRAFT_SHARED',
  DRAFT_SHOW_NEIGHBORHOOD_COLOR_SETTING_UPDATED = 'DRAFT_SHOW_NEIGHBORHOOD_COLOR_SETTING_UPDATED',
  NEIGHBORHOOD_COLOR_CHANGED = 'NEIGHBORHOOD_COLOR_CHANGED',
  NEIGHBORHOOD_CREATED = 'NEIGHBORHOOD_CREATED',
  NEIGHBORHOOD_REMOVED = 'NEIGHBORHOOD_REMOVED',
  NEIGHBORHOOD_RENAMED = 'NEIGHBORHOOD_RENAMED',
  USER_ASSIGNED_TO_DESK = 'USER_ASSIGNED_TO_DESK',
  USER_UNASSIGNED_FROM_DESK = 'USER_UNASSIGNED_FROM_DESK'
}

export type DraftAuditPaginationInput = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type DraftChangeSummary = {
  __typename: 'DraftChangeSummary';
  assignmentChanges: Scalars['Int'];
  deskStateChanges: Scalars['Int'];
  neighborhoodChanges: Scalars['Int'];
};

export enum DraftCollaboratorAccessLevel {
  COLLABORATOR = 'collaborator',
  VIEWER = 'viewer'
}

export type DraftCollaboratorAccessLevelChangedAuditMetadata = {
  __typename: 'DraftCollaboratorAccessLevelChangedAuditMetadata';
  buildingId: Maybe<Scalars['ID']>;
  buildingName: Maybe<Scalars['String']>;
  newValue: DraftAccessLevel;
  oldValue: DraftAccessLevel;
  user: AuditUserObject;
};

export type DraftCollaboratorRemovedAuditMetadata = {
  __typename: 'DraftCollaboratorRemovedAuditMetadata';
  buildingId: Maybe<Scalars['ID']>;
  buildingName: Maybe<Scalars['String']>;
  users: Array<AuditUserObject>;
};

export type DraftConflict = {
  __typename: 'DraftConflict';
  draftChange: Maybe<EntityState>;
  entityData: Maybe<EntityData>;
  entityId: Scalars['ID'];
  entityType: DraftConflictEntityType;
  id: Scalars['ID'];
  liveState: Maybe<EntityState>;
  reason: DraftConflictReason;
  type: DraftConflictType;
};

export enum DraftConflictEntityType {
  DESK = 'desk'
}

export enum DraftConflictReason {
  DESK_DELETED = 'desk_deleted',
  SNAPSHOT_LIVE_MISMATCH = 'snapshot_live_mismatch',
  USER_DELETED = 'user_deleted'
}

export enum DraftConflictType {
  ACTIONABLE = 'actionable',
  INFORMATIVE = 'informative'
}

export type DraftCreatedAuditMetadata = {
  __typename: 'DraftCreatedAuditMetadata';
  buildingId: Maybe<Scalars['ID']>;
  buildingName: Maybe<Scalars['String']>;
  draftName: Scalars['String'];
  shouldKeepAssignments: Maybe<Scalars['Boolean']>;
  shouldKeepNeighborhoods: Maybe<Scalars['Boolean']>;
};

export type DraftCsvExportSentAuditMetadata = {
  __typename: 'DraftCsvExportSentAuditMetadata';
  buildingId: Maybe<Scalars['ID']>;
  buildingName: Maybe<Scalars['String']>;
  customMessage: Maybe<Scalars['String']>;
  recipients: Array<AuditUserObject>;
  recipientsCount: Scalars['Int'];
};

export type DraftDeskAssignmentSchedule = {
  __typename: 'DraftDeskAssignmentSchedule';
  deskId: Scalars['ID'];
  floor: Maybe<Level>;
  id: Scalars['ID'];
  label: Maybe<Scalars['String']>;
  recurrence: Scalars['String'];
  zone: Maybe<Zone>;
};

export type DraftDiscardedAuditMetadata = {
  __typename: 'DraftDiscardedAuditMetadata';
  buildingId: Maybe<Scalars['ID']>;
  buildingName: Maybe<Scalars['String']>;
  draftName: Scalars['String'];
};

export type DraftEmailsSentToAffectedUsersAuditMetadata = {
  __typename: 'DraftEmailsSentToAffectedUsersAuditMetadata';
  buildingId: Maybe<Scalars['ID']>;
  buildingName: Maybe<Scalars['String']>;
  customMessage: Maybe<Scalars['String']>;
  numberOfPeopleNotified: Scalars['Int'];
};

export type DraftFiltersInput = {
  buildingId?: InputMaybe<Scalars['ID']>;
  floorId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Array<InputMaybe<DraftStatus>>>;
};

export type DraftFiltersInputV2 = {
  status?: InputMaybe<Array<InputMaybe<DraftStatus>>>;
};

export type DraftFloorInfo = {
  __typename: 'DraftFloorInfo';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type DraftFloorNotificationMetadata = {
  __typename: 'DraftFloorNotificationMetadata';
  floorId: Scalars['ID'];
  floorName: Scalars['String'];
  hasAffectedUsers: Scalars['Boolean'];
};

export type DraftInput = {
  levelId: Scalars['ID'];
  name: Scalars['String'];
  settings: Array<DraftSettingsInput>;
};

export type DraftLayoutInputEntity = {
  deletedResources?: InputMaybe<Array<Scalars['ID']>>;
  resourceGroups?: InputMaybe<Array<ResourceGroupInput>>;
  updatedResources?: InputMaybe<Array<DraftLayoutUpdateResourceInputEntity>>;
};

export type DraftLayoutUpdateResourceInputEntity = {
  id: Scalars['ID'];
  parcel?: InputMaybe<LayoutParcelInput>;
};

export type DraftListItemV2 = {
  __typename: 'DraftListItemV2';
  draftScope: DraftScope;
  hasAuditLogs: Maybe<Scalars['Boolean']>;
  hasReviewData: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isExportAvailable: Maybe<Scalars['Boolean']>;
  lastUpdated: DraftAuditInfo;
  levelId: Maybe<Scalars['ID']>;
  levelName: Maybe<Scalars['String']>;
  locationId: Scalars['ID'];
  name: Scalars['String'];
  owner: DraftAuditInfo;
  reviewVersion: Maybe<Scalars['Int']>;
  settings: Array<DraftSettings>;
  status: DraftStatus;
  version: Maybe<Scalars['Int']>;
};

export type DraftLockStatusChangedAuditMetadata = {
  __typename: 'DraftLockStatusChangedAuditMetadata';
  buildingId: Maybe<Scalars['ID']>;
  buildingName: Maybe<Scalars['String']>;
  newValue: Scalars['Boolean'];
  oldValue: Scalars['Boolean'];
};

export type DraftMetadata = {
  __typename: 'DraftMetadata';
  hasChanges: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isLocked: Scalars['Boolean'];
  lastUpdated: Maybe<DraftAuditInfo>;
  name: Maybe<Scalars['String']>;
  owner: Maybe<DraftAuditInfo>;
  version: Scalars['Int'];
};

export type DraftNeighborhoodResource = {
  __typename: 'DraftNeighborhoodResource';
  id: Scalars['ID'];
  resourceId: Scalars['ID'];
  type: NeighborhoodResourceType;
};

export type DraftNotificationMetadata = {
  __typename: 'DraftNotificationMetadata';
  affectedUsersCount: Scalars['Int'];
  floors: Maybe<Array<DraftFloorNotificationMetadata>>;
  lastNotificationSentAt: Maybe<Scalars['String']>;
};

export enum DraftOrderByValues {
  CREATEDAT = 'createdAt',
  CREATEDBY = 'createdBy',
  FLOORNAME = 'floorName',
  NAME = 'name',
  STATUS = 'status',
  TYPE = 'type',
  UPDATEDAT = 'updatedAt',
  UPDATEDBY = 'updatedBy'
}

export type DraftPagingResult = {
  __typename: 'DraftPagingResult';
  drafts: Array<Draft>;
  draftsTotal: Scalars['Int'];
  hasNextPage: Scalars['Boolean'];
  nextPageOffset: Scalars['Int'];
};

export type DraftPagingResultV2 = {
  __typename: 'DraftPagingResultV2';
  drafts: Array<DraftListItemV2>;
  draftsTotal: Scalars['Int'];
  hasNextPage: Scalars['Boolean'];
  nextPageOffset: Scalars['Int'];
};

export type DraftPublishedAuditMetadata = {
  __typename: 'DraftPublishedAuditMetadata';
  buildingId: Maybe<Scalars['ID']>;
  buildingName: Maybe<Scalars['String']>;
  draftName: Scalars['String'];
  publishedAt: Maybe<Scalars['String']>;
  publishedBy: Maybe<Scalars['String']>;
};

export type DraftRenamedAuditMetadata = {
  __typename: 'DraftRenamedAuditMetadata';
  buildingId: Maybe<Scalars['ID']>;
  buildingName: Maybe<Scalars['String']>;
  newName: Scalars['String'];
  oldName: Scalars['String'];
};

export enum DraftScope {
  BUILDING = 'building',
  FLOOR = 'floor'
}

export type DraftSettings = {
  __typename: 'DraftSettings';
  type: DraftSettingsType;
  value: Maybe<Scalars['String']>;
};

export type DraftSettingsInput = {
  booleanValue?: InputMaybe<Scalars['Boolean']>;
  name: DraftSettingsName;
  numberValue?: InputMaybe<Scalars['Float']>;
  stringValue?: InputMaybe<Scalars['String']>;
};

export enum DraftSettingsName {
  ASSIGNMENTS = 'ASSIGNMENTS',
  CONFLICTS = 'CONFLICTS',
  DEFAULT = 'DEFAULT',
  DISPOSABLE = 'DISPOSABLE',
  DRAFT_SCOPE = 'DRAFT_SCOPE',
  LAYOUT = 'LAYOUT',
  NEIGHBORHOODS = 'NEIGHBORHOODS'
}

export type DraftSettingsType = {
  __typename: 'DraftSettingsType';
  name: Scalars['String'];
  valueType: SettingValueType;
};

export type DraftSharedAuditMetadata = {
  __typename: 'DraftSharedAuditMetadata';
  buildingId: Maybe<Scalars['ID']>;
  buildingName: Maybe<Scalars['String']>;
  users: Array<AuditUserWithAccessLevelObject>;
};

export type DraftShowNeighborhoodColorSettingUpdatedMetadata = {
  __typename: 'DraftShowNeighborhoodColorSettingUpdatedMetadata';
  newValue: Scalars['Boolean'];
  oldValue: Scalars['Boolean'];
};

export enum DraftStatus {
  DISCARDED = 'discarded',
  /** A draft holding a copy of the building's live state, created so a caller can read who sits where without leaving a plan behind. Absent from every drafts listing by design, never publishable, and promotable to `open` once it holds a layout somebody has agreed to. */
  LIVE_STATE = 'live_state',
  OPEN = 'open',
  PUBLISHED = 'published',
  PUBLISHING = 'publishing',
  PUBLISHING_FAILED = 'publishing_failed'
}

export type DraftStatusResponse = {
  __typename: 'DraftStatusResponse';
  id: Scalars['ID'];
  status: DraftStatus;
};

export type DraftUserAssignments = {
  __typename: 'DraftUserAssignments';
  assignee: AssigneePayload;
  assignments: Array<DraftDeskAssignmentSchedule>;
};

export type DraftsSort = {
  field: DraftOrderByValues;
  order: SortDirection;
};

export type EditMeetingServicesCategoryChangesInput = {
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type EditMeetingServicesCategoryErrorResponse = {
  __typename: 'EditMeetingServicesCategoryErrorResponse';
  reason: EditMeetingServicesCategoryErrorResponseReason;
};

export enum EditMeetingServicesCategoryErrorResponseReason {
  CATEGORY_MISSING = 'CATEGORY_MISSING',
  NAME_IS_NOT_UNIQUE = 'NAME_IS_NOT_UNIQUE'
}

export type EditMeetingServicesCategoryInput = {
  changes: EditMeetingServicesCategoryChangesInput;
  meetingServicesCategoryId: Scalars['ID'];
};

export type EditMeetingServicesCategoryResponse = EditMeetingServicesCategoryErrorResponse | EditMeetingServicesCategorySuccessResponse;

export type EditMeetingServicesCategorySuccessResponse = {
  __typename: 'EditMeetingServicesCategorySuccessResponse';
  _: Maybe<Scalars['Void']>;
};

export type Email = {
  __typename: 'Email';
  email: Scalars['String'];
  isVerified: Scalars['Boolean'];
};

/** Emails of users who are deactivated or not existing in the tenant will be grouped in `invalid` */
export type EmailCheckResponse = {
  __typename: 'EmailCheckResponse';
  invalid: Array<Scalars['String']>;
  unverified: Array<Scalars['String']>;
  verified: Array<Scalars['String']>;
};

export type EmailConfiguration = {
  __typename: 'EmailConfiguration';
  attachment: Maybe<Scalars['String']>;
  headerBackgroundColorHexCode: Maybe<Scalars['String']>;
  headerFontColorHexCode: Maybe<Scalars['String']>;
  headerImageURL: Maybe<Scalars['String']>;
  locationId: Scalars['ID'];
};

export type EmailConfigurationInput = {
  attachment?: InputMaybe<Scalars['String']>;
  base64EncodedHeaderImage?: InputMaybe<Scalars['String']>;
  headerBackgroundColorHexCode?: InputMaybe<Scalars['String']>;
  headerFontColorHexCode?: InputMaybe<Scalars['String']>;
  headerImageURL?: InputMaybe<Scalars['String']>;
};

export type EmployeeCredentialProvisioningProvider = {
  __typename: 'EmployeeCredentialProvisioningProvider';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type EmployeeRegisteredForWaitlistVisitInput = {
  /** The employee ID. */
  employeeUserId: Scalars['ID'];
  /** The waitlist location ID. */
  waitlistLocationId: Scalars['ID'];
  /** The waitlist visit ID. */
  waitlistVisitId: Scalars['ID'];
};

export type EmployeeVisit = {
  __typename: 'EmployeeVisit';
  confirmation: EmployeeVisitConfirmation;
  endTime: Scalars['ISODateTime'];
  id: Scalars['ID'];
  location: Maybe<Location>;
  locationId: Scalars['ID'];
  scheduleId: Maybe<Scalars['ID']>;
  startTime: Scalars['ISODateTime'];
  status: EmployeeVisitStatus;
  userId: Scalars['ID'];
};

export type EmployeeVisitConfirmation = {
  __typename: 'EmployeeVisitConfirmation';
  confirmed_at: Maybe<Scalars['ISODateTime']>;
  employeeVisitId: Scalars['ID'];
  status: EmployeeVisitConfirmationStatus;
};

export enum EmployeeVisitConfirmationStatus {
  CANCELED = 'CANCELED',
  CONFIRMED = 'CONFIRMED',
  UNKNOWN = 'UNKNOWN'
}

export enum EmployeeVisitFilterSetting {
  ACTIVE_ONLY = 'ACTIVE_ONLY',
  ALL = 'ALL',
  CANCELLED_ONLY = 'CANCELLED_ONLY'
}

export type EmployeeVisitMutations = {
  __typename: 'EmployeeVisitMutations';
  excludeDaysFromAllSchedules: Maybe<Scalars['Void']>;
  setWeeklySchedule: Maybe<Scalars['ID']>;
};


export type EmployeeVisitMutationsExcludeDaysFromAllSchedulesArgs = {
  input?: InputMaybe<ExcludeAllDaysFromScheduleInput>;
};


export type EmployeeVisitMutationsSetWeeklyScheduleArgs = {
  input: SetWeeklyScheduleInput;
};

export type EmployeeVisitQueries = {
  __typename: 'EmployeeVisitQueries';
  /** Get all of an employee's visits during a specific time range within a specific org */
  getAllEmployeeVisitsForEmployee: Array<EmployeeVisit>;
  getAllWeeklySchedulesForUser: Maybe<AllSchedules>;
  getWeeklyScheduleForUser: Maybe<WeeklyScheduleResult>;
};


export type EmployeeVisitQueriesGetAllEmployeeVisitsForEmployeeArgs = {
  employeeId: Scalars['ID'];
  endTime: Scalars['ISODateTime'];
  filterSetting?: InputMaybe<EmployeeVisitFilterSetting>;
  startTime: Scalars['ISODateTime'];
};


export type EmployeeVisitQueriesGetAllWeeklySchedulesForUserArgs = {
  userId: Scalars['String'];
};


export type EmployeeVisitQueriesGetWeeklyScheduleForUserArgs = {
  locationId: Scalars['String'];
  userId: Scalars['String'];
};

export type EmployeeVisitSchedule = {
  __typename: 'EmployeeVisitSchedule';
  id: Maybe<Scalars['String']>;
};

export enum EmployeeVisitStatus {
  CANCELLED = 'CANCELLED',
  CONFIRMED = 'CONFIRMED',
  UNCONFIRMED = 'UNCONFIRMED'
}

export type EmployeeVisitsByDate = {
  __typename: 'EmployeeVisitsByDate';
  date: Scalars['Date'];
  employeeVisits: Array<EmployeeVisit>;
};

export type EnableGeofenceFeatureForBuildingInput = {
  buildingId: Scalars['ID'];
};

export type EndOrCancelDelegatedReservationResponse = {
  __typename: 'EndOrCancelDelegatedReservationResponse';
  reservationId: Scalars['ID'];
};

export type EndOrCancelReservationResponse = {
  __typename: 'EndOrCancelReservationResponse';
  reservationId: Scalars['ID'];
};

export type EndReservationOrVisitInRangeResponse = {
  __typename: 'EndReservationOrVisitInRangeResponse';
  reservationsCancelledAttempts: Maybe<Array<Maybe<CancelledVisitOrReservationResult>>>;
  /** If true, all visits and reservations in range were successfully cancelled. If false there are one or more failures */
  success: Scalars['Boolean'];
  visitsCancelledAttempts: Maybe<Array<Maybe<CancelledVisitOrReservationResult>>>;
};

/** One source's record of something that terminates communication in a place. An Endpoint is a SOURCE RECORD, not a fused physical thing. Google's Chromebox and a Logitech bar's sighting of the same box are two Endpoints, and the claim that they are one piece of hardware is an IS_SAME_AS relationship between them. One physical thing is therefore a connected component, not a row — which is what keeps fusion in the graph, where it can be inspected, explained and overruled, instead of buried in a merge that already happened. One exception: a Google Meet box is also a ChromeOS device, so it comes back once, as the ChromeOS device, placed by its Meet mapping. These fields are what every record has whatever it records. What is only true of a physical box — serial, MACs, model — lives on the concrete source types, so nothing here is nullable merely because some other kind of endpoint could not have it. */
export type Endpoint = {
  /** When a source first told us this endpoint exists. */
  firstSeenAt: Scalars['DateTime'];
  /** This service's own id, stable, so it is safe to store in another service or in a URL. */
  id: Scalars['ID'];
  /** When a source last told us this endpoint exists. This is the SOURCE's observation time, not our write time, so replaying an old import cannot make stale hardware look present. */
  lastSeenAt: Scalars['DateTime'];
  /** The name this source gave it, or null when it gave none — normal for something we only saw on a network. */
  name: Maybe<Scalars['String']>;
  /** Where this endpoint is, or null when nothing has placed it yet. Null is a normal steady state during onboarding, not an error: some placement evidence needs meetings to have happened before it exists. */
  placement: Maybe<EndpointPlacement>;
  /** Relationships with this endpoint at either end. Unfiltered this is every relationship the graph can answer for, including the ones it computes rather than stores. */
  relationships: Array<EndpointRelationship>;
  /** That source's own id for the endpoint. */
  remoteId: Scalars['String'];
  /** The system that reported it. With remoteId this is the natural key, so re-importing refreshes an Endpoint rather than adding one. */
  source: EndpointSource;
  vendor: Maybe<Scalars['String']>;
};


/** One source's record of something that terminates communication in a place. An Endpoint is a SOURCE RECORD, not a fused physical thing. Google's Chromebox and a Logitech bar's sighting of the same box are two Endpoints, and the claim that they are one piece of hardware is an IS_SAME_AS relationship between them. One physical thing is therefore a connected component, not a row — which is what keeps fusion in the graph, where it can be inspected, explained and overruled, instead of buried in a merge that already happened. One exception: a Google Meet box is also a ChromeOS device, so it comes back once, as the ChromeOS device, placed by its Meet mapping. These fields are what every record has whatever it records. What is only true of a physical box — serial, MACs, model — lives on the concrete source types, so nothing here is nullable merely because some other kind of endpoint could not have it. */
export type EndpointRelationshipsArgs = {
  kinds?: InputMaybe<Array<EndpointRelationshipKind>>;
};

export type EndpointDiscoverySourceStatus = {
  __typename: 'EndpointDiscoverySourceStatus';
  /** Endpoints this source has contributed so far. */
  endpointCount: Scalars['Int'];
  /** Null until the first pass finishes. */
  lastCompletedAt: Maybe<Scalars['DateTime']>;
  /** True when this source's crawl failed for a scope or privilege reason — the connected account lacks the admin access the source needs (e.g. ChromeOS device management). A screen surfaces a reconnect interstitial instead of treating the empty result as a normal completion. Absent reads as false. */
  permissionError: Maybe<Scalars['Boolean']>;
  /** Meetings this source's current pass has scanned so far. Null means indeterminate, not zero: the Reports API exposes no total until a baseline completes, so there is nothing honest to count against yet. Present, the pair with totalMeetings drives a determinate progress bar during the slow Google Meet correlation. */
  scannedMeetings: Maybe<Scalars['Int']>;
  source: EndpointSource;
  /** Total meetings this source's current pass will scan. Null for the same reason as scannedMeetings — the Reports API gives no total during history collection. */
  totalMeetings: Maybe<Scalars['Int']>;
};

/** How far along endpoint discovery is for this tenant. Discovery is asynchronous and the slow part is not slow for technical reasons: correlating Meet hardware to a room needs meetings to have actually happened in it. So a screen that waits for "done" waits forever. This exists so onboarding can say what it is still waiting on and let the operator leave. */
export type EndpointDiscoveryStatus = {
  __typename: 'EndpointDiscoveryStatus';
  /** True while a Google Meet discovery run is in flight — the crawl a connected Google account's screen waits on. False when the tenant has not started one, or the most recent run is over: a completed run is done, and a failed run is not still importing (the scope/privilege failures surface via `permissionError`). Placement, which discovery never finishes, does not hold this open. */
  importing: Scalars['Boolean'];
  /** One entry per source connected for this tenant, not one per EndpointSource value. */
  sources: Array<EndpointDiscoverySourceStatus>;
  /** Durable, event-derived detail for the tenant's latest Google Meet discovery run, or null when the tenant has never run discovery. Live progress for a screen polling the crawl — the building-scoped, durable report is the same facts keyed by run, for a building. */
  timeline: Maybe<EndpointDiscoveryTimeline>;
};

export type EndpointDiscoveryStatusResponse = {
  __typename: 'EndpointDiscoveryStatusResponse';
  status: EndpointDiscoveryStatus;
};

/** Durable, event-derived progress for the tenant's latest Google Meet discovery run: what phase it is in, what the run has counted so far, and the activity feed behind those numbers. A screen polls this while the crawl runs. The counts answer "how is the run doing" and the building report answers "what did it find": the same event stream, this view live and tenant-scoped, the report durable and building-scoped. */
export type EndpointDiscoveryTimeline = {
  __typename: 'EndpointDiscoveryTimeline';
  /** The activity feed behind the counters, oldest first. */
  activities: Array<EndpointDiscoveryTimelineActivity>;
  /** Call-ended events examined so far. Null until the baseline completes — the Reports API exposes no total while history collection is still reading, so the honest answer is indeterminate, not a count. */
  baselineCallCount: Maybe<Scalars['Int']>;
  /** Distinct calendar meetings read so far while matching calls to rooms, and the total to read. Together they drive the determinate "N of M" during the correlation pause. Null before history collection completes. */
  calendarEventsResolved: Maybe<Scalars['Int']>;
  calendarEventsTotal: Maybe<Scalars['Int']>;
  /** Correlation attempts made so far. */
  correlationAttemptCount: Scalars['Int'];
  /** Devices the run can try to correlate. Null until the run reaches planning. */
  correlationCandidateCount: Maybe<Scalars['Int']>;
  /** Correlation attempts that produced a link. */
  correlationSuccessCount: Scalars['Int'];
  /** An honest guess at seconds remaining, or null when there is no honest basis for one — the Reports API gives no total during history collection, so early phases cannot project a finish. Null means "don't render a countdown", not "unknown but probably soon". */
  estimatedSecondsRemaining: Maybe<Scalars['Int']>;
  lastUpdatedAt: Scalars['DateTime'];
  /** The human-readable name of the most recently resolved room, or null when none has resolved yet. Lets a screen show what is being scanned right now alongside the N-of-M count. */
  latestRoomName: Maybe<Scalars['String']>;
  phase: DiscoveryPhase;
  /** Distinct Google Calendar/Meet room resources found while reading call history. Null until the run reaches planning. */
  roomResourceCount: Maybe<Scalars['Int']>;
  /** The run this timeline describes, a UUID. Stable across polls, so a screen can tell a new run from the one it was showing. */
  runId: Scalars['ID'];
  startedAt: Scalars['DateTime'];
};

/** One entry in a discovery run's activity feed — the narrative behind the timeline's counters, in the order it happened. */
export type EndpointDiscoveryTimelineActivity = {
  __typename: 'EndpointDiscoveryTimelineActivity';
  at: Scalars['DateTime'];
  id: Scalars['ID'];
  kind: Scalars['String'];
  message: Scalars['String'];
};

/** The governed facets: the signals the frontend builds specific behaviour on — a thermometer for TEMPERATURE, a comfort band for CO2 — so each has a fixed domain, value type, normalized unit and meaning. A facet outside this set still flows through EndpointObservation.facet with knownFacet null and renders generically. A superset of PeripheralKind: the OPERATIONAL members are spelled the same way, so a status row, an incident and an observation name one organ the same way. */
export enum EndpointFacet {
  CALL = 'CALL',
  CAMERA = 'CAMERA',
  CO2 = 'CO2',
  DISPLAY = 'DISPLAY',
  HUMIDITY = 'HUMIDITY',
  IN_CALL = 'IN_CALL',
  MICROPHONE = 'MICROPHONE',
  NETWORK = 'NETWORK',
  NOISE = 'NOISE',
  PEOPLE_COUNT = 'PEOPLE_COUNT',
  PM25 = 'PM25',
  PRESENCE = 'PRESENCE',
  REACHABILITY = 'REACHABILITY',
  SCREEN_SHARE = 'SCREEN_SHARE',
  SPEAKER = 'SPEAKER',
  TEMPERATURE = 'TEMPERATURE',
  TOUCH_CONTROLLER = 'TOUCH_CONTROLLER',
  TVOC = 'TVOC',
  UTILIZATION = 'UTILIZATION'
}

/** A facet's normalized state, one vocabulary across every source. LogiSync's status and healthStatus fold into it — reachable but reporting a hardware error is DEGRADED, unreachable is OFFLINE — and the raw pair stays in detail. UNKNOWN is the state before any signal. When a source goes quiet, its observation keeps the last explicit health and is marked fresh: false. Silence is never OFFLINE: only an explicit signal sets a facet offline, and a client that wants to treat silence as trouble has fresh and staleAfter to do it with. */
export enum EndpointHealth {
  DEGRADED = 'DEGRADED',
  OFFLINE = 'OFFLINE',
  ONLINE = 'ONLINE',
  UNKNOWN = 'UNKNOWN'
}

/** A hard identifier that fuses sightings into one box. A shared serial or MAC is a high-confidence fuse; a vendor device id only ever names one source's record and is listed so a screen can show it. */
export type EndpointIdentifier = {
  __typename: 'EndpointIdentifier';
  kind: EndpointIdentifierKind;
  value: Scalars['String'];
};

export enum EndpointIdentifierKind {
  MAC = 'MAC',
  SERIAL = 'SERIAL',
  VENDOR_DEVICE_ID = 'VENDOR_DEVICE_ID'
}

/** One signal, in the one envelope every signal travels in. Freshness is per source and per facet, because a LogiSync poll is two minutes old at most while a call signal can be hours old and still mean something. Stale readings are returned and marked, not dropped: the client decides what an age means. */
export type EndpointObservation = {
  __typename: 'EndpointObservation';
  /** When the current value or health was first observed — how long this state has held. Null when the service cannot say. This is what a derived alert is built on: an OPERATIONAL observation that is DEGRADED or OFFLINE, held since changedAt. */
  changedAt: Maybe<Scalars['DateTime']>;
  /** 0..1 where the source or the derivation reports one, else null. */
  confidence: Maybe<Scalars['Float']>;
  /** The raw vendor payload behind this reading, for drill-in. Shape varies by source and facet. */
  detail: Maybe<Scalars['JSON']>;
  domain: EndpointObservationDomain;
  /** The stable identifier, always present. Governed facets carry the bare lower-case name of their EndpointFacet member ("camera", "people_count"); everything else carries a namespace prefix ("logi:room_grade"), so an extension can never squat a governed name. */
  facet: Scalars['String'];
  /** observedAt plus this source's TTL for this facet is still in the future. */
  fresh: Scalars['Boolean'];
  /** The normalized rating. Set for OPERATIONAL facets, null for the rest: a measurement carries a number and a unit, not a verdict. */
  health: Maybe<EndpointHealth>;
  /** Set when facet is in the governed registry, else null. The client switches on this for specific behaviour and falls back to facet when it is null. */
  knownFacet: Maybe<EndpointFacet>;
  /** When the SOURCE knew it, not when this service recorded it. */
  observedAt: Scalars['DateTime'];
  source: EndpointSource;
  /** observedAt plus the TTL. For a polled source the TTL is two poll intervals, so one late poll does not mark the reading stale. */
  staleAfter: Scalars['DateTime'];
  /** What this is about — the source record that reported it, or the place it describes. Never a FusedEndpoint: a fused box aggregates its members' observations rather than having its own. */
  subject: EndpointOrPlace;
  /** Normalized for governed facets — temperature is always celsius — and whatever the source said otherwise. Null when the value has no unit. */
  unit: Maybe<Scalars['String']>;
  /** The reading. valueType says how to read it; for OPERATIONAL facets it is the EndpointHealth name and mirrors health. */
  value: Scalars['JSON'];
  valueType: EndpointObservationValueType;
};

/** What a signal is ABOUT. Four parallel answers and no generic "state" bucket, because everything here is state. Small and closed: a new domain is a real design decision, where a new facet is not. */
export enum EndpointObservationDomain {
  /** What is happening right now? Facets like in_call, screen_share. Subject is an Endpoint or a place. */
  ACTIVITY = 'ACTIVITY',
  /** What are the room's physical conditions? Facets like temperature, co2, noise. Subject is a place or the sensor that measured it. */
  ENVIRONMENT = 'ENVIRONMENT',
  /** Is the room being used? Facets like people_count, presence. Subject is a place or the sensor that measured it. */
  OCCUPANCY = 'OCCUPANCY',
  /** Is the equipment working? Facets like reachability, camera, microphone. Subject is an Endpoint. The only domain where health is set. */
  OPERATIONAL = 'OPERATIONAL'
}

/** Names what observations are about. Supply exactly one. */
export type EndpointObservationSubjectInput = {
  /** One source record. */
  endpointId?: InputMaybe<Scalars['ID']>;
  /** A fused box: observations across all of its members. */
  fusedEndpointId?: InputMaybe<Scalars['ID']>;
  /** A place: observations whose subject is the place itself — its environment and occupancy — not the boxes inside it. */
  place?: InputMaybe<RobinPlaceRefInput>;
};

/** How to read EndpointObservation.value, so a facet the client has never seen still renders as a label, a value and a unit. */
export enum EndpointObservationValueType {
  BOOLEAN = 'BOOLEAN',
  /** A string from a closed vocabulary. For OPERATIONAL facets the vocabulary is EndpointHealth and value mirrors health. */
  ENUM = 'ENUM',
  NUMBER = 'NUMBER',
  STRING = 'STRING'
}

export type EndpointObservationsInput = {
  /** Only these domains. Omitted or empty filters nothing. */
  domain?: InputMaybe<Array<EndpointObservationDomain>>;
  /** Only these facets. Omitted or empty filters nothing. */
  facet?: InputMaybe<Array<Scalars['String']>>;
  onlyFresh?: InputMaybe<Scalars['Boolean']>;
  /** Omit for current state only — one observation per subject, source and facet. Give a time to get the history behind each signal since then, newest first, which is how trends and call history render. */
  since?: InputMaybe<Scalars['DateTime']>;
  subject: EndpointObservationSubjectInput;
};

export type EndpointObservationsResponse = {
  __typename: 'EndpointObservationsResponse';
  observations: Array<EndpointObservation>;
};

/** A relationship's far end — the union says exactly what it is: an endpoint, or a place in Robin. The kind determines which: IS_SAME_AS and ATTACHED_TO end at an endpoint, WITHIN at a place. A union names concrete types, so this is the one seam the Endpoint interface does not absorb: a new implementer of Endpoint is a member added here, and a fragment spelled on one implementer has to add its siblings to keep seeing every far end. */
export type EndpointOrPlace = Campus | ChromeOsDevice | GoogleMeetDevice | Level | Location | LogiSyncDevice | NeatPulseDevice | Space;

/** Names one end of a relationship. Supply exactly one of endpoint or place. */
export type EndpointOrPlaceInput = {
  endpointId?: InputMaybe<Scalars['ID']>;
  place?: InputMaybe<RobinPlaceRefInput>;
};

/** Where an endpoint resolved to, with the runners-up that lost. Placement is largely inferred, so the honest answer is a ranking rather than a fact. An endpoint claimed by one room at 0.95 and one torn between two at 0.5 and 0.48 look identical once reduced to a winner, and they want opposite handling: accept the first, ask about the second. */
export type EndpointPlacement = {
  __typename: 'EndpointPlacement';
  /** Places this endpoint could be in instead, strongest first. Empty when nothing competed. One entry per place, represented by its strongest claim. */
  alternatives: Array<EndpointPlacementCandidate>;
  assertedBy: Maybe<AccountUser>;
  confidence: Scalars['Float'];
  /** Empty when this endpoint was placed by its own evidence. Otherwise the endpoints it inherited the placement from — a camera is in room 3 because the Chromebox it is attached to is, and this names that Chromebox so a screen can say so. */
  inheritedFrom: Array<Endpoint>;
  observedAt: Scalars['DateTime'];
  place: RobinPlace;
  reason: EndpointRelationshipReason;
};

export type EndpointPlacementCandidate = {
  __typename: 'EndpointPlacementCandidate';
  confidence: Scalars['Float'];
  place: RobinPlace;
  reason: EndpointRelationshipReason;
};

/** One relationship the graph can answer for. endpoint is always an endpoint, because a relationship between two places would not be a fact about hardware. relatedTo is another endpoint or a place. Named for the two ends rather than a direction, because only two of the three kinds have one. ATTACHED_TO and WITHIN read endpoint→relatedTo — a camera attached to a Chromebox, a Chromebox within room 8214. IS_SAME_AS has no direction at all, and the pair is stored in a fixed order, so asserting A/B and B/A is one relationship rather than two. */
export type EndpointRelationship = {
  __typename: 'EndpointRelationship';
  /** The operator who decided this, or null when the service inferred it. Null is the common case. */
  assertedBy: Maybe<AccountUser>;
  /** Strength in 0..1, comparable across reasons of the same kind. */
  confidence: Scalars['Float'];
  endpoint: Endpoint;
  /** Stable while the relationship holds. Pass it to removeEndpointRelationships rather than restating both ends. A relationship the service worked out on the spot has no row to name, so its id is derived from the two ends, the kind and the reason — deterministic, so it is the same id on the next read and removing it still means something. */
  id: Scalars['ID'];
  kind: EndpointRelationshipKind;
  /** When the SOURCE observed this, not when we recorded it. Nothing weighs this today beyond breaking ties between equally strong claims, and relationships do not expire. It is here so that if we ever do decay old evidence, the input already exists and already means the right thing. */
  observedAt: Scalars['DateTime'];
  reason: EndpointRelationshipReason;
  relatedTo: EndpointOrPlace;
};

/** What a relationship MEANS, which decides both how competing claims are settled and what the far end of it can be. IS_SAME_AS is identity, endpoint to endpoint, and is transitive: A is B and B is C makes one piece of hardware. ATTACHED_TO is endpoint to endpoint and WITHIN is endpoint to Robin place; neither is transitive, because a thing is in exactly one place, so rival claims are ranked rather than merged. The two compose — a camera ATTACHED_TO a Chromebox that is WITHIN room 3 is itself in room 3 — which is how an endpoint with no room of its own gets one. Composing is not merging, and the two stay separate endpoints. There is deliberately no negative kind. Vetoing a bad merge only matters once matching is fuzzy, and this matches on exact serials and exact MACs. */
export enum EndpointRelationshipKind {
  ATTACHED_TO = 'ATTACHED_TO',
  IS_SAME_AS = 'IS_SAME_AS',
  WITHIN = 'WITHIN'
}

/** Why the graph believes a relationship. Naming the rule rather than a bare score is what lets a screen explain itself: "we matched the serial" and "we saw it in this room on 9 of 10 calls" want different words and different offers to the operator, and both are 0.9. A rule's strength is a property of the rule, not of whoever noticed it, so a SHARED_SERIAL weighs the same whether Google or a relay reported it. The manual reasons outrank every derived one for the same pair and kind, whatever the confidences say. That ordering is what makes an operator's decision hold: the crawl that derived a relationship runs again and derives it again, and resolution reads the human's ruling first. Two manual rulings on one pair and kind settle the way derived rivals do — by observedAt recency — so an operator's newest decision replaces their older one. */
export enum EndpointRelationshipReason {
  /** Share of this endpoint's meetings whose calendar event resolved to this place, with recent meetings weighing more. Google exposes no device-to-room assignment through any API, so this is how Meet hardware finds its room. A place qualifies after one meeting booked only in that room, or two meetings of any kind, and it must score higher than every other place. */
  CALL_CORRELATION = 'CALL_CORRELATION',
  /** An operator placed this endpoint. */
  MANUAL_ASSIGNMENT = 'MANUAL_ASSIGNMENT',
  /** An operator asserted the relationship — the same piece of hardware for IS_SAME_AS, attached for ATTACHED_TO. The positive counterpart of MANUAL_UNLINK. */
  MANUAL_LINK = 'MANUAL_LINK',
  /** An operator said these are NOT the same piece of hardware, or that this endpoint is not attached to that one, or not in that place — whichever kind the relationship carries. Ordinary evidence pointing the other way, which is why it is a reason rather than a relationship kind of its own: one value covers a false merge, a camera hung off the wrong host and an endpoint put in the wrong room, and it reads back through the same field a screen already renders. Confidence keeps meaning how sure the claim is, so an operator certain that two records are different hardware asserts this at 1.0, exactly as MANUAL_LINK is asserted at 1.0 the other way. */
  MANUAL_UNLINK = 'MANUAL_UNLINK',
  /** A vendor place was matched to a Space by cross-referencing its devices' serials against hardware already placed in a Space — a Meet/Chrome OS mapping keyed on the same serial. Deterministic where a serial is shared, so it outranks a name match; confidence is the share of the place's placed serials that agreed on the winning Space. */
  SERIAL_CORRELATION = 'SERIAL_CORRELATION',
  /** Same burned-in MAC. Just below serial, because bonded NICs, cloned VMs and a shared dock all put one MAC on several endpoints. */
  SHARED_MAC = 'SHARED_MAC',
  /** Two endpoints carry the same name. Reads with SHARED_SERIAL and SHARED_MAC: the same fact about two source records, on a weaker key. Names collide and get copy-pasted, so this corroborates and never concludes on its own. */
  SHARED_NAME = 'SHARED_NAME',
  /** Same manufacturer serial. The strongest identifier we get: a serial names the hardware where a MAC names one of its interfaces. */
  SHARED_SERIAL = 'SHARED_SERIAL',
  /** An endpoint's name matches a SPACE's name — 'Ada Lovelace Display' against Ada Lovelace. Named for the Space rather than for the field it reads, because that is what makes it a different reason from SHARED_NAME rather than a variant of it. One is two endpoints being the same hardware; this one is an endpoint being in a room. Running this through identity instead would fuse every endpoint in a room into one THROUGH the room. How much of the name matched is confidence, not a separate reason. An exact hit and a prefix hit are the same rule at different strengths, and splitting them would make every scoring change a schema change. */
  SPACE_NAME_MATCH = 'SPACE_NAME_MATCH',
  /** Two facts composed: the vendor reports this endpoint in one of ITS rooms, and an operator mapped that room to a Robin Space. LogiSync is the one source that produces this today. Someone installed a Rally Bar and registered it to a Logitech room; an admin mapped that room to a Space once. Every endpoint the vendor reports in that room is placed from then on, including hardware added later that nobody touches — which is the whole value of mapping the room rather than the endpoint. Not the same as MANUAL_ASSIGNMENT, which is an operator pointing at one specific endpoint. Here the human named a room and the machine keeps saying what is in it, so a re-crawl refreshes half of this on its own. Strong, because someone physically installed the thing and registered it. Short of certain, because a vendor room is not guaranteed to be a Robin Space — it can be a whole floor, and gear gets moved without the console ever hearing about it. */
  VENDOR_ROOM_ASSIGNMENT = 'VENDOR_ROOM_ASSIGNMENT'
}

export type EndpointRelationshipsInput = {
  /** Omit for every kind. */
  kinds?: InputMaybe<Array<EndpointRelationshipKind>>;
  /** One end. Returns every relationship touching it, whichever side it sits on — the symmetric kinds have no meaningful direction, so matching only from would silently hide half the answer. */
  node?: InputMaybe<EndpointOrPlaceInput>;
  /** The other end. Given both, returns only the relationships between exactly these two. */
  relatedTo?: InputMaybe<EndpointOrPlaceInput>;
};

export type EndpointRelationshipsResponse = {
  __typename: 'EndpointRelationshipsResponse';
  relationships: Array<EndpointRelationship>;
};

/** The system that reported an endpoint. Closed, because with remoteId it is half the natural key — free text there means "Google" and "google" are two endpoints. Distinct from vendor, which is who MADE the thing: vendor is whatever the source reported, verbatim — LogiSync writes its device type ('Logitech', as the source spells it), Neat writes 'Neat', and Chrome OS reports no manufacturer — so vendor has no CHECK constraint and, unlike source, deliberately no closed vocabulary. Two sources' records of one box are joined by IS_SAME_AS, not by matching vendor strings. */
export enum EndpointSource {
  /** Google's ChromeOS device inventory. Separate from GOOGLE_MEET: it sees Chromeboxes the Meet API does not, and reports different fields for the ones it shares. */
  GOOGLE_CHROME_OS = 'GOOGLE_CHROME_OS',
  /** Google's Meet hardware admin API. */
  GOOGLE_MEET = 'GOOGLE_MEET',
  LOGI_SYNC = 'LOGI_SYNC',
  NEAT_PULSE = 'NEAT_PULSE'
}

export type EndpointsInput = {
  macs?: InputMaybe<Array<Scalars['String']>>;
  remoteIds?: InputMaybe<Array<Scalars['String']>>;
  /** The lookup. Every filter here is a list, because the callers that hold these values hold them in batches — an audit log sync with 200 serials should be one query, not 200. Given more than one, an endpoint matching ANY value in ANY of them is returned. A caller resolving an audit log does not know in advance whether it will find its endpoint by serial or by MAC, and making it ask twice would only mean two round trips for one question. */
  serials?: InputMaybe<Array<Scalars['String']>>;
  /** Only endpoints from this source. */
  source?: InputMaybe<EndpointSource>;
  /** Only endpoints with no placement — the review queue for onboarding. */
  unplacedOnly?: InputMaybe<Scalars['Boolean']>;
};

export type EndpointsResponse = {
  __typename: 'EndpointsResponse';
  endpoints: Array<Endpoint>;
};

export type Entity = {
  __typename: 'Entity';
  data: Maybe<EntityData>;
  id: Scalars['ID'];
  previousState: Maybe<EntityState>;
  state: EntityState;
  type: EntityType;
};

export type EntityData = DeskEntityData;

export type EntityState = DeskEntityState;

export enum EntityType {
  DESK = 'DESK',
  NEIGHBORHOOD = 'NEIGHBORHOOD'
}

/** A filter the frontend can offer for a global search. Every option carries an `entityType` and a human-readable `displayName`. Concrete variants add the extra key a caller needs to pass back into `GlobalSearchFilter.entityTypeFilters`: built-in types (USER/DESK/SPACE) need nothing more; custom-resource categories carry a `categoryTypeId`. */
export type EntityTypeFilterOption = {
  displayName: Scalars['String'];
  entityType: GlobalSearchEntityType;
};

/** A single entity-type filter selection. For built-in types only `entityType` is set. `categoryTypeId` is set only for `entityType = CUSTOM_RESOURCE`, where it identifies the resource category (template) to filter to; the collection is implied by the entity type. It is ignored for built-in types. */
export type EntityTypeFilterSelection = {
  categoryTypeId?: InputMaybe<Scalars['ID']>;
  entityType: GlobalSearchEntityType;
};

/** Actionable resolution guidance for the error */
export type ErrorResolution = {
  __typename: 'ErrorResolution';
  action: Scalars['String'];
  description: Scalars['String'];
};

/** A string paired with the ETag identifying it, for conditional writes. Selecting `etag` alongside `value` is what lets a client come back and change the value later; a client that never intends to can select `value` alone. Its `etag` is a strong entity-tag, never `W/`-prefixed: `If-Match` is defined in terms of strong comparison, so a weak validator would be the wrong instrument for the writes this type exists to condition. There is no null value. A field that must distinguish absent from empty should not use this type. */
export type EtaggedString = {
  __typename: 'EtaggedString';
  etag: Scalars['ETag'];
  value: Scalars['String'];
};

/** A new string, and the ETag of the one it replaces. The write is refused with PRECONDITION_FAILED if that ETag no longer identifies what the field holds, so a client working from a stale view cannot overwrite something it never saw. There is deliberately no unconditional overwrite: a client that wants to overwrite has already re-read the value in order to show its user the conflict, so it holds the ETag it needs to say so. */
export type EtaggedStringInput = {
  /** The `etag` of the value you read */
  ifMatch: Scalars['ETag'];
  /** The replacement. This type has no null, so the empty string is how a field that has an empty value expresses one; whether a given field accepts it is that field's business. */
  value: Scalars['String'];
};

/** An ordered list of strings paired with the ETag identifying it, for conditional writes. The list counterpart of `EtaggedString`. There is no null value, and no null member. An empty list is the empty value. */
export type EtaggedStringList = {
  __typename: 'EtaggedStringList';
  etag: Scalars['ETag'];
  values: Array<Scalars['String']>;
};

/** A new list of strings, and the ETag of the one it replaces. The list counterpart of `EtaggedStringInput`, refused with PRECONDITION_FAILED on the same terms: the write is conditional, and there is deliberately no unconditional overwrite. */
export type EtaggedStringListInput = {
  /** The `etag` of the list you read */
  ifMatch: Scalars['ETag'];
  /** The replacement list. The empty list is the empty value - this type has no null. */
  values: Array<Scalars['String']>;
};

export type Evaluations = {
  workingHours?: InputMaybe<Scalars['Boolean']>;
};

export type Event = {
  __typename: 'Event';
  creationType: EventCreationType;
  creatorEmail: Maybe<Scalars['String']>;
  creatorId: Maybe<Scalars['ID']>;
  description: Maybe<Scalars['String']>;
  endTime: Maybe<Scalars['String']>;
  eventWithCheckInStatus: Maybe<EventWithCheckInStatus>;
  hasMeetingServiceRequests: Maybe<Scalars['Boolean']>;
  /** Event Id */
  id: Scalars['ID'];
  invitees: Array<EventInvitee>;
  isAllDay: Scalars['Boolean'];
  isCandidateForSpaceSuggestions: Scalars['Boolean'];
  organizerEmail: Maybe<Scalars['String']>;
  organizerId: Maybe<Scalars['ID']>;
  recurrence: Maybe<Scalars['String']>;
  seriesId: Maybe<Scalars['String']>;
  spaces: Array<Space>;
  startTime: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  uid: Maybe<Scalars['String']>;
  visibility: Maybe<Scalars['String']>;
  whosInData: WhosInData;
};


export type EventWhosInDataArgs = {
  locationIds: Array<Scalars['ID']>;
};

export type EventAuditLog = {
  __typename: 'EventAuditLog';
  actor: EventAuditLogActor;
  /** @deprecated Use actor instead */
  actorId: Maybe<Scalars['ID']>;
  /** @deprecated Use actor instead */
  actorType: EventAuditLogActorType;
  changes: Array<EventAuditLogChange>;
  etag: Maybe<Scalars['String']>;
  eventId: Scalars['ID'];
  id: Scalars['ID'];
  /** Tracks any changes to the invitee list */
  inviteeChanges: EventAuditLogInviteeChange;
  metadata: Maybe<Scalars['String']>;
  operation: EventAuditLogOperation;
  spaceId: Scalars['ID'];
  timestamp: Scalars['ISODateTime'];
};

/** Interface for any actor that can perform operations on events */
export type EventAuditLogActor = {
  id: Maybe<Scalars['ID']>;
};

/** Enum for actor types that can perform operations on events */
export enum EventAuditLogActorType {
  APP = 'APP',
  DEVICE = 'DEVICE',
  ORGANIZATION = 'ORGANIZATION',
  UNKNOWN = 'UNKNOWN',
  USER = 'USER'
}

export type EventAuditLogChange = {
  __typename: 'EventAuditLogChange';
  fieldChanged: EventAuditLogFieldType;
  id: Scalars['ID'];
  newValue: Maybe<Scalars['String']>;
  oldValue: Maybe<Scalars['String']>;
};

/** Enum for event field types that can be changed */
export enum EventAuditLogFieldType {
  CREATED_AT = 'CREATED_AT',
  CREATION_TYPE = 'CREATION_TYPE',
  CREATOR_EMAIL = 'CREATOR_EMAIL',
  CREATOR_ID = 'CREATOR_ID',
  DESCRIPTION = 'DESCRIPTION',
  ENDED_AT = 'ENDED_AT',
  ENDED_AT_TIMEZONE = 'ENDED_AT_TIMEZONE',
  IS_ALL_DAY = 'IS_ALL_DAY',
  LOCATION = 'LOCATION',
  ORGANIZER_EMAIL = 'ORGANIZER_EMAIL',
  ORGANIZER_ID = 'ORGANIZER_ID',
  RECURRENCE = 'RECURRENCE',
  RECURRENCE_ID = 'RECURRENCE_ID',
  REMOTE_CALENDAR_MAILBOX_ADDRESS = 'REMOTE_CALENDAR_MAILBOX_ADDRESS',
  REMOTE_EVENT_ID = 'REMOTE_EVENT_ID',
  REMOTE_SERIES_ID = 'REMOTE_SERIES_ID',
  REMOTE_TYPE = 'REMOTE_TYPE',
  SEQUENCE = 'SEQUENCE',
  SERIES_ID = 'SERIES_ID',
  SHOW_AS = 'SHOW_AS',
  SPACE_ID = 'SPACE_ID',
  STARTED_AT = 'STARTED_AT',
  STARTED_AT_TIMEZONE = 'STARTED_AT_TIMEZONE',
  STATUS = 'STATUS',
  TITLE = 'TITLE',
  UID = 'UID',
  VISIBILITY = 'VISIBILITY'
}

export type EventAuditLogFilterInput = {
  placeHierarchy?: InputMaybe<EventAuditLogPlaceHierarchyFilterInput>;
};

export type EventAuditLogInvitee = {
  __typename: 'EventAuditLogInvitee';
  email: Scalars['String'];
};

export type EventAuditLogInviteeChange = {
  __typename: 'EventAuditLogInviteeChange';
  addedInvitees: Array<EventAuditLogInvitee>;
  inviteeChanges: Array<EventAuditLogInviteeFieldChange>;
  removedInvitees: Array<EventAuditLogInvitee>;
};

export type EventAuditLogInviteeFieldChange = {
  __typename: 'EventAuditLogInviteeFieldChange';
  fieldChanged: EventAuditLogInviteeFieldType;
  invitee: EventAuditLogInvitee;
  newValue: Scalars['String'];
  oldValue: Scalars['String'];
};

export enum EventAuditLogInviteeFieldType {
  RESPONSE_STATUS = 'RESPONSE_STATUS'
}

/** Enum for operations that can be performed on events */
export enum EventAuditLogOperation {
  ADD_SPACE = 'ADD_SPACE',
  APPROVE_SPACE_RESERVATION_REQUEST = 'APPROVE_SPACE_RESERVATION_REQUEST',
  CANCEL = 'CANCEL',
  CONFIRM = 'CONFIRM',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  DENY_SPACE_RESERVATION_REQUEST = 'DENY_SPACE_RESERVATION_REQUEST',
  REMOVE_SPACE = 'REMOVE_SPACE',
  SYNC_CANCEL = 'SYNC_CANCEL',
  SYNC_CREATE = 'SYNC_CREATE',
  SYNC_DELETE = 'SYNC_DELETE',
  SYNC_UPDATE = 'SYNC_UPDATE',
  UNCONFIRM = 'UNCONFIRM',
  UPDATE = 'UPDATE'
}

export type EventAuditLogPaginationInput = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
};

export type EventAuditLogPaginationOutput = {
  __typename: 'EventAuditLogPaginationOutput';
  endCursor: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
};

/** Filter options for event audit logs */
export type EventAuditLogPlaceHierarchyFilterInput = {
  buildingId?: InputMaybe<Scalars['Int']>;
  floorId?: InputMaybe<Scalars['Int']>;
  spaceId?: InputMaybe<Scalars['Int']>;
};

export type EventAuditLogTimeRangeInput = {
  endTime: Scalars['ISODateTime'];
  startTime: Scalars['ISODateTime'];
};

export type EventConfirmation = {
  __typename: 'EventConfirmation';
  confirmedAt: Maybe<Scalars['String']>;
  deviceId: Maybe<Scalars['Int']>;
  eventId: Scalars['ID'];
  userId: Maybe<Scalars['ID']>;
};

export enum EventCreationType {
  AUTOMATIC = 'AUTOMATIC',
  MANUAL = 'MANUAL',
  PROXIED = 'PROXIED',
  SYNCED = 'SYNCED',
  UNKNOWN = 'UNKNOWN'
}

/** When dealing with events that may not exist yet, the robinEventId is unknown. In this case, we only know the ical UID that we will set on the event when we create it. Note that referencing recurring events is not allowed, must reference a specific instance. */
export type EventInstanceReference = {
  ical?: InputMaybe<IcalInstanceReference>;
  robinEventId?: InputMaybe<Scalars['ID']>;
};

export type EventInvitee = {
  __typename: 'EventInvitee';
  displayName: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  eventId: Scalars['ID'];
  id: Maybe<Scalars['ID']>;
  isOrganizer: Scalars['Boolean'];
  isResource: Scalars['Boolean'];
  /** Gets an onsite for an invitee in a specific location at event's date. */
  onsiteInLocation: Maybe<EventInviteeOnsiteStatus>;
  /** Gets an onsite for an invitee in a specific location for a date */
  onsiteInLocationForDate: Maybe<EventInviteeOnsiteStatus>;
  participationRole: EventParticipationRole;
  responseStatus: EventResponseStatus;
  spaceId: Maybe<Scalars['ID']>;
  user: Maybe<User>;
};


export type EventInviteeOnsiteInLocationArgs = {
  locationId: Scalars['ID'];
};


export type EventInviteeOnsiteInLocationForDateArgs = {
  date: Scalars['LocalDate'];
  locationId: Scalars['ID'];
};

export type EventInviteeOnsiteStatus = {
  __typename: 'EventInviteeOnsiteStatus';
  /** The desk reservations for this onsite entry */
  deskReservations: Array<Reservation>;
  /** The ID of the day's response. */
  id: Scalars['ID'];
  /** The method used to set the current onsite status. */
  onsiteConfirmationMethod: OnsiteConfirmationMethod;
  /** The type of onsite entry */
  onsiteType: OnsiteType;
  /** Onsite type set at timestamp. */
  onsiteTypeSetAt: Maybe<Scalars['ISODateTime']>;
};

export enum EventParticipationRole {
  CHAIR = 'CHAIR',
  NON_PARTICIPANT = 'NON_PARTICIPANT',
  OPTIONAL = 'OPTIONAL',
  REQUIRED = 'REQUIRED',
  UNKNOWN = 'UNKNOWN'
}

export enum EventResponseStatus {
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  DELEGATED = 'DELEGATED',
  NOT_RESPONDED = 'NOT_RESPONDED',
  TENTATIVE = 'TENTATIVE',
  UNKNOWN = 'UNKNOWN'
}

export type EventTrackingOnlyResponse = {
  __typename: 'EventTrackingOnlyResponse';
  /** eventType is null when no state is updated but result is still successful */
  eventType: Maybe<Scalars['ID']>;
  /** value is -1 when no state is updated but result is still successful */
  value: Scalars['Int'];
};

export enum EventUpdateFailReasons {
  LACKING_EVENT_UPDATE_PERMISSIONS = 'LACKING_EVENT_UPDATE_PERMISSIONS',
  SPACE_DECLINED = 'SPACE_DECLINED',
  SPACE_UNAVAILABLE = 'SPACE_UNAVAILABLE',
  UNKNOWN = 'UNKNOWN'
}

export type EventUpdatePermission = {
  __typename: 'EventUpdatePermission';
  eventId: Scalars['String'];
  id: Scalars['String'];
  isPermitted: Scalars['Boolean'];
};

/** An event as robin-api's v2 read returns it, which is what the event composer reads: the event, the actor's permissions on it, people and rooms as separate lists, and the room copies' check-in, buffers and approval. When the actor is not a participant and may not read others' private events, robin-api masks the event rather than hiding it: title "Reserved", empty description, no organizer or creator emails, and empty people, room and integration lists. Such an event still has a schedule and permissions. */
export type EventV2 = {
  __typename: 'EventV2';
  confirmation: Maybe<EventV2Confirmation>;
  createdAt: Maybe<Scalars['String']>;
  creationType: EventCreationType;
  creatorEmail: Maybe<Scalars['String']>;
  creatorId: Maybe<Scalars['ID']>;
  description: Maybe<Scalars['String']>;
  end: EventV2Time;
  id: Scalars['ID'];
  integrations: Array<EventV2Integration>;
  invitees: Array<EventV2Invitee>;
  isAllDay: Scalars['Boolean'];
  /** The calendar's free-text location line, as the organizer typed it. Not a Robin location: the room the event is booked in is `spaceId`. */
  location: Maybe<Scalars['String']>;
  organizerEmail: Maybe<Scalars['String']>;
  organizerId: Maybe<Scalars['ID']>;
  permissions: EventV2Permissions;
  /** RRULE strings; null when the event does not recur. */
  recurrence: Maybe<Array<Scalars['RecurrenceRule']>>;
  /** Set on an occurrence of a recurring event; the scope suffixes on update and cancel need one. */
  recurrenceId: Maybe<Scalars['String']>;
  remoteCalendarMailboxAddress: Maybe<Scalars['String']>;
  remoteEventId: Maybe<Scalars['String']>;
  remoteSeriesId: Maybe<Scalars['String']>;
  /** Calendar provider, lower-cased: google, microsoft_365, ... */
  remoteType: Scalars['String'];
  reservationApproval: Maybe<EventV2ReservationApproval>;
  robinCreatorId: Maybe<Scalars['ID']>;
  /** Null for a one-off event, and withheld for some Microsoft events. */
  seriesId: Maybe<Scalars['String']>;
  /** free, busy or focus. */
  showAs: Maybe<Scalars['String']>;
  /** The room the event is booked in, when a room's calendar holds it. */
  spaceId: Maybe<Scalars['ID']>;
  spaceInvitees: Array<EventV2SpaceInvitee>;
  start: EventV2Time;
  /** confirmed, tentative or cancelled. */
  status: Scalars['String'];
  title: Maybe<Scalars['String']>;
  uid: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['String']>;
  visibility: Maybe<Scalars['String']>;
};

/** A check-in on the event. */
export type EventV2Confirmation = {
  __typename: 'EventV2Confirmation';
  confirmationType: Maybe<Scalars['String']>;
  confirmedAt: Scalars['String'];
  deviceId: Maybe<Scalars['Int']>;
  eventId: Scalars['ID'];
  userId: Maybe<Scalars['ID']>;
};

/** Setup and teardown time a room holds around the meeting, as ISO 8601 durations. */
export type EventV2DesiredBuffers = {
  __typename: 'EventV2DesiredBuffers';
  afterDuration: Maybe<Scalars['ISO8601Duration']>;
  beforeDuration: Maybe<Scalars['ISO8601Duration']>;
};

/** A video-conference block attached to the event. */
export type EventV2Integration = {
  __typename: 'EventV2Integration';
  actions: Array<EventV2IntegrationAction>;
  id: Scalars['ID'];
  integrationId: Scalars['ID'];
  status: Scalars['String'];
};

export type EventV2IntegrationAction = {
  __typename: 'EventV2IntegrationAction';
  name: Scalars['String'];
  type: Scalars['String'];
  value: Scalars['String'];
};

/** A person on a v2 event. */
export type EventV2Invitee = {
  __typename: 'EventV2Invitee';
  displayName: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  isOrganizer: Scalars['Boolean'];
  participationRole: EventParticipationRole;
  responseStatus: EventResponseStatus;
  /** The Robin user, when the invitee is one. */
  user: Maybe<User>;
  userId: Maybe<Scalars['ID']>;
};

/** The room's own copy of the event on its calendar. Check-in, buffers and approval live on this copy, not on the organizer's event. */
export type EventV2InviteeEvent = {
  __typename: 'EventV2InviteeEvent';
  confirmation: Maybe<EventV2Confirmation>;
  desiredBuffers: Maybe<EventV2DesiredBuffers>;
  id: Scalars['ID'];
  reservationApproval: Maybe<EventV2ReservationApproval>;
};

/** What the actor may do to this event, decided by robin-api from who they are and which calendars they can write to. These are the flags the event composer uses to enable Edit and Delete. */
export type EventV2Permissions = {
  __typename: 'EventV2Permissions';
  /** Cancel the event for everyone. */
  cancel: Scalars['Boolean'];
  /** Cancel as the room: release the room, or cancel the event when the room organizes it. */
  removeSpace: Scalars['Boolean'];
  /** Edit the event as its organizer or a delegate. */
  update: Scalars['Boolean'];
  /** Edit the room's copy of the event, acting as the room's calendar. */
  updateAsSpace: Scalars['Boolean'];
};

/** The approval request a request-only room booking creates. */
export type EventV2ReservationApproval = {
  __typename: 'EventV2ReservationApproval';
  /** Null when robin-api withholds it from this actor. */
  approvalNotes: Maybe<Scalars['String']>;
  approved: Scalars['Boolean'];
  approvedAt: Maybe<EventV2Time>;
  /** Null when robin-api withholds it from this actor. */
  approvingUserId: Maybe<Scalars['ID']>;
  inviteeCount: Maybe<Scalars['Int']>;
  reservationId: Scalars['ID'];
  reservationType: Scalars['String'];
};

/** A room on a v2 event. */
export type EventV2SpaceInvitee = {
  __typename: 'EventV2SpaceInvitee';
  displayName: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  /** Null when the room's copy could not be resolved. */
  inviteeEvent: Maybe<EventV2InviteeEvent>;
  /** Whether this room's calendar organizes the event. Such a room is changed with moveEvent, never removed. */
  isOrganizer: Scalars['Boolean'];
  participationRole: EventParticipationRole;
  responseStatus: EventResponseStatus;
  /** The Robin space. Nullable like every other federated room in this schema: a room since deleted, or a place subgraph that cannot answer, must not take the whole event down with it. */
  space: Maybe<Space>;
  spaceId: Scalars['ID'];
};

/** A start or end on a v2 event. A timed event sets dateTime and timeZone. An all-day event sets date, and for now also the legacy dateTime and timeZone, which robin-api says it will stop sending; read date when isAllDay is true. An all-day end is exclusive: a one-day event ends on the next day's date. */
export type EventV2Time = {
  __typename: 'EventV2Time';
  /** YYYY-MM-DD. All-day events. */
  date: Maybe<Scalars['LocalDate']>;
  /** ISO 8601 date-time with offset. Timed events. */
  dateTime: Maybe<Scalars['String']>;
  /** IANA time zone the event was booked in. Timed events. */
  timeZone: Maybe<Scalars['String']>;
};

export type EventWithCheckInStatus = {
  __typename: 'EventWithCheckInStatus';
  checkInEndTime: Scalars['String'];
  checkInStartTime: Scalars['String'];
  checkInStatus: CheckInStatus;
  inviteeEvent: Maybe<InviteeEvent>;
  spaceId: Scalars['String'];
};

export type ExcludeAllDaysFromScheduleInput = {
  fri?: InputMaybe<Scalars['Boolean']>;
  mon?: InputMaybe<Scalars['Boolean']>;
  sat?: InputMaybe<Scalars['Boolean']>;
  sun?: InputMaybe<Scalars['Boolean']>;
  thu?: InputMaybe<Scalars['Boolean']>;
  tue?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['String'];
  wed?: InputMaybe<Scalars['Boolean']>;
};

export type Exclusion = {
  __typename: 'Exclusion';
  endTime: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** @deprecated temporally broken because API currently provides series master id instead of the instance id */
  reservation: Maybe<Reservation>;
  startTime: Scalars['String'];
};

/** Basic information about the external account */
export type ExternalAccountInfo = {
  __typename: 'ExternalAccountInfo';
  id: Scalars['ID'];
  type: ExternalAccountType;
};

/** External account integration status information */
export type ExternalAccountStatus = {
  __typename: 'ExternalAccountStatus';
  externalAccount: ExternalAccountInfo;
  status: IntegrationStatus;
};

/** External account integration types. */
export enum ExternalAccountType {
  GOOGLE = 'GOOGLE',
  MICROSOFT_GRAPH = 'MICROSOFT_GRAPH'
}

export type ExternalEvent = {
  __typename: 'ExternalEvent';
  description: Scalars['String'];
  endDate: Scalars['ISODateTime'];
  id: Scalars['ID'];
  imageUrl: Scalars['String'];
  name: Scalars['String'];
  sourceUrl: Scalars['String'];
  startDate: Scalars['ISODateTime'];
  ticketUrl: Maybe<Scalars['String']>;
  venue: ExternalEventVenue;
};

export type ExternalEventVenue = {
  __typename: 'ExternalEventVenue';
  address: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  region: Scalars['String'];
};

export type ExternalIntegration = {
  __typename: 'ExternalIntegration';
  archivedAt: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['Date']>;
  enabled: Maybe<Scalars['Boolean']>;
  externalId: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  integrationJson: Maybe<Scalars['Json']>;
  name: Maybe<Scalars['String']>;
  tenantId: Scalars['ID'];
  updatedAt: Maybe<Scalars['Date']>;
};

export enum FeatureFlagType {
  /** Enables category images for activities */
  ACTIVITIES_CATEGORY_IMAGES_SUPPORT = 'ACTIVITIES_CATEGORY_IMAGES_SUPPORT',
  /** Enable Chat Functionality on Activities */
  ACTIVITY_CHAT = 'ACTIVITY_CHAT',
  /** Enables add a space modal on web */
  ADD_SPACE_MODAL_WEB = 'ADD_SPACE_MODAL_WEB',
  /** Enables the ui for the auto desk booking for employee and admin */
  AUTO_DESK_BOOKING = 'AUTO_DESK_BOOKING',
  /** Enables the ui for booking multiples days in a week */
  BOOK_DESK_AHEAD = 'BOOK_DESK_AHEAD',
  /** Enables the bulk map uploads */
  BULK_MAP_UPLOADS = 'BULK_MAP_UPLOADS',
  /** Feature sends out notifications out when a calendar integration or space calendars are detected to be in a bad state */
  CALENDAR_HEALTH_NOTIFICATIONS = 'CALENDAR_HEALTH_NOTIFICATIONS',
  /** Enables the schedule Information tab for campus app */
  CAMPUS_APP = 'CAMPUS_APP',
  /** New booking flow */
  CONSOLIDATED_BOOKING_FLOW = 'CONSOLIDATED_BOOKING_FLOW',
  /** Enables creating, editing, and using custom fields for guest visits */
  CUSTOM_VISIT_FIELDS = 'CUSTOM_VISIT_FIELDS',
  /** Enables adding/removing custom visit types */
  CUSTOM_VISIT_TYPES = 'CUSTOM_VISIT_TYPES',
  /** Enables the create org functionality in the dashboard apps project */
  DASHBOARD_APPS_CREATE_ORGANIZATION = 'DASHBOARD_APPS_CREATE_ORGANIZATION',
  /** Allow user to view the new onboarding flow */
  DASHBOARD_APPS_ONBOARDING = 'DASHBOARD_APPS_ONBOARDING',
  /** Enables the new schedule tab in the dashboard apps project */
  DASHBOARD_APPS_SCHEDULE_TAB = 'DASHBOARD_APPS_SCHEDULE_TAB',
  /** Enables the dashboard deliveries tab */
  DELIVERIES_TAB = 'DELIVERIES_TAB',
  /**
   * Enables desk issue reporting
   * @deprecated Flag removed; isFeatureFlagEnabledForOrgOrMe always returns true for it
   */
  DESK_ISSUE_REPORTING = 'DESK_ISSUE_REPORTING',
  /** Document agreements (NDAs, liability waivers, etc.) */
  DOCUMENT_AGREEMENTS = 'DOCUMENT_AGREEMENTS',
  /** Enables desk reservation edits */
  EDIT_DESK_RESERVATIONS = 'EDIT_DESK_RESERVATIONS',
  /** Enables the employee visits feature set */
  EMPLOYEE_VISITS = 'EMPLOYEE_VISITS',
  /** Enables the enforcement of workplace service licensing */
  ENFORCE_WORKPLACE_SERVICE_LICENSING = 'ENFORCE_WORKPLACE_SERVICE_LICENSING',
  /** Enables external event sync from OccasionGenius */
  EXTERNAL_OCCASION_GENIUS_EVENT_SYNC = 'EXTERNAL_OCCASION_GENIUS_EVENT_SYNC',
  /** Enables Global Hybrid Index page */
  HYBRID_INDEX = 'HYBRID_INDEX',
  /** Enables new analytics visualizations */
  INSIGHTS_UI_REDESIGN = 'INSIGHTS_UI_REDESIGN',
  /**
   * Enables issue reporting V2 - report issues with spaces
   * @deprecated Flag removed; isFeatureFlagEnabledForOrgOrMe always returns true for it
   */
  ISSUE_REPORTING_V2 = 'ISSUE_REPORTING_V2',
  /** Language selection feature flag for project Global */
  LANGUAGE_SELECTION_ENABLED = 'LANGUAGE_SELECTION_ENABLED',
  /** Enables the mobile week view home tab */
  MOBILE_HOME_TAB_WEEK_VIEW = 'MOBILE_HOME_TAB_WEEK_VIEW',
  /** Enables the meetings/space functionality on the Schedule tab in MS Teams */
  MS_TEAMS_SPACE_BOOKING = 'MS_TEAMS_SPACE_BOOKING',
  /** Enables the use of office activities */
  OFFICE_ACTIVITIES = 'OFFICE_ACTIVITIES',
  /** Enables the use of office activities for mobile */
  OFFICE_ACTIVITIES_MOBILE = 'OFFICE_ACTIVITIES_MOBILE',
  /** Enables components intented to improve the office tab performance */
  OFFICE_TAB_PERFORMANCE = 'OFFICE_TAB_PERFORMANCE',
  /** Enables the onboarding map upload flow */
  ONBOARDING_MAP_UPLOAD = 'ONBOARDING_MAP_UPLOAD',
  /** Enables passive check in */
  PASSIVE_CHECK_IN = 'PASSIVE_CHECK_IN',
  /** Enables the new People tab within insights */
  PEOPLE_INSIGHTS = 'PEOPLE_INSIGHTS',
  /** Optimizes people search */
  PEOPLE_SEARCH_OPTIMIZATION = 'PEOPLE_SEARCH_OPTIMIZATION',
  /** Enables people tab in dashboard apps */
  PEOPLE_TAB_DASHBOARD_APPS = 'PEOPLE_TAB_DASHBOARD_APPS',
  /** Enables team phoenix to toggle features that are in mid development and still release as needed */
  PHOENIX_DEV = 'PHOENIX_DEV',
  /** Enables Office Utilization insights page */
  REAL_ESTATE_OPTIMIZATION_INSIGHTS = 'REAL_ESTATE_OPTIMIZATION_INSIGHTS',
  /** Allow user to view the new schedule desk booking flow */
  SCHEDULE_DESK_BOOKING_ENABLED = 'SCHEDULE_DESK_BOOKING_ENABLED',
  /** Sharptooth team feature flag for development */
  SHARPTOOTH_DEVELOPMENT = 'SHARPTOOTH_DEVELOPMENT',
  /**
   * Deprecate old work place service features across the platform
   * @deprecated Flag removed; isFeatureFlagEnabledForOrgOrMe always returns false for it
   */
  SHOW_LEGACY_WORKPLACE_SERVICE = 'SHOW_LEGACY_WORKPLACE_SERVICE',
  /** Enables suggested spaces on mobile */
  SPACE_SUGGESTIONS_MOBILE = 'SPACE_SUGGESTIONS_MOBILE',
  /** Enables space recommendations */
  SUGGESTED_SPACES = 'SUGGESTED_SPACES',
  /** Admins can create questions that accept file uploads */
  TICKET_FILE_UPLOADS = 'TICKET_FILE_UPLOADS',
  /** Enables the ability to capture images to be used on visitor badges */
  VISITOR_BADGE_IMAGES = 'VISITOR_BADGE_IMAGES',
  /** Enables the ability to add badge printing functionality to arrival displays */
  VISITOR_BADGE_PRINTING = 'VISITOR_BADGE_PRINTING',
  /** Enables visit list table csv export */
  VISITOR_CSV_EXPORT = 'VISITOR_CSV_EXPORT',
  /** Enables the ability to select a range of dates for a visitor to export */
  VISITOR_EXPORT_DATE_RANGE = 'VISITOR_EXPORT_DATE_RANGE',
  /** Visitor managment location enablement */
  VISITOR_LOCATION_ENABLEMENT = 'VISITOR_LOCATION_ENABLEMENT',
  /** Enables permissions checks to gate certain visitor management features */
  VISITOR_MANAGEMENT_PERMISSIONS = 'VISITOR_MANAGEMENT_PERMISSIONS',
  /** Enables who's in sidebar on week view page */
  WEEKVIEW_WHOSIN_SIDEBAR_ENABLED = 'WEEKVIEW_WHOSIN_SIDEBAR_ENABLED',
  /**
   * Enables the ui for workplace services page and request forms to admins and users
   * @deprecated Flag removed; isFeatureFlagEnabledForOrgOrMe always returns true for it
   */
  WORKPLACE_SERVICES = 'WORKPLACE_SERVICES',
  /** Reveals features for managing work areas */
  WORK_AREAS = 'WORK_AREAS',
  /** Reveals feature for work areas on mobile */
  WORK_AREAS_MOBILE = 'WORK_AREAS_MOBILE',
  /** Reveals features for work area insights */
  WORK_AREA_INSIGHTS = 'WORK_AREA_INSIGHTS',
  /**
   * Toggles the updated work week UX/UI
   * @deprecated Feature has been released and is permanently on, flag no longer needed
   */
  WORK_WEEK_IMPROVEMENT_ENABLED = 'WORK_WEEK_IMPROVEMENT_ENABLED',
  /** Toggles the updated (V2) work week UX/UI */
  WORK_WEEK_IMPROVEMENT_V2_ENABLED = 'WORK_WEEK_IMPROVEMENT_V2_ENABLED'
}

export enum FeatureType {
  ACTIVATED_USERS = 'ACTIVATED_USERS',
  ACTIVE_USERS = 'ACTIVE_USERS',
  BOOKABLE_SEATS = 'BOOKABLE_SEATS',
  BOOKABLE_SPACES = 'BOOKABLE_SPACES',
  EXPORTABLE_DATA_DAYS = 'EXPORTABLE_DATA_DAYS',
  FEATURE = 'Feature',
  LEVELS = 'LEVELS',
  LOCATIONS = 'LOCATIONS',
  RIPPLING_USERS = 'RIPPLING_USERS',
  USERS = 'USERS',
  VIEWABLE_DATA_DAYS = 'VIEWABLE_DATA_DAYS',
  VISITOR_ENABLED_LOCATIONS = 'VISITOR_ENABLED_LOCATIONS',
  WORKPLACE_SERVICES_ENABLED_LOCATIONS = 'WORKPLACE_SERVICES_ENABLED_LOCATIONS'
}

export enum FeedbackRating {
  NEGATIVE = 'negative',
  POSITIVE = 'positive'
}

/** A building in the fleet: a Robin Location and its floors. */
export type FleetBuilding = {
  __typename: 'FleetBuilding';
  floors: Array<FleetFloor>;
  /** The Robin Location this building is. Its name and address resolve from the place subgraph. Null when the place subgraph cannot hydrate the Location — a building imported but not yet enabled is hidden, so it has no place detail during import. The building stays in the fleet; only this detail is null, so one such building never fails the whole query. */
  location: Maybe<Location>;
  /** The id of the Robin Location this building is. Always set, including while `location` is null during import, so a client can match the building to its rooms' `Space.locationId`. */
  robinLocationId: Scalars['ID'];
};

export type FleetBuildingsResponse = {
  __typename: 'FleetBuildingsResponse';
  buildings: Array<FleetBuilding>;
};

/** A floor within a building, with the counts a floor plan needs before it draws a single room. */
export type FleetFloor = {
  __typename: 'FleetFloor';
  /** Rooms on this floor whose health is CRITICAL. */
  criticalCount: Scalars['Int'];
  /** Rooms on this floor whose health is HEALTHY. */
  healthyCount: Scalars['Int'];
  /** The Robin Level this floor is. Its name and number resolve from the place subgraph. Null when the place subgraph cannot hydrate the Level — a building imported but not yet enabled is hidden, so its floors have no place detail during import. The floor stays in the fleet; only this detail is null, so one such building never fails the whole query. */
  level: Maybe<Level>;
  /** The id of the Robin Level this floor is. Always set, including while `level` is null during import, so a client can match the floor to its rooms' `Space.levelId`. */
  robinLevelId: Scalars['ID'];
  /** Rooms on this floor. */
  roomCount: Scalars['Int'];
};

/** A room in the fleet: a Robin Space, the hardware in it, and its live state. */
export type FleetRoom = {
  __typename: 'FleetRoom';
  /** True when a device in the room is offline, false when its devices report reachability and none are offline, null when no device in the room reports a reachability verdict at all. */
  avOffline: Maybe<Scalars['Boolean']>;
  /** True when the room is booked but sensed empty. Null until booking and occupancy are correlated. */
  bookedButEmpty: Maybe<Scalars['Boolean']>;
  /** Recent calls in this room, newest first. History covers the last 30 days. The server caps the list: limit is at most 50 and defaults to 50, and a larger value is clamped to 50 rather than rejected. Ask for fewer when a screen only shows the latest few. A limit of 0 or below returns an empty list, not an error: an empty page is the honest answer to asking for no calls. */
  callHistory: Array<Call>;
  /** CO2 in ppm, or null until air quality is collected. */
  co2Ppm: Maybe<Scalars['Int']>;
  /** The current calendar event's title, or null when the room is free / until calendars are read. */
  currentEvent: Maybe<Scalars['String']>;
  /** The hardware placed in this room, one entry per source record. A box two sources see can appear once per source; fusedEndpoints is the same hardware one entry per physical box. */
  devices: Array<Endpoint>;
  /** The physical boxes in this room, one per fused component of devices, with their product names and signals. Read from the same resolution as devices, so selecting both costs one read. */
  fusedEndpoints: Array<FusedEndpoint>;
  /** 0-100 health score, or null until scoring exists. */
  healthScore: Maybe<Scalars['Int']>;
  /** The most recent activity timestamp across the room's hardware, or null when the room has no hardware. This is the newest of each device's last-seen time, which is a source observation for most sources but our own mapping write time for Google Meet (which has no source observation clock) — so in a Meet-only or mixed room an admin mapping edit can move this value. Treat it as last activity, not a guaranteed hardware observation. */
  lastSeen: Maybe<Scalars['DateTime']>;
  /** Current headcount, or null until occupancy is collected. */
  occupancy: Maybe<Scalars['Int']>;
  /** The Robin Space this room is. Its name, floor and capacity resolve from the place subgraph. Null when the place subgraph cannot hydrate the Space — a room in a building imported but not yet enabled is hidden, so it has no place detail during import. The room stays in the fleet; only this detail is null, so one such room never fails the whole query. */
  space: Maybe<Space>;
  /** Rolled-up room health. */
  status: FleetRoomHealth;
};


/** A room in the fleet: a Robin Space, the hardware in it, and its live state. */
export type FleetRoomCallHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** A room's overall health, rolled up from the hardware in it and how it is being used. Coarser than a device's own status on purpose: this is the single badge a floor plan shows per room. UNKNOWN is a room with no hardware placed (or only hardware that reports no reachability): nothing is wrong, but nothing is confirmed working either, so it is kept distinct from HEALTHY. */
export enum FleetRoomHealth {
  CRITICAL = 'CRITICAL',
  DEGRADED = 'DEGRADED',
  HEALTHY = 'HEALTHY',
  UNKNOWN = 'UNKNOWN'
}

export type FleetRoomsResponse = {
  __typename: 'FleetRoomsResponse';
  rooms: Array<FleetRoom>;
};

/** Scopes a fleet read to one building or one floor. Omit both for the whole tenant; give robinLevelId to narrow to a floor within its building. */
export type FleetScopeInput = {
  robinLevelId?: InputMaybe<Scalars['ID']>;
  robinLocationId?: InputMaybe<Scalars['ID']>;
};

/** An integration the fleet depends on, and whether it is currently usable. */
export type FleetService = {
  __typename: 'FleetService';
  id: Scalars['ID'];
  name: Scalars['String'];
  status: FleetServiceStatus;
};

/** Whether an integration the fleet depends on is currently usable. DEGRADED is reserved for a partial-health signal this service does not collect yet, so no service resolves to it today. */
export enum FleetServiceStatus {
  CONNECTED = 'CONNECTED',
  DEGRADED = 'DEGRADED',
  DISCONNECTED = 'DISCONNECTED'
}

export type FleetServicesResponse = {
  __typename: 'FleetServicesResponse';
  services: Array<FleetService>;
};

/** Tenant-wide rollups for the fleet dashboard header. */
export type FleetSummary = {
  __typename: 'FleetSummary';
  /** Google ChromeOS device records in scope. */
  chromeOsDevices: Scalars['Int'];
  /** Rooms whose health is CRITICAL. */
  criticalCount: Scalars['Int'];
  /** Google Meet device records in scope. */
  googleMeetDevices: Scalars['Int'];
  /** LogiSync device records in scope. */
  logiDevices: Scalars['Int'];
  /** Neat Pulse device records in scope. */
  neatDevices: Scalars['Int'];
  /** Total rooms in scope. */
  rooms: Scalars['Int'];
};

export type Floor = {
  __typename: 'Floor';
  building: Building;
  id: Scalars['ID'];
  label: Scalars['String'];
};

/** How one floor of an allocation draft is divided between business units. */
export type FloorAllocation = {
  __typename: 'FloorAllocation';
  businessUnits: Array<BusinessUnitAllocation>;
  floorId: Scalars['ID'];
};

/** How one floor is divided between business units. */
export type FloorAllocationInput = {
  businessUnits: Array<BusinessUnitAllocationInput>;
  floorId: Scalars['ID'];
};

export type FloorConflicts = {
  __typename: 'FloorConflicts';
  conflicts: Array<DraftConflict>;
  floorId: Scalars['ID'];
  floorName: Scalars['String'];
};

export type FloorNeighborhoodInput = {
  floorId: Scalars['Int'];
  neighborhoods: Array<PersistNeighborhoodInput>;
  showNeighborhoodColor?: InputMaybe<Scalars['Boolean']>;
};

export type FloorNeighborhoodResult = {
  __typename: 'FloorNeighborhoodResult';
  createdNeighborhoods: Array<Scalars['String']>;
  deletedNeighborhoods: Array<Scalars['String']>;
  floorId: Scalars['Int'];
  settingUpdated: Scalars['Boolean'];
  updatedNeighborhoods: Array<Scalars['String']>;
};

export type FloorNeighborhoodsResponse = {
  __typename: 'FloorNeighborhoodsResponse';
  neighborhoods: Array<Neighborhood>;
  showNeighborhoodColors: Scalars['Boolean'];
};

/** https://developer.mozilla.org/en-US/docs/Web/API/FormData/entries */
export type FormDataField = {
  __typename: 'FormDataField';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type ForwardPageInfo = {
  __typename: 'ForwardPageInfo';
  /** Pass this into `after` to get results after this page. Null if no results. */
  endCursor: Maybe<Scalars['String']>;
  /** True if there are more results after endCursor */
  hasNextPage: Scalars['Boolean'];
};

/** One physical piece of hardware, fused across every source that saw it. An Endpoint is one source's record; a FusedEndpoint is the IS_SAME_AS connected component those records form, and observedVia lists them. Until fusion writes edges every component has exactly one member — the shape is stable now and the list grows when the graph does, with no change to the wire. When members disagree, each fused field takes one member's value by a fixed rule, and says which member through productFrom and nameFrom. The other members' values stay readable through observedVia. Two members that disagree on a hard fact — the serial, or the product — are not resolved silently: conflicts lists them. Health is never merged: each observation keeps the member that reported it as its subject. */
export type FusedEndpoint = {
  __typename: 'FusedEndpoint';
  /** Hard facts the members disagree on. Empty when they agree, which is the normal case. A conflict means fusion joined records that may not be one box, so a screen should flag it rather than trust the fused values. */
  conflicts: Array<FusedEndpointConflict>;
  /** The earliest real source observation of the box across members. See lastSeenAt for what counts. Null when no member has one. */
  firstSeenAt: Maybe<Scalars['DateTime']>;
  /** The box's handle: its primary member's Endpoint id. Stable across syncs for as long as the box's membership does not change, so it is safe in a URL today. When fusion joins or splits boxes, the writer that does it owns how an old id resolves. Opaque: it is not always a uuid (a Google Meet member's id is its serial). A Meet box that is also a ChromeOS device comes back once, as its ChromeOS record, so its id is the ChromeOS id. */
  id: Scalars['ID'];
  /** The hard identifiers that fuse records into this box — serials, MACs and vendor device ids — deduplicated across members. */
  identifiers: Array<EndpointIdentifier>;
  /** The latest real source observation of the box across members, or null when no member has one. Only a source's own sighting of the device counts. For a ChromeOS member that is its lastActiveAt or lastSeenAt from the Directory poll. For a Logi Sync or Neat Pulse member it is its lastSeenAt from the poll. For a Google Meet member it is its latest Meet hardware audit event: a call join or leave, a peripheral change, a restart or a software update. A Meet member's own lastSeenAt never counts: it is the time the collector wrote the mapping, not a sighting of the device. So a Meet-only box with no hardware event since the org connected reads null. The first poll looks back only five minutes. No per-device read of those events exists yet, so today every Meet-only box reads null. */
  lastSeenAt: Maybe<Scalars['DateTime']>;
  /** The raw model key, verbatim from productFrom, and stable, so a client can key behavior on it. Model keys are per source — a Neat code, a Logitech product name, a Google model string — so read it together with productFrom.source, never alone. */
  model: Maybe<Scalars['String']>;
  /** The product name for model, from the collector's product-name table, taken from productFrom with model. A label for people that may change; key behavior on model instead. Null when the table does not know the model. */
  modelName: Maybe<Scalars['String']>;
  /** What an admin called the box, not its model. Taken from nameFrom. ChromeOS and Google Meet members report none. A Neat Pulse member carries the name set in Neat Pulse once discovery has seen it (the plain inventory poll records none), and a Logi Sync Computer or Generic member its host name. A Logitech device in Logi Sync reports only its model, so it has none. A screen should fall back to modelName. */
  name: Maybe<Scalars['String']>;
  /** The member name came from, or null when no member names the box. The rule: prefer a member from a system where admins name devices, which is usually the maker's own management system; otherwise the most recently seen member that reports a name. A member whose name only repeats its model — a Logitech device in Logi Sync — does not count as naming the box. */
  nameFrom: Maybe<Endpoint>;
  /** Every current signal about this box, across its members. Filter by domain and facet; pass onlyFresh to drop readings past their staleAfter. An empty domain or facet list filters nothing, like an omitted one. Each observation's subject is the member Endpoint that reported it. */
  observations: Array<EndpointObservation>;
  /** The source records this box was seen through, and therefore its sightings: each carries its own source, remoteId, firstSeenAt and lastSeenAt. Never empty. */
  observedVia: Array<Endpoint>;
  /** Where the box is: the strongest placement among its members, or null when nothing has placed any of them yet — a normal onboarding state, not an error. */
  placement: Maybe<EndpointPlacement>;
  /** The member vendor, model and modelName came from, or null when no member reports a vendor or a model. All three come from this one member, so they always describe one product. The rule: the member from the maker's own management system wins when it reports a vendor or a model — Neat Pulse for Neat hardware, Logi Sync for Logitech hardware, Google's ChromeOS inventory for a Chromebox. Otherwise, the most recently seen member that reports a vendor or a model. Logi Sync reports a device type (Logitech, Computer or Generic), not a maker. So a Logi Sync member reports a vendor only when its type is Logitech, which is when its model is non-null. A Computer or Generic member reports neither. */
  productFrom: Maybe<Endpoint>;
  /** What the box is for, inferred from its source and model. UNKNOWN for a model the collector does not know. Coarser than a per-kind split: cameras, mics, speakers and touch controllers are all PERIPHERAL. */
  role: FusedEndpointRole;
  /** Who made the box, verbatim from productFrom, with no closed vocabulary. */
  vendor: Maybe<Scalars['String']>;
};


/** One physical piece of hardware, fused across every source that saw it. An Endpoint is one source's record; a FusedEndpoint is the IS_SAME_AS connected component those records form, and observedVia lists them. Until fusion writes edges every component has exactly one member — the shape is stable now and the list grows when the graph does, with no change to the wire. When members disagree, each fused field takes one member's value by a fixed rule, and says which member through productFrom and nameFrom. The other members' values stay readable through observedVia. Two members that disagree on a hard fact — the serial, or the product — are not resolved silently: conflicts lists them. Health is never merged: each observation keeps the member that reported it as its subject. */
export type FusedEndpointObservationsArgs = {
  domain?: InputMaybe<Array<EndpointObservationDomain>>;
  facet?: InputMaybe<Array<Scalars['String']>>;
  onlyFresh?: InputMaybe<Scalars['Boolean']>;
};

/** Members of one FusedEndpoint that report different values for a hard fact. */
export type FusedEndpointConflict = {
  __typename: 'FusedEndpointConflict';
  field: FusedEndpointConflictField;
  /** Each distinct value, with the members that reported it. Always two or more. */
  values: Array<FusedEndpointConflictValue>;
};

/** A hard fact that members of one box must agree on. Additive: a client that does not know a field should still show the conflict. */
export enum FusedEndpointConflictField {
  /** Members report different products. Raw model keys differ by source, so members are compared by modelName; a member whose model the product-name table does not know is not compared. */
  MODEL = 'MODEL',
  /** Members report different manufacturer serials. */
  SERIAL = 'SERIAL'
}

export type FusedEndpointConflictValue = {
  __typename: 'FusedEndpointConflictValue';
  reportedBy: Array<Endpoint>;
  value: Scalars['String'];
};

export type FusedEndpointResponse = {
  __typename: 'FusedEndpointResponse';
  /** Null when no box has this id in this tenant. */
  fusedEndpoint: Maybe<FusedEndpoint>;
};

/** What a fused box is for. Additive: a new role is backward compatible on the wire, and a client that does not know one should treat it as UNKNOWN. */
export enum FusedEndpointRole {
  MEDIA_PLAYER = 'MEDIA_PLAYER',
  PC = 'PC',
  /** Attached to a controller — a mic pod, a touch controller, a camera. */
  PERIPHERAL = 'PERIPHERAL',
  /** The box that runs the room — a Rally Bar, a Neat Bar, a Chromebox. */
  ROOM_CONTROLLER = 'ROOM_CONTROLLER',
  ROOM_SIGN = 'ROOM_SIGN',
  SCREEN = 'SCREEN',
  SENSOR = 'SENSOR',
  UNKNOWN = 'UNKNOWN'
}

export enum GallagherTenancy {
  AU = 'AU',
  US = 'US'
}

export enum GeneaTenancy {
  US = 'US'
}

export type GenerateAssignmentRecommendationInput = {
  /** Optional: constrain the search to one building */
  buildingId?: InputMaybe<Scalars['ID']>;
  /** Ranked alternatives to return besides the top pick (default 5, max 10) */
  maxAlternatives?: InputMaybe<Scalars['Int']>;
  /** User to place (admin-scoped: any user in the tenant) */
  userId: Scalars['ID'];
};

export type GenerateStickerBatchRequest = {
  count?: InputMaybe<Scalars['Int']>;
};

export type GenerateStickerBatchResponse = {
  __typename: 'GenerateStickerBatchResponse';
  batch: StickerBatch;
};

/** A configured source-to-Robin mapping for a universal connector integration. */
export type GenericConnectorSourceMapping = {
  __typename: 'GenericConnectorSourceMapping';
  robinLevelId: Maybe<Scalars['Int']>;
  robinLocationId: Scalars['Int'];
  sourcePattern: Scalars['String'];
};

export enum GenericHealthCheckpointEntityType {
  GUEST_INVITE = 'GUEST_INVITE'
}

export type GenericHealthCheckpointResponse = {
  __typename: 'GenericHealthCheckpointResponse';
  id: Scalars['ID'];
  status: GenericHealthCheckpointStatus;
};

export enum GenericHealthCheckpointStatus {
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
  INCOMPLETE = 'INCOMPLETE',
  PASSED = 'PASSED',
  UNKNOWN = 'UNKNOWN'
}

export enum GeoJsonType {
  FEATURE = 'Feature'
}

export type Geometry = {
  __typename: 'Geometry';
  coordinates: Array<Array<Array<Scalars['Float']>>>;
  type: GeometryType;
};

export type GeometryInput = {
  coordinates: Array<Array<Array<Scalars['Float']>>>;
  type: GeometryType;
};

export enum GeometryType {
  POLYGON = 'Polygon'
}

export type GetActivityCoverImagesResponse = {
  __typename: 'GetActivityCoverImagesResponse';
  forwardPageInfo: ForwardPageInfo;
  images: Array<ActivityImage>;
};

export type GetBadgeCsvUploadStatusForCurrentTenantError = {
  __typename: 'GetBadgeCSVUploadStatusForCurrentTenantError';
  failedRecordsCount: Scalars['Int'];
  reason: Scalars['String'];
};

export type GetBadgeCsvUploadStatusInput = {
  uuid: Scalars['ID'];
};

export type GetBadgeCsvUploadStatusResponse = {
  __typename: 'GetBadgeCSVUploadStatusResponse';
  errors: Array<BadgeCsvUploadStatusError>;
  status: Scalars['String'];
};

export type GetBadgeCsvUploadsForCurrentTenantPagination = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type GetBadgeCsvUploadsForCurrentTenantResponse = {
  __typename: 'GetBadgeCSVUploadsForCurrentTenantResponse';
  pagination: PagedPaginationResponse;
  records: Array<GetBadgeCsvUploadsForCurrentTenantResponseRecords>;
};

export type GetBadgeCsvUploadsForCurrentTenantResponseRecords = {
  __typename: 'GetBadgeCSVUploadsForCurrentTenantResponseRecords';
  canForceRetry: Scalars['Boolean'];
  downloadLink: Maybe<Scalars['String']>;
  errors: Array<GetBadgeCsvUploadStatusForCurrentTenantError>;
  fileName: Scalars['String'];
  location: Maybe<Location>;
  status: Scalars['String'];
  uploadedAt: Scalars['String'];
  uploader: Maybe<AccountUser>;
  userActor: Scalars['Int'];
  uuid: Scalars['ID'];
};

export type GetBadgePresenceAuditLogPageInput = {
  cursor?: InputMaybe<Scalars['String']>;
  integrationUuid?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  statuses?: InputMaybe<Array<BadgePresenceDoorEntryRecordStatus>>;
};

export type GetBadgePresenceAuditLogPageResponse = {
  __typename: 'GetBadgePresenceAuditLogPageResponse';
  pagination: CursoredPaginationResponse;
  records: Array<BadgePresenceDoorEntryRecord>;
};

export type GetBadgePresenceConnectionsForCurrentTenantResponse = {
  __typename: 'GetBadgePresenceConnectionsForCurrentTenantResponse';
  connections: Array<BadgePresenceConnection>;
};

export type GetBrivoAccountStatusForCurrentTenant = {
  __typename: 'GetBrivoAccountStatusForCurrentTenant';
  isHealthy: Scalars['Boolean'];
  unhealthyReasons: Array<Scalars['String']>;
};

export type GetBrivoLocksForCurrentTenant = {
  __typename: 'GetBrivoLocksForCurrentTenant';
  sites: Array<GetBrivoLocksForCurrentTenantLock>;
};

export type GetBrivoLocksForCurrentTenantLock = {
  __typename: 'GetBrivoLocksForCurrentTenantLock';
  remoteLockId: Scalars['ID'];
  remoteLockName: Scalars['String'];
  remotePlaceId: Scalars['String'];
  remotePlaceName: Scalars['String'];
  robinLevelId: Maybe<Scalars['Int']>;
  robinLocationId: Maybe<Scalars['Int']>;
};

export type GetBuildingGeofenceInput = {
  buildingId: Scalars['ID'];
};

export type GetBuildingGeofenceResponse = {
  __typename: 'GetBuildingGeofenceResponse';
  geofence: BuildingGeofence;
};

export type GetBuildingsAtAPointForCurrentTenantInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type GetBuildingsAtAPointForCurrentTenantResponse = {
  __typename: 'GetBuildingsAtAPointForCurrentTenantResponse';
  buildings: Array<Location>;
};

export type GetCredentialDetailsForCurrentTenantDoor = {
  __typename: 'GetCredentialDetailsForCurrentTenantDoor';
  doorId: Scalars['String'];
  doorName: Scalars['String'];
  floorName: Maybe<Scalars['String']>;
};

export type GetCredentialDetailsForCurrentTenantInput = {
  linkToken: Scalars['String'];
};

export type GetCredentialDetailsForCurrentTenantResponse = {
  __typename: 'GetCredentialDetailsForCurrentTenantResponse';
  doors: Array<GetCredentialDetailsForCurrentTenantDoor>;
  endTime: Scalars['String'];
  startTime: Scalars['String'];
  vendor: Scalars['String'];
};

export type GetCredentialOrganizationAndLocationInfoForCurrentTenantInput = {
  linkToken: Scalars['String'];
};

export type GetCredentialOrganizationAndLocationInfoForCurrentTenantResponse = {
  __typename: 'GetCredentialOrganizationAndLocationInfoForCurrentTenantResponse';
  organizationLogoUrl: Scalars['String'];
  organizationName: Scalars['String'];
  robinLocationName: Scalars['String'];
};

export type GetCurrentActorBadgePermissionsForCurrentTenantReponse = {
  __typename: 'GetCurrentActorBadgePermissionsForCurrentTenantReponse';
  canManageKisi: Scalars['Boolean'];
  canUpload: Scalars['Boolean'];
};

export type GetDeskAvailabilityByLevelIdFiltersInput = {
  deskAmenityIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type GetDeskAvailabilityByLevelIdScopeInput = {
  levelId: Scalars['ID'];
};

export type GetDeskAvailabilityByLevelIdViewOptionsInput = {
  endTime: Scalars['ISODateTime'];
  startTime: Scalars['ISODateTime'];
};

export enum GetEphemeralDownloadUrlForScannedTicketFileErrorReason {
  STILL_SCANNING = 'STILL_SCANNING',
  UNKNOWN_SCAN_ERROR = 'UNKNOWN_SCAN_ERROR',
  VIRUS_DETECTED = 'VIRUS_DETECTED'
}

export type GetEphemeralDownloadUrlForScannedTicketFileErrorResponse = {
  __typename: 'GetEphemeralDownloadUrlForScannedTicketFileErrorResponse';
  reason: GetEphemeralDownloadUrlForScannedTicketFileErrorReason;
};

export type GetEphemeralDownloadUrlForScannedTicketFileResponse = GetEphemeralDownloadUrlForScannedTicketFileErrorResponse | GetEphemeralDownloadUrlForScannedTicketFileSuccessResponse;

export type GetEphemeralDownloadUrlForScannedTicketFileSuccessResponse = {
  __typename: 'GetEphemeralDownloadUrlForScannedTicketFileSuccessResponse';
  expiresAt: Scalars['ISODateTime'];
  url: Scalars['String'];
};

export type GetEventAuditLogsByEventIdInput = {
  eventId: Scalars['ID'];
  pagination: EventAuditLogPaginationInput;
};

export type GetEventAuditLogsByEventIdResponse = {
  __typename: 'GetEventAuditLogsByEventIdResponse';
  logs: Array<EventAuditLog>;
  pagination: EventAuditLogPaginationOutput;
};

export type GetEventAuditLogsInput = {
  filter: EventAuditLogFilterInput;
  pagination: EventAuditLogPaginationInput;
  timeRange: EventAuditLogTimeRangeInput;
};

export type GetEventAuditLogsPaginatedResponse = {
  __typename: 'GetEventAuditLogsPaginatedResponse';
  logs: Array<EventAuditLog>;
  pagination: EventAuditLogPaginationOutput;
};

export type GetEventsWithCheckInStatusForProxiedEventIdReponse = {
  __typename: 'GetEventsWithCheckInStatusForProxiedEventIdReponse';
  events: Array<EventWithCheckInStatus>;
};

export type GetGallagherAccountForCurrentTenant = {
  __typename: 'GetGallagherAccountForCurrentTenant';
  emailFieldIdentifier: Maybe<Scalars['String']>;
  integrationUuid: Maybe<Scalars['ID']>;
  isHealthy: Scalars['Boolean'];
  unhealthyReasons: Array<Scalars['String']>;
};

export type GetGallagherDoorsByIntegrationUuid = {
  __typename: 'GetGallagherDoorsByIntegrationUuid';
  doors: Array<GetGallagherDoorsByIntegrationUuidDoor>;
};

export type GetGallagherDoorsByIntegrationUuidDoor = {
  __typename: 'GetGallagherDoorsByIntegrationUuidDoor';
  remoteDoorId: Scalars['ID'];
  remoteDoorName: Scalars['String'];
  robinLevelId: Maybe<Scalars['Int']>;
  robinLocationId: Maybe<Scalars['Int']>;
};

export type GetGallagherDoorsByIntegrationUuidInput = {
  integrationUuid: Scalars['ID'];
};

export type GetGeneaAccountForCurrentTenant = {
  __typename: 'GetGeneaAccountForCurrentTenant';
  integrationUuid: Maybe<Scalars['ID']>;
  isHealthy: Scalars['Boolean'];
  unhealthyReasons: Array<Scalars['String']>;
};

export type GetGeneaDoorsForCurrentTenant = {
  __typename: 'GetGeneaDoorsForCurrentTenant';
  doors: Array<GetGeneaDoorsForCurrentTenantLock>;
};

export type GetGeneaDoorsForCurrentTenantLock = {
  __typename: 'GetGeneaDoorsForCurrentTenantLock';
  remoteDoorId: Scalars['ID'];
  remoteDoorName: Scalars['String'];
  remoteLocationId: Scalars['String'];
  remoteLocationName: Scalars['String'];
  robinLevelId: Maybe<Scalars['Int']>;
  robinLocationId: Maybe<Scalars['Int']>;
};

export type GetGenericConnectorSourceMappingsInput = {
  integrationUuid: Scalars['ID'];
};

export type GetGenericConnectorSourceMappingsResponse = {
  __typename: 'GetGenericConnectorSourceMappingsResponse';
  mappings: Array<GenericConnectorSourceMapping>;
};

export type GetGenetecAccountForCurrentTenant = {
  __typename: 'GetGenetecAccountForCurrentTenant';
  integrationUuid: Maybe<Scalars['ID']>;
  isHealthy: Scalars['Boolean'];
  unhealthyReasons: Array<Scalars['String']>;
};

export type GetGenetecDoorsByIntegrationUuidDoor = {
  __typename: 'GetGenetecDoorsByIntegrationUuidDoor';
  remoteDoorId: Scalars['ID'];
  remoteDoorName: Scalars['String'];
  robinLevelId: Maybe<Scalars['Int']>;
  robinLocationId: Maybe<Scalars['Int']>;
};

export type GetGenetecDoorsByIntegrationUuidInput = {
  integrationUuid: Scalars['ID'];
};

export type GetGenetecDoorsByIntegrationUuidResponse = {
  __typename: 'GetGenetecDoorsByIntegrationUuidResponse';
  doors: Array<GetGenetecDoorsByIntegrationUuidDoor>;
};

export type GetGoogleAccountForCurrentTenant = {
  __typename: 'GetGoogleAccountForCurrentTenant';
  integrationUuid: Maybe<Scalars['ID']>;
  isHealthy: Scalars['Boolean'];
};

export type GetGoogleMeetDevicesForCurrentTenantResponse = {
  __typename: 'GetGoogleMeetDevicesForCurrentTenantResponse';
  devices: Array<GoogleMeetDevice>;
};

export type GetIssueReportByIdentifierResponse = {
  __typename: 'GetIssueReportByIdentifierResponse';
  /** Null if no such issue report exists, or the current user cannot see it */
  issueReport: Maybe<IssueReport>;
};

export type GetKisiAccountStatusForCurrentTenant = {
  __typename: 'GetKisiAccountStatusForCurrentTenant';
  isHealthy: Scalars['Boolean'];
  unhealthyReasons: Array<Scalars['String']>;
};

export type GetKisiLocksForCurrentTenant = {
  __typename: 'GetKisiLocksForCurrentTenant';
  sites: Array<GetKisiLocksForCurrentTenantLock>;
};

export type GetKisiLocksForCurrentTenantLock = {
  __typename: 'GetKisiLocksForCurrentTenantLock';
  isConfigured: Scalars['Boolean'];
  isOnline: Scalars['Boolean'];
  remoteLockId: Scalars['String'];
  remoteLockName: Scalars['String'];
  remotePlaceId: Scalars['String'];
  remotePlaceName: Scalars['String'];
  robinLevelId: Maybe<Scalars['Int']>;
  robinLocationId: Maybe<Scalars['Int']>;
};

export type GetLogiSyncAccountForCurrentTenant = {
  __typename: 'GetLogiSyncAccountForCurrentTenant';
  integrationUuid: Maybe<Scalars['ID']>;
  isHealthy: Scalars['Boolean'];
};

export type GetLogiSyncPlacesForCurrentTenant = {
  __typename: 'GetLogiSyncPlacesForCurrentTenant';
  places: Array<GetLogiSyncPlacesForCurrentTenantPlace>;
};

export type GetLogiSyncPlacesForCurrentTenantPlace = {
  __typename: 'GetLogiSyncPlacesForCurrentTenantPlace';
  /** Confidence (0..1) in the mapping, or null when it is unmapped. */
  confidence: Maybe<Scalars['Float']>;
  devices: Array<LogiSyncDevice>;
  /** How the place's current space mapping was made, or null when it is unmapped. */
  mappingMethod: Maybe<Scalars['String']>;
  name: Scalars['String'];
  placeId: Scalars['ID'];
  robinSpaceId: Maybe<Scalars['Int']>;
  type: Scalars['String'];
};

export type GetMeetingServiceByIdResponse = {
  __typename: 'GetMeetingServiceByIdResponse';
  /** null if meeting service with ID cannot be found */
  meetingService: Maybe<MeetingService>;
};

export type GetMeetingServiceRequestByIdResponse = {
  __typename: 'GetMeetingServiceRequestByIdResponse';
  meetingServiceRequest: Maybe<MeetingServiceRequest>;
};

export type GetMeetingServiceRequestByIdentifierResponse = {
  __typename: 'GetMeetingServiceRequestByIdentifierResponse';
  meetingServiceRequest: Maybe<MeetingServiceRequest>;
};

export type GetMobileGeofencesForMeInTenantInput = {
  tenantId: Scalars['ID'];
};

export type GetMobileGeofencesForMeInTenantResponse = {
  __typename: 'GetMobileGeofencesForMeInTenantResponse';
  geofences: Array<MobileGeofence>;
};

export type GetMyWaitlistResponse = {
  __typename: 'GetMyWaitlistResponse';
  /** The active URL for actor to open up. It will change based on the current state of the waitlist and potentially will return different URLs based on actor's status in the queue. */
  activeUrl: Maybe<Scalars['String']>;
  /** Same as status == NOT_ENABLED, but simpler for front-ends to filter by this. */
  isEnabled: Scalars['Boolean'];
  status: GetMyWaitlistStatus;
};

export enum GetMyWaitlistStatus {
  /** A waitlist is available and can be opened. */
  AVAILABLE = 'AVAILABLE',
  /** Waitlist not enabled. */
  NOT_ENABLED = 'NOT_ENABLED',
  /** Currently queued in a waitlist. */
  SCHEDULED = 'SCHEDULED'
}

export type GetMyWaitlistsResponse = {
  __typename: 'GetMyWaitlistsResponse';
  /** Global flag indicating if waitlists are enabled for this context. */
  isEnabled: Scalars['Boolean'];
  waitlists: Array<GetMyWaitlistsResponseWaitlists>;
};

export type GetMyWaitlistsResponseWaitlists = {
  __typename: 'GetMyWaitlistsResponseWaitlists';
  /** The active URL for actor to open up. It will change based on the current state of the waitlist and potentially will return different URLs based on actor's status in the queue. */
  activeUrl: Maybe<Scalars['String']>;
  /** Waitlist name, usually shown in the UI. */
  name: Maybe<Scalars['String']>;
  /** Current status of the waitlist. */
  status: GetMyWaitlistsStatus;
  /** Status byline shown in the UI. Can show estimated waiting time etc. */
  statusByline: Maybe<Scalars['String']>;
};

export enum GetMyWaitlistsStatus {
  /** A waitlist is available and can be opened. */
  AVAILABLE = 'AVAILABLE',
  /** Waitlist not enabled. */
  NOT_ENABLED = 'NOT_ENABLED',
  /** Currently queued in a waitlist. */
  SCHEDULED = 'SCHEDULED'
}

export type GetNeatPulseAccountForCurrentTenant = {
  __typename: 'GetNeatPulseAccountForCurrentTenant';
  integrationUuid: Maybe<Scalars['ID']>;
  isHealthy: Scalars['Boolean'];
};

export type GetNeatPulseDeviceSensorDataInput = {
  deviceId: Scalars['ID'];
};

export type GetNeatPulseRoomsForCurrentTenantInput = {
  locationId?: InputMaybe<Scalars['ID']>;
  regionId?: InputMaybe<Scalars['ID']>;
};

export type GetNeatPulseRoomsForCurrentTenantResponse = {
  __typename: 'GetNeatPulseRoomsForCurrentTenantResponse';
  rooms: Array<NeatPulseRoom>;
};

export type GetNeighborhoodByIdResponse = {
  __typename: 'GetNeighborhoodByIdResponse';
  neighborhood: Neighborhood;
  showNeighborhoodColors: Scalars['Boolean'];
};

export type GetOpenpathAccountStatusForCurrentTenant = {
  __typename: 'GetOpenpathAccountStatusForCurrentTenant';
  credentialProvisioningEnabled: Scalars['Boolean'];
  integrationUuid: Maybe<Scalars['ID']>;
  isHealthy: Scalars['Boolean'];
  presenceReportingEnabled: Scalars['Boolean'];
  unhealthyReasons: Array<Scalars['String']>;
};

export type GetOpenpathLocksForCurrentTenant = {
  __typename: 'GetOpenpathLocksForCurrentTenant';
  sites: Array<GetOpenpathLocksForCurrentTenantLock>;
};

export type GetOpenpathLocksForCurrentTenantLock = {
  __typename: 'GetOpenpathLocksForCurrentTenantLock';
  canBeUsedForCredentialProvisioning: Scalars['Boolean'];
  remoteLockId: Scalars['String'];
  remoteLockName: Scalars['String'];
  remotePlaceId: Scalars['String'];
  remotePlaceName: Scalars['String'];
  robinLevelId: Maybe<Scalars['Int']>;
  robinLocationId: Maybe<Scalars['Int']>;
};

export type GetPublishedDraftResponse = {
  __typename: 'GetPublishedDraftResponse';
  content: ReviewDraftChangesResponse;
  floor: Maybe<Level>;
  hasAuditLogs: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  reviewVersion: Scalars['Int'];
  settings: Array<DraftSettings>;
};

export type GetRipplingAccountStateResponse = {
  __typename: 'GetRipplingAccountStateResponse';
  lastSync: Scalars['String'];
  state: SyncState;
  syncedUsers: Scalars['Int'];
};

export type GetSpaceSuggestableEventsForUserResponse = {
  __typename: 'GetSpaceSuggestableEventsForUserResponse';
  events: Array<Event>;
};

export type GetSuggestedSpaceForEventsEventInput = {
  endTime: Scalars['ISODateTime'];
  id: Scalars['ID'];
  /** Represents the number of attendees that are in the office for the filtered location and also accepted the event */
  preferredSpaceCapacity?: InputMaybe<Scalars['Int']>;
  startTime: Scalars['ISODateTime'];
};

/** How to decide which spaces to suggest - for A/B testing */
export enum GetSuggestedSpacesForEventsAlgorithm {
  FRECENCY_V1 = 'FRECENCY_V1',
  FRECENCY_V2 = 'FRECENCY_V2'
}

export type GetSuggestedSpacesForEventsInput = {
  algorithm?: InputMaybe<GetSuggestedSpacesForEventsAlgorithm>;
  events: Array<GetSuggestedSpaceForEventsEventInput>;
  spaceFilters: GetSuggestedSpacesForEventsSpaceFiltersInput;
  /** Loose preferences for spaces - attempt to fit criteria but no guarantees */
  spacePreferences?: InputMaybe<GetSuggestedSpacesForEventsSpacePreferencesInput>;
};

export type GetSuggestedSpacesForEventsResponse = {
  __typename: 'GetSuggestedSpacesForEventsResponse';
  /** Nullable to force resilience in the face of changing enum values */
  algorithm: Maybe<GetSuggestedSpacesForEventsAlgorithm>;
  suggestedSpaces: Array<SuggestedSpaceForEvent>;
};

export type GetSuggestedSpacesForEventsSpaceFiltersInput = {
  locationIds: Array<Scalars['ID']>;
};

export type GetSuggestedSpacesForEventsSpacePreferencesInput = {
  levelIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** How to decide which spaces to suggest - for A/B testing */
export enum GetSuggestedSpacesForTimeFrameAlgorithm {
  FRECENCY_V1 = 'FRECENCY_V1',
  FRECENCY_V2 = 'FRECENCY_V2'
}

export type GetSuggestedSpacesForTimeFrameFiltersInput = {
  locationIds: Array<Scalars['ID']>;
};

export type GetSuggestedSpacesForTimeFrameInput = {
  algorithm?: InputMaybe<GetSuggestedSpacesForEventsAlgorithm>;
  endTime: Scalars['ISODateTime'];
  filters: GetSuggestedSpacesForTimeFrameFiltersInput;
  /** Loose preferences for spaces - attempt to fit criteria but no guarantees */
  spacePreferences?: InputMaybe<GetSuggestedSpacesForTimeFramePreferencesInput>;
  startTime: Scalars['ISODateTime'];
};

export type GetSuggestedSpacesForTimeFramePreferencesInput = {
  levelIds?: InputMaybe<Array<Scalars['ID']>>;
  preferredSpaceCapacity?: InputMaybe<Scalars['Int']>;
};

export type GetSuggestedSpacesForTimeFrameResponse = {
  __typename: 'GetSuggestedSpacesForTimeFrameResponse';
  /** Nullable to force resilience in the face of changing enum values */
  algorithm: Maybe<GetSuggestedSpacesForTimeFrameAlgorithm>;
  suggestedSpaces: Array<Space>;
};

/** Filters for getPaginatedSurveyResponses */
export type GetSurveyResponsesFilters = {
  /** FIlter results by one or more building(s) */
  buildingIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** End of search window */
  inOfficeAtEnd: Scalars['ISODateTime'];
  /** Beginning of search window */
  inOfficeAtStart: Scalars['ISODateTime'];
  /** Include pending, expired, and dismissed survey responses */
  includeIncomplete?: InputMaybe<Scalars['Boolean']>;
  /** Filter results by one or more rating(s) */
  ratings?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Filter resuts by a user ID */
  userId?: InputMaybe<Scalars['String']>;
};

/** Input for sorting survey responses by different keys */
export type GetSurveyResponsesSort = {
  /** The key to sort responses by */
  key: SurveyResponseSortKey;
  /** The order to sort that key */
  order: SortOrder;
};

export type GetTimeZonesForRipplingAddressesInput = {
  addresses: Array<Scalars['String']>;
};

export type GetTimeZonesForRipplingAddressesResponse = {
  __typename: 'GetTimeZonesForRipplingAddressesResponse';
  timezones: Array<GetTimeZonesForRipplingAddressesResponseTimeZone>;
};

export type GetTimeZonesForRipplingAddressesResponseTimeZone = {
  __typename: 'GetTimeZonesForRipplingAddressesResponseTimeZone';
  address: Scalars['String'];
  zone: Maybe<Scalars['String']>;
};

export type GetUpdatePermissionsForEventsResponse = {
  __typename: 'GetUpdatePermissionsForEventsResponse';
  events: Array<Maybe<EventUpdatePermission>>;
};

export type GetVerkadaAccountForCurrentTenant = {
  __typename: 'GetVerkadaAccountForCurrentTenant';
  integrationUuid: Maybe<Scalars['ID']>;
  isHealthy: Scalars['Boolean'];
  unhealthyReasons: Array<Scalars['String']>;
};

export type GetVerkadaDoorsForCurrentTenant = {
  __typename: 'GetVerkadaDoorsForCurrentTenant';
  doors: Array<GetVerkadaDoorsForCurrentTenantLock>;
};

export type GetVerkadaDoorsForCurrentTenantLock = {
  __typename: 'GetVerkadaDoorsForCurrentTenantLock';
  remoteDoorId: Scalars['ID'];
  remoteDoorName: Scalars['String'];
  remotePlaceId: Scalars['String'];
  remotePlaceName: Scalars['String'];
  robinLevelId: Maybe<Scalars['Int']>;
  robinLocationId: Maybe<Scalars['Int']>;
};

/** Useful context to show appropriate waitlist url for an actor. */
export type GetWaitlistForMeContext = {
  /** A flag indicating if current platform is a mobile app */
  isMobile?: InputMaybe<Scalars['Boolean']>;
  /** Location ID of the current context. */
  locationId?: InputMaybe<Scalars['String']>;
};

/** Useful context to show appropriate waitlist url for an actor. */
export type GetWaitlistsForMeContext = {
  /** A flag indicating if current platform is a mobile app */
  isMobile?: InputMaybe<Scalars['Boolean']>;
  /** Location ID of the current context. */
  locationId?: InputMaybe<Scalars['String']>;
};

/** Response wrapper for level-based onsite data queries. */
export type GetWhoIsOnsiteByLevelResponse = {
  __typename: 'GetWhoIsOnsiteByLevelResponse';
  /** Retrieves data for a specific day */
  day: GetWhoIsOnsiteByLocationResponseDay;
  days: Array<GetWhoIsOnsiteByLocationResponseDay>;
  id: Scalars['ID'];
  level: Level;
};


/** Response wrapper for level-based onsite data queries. */
export type GetWhoIsOnsiteByLevelResponseDayArgs = {
  date: Scalars['LocalDate'];
};


/** Response wrapper for level-based onsite data queries. */
export type GetWhoIsOnsiteByLevelResponseDaysArgs = {
  dates: Array<Scalars['LocalDate']>;
};

/** Response wrapper for location-based onsite data queries. */
export type GetWhoIsOnsiteByLocationResponse = {
  __typename: 'GetWhoIsOnsiteByLocationResponse';
  /** Retrieves data for a specific day */
  day: GetWhoIsOnsiteByLocationResponseDay;
  days: Array<GetWhoIsOnsiteByLocationResponseDay>;
  id: Scalars['ID'];
  location: Location;
};


/** Response wrapper for location-based onsite data queries. */
export type GetWhoIsOnsiteByLocationResponseDayArgs = {
  date: Scalars['LocalDate'];
};


/** Response wrapper for location-based onsite data queries. */
export type GetWhoIsOnsiteByLocationResponseDaysArgs = {
  dates: Array<Scalars['LocalDate']>;
};

/** Contains all onsite data for a specific day. */
export type GetWhoIsOnsiteByLocationResponseDay = {
  __typename: 'GetWhoIsOnsiteByLocationResponseDay';
  /** The date in ISO 8601 format (YYYY-MM-DD) in location's time zone. */
  date: Scalars['String'];
  /** The day of the week (e.g., "MONDAY", "TUESDAY") in location's timezone. */
  dayOfWeek: Maybe<DayOfWeek>;
  /** The ID of the day's response. */
  id: Scalars['ID'];
  /** List of onsite entries for this day. Can be ordered and limited based on input parameters. */
  onsites: Array<GetWhoIsOnsiteByLocationResponseDayOnsites>;
  /** Total count of onsite entries for this day excluding the returned onsites */
  remainingOnsitesWithoutResolvedOnsites: Scalars['Int'];
  /** Total anonymous onsites */
  totalAnonymousOnsites: Scalars['Int'];
  /** Total count of onsite entries, which were confirmed locally, for this day */
  totalLocallyConfirmedOnsites: Scalars['Int'];
  /** Total count of onsite entries, which were confirmed locally, for this day which have desk reservations. If there are multiple desk reservations, the count is not additionally incremented. */
  totalLocallyConfirmedOnsitesWithDeskReservations: Scalars['Int'];
  /** Total count of onsite entries for this day */
  totalOnsites: Scalars['Int'];
  /** Total count of onsite entries for this day which have desk reservations. If there are multiple desk reservations, the count is not additionally incremented. */
  totalOnsitesWithDeskReservations: Scalars['Int'];
  /** Total count of onsite entries for this day excluding the current user */
  totalOnsitesWithoutCurrentUser: Scalars['Int'];
  /** Total count of onsite entries, which were confirmed remotely, for this day */
  totalRemotelyConfirmedOnsites: Scalars['Int'];
  /** Total count of onsite entries, which were confirmed remotely, for this day which have desk reservations. If there are multiple desk reservations, the count is not additionally incremented. */
  totalRemotelyConfirmedOnsitesWithDeskReservations: Scalars['Int'];
  /** Total count of onsite entries, which are scheduled for this day */
  totalScheduledOnsites: Scalars['Int'];
  /** Total count of onsite entries, which are scheduled for this day which have desk reservations. If there are multiple desk reservations, the count is not additionally incremented. */
  totalScheduledOnsitesWithDeskReservations: Scalars['Int'];
};


/** Contains all onsite data for a specific day. */
export type GetWhoIsOnsiteByLocationResponseDayOnsitesArgs = {
  departmentQuery?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<OnsitesLimit>;
  offset?: InputMaybe<OnsitesOffset>;
  onsiteTypes?: InputMaybe<Array<OnsiteType>>;
  orderBy?: InputMaybe<Array<GetWhoIsOnsiteByLocationResponseDayOnsitesOrderBy>>;
  query?: InputMaybe<Scalars['String']>;
};

/** Represents a single onsite entry containing user information. */
export type GetWhoIsOnsiteByLocationResponseDayOnsites = {
  __typename: 'GetWhoIsOnsiteByLocationResponseDayOnsites';
  /** The desk reservations for this onsite entry */
  deskReservations: Array<Reservation>;
  /** The ID of the day's response. */
  id: Scalars['ID'];
  /** The method used to set the current onsite status. */
  onsiteConfirmationMethod: OnsiteConfirmationMethod;
  /** The type of onsite entry */
  onsiteType: OnsiteType;
  /** Onsite type set at timestamp. */
  onsiteTypeSetAt: Maybe<Scalars['ISODateTime']>;
  /** The user account information for this onsite entry */
  user: AccountUser;
};

/** Input type for specifying ordering criteria of onsite entries. */
export type GetWhoIsOnsiteByLocationResponseDayOnsitesOrderBy = {
  /** The direction of ordering */
  direction: OrderDirection;
  /** The field to order by */
  field: GetWhoIsOnsiteByLocationResponseDayOnsitesOrderField;
};

/** Available fields for ordering onsite entries. */
export enum GetWhoIsOnsiteByLocationResponseDayOnsitesOrderField {
  /** Order by confirmation status Lowest to highest is "SCHEDULED", "REMOTE_CONFIRMATION", "ON_SITE_CONFIRMATION" */
  CONFIRMATION_STATUS = 'CONFIRMATION_STATUS',
  /** Order by current user */
  CURRENT_USER = 'CURRENT_USER',
  /** Order by whether the user is marked as favorite by the current user */
  IS_MY_FAVORITE = 'IS_MY_FAVORITE',
  /** Order by user name */
  USER_NAME = 'USER_NAME'
}

export type GetZoomRoomsAccountForCurrentTenant = {
  __typename: 'GetZoomRoomsAccountForCurrentTenant';
  integrationUuid: Maybe<Scalars['ID']>;
  isHealthy: Scalars['Boolean'];
};

export type GetZoomRoomsRoomsForCurrentTenant = {
  __typename: 'GetZoomRoomsRoomsForCurrentTenant';
  rooms: Array<GetZoomRoomsRoomsForCurrentTenantRoom>;
};

export type GetZoomRoomsRoomsForCurrentTenantRoom = {
  __typename: 'GetZoomRoomsRoomsForCurrentTenantRoom';
  name: Scalars['String'];
  /** The Robin space this Zoom Room is mapped to, or null if unmapped. */
  robinSpaceId: Maybe<Scalars['Int']>;
  /** The Zoom Room identifier mappings are keyed on, and the value to pass back as roomId in changeZoomRoomsRoomLinks. */
  roomId: Scalars['ID'];
  /** Vendor room status: Offline, Available, InMeeting, or UnderConstruction. Presence is only reported while InMeeting. */
  status: Scalars['String'];
};

export enum GlobalSearchEntityType {
  CUSTOM_RESOURCE = 'CUSTOM_RESOURCE',
  DESK = 'DESK',
  SPACE = 'SPACE',
  USER = 'USER'
}

export type GlobalSearchFilter = {
  /** Structured entity-type selections. A superset of `entityTypes` that also carries the key for dynamic custom-resource types. A frontend may use this field exclusively (including for built-in types) instead of `entityTypes`. */
  entityTypeFilters?: InputMaybe<Array<EntityTypeFilterSelection>>;
  levelIds?: InputMaybe<Array<Scalars['ID']>>;
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** The filters the frontend can offer for a global search, resolved for a single organization. `entityTypes` contains the built-in types (USER/DESK/SPACE) plus one CUSTOM_RESOURCE option per resource category available to the organization; buildings are derived from the indexed locations for the organization. */
export type GlobalSearchFilterOptions = {
  __typename: 'GlobalSearchFilterOptions';
  buildings: Array<BuildingFilterOption>;
  entityTypes: Array<EntityTypeFilterOption>;
};

export type GlobalSearchFilterOptionsInput = {
  organizationId: Scalars['ID'];
};

export type GlobalSearchHit = {
  displayName: Scalars['String'];
  entityId: Scalars['ID'];
  entityType: GlobalSearchEntityType;
  id: Scalars['ID'];
  score: Scalars['Float'];
};

export type GlobalSearchInput = {
  filter?: InputMaybe<GlobalSearchFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['ID'];
  query: Scalars['String'];
};

export type GlobalSearchPagination = {
  __typename: 'GlobalSearchPagination';
  hasNextPage: Scalars['Boolean'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  total: Scalars['Int'];
};

export type GlobalSearchResult = {
  __typename: 'GlobalSearchResult';
  pagination: GlobalSearchPagination;
  results: Array<GlobalSearchHit>;
};

export type GoogleBuilding = {
  __typename: 'GoogleBuilding';
  buildingId: Maybe<Scalars['String']>;
  buildingName: Maybe<Scalars['String']>;
};

/** A device from Google's Meet hardware admin API. An Endpoint implementer. remoteId is the serial, because Meet device ids rotate while a serial is stable; name and vendor are null, because Meet exposes no display name. `id` is the serial for the same reason: Meet's durable catalog is the serial-keyed mapping table, with no surrogate of its own, so the serial is the stable handle. */
export type GoogleMeetDevice = Endpoint & {
  __typename: 'GoogleMeetDevice';
  /** Confidence (0..1) in the mapping, or null when it is unmapped. */
  confidence: Maybe<Scalars['Float']>;
  firstSeenAt: Scalars['DateTime'];
  id: Scalars['ID'];
  lastSeenAt: Scalars['DateTime'];
  /** How the device's current mapping was made, or null when it is unmapped. */
  mappingMethod: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  placement: Maybe<EndpointPlacement>;
  relationships: Array<EndpointRelationship>;
  /** Mirrors serialNumber on this type: the same Meet serial in both fields. The two must not diverge. */
  remoteId: Scalars['String'];
  /** The Robin space this device is mapped to, or null if unmapped. */
  robinSpaceId: Maybe<Scalars['Int']>;
  serialNumber: Scalars['ID'];
  source: EndpointSource;
  vendor: Maybe<Scalars['String']>;
};


/** A device from Google's Meet hardware admin API. An Endpoint implementer. remoteId is the serial, because Meet device ids rotate while a serial is stable; name and vendor are null, because Meet exposes no display name. `id` is the serial for the same reason: Meet's durable catalog is the serial-keyed mapping table, with no surrogate of its own, so the serial is the stable handle. */
export type GoogleMeetDeviceRelationshipsArgs = {
  kinds?: InputMaybe<Array<EndpointRelationshipKind>>;
};

export type GoogleToRobinInput = {
  locationId: Scalars['String'];
  remoteGoogleId?: InputMaybe<Scalars['String']>;
  remoteGoogleLabel?: InputMaybe<Scalars['String']>;
};

export enum GoogleWorkingLocationSourceOfTruth {
  GOOGLE = 'GOOGLE',
  ROBIN = 'ROBIN'
}

export type GoogleWorkingLocationSyncSetting = {
  __typename: 'GoogleWorkingLocationSyncSetting';
  organizationId: Scalars['ID'];
  sourceOfTruth: Maybe<Scalars['String']>;
};

export type Group = {
  __typename: 'Group';
  id: Scalars['ID'];
  /** Whether the group is synced from an external HR system (e.g. Rippling/SCIM). Externally-synced groups can't be managed in Robin. */
  isExternal: Scalars['Boolean'];
  members: Array<User>;
  name: Scalars['String'];
  /** The roles every member of this group inherits. */
  roles: Array<Role>;
  slug: Scalars['String'];
};


export type GroupMembersArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type GroupedResourceSaveUpdateInput = {
  bookingType: WeeklyBookingCommand;
  customResourceInstanceId: Scalars['ID'];
  floorId: Scalars['ID'];
  locationId: Scalars['ID'];
  name: Scalars['String'];
  originatingCustomResourceTemplateId: Scalars['ID'];
  resourceGroupId: Scalars['ID'];
};

export type GroupedUnhealthyCalendarLocation = {
  __typename: 'GroupedUnhealthyCalendarLocation';
  hasMoreUnhealthyCalendars: Scalars['Boolean'];
  locationId: Scalars['ID'];
  locationName: Scalars['String'];
  unhealthyCalendars: Array<UnhealthyCalendar>;
};

export type GroupedUnhealthyCalendarOrg = {
  __typename: 'GroupedUnhealthyCalendarOrg';
  locations: Array<GroupedUnhealthyCalendarLocation>;
  orgId: Scalars['Int'];
  orgName: Scalars['String'];
  orgSlug: Scalars['String'];
};

/** A Guest is someone who was invited to a Visit. A single guest may be invited to multiple Visits, via a GuestInvite that's unique for each visit. */
export type Guest = {
  __typename: 'Guest';
  /** Email address of the guest */
  guestEmail: Scalars['String'];
  /** Name of the guest, ex Jeff Jefferson */
  guestName: Scalars['String'];
  /** Guest unique identifier */
  id: Scalars['ID'];
  /** URL of the guest's image */
  imageURL: Maybe<Scalars['String']>;
  /** Guest personal identity information has been obfuscated */
  isObfuscated: Scalars['Boolean'];
  /** If this guest has been PII obfuscated, it occurred on this date and time */
  obfuscatedOn: Maybe<Scalars['ISODateTime']>;
};

export type GuestInputType = {
  /** Custom fields for the guest */
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  /** Email address of the guest */
  guestEmail?: InputMaybe<Scalars['String']>;
  /** An optional, client-generated ID for this guest's invite record */
  guestInviteId?: InputMaybe<Scalars['ID']>;
  /** Name of the guest, ex Jeff Jefferson */
  guestName: Scalars['String'];
};

/** A GuestInvite is the pairing of a Guest with a particular visit. It contains details about that guest's visit. GuestInvite is unique to the Visit, but a Guest can be associated with multiple Visits as a part of different GuestInvites. */
export type GuestInvite = {
  __typename: 'GuestInvite';
  /** The access credentials for the guest invite */
  accessCredentials: Maybe<GuestInviteAccessCredentials>;
  /** Visit canceled by robin user */
  canceledBy: Maybe<UserWithDefault>;
  /** Date and time of cancelation */
  canceledOn: Maybe<Scalars['ISODateTime']>;
  /** Why the visit was canceled, if specified */
  canceledReason: Maybe<GuestInviteCanceledReason>;
  /** Date and time of the check-in, null if never checked-in */
  checkinOn: Maybe<Scalars['String']>;
  /** Date and time of the checkout, null if never checked-out */
  checkoutOn: Maybe<Scalars['String']>;
  /** The custom fields for the guest invite */
  customFields: Maybe<Array<CustomField>>;
  /** Invited Guest */
  guest: Guest;
  /** Indicates if the guest has access credentials */
  hasAccessCredentials: Maybe<Scalars['Boolean']>;
  /** The health checkpoint survey response associated with the visit */
  healthCheckpointSurveyResponse: Maybe<GenericHealthCheckpointResponse>;
  /** Guest Invite unique identifier */
  id: Scalars['ID'];
  /** The guest's magic link */
  magicLink: Scalars['String'];
  /** Whether email notifications should be sent to the guest */
  shouldSendEmailNotifications: Maybe<Scalars['Boolean']>;
  /** Status of guest invitation */
  status: GuestInviteStatus;
  /** The visit the guest invite is for */
  visit: Maybe<Visit>;
};

export type GuestInviteAccessCredentials = {
  __typename: 'GuestInviteAccessCredentials';
  uuid: Scalars['ID'];
  webCredentialsLink: Scalars['String'];
};

/** Why a guest invite was canceled. */
export enum GuestInviteCanceledReason {
  CANCELED_BY_ADMIN = 'CANCELED_BY_ADMIN',
  FAILED_HEALTH_CHECKPOINT = 'FAILED_HEALTH_CHECKPOINT'
}

/** The user-facing status buckets shown in the visits dashboard, folding the (status, organizerType) derivation the UI does into named values so the status filter can be a flat list that composes as an OR. SELF_REGISTERED is an arrival-display guest still EXPECTED/INVITED; EXPECTED excludes those, so the two are mutually exclusive. */
export enum GuestInviteDisplayStatus {
  CANCELED = 'CANCELED',
  CHECKED_IN = 'CHECKED_IN',
  CHECKED_OUT = 'CHECKED_OUT',
  COMPLETED_REQUIREMENTS = 'COMPLETED_REQUIREMENTS',
  EXPECTED = 'EXPECTED',
  SELF_REGISTERED = 'SELF_REGISTERED'
}

/** Distinct filter-dropdown options for guest invites in a location + date range. */
export type GuestInviteFilterOptions = {
  __typename: 'GuestInviteFilterOptions';
  /** Distinct guest names across the matching guest invites. */
  guestNames: Array<Scalars['String']>;
  /** Distinct hosts across the matching guest invites. */
  hosts: Array<UserWithDefault>;
  /** Distinct custom visit types across the matching guest invites. Includes since-deactivated types still present on visits, which the org's active-types list omits. */
  visitTypes: Array<Scalars['String']>;
};

/** Controls the sort order of guest invites. */
export type GuestInviteOrderBy = {
  field?: InputMaybe<GuestInviteOrderByField>;
  ordinality?: InputMaybe<Ordinality>;
};

/** Fields that guest invites can be sorted by. */
export enum GuestInviteOrderByField {
  /** Sort by the guest's check-in time. Guests who never checked in sort as null. */
  CHECKINON = 'CheckinOn',
  /** Sort by the guest's check-out time. Guests who never checked out sort as null. */
  CHECKOUTON = 'CheckoutOn',
  /** Sort by the guest's name. */
  GUESTNAME = 'GuestName',
  /** Sort by the guest invite status. */
  STATUS = 'Status',
  /** Sort by the start time of the associated visit. */
  VISITSTART = 'VisitStart',
  /** Sort by the visit's custom visit type. */
  VISITTYPE = 'VisitType'
}

export enum GuestInviteStatus {
  CANCELED = 'CANCELED',
  CHECKED_IN = 'CHECKED_IN',
  CHECKED_OUT = 'CHECKED_OUT',
  COMPLETED_REQUIREMENTS = 'COMPLETED_REQUIREMENTS',
  EXPECTED = 'EXPECTED',
  INVITED = 'INVITED',
  PENDING_INVITE = 'PENDING_INVITE'
}

/** A device in trouble as one run observed it, and which organ failed. */
export type HardwareIncident = {
  __typename: 'HardwareIncident';
  /** The endpoint record the incident is about. */
  device: Endpoint;
  kind: HardwareIncidentKind;
  /** When the run observed the incident. */
  observedAt: Scalars['DateTime'];
  peripheral: PeripheralKind;
  /** Where the device sits, or null when the run never placed it. RobinPlace (Campus | Location | Level | Space) rather than Space because a vendor room is not guaranteed to be a room — see EndpointPlacement.place; narrowing to Space would silently drop hardware placed on a Level. */
  place: Maybe<RobinPlace>;
  /** When the incident cleared, or null while it is open. */
  resolvedAt: Maybe<Scalars['DateTime']>;
};

/** What kind of hardware problem an incident observation records. A problem with the box itself is DEVICE_UNAVAILABLE; a problem with one of its organs is PERIPHERAL_DISCONNECTED. The honest boundary: a device that loses power cannot report going missing, so the absence of an incident is not evidence of health, and this feed can never support an uptime percentage. It says what the sources could see fail, not that everything unseen was fine. */
export enum HardwareIncidentKind {
  /** The device itself stopped reporting — offline, unplugged from the network, or powered off. */
  DEVICE_UNAVAILABLE = 'DEVICE_UNAVAILABLE',
  /** One of the device's organs dropped while the box stayed up — a camera, mic, speaker, display or touch controller stopped reporting. */
  PERIPHERAL_DISCONNECTED = 'PERIPHERAL_DISCONNECTED'
}

export type HealthCheckpoint = {
  __typename: 'HealthCheckpoint';
  answeredAt: Maybe<Scalars['String']>;
  customizations: Maybe<Customizations>;
  status: HealthCheckpointStatus;
  surveyId: Maybe<Scalars['String']>;
  surveyUrl: Maybe<Scalars['String']>;
};

export enum HealthCheckpointStatus {
  COMPLETE = 'COMPLETE',
  DISABLED = 'DISABLED',
  EXEMPT = 'EXEMPT',
  FAILED = 'FAILED',
  INCOMPLETE = 'INCOMPLETE',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  PASSED = 'PASSED'
}

/** Health check diagnostics */
export type HealthChecks = {
  __typename: 'HealthChecks';
  tokenExpired: Scalars['Boolean'];
  tokenExpiresAt: Scalars['String'];
};

/** Health status enumeration */
export enum HealthStatus {
  HEALTHY = 'HEALTHY',
  UNHEALTHY = 'UNHEALTHY'
}

export enum HierarchyPermissionAction {
  ASSIGNMENT = 'ASSIGNMENT',
  /** @deprecated Use DELEGATE instead */
  ASSIGNMENT_DELEGATE = 'ASSIGNMENT_DELEGATE',
  BOOK = 'BOOK',
  BYPASS_BOOKING_POLICIES = 'BYPASS_BOOKING_POLICIES',
  DELEGATE = 'DELEGATE',
  MANAGE_OFFICE_AND_MAPS = 'MANAGE_OFFICE_AND_MAPS',
  SKIP_BOOKING_CONFIRMATION = 'SKIP_BOOKING_CONFIRMATION'
}

export type HierarchyPermissionCommand = {
  /** Role IDs to which this permission applies (users) */
  applyPermissionToRoleIds: Array<Scalars['ID']>;
  /** The actions permitted or denied by this permission */
  permissionActions: Array<HierarchyPermissionAction>;
  /** The hierarchical grouping of resources to which this permission applies */
  permissionHierarchyTarget: PermissionHierarchyTarget;
  /** The ID of the hierarchical element that this permission applies */
  permissionHierarchyTargetId: Scalars['ID'];
  /** Whether the specified actions are permitted (true) or explicitly denied (false). */
  permit: Scalars['Boolean'];
  /** ID of the resource category affected by this permission setting */
  resourceCategoryId: Scalars['ID'];
};

export enum HomepageType {
  ANALYTICS = 'ANALYTICS',
  DASHBOARD = 'DASHBOARD',
  DELIVERIES = 'DELIVERIES',
  MEETING_SPACES = 'MEETING_SPACES',
  OFFICE = 'OFFICE',
  PEOPLE = 'PEOPLE',
  SCHEDULE = 'SCHEDULE',
  TICKETS = 'TICKETS',
  VISITORS = 'VISITORS'
}

export type HydratedNeighborhoodResource = Desk;

export type IcalInstanceReference = {
  /** e.g. '20240510T014500Z' */
  recurrenceId?: InputMaybe<Scalars['String']>;
  /** Likely a UUIDv4 but not necessarily */
  uid: Scalars['String'];
};

export enum IconType {
  CRC_LOCKERS = 'CRC_LOCKERS',
  FA_BICYCLE_SOLID = 'FA_BICYCLE_SOLID',
  FA_CAR_SOLID = 'FA_CAR_SOLID',
  FA_CHAIR_SOLID = 'FA_CHAIR_SOLID',
  FA_DUMBBELL_SOLID = 'FA_DUMBBELL_SOLID',
  FA_FLASK_SOLID = 'FA_FLASK_SOLID',
  FA_HAMMER_BRUSH_SOLID = 'FA_HAMMER_BRUSH_SOLID',
  FA_HOUSE_BUILDING_SOLID = 'FA_HOUSE_BUILDING_SOLID',
  FA_LAPTOP_SOLID = 'FA_LAPTOP_SOLID',
  FA_MOBILE_SCREEN_BUTTON_SOLID = 'FA_MOBILE_SCREEN_BUTTON_SOLID',
  FA_PAW_SOLID = 'FA_PAW_SOLID',
  FA_PRINT_SOLID = 'FA_PRINT_SOLID',
  FA_TABLET_SCREEN_BUTTON_SOLID = 'FA_TABLET_SCREEN_BUTTON_SOLID',
  FA_UTENSILS_SOLID = 'FA_UTENSILS_SOLID',
  /** @deprecated No longer supported */
  HAMMER_1 = 'HAMMER_1',
  /** @deprecated No longer supported */
  PROJECTOR_1 = 'PROJECTOR_1',
  /** @deprecated No longer supported */
  ROUNDED_SQUARE_1 = 'ROUNDED_SQUARE_1',
  /** @deprecated No longer supported */
  SQUARE_1 = 'SQUARE_1',
  /** @deprecated No longer supported */
  TABLET_1 = 'TABLET_1',
  /** @deprecated No longer supported */
  TRIANGLE_1 = 'TRIANGLE_1'
}

export type InOfficeData = {
  __typename: 'InOfficeData';
  peopleInTheOffice: Array<User>;
  totalNumberOfPeopleInTheOffice: Scalars['Int'];
};


export type InOfficeDataPeopleInTheOfficeArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  preferredUserIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type InOfficeDataByDay = {
  __typename: 'InOfficeDataByDay';
  date: Scalars['ISODateTime'];
  inOfficeData: InOfficeData;
};

export type InitiateBrivoAccountConnectionForCurrentTenantInput = {
  apiKey: Scalars['String'];
  tenancy: BrivoTenancy;
};

export type InitiateBrivoAccountConnectionForCurrentTenantResponse = {
  __typename: 'InitiateBrivoAccountConnectionForCurrentTenantResponse';
  url: Scalars['String'];
};

export type InitiateFullRipplingUserSyncInput = {
  organizationId: Scalars['ID'];
};

export type InitiateFullRipplingUserSyncResponse = {
  __typename: 'InitiateFullRipplingUserSyncResponse';
  id: Scalars['ID'];
};

export type InitiateRipplingBuildingSyncInput = {
  id: Scalars['ID'];
};

export type InitiateRipplingBuildingSyncResponse = {
  __typename: 'InitiateRipplingBuildingSyncResponse';
  id: Scalars['ID'];
};

export type InitiateRipplingConnectionAndSyncInput = {
  agreeToTosForCurrentActor?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['ID'];
};

export type InitiateRipplingConnectionAndSyncResponse = {
  __typename: 'InitiateRipplingConnectionAndSyncResponse';
  buildingSyncId: Scalars['ID'];
};

export type InitiateRipplingUserSyncInput = {
  organizationId: Scalars['ID'];
};

export type InitiateRipplingUserSyncResponse = {
  __typename: 'InitiateRipplingUserSyncResponse';
  syncId: Scalars['ID'];
};

export type InitiateZoomRoomsAccountConnectionForCurrentTenantInput = {
  /** The Zoom OAuth region for this account. Defaults to ZOOM_US. Use ZOOM_GOV for US government accounts, ZOOM_EU for EU accounts. */
  oauthHost?: InputMaybe<ZoomOAuthHost>;
  /** The tenant ID to initiate the Zoom Rooms account connection for. */
  tenantId: Scalars['ID'];
};

export type InitiateZoomRoomsAccountConnectionForCurrentTenantResponse = {
  __typename: 'InitiateZoomRoomsAccountConnectionForCurrentTenantResponse';
  authorizationUrl: Scalars['String'];
};

export type InsightsAssistantConversationV1 = {
  __typename: 'InsightsAssistantConversationV1';
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  messages: Maybe<Array<InsightsAssistantMessageV1>>;
  organizationId: Scalars['ID'];
  organizationSlug: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userEmail: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type InsightsAssistantConversationV2 = {
  __typename: 'InsightsAssistantConversationV2';
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
  organizationSlug: Maybe<Scalars['String']>;
  threadId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userEmail: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type InsightsAssistantFeedbackInputV1 = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  comment?: InputMaybe<Scalars['String']>;
  rating: FeedbackRating;
};

export type InsightsAssistantFeedbackV1 = {
  __typename: 'InsightsAssistantFeedbackV1';
  categories: Maybe<Array<Scalars['String']>>;
  comment: Maybe<Scalars['String']>;
  conversationId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  messageId: Scalars['ID'];
  rating: FeedbackRating;
  updatedAt: Scalars['DateTime'];
};

export type InsightsAssistantFeedbackV2 = {
  __typename: 'InsightsAssistantFeedbackV2';
  categories: Maybe<Array<Scalars['String']>>;
  comment: Maybe<Scalars['String']>;
  conversationId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  messageId: Scalars['ID'];
  rating: FeedbackRating;
  updatedAt: Scalars['DateTime'];
};

export type InsightsAssistantFeedbackV2Input = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  comment?: InputMaybe<Scalars['String']>;
  rating: FeedbackRating;
};

export type InsightsAssistantMessageV1 = {
  __typename: 'InsightsAssistantMessageV1';
  canceled: Scalars['Boolean'];
  conversationId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  feedback: Maybe<InsightsAssistantFeedbackV1>;
  id: Scalars['ID'];
  parentMessageId: Maybe<Scalars['ID']>;
  source: Scalars['String'];
  text: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type InstantAvailability = {
  __typename: 'InstantAvailability';
  availability: Availability;
  reservation: Maybe<Reservation>;
};

/** Integration error details with provider-specific information */
export type IntegrationError = {
  __typename: 'IntegrationError';
  category: Scalars['String'];
  code: Scalars['String'];
  message: Scalars['String'];
  providerError: Maybe<ProviderError>;
  resolution: ErrorResolution;
};

/** Integration health status details */
export type IntegrationStatus = {
  __typename: 'IntegrationStatus';
  checks: HealthChecks;
  error: Maybe<IntegrationError>;
  health: HealthStatus;
};

export type InternalCategoryPermission = {
  __typename: 'InternalCategoryPermission';
  action: QueryablePermissionAction;
  categoryId: Scalars['ID'];
  id: Scalars['ID'];
  permitted: Scalars['Boolean'];
};

export type InternalPermissionUserOrgActions = {
  __typename: 'InternalPermissionUserOrgActions';
  actions: Array<QueryablePermissionAction>;
  campus: Array<InternalCategoryPermission>;
  group: Array<InternalCategoryPermission>;
  id: Scalars['ID'];
  level: Array<InternalCategoryPermission>;
  location: Array<InternalCategoryPermission>;
  org: Array<InternalCategoryPermission>;
  organizationId: Scalars['ID'];
  resource: Array<InternalResourcePermission>;
  userId: Scalars['ID'];
};

export type InternalResource = {
  __typename: 'InternalResource';
  campusId: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  levelId: Scalars['ID'];
  locationId: Scalars['ID'];
  organizationId: Scalars['ID'];
  resourceCategoryID: Scalars['ID'];
  resourceGroupId: Maybe<Scalars['ID']>;
};

export type InternalResourcePermission = {
  __typename: 'InternalResourcePermission';
  action: QueryablePermissionAction;
  id: Scalars['ID'];
  permitted: Scalars['Boolean'];
};

export type InvalidCidrError = {
  __typename: 'InvalidCidrError';
  cidr: Scalars['IPAddressCIDR'];
  message: Scalars['String'];
};

export type InviteeEvent = {
  __typename: 'InviteeEvent';
  confirmation: Maybe<EventConfirmation>;
  id: Scalars['ID'];
};

export type InviteeFetchFailure = {
  __typename: 'InviteeFetchFailure';
  email: Scalars['String'];
  reason: Scalars['String'];
};

export type InviteeRef = {
  __typename: 'InviteeRef';
  email: Scalars['String'];
  name: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['ID']>;
};

export type IsBrivoIntegrationEnabledForCurrentTenantReponse = {
  __typename: 'IsBrivoIntegrationEnabledForCurrentTenantReponse';
  isEnabled: Scalars['Boolean'];
};

export type IsCsvUploadEnabledForCurrentTenantReponse = {
  __typename: 'IsCSVUploadEnabledForCurrentTenantReponse';
  isEnabled: Scalars['Boolean'];
};

export type IsGallagherIntegrationEnabledForCurrentTenantReponse = {
  __typename: 'IsGallagherIntegrationEnabledForCurrentTenantReponse';
  isEnabled: Scalars['Boolean'];
};

export type IsGeneaIntegrationEnabledForCurrentTenantReponse = {
  __typename: 'IsGeneaIntegrationEnabledForCurrentTenantReponse';
  isEnabled: Scalars['Boolean'];
};

export type IsGenetecIntegrationEnabledForCurrentTenantReponse = {
  __typename: 'IsGenetecIntegrationEnabledForCurrentTenantReponse';
  isEnabled: Scalars['Boolean'];
};

export type IsGoogleIntegrationEnabledForCurrentTenantReponse = {
  __typename: 'IsGoogleIntegrationEnabledForCurrentTenantReponse';
  isEnabled: Scalars['Boolean'];
};

export type IsKisiIntegrationEnabledForCurrentTenantReponse = {
  __typename: 'IsKisiIntegrationEnabledForCurrentTenantReponse';
  isEnabled: Scalars['Boolean'];
};

export type IsLogiSyncIntegrationEnabledForCurrentTenantReponse = {
  __typename: 'IsLogiSyncIntegrationEnabledForCurrentTenantReponse';
  isEnabled: Scalars['Boolean'];
};

export type IsNeatPulseIntegrationEnabledForCurrentTenantReponse = {
  __typename: 'IsNeatPulseIntegrationEnabledForCurrentTenantReponse';
  isEnabled: Scalars['Boolean'];
};

export type IsOpenpathIntegrationEnabledForCurrentTenantReponse = {
  __typename: 'IsOpenpathIntegrationEnabledForCurrentTenantReponse';
  isEnabled: Scalars['Boolean'];
};

export type IsOpenpathLockProvisioningEnabledForCurrentTenantResponse = {
  __typename: 'IsOpenpathLockProvisioningEnabledForCurrentTenantResponse';
  isEnabled: Scalars['Boolean'];
};

export type IsPassiveCheckInFeatureEnabledForBuildingInput = {
  buildingId: Scalars['ID'];
};

export type IsVerkadaIntegrationEnabledForCurrentTenantReponse = {
  __typename: 'IsVerkadaIntegrationEnabledForCurrentTenantReponse';
  isEnabled: Scalars['Boolean'];
};

export type IsZoomRoomsIntegrationEnabledForCurrentTenantReponse = {
  __typename: 'IsZoomRoomsIntegrationEnabledForCurrentTenantReponse';
  isEnabled: Scalars['Boolean'];
};

export type IssueReport = Ticket & {
  __typename: 'IssueReport';
  /** Can be null if nobody is assigned */
  assignees: Maybe<UsersAndGroups>;
  category: IssueReportCategory;
  /** Null when the report was created without answering any form questions */
  completedForm: Maybe<CompletedTicketForm>;
  createdAt: Scalars['ISODateTime'];
  /** The reporter's full description of the issue */
  description: EtaggedString;
  id: Scalars['ID'];
  /** Image-service URLs for photos of the issue, in the order they display. Empty when the report has no photos. Legacy - superseded by the form API when issue reports gain custom forms, and deprecated then. */
  imageUrls: EtaggedStringList;
  issueReportStatus: IssueReportStatus;
  key: Scalars['String'];
  /** The ID of the latest change to this issue report. Every time the issue report is changed, this ID will change. Could be used for concurrency control in the future. */
  latestChangeId: Scalars['ID'];
  originProduct: TicketOriginProduct;
  priority: TicketPriority;
  /** The entity (space, desk, ...) that this issue report regards */
  regardsEntity: TicketRegardsEntity;
  /** The user who reported the issue. Null if that user was deleted. */
  requester: Maybe<User>;
  /** A short human-readable summary of the issue, suitable for a table row or subject line */
  title: Scalars['String'];
  updatedAt: Scalars['ISODateTime'];
};

/** A workflow category for issue report workflows, e.g. 'Facilities' */
export type IssueReportCategory = WorkflowCategory & {
  __typename: 'IssueReportCategory';
  id: Scalars['ID'];
  /** 'ISSUE' in ticket keys like 'ISSUE-123' */
  key: Scalars['String'];
  name: Scalars['String'];
};

/** The lifecycle status of an issue report. A subset of the statuses used by other kinds of tickets - issue reports have no approval flow, so there is no NEEDS_APPROVAL or REJECTED. */
export enum IssueReportStatus {
  BLOCKED = 'BLOCKED',
  /** The report was closed without fixing the issue, e.g. duplicate or invalid reports */
  CANCELLED = 'CANCELLED',
  /** The issue was fixed */
  DONE = 'DONE',
  IN_PROGRESS = 'IN_PROGRESS',
  /** Reported, but nobody has started working on it */
  TODO = 'TODO'
}

export type JiraIntegration = TicketIntegration & {
  __typename: 'JiraIntegration';
  baseUrl: Maybe<Scalars['String']>;
  cloudId: Maybe<Scalars['String']>;
  createdAt: Scalars['ISODateTime'];
  /** When the integration stopped after its provider kept refusing its credentials; set only for DEACTIVATED. */
  deactivatedAt: Maybe<Scalars['ISODateTime']>;
  id: Scalars['ID'];
  /** @deprecated Use status. */
  isActive: Scalars['Boolean'];
  providerType: TicketProviderType;
  status: TicketIntegrationStatus;
  /** Which directions sync runs in; each can be switched off without disconnecting. */
  syncDirections: TicketIntegrationSyncDirections;
};

export type LayoutChangeEntity = {
  __typename: 'LayoutChangeEntity';
  id: Scalars['ID'];
  name: Maybe<Scalars['String']>;
  operation: LayoutParcelOperation;
  parcel: Maybe<LayoutParcel>;
};

export type LayoutDraftInput = {
  levelId: Scalars['ID'];
  name: Scalars['String'];
  organizationId: Scalars['ID'];
};

export type LayoutParcel = {
  __typename: 'LayoutParcel';
  geometry: Maybe<Geometry>;
  properties: Maybe<CustomResourceInstance>;
};

export type LayoutParcelInput = {
  geometry: GeometryInput;
  properties?: InputMaybe<CustomResourceInstanceInput>;
};

export enum LayoutParcelOperation {
  DELETE_RESOURCE = 'delete_resource',
  UPSERT_RESOURCE = 'upsert_resource',
  UPSERT_RESOURCE_GROUP = 'upsert_resource_group'
}

export type LayoutResourceGroupEntity = {
  __typename: 'LayoutResourceGroupEntity';
  amenityIds: Maybe<Array<Scalars['ID']>>;
  bookingType: Maybe<ResourceWeeklyBookingType>;
  capacity: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isAccessible: Maybe<Scalars['Boolean']>;
  name: Maybe<Scalars['String']>;
  note: Maybe<Scalars['String']>;
  operation: LayoutParcelOperation;
  policies: Maybe<ResourcePolicy>;
  subCategory: Maybe<Scalars['String']>;
};

export type LayoutResourcePolicyDurationInput = {
  type?: InputMaybe<LayoutResourcePolicyDurationType>;
  value: Scalars['Int'];
};

export enum LayoutResourcePolicyDurationType {
  DAYS = 'days',
  HOURS = 'hours',
  MINUTES = 'minutes',
  MONTHS = 'months',
  WEEKS = 'weeks',
  YEARS = 'years'
}

export type LayoutResourcePolicyEnabledWithDurationInput = {
  duration?: InputMaybe<LayoutResourcePolicyDurationInput>;
  enabled: Scalars['Boolean'];
};

export type LayoutResourcePolicyInput = {
  abandonedResourceProtection?: InputMaybe<LayoutResourcePolicyEnabledWithDurationInput>;
  advanceCheckInWindow?: InputMaybe<LayoutResourcePolicyEnabledWithDurationInput>;
  advancedBookingThreshold?: InputMaybe<LayoutResourcePolicyEnabledWithDurationInput>;
  allowOverlappingBookings?: InputMaybe<Scalars['Boolean']>;
  localCheckInOnly?: InputMaybe<Scalars['Boolean']>;
  maxBookingLength?: InputMaybe<LayoutResourcePolicyEnabledWithDurationInput>;
  requireCheckIn?: InputMaybe<Scalars['Boolean']>;
  resourceSharing?: InputMaybe<Scalars['Boolean']>;
  restrictBookingToWorkingHours?: InputMaybe<Scalars['Boolean']>;
};

export type LegacyIntegration = {
  __typename: 'LegacyIntegration';
  configuration: Scalars['Json'];
  createdAt: Scalars['String'];
  externalAccountId: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  organizationId: Scalars['Int'];
  resourceType: LegacyIntegrationResourceType;
  state: Scalars['String'];
  type: LegacyIntegrationType;
  updatedAt: Scalars['String'];
  user: User;
  userId: Scalars['Int'];
};

export enum LegacyIntegrationResourceType {
  CALENDAR = 'CALENDAR',
  EVENT = 'EVENT',
  NOTIFICATION = 'NOTIFICATION'
}

export enum LegacyIntegrationType {
  BLUEJEANS = 'BLUEJEANS',
  BLUEJEANS_RELAY = 'BLUEJEANS_RELAY',
  SLACK = 'SLACK',
  TEAMS = 'TEAMS',
  ZOOM = 'ZOOM'
}

export type Level = {
  __typename: 'Level';
  /** Total desks on the floor - excluding inactive. */
  activeDeskCount: Scalars['Int'];
  availableDeskAmenities: Array<MinimizedAmenityViewModel>;
  availableSpaceAmenities: Array<MinimizedAmenityViewModel>;
  campusId: Maybe<Scalars['ID']>;
  createdAt: Maybe<Scalars['Date']>;
  /** Published custom resources on this floor. Null when the request carries no tenant; empty when the floor has none or the level belongs to another organization. */
  customResources: Maybe<Array<CustomResource>>;
  /** Total desks on the floor - including inactive. */
  deskCount: Scalars['Int'];
  /** Total desks within the level that fit within various scheduling type and status buckets */
  deskSchedulingAggregates: SchedulingAggregateOfDesks;
  desks: Array<Desk>;
  filteredDesksByAmenityIds: Array<Desk>;
  filteredSpacesByAmenityIds: Array<Space>;
  id: Scalars['ID'];
  levelLocation: Maybe<LevelLocation>;
  levelNumber: Maybe<Scalars['Int']>;
  locationId: Scalars['ID'];
  /** check whether the level has a map or not */
  mapIsAvailable: Maybe<Scalars['Boolean']>;
  mapUploadStatus: Maybe<MapUploadStatus>;
  maxCapacity: Scalars['Int'];
  name: Scalars['String'];
  neighborhoods: Array<Neighborhood>;
  organizationId: Scalars['ID'];
  spaces: Array<Space>;
  state: LevelState;
  timezone: Maybe<Scalars['String']>;
  /** @deprecated Use `activeDeskCount` instead */
  totalDesks: Scalars['Int'];
  /** total spaces will be contextual to the filter */
  totalSpaces: Scalars['Int'];
  updatedAt: Maybe<Scalars['Date']>;
  /** Stable identifier from robin-api, as 32 lowercase hex characters. */
  uuid: Scalars['ID'];
  workAreas: Array<WorkArea>;
  /** Total desks within the location where booked counts are bound to the current workday and the configured hours of operation for the location */
  workplaceDeskSchedulingAggregates: BookedSchedulingAggregateOfDesks;
  zones: Array<Zone>;
};


export type LevelDesksArgs = {
  filters?: InputMaybe<Array<DeskFilters>>;
};


export type LevelFilteredDesksByAmenityIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type LevelFilteredSpacesByAmenityIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type LevelSpacesArgs = {
  filters?: InputMaybe<Array<SpaceFilters>>;
};


export type LevelStateArgs = {
  endTime: Scalars['Date'];
  evaluations?: InputMaybe<Evaluations>;
  recurrence?: InputMaybe<Scalars['String']>;
  startTime: Scalars['Date'];
};


export type LevelTotalSpacesArgs = {
  filters?: InputMaybe<Array<SpaceFilters>>;
};

export type LevelDeskReservation = {
  __typename: 'LevelDeskReservation';
  levelId: Scalars['ID'];
  reservations: Array<Reservation>;
};

export type LevelLocation = {
  __typename: 'LevelLocation';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type LevelState = {
  __typename: 'LevelState';
  availability: PlaceAvailability;
  freeCapacity: Scalars['Int'];
};

export enum LimitStrategy {
  ADAPTIVE = 'ADAPTIVE',
  FIXED = 'FIXED'
}

export type LinkKisiLockToRobinLocationInput = {
  remoteLockId: Scalars['String'];
  robinLocationId: Scalars['Int'];
};

export type LinkKisiLockToRobinLocationResponse = {
  __typename: 'LinkKisiLockToRobinLocationResponse';
  uuid: Maybe<Scalars['ID']>;
};

export type ListBuildingCidrsInput = {
  buildingId: Scalars['ID'];
};

export type ListBuildingCidrsResponse = {
  __typename: 'ListBuildingCidrsResponse';
  cidrs: Array<Scalars['IPAddressCIDR']>;
};

export type ListBuildingsWhereUserCanManageMeetingServicesResponse = {
  __typename: 'ListBuildingsWhereUserCanManageMeetingServicesResponse';
  buildings: Array<Maybe<Location>>;
};

export type ListIssueReportsFiltersInput = {
  belongsToAnyCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  createdAtBetween?: InputMaybe<TimeRangeInput>;
  /** userIds match filter transitively through group membership */
  hasAnyAssignee?: InputMaybe<UsersAndGroupsInput>;
  hasAnyOriginProduct?: InputMaybe<Array<TicketOriginProduct>>;
  hasAnyPriority?: InputMaybe<Array<TicketPriority>>;
  hasAnyRequesterUserId?: InputMaybe<Array<Scalars['ID']>>;
  hasAnyStatus?: InputMaybe<Array<IssueReportStatus>>;
  /** 'ISSUE' matches 'ISSUE-123', 'ISSUE-456', but not 'ISSUES-123'. 'ISSUE-123' matches 'ISSUE-123' but not 'ISSUE-1234'. '123' matches 'ISSUE-123', 'DESK-123', but not 'ISSUE-1234'. */
  keyMatches?: InputMaybe<Scalars['String']>;
  regardingAnyBuildingIdsOrTheirDescendants?: InputMaybe<Array<Scalars['ID']>>;
  /** A null entry matches reports regarding an entity on no floor */
  regardingAnyFloorIdsOrTheirDescendants?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Match reports regarding any of these specific entities */
  regardsAnyEntities?: InputMaybe<Array<TicketEntityInput>>;
};

export type ListIssueReportsInput = {
  /** If after is provided, we only return results that come after the previous result set */
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ListIssueReportsFiltersInput>;
  /** Return only the first N results */
  first: Scalars['Int'];
  /** Skip N results, e.g. if you need to jump more than one page ahead. This stacks on top of `after` if provided. Avoid use if possible - prefer using `after` alone. */
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: ListIssueReportsSortByInput;
};

export type ListIssueReportsResponse = {
  __typename: 'ListIssueReportsResponse';
  forwardPageInfo: ForwardPageInfo;
  issueReports: Array<IssueReport>;
};

export enum ListIssueReportsSortByCriteria {
  CREATED_AT = 'CREATED_AT',
  KEY = 'KEY',
  PRIORITY = 'PRIORITY',
  STATUS = 'STATUS',
  UPDATED_AT = 'UPDATED_AT'
}

export type ListIssueReportsSortByInput = {
  criteria: ListIssueReportsSortByCriteria;
  order: SortOrder;
};

export type ListMeetingServiceRequestsFiltersInput = {
  eventStartTimeBetween?: InputMaybe<TimeRangeInput>;
  /** userIds match filter transitively through group membership */
  hasAnyApprover?: InputMaybe<UsersAndGroupsInput>;
  /** userIds match filter transitively through group membership */
  hasAnyAssignee?: InputMaybe<UsersAndGroupsInput>;
  hasAnyRequesterUserId?: InputMaybe<Array<Scalars['ID']>>;
  hasAnyStatus?: InputMaybe<Array<MeetingServiceRequestStatus>>;
  /** 'CAT' matches 'CAT-123', 'CAT-456', but not 'CATS-123'. 'CAT-123' matches 'CAT-123' but not 'CAT-1234'. '123' matches 'CAT-123', 'DOG-123', but not 'CAT-1234'. */
  keyMatches?: InputMaybe<Scalars['String']>;
  regardingAnyBuildingIdsOrTheirDescendants?: InputMaybe<Array<Scalars['ID']>>;
  regardingAnySpaceIds?: InputMaybe<Array<Scalars['ID']>>;
  serviceBelongsToAnyCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  serviceHasAnyId?: InputMaybe<Array<Scalars['ID']>>;
};

export type ListMeetingServiceRequestsInput = {
  /** If after is provided, we only return results that come after the previous result set */
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ListMeetingServiceRequestsFiltersInput>;
  /** Return only the first N results */
  first: Scalars['Int'];
  /** Skip N results, e.g. if you need to jump more than one page ahead. This stacks on top of `after` if provided. Avoid use if possible - prefer using `after` alone. */
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: ListMeetingServiceRequestsSortByInput;
};

export type ListMeetingServiceRequestsResponse = {
  __typename: 'ListMeetingServiceRequestsResponse';
  forwardPageInfo: ForwardPageInfo;
  meetingServiceRequests: Array<MeetingServiceRequest>;
};

export enum ListMeetingServiceRequestsSortByCriteria {
  CREATED_AT = 'CREATED_AT',
  EVENT_START_TIME = 'EVENT_START_TIME',
  KEY = 'KEY',
  SERVICE_CATEGORY_NAME = 'SERVICE_CATEGORY_NAME',
  SERVICE_NAME = 'SERVICE_NAME',
  STATUS = 'STATUS',
  UPDATED_AT = 'UPDATED_AT'
}

export type ListMeetingServiceRequestsSortByInput = {
  criteria: ListMeetingServiceRequestsSortByCriteria;
  order: SortOrder;
};

export type ListMeetingServicesAvailableInSpaceFiltersInput = {
  spaceId: Scalars['ID'];
};

export type ListMeetingServicesAvailableInSpaceInput = {
  /** If after is provided, we only return results that come after the previous result set */
  after?: InputMaybe<Scalars['String']>;
  filters: ListMeetingServicesAvailableInSpaceFiltersInput;
  /** Return only the first N results */
  first: Scalars['Int'];
};

export type ListMeetingServicesAvailableInSpaceResponse = {
  __typename: 'ListMeetingServicesAvailableInSpaceResponse';
  forwardPageInfo: ForwardPageInfo;
  meetingServices: Array<MeetingService>;
};

export type ListMeetingServicesCategoriesFiltersInput = {
  hasServicesAvailableInBuildingIds?: InputMaybe<Array<Scalars['ID']>>;
  nameContainsString?: InputMaybe<Scalars['String']>;
};

export type ListMeetingServicesCategoriesInput = {
  /** If after is provided, we only return results that come after the previous result set */
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ListMeetingServicesCategoriesFiltersInput>;
  /** Return only the first N results */
  first: Scalars['Int'];
  /** Skip N results, e.g. if you need to jump more than one page ahead. This stacks on top of `after` if provided. Avoid use if possible - prefer using `after` alone. */
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: ListMeetingServicesCategoriesSortByInput;
};

export type ListMeetingServicesCategoriesResponse = {
  __typename: 'ListMeetingServicesCategoriesResponse';
  forwardPageInfo: ForwardPageInfo;
  meetingServicesCategories: Array<MeetingServicesCategory>;
};

export enum ListMeetingServicesCategoriesSortByCriteria {
  KEY = 'KEY',
  NAME = 'NAME'
}

export type ListMeetingServicesCategoriesSortByInput = {
  criteria: ListMeetingServicesCategoriesSortByCriteria;
  order: SortOrder;
};

export type ListMeetingServicesFiltersInput = {
  /** userIds match filter transitively through group membership */
  assignedToAny?: InputMaybe<UsersAndGroupsInput>;
  availableInAnyBuildingIdsOrTheirDescendants?: InputMaybe<Array<Scalars['ID']>>;
  belongsToAnyCategoryId?: InputMaybe<Array<Scalars['ID']>>;
  nameContainsString?: InputMaybe<Scalars['String']>;
};

export type ListMeetingServicesInput = {
  /** If after is provided, we only return results that come after the previous result set */
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ListMeetingServicesFiltersInput>;
  /** Return only the first N results */
  first: Scalars['Int'];
  /** Skip N results, e.g. if you need to jump more than one page ahead. This stacks on top of `after` if provided. Avoid use if possible - prefer using `after` alone. */
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: ListMeetingServicesSortByInput;
};

export type ListMeetingServicesResponse = {
  __typename: 'ListMeetingServicesResponse';
  forwardPageInfo: ForwardPageInfo;
  meetingServices: Array<MeetingService>;
};

export enum ListMeetingServicesSortByCriteria {
  CATEGORY_NAME = 'CATEGORY_NAME',
  SERVICE_NAME = 'SERVICE_NAME',
  UPDATED_AT = 'UPDATED_AT'
}

export type ListMeetingServicesSortByInput = {
  criteria: ListMeetingServicesSortByCriteria;
  order: SortOrder;
};

export enum ListTicketIntegrationAvailableTargetsErrorReason {
  NOT_ACTIVE = 'NOT_ACTIVE',
  NOT_FOUND = 'NOT_FOUND',
  PROVIDER_CAPABILITY_MISSING = 'PROVIDER_CAPABILITY_MISSING'
}

export type ListTicketIntegrationAvailableTargetsErrorResponse = {
  __typename: 'ListTicketIntegrationAvailableTargetsErrorResponse';
  reason: ListTicketIntegrationAvailableTargetsErrorReason;
};

export type ListTicketIntegrationAvailableTargetsResponse = ListTicketIntegrationAvailableTargetsErrorResponse | ListTicketIntegrationAvailableTargetsSuccessResponse;

export type ListTicketIntegrationAvailableTargetsSuccessResponse = {
  __typename: 'ListTicketIntegrationAvailableTargetsSuccessResponse';
  /** Matching Jira project issue types left out because `includeJiraProjects` is false. */
  hiddenJiraProjectTargetCount: Scalars['Int'];
  targetImport: TicketIntegrationTargetImport;
  targets: Array<TicketIntegrationAvailableTarget>;
  /** True when more targets match than are returned — narrow with `search`. */
  truncated: Scalars['Boolean'];
};

export type ListTicketIntegrationEntityMappingsResponse = {
  __typename: 'ListTicketIntegrationEntityMappingsResponse';
  entityMappings: Array<TicketIntegrationEntityMapping>;
  forwardPageInfo: ForwardPageInfo;
};

export enum ListTicketIntegrationExternalObjectClassesErrorReason {
  NOT_ACTIVE = 'NOT_ACTIVE',
  NOT_CONNECTED = 'NOT_CONNECTED',
  NOT_FOUND = 'NOT_FOUND',
  /** The provider has one fixed create target and no external object classes to choose from (ServiceNow, Zendesk). */
  PROVIDER_CAPABILITY_MISSING = 'PROVIDER_CAPABILITY_MISSING',
  /** The provider was reached and refused the request (auth/permissions) — check the connection's access, not the network. */
  PROVIDER_REJECTED = 'PROVIDER_REJECTED',
  PROVIDER_UNREACHABLE = 'PROVIDER_UNREACHABLE'
}

export type ListTicketIntegrationExternalObjectClassesErrorResponse = {
  __typename: 'ListTicketIntegrationExternalObjectClassesErrorResponse';
  reason: ListTicketIntegrationExternalObjectClassesErrorReason;
};

export type ListTicketIntegrationExternalObjectClassesResponse = ListTicketIntegrationExternalObjectClassesErrorResponse | ListTicketIntegrationExternalObjectClassesSuccessResponse;

export type ListTicketIntegrationExternalObjectClassesSuccessResponse = {
  __typename: 'ListTicketIntegrationExternalObjectClassesSuccessResponse';
  externalObjectClasses: Array<TicketIntegrationExternalObjectClass>;
};

/** This field returns `NOT_FOUND`, or `NOT_ACTIVE` for an integration that is pending or deactivated. The rest remain in the enum so existing clients keep compiling: this path makes no provider call. */
export enum ListTicketIntegrationExternalObjectsErrorReason {
  NOT_ACTIVE = 'NOT_ACTIVE',
  NOT_CONNECTED = 'NOT_CONNECTED',
  NOT_FOUND = 'NOT_FOUND',
  /** The provider has no representation for external objects on this plan/config (text-only tier). */
  PROVIDER_CAPABILITY_MISSING = 'PROVIDER_CAPABILITY_MISSING',
  /** The provider was reached and refused the request (auth/permissions) — check the connection's access, not the network. */
  PROVIDER_REJECTED = 'PROVIDER_REJECTED',
  PROVIDER_UNREACHABLE = 'PROVIDER_UNREACHABLE'
}

export type ListTicketIntegrationExternalObjectsErrorResponse = {
  __typename: 'ListTicketIntegrationExternalObjectsErrorResponse';
  reason: ListTicketIntegrationExternalObjectsErrorReason;
};

export type ListTicketIntegrationExternalObjectsResponse = ListTicketIntegrationExternalObjectsErrorResponse | ListTicketIntegrationExternalObjectsSuccessResponse;

export type ListTicketIntegrationExternalObjectsSuccessResponse = {
  __typename: 'ListTicketIntegrationExternalObjectsSuccessResponse';
  externalObjects: Array<TicketIntegrationExternalObject>;
  forwardPageInfo: ForwardPageInfo;
  /** The most recent object import, or null when none has ever run for this integration. An empty `externalObjects` with a null `objectImportStatus` means nothing has been imported yet, not that the provider is empty — and an integration with no object-class assignments always reads empty, because an unfiltered read is restricted to the classes that carry one. Also null for a caller without `places:manage`, which is the permission `ticketIntegrationObjectImportStatus` requires for the same object. */
  objectImportStatus: Maybe<TicketIntegrationObjectImportStatus>;
  /** True when the fetch behind this data hit a provider cap before exhausting the tree, so the store is a prefix of the estate. Set while a capped fetch is still running, and a prior full fetch's cap is never cleared by a later class-scoped run. Narrow with `search`/`seedNames`. Integration-wide, not scoped to `classIds`: a run records one flag for the whole fetch, so a class that fetched clean still reports `true` when another class capped. Read `forwardPageInfo.hasNextPage` for "more rows behind this response" — that is a separate question from whether the store is complete. */
  truncated: Scalars['Boolean'];
};

export enum ListTicketIntegrationFieldMappingsErrorReason {
  NOT_ACTIVE = 'NOT_ACTIVE',
  NOT_FOUND = 'NOT_FOUND',
  TARGET_CONFIG_NOT_FOUND = 'TARGET_CONFIG_NOT_FOUND',
  WORKFLOW_NOT_FOUND = 'WORKFLOW_NOT_FOUND'
}

export type ListTicketIntegrationFieldMappingsErrorResponse = {
  __typename: 'ListTicketIntegrationFieldMappingsErrorResponse';
  reason: ListTicketIntegrationFieldMappingsErrorReason;
};

export type ListTicketIntegrationFieldMappingsResponse = ListTicketIntegrationFieldMappingsErrorResponse | ListTicketIntegrationFieldMappingsSuccessResponse;

export type ListTicketIntegrationFieldMappingsSuccessResponse = {
  __typename: 'ListTicketIntegrationFieldMappingsSuccessResponse';
  fieldMappings: Array<TicketIntegrationFieldMapping>;
};

export enum ListTicketIntegrationSourceFieldsErrorReason {
  NOT_ACTIVE = 'NOT_ACTIVE',
  NOT_FOUND = 'NOT_FOUND',
  WORKFLOW_NOT_FOUND = 'WORKFLOW_NOT_FOUND'
}

export type ListTicketIntegrationSourceFieldsErrorResponse = {
  __typename: 'ListTicketIntegrationSourceFieldsErrorResponse';
  reason: ListTicketIntegrationSourceFieldsErrorReason;
};

export type ListTicketIntegrationSourceFieldsResponse = ListTicketIntegrationSourceFieldsErrorResponse | ListTicketIntegrationSourceFieldsSuccessResponse;

export type ListTicketIntegrationSourceFieldsSuccessResponse = {
  __typename: 'ListTicketIntegrationSourceFieldsSuccessResponse';
  sourceFields: Array<TicketIntegrationSourceField>;
};

export enum ListTicketIntegrationTargetConfigsErrorReason {
  NOT_ACTIVE = 'NOT_ACTIVE',
  NOT_FOUND = 'NOT_FOUND'
}

export type ListTicketIntegrationTargetConfigsErrorResponse = {
  __typename: 'ListTicketIntegrationTargetConfigsErrorResponse';
  reason: ListTicketIntegrationTargetConfigsErrorReason;
};

export type ListTicketIntegrationTargetConfigsResponse = ListTicketIntegrationTargetConfigsErrorResponse | ListTicketIntegrationTargetConfigsSuccessResponse;

export type ListTicketIntegrationTargetConfigsSuccessResponse = {
  __typename: 'ListTicketIntegrationTargetConfigsSuccessResponse';
  targetConfigs: Array<TicketIntegrationTargetConfig>;
};

export enum ListTicketIntegrationTargetFieldsErrorReason {
  NOT_ACTIVE = 'NOT_ACTIVE',
  NOT_CONNECTED = 'NOT_CONNECTED',
  NOT_FOUND = 'NOT_FOUND',
  /** The provider exposes no enumerable ticket fields on this plan/config. */
  PROVIDER_CAPABILITY_MISSING = 'PROVIDER_CAPABILITY_MISSING',
  PROVIDER_REJECTED = 'PROVIDER_REJECTED',
  PROVIDER_UNREACHABLE = 'PROVIDER_UNREACHABLE',
  TARGET_CONFIG_NOT_FOUND = 'TARGET_CONFIG_NOT_FOUND'
}

export type ListTicketIntegrationTargetFieldsErrorResponse = {
  __typename: 'ListTicketIntegrationTargetFieldsErrorResponse';
  reason: ListTicketIntegrationTargetFieldsErrorReason;
};

export type ListTicketIntegrationTargetFieldsResponse = ListTicketIntegrationTargetFieldsErrorResponse | ListTicketIntegrationTargetFieldsSuccessResponse;

export type ListTicketIntegrationTargetFieldsSuccessResponse = {
  __typename: 'ListTicketIntegrationTargetFieldsSuccessResponse';
  targetFields: Array<TicketIntegrationTargetField>;
  /** True when the provider fetch hit its time budget — narrow with `search`. */
  truncated: Scalars['Boolean'];
};

export enum ListTicketIntegrationTransitionFieldsErrorReason {
  NOT_ACTIVE = 'NOT_ACTIVE',
  NOT_CONNECTED = 'NOT_CONNECTED',
  NOT_FOUND = 'NOT_FOUND',
  /** The provider has no workflow configuration to read. */
  PROVIDER_CAPABILITY_MISSING = 'PROVIDER_CAPABILITY_MISSING',
  /** Includes a connection not granted by a Jira administrator: reconnect as one. */
  PROVIDER_REJECTED = 'PROVIDER_REJECTED',
  PROVIDER_UNREACHABLE = 'PROVIDER_UNREACHABLE',
  TARGET_CONFIG_NOT_FOUND = 'TARGET_CONFIG_NOT_FOUND'
}

export type ListTicketIntegrationTransitionFieldsErrorResponse = {
  __typename: 'ListTicketIntegrationTransitionFieldsErrorResponse';
  reason: ListTicketIntegrationTransitionFieldsErrorReason;
};

export type ListTicketIntegrationTransitionFieldsResponse = ListTicketIntegrationTransitionFieldsErrorResponse | ListTicketIntegrationTransitionFieldsSuccessResponse;

export type ListTicketIntegrationTransitionFieldsSuccessResponse = {
  __typename: 'ListTicketIntegrationTransitionFieldsSuccessResponse';
  transitions: Array<TicketIntegrationTransition>;
};

export type ListTicketIntegrationUnmappedEntitiesResponse = {
  __typename: 'ListTicketIntegrationUnmappedEntitiesResponse';
  forwardPageInfo: ForwardPageInfo;
  unmappedEntities: Array<TicketIntegrationUnmappedEntity>;
};

export enum ListTicketIntegrationWorkflowBindingsErrorReason {
  NOT_ACTIVE = 'NOT_ACTIVE',
  NOT_FOUND = 'NOT_FOUND'
}

export type ListTicketIntegrationWorkflowBindingsErrorResponse = {
  __typename: 'ListTicketIntegrationWorkflowBindingsErrorResponse';
  reason: ListTicketIntegrationWorkflowBindingsErrorReason;
};

export type ListTicketIntegrationWorkflowBindingsResponse = ListTicketIntegrationWorkflowBindingsErrorResponse | ListTicketIntegrationWorkflowBindingsSuccessResponse;

export type ListTicketIntegrationWorkflowBindingsSuccessResponse = {
  __typename: 'ListTicketIntegrationWorkflowBindingsSuccessResponse';
  workflowBindings: Array<TicketIntegrationWorkflowBinding>;
};

export type ListUniqueAssigneesForMeetingServicesFiltersInput = {
  serviceAvailableInAnyBuildingIdsOrTheirDescendants?: InputMaybe<Array<Scalars['ID']>>;
};

export type ListUniqueAssigneesForMeetingServicesInput = {
  /** If after is provided, we only return results that come after the previous result set */
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ListUniqueAssigneesForMeetingServicesFiltersInput>;
  /** Return only the first N results */
  first: Scalars['Int'];
};

export type ListUniqueAssigneesForMeetingServicesResponse = {
  __typename: 'ListUniqueAssigneesForMeetingServicesResponse';
  forwardPageInfo: ForwardPageInfo;
  uniqueAssignees: Array<Maybe<UserOrGroupUnion>>;
};

export type ListUniqueIssueReportValuesFiltersInput = {
  createdAtBetween?: InputMaybe<TimeRangeInput>;
  regardingAnyBuildingIdsOrTheirDescendants?: InputMaybe<Array<Scalars['ID']>>;
  /** A null entry matches reports regarding an entity on no floor */
  regardingAnyFloorIdsOrTheirDescendants?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type ListUniqueIssueReportValuesInput = {
  filters?: InputMaybe<ListUniqueIssueReportValuesFiltersInput>;
  /** Return only the first N results for each value */
  first: Scalars['Int'];
};

export type ListUniqueIssueReportValuesResponse = {
  __typename: 'ListUniqueIssueReportValuesResponse';
  uniqueValues: UniqueIssueReportValues;
};

export type ListUniqueMeetingServiceRequestValuesFiltersInput = {
  eventStartTimeBetween?: InputMaybe<TimeRangeInput>;
  regardingAnyBuildingIdsOrTheirDescendants?: InputMaybe<Array<Scalars['ID']>>;
};

export type ListUniqueMeetingServiceRequestValuesInput = {
  filters?: InputMaybe<ListUniqueMeetingServiceRequestValuesFiltersInput>;
  /** Return only the first N results for each value */
  first: Scalars['Int'];
};

export type ListUniqueMeetingServiceRequestValuesResponse = {
  __typename: 'ListUniqueMeetingServiceRequestValuesResponse';
  uniqueValues: UniqueMeetingServiceRequestValues;
};

export type LocalDateTimePair = {
  __typename: 'LocalDateTimePair';
  localDate: Scalars['IsoDateOnlyString'];
  localTime: Scalars['IsoLocalTimeString'];
};

export type LocalTimePair = {
  __typename: 'LocalTimePair';
  endTime: Scalars['IsoLocalTimeString'];
  startTime: Scalars['IsoLocalTimeString'];
};

export type LocaleDateTimePair = {
  localDate: Scalars['IsoDateOnlyString'];
  localTime: Scalars['IsoLocalTimeString'];
};

export type Location = {
  __typename: 'Location';
  /** Total desks in the building - excluding inactive. */
  activeDeskCount: Maybe<Scalars['Int']>;
  address: Maybe<Scalars['String']>;
  allowsEmployeeCredentialProvisioning: Scalars['Boolean'];
  campus: Maybe<Campus>;
  campusId: Maybe<Scalars['ID']>;
  /** Excluding request-only and on-demand spaces. See SpaceScheduleConfiguration.SCHEDULED. */
  containsAtLeastOneScheduledSpace: Scalars['Boolean'];
  createdAt: Maybe<Scalars['Date']>;
  /** customWorkingHours are limited to 100 entries and will only grab custom working hours from the current date of the location and upcoming custom working hours It paginates via optional `startFromDateTime` parameter This will grab custom working hours that has a date time greater than `startFromDateTime` provided Format expected is `YYYY-MM-DD HH:mm` */
  customWorkingHours: Array<CustomWorkingHours>;
  description: Maybe<Scalars['String']>;
  /** Total desks in the building - including inactive. */
  deskCount: Scalars['Int'];
  /** Total desks within the location that fit within various scheduling type and status buckets */
  deskSchedulingAggregates: SchedulingAggregateOfDesks;
  employeeCredentialProvisioningProviders: Array<EmployeeCredentialProvisioningProvider>;
  /** Endpoints that resolve into this Location or anything beneath it — the "endpoints by building" convenience. Beneath it includes Levels, not just Spaces: placement can land on a whole floor (a vendor room is not guaranteed to be a room), and that hardware belongs to the building too. */
  endpoints: Array<Endpoint>;
  geofenceFeatureEnabled: Scalars['Boolean'];
  /** Expects a `startDate` and `endDate` formated as YYYY-MM-DD `startDate` and `endDate` are inclusive */
  hoursForTimeRange: Array<DateSpecificWorkingHours>;
  id: Scalars['ID'];
  image: Maybe<Scalars['String']>;
  isHealthCheckpointRequired: Scalars['Boolean'];
  isVisitorManagementEnabled: Scalars['Boolean'];
  isWorkplaceServicesEnabled: Scalars['Boolean'];
  latitude: Maybe<Scalars['Float']>;
  levels: Array<Level>;
  longitude: Maybe<Scalars['Float']>;
  maxCapacity: Scalars['Int'];
  name: Scalars['String'];
  officeAccess: Array<OfficeAccess>;
  organizationId: Scalars['ID'];
  preferredLanguageTag: Maybe<Scalars['String']>;
  remoteGoogleId: Maybe<Scalars['ID']>;
  remoteGoogleLabel: Maybe<Scalars['String']>;
  spaces: Array<Space>;
  state: LocationState;
  stateByDay: Array<LocationStateByDay>;
  timezone: Maybe<Scalars['String']>;
  /** @deprecated Use `activeDeskCount` instead */
  totalDesks: Scalars['Int'];
  totalLevels: Scalars['Int'];
  /** total spaces will be contextual to the filter */
  totalSpaces: Scalars['Int'];
  updatedAt: Scalars['Date'];
  /** Stable identifier from robin-api, as 32 lowercase hex characters. */
  uuid: Scalars['ID'];
  workingHours: Array<WorkingHours>;
  /** Total desks within the location where booked counts are bound to the current workday and the configured hours of operation for the location */
  workplaceDeskSchedulingAggregates: BookedSchedulingAggregateOfDesks;
};


export type LocationCustomWorkingHoursArgs = {
  startFromDateTime?: InputMaybe<Scalars['Date']>;
};


export type LocationHoursForTimeRangeArgs = {
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};


export type LocationOfficeAccessArgs = {
  userId: Scalars['ID'];
};


export type LocationSpacesArgs = {
  filters?: InputMaybe<Array<SpaceFilters>>;
};


export type LocationStateArgs = {
  endTime: Scalars['Date'];
  evaluations?: InputMaybe<Evaluations>;
  recurrence?: InputMaybe<Scalars['String']>;
  startTime: Scalars['Date'];
  userId: Scalars['ID'];
};


export type LocationStateByDayArgs = {
  endTime: Scalars['Date'];
  evaluations?: InputMaybe<Evaluations>;
  recurrence?: InputMaybe<Scalars['String']>;
  startTime: Scalars['Date'];
};


export type LocationTotalSpacesArgs = {
  filters?: InputMaybe<Array<SpaceFilters>>;
};

export type LocationDeskReservation = {
  __typename: 'LocationDeskReservation';
  locationId: Scalars['ID'];
  reservations: Array<Reservation>;
};

export type LocationFilters = {
  currentActorPermissions: Array<Scalars['String']>;
};

export type LocationState = {
  __typename: 'LocationState';
  availability: PlaceAvailability;
  freeCapacity: Scalars['Int'];
  isOpen: Maybe<Scalars['Boolean']>;
};

export type LocationStateByDay = {
  __typename: 'LocationStateByDay';
  availability: PlaceAvailability;
  day: Scalars['Date'];
};

export type LogSuggestedSpaceBookedInput = {
  suggestedSpaceRecordId: Scalars['ID'];
};

export type LogSuggestedSpaceDismissedInput = {
  suggestedSpaceRecordId: Scalars['ID'];
};

export type LogSuggestedSpaceViewedInput = {
  suggestedSpaceRecordId: Scalars['ID'];
};

/** A Logitech device discovered in a LogiSync place. Logi Sync names a Logitech device by its product name (e.g. Rally Bar, Spot, Tap), so name and model carry the same string for one. An Endpoint implementer. id is the surrogate uuid from the LogiSync catalog; remoteId is the device id, org-scoped rather than place-scoped, because a device that moves between places keeps its identity. */
export type LogiSyncDevice = Endpoint & {
  __typename: 'LogiSyncDevice';
  deviceId: Scalars['ID'];
  firstSeenAt: Scalars['DateTime'];
  healthStatus: Scalars['String'];
  id: Scalars['ID'];
  lastSeenAt: Scalars['DateTime'];
  /** Every MAC the LogiSync poll reported for this device. */
  macs: Array<Scalars['String']>;
  /** The raw model key, verbatim and stable, so a client can key behavior on it. Logi Sync has no model field: its device type is a category (Logitech, Computer or Generic), and for a Logitech device the name is the product name, so model is that name. Null for a Computer or Generic device, whose name is a host name or a free-form label. */
  model: Maybe<Scalars['String']>;
  /** The product name for model, from the collector's product-name table — a label for people, which may change as the table learns better names. Key behavior on model, never on this. Null when the table does not know the model. */
  modelName: Maybe<Scalars['String']>;
  name: Scalars['String'];
  placement: Maybe<EndpointPlacement>;
  relationships: Array<EndpointRelationship>;
  /** Mirrors deviceId on this type: the same LogiSync device id in both fields. The two must not diverge. */
  remoteId: Scalars['String'];
  /** The manufacturer serial, or null when Logi Sync reports none. */
  serial: Maybe<Scalars['String']>;
  source: EndpointSource;
  status: Scalars['String'];
  vendor: Maybe<Scalars['String']>;
};


/** A Logitech device discovered in a LogiSync place. Logi Sync names a Logitech device by its product name (e.g. Rally Bar, Spot, Tap), so name and model carry the same string for one. An Endpoint implementer. id is the surrogate uuid from the LogiSync catalog; remoteId is the device id, org-scoped rather than place-scoped, because a device that moves between places keeps its identity. */
export type LogiSyncDeviceRelationshipsArgs = {
  kinds?: InputMaybe<Array<EndpointRelationshipKind>>;
};

export type MapBuildingToRipplingWorkLocationInput = {
  buildingId: Scalars['ID'];
  organizationId: Scalars['ID'];
  ripplingWorkLocationId: Scalars['ID'];
};

export type MapBuildingToRipplingWorkLocationResponse = {
  __typename: 'MapBuildingToRipplingWorkLocationResponse';
  id: Scalars['ID'];
};

export type MapBuildingsToRipplingWorkLocationsInput = {
  mappings: Array<MapBuildingsToRipplingWorkLocationsMappingsInput>;
  organizationId: Scalars['ID'];
};

export type MapBuildingsToRipplingWorkLocationsMappingsInput = {
  buildingId: Scalars['ID'];
  ripplingWorkLocationId: Scalars['ID'];
};

export type MapBuildingsToRipplingWorkLocationsResponse = {
  __typename: 'MapBuildingsToRipplingWorkLocationsResponse';
  id: Scalars['ID'];
};

export type MapKisiLocksToRobinLocations = {
  mappings: Array<MapKisiLocksToRobinLocationsMapping>;
};

export type MapKisiLocksToRobinLocationsMapping = {
  isConfigured: Scalars['Boolean'];
  isOnline: Scalars['Boolean'];
  remoteLockId: Scalars['String'];
  remotePlaceId: Scalars['String'];
  remotePlaceName: Scalars['String'];
  robinFloorId?: InputMaybe<Scalars['Int']>;
  robinLocationId: Scalars['Int'];
};

export type MapKisiLocksToRobinLocationsResponse = {
  __typename: 'MapKisiLocksToRobinLocationsResponse';
  uuid: Scalars['ID'];
};

export enum MapUploadStatus {
  AWAITING_UPLOAD = 'AWAITING_UPLOAD',
  UNKNOWN = 'UNKNOWN',
  UPLOADED = 'UPLOADED'
}

export enum MatchTicketIntegrationEntityMappingCandidatesErrorReason {
  NOT_FOUND = 'NOT_FOUND'
}

export type MatchTicketIntegrationEntityMappingCandidatesErrorResponse = {
  __typename: 'MatchTicketIntegrationEntityMappingCandidatesErrorResponse';
  reason: MatchTicketIntegrationEntityMappingCandidatesErrorReason;
};

export type MatchTicketIntegrationEntityMappingCandidatesResponse = MatchTicketIntegrationEntityMappingCandidatesErrorResponse | MatchTicketIntegrationEntityMappingCandidatesSuccessResponse;

export type MatchTicketIntegrationEntityMappingCandidatesSuccessResponse = {
  __typename: 'MatchTicketIntegrationEntityMappingCandidatesSuccessResponse';
  candidates: Array<TicketIntegrationEntityMappingCandidate>;
  /** When the matching phase that produced these candidates saved them. Null before any has, so an empty result is "not matched yet" rather than "no match". A place added since then has no candidate until the next one. */
  matchedAt: Maybe<Scalars['ISODateTime']>;
  /** True when the result may be incomplete: the last full object import stopped before the provider's end (so every match is LOW), the last matching phase ran out of time before near-miss matching reached every place (so a place with no candidate may still have one), or the building has more unmapped places than one call reads. */
  truncated: Scalars['Boolean'];
  /** Robin places with no match at all (not present in `candidates`). Counted over the same building-scoped unmapped set that produces `candidates` — not a set difference against every place in the org. */
  unmatchedEntityCount: Scalars['Int'];
};

/** Public-facing, unauthenticated organization data (e.g. for picking an org to log in to) */
export type MeOrganization = {
  __typename: 'MeOrganization';
  authMethods: Maybe<Array<AuthMethod>>;
  avatar: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

/** A Google Meet call, exposing the raw Meet detail behind the generic Call contract. */
export type MeetCall = Call & {
  __typename: 'MeetCall';
  durationMinutes: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  issues: Array<CallIssue>;
  /** Raw Google Meet detail for this call. */
  meet: MeetCallDetail;
  /** How many Meet devices joined the call, not how many people. Google's call-audit stream is read with identifier_type==device_id, so this counts the conferencing units on the call; a full room on one unit counts as one. */
  participantCount: Maybe<Scalars['Int']>;
  platform: CallPlatform;
  quality: Maybe<CallQuality>;
  startedAt: Scalars['DateTime'];
};

/** Raw Google Meet call detail. */
export type MeetCallDetail = {
  __typename: 'MeetCallDetail';
  /** The Google Calendar event the call was associated with. */
  calendarEventId: Maybe<Scalars['String']>;
  /** The Meet-reported device identifier that hosted the call. */
  deviceId: Scalars['String'];
  /** The raw Google Reports API activity this call was recorded from, JSON-encoded. Loaded on demand; null when the call has no source activity. It carries personal data from the Google Workspace audit record, including the organizer's email address and participant IP addresses. */
  rawEvent: Maybe<Scalars['String']>;
  /** The device serial, when known. */
  serialNumber: Maybe<Scalars['String']>;
};

export type MeetingService = {
  __typename: 'MeetingService';
  /** Assignees are required when service is created, but could become null/empty due to user/group deletion. Can also be null when kind=SPACE_REQUEST_FORM. */
  assignees: Maybe<UsersAndGroups>;
  /** A building-level summary of availability of this service. Use availabilityInSpacesOfBuilding for the availability of a specific building. */
  availabilityInBuildings: MeetingServiceAvailabilityInBuildings;
  /** Use availabilityInBuildings first to get the buildings where this service is available */
  availabilityInSpacesOfBuilding: MeetingServiceAvailabilityInSpacesOfBuilding;
  category: MeetingServicesCategory;
  /** The currency for all monetary amounts in this service, like on menu item unitPrice. New meeting services require this field, but old ones may be missing. */
  currencyCode: Maybe<Scalars['CurrencyCodeISO4217']>;
  description: Maybe<Scalars['Markdown']>;
  id: Scalars['ID'];
  kind: TicketWorkflowKind;
  /** null if approval is not required */
  multipleApprovers: Maybe<UsersAndGroups>;
  name: Scalars['String'];
  /** @deprecated Not yet implemented as of 2024-11-05 */
  permissions: Maybe<MeetingServicePermissions>;
  questions: Array<TicketQuestion>;
  /** If true, approver must approve creation/changes on requests before assignees are emailed */
  requestsNeedApproval: Scalars['Boolean'];
  /**
   * If true, approver must approve creation/changes on requests before assignees are emailed
   * @deprecated Use requestsNeedApproval instead
   */
  requireAdminApproval: Scalars['Boolean'];
  updatedAt: Scalars['ISODateTime'];
  versionId: Scalars['ID'];
  versionNumber: Scalars['Int'];
};


export type MeetingServiceAvailabilityInSpacesOfBuildingArgs = {
  buildingId: Scalars['ID'];
};

export type MeetingServiceAvailabilityInBuilding = {
  __typename: 'MeetingServiceAvailabilityInBuilding';
  building: Maybe<Location>;
  buildingId: Scalars['ID'];
  /** The number of spaces within this building where this service is available */
  spaceCount: Scalars['Int'];
};

export type MeetingServiceAvailabilityInBuildings = {
  __typename: 'MeetingServiceAvailabilityInBuildings';
  /** The buildings containing at least one space where this service is available */
  buildingAvailability: Array<MeetingServiceAvailabilityInBuilding>;
  /** The number of buildings containing at least one space where this service is available */
  buildingCount: Scalars['Int'];
  /** The number of spaces across all buildings where this service is available */
  spaceCount: Scalars['Int'];
};

export type MeetingServiceAvailabilityInSpacesOfBuilding = {
  __typename: 'MeetingServiceAvailabilityInSpacesOfBuilding';
  availableInSpaceIds: Array<Scalars['ID']>;
  availableInSpaces: Array<Maybe<Space>>;
  building: Maybe<Location>;
};

export type MeetingServiceAvailableInSpacesByBuildingInput = {
  /** The ID of the building that contains all the spaceIds */
  buildingId: Scalars['ID'];
  spaceIds: Array<Scalars['ID']>;
};

export type MeetingServicePermissions = {
  __typename: 'MeetingServicePermissions';
  /** Must have workplace_services:manage permssion in ALL of the service's buildings. If the service is not available in any building, anyone with workplace_services:manage permission in at least one building can delete. */
  canDelete: Scalars['Boolean'];
  /** Must have workplace_services:manage permission on AT LEAST ONE of the service's buildings. If the service is not available in any building, anyone with workplace_services:manage permission in at least one building can update. */
  canUpdate: Scalars['Boolean'];
};

export type MeetingServiceRequest = Ticket & {
  __typename: 'MeetingServiceRequest';
  assignees: Maybe<UsersAndGroups>;
  category: MeetingServicesCategory;
  completedForm: Maybe<CompletedTicketForm>;
  createdAt: Scalars['ISODateTime'];
  /** This may differ from the currencyCode on the meetingService if the meeting service was changed after this request was made. */
  currencyCode: Maybe<Scalars['CurrencyCodeISO4217']>;
  id: Scalars['ID'];
  key: Scalars['String'];
  /** The ID of the latest change to this service request. Every time the service request is changed, this ID will change. Used for concurrency control on mutations like approveMeetingServiceRequest. */
  latestChangeId: Scalars['ID'];
  /** If you are looking for form questions, consult completedForm which shows questions as they were at the time of ticket creation. meetingService.questions are presented for *new* service requests. */
  meetingService: MeetingService;
  meetingServiceRequestStatus: MeetingServiceRequestStatus;
  multipleApprovers: Maybe<UsersAndGroups>;
  permissions: Maybe<MeetingServiceRequestPermissions>;
  priority: TicketPriority;
  /** The space the request regards - see regardsEventAtSpace for the event */
  regardsEntity: TicketRegardsEntity;
  regardsEventAtSpace: TicketRegardsEventAtSpace;
  /** If the service request has status REJECTED, this will contain the comment related to the rejection. Such a comment is optional, so this may be null even if the service request is rejected. */
  rejectionComment: Maybe<Scalars['String']>;
  requester: Maybe<User>;
  title: Scalars['String'];
  /** The total price of this service request (see menu choices), after any surcharges/taxes. */
  totalPrice: Maybe<Money>;
  updatedAt: Scalars['ISODateTime'];
};

export type MeetingServiceRequestIdentifierInput = {
  id?: InputMaybe<Scalars['ID']>;
  key?: InputMaybe<Scalars['String']>;
};

export type MeetingServiceRequestPermissions = {
  __typename: 'MeetingServiceRequestPermissions';
  canApproveOrReject: Scalars['Boolean'];
  canChangeAnswers: Scalars['Boolean'];
  canDeleteOrCancel: Scalars['Boolean'];
  canUpdateStatus: Scalars['Boolean'];
};

export enum MeetingServiceRequestSpaceStatus {
  /** The space has explicitly accepted the invitation. Some space calendars will never explicitly accept, and merely acquiesce. */
  ACCEPTED = 'ACCEPTED',
  /** The space has not explicitly accepted the invitation, but it also hasn't explicitly declined the invitation, nor are we awaiting any sort of approval. Robin considers this enough for the space to be successfully booked. */
  ACQUIESCED = 'ACQUIESCED',
  /** The space declined the invitation from the organizer. The most likely reason is that there was a conflict with another event. Can also happen due to disallowed cross-domain invitations or other policy violations. Or, this could be a request-only space and the request was denied by the admin. */
  DECLINED = 'DECLINED',
  /** We have seen the event (e.g. through other space calendars), but the space that this service request was intended for is missing. The service request may have been created for an event that was not saved yet, and the creator removed the space before saving the event. Could also happen if someone was editing an event, added a space, moved a service request to that space, but then removed (or failed to add) the space. */
  MISSING = 'MISSING',
  /** We have not seen anything related to this event. The service request may have been created for an event that was not saved yet, and the creator either never saved the event or removed all spaces before saving. */
  NOT_SYNCED = 'NOT_SYNCED',
  /** Either the event was cancelled by the organizer, or the space was disinvited from the event. It is difficult to tell the difference between the two situations. */
  REMOVED_OR_EVENT_CANCELLED = 'REMOVED_OR_EVENT_CANCELLED',
  /** The space has tentatively accepted the invitation, but we're still waiting for an admin to approve the request. */
  REQUESTED = 'REQUESTED'
}

export enum MeetingServiceRequestStatus {
  BLOCKED = 'BLOCKED',
  CANCELLED = 'CANCELLED',
  DONE = 'DONE',
  IN_PROGRESS = 'IN_PROGRESS',
  NEEDS_APPROVAL = 'NEEDS_APPROVAL',
  REJECTED = 'REJECTED',
  TODO = 'TODO'
}

export type MeetingServicesCategory = WorkflowCategory & {
  __typename: 'MeetingServicesCategory';
  id: Scalars['ID'];
  key: Scalars['String'];
  name: Scalars['String'];
  serviceCount: Scalars['Int'];
};

export type MetadataDeskObject = {
  __typename: 'MetadataDeskObject';
  id: Scalars['String'];
  name: Maybe<Scalars['String']>;
  zone: MetadataZoneObject;
};

export type MetadataZoneObject = {
  __typename: 'MetadataZoneObject';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type MeteredFeature = {
  __typename: 'MeteredFeature';
  billableTotal: Maybe<Scalars['Int']>;
  feature: FeatureType;
  limit: Maybe<Scalars['Int']>;
  overProvisioningLimit: Maybe<Scalars['Int']>;
  total: Maybe<Scalars['Int']>;
};

export type MigrationProgress = {
  __typename: 'MigrationProgress';
  migratedSpaceCount: Scalars['Int'];
  spaceCount: Scalars['Int'];
};

export type MigrationReportTotals = {
  __typename: 'MigrationReportTotals';
  error: Scalars['Int'];
  rolledBack: Scalars['Int'];
  skipped: Scalars['Int'];
  success: Scalars['Int'];
};

export type MigrationReportWithTotals = {
  __typename: 'MigrationReportWithTotals';
  reports: Array<MigrationSpaceReport>;
  totals: MigrationReportTotals;
};

export type MigrationSpaceReport = {
  __typename: 'MigrationSpaceReport';
  calendarId: Scalars['String'];
  migratedAt: Scalars['String'];
  spaceId: Scalars['String'];
  spaceName: Scalars['String'];
  /** Null where the backed-up calendar had no resource mailbox recorded. `space_calendar_backups.space_resource_email` is nullable, so this was never safely non-null — a null row raised "Cannot return null for non-nullable field" through the legacy route too. It has not fired because this query has no live caller. */
  spaceResourceEmail: Maybe<Scalars['String']>;
  status: Scalars['Int'];
};

export type MinimizedAmenityViewModel = {
  __typename: 'MinimizedAmenityViewModel';
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

export enum MobileActivityType {
  IN_VEHICLE = 'in_vehicle',
  ON_BICYCLE = 'on_bicycle',
  ON_FOOT = 'on_foot',
  RUNNING = 'running',
  STILL = 'still',
  UNKNOWN = 'unknown',
  WALKING = 'walking'
}

export type MobileGeofence = {
  __typename: 'MobileGeofence';
  /** Arbitrary key-values appended to the geofence event. */
  extras: Maybe<Scalars['JSON']>;
  /** Unique geofence identifier. */
  identifier: Scalars['ID'];
  /** Latitude of geofence center. Not required when using `vertices` for polygon geofences. */
  latitude: Maybe<Scalars['Float']>;
  /** Minimum time in milliseconds the device must "loiter" within this geofence before notifyOnDwell event fires. */
  loiteringDelay: Maybe<Scalars['Int']>;
  /** Longitude of geofence center. Not required when using `vertices` for polygon geofences. */
  longitude: Maybe<Scalars['Float']>;
  /** Set true to fire event when device "loiters" within this geofence for loiteringDelay milliseconds. */
  notifyOnDwell: Maybe<Scalars['Boolean']>;
  /** Set true to fire event when device enters this geofence. */
  notifyOnEntry: Maybe<Scalars['Boolean']>;
  /** Set true to fire event when device exits this geofence. */
  notifyOnExit: Maybe<Scalars['Boolean']>;
  /** Radius of the circular geofence in meters. The minimum reliable radius is 200 meters. Not required when using `vertices` for polygon geofences. */
  radius: Maybe<Scalars['Float']>;
  /** Optional: a list of vertices ([ [lat, lng],...]) defining a Polygon geofence. By default, geofences are circular. */
  vertices: Maybe<Array<Array<Scalars['Float']>>>;
};

export enum MobileGeofenceAction {
  DWELL = 'DWELL',
  ENTER = 'ENTER',
  EXIT = 'EXIT'
}

export type MobileGeofenceEventBatteryInput = {
  is_charging: Scalars['Boolean'];
  level: Scalars['Float'];
};

export type MobileGeofenceEventCoordsInput = {
  accuracy: Scalars['Float'];
  altitude: Scalars['Float'];
  ellipsoidal_altitude?: InputMaybe<Scalars['Float']>;
  heading: Scalars['Float'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  speed: Scalars['Float'];
};

export type MobileGeofenceEventInput = {
  /** The transition type: ENTER, EXIT, DWELL. */
  action: MobileGeofenceAction;
  /** Optional Geofence extras. This can be any JSON object (it's implementation-defined). */
  extras?: InputMaybe<Scalars['JSON']>;
  /** The identifier of the geofence which fired. */
  identifier: Scalars['String'];
  /** The Location where the geofence transition occurred. */
  location: ReportMyPresenceViaMobileGeofenceEventLocationInput;
  /** The device system time when the Geofence event was received by the OS. Note: this can differ from the timestamp of the triggering location responsible for the geofence (the triggering location can be from the past). */
  timestamp: Scalars['String'];
};

export type MobileGeofenceEventMotionActivityInput = {
  confidence: Scalars['Int'];
  type: MobileActivityType;
};

export enum MobileLocationEvent {
  GEOFENCE = 'geofence',
  HEARTBEAT = 'heartbeat',
  MOTIONCHANGE = 'motionchange',
  PROVIDERCHANGE = 'providerchange'
}

export type Money = {
  __typename: 'Money';
  /** The number of major currency units in the amount. e.g. `"1.54"` in USD is one dollar and 54 cents. `"100"` in JPY is one hundred yen. Always serialized in fixed notation (i.e. not 1.24e4 exponential notation). */
  amountMajor: Scalars['Decimal'];
  currencyCode: Scalars['CurrencyCodeISO4217'];
};

export type MoneyInput = {
  /** The number of major currency units in the amount. e.g. `"1.54"` in USD is one dollar and 54 cents. `"100"` in JPY is one hundred yen. */
  amountMajor: Scalars['Decimal'];
  currencyCode: Scalars['CurrencyCodeISO4217'];
};

export type MoveEventError = {
  __typename: 'MoveEventError';
  message: Maybe<Scalars['String']>;
  reason: MoveEventFailReason;
};

/** Why the move was rejected synchronously. robin-api accepts a move before the calendar sync that performs it runs, so a MoveEventSuccess means the move was submitted, not that the destination room took the event. */
export enum MoveEventFailReason {
  /** No event with that ID is visible to the actor. */
  EVENT_NOT_FOUND = 'EVENT_NOT_FOUND',
  /** robin-api rejected the request: the event has ended, the start is in the past, the destination is already on the event, the rooms are on different calendar providers, or the event's room is request-only. */
  INVALID_INPUT = 'INVALID_INPUT',
  /** The actor's calendar account cannot write to the rooms' calendars. An actor who may not modify the event at all gets a GraphQL error instead. */
  LACKING_PERMISSIONS = 'LACKING_PERMISSIONS',
  /** The destination room is booked at that time, or an invitee is unavailable. */
  SPACE_UNAVAILABLE = 'SPACE_UNAVAILABLE',
  UNKNOWN = 'UNKNOWN'
}

/** Input for moveEvent. Send spaceChange to change rooms, start to change the time, or both; at least one is required. A recurring event moves this occurrence only. Mirrors the event composer's room-change flow. */
export type MoveEventInput = {
  eventId: Scalars['ID'];
  /** Whether attendees are told about the move. Omit or null to leave the decision to robin-api, which does not notify by default. */
  notifyAttendees?: InputMaybe<Scalars['Boolean']>;
  /** Omit or null to keep the event's room and change only its time. */
  spaceChange?: InputMaybe<MoveEventSpaceChangeInput>;
  /** New start. Omit or null to keep the event's current time, which is also how a room-only move of a meeting already in progress avoids being rejected for a start in the past. The event keeps its duration, so there is no end. */
  start?: InputMaybe<DateWithTimezone>;
};

/** Either an accepted move, or why it was rejected. Never both. */
export type MoveEventResponse = MoveEventError | MoveEventSuccess;

/** A room's calendar, and a tag for polling whether the move has synced to it. */
export type MoveEventSpaceCalendar = {
  __typename: 'MoveEventSpaceCalendar';
  /** Weak entity tag of the calendar when the move was accepted. It changes once the calendar has synced, so poll until it differs from this value. */
  etag: Scalars['String'];
  /** Relative robin-api path of the room's calendar. */
  spaceCalendarUri: Scalars['String'];
};

/** The room an event leaves and the room it moves to. */
export type MoveEventSpaceChangeInput = {
  /** The room to move the event to. It must not already be on the event. */
  newSpaceId: Scalars['ID'];
  /** The room the event is booked in now. */
  oldSpaceId: Scalars['ID'];
};

/** robin-api accepted the move. The calendar sync that moves the event runs afterwards, per calendar, so for a while the event can show both rooms or neither, and on Office 365 it can come back under a new ID. Poll the two calendars, or re-read the event, to learn when it has landed. */
export type MoveEventSuccess = {
  __typename: 'MoveEventSuccess';
  /** The room the event is leaving. The same calendar as target for a time-only move. */
  sourceSpaceCalendar: MoveEventSpaceCalendar;
  /** The room the event is moving to. */
  targetSpaceCalendar: MoveEventSpaceCalendar;
};

export type MultiPlacePassInput = {
  groups: Array<Scalars['ID']>;
  healthCheckpointRequired?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  places: Array<PassPlaceInput>;
  schedule: Array<Scalars['String']>;
  userChanges?: InputMaybe<PassUsersInput>;
};

export type Mutation = {
  __typename: 'Mutation';
  /** Requesting user acknowledges a given announcement for a given location */
  acknowledgeAnnouncement: Maybe<Scalars['Void']>;
  acknowledgeAnnouncementForMultipleLocations: Maybe<Scalars['Void']>;
  /** Records that the signed-in user has explicitly accepted the location we picked from their teammates -- called when they dismiss the notice, not when it is rendered. Provenance is kept, so this does not disguise the value as one they chose. A no-op unless the current value is one we set and has not already been acknowledged. */
  acknowledgeAutoSetDefaultLocation: Maybe<Scalars['Void']>;
  /** Acknowledge the handling of visit events to prevent duplication of event driven side-effects */
  acknowledgeVisitEventHandled: Maybe<Scalars['Void']>;
  /** Adds a new custom resource template to the collection of templates for an organization */
  addCustomResourceTemplate: Maybe<Scalars['Void']>;
  addCustomWorkingHours: Maybe<Scalars['Void']>;
  /** Adds record to visit draft */
  addDraftVisitRecord: Scalars['ID'];
  /** Records relationships: that two endpoints are the same hardware, that they are not, that an endpoint is in a place, or that one is attached to another. This is the door for decisions a human makes on a screen. Machine evidence goes the other way — an integration emits a domain event and a resolver projects it — which is what keeps every row traceable to an event. */
  addEndpointRelationships: AddEndpointRelationshipsResponse;
  addGuestBadgeImage: Maybe<Scalars['Void']>;
  /** Add a host to an existing visit */
  addHostToVisit: Maybe<Scalars['Void']>;
  /** Adds a message to a conversation. This is called by the UI when a user sends a message. (The source of the resulting message will be "user") */
  addInsightsAssistantInboundMessageToConversation: InsightsAssistantMessageV1;
  /** Adds a message to a conversation. This is called by the insights-nlq-chaperone when the LLM generates a response. (The source of the resulting message will be "model") */
  addInsightsAssistantOutboundMessageToConversation: Maybe<Scalars['Void']>;
  addLevelToLocation: Maybe<AddLevelToLocationResponse>;
  addLevelsToLocation: Maybe<Array<Maybe<AddLevelsToLocationResponse>>>;
  addLevelsWithDetailsToLocation: Array<AddLevelsWithDetailsToLocationResponse>;
  addLocationToOrganization: Maybe<AddLocationToOrganizationResponse>;
  /** Add a meeting service, e.g. 'Breakfast' */
  addMeetingService: AddMeetingServiceResponse;
  /** Add a category for meeting services, e.g. 'Catering'. Idempotent - if category already exists with same attributes, return old category. */
  addMeetingServicesCategory: AddMeetingServicesCategoryResponse;
  addOfficeAdmin: Maybe<Scalars['Void']>;
  addOrUpdateLevelSetting: Setting;
  addOrganization: Maybe<AddOrganizationResponse>;
  addPinnedUserSpaces: Maybe<Scalars['Void']>;
  addSpaceToEvent: UpdateEventResponse;
  /** Adds a new subcategory to a custom resource template. */
  addSubcategoryToCustomTemplate: EventTrackingOnlyResponse;
  /** Add target configs from `listTicketIntegrationAvailableTargets`. Only a target the last target import saw, and did not see removed, can be added. Targets already added are returned as they are. The first target becomes the default when the integration has none. An integration that has never had a workflow binding gets the org's default issue report workflow bound to its default target config, creating that workflow if needed. */
  addTicketIntegrationTargetConfigs: AddTicketIntegrationTargetConfigsResponse;
  addUserToAssignmentsQueue: Maybe<Scalars['Void']>;
  addUserToFavorites: Maybe<Scalars['Void']>;
  addUserToRole: Maybe<Scalars['Void']>;
  addUsersToAssignmentsQueue: Maybe<Scalars['Void']>;
  /** Created a org_visit_type entry matching the given visitTypeName. If visit_type exists, simply enable it for given org. */
  addVisitTypeForOrg: Maybe<Scalars['Void']>;
  /** Allows a robin administrator to register a guest for a visit at some location */
  administratorRegisterGuest: Maybe<Scalars['Void']>;
  /** @deprecated Use the `autoAllocateStickersToOrg` operation instead */
  allocateStickersToOrg: Maybe<Scalars['Void']>;
  /** @deprecated Use the `autoAllocateStickersToOrg` operation instead */
  allocateStickersToOrgByDisplayCode: Maybe<Scalars['Void']>;
  /** Approve a meeting service request that has status "NEEDS_APPROVAL". Once approved, the status will change to "TODO". If the service request has changed since latestChangeId, this fails with "CONFLICT". Only permitted if MeetingServiceRequest.permissions.canApproveOrReject is true. */
  approveMeetingServiceRequest: ApproveMeetingServiceRequestResponse;
  /** Archive an announcement by ID. Changes the `status` to ARCHIVED. */
  archiveAnnouncement: Maybe<Scalars['Void']>;
  /** Archive a SLACK announcement by ID. Changes the `status` to ARCHIVED. */
  archiveAnnouncementForSlack: Maybe<Scalars['Void']>;
  /** Archives an integration by id */
  archiveIntegrationById: Maybe<Scalars['Void']>;
  /** Recover your arrival display using a client signed certificate of authority */
  arrivalDisplayCertRecovery: ArrivalDisplayRescueResponse;
  /** Provided the expressed name and email, either find or create a guest record. Returns guest ID in all cases. */
  assertGuestIdentity: Scalars['ID'];
  /** Creates a new assigned desk reservation for a given user on your behalf. */
  assignDelegatedDesk: Reservation;
  /** Creates a new assigned desk reservation for the current user. */
  assignDeskToMe: Reservation;
  assignStickerToCustomResourceByShortCode: Maybe<AssignStickerToCustomResourceByShortCodeResponse>;
  assignStickerToDeskByShortCode: Maybe<AssignStickerToDeskByShortCodeResponse>;
  assignStickers: AssignStickerResponse;
  /** Associate a health checkpoint response record to a guest invite */
  associateHealthCheckpointWithVisit: Maybe<Scalars['Void']>;
  /** Generate an authentication bearer token in exchange for a magic link token */
  authenticateVisitorWithMagicLink: VisitMagicLinkAuthResponse;
  autoAllocateStickersToMultipleOrgs: Maybe<Scalars['Void']>;
  autoAllocateStickersToOrg: Maybe<Scalars['Void']>;
  /** Batch report for issues with booking users in auto-desk-booking */
  autoDeskBookingBatchReportFailures: Maybe<Scalars['Void']>;
  /** report for process failures in auto-desk-booking */
  autoDeskBookingReportProcessFailure: Maybe<Scalars['Void']>;
  /** This mutation is used to unlink a Kisi locks from a Robin levels. If the locks are linked to a Robin location, they will not be unlinked from their locations. */
  batchUnlinkKisiLocksFromRobinLevels: Maybe<BatchUnlinkKisiLocksFromRobinLevelsResponse>;
  batchUnlinkKisiLocksFromRobinLocations: Maybe<BatchUnlinkKisiLocksFromRobinLocationsResponse>;
  /** Request pre-signed URLs for uploading files to answer a ticket question. The URLs can be used to upload files before submitting the answer. Client-provided UUIDs in the request will be returned in the response to match files with their URLs. */
  beginFileUploadsForTicketAnswer: BeginFileUploadsForTicketAnswerResponse;
  /** Begin the 3-legged OAuth grant; returns the provider authorize URL. `returnUrl` is where the backend callback bounces the browser after the grant completes (with `?integration_status=connected|error`); it must be on the environment's host allowlist. The provider OAuth redirect_uri is the fixed backend callback, not this value. */
  beginTicketIntegrationOAuth: BeginTicketIntegrationOAuthResponse;
  /** Bulk-activates users, waiting on the result — the same submit/poll/budget contract as bulkDeactivateUsers. Only organization-level deactivations are undone: a user also disabled via SCIM or billing remains effectively disabled and surfaces in `errors` with a `stillDisabled` list explaining why they didn't reactivate (the job ends PARTIALLY_FAILED alongside successes). Requires organization:manage_users. */
  bulkActivateUsers: UserBulkActionJob;
  /** Fire-and-poll variant of bulkActivateUsers: submits the job and returns its id immediately with status PENDING. Follow up via userBulkActionJob. */
  bulkActivateUsersAsync: UserBulkActionJob;
  /** Archive multiple announcements by IDs, modifying it's status to ARCHIVED. If one announcement is unable to be processed, it fails the entire operation */
  bulkArchiveAnnouncements: Maybe<Scalars['Void']>;
  /** Bulk-deactivates users, waiting on the result. Submits an async job to the API and polls it inside the resolver; small batches return full results in one round trip. If the job outlives the resolver budget the mutation returns IN_PROGRESS with the job id — not an error — and the client completes via the userBulkActionJob query. Requires organization:manage_users; per-item failures (not found, self-deactivation) surface in `errors`, not as request errors. */
  bulkDeactivateUsers: UserBulkActionJob;
  /** Fire-and-poll variant of bulkDeactivateUsers: submits the job and returns its id immediately with status PENDING. Follow up via userBulkActionJob. */
  bulkDeactivateUsersAsync: UserBulkActionJob;
  /** Bulk-invites users by email, waiting on the result — the same submit/poll/budget contract as bulkDeactivateUsers. Per-item outcomes: new users are created and invited (`invitedCount`), pending users get their invitation re-sent with a fresh token (`resentCount`), and emails of disabled users are skipped with a per-item error — bulk invite never reactivates, a deliberate deviation from the legacy sync invite endpoint. Repeated emails are deduped keep-first. Invite items are keyed by email, so entries in `errors` carry `email` rather than `userId`. Requires organization:manage_users. */
  bulkInviteUsers: UserBulkActionJob;
  /** Fire-and-poll variant of bulkInviteUsers: submits the job and returns its id immediately with status PENDING. The invite modal is expected to use this variant — invite lists can run to hundreds of entries. Follow up via userBulkActionJob. */
  bulkInviteUsersAsync: UserBulkActionJob;
  /** Bulk-removes users from the organization, waiting on the result — the same submit/poll/budget contract as bulkDeactivateUsers. Each removal runs the single-user removal's full cascading cleanup (membership, authorization, org roles, policy statements, group memberships) and deprovisions the user's seat reservations. Organization owners and the requesting actor cannot be removed and surface in `errors`, not as request errors. Removal is the slowest bulk action, so larger batches commonly return IN_PROGRESS and complete via userBulkActionJob. Requires organization:manage_users. */
  bulkRemoveUsers: UserBulkActionJob;
  /** Fire-and-poll variant of bulkRemoveUsers: submits the job and returns its id immediately with status PENDING. Follow up via userBulkActionJob. */
  bulkRemoveUsersAsync: UserBulkActionJob;
  /** Bulk updates custom working hours for a single location by overriding all the custom working hours to the custom working hour objects provided in the payload. There are three scenarios: If a custom working hour object in the payload has an ID, it updates that object in the db with the corresponding ID If no ID is provided with a custom working hour object, a new object is created in the db If there are objects in the db that is not defined in the payload, they are deleted If there is a failure for one of the objects, the entire operation fails and reverts to custom working hours before the request was made. */
  bulkUpdateCustomWorkingHours: Maybe<Scalars['Void']>;
  cancelActivity: Maybe<Scalars['Void']>;
  /** Cancel an existing employee visit */
  cancelEmployeeVisit: Maybe<Scalars['Void']>;
  cancelEmployeeVisitsAtLocationForEmployee: Maybe<Scalars['Void']>;
  cancelEmployeeVisitsForEmployee: Maybe<Scalars['Void']>;
  /** Cancel event by event ID */
  cancelEvent: Maybe<Scalars['Void']>;
  /** Cancel an event, one occurrence of a series, or the series from an occurrence on, as the organizer or as the room. Same endpoints the event composer's Event Details delete uses. The existing cancelEvent stays as it is. */
  cancelEventV2: CancelEventV2Response;
  cancelGuestInvite: Maybe<Scalars['Void']>;
  cancelGuestInvites: Maybe<Scalars['Void']>;
  /** Marks a message as canceled. This is used to stop processing a question. */
  cancelInsightsAssistantMessage: Maybe<Scalars['Void']>;
  cancelVisit: Maybe<Scalars['Void']>;
  /** Change the answers to the questions on a meeting service request. The current CompletedTicketForm.id must be passed in to ensure that the client is working from the latest version. If someone else changes the answers in the meantime, the update will fail with "CONFLICT". */
  changeAnswersOnMeetingServiceRequest: ChangeAnswersOnMeetingServiceRequestResponse;
  /** Changes the Brivo lock links. Can add, change, or remove links. */
  changeBrivoLockLinks: ChangeBrivoLockLinksResponse;
  /** Changes the Gallagher door links. Can add, change, or remove links. */
  changeGallagherDoorLinksForIntegration: ChangeGallagherDoorLinksForIntegrationResponse;
  /** Changes the Genea lock links. Can add, change, or remove links. */
  changeGeneaDoorLinks: ChangeGeneaLockLinksResponse;
  /** Reconciles source→Robin-location mappings (exact id or glob pattern) for a universal connector integration: a mapping with a robinLocationId is added or updated, and one with a null robinLocationId is removed. */
  changeGenericConnectorSourceMappings: ChangeGenericConnectorSourceMappingsResponse;
  /** Changes the Genetec door links. Can add, change, or remove links. */
  changeGenetecDoorLinksForIntegration: ChangeGenetecDoorLinksForIntegrationResponse;
  /** Maps Google Meet devices to Robin spaces for the current tenant. A null robinSpaceId unlinks the device. */
  changeGoogleMeetDeviceLinks: ChangeGoogleMeetDeviceLinksResponse;
  /** This mutation is used to change the Robin level a Kisi lock is linked to. It can also be used to create a new link between a Kisi lock and a Robin level. */
  changeKisiLockLinkToRobinLevel: Maybe<ChangeKisiLockLinkToRobinLevelResponse>;
  changeKisiLockLinkToRobinLocation: Maybe<ChangeKisiLockLinkToRobinLocationResponse>;
  /** Changes the LogiSync place → Robin space links. Can add, change, or remove links. */
  changeLogiSyncPlaceLinks: ChangeLogiSyncPlaceLinksResponse;
  /** Maps Neat Pulse rooms to Robin spaces for the current tenant. A null robinSpaceId unlinks the room. */
  changeNeatPulseRoomLinks: ChangeNeatPulseRoomLinksResponse;
  /** Changes the Openpath lock links. Can add, change, or remove links. */
  changeOpenpathLockLinks: ChangeOpenpathLockLinksResponse;
  /** Changes the Verkada door links. Can add, change, or remove links. */
  changeVerkadaDoorLinks: ChangeVerkadaLockLinksResponse;
  /** Maps Zoom Rooms to Robin spaces for the current tenant. A null robinSpaceId unlinks the room. */
  changeZoomRoomsRoomLinks: ChangeZoomRoomsRoomLinksResponse;
  /** check into a visit that was self-registered from the arrival display */
  checkIntoSelfRegisteredVisitFromArrivalDisplay: Maybe<Scalars['Void']>;
  /**
   * check into a visit using a guest's magic link
   * @deprecated checkIntoVisit is deprecated. Use checkIntoVisitWithMagicLink instead.
   */
  checkIntoVisit: Maybe<Scalars['Void']>;
  /** check into a visit for a location that does not require HCP from the arrival display */
  checkIntoVisitFromArrivalDisplay: Maybe<Scalars['Void']>;
  checkIntoVisitFromDashboard: Maybe<Scalars['Void']>;
  /**
   * check into a visit for a location that requires HCP from the arrival display
   * @deprecated Use checkIntoSelfRegisteredVisitFromArrivalDisplay instead
   */
  checkIntoVisitRequiringHCPFromArrivalDisplay: Maybe<Scalars['Void']>;
  /** check into a visit using a guest's magic link */
  checkIntoVisitWithMagicLink: Maybe<Scalars['Void']>;
  /** Check in multiple guests at once from the visit admin dashboard. The same rules as `checkIntoVisitFromDashboard` are applied to every supplied guest invite, independently. Each successful check-in is committed on its own, so a failure on one guest never rolls back or blocks the others. The guest invite ids that could not be checked in are returned in `failedGuestInviteIds` (empty when all succeeded); the guests that did succeed remain checked in. */
  checkIntoVisitsFromDashboard: CheckIntoVisitsFromDashboardResult;
  /** check out a guest from the arrival display */
  checkOutGuestFromArrivalDisplay: Maybe<Scalars['Void']>;
  /** check out a guest from the visit admin dashboard */
  checkOutGuestFromDashboard: Maybe<Scalars['Void']>;
  clearDraftAssignments: Maybe<UpdateDraftResponse>;
  clearDraftNeighborhoodChanges: UpdateDraftNeighborhoodResponse;
  /** Complete a a survey response */
  completeSurveyResponse: Maybe<SurveyResponse>;
  confirmDeskReservation: Maybe<Scalars['Void']>;
  /** Confirm the desk reservation for the given user. Requires a token with elevated scopes. Allows bypassing confirmation checks, as this should be used when there's real user presence in the office. */
  confirmDeskReservationBypassingConfirmationWindowDelegated: Maybe<Scalars['Void']>;
  /** Confirm the desk reservation for the given user. Requires a token with elevated scopes. */
  confirmDeskReservationDelegated: Maybe<Scalars['Void']>;
  /** Confirm event by event ID */
  confirmEvent: Maybe<Scalars['Void']>;
  /** Connects Gallagher account. */
  connectGallagherAccountForCurrentTenant: ConnectGallagherAccountForCurrentTenantResponse;
  /** Connects Genea account. */
  connectGeneaAccountForCurrentTenant: ConnectGeneaAccountForCurrentTenantResponse;
  connectGenericConnectorAccount: ConnectGenericConnectorAccountResponse;
  /** Connects Genetec account. */
  connectGenetecAccountForCurrentTenant: ConnectGenetecAccountForCurrentTenantResponse;
  /** Connects Google account. Account credentials are managed by Robin platform. */
  connectGoogleAccountForCurrentTenant: ConnectGoogleAccountForCurrentTenantResponse;
  /** Accepts Kisi admin created API and creates necessary event webhooks. */
  connectKisiAccount: ConnectKisiAccountResponse;
  /** Connects a Logi Sync account for the current tenant. */
  connectLogiSyncAccount: ConnectLogiSyncAccountResponse;
  /** Connects a Neat Pulse account for the current tenant. */
  connectNeatPulseAccount: ConnectNeatPulseAccountResponse;
  /** Accepts OpenPath credentials and sets up the account. */
  connectOpenpathAccount: ConnectOpenpathAccountResponse;
  /** Connects Verkada account. */
  connectVerkadaAccountForCurrentTenant: ConnectVerkadaAccountForCurrentTenantResponse;
  /** Converts an existing API token to a JWT claims token and refresh token pair */
  convertApiTokenToJwtAuth: AuthorizationResponse;
  convertGroupToExternalRipplingGroup: ConvertGroupToExternalRipplingGroupResponse;
  createActivity: CreateActivityReturnType;
  /** Link a custom image and image name with the location of an activity. */
  createActivityCustomImage: Scalars['ID'];
  /** Creates an allocation draft: one way of placing a variation's seats across the building's floors. The chosen variation is copied onto the draft, so it records what it was built against rather than pointing at something that can change underneath it. */
  createAllocation: CreateAllocationResponse;
  /** Create a new amenity (applies to neither spaces or desks if no configuration is provided) mutation returns the ID of the created amenity */
  createAmenity: Scalars['ID'];
  createAndMapBuildingsFromRippling: CreateAndMapBuildingsFromRipplingResponse;
  /** Create a new announcement for given locations. `status` is ACTIVE by default. - Note: only user actors are allowed to create announcements */
  createAnnouncement: Maybe<Scalars['Void']>;
  /** Create a new announcement to be consumed by SLACK. `status` is ACTIVE by default. */
  createAnnouncementForSlack: Maybe<Scalars['Void']>;
  /** From dashboard on creation of the new arrival display. Creates new device for the given tenant. In event land: Successful create causes event handler to generate new device authentication which is registered against this entity. */
  createArrivalDisplay: Scalars['ArrivalDisplayRegistrationKey'];
  /** Creates a badge CSV upload link, associated with given inputs. */
  createBadgeCSVUploadLink: CreateBadgeCsvUploadLinkResponse;
  /** From dashboard on creation of the new badge printer. Creates new device for the given tenant. */
  createBadgePrinter: Maybe<Scalars['Void']>;
  createBookingWindowPolicyForLocation: Maybe<Scalars['Void']>;
  createBuildingDraft: CreateBuildingDraftResponse;
  /** Creates a new custom form from the input */
  createCustomVisitForm: Maybe<CustomVisitForm>;
  createDelivery: Maybe<Delivery>;
  createDeliveryZone: Maybe<DeliveryZone>;
  createDeskExclusions: Maybe<Array<Scalars['ID']>>;
  createDisposableDraft: CreateDraftResponse;
  createDraft: CreateDraftResponse;
  /** Creates new visit draft. Also deletes old draft data if it exists */
  createDraftVisit: Scalars['ID'];
  /** Creates a new email configuration associated with the given location */
  createEmailConfiguration: Maybe<EmailConfiguration>;
  /** Create an event (v2), optionally booking one or more rooms. Same endpoint and body the event composer uses. */
  createEventV2: CreateEventV2Response;
  createGenericHealthCheckpoint: CreateGenericHealthCheckpointResponse;
  createGroupAndMakeItExternalRipplingGroup: CreateGroupAndMakeItExternalRipplingGroupResponse;
  /** Creates a new integration */
  createIntegration: Maybe<ExternalIntegration>;
  /** Create the org's Jira integration (pending until OAuth completes), or return its pending one. */
  createJiraIntegration: CreateTicketIntegrationResponse;
  createLayoutDraft: CreateDraftResponse;
  createLegacyIntegration: Maybe<LegacyIntegration>;
  /** @deprecated Use `persistNeighborhoods` instead */
  createNeighborhood: Maybe<CreateNeighborhoodResponse>;
  createOfficeAdminRole: Maybe<Scalars['Void']>;
  /** @deprecated createPass is deprecated. Use createPassForPlaces instead. */
  createPass: Maybe<Scalars['Void']>;
  /** Creates a pass for one or more places */
  createPassForPlaces: Maybe<Scalars['Void']>;
  createRobinOrganizationFromRipplingOAuthData: CreateRobinOrganizationFromRipplingOAuthDataResponse;
  createRole: Maybe<Scalars['Void']>;
  /** Create the org's ServiceNow integration (pending until OAuth completes), or return its pending one when the input is the same. For the org's active or deactivated integration on the same instance, stage this OAuth client on it and return it: call beginTicketIntegrationOAuth on the returned id to apply a rotated client. It keeps its default target object. A client that cleans up after an abandoned connect should delete the returned integration only when its status is PENDING. */
  createServiceNowIntegration: CreateTicketIntegrationResponse;
  /** Creates a Sigma user if it doesn't exist */
  createSigmaMember: Maybe<Scalars['ID']>;
  /** Creates a new Sigma workbook in My Documents or Shared */
  createSigmaWorkbook: Maybe<SigmaWorkbook>;
  /** Creates a stack plan for a building. Requires the same `scenario_plan:manage` permission on the building as creating a building draft. */
  createStackPlan: CreateStackPlanResponse;
  /** Records a BU-count variation on a stack plan: how many seats each business unit needs across the building. A stack plan may hold several. */
  createStackPlanAllocation: StackPlanAllocation;
  /** Create external objects in the provider for Robin places that have no match (e.g. new `cmn_location` records), mapping each as it is created. Items are processed in hierarchy order (campus before building before level before space) so parents exist before children; already-mapped places are skipped. At most 200 items per call. If a provider create succeeds but the mapping write fails, the item reports FAILED with reason MAPPING_WRITE_FAILED and carries the created external object — recover by upserting a mapping to it. */
  createTicketIntegrationExternalObjects: CreateTicketIntegrationExternalObjectsResponse;
  /**
   * Internal method to create a new visit with zero side effects.
   * @deprecated Use createVisitWithCustomVisitType
   */
  createVisit: Maybe<Scalars['Void']>;
  /** Internal method to create a new visit with zero side effects using a string visit type. */
  createVisitWithCustomVisitType: Maybe<Scalars['Void']>;
  createWorkPolicy: Maybe<Scalars['Void']>;
  /** Create the org's Zendesk integration (pending until OAuth completes), or return its pending one when the input is the same. */
  createZendeskIntegration: CreateTicketIntegrationResponse;
  customResourceInstancePrePublishDelete: Maybe<Scalars['Void']>;
  /** Save new, or update existing custom resource instances in a pre-publish state. This method is intended to support progressive updates to an in-progress mapping of resources. Changes will be published after save if publishChangesAfterSave is set to true, otherwise the session will remain open and accept additional updates. */
  customResourceInstancePrePublishSave: Maybe<Scalars['Void']>;
  /** Edit a recurring reservation series, modifying only future occurrences. Past reservation events are preserved and unmodified. Returns validation response to ensure the changes comply with resource policies. */
  customResourceRecurringReservationEdit: ScheduleRecurringReservationResponseType;
  /** Confirms multiple reservations in bulk on behalf of a user (internal service only) All reservations must be for the same organization and use the same confirmation timestamp/client type */
  customResourceReservationBulkConfirmInternal: Maybe<BulkResourceReservationConfirmationResponse>;
  /** Cancel a resource reservation completely. Future single day reservations are canceled. Recurring reservation instances are canceled if the fall in the future. */
  customResourceReservationCompletelyCancel: Maybe<CancelResourceReservationCompleteCancelResponseType>;
  /** Reschedule a reservation instance. This allows modifying a single occurrence of a recurring reservation. Or a single day reservation. Returns validation response to ensure the reschedule complies with resource policies. */
  customResourceReservationInstanceReschedule: ScheduleSingleDayReservationResponseType;
  /** Moves remaining reservations from the current resource to a new resource. A new reservation IDs are spawned from this activity. Existing reservations IDs are ended. */
  customResourceReservationMove: Array<ScheduleRecurringReservationResponseType>;
  /** Confirms reservation */
  customResourceReservationSelfConfirm: Maybe<ResourceReservationConfirmationResponse>;
  /** Request to schedule a single day reservation of a resource by ID for another user */
  customResourceScheduleSingleDayDelegateReservation: ScheduleSingleDayReservationResponseType;
  /** Disable a org_visit_type entry matching the given visitTypeName. */
  deactivateVisitTypeForOrg: Maybe<Scalars['Void']>;
  /**
   * Set a decision for a document for a visiting guest for one document within a specified workflow.
   * @deprecated Use decideOutcomeForVisitDocumentFromArrivalDisplay instead
   */
  decideOutcomeForVisitDocument: Maybe<Scalars['Void']>;
  /** Set a decision from the Arrival Display for a document for a visiting guest for one document within a specified workflow. */
  decideOutcomeForVisitDocumentFromArrivalDisplay: Maybe<Scalars['Void']>;
  /** Set a decision from the GuestUI for a document for a visiting guest for one document within a specified workflow. */
  decideOutcomeForVisitDocumentFromGuestUI: Maybe<Scalars['Void']>;
  /** Ends or cancels a reservation and updates the user's participation status. Should be used to cancel actor's own reservation. */
  declineAndEndReservation: EndOrCancelReservationResponse;
  /** Soft delete a custom image associated with an activity's location. */
  deleteActivityCustomImage: Maybe<Scalars['Void']>;
  /** Deletes a custom form with the given ID */
  deleteCustomVisitForm: Maybe<Scalars['Void']>;
  deleteDeliveries: Maybe<Scalars['Void']>;
  /** @deprecated use deleteDeliveries instead */
  deleteDelivery: Maybe<Scalars['Void']>;
  /** Remove the delivery reminder interval for the organization */
  deleteDeliveryReminderInterval: DeliverySettings;
  deleteDeliveryZone: Maybe<Scalars['Void']>;
  deleteDeskExclusions: Maybe<Scalars['Void']>;
  deleteDraft: Maybe<Scalars['Void']>;
  deleteDraftV2: Maybe<Scalars['Void']>;
  /** Deletes the email configuration associated with the given location */
  deleteEmailConfiguration: Maybe<Scalars['Void']>;
  deleteExternalRipplingGroup: DeleteExternalRipplingGroupResponse;
  /** Deletes a legacy integration exists for the user by the given type and resource-type Tenant ID is also taken into account Returns the id of the deleted integration */
  deleteLegacyIntegrationByType: Maybe<Scalars['Int']>;
  /** Soft deletes meeting services by ids. Idempotent. It does not cancel any meeting requests already created under those services. */
  deleteMeetingServices: Maybe<Scalars['Void']>;
  /** Delete a meeting services category. Idempotent. Fails if the category has meeting services associated with it. */
  deleteMeetingServicesCategory: DeleteMeetingServicesCategoryResponse;
  /** Deletes a meeting service request by ID. Idempotent. */
  deleteOrCancelMeetingServiceRequest: Maybe<Scalars['Void']>;
  deletePass: Maybe<Scalars['Void']>;
  /** Delete an integration. It is never connected again; connecting again creates a new integration. Deleting a deleted integration succeeds. */
  deleteTicketIntegration: DeleteTicketIntegrationResponse;
  disableAnonymityModeForOrg: Maybe<Scalars['Void']>;
  disableGeofenceFeatureForBuilding: Maybe<Scalars['Void']>;
  disableGeofenceFeatureForMe: Maybe<Scalars['Void']>;
  disableOrganizationUser: Maybe<Scalars['Void']>;
  disablePassiveCheckInFeatureForBuilding: Maybe<Scalars['Void']>;
  disableSpaces: DisableSpacesResults;
  /** Discards a stack plan and every allocation draft under it. Scenario drafts implementing those allocations are left alone — they are work in their own right, and keep the allocation id they were built from. There is no way to discard one allocation draft on its own: a stack plan is the unit a planner abandons. */
  discardStackPlan: DiscardStackPlanResponse;
  /** Disables Brivo integration for the current tenant. */
  disconnectBrivoAccountForCurrentTenant: DisconnectBrivoAccountResponse;
  /** Disables Gallagher integration by given UUID. */
  disconnectGallagherAccountByIntegrationUuid: DisconnectGallagherAccountByIntegrationUuidResponse;
  /** Disables Genea integration by given UUID. */
  disconnectGeneaAccountByIntegrationUuid: DisconnectGeneaAccountByIntegrationUuidResponse;
  /** Disconnects a generic connector integration by given UUID. */
  disconnectGenericConnectorAccountByIntegrationUuid: DisconnectGenericConnectorAccountByIntegrationUuidResponse;
  /** Disables Genetec integration by given UUID. */
  disconnectGenetecAccountByIntegrationUuid: DisconnectGenetecAccountByIntegrationUuidResponse;
  /** Disconnects Google integration by given UUID. */
  disconnectGoogleAccountByIntegrationUuid: DisconnectGoogleAccountByIntegrationUuidResponse;
  /** Disables Kisi integration for the current tenant. */
  disconnectKisiAccount: DisconnnectKisiAccountResponse;
  /** Disconnects a Logi Sync account by integration UUID. */
  disconnectLogiSyncAccountByIntegrationUuid: DisconnectLogiSyncAccountByIntegrationUuidResponse;
  /** Disconnects a Neat Pulse account by integration UUID. */
  disconnectNeatPulseAccountByIntegrationUuid: DisconnectNeatPulseAccountByIntegrationUuidResponse;
  /** Disables OpenPath integration for the current tenant. */
  disconnectOpenpathAccount: DisconnectOpenpathAccountResponse;
  /** Disables Verkada integration by given UUID. */
  disconnectVerkadaAccountByIntegrationUuid: DisconnectVerkadaAccountByIntegrationUuidResponse;
  /** Disconnects a Zoom Rooms account by integration UUID. */
  disconnectZoomRoomsAccountByIntegrationUuid: DisconnectZoomRoomsAccountByIntegrationUuidResponse;
  /** Kicks off a one-shot backwards correlation of the tenant's Google Meet hardware to Robin spaces, using recent call history. Called after an admin grants the Meet audit + calendar scopes, so the collector can map devices to rooms without any manual configuration. The optional input scopes which spaces the run may correlate into and which history window it reads; omitted, the run crawls the tenant's whole estate over the default window. */
  discoverGoogleMeetDevices: DiscoverGoogleMeetDevicesResponse;
  /** Dismiss a survey response */
  dismissSurveyResponse: Maybe<SurveyResponse>;
  editCustomResourceTemplate: Maybe<Scalars['Void']>;
  /** Edits record to visit draft. If there are not guests in guests array the record will be deleted instead. */
  editDraftVisitRecord: Maybe<Scalars['Void']>;
  /** Edit a meeting services category. Idempotent. Changing the name affects existing services. Changing the key affects existing services, but only applies to new requests going forward. Existing requests will continue to use the old key. */
  editMeetingServicesCategory: EditMeetingServicesCategoryResponse;
  employeeRegisteredForWaitlistVisit: Maybe<Scalars['Void']>;
  employeeVisit: EmployeeVisitMutations;
  enableAnonymityModeForOrg: Maybe<Scalars['Void']>;
  enableGeofenceFeatureForBuilding: Maybe<Scalars['Void']>;
  enableGeofenceFeatureForMe: Maybe<Scalars['Void']>;
  enableOrganizationUser: Maybe<Scalars['Void']>;
  enablePassiveCheckInFeatureForBuilding: Maybe<Scalars['Void']>;
  /** Terminates a conversation setting active to false. */
  endInsightsAssistantConversation: Maybe<Scalars['Void']>;
  endInsightsAssistantConversationV2: Maybe<Scalars['Void']>;
  /** Ends or cancels a reservation via delegation */
  endOrCancelDelegatedReservation: EndOrCancelReservationResponse;
  /** Ends or cancels a reservation. Should be used to cancel actor's own reservation. */
  endOrCancelReservation: EndOrCancelReservationResponse;
  endReservationOrVisitsInRange: Maybe<EndReservationOrVisitInRangeResponse>;
  /** Accepts a list of records and force resolves them to a success state */
  forceResolveCSVUploadRecords: ForceResolveCsvUploadRecordsResponse;
  /** Computes and persists the best-seat recommendation for a user. Requires organization:manage_users. */
  generateAssignmentRecommendation: AssignmentRecommendationResult;
  generateStickerBatch: GenerateStickerBatchResponse;
  /** A guest invite failed their health checkpoint */
  guestHealthCheckpointFailed: Maybe<Scalars['Void']>;
  /** Called when a guest's invitation email has been sent */
  guestInvited: Maybe<Scalars['Void']>;
  /** Handle department data for all users with department strings for an organization. */
  handleDepartmentDataForOrganization: Maybe<Scalars['Void']>;
  /** Initiates Brivo account connection. Will return an OAuth URL client should use. */
  initiateBrivoAccountConnectionForCurrentTenant: InitiateBrivoAccountConnectionForCurrentTenantResponse;
  initiateRipplingConnectionAndSync: InitiateRipplingConnectionAndSyncResponse;
  initiateRipplingUserSync: InitiateRipplingUserSyncResponse;
  /** Initiates a Zoom Rooms account connection for the current tenant. Returns an authorization URL the user should open in a popup to complete the OAuth flow. */
  initiateZoomRoomsAccountConnectionForCurrentTenant: InitiateZoomRoomsAccountConnectionForCurrentTenantResponse;
  inviteOfficeAdminUsers: Maybe<Scalars['Void']>;
  inviteUsersToDraft: Maybe<Scalars['Void']>;
  /** @deprecated Use inviteUsersToDraft instead */
  inviteUsersToDraftAsCollaborators: Maybe<Scalars['Void']>;
  inviteUsersToDraftV2: Maybe<Scalars['Void']>;
  joinActivity: Maybe<Scalars['Void']>;
  /** Perform whichever action makes sense to allow a user to "Join" the office. If there is a desk reservation reservation, confirm it if allowed. Otherwise, schedule an employee visit. */
  joinOffice: Maybe<Scalars['Void']>;
  linkArrivalDisplayAndBadgePrinter: Maybe<Scalars['Void']>;
  linkKisiLockToRobinLocation: Maybe<LinkKisiLockToRobinLocationResponse>;
  logSpaceSuggestionBooked: Maybe<Scalars['Void']>;
  logSpaceSuggestionDismissed: Maybe<Scalars['Void']>;
  logSpaceSuggestionViewed: Maybe<Scalars['Void']>;
  mapBuildingToRipplingWorkLocation: MapBuildingToRipplingWorkLocationResponse;
  mapBuildingsToRipplingWorkLocations: Array<MapBuildingsToRipplingWorkLocationsResponse>;
  /** Accepts a list of Kisi locks and maps it to Robin locations. */
  mapKisiLocksToRobinLocations: Maybe<MapKisiLocksToRobinLocationsResponse>;
  modifyDraftCollaboratorAccessLevel: Maybe<Scalars['Void']>;
  modifyDraftCollaboratorAccessLevelV2: Maybe<Scalars['Void']>;
  /** Move an event to another room, another time, or both, in one operation. This is the only way to change the room whose calendar organizes an event. Same endpoint and body the event composer uses; robin-api accepts the move and syncs the calendars afterwards, so success means submitted, not landed. */
  moveEvent: MoveEventResponse;
  notifyAffectedUsersOnFloors: SendEmailToAffectedDraftUsersResult;
  /** Parse details from a package label image */
  parseDeliveryImage: ParsedDeliveryImage;
  persistBuildingNeighborhoodsFromDraft: PersistBuildingNeighborhoodsFromDraftResponse;
  persistNeighborhoods: Maybe<PersistNeighborhoodsResponse>;
  publishDraft: Maybe<Scalars['Void']>;
  publishDraftV2: Maybe<Scalars['Void']>;
  publishSharedScheduleForDesk: Maybe<Scalars['Void']>;
  /** Attempts to publish all records tied to the given draft id */
  publishVisitDraft: Scalars['Boolean'];
  /** Requests a reboot of a Neat Pulse device. The reboot is executed asynchronously by Neat; a successful response means the request was accepted, not that the device has rebooted. */
  rebootNeatPulseDevice: RebootNeatPulseDeviceResponse;
  /** Accepts OpenPath credentials and updates the account connection. */
  reconnectOpenpathAccount: ReconnectOpenpathAccountResponse;
  refreshDeviceAuthorization: DeviceAuthorizationResponse;
  /** Re-primes the building-floors-list cache after floors are added/removed. Called by graphql-cache-buster on places-levels events. Intended caller is the graphql-cache-buster service; no additional authorization is needed because the effects are tenant-local and non-destructive (cache refresh/invalidation only). */
  refreshDraftCachesForBuilding: Scalars['Boolean'];
  /** Re-primes draft-service caches for one floor after upstream place changes (desk added/deleted/archived, space/zone changes). Called by graphql-cache-buster on places-seats/spaces/zones events. Refreshes the floor's desk-id list and invalidates all users' cached floor permissions for the floor (via a per-floor generation bump). Intended caller is the graphql-cache-buster service; no additional authorization is needed because the effects are tenant-local and non-destructive (cache refresh/invalidation only). */
  refreshDraftCachesForFloor: Scalars['Boolean'];
  /** Refreshes an existing JWT claims token and refresh token pair */
  refreshJwtAuthToken: AuthorizationResponse;
  /** Ask for the integration's targets to be imported from the provider again. The import runs in the background; `listTicketIntegrationAvailableTargets` reports its progress. */
  refreshTicketIntegrationAvailableTargets: RefreshTicketIntegrationAvailableTargetsResponse;
  /** Register arrival display for service. Each key only works one time. */
  registerArrivalDisplay: ArrivalDisplayRegistrationResponse;
  /**
   * register a guest in a location that doesn't require HCP from the arrival display - automatically checks the visit in
   * @deprecated Use registerGuestWithoutHCPFromArrivalDisplay
   */
  registerGuestFromArrivalDisplay: Maybe<Scalars['Void']>;
  /**
   * create a new visit from dashboard. guests listed will be upserted into the set of known guests, matched by email.
   * @deprecated This creation method will be replaced with a more open usage of visit type. Replaced by administratorRegisterGuest.
   */
  registerGuestFromDashboard: Maybe<Scalars['Void']>;
  /**
   * register a guest in a location that requires a HCP from the arrival display
   * @deprecated Use registerGuestWithHCPFromArrivalDisplayWithCustomVisitType
   */
  registerGuestWithHCPFromArrivalDisplay: Maybe<Scalars['Void']>;
  /** register a guest in a location that requires a HCP from the arrival display using a string visit type */
  registerGuestWithHCPFromArrivalDisplayWithCustomVisitType: Maybe<Scalars['Void']>;
  /**
   * register a guest in a location that doesn't require HCP from the arrival display
   * @deprecated Use registerGuestWithoutHCPFromArrivalDisplayWithCustomVisitType
   */
  registerGuestWithoutHCPFromArrivalDisplay: Maybe<Scalars['Void']>;
  /** register a guest in a location that doesn't require HCP from the arrival display using a string visit type */
  registerGuestWithoutHCPFromArrivalDisplayWithCustomVisitType: Maybe<Scalars['Void']>;
  /** Reject a meeting service request that has status "NEEDS_APPROVAL". Once rejected, the status will change to "REJECTED", similar to "CANCELLED". If the service request has changed since latestChangeId, this fails with "CONFLICT". Only permitted if MeetingServiceRequest.permissions.canApproveOrReject is true. */
  rejectMeetingServiceRequest: RejectMeetingServiceRequestResponse;
  /** Unregister and de-authenticate all devices for location. */
  removeAllDevicesForLocation: Maybe<Scalars['Void']>;
  /** Unregister and de-authenticate an arrival display. */
  removeArrivalDisplay: Maybe<Scalars['Void']>;
  /** Unregister a badge printer. */
  removeBadgePrinter: Maybe<Scalars['Void']>;
  removeBookingWindowPolicyForLocation: Maybe<Scalars['Void']>;
  removeBuildingGeofence: Maybe<Scalars['Void']>;
  /** Removes messages by ID from a chat on activity */
  removeChatMessagesFromActivity: Maybe<Scalars['Void']>;
  removeCustomWorkingHours: Maybe<Scalars['Void']>;
  removeDraftCollaboratorsV2: Maybe<Scalars['Void']>;
  /** Removes relationships by id. The affected endpoints fall back to whatever evidence remains, which may place them somewhere else or nowhere. */
  removeEndpointRelationships: RemoveEndpointRelationshipsResponse;
  /** Remove a host from a visit */
  removeHostFromVisit: Maybe<Scalars['Void']>;
  removeOfficeAdmin: Maybe<Scalars['Void']>;
  /** Remove permissions from roles for a specific target and category */
  removePermissionOnRole: Maybe<Scalars['Void']>;
  removePinnedUserSpaces: Maybe<Scalars['Void']>;
  removeSpaceFromEvent: RemoveSpaceFromEventResponse;
  /** Remove entity mappings. Tickets for those places fall back to the nearest mapped ancestor. Idempotent: entities that have no mapping are reported as removed rather than erroring. At most 200 entities per call. */
  removeTicketIntegrationEntityMappings: RemoveTicketIntegrationEntityMappingsResponse;
  /** Remove field mappings. Idempotent: target fields with no mapping report as removed. At workflow scope this removes the override; the integration-level row (if any) applies again. */
  removeTicketIntegrationFieldMappings: RemoveTicketIntegrationFieldMappingsResponse;
  /** Remove a target config and its field mappings. Workflow bindings that chose it fall back to the default. The default itself cannot be removed. */
  removeTicketIntegrationTargetConfig: RemoveTicketIntegrationTargetConfigResponse;
  /** Stop syncing a workflow's tickets to this integration. */
  removeTicketIntegrationWorkflowBinding: RemoveTicketIntegrationWorkflowBindingResponse;
  removeUserFromFavorites: Maybe<Scalars['Void']>;
  removeUserFromRole: Maybe<Scalars['Void']>;
  removeUsersFromAssignmentsQueue: Maybe<Scalars['Void']>;
  removeUsersFromDraftCollaborators: Maybe<Scalars['Void']>;
  /** Extends the expiration period on an expired, unused arrival display registration. */
  renewArrivalDisplayRegistration: Maybe<Scalars['Void']>;
  /** Used by arrival displays to report their status and to report the status of their connected badge printer. */
  reportDeviceStatus: Maybe<Scalars['Void']>;
  /** Report an issue with a desk - chair is broken, monitor is busted, etc */
  reportIssueWithDesk: ReportIssueResponse;
  /** Report an issue with a space - TV isn't working, table is wobbly, etc */
  reportIssueWithSpace: ReportIssueResponse;
  /** Reports presence from a mobile client via a geofence event. */
  reportMyPresenceViaMobileGeofenceEvent: ReportMyPresenceViaMobileGeofenceEventResponse;
  /** Tells us the device's current IP address. From this, we can infer that the user is present with their device at a building associated with that IP address, and perform side effects like checking them in to their reservations at that building. Don't bother calling this if device is on a cellular data connection or a VPN. */
  reportUserPresenceAtIPAddress: ReportUserPresenceAtIpAddressResponse;
  /** Reports presence from a web client. Similar to reportUserPresenceAtIPAddress, but for web clients, which don't have a direct way to report their IP address. We will be conservative in trusting the remote IP. */
  reportUserPresenceFromWebClient: ReportUserPresenceFromWebClientResponse;
  /** Tells us that the user is present in a particular building at a particular time */
  reportUserPresenceInBuildingAtTime: ReportUserPresenceInBuildingAtTimeResponse;
  /** Creates a meeting service request for a draft event at a space. A "draft event" is one that has not yet been created, so neither Robin nor Google/MS know about it. Service requests created with this mutation are not "real" until we see the event sync back to Robin. Nobody will be emailed until that sync happens. If the draft Event is never saved, then we can have dangling service requests that should be cleaned up later. If the event has already been created, use requestMeetingServiceForExistingEventAtSpace instead. Requires permission to request services at the given spaceId (workplace_services:request). */
  requestMeetingServiceForDraftEventAtSpace: RequestMeetingServiceForDraftEventAtSpaceResponse;
  /** Creates a meeting service request for an existing event at a space. If the event has not been created yet, use requestMeetingServiceForDraftEventAtSpace instead. Requires permission to request services at the given spaceId (workplace_services:request). */
  requestMeetingServiceForExistingEventAtSpace: RequestMeetingServiceForExistingEventAtSpaceResponse;
  resendCollaboratorInvite: Maybe<Scalars['Void']>;
  resendCollaboratorInviteV2: Maybe<Scalars['Void']>;
  /** Creates a new hot/hoteled desk reservationfor a given user on your behalf. */
  reserveDelegatedDesk: Reservation;
  /** Creates a new hot/hoteled desk reservation for the current user. */
  reserveDeskForMe: Reservation;
  /** Reserve a space */
  reserveSpace: ReserveSpaceResponse;
  /** Assign a resource to a user */
  resourceRecurringAssignmentSchedule: ScheduleRecurringReservationResponseType;
  /** Request to schedule a recurring reservation for a specific user by resource ID */
  resourceRecurringReservationSchedule: ScheduleRecurringReservationResponseType;
  /** Sets the policy for a category of resources within a location. This policy change can optionally be applied to all existing resources matching the specified category currently in that location. */
  resourceSetCategoryPolicyOnLocation: ResourceMutationResponseTrackingType;
  rollbackMicrosoftMigration: Maybe<Scalars['Void']>;
  saveMappedGoogleLocations: Maybe<Scalars['Void']>;
  /** Save a new survey configuration */
  saveSurveyConfiguration: Maybe<Survey>;
  scaffoldDemoFloorPlan: Maybe<Scalars['Void']>;
  /** Create a new employee visit */
  scheduleEmployeeVisitAtLocation: Maybe<Scalars['Void']>;
  /** Request to schedule a single day reservation for current user of a resource by ID */
  scheduleSingleDayReservation: ScheduleSingleDayReservationResponseType;
  /**
   * Add a chat message to an activity
   * @deprecated Deprecated in favor of `sendChatOnActivityWithId`
   */
  sendChatOnActivity: Maybe<Scalars['Void']>;
  /** Add a chat message to an activity with client specified UUID identity */
  sendChatOnActivityWithId: Maybe<Scalars['Void']>;
  /**
   * This mutation allows admins to retrigger a notification to a recipient.
   * @deprecated use sendDeliveryNotificationsToRecipients instead
   */
  sendDeliveryNotificationToRecipient: Maybe<Scalars['Void']>;
  /** This mutation allows admins to retrigger notifications to many recipients. */
  sendDeliveryNotificationsToRecipients: Maybe<Scalars['Void']>;
  sendEmailToAffectedDraftUsers: SendEmailToAffectedDraftUsersResult;
  sendEmailToAffectedDraftUsersV2: SendEmailToAffectedDraftUsersResult;
  sendExportCSVChangesOnFloors: SendEmailToAffectedDraftUsersResult;
  /** Sets the auto desk booking setting for current (user) actor */
  setAutoDeskBooking: Maybe<Scalars['Void']>;
  setAutoDeskBookingForOrg: Maybe<Scalars['Void']>;
  /** Requires places:manage permission for the given building. Sets public CIDRs associated with the given building, for use with passive check-in. Idempotent. Number of CIDRs, size of subnet are both limited. Rejects CIDRs that might technically be valid but are likely user error: "1", "1.2", etc. Tries to reject bogons and martians: https://en.wikipedia.org/wiki/Bogon_filtering */
  setBuildingCidrs: SetBuildingCidrsResponse;
  setBuildingGeofenceAsPointWithRadius: SetBuildingGeofenceAsPointWithRadiusResponse;
  /** Sets a channel ID for a user's personal calendar integration. */
  setChannelAndResourceIdsForUserCalendar: Maybe<Scalars['Void']>;
  setCompletedOnboardingStepsForOrg: Maybe<Scalars['Void']>;
  setDefaultLocationForUser: Maybe<Scalars['Void']>;
  /** Set how often to send reminders for uncollected deliveries. */
  setDeliveryReminderInterval: DeliverySettings;
  /** Sets sentAt field for distribution and resolves sendResult to SUCCESS for all provided recipient ids. An error will be thrown if client tries to set send data of a distribution or recipient that has already been set. */
  setDistributionSendData: Maybe<Scalars['Void']>;
  setEmployeeVisitsEnabledForOrg: Maybe<Scalars['Void']>;
  /** Changes the Gallagher e-mail field indentifier. */
  setGallagherEmailFieldIdentifierForIntegration: SetGallagherEmailFieldIdentifierForIntegrationResponse;
  setGoogleWorkingLocationSyncSettingForOrg: Maybe<Scalars['Void']>;
  /** Sets the sync google working locations setting user. 0 for off, org ID for on. */
  setGoogleWorkingLocationSyncSettingForUser: Maybe<Scalars['Void']>;
  /** Sets the homepage preference for current (user) actor. */
  setMyHomepage: Maybe<Scalars['Void']>;
  /** Sets a languge tag for current (user) actor */
  setMyLanguageTag: Maybe<Scalars['Void']>;
  /** Sets working hours for current user */
  setMyWorkingHours: Maybe<Scalars['Void']>;
  /** Update the given notification preference for the current user */
  setNotificationPreferenceForCurrentUser: Maybe<Scalars['Void']>;
  setOpenpathCredentialProvisioningEnabledForIntegration: SetOpenpathCredentialProvisioningEnabledForIntegrationResponse;
  setOpenpathPresenceReportingEnabledForIntegration: SetOpenpathPresenceReportingEnabledForIntegrationResponse;
  setOrganization14Day100UsersTrial: Maybe<Scalars['Void']>;
  /** Set resource permissions within hierarchy */
  setPermissionsOnHierarchy: Maybe<Scalars['Void']>;
  /** Set resource permissions on one or more roles */
  setPermissionsOnRole: Maybe<Scalars['Void']>;
  /** Updates startAt date for recurring distribution announcements and keeps the sentAt field set to null. Sent the startAt date as a ISODateTime */
  setRecurringAnnouncementData: Maybe<Scalars['Void']>;
  /** Enable or disable the require release signature setting */
  setRequireReleaseSignature: DeliverySettings;
  /** Sets the show weekends setting for current (user) actor */
  setShowWeekendsForMe: Maybe<Scalars['Void']>;
  setSuggestedSpacesEnabledForOrg: Maybe<Scalars['Void']>;
  setTeamMembershipByName: Maybe<Scalars['Void']>;
  /** Make one of the integration's target configs its default. */
  setTicketIntegrationDefaultTargetConfig: SetTicketIntegrationDefaultTargetConfigResponse;
  /** Turn each direction of an integration's sync on or off without disconnecting it. An omitted direction keeps its setting. */
  setTicketIntegrationSyncDirections: SetTicketIntegrationSyncDirectionsResponse;
  /** Set the values Robin fills in when a synced ticket's status change needs a provider transition whose screen requires fields (a Jira Resolution, for example). Replaces the values for that status; an empty list clears them. A required field with no value leaves the status unsynced and is logged. */
  setTicketIntegrationTargetConfigTransitionFields: SetTicketIntegrationTargetConfigTransitionFieldsResponse;
  /** Bind an issue report workflow to this integration; its bindings to other integrations stay, so a report can go to several. Each integration takes the reports from the buildings its place mappings cover (every building when it has none). `targetConfigId` null = the integration's default. */
  setTicketIntegrationWorkflowBinding: SetTicketIntegrationWorkflowBindingResponse;
  /** Sets a user notification setting. */
  setUserNotificationSetting: Maybe<Scalars['Void']>;
  /** Set the complete host list for a visit (replaces all existing hosts). The first host in the array becomes the primary host. Hosts not in the array will be removed (soft deleted). */
  setVisitHosts: Maybe<Scalars['Void']>;
  /** Begins a new empty active conversation. */
  startInsightsAssistantConversation: InsightsAssistantConversationV1;
  /** Begins a new empty active V2 conversation and creates a thread. */
  startInsightsAssistantConversationV2: InsightsAssistantConversationV2;
  /** Start (or join) the background object import for an integration: fetches the provider a page at a time, persisting imported objects for `listTicketIntegrationExternalObjects` to read, then matches them against Robin places. Idempotent per integration — a caller while one is already in flight joins it and gets the same import back rather than starting a duplicate. Re-sync (calling again once complete) starts a fresh full fetch. Poll `ticketIntegrationObjectImportStatus` for progress. */
  startTicketIntegrationObjectImport: StartTicketIntegrationObjectImportResponse;
  /** Temporary migration query which generates and returns the client secret for existing arrival displays */
  tempArrivalDisplayAuthMigration: ArrivalDisplayRegistrationResponse;
  /** Readiness check: the integration is active and has stored credentials (not a live provider round-trip). */
  testTicketIntegration: TestTicketIntegrationResponse;
  toggleDraftLock: ToggleDraftLockResponse;
  toggleDraftLockV2: ToggleDraftLockResponse;
  triggerManualSyncOfSpaceCalendar: Maybe<Scalars['Void']>;
  unassignSticker: Maybe<Scalars['Void']>;
  unassignUsersFromDraft: UpdateDraftResponse;
  unjoinActivity: Maybe<Scalars['Void']>;
  unlinkArrivalDisplayAndBadgePrinter: Maybe<Scalars['Void']>;
  /** This mutation is used to unlink a Kisi lock from a Robin level. If the lock is linked to a Robin location, it will not be unlinked from the location. */
  unlinkKisiLockFromRobinLevel: Maybe<UnlinkKisiLockFromRobinLevelResponse>;
  unlinkKisiLockFromRobinLocation: Maybe<UnlinkKisiLockFromRobinLocationResponse>;
  /** To be used when a location is deleted */
  unlinkLocationFromCustomForms: Maybe<Scalars['Void']>;
  /** Unlocks Openpath door. */
  unlockOpenpathDoorForProvisionedCredentials: UnlockOpenpathDoorForProvisionedCredentialsResponse;
  /** This mutation understands the input as the state of the activity, therefore it will update every field according to the input */
  updateActivity: Maybe<Scalars['Void']>;
  /** The same, for one allocation draft under a stack plan. */
  updateAllocationMetadata: UpdatePlanningDraftMetadataResponse;
  /** Update a single (ACTIVE or SCHEDULED) announcement. Author cannot change. */
  updateAnnouncement: Maybe<Scalars['Void']>;
  /** From the Dashboard, users can edit arrival displays they've already created. */
  updateArrivalDisplay: Maybe<Scalars['Void']>;
  /** From the Dashboard, users can edit badge printers they've already created. */
  updateBadgePrinter: Maybe<Scalars['Void']>;
  updateBookingWindowPolicyForLocation: Maybe<Scalars['Void']>;
  /** Updates an existing custom resource template's associated amenities */
  updateCustomResourceTemplateAssociatedAmenities: Maybe<Scalars['Void']>;
  /** Updates subcategories in a custom resource template. For each subcategory to be updated, you must provide both the original value and the new value to ensure proper replacement. */
  updateCustomResourceTemplateSubcategories: EventTrackingOnlyResponse;
  /** Updates a given custom form with the provided updates */
  updateCustomVisitForm: Maybe<CustomVisitForm>;
  updateCustomWorkingHours: Maybe<Scalars['Void']>;
  /** Updates the default pass setting */
  updateDefaultPass: Maybe<Scalars['Void']>;
  updateDelivery: Maybe<Delivery>;
  /** This route allows user's with magic links to update delivery status. */
  updateDeliveryStatusByMagicLink: Delivery;
  updateDeliveryZone: DeliveryZone;
  updateDistributionsByAnnouncementId: Maybe<Scalars['Void']>;
  updateDraft: UpdateDraftResponse;
  updateDraftData: UpdateDraftDataResponse;
  updateDraftDataV2: UpdateDraftDataV2Response;
  /** Updates last heartbeat of given draft */
  updateDraftHeartbeat: Maybe<Scalars['Void']>;
  updateDraftMetadata: Maybe<Scalars['Void']>;
  updateDraftMetadataV2: Maybe<UpdateDraftMetadataV2Response>;
  updateDraftNeighborhood: UpdateDraftNeighborhoodResponse;
  updateDraftNeighborhoodV2: UpdateDraftNeighborhoodResponse;
  updateDraftV2: UpdateDraftResponse;
  /** Updates the email configuration associated with the given location */
  updateEmailConfiguration: Maybe<EmailConfiguration>;
  /** Update an event (v2): title, time, people, rooms or recurrence, for one occurrence or a series. Same endpoint and body the event composer uses. */
  updateEventV2: UpdateEventV2Response;
  /** Rewrites the floor split of an allocation draft. Each floor sent replaces that floor's rows outright; floors left out are untouched. A split that does not add up is reported rather than refused. */
  updateFloorAllocations: UpdateFloorAllocationsResponse;
  updateGenericConnectorAccount: UpdateGenericConnectorAccountResponse;
  /** Update host settings for a visit */
  updateHostSettings: Maybe<Scalars['Void']>;
  /** Adds feedback for a given message. */
  updateInsightsAssistantFeedbackForMessage: Maybe<Scalars['Void']>;
  updateInsightsAssistantFeedbackForMessageV2: Maybe<Scalars['Void']>;
  /** Update an issue report, as an assignee of the report, a manager of its building, or its requester within the limits on `changes`. */
  updateIssueReport: UpdateIssueReportResponse;
  updateLayoutDraft: UpdateLayoutDraftResponse;
  /** Change a meeting service, keeping the old versions of questions around for existing requests. Clients must have an accurate picture of previous state, so conflicting changes are rejected. Future iterations of this mutation might be diff-based (e.g. adding spaces instead of passing the whole list back and forth). Partial updates are supported by omitting fields, rather than explicitly setting them to null. */
  updateMeetingService: UpdateMeetingServiceResponse;
  /** Updates a ticket status based on current status. Idempotent. */
  updateMeetingServiceRequestStatus: UpdateMeetingServiceRequestStatusResponse;
  /** Updates the desk, start time, and end time for the current user's non-recurring desk reservation. */
  updateMyReservationDeskAndTimeFrame: UpdateDeskReservationResponse;
  /** @deprecated updatePass is deprecated. Use updatePassForPlaces instead. */
  updatePass: Maybe<Scalars['Void']>;
  /** Updates a pass for one or more places */
  updatePassForPlaces: Maybe<Scalars['Void']>;
  /** Updates the desk RDATES for the user's recurring desk reservation. */
  updateRecurringReservationDates: Maybe<Scalars['Void']>;
  /** Updates the complete RDATE rule for the user's recurring desk reservation. */
  updateRecurringReservationRdate: Maybe<Scalars['Void']>;
  /** Updates the visibility of a desk reservation. */
  updateReservationVisibility: Maybe<Scalars['Void']>;
  updateShowNeighborhoodColor: UpdateShowNeighborhoodColorResponse;
  updateShowNeighborhoodColorV2: UpdateShowNeighborhoodColorV2Response;
  /** Rewrites one of a stack plan's BU-count variations in place, while nothing implements it yet. Once an allocation draft implements a variation the variation is frozen and the write is refused — record a second variation on the plan and compare the two instead. */
  updateStackPlanAllocation: UpdateStackPlanAllocationResponse;
  /** Renames a stack plan and sets the description of what the replan is for. */
  updateStackPlanMetadata: UpdatePlanningDraftMetadataResponse;
  updateStandardWorkingHoursForLocation: Maybe<Scalars['Void']>;
  /** Update an existing survey configuration */
  updateSurveyConfiguration: Maybe<Survey>;
  /** Allows a robin administrator to update a visit */
  updateVisit: Maybe<Scalars['Void']>;
  updateWorkAreas: Array<WorkArea>;
  updateWorkPolicy: Maybe<Scalars['Void']>;
  /** Upsert entity mappings (keyed by Robin entity within the integration). Mappings take effect immediately; a removed or missing mapping never drops a ticket — outbound resolution falls back to the nearest mapped ancestor. When no ancestor is mapped at all, sync degrades per field: an optional external field is omitted (with a warning in the sync log); a required external field parks the link as deferred with a readable sync error — no retry attempts are burned, and the ticket syncs late rather than never. Upserting a mapping re-enqueues any links parked on a missing mapping for this integration. At most 200 entityMappings per call; duplicate entries for one place collapse to the last occurrence. */
  upsertTicketIntegrationEntityMappings: UpsertTicketIntegrationEntityMappingsResponse;
  /** Upsert field mappings (keyed by target field within integration + workflow scope + target config). All-or-nothing; `itemErrors` carries input indices. Each mapping is checked against the provider's live target fields. */
  upsertTicketIntegrationFieldMappings: UpsertTicketIntegrationFieldMappingsResponse;
  /** Upsert this integration's object-class assignments: which place entity type each external object class stands in for, and which class is the create target per entity type. All-or-nothing — an invalid item rejects the whole batch with INVALID_INPUT and nothing is written. entityType: null unassigns the class: it is no longer suggested and object imports leave it out. Assigning a class the latest object import didn't cover starts an incremental object import scoped to the newly-assigned class ids. */
  upsertTicketIntegrationObjectClassAssignments: UpsertTicketIntegrationObjectClassAssignmentsResponse;
  /** Store data that user has viewed an announcement at the given location. */
  viewAnnouncement: Maybe<Scalars['Void']>;
  viewAnnouncementForMultipleLocations: Maybe<Scalars['Void']>;
  /** Add a new document task to visit workflows for the specified visit types and locations */
  visitAddDocumentTask: Maybe<Scalars['Void']>;
  /** Archive an existing document. The specified document is removed from all live workflows. */
  visitArchiveDocument: Maybe<Scalars['Void']>;
  /** Update the status of an async visit request. This mutation is only accessible using an internal service auth token. */
  visitAsyncRequestStatusReport: Maybe<Scalars['Void']>;
  /**
   * Update a document task to apply to a new visit workflow for the specified visit types and locations
   * @deprecated Use visitChangeDocumentTaskAssociationsWithCustomVisitType instead
   */
  visitChangeDocumentTaskAssociations: Maybe<Scalars['Void']>;
  /** Update a document task to apply to a new visit workflow for the specified visit types and locations */
  visitChangeDocumentTaskAssociationsWithCustomVisitType: Maybe<Scalars['Void']>;
};


export type MutationAcknowledgeAnnouncementArgs = {
  announcementId: Scalars['ID'];
  locationId: Scalars['ID'];
};


export type MutationAcknowledgeAnnouncementForMultipleLocationsArgs = {
  announcementId: Scalars['ID'];
  locationIds: Array<Scalars['ID']>;
};


export type MutationAcknowledgeVisitEventHandledArgs = {
  eventType: VisitEventAcknowledgement;
  visitId: Scalars['ID'];
};


export type MutationAddCustomResourceTemplateArgs = {
  associatedAmenityIds?: InputMaybe<Array<Scalars['ID']>>;
  description?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<IconType>;
  organizationID: Scalars['ID'];
  policyConfiguration?: InputMaybe<CustomResourcePolicyDocumentCommand>;
  resourceCategory: Scalars['String'];
  resourceCategorySingular?: InputMaybe<Scalars['String']>;
  subCategories?: InputMaybe<Array<Scalars['CustomResourceSubCategoryType']>>;
  templateId: Scalars['ID'];
};


export type MutationAddCustomWorkingHoursArgs = {
  customWorkingHours: CustomWorkingHoursInput;
};


export type MutationAddDraftVisitRecordArgs = {
  arrivalInstructions?: InputMaybe<Scalars['String']>;
  arrivalLocationId: Scalars['ID'];
  checkInGuest?: InputMaybe<Scalars['Boolean']>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  eventUid: Scalars['String'];
  guests: Array<GuestInputType>;
  hostUserId: Scalars['ID'];
  provisionCredentials?: InputMaybe<Scalars['Boolean']>;
  sendGuestEmailInvite?: InputMaybe<Scalars['Boolean']>;
  startTime: Scalars['ISODateTime'];
  visitType: Scalars['String'];
};


export type MutationAddEndpointRelationshipsArgs = {
  input: AddEndpointRelationshipsInput;
};


export type MutationAddGuestBadgeImageArgs = {
  base64Image: Scalars['String'];
  guestInviteId: Scalars['ID'];
};


export type MutationAddHostToVisitArgs = {
  host: VisitHostInput;
  visitId: Scalars['ID'];
};


export type MutationAddInsightsAssistantInboundMessageToConversationArgs = {
  conversationId: Scalars['ID'];
  text: Scalars['String'];
};


export type MutationAddInsightsAssistantOutboundMessageToConversationArgs = {
  conversationId: Scalars['ID'];
  parentMessageId?: InputMaybe<Scalars['ID']>;
  text: Scalars['String'];
};


export type MutationAddLevelToLocationArgs = {
  locationId: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationAddLevelsToLocationArgs = {
  locationId: Scalars['ID'];
  names: Array<Scalars['String']>;
};


export type MutationAddLevelsWithDetailsToLocationArgs = {
  levels: Array<CreateLevelInput>;
  locationId: Scalars['ID'];
};


export type MutationAddLocationToOrganizationArgs = {
  address: Scalars['String'];
  name: Scalars['String'];
  timeZone: Scalars['String'];
};


export type MutationAddMeetingServiceArgs = {
  input: AddMeetingServiceInput;
};


export type MutationAddMeetingServicesCategoryArgs = {
  input: AddMeetingServicesCategoryInput;
};


export type MutationAddOfficeAdminArgs = {
  locationId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationAddOrUpdateLevelSettingArgs = {
  levelId: Scalars['ID'];
  setting: SettingInput;
};


export type MutationAddOrganizationArgs = {
  name: Scalars['String'];
  slug: Scalars['String'];
};


export type MutationAddPinnedUserSpacesArgs = {
  locationId: Scalars['String'];
  spaceIds: Array<Scalars['String']>;
};


export type MutationAddSpaceToEventArgs = {
  request?: InputMaybe<AddSpaceToEventRequest>;
};


export type MutationAddSubcategoryToCustomTemplateArgs = {
  organizationId: Scalars['ID'];
  subcategory: Scalars['CustomResourceSubCategoryType'];
  templateId: Scalars['ID'];
};


export type MutationAddTicketIntegrationTargetConfigsArgs = {
  input: AddTicketIntegrationTargetConfigsInput;
};


export type MutationAddUserToAssignmentsQueueArgs = {
  id: Scalars['ID'];
  levelId?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type MutationAddUserToFavoritesArgs = {
  userId: Scalars['String'];
};


export type MutationAddUserToRoleArgs = {
  roleSlug: Scalars['String'];
  userId: Scalars['ID'];
};


export type MutationAddUsersToAssignmentsQueueArgs = {
  id: Scalars['ID'];
  levelId: Scalars['ID'];
  userIds: Array<Scalars['ID']>;
};


export type MutationAddVisitTypeForOrgArgs = {
  locationId?: InputMaybe<Scalars['ID']>;
  visitTypeName: Scalars['String'];
};


export type MutationAdministratorRegisterGuestArgs = {
  arrivalInstructions?: InputMaybe<Scalars['String']>;
  arrivalLocationId: Scalars['ID'];
  checkInGuest?: InputMaybe<Scalars['Boolean']>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  guests: Array<GuestInputType>;
  hosts?: InputMaybe<Array<VisitHostInput>>;
  provisionCredentials?: InputMaybe<Scalars['Boolean']>;
  sendGuestEmailInvite?: InputMaybe<Scalars['Boolean']>;
  startTime: Scalars['ISODateTime'];
  visitType: Scalars['String'];
};


export type MutationAllocateStickersToOrgArgs = {
  input: AllocateStickersToOrgRequest;
};


export type MutationAllocateStickersToOrgByDisplayCodeArgs = {
  input: AllocateStickersToOrgByDisplayCodeRequest;
};


export type MutationApproveMeetingServiceRequestArgs = {
  input: ApproveMeetingServiceRequestInput;
};


export type MutationArchiveAnnouncementArgs = {
  announcementId: Scalars['ID'];
};


export type MutationArchiveAnnouncementForSlackArgs = {
  announcementId: Scalars['ID'];
};


export type MutationArchiveIntegrationByIdArgs = {
  id: Scalars['ID'];
};


export type MutationAssertGuestIdentityArgs = {
  guestEmail: Scalars['String'];
  guestName: Scalars['String'];
};


export type MutationAssignDelegatedDeskArgs = {
  email: Scalars['String'];
  notify?: InputMaybe<Scalars['Boolean']>;
  seatId: Scalars['Int'];
  start: DateWithTimezone;
  visibility?: InputMaybe<DeskReservationVisibility>;
};


export type MutationAssignDeskToMeArgs = {
  notify?: InputMaybe<Scalars['Boolean']>;
  seatId: Scalars['Int'];
  start: DateWithTimezone;
  visibility?: InputMaybe<DeskReservationVisibility>;
};


export type MutationAssignStickerToCustomResourceByShortCodeArgs = {
  input: AssignStickerToCustomResourceByShortCodeRequest;
};


export type MutationAssignStickerToDeskByShortCodeArgs = {
  input: AssignStickerToDeskByShortCodeRequest;
};


export type MutationAssignStickersArgs = {
  input: AssignStickerRequest;
};


export type MutationAssociateHealthCheckpointWithVisitArgs = {
  guestInviteId: Scalars['ID'];
  healthCheckpointId: Scalars['ID'];
};


export type MutationAuthenticateVisitorWithMagicLinkArgs = {
  magicLink: Scalars['String'];
};


export type MutationAutoAllocateStickersToMultipleOrgsArgs = {
  input: Array<AutoAllocateStickersToOrgRequest>;
};


export type MutationAutoAllocateStickersToOrgArgs = {
  input: AutoAllocateStickersToOrgRequest;
};


export type MutationAutoDeskBookingBatchReportFailuresArgs = {
  reports: Array<AutoDeskBookingUserBatchFailureReportCommand>;
};


export type MutationAutoDeskBookingReportProcessFailureArgs = {
  report?: InputMaybe<AutoDeskBookingProcessFailureReportCommand>;
};


export type MutationBatchUnlinkKisiLocksFromRobinLevelsArgs = {
  input: BatchUnlinkKisiLocksFromRobinLevelsInput;
};


export type MutationBatchUnlinkKisiLocksFromRobinLocationsArgs = {
  input: BatchUnlinkKisiLocksFromRobinLocationsInput;
};


export type MutationBeginFileUploadsForTicketAnswerArgs = {
  input: BeginFileUploadsForTicketAnswerInput;
};


export type MutationBeginTicketIntegrationOAuthArgs = {
  id: Scalars['ID'];
  returnUrl: Scalars['String'];
};


export type MutationBulkActivateUsersArgs = {
  userIds: Array<Scalars['ID']>;
};


export type MutationBulkActivateUsersAsyncArgs = {
  userIds: Array<Scalars['ID']>;
};


export type MutationBulkArchiveAnnouncementsArgs = {
  announcementIds: Array<Scalars['ID']>;
};


export type MutationBulkDeactivateUsersArgs = {
  userIds: Array<Scalars['ID']>;
};


export type MutationBulkDeactivateUsersAsyncArgs = {
  userIds: Array<Scalars['ID']>;
};


export type MutationBulkInviteUsersArgs = {
  customMessage?: InputMaybe<Scalars['String']>;
  invites: Array<UserBulkInviteInput>;
  sendInvites?: Scalars['Boolean'];
};


export type MutationBulkInviteUsersAsyncArgs = {
  customMessage?: InputMaybe<Scalars['String']>;
  invites: Array<UserBulkInviteInput>;
  sendInvites?: Scalars['Boolean'];
};


export type MutationBulkRemoveUsersArgs = {
  userIds: Array<Scalars['ID']>;
};


export type MutationBulkRemoveUsersAsyncArgs = {
  userIds: Array<Scalars['ID']>;
};


export type MutationBulkUpdateCustomWorkingHoursArgs = {
  customWorkingHoursUpdates: Array<CustomWorkingHoursBulkUpdateInput>;
  locationId: Scalars['ID'];
};


export type MutationCancelActivityArgs = {
  activityId: Scalars['ID'];
};


export type MutationCancelEmployeeVisitArgs = {
  cancelReservations?: InputMaybe<Scalars['Boolean']>;
  employeeVisitId: Scalars['ID'];
  source?: InputMaybe<Scalars['String']>;
};


export type MutationCancelEmployeeVisitsAtLocationForEmployeeArgs = {
  cancelReservations?: InputMaybe<Scalars['Boolean']>;
  employeeId: Scalars['ID'];
  endTime: Scalars['ISODateTime'];
  locationId: Scalars['ID'];
  source?: InputMaybe<Scalars['String']>;
  startTime: Scalars['ISODateTime'];
};


export type MutationCancelEmployeeVisitsForEmployeeArgs = {
  cancelReservations?: InputMaybe<Scalars['Boolean']>;
  date: Scalars['LocalDate'];
  employeeId: Scalars['ID'];
  source?: InputMaybe<Scalars['String']>;
};


export type MutationCancelEventArgs = {
  id: Scalars['ID'];
};


export type MutationCancelEventV2Args = {
  input: CancelEventV2Input;
};


export type MutationCancelGuestInviteArgs = {
  id: Scalars['ID'];
  reason?: InputMaybe<GuestInviteCanceledReason>;
};


export type MutationCancelGuestInvitesArgs = {
  ids: Array<Scalars['ID']>;
  reason?: InputMaybe<GuestInviteCanceledReason>;
};


export type MutationCancelInsightsAssistantMessageArgs = {
  conversationId: Scalars['ID'];
  messageId: Scalars['ID'];
};


export type MutationCancelVisitArgs = {
  id: Scalars['ID'];
  reason?: InputMaybe<GuestInviteCanceledReason>;
};


export type MutationChangeAnswersOnMeetingServiceRequestArgs = {
  input: ChangeAnswersOnMeetingServiceRequestInput;
};


export type MutationChangeBrivoLockLinksArgs = {
  input: ChangeBrivoLockLinksInput;
};


export type MutationChangeGallagherDoorLinksForIntegrationArgs = {
  input: ChangeGallagherDoorLinksForIntegrationInput;
};


export type MutationChangeGeneaDoorLinksArgs = {
  input: ChangeGeneaDoorLinksInput;
};


export type MutationChangeGenericConnectorSourceMappingsArgs = {
  input: ChangeGenericConnectorSourceMappingsInput;
};


export type MutationChangeGenetecDoorLinksForIntegrationArgs = {
  input: ChangeGenetecDoorLinksForIntegrationInput;
};


export type MutationChangeGoogleMeetDeviceLinksArgs = {
  input: ChangeGoogleMeetDeviceLinksInput;
};


export type MutationChangeKisiLockLinkToRobinLevelArgs = {
  input: ChangeKisiLockLinkToRobinLevelInput;
};


export type MutationChangeKisiLockLinkToRobinLocationArgs = {
  input: ChangeKisiLockLinkToRobinLocationInput;
};


export type MutationChangeLogiSyncPlaceLinksArgs = {
  input: ChangeLogiSyncPlaceLinksInput;
};


export type MutationChangeNeatPulseRoomLinksArgs = {
  input: ChangeNeatPulseRoomLinksInput;
};


export type MutationChangeOpenpathLockLinksArgs = {
  input: ChangeOpenpathLockLinksInput;
};


export type MutationChangeVerkadaDoorLinksArgs = {
  input: ChangeVerkadaDoorLinksInput;
};


export type MutationChangeZoomRoomsRoomLinksArgs = {
  input: ChangeZoomRoomsRoomLinksInput;
};


export type MutationCheckIntoSelfRegisteredVisitFromArrivalDisplayArgs = {
  guestInviteId: Scalars['ID'];
};


export type MutationCheckIntoVisitArgs = {
  magicLink: Scalars['String'];
};


export type MutationCheckIntoVisitFromArrivalDisplayArgs = {
  guestInviteId: Scalars['ID'];
};


export type MutationCheckIntoVisitFromDashboardArgs = {
  guestInviteId: Scalars['ID'];
};


export type MutationCheckIntoVisitRequiringHcpFromArrivalDisplayArgs = {
  guestInviteId: Scalars['ID'];
};


export type MutationCheckIntoVisitWithMagicLinkArgs = {
  magicLink: Scalars['String'];
};


export type MutationCheckIntoVisitsFromDashboardArgs = {
  guestInviteIds: Array<Scalars['ID']>;
};


export type MutationCheckOutGuestFromArrivalDisplayArgs = {
  guestInviteId: Scalars['ID'];
};


export type MutationCheckOutGuestFromDashboardArgs = {
  guestInviteId: Scalars['ID'];
};


export type MutationClearDraftAssignmentsArgs = {
  id: Scalars['ID'];
  levelId: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationClearDraftNeighborhoodChangesArgs = {
  draftId: Scalars['ID'];
  levelId: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationCompleteSurveyResponseArgs = {
  comment?: InputMaybe<Scalars['String']>;
  isAnonymous: Scalars['Boolean'];
  rating: Scalars['Int'];
  reservationId?: InputMaybe<Scalars['String']>;
  surveyResponseId?: InputMaybe<Scalars['ID']>;
};


export type MutationConfirmDeskReservationArgs = {
  reservationId: Scalars['ID'];
  type: DeskConfirmationType;
};


export type MutationConfirmDeskReservationBypassingConfirmationWindowDelegatedArgs = {
  confirmedAt?: InputMaybe<Scalars['ISODateTime']>;
  reservationId: Scalars['ID'];
  type: DeskConfirmationType;
  userId: Scalars['ID'];
};


export type MutationConfirmDeskReservationDelegatedArgs = {
  confirmedAt?: InputMaybe<Scalars['ISODateTime']>;
  reservationId: Scalars['ID'];
  type: DeskConfirmationType;
  userId: Scalars['ID'];
};


export type MutationConfirmEventArgs = {
  id: Scalars['ID'];
};


export type MutationConnectGallagherAccountForCurrentTenantArgs = {
  input: ConnectGallagherAccountForCurrentTenantInput;
};


export type MutationConnectGeneaAccountForCurrentTenantArgs = {
  input: ConnectGeneaAccountForCurrentTenantInput;
};


export type MutationConnectGenericConnectorAccountArgs = {
  input: ConnectGenericConnectorAccountInput;
};


export type MutationConnectGenetecAccountForCurrentTenantArgs = {
  input: ConnectGenetecAccountForCurrentTenantInput;
};


export type MutationConnectKisiAccountArgs = {
  input: ConnectKisiAccountInput;
};


export type MutationConnectLogiSyncAccountArgs = {
  input: ConnectLogiSyncAccountInput;
};


export type MutationConnectNeatPulseAccountArgs = {
  input: ConnectNeatPulseAccountInput;
};


export type MutationConnectOpenpathAccountArgs = {
  input: ConnectOpenpathAccountInput;
};


export type MutationConnectVerkadaAccountForCurrentTenantArgs = {
  input: ConnectVerkadaAccountForCurrentTenantInput;
};


export type MutationConvertGroupToExternalRipplingGroupArgs = {
  input: ConvertGroupToExternalRipplingGroupInput;
};


export type MutationCreateActivityArgs = {
  input: CreateActivityInput;
};


export type MutationCreateActivityCustomImageArgs = {
  buildingId: Scalars['ID'];
  name: Scalars['String'];
  url: Scalars['String'];
};


export type MutationCreateAllocationArgs = {
  allocation: CreateAllocationInput;
};


export type MutationCreateAmenityArgs = {
  amenityName: Scalars['String'];
  configuration?: InputMaybe<AmenitySelectionConfiguration>;
  organizationId: Scalars['ID'];
};


export type MutationCreateAndMapBuildingsFromRipplingArgs = {
  input: CreateAndMapBuildingsFromRipplingInput;
};


export type MutationCreateAnnouncementArgs = {
  announcement: AnnouncementCreateInput;
};


export type MutationCreateAnnouncementForSlackArgs = {
  announcement: AnnouncementCreateInput;
};


export type MutationCreateArrivalDisplayArgs = {
  badgePrinterIPAddress?: InputMaybe<Scalars['String']>;
  badgePrinterId?: InputMaybe<Scalars['String']>;
  guestImageCaptureEnabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  locationId: Scalars['ID'];
  name: Scalars['String'];
  selfRegistrationEnabled?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateBadgeCsvUploadLinkArgs = {
  input: CreateBadgeCsvUploadLinkInput;
};


export type MutationCreateBadgePrinterArgs = {
  arrivalDisplayIds?: InputMaybe<Array<Scalars['ID']>>;
  badgePrinterIPAddress: Scalars['String'];
  locationId: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationCreateBookingWindowPolicyForLocationArgs = {
  input: CreateBookingWindowPolicyInput;
};


export type MutationCreateBuildingDraftArgs = {
  draft: BuildingDraftInput;
};


export type MutationCreateCustomVisitFormArgs = {
  form?: InputMaybe<CustomVisitFormInput>;
};


export type MutationCreateDeliveryArgs = {
  input: CreateDeliveryInput;
};


export type MutationCreateDeliveryZoneArgs = {
  input: CreateDeliveryZoneInput;
};


export type MutationCreateDeskExclusionsArgs = {
  dates: Array<InputMaybe<DateRangeWithTimeZone>>;
  seriesId: Scalars['ID'];
};


export type MutationCreateDisposableDraftArgs = {
  levelId: Scalars['ID'];
};


export type MutationCreateDraftArgs = {
  draft: DraftInput;
};


export type MutationCreateDraftVisitArgs = {
  eventUid: Scalars['String'];
};


export type MutationCreateEmailConfigurationArgs = {
  input: EmailConfigurationInput;
  locationId: Scalars['ID'];
};


export type MutationCreateEventV2Args = {
  input: CreateEventV2Input;
};


export type MutationCreateGenericHealthCheckpointArgs = {
  entityId: Scalars['ID'];
  entityType: GenericHealthCheckpointEntityType;
  id?: InputMaybe<Scalars['ID']>;
  locationId: Scalars['ID'];
};


export type MutationCreateGroupAndMakeItExternalRipplingGroupArgs = {
  input: CreateGroupAndMakeItExternalRipplingGroupInput;
};


export type MutationCreateIntegrationArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  externalId: Scalars['String'];
  integrationJson?: InputMaybe<Scalars['Json']>;
  name: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationCreateLayoutDraftArgs = {
  draft: LayoutDraftInput;
};


export type MutationCreateLegacyIntegrationArgs = {
  configuration: Scalars['Json'];
  resourceType: Scalars['String'];
  state: Scalars['String'];
  type: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationCreateNeighborhoodArgs = {
  neighborhood: NeighborhoodCreationInput;
};


export type MutationCreateOfficeAdminRoleArgs = {
  locationId: Scalars['ID'];
};


export type MutationCreatePassArgs = {
  input?: InputMaybe<PassInput>;
};


export type MutationCreatePassForPlacesArgs = {
  input?: InputMaybe<MultiPlacePassInput>;
};


export type MutationCreateRobinOrganizationFromRipplingOAuthDataArgs = {
  input: CreateRobinOrganizationFromRipplingOAuthDataInput;
};


export type MutationCreateRoleArgs = {
  input: RoleCreationInput;
};


export type MutationCreateServiceNowIntegrationArgs = {
  input: CreateServiceNowIntegrationInput;
};


export type MutationCreateSigmaWorkbookArgs = {
  location: SigmaLocationType;
  name: Scalars['String'];
};


export type MutationCreateStackPlanArgs = {
  stackPlan: CreateStackPlanInput;
};


export type MutationCreateStackPlanAllocationArgs = {
  allocation: CreateStackPlanAllocationInput;
};


export type MutationCreateTicketIntegrationExternalObjectsArgs = {
  input: CreateTicketIntegrationExternalObjectsInput;
};


export type MutationCreateVisitArgs = {
  guests: Array<GuestInputType>;
  organizerId: Scalars['ID'];
  organizerType: VisitOrganizerType;
  visitDetails: VisitWithIdInputType;
};


export type MutationCreateVisitWithCustomVisitTypeArgs = {
  arrivalLocationId: Scalars['ID'];
  guests: Array<GuestInputType>;
  hostUserId: Scalars['ID'];
  id: Scalars['ID'];
  organizerId: Scalars['ID'];
  organizerType: VisitOrganizerType;
  startTime: Scalars['ISODateTime'];
  visitType: Scalars['String'];
};


export type MutationCreateWorkPolicyArgs = {
  workPolicy: WorkPolicyInput;
};


export type MutationCreateZendeskIntegrationArgs = {
  input: CreateZendeskIntegrationInput;
};


export type MutationCustomResourceInstancePrePublishDeleteArgs = {
  customResourceInstanceIds: Array<Scalars['ID']>;
  mapId: Scalars['ID'];
  organizationID: Scalars['ID'];
  publicationSessionId: Scalars['ID'];
  publishChangesAfterSave?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCustomResourceInstancePrePublishSaveArgs = {
  deletedCustomResourceInstanceIds?: InputMaybe<Array<Scalars['ID']>>;
  groupedResourceInstances?: InputMaybe<Array<GroupedResourceSaveUpdateInput>>;
  mapId: Scalars['ID'];
  organizationID: Scalars['ID'];
  publicationSessionId: Scalars['ID'];
  publishChangesAfterSave?: InputMaybe<Scalars['Boolean']>;
  resourceGroups?: InputMaybe<Array<ResourceGroupSaveUpdateInput>>;
  ungroupedResourceInstances?: InputMaybe<Array<UngroupedResourceSaveUpdateInput>>;
};


export type MutationCustomResourceRecurringReservationEditArgs = {
  clientType: ClientType;
  duration: Scalars['ISO8601_Duration'];
  organizationId: Scalars['ID'];
  recurringReservationRequestExclusions?: InputMaybe<Array<RecurringReservationRequest>>;
  recurringReservationRequests: Array<RecurringReservationRequest>;
  requestReservationDates?: InputMaybe<Array<LocaleDateTimePair>>;
  reservationId: Scalars['ID'];
  reservationRequestDateExclusions?: InputMaybe<Array<LocaleDateTimePair>>;
  truncationDate: Scalars['IsoDateOnlyString'];
  truncationStartTime: Scalars['IsoLocalTimeString'];
};


export type MutationCustomResourceReservationBulkConfirmInternalArgs = {
  clientType: ConfirmationClientType;
  organizationId: Scalars['ID'];
  reservationIds: Array<Scalars['ID']>;
  userId: Scalars['ID'];
  utcConfirmationTime: Scalars['ISO8601Timestamp'];
};


export type MutationCustomResourceReservationCompletelyCancelArgs = {
  organizationId: Scalars['ID'];
  reservationId: Scalars['ID'];
  resourceId: Scalars['ID'];
};


export type MutationCustomResourceReservationInstanceRescheduleArgs = {
  clientType: ClientType;
  newDate: Scalars['IsoDateOnlyString'];
  newDuration?: InputMaybe<Scalars['ISO8601_Duration']>;
  newStartTime: Scalars['IsoLocalTimeString'];
  organizationId: Scalars['ID'];
  originalDate: Scalars['IsoDateOnlyString'];
  originalStartTime: Scalars['IsoLocalTimeString'];
  reservationId: Scalars['ID'];
};


export type MutationCustomResourceReservationMoveArgs = {
  clientType: ClientType;
  organizationId: Scalars['ID'];
  reservationResourcePairs: Array<ReservationResourcePairInput>;
};


export type MutationCustomResourceReservationSelfConfirmArgs = {
  clientType: ConfirmationClientType;
  organizationId: Scalars['ID'];
  reservationId: Scalars['ID'];
  startDate: Scalars['IsoDateOnlyString'];
  startTime: Scalars['IsoLocalTimeString'];
};


export type MutationCustomResourceScheduleSingleDayDelegateReservationArgs = {
  clientType: ClientType;
  date: Scalars['IsoDateOnlyString'];
  duration: Scalars['ISO8601_Duration'];
  endReservationIds?: InputMaybe<Array<Scalars['ID']>>;
  organizationId: Scalars['ID'];
  reservee: Scalars['ID'];
  resourceInstanceId: Scalars['ID'];
  startTime: Scalars['IsoLocalTimeString'];
};


export type MutationDeactivateVisitTypeForOrgArgs = {
  locationId?: InputMaybe<Scalars['ID']>;
  visitTypeName: Scalars['String'];
};


export type MutationDecideOutcomeForVisitDocumentArgs = {
  guestId: Scalars['ID'];
  outcomeId: Scalars['ID'];
  visitId: Scalars['ID'];
  visitInviteId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationDecideOutcomeForVisitDocumentFromArrivalDisplayArgs = {
  base64Signature?: InputMaybe<Scalars['String']>;
  guestId: Scalars['ID'];
  outcomeId: Scalars['ID'];
  sendCopyToGuest?: InputMaybe<Scalars['Boolean']>;
  visitId: Scalars['ID'];
  visitInviteId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationDecideOutcomeForVisitDocumentFromGuestUiArgs = {
  base64Signature?: InputMaybe<Scalars['String']>;
  guestId: Scalars['ID'];
  outcomeId: Scalars['ID'];
  sendCopyToGuest?: InputMaybe<Scalars['Boolean']>;
  visitId: Scalars['ID'];
  visitInviteId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationDeclineAndEndReservationArgs = {
  reservationId: Scalars['ID'];
};


export type MutationDeleteActivityCustomImageArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCustomVisitFormArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type MutationDeleteDeliveriesArgs = {
  clientOptions?: InputMaybe<ClientOptionsInput>;
  ids: Array<Scalars['ID']>;
};


export type MutationDeleteDeliveryArgs = {
  clientOptions?: InputMaybe<ClientOptionsInput>;
  id: Scalars['ID'];
};


export type MutationDeleteDeliveryZoneArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDeskExclusionsArgs = {
  exclusionIds: Array<Scalars['ID']>;
  seriesId: Scalars['ID'];
};


export type MutationDeleteDraftArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDraftV2Args = {
  id: Scalars['ID'];
};


export type MutationDeleteEmailConfigurationArgs = {
  locationId: Scalars['ID'];
};


export type MutationDeleteExternalRipplingGroupArgs = {
  input: DeleteExternalRipplingGroupInput;
};


export type MutationDeleteLegacyIntegrationByTypeArgs = {
  resourceType: LegacyIntegrationResourceType;
  type: LegacyIntegrationType;
};


export type MutationDeleteMeetingServicesArgs = {
  meetingServiceIds: Array<Scalars['ID']>;
};


export type MutationDeleteMeetingServicesCategoryArgs = {
  meetingServicesCategoryId: Scalars['ID'];
};


export type MutationDeleteOrCancelMeetingServiceRequestArgs = {
  meetingServiceRequestId: Scalars['ID'];
};


export type MutationDeletePassArgs = {
  passId?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteTicketIntegrationArgs = {
  id: Scalars['ID'];
};


export type MutationDisableAnonymityModeForOrgArgs = {
  input: AnonymityModeToggleInput;
};


export type MutationDisableGeofenceFeatureForBuildingArgs = {
  input: DisableGeofenceFeatureForBuildingInput;
};


export type MutationDisableOrganizationUserArgs = {
  organizationId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationDisablePassiveCheckInFeatureForBuildingArgs = {
  input: SetPassiveCheckInFeatureForBuildingInput;
};


export type MutationDisableSpacesArgs = {
  spaceIds: Array<Scalars['ID']>;
};


export type MutationDiscardStackPlanArgs = {
  id: Scalars['ID'];
};


export type MutationDisconnectGallagherAccountByIntegrationUuidArgs = {
  input: DisconnectGallagherAccountByIntegrationUuidInput;
};


export type MutationDisconnectGeneaAccountByIntegrationUuidArgs = {
  input: DisconnectGeneaAccountByIntegrationUuidInput;
};


export type MutationDisconnectGenericConnectorAccountByIntegrationUuidArgs = {
  input: DisconnectGenericConnectorAccountByIntegrationUuidInput;
};


export type MutationDisconnectGenetecAccountByIntegrationUuidArgs = {
  input: DisconnectGenetecAccountByIntegrationUuidInput;
};


export type MutationDisconnectGoogleAccountByIntegrationUuidArgs = {
  input: DisconnectGoogleAccountByIntegrationUuidInput;
};


export type MutationDisconnectLogiSyncAccountByIntegrationUuidArgs = {
  input: DisconnectLogiSyncAccountByIntegrationUuidInput;
};


export type MutationDisconnectNeatPulseAccountByIntegrationUuidArgs = {
  input: DisconnectNeatPulseAccountByIntegrationUuidInput;
};


export type MutationDisconnectVerkadaAccountByIntegrationUuidArgs = {
  input: DisconnectVerkadaAccountByIntegrationUuidInput;
};


export type MutationDisconnectZoomRoomsAccountByIntegrationUuidArgs = {
  input: DisconnectZoomRoomsAccountByIntegrationUuidInput;
};


export type MutationDiscoverGoogleMeetDevicesArgs = {
  input?: InputMaybe<DiscoverGoogleMeetDevicesInput>;
};


export type MutationDismissSurveyResponseArgs = {
  reservationId?: InputMaybe<Scalars['String']>;
  surveyResponseId?: InputMaybe<Scalars['ID']>;
};


export type MutationEditCustomResourceTemplateArgs = {
  associatedAmenityIds?: InputMaybe<Array<Scalars['ID']>>;
  description?: InputMaybe<Scalars['String']>;
  organizationID: Scalars['ID'];
  policyConfiguration?: InputMaybe<CustomResourcePolicyDocumentCommand>;
  resourceCategory: Scalars['String'];
  resourceCategorySingular?: InputMaybe<Scalars['String']>;
  subCategories?: InputMaybe<Array<Scalars['CustomResourceSubCategoryType']>>;
  templateId: Scalars['ID'];
};


export type MutationEditDraftVisitRecordArgs = {
  arrivalInstructions?: InputMaybe<Scalars['String']>;
  arrivalLocationId: Scalars['ID'];
  checkInGuest?: InputMaybe<Scalars['Boolean']>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  eventUid: Scalars['String'];
  guests: Array<GuestInputType>;
  hostUserId: Scalars['ID'];
  provisionCredentials?: InputMaybe<Scalars['Boolean']>;
  recordId: Scalars['ID'];
  sendGuestEmailInvite?: InputMaybe<Scalars['Boolean']>;
  startTime: Scalars['ISODateTime'];
  visitType: Scalars['String'];
};


export type MutationEditMeetingServicesCategoryArgs = {
  input: EditMeetingServicesCategoryInput;
};


export type MutationEmployeeRegisteredForWaitlistVisitArgs = {
  input: EmployeeRegisteredForWaitlistVisitInput;
};


export type MutationEnableAnonymityModeForOrgArgs = {
  input: AnonymityModeToggleInput;
};


export type MutationEnableGeofenceFeatureForBuildingArgs = {
  input: EnableGeofenceFeatureForBuildingInput;
};


export type MutationEnableOrganizationUserArgs = {
  organizationId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationEnablePassiveCheckInFeatureForBuildingArgs = {
  input: SetPassiveCheckInFeatureForBuildingInput;
};


export type MutationEndInsightsAssistantConversationArgs = {
  id: Scalars['ID'];
};


export type MutationEndInsightsAssistantConversationV2Args = {
  id: Scalars['ID'];
};


export type MutationEndOrCancelDelegatedReservationArgs = {
  notifyAssignee?: InputMaybe<Scalars['Boolean']>;
  reservationId: Scalars['ID'];
};


export type MutationEndOrCancelReservationArgs = {
  reservationId: Scalars['ID'];
};


export type MutationEndReservationOrVisitsInRangeArgs = {
  cancelFutureVisits?: InputMaybe<Scalars['Boolean']>;
  creationType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  end: Scalars['Date'];
  orgId: Scalars['ID'];
  start: Scalars['Date'];
  userId: Scalars['ID'];
};


export type MutationForceResolveCsvUploadRecordsArgs = {
  input: UploadCsvForcePushRecords;
};


export type MutationGenerateAssignmentRecommendationArgs = {
  input: GenerateAssignmentRecommendationInput;
};


export type MutationGenerateStickerBatchArgs = {
  input: GenerateStickerBatchRequest;
};


export type MutationGuestHealthCheckpointFailedArgs = {
  healthCheckpointResponseId: Scalars['ID'];
};


export type MutationGuestInvitedArgs = {
  magicLink: Scalars['String'];
};


export type MutationHandleDepartmentDataForOrganizationArgs = {
  delimiter?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
};


export type MutationInitiateBrivoAccountConnectionForCurrentTenantArgs = {
  input: InitiateBrivoAccountConnectionForCurrentTenantInput;
};


export type MutationInitiateRipplingConnectionAndSyncArgs = {
  input: InitiateRipplingConnectionAndSyncInput;
};


export type MutationInitiateRipplingUserSyncArgs = {
  input: InitiateRipplingUserSyncInput;
};


export type MutationInitiateZoomRoomsAccountConnectionForCurrentTenantArgs = {
  input: InitiateZoomRoomsAccountConnectionForCurrentTenantInput;
};


export type MutationInviteOfficeAdminUsersArgs = {
  emailAddresses: Array<Scalars['String']>;
};


export type MutationInviteUsersToDraftArgs = {
  draftAccessLevel: DraftCollaboratorAccessLevel;
  draftId: Scalars['ID'];
  userIds: Array<Scalars['ID']>;
};


export type MutationInviteUsersToDraftAsCollaboratorsArgs = {
  draftId: Scalars['ID'];
  userIds: Array<Scalars['ID']>;
};


export type MutationInviteUsersToDraftV2Args = {
  draftAccessLevel: DraftCollaboratorAccessLevel;
  draftId: Scalars['ID'];
  userIds: Array<Scalars['ID']>;
};


export type MutationJoinActivityArgs = {
  activityId: Scalars['ID'];
};


export type MutationJoinOfficeArgs = {
  endTime: Scalars['ISODateTime'];
  locationId: Scalars['ID'];
  startTime: Scalars['ISODateTime'];
  type: DeskConfirmationType;
  userId: Scalars['ID'];
};


export type MutationLinkArrivalDisplayAndBadgePrinterArgs = {
  arrivalDisplayId: Scalars['ID'];
  badgePrinterId: Scalars['ID'];
};


export type MutationLinkKisiLockToRobinLocationArgs = {
  input: LinkKisiLockToRobinLocationInput;
};


export type MutationLogSpaceSuggestionBookedArgs = {
  input: LogSuggestedSpaceBookedInput;
};


export type MutationLogSpaceSuggestionDismissedArgs = {
  input: LogSuggestedSpaceDismissedInput;
};


export type MutationLogSpaceSuggestionViewedArgs = {
  input: LogSuggestedSpaceViewedInput;
};


export type MutationMapBuildingToRipplingWorkLocationArgs = {
  input: MapBuildingToRipplingWorkLocationInput;
};


export type MutationMapBuildingsToRipplingWorkLocationsArgs = {
  input: MapBuildingsToRipplingWorkLocationsInput;
};


export type MutationMapKisiLocksToRobinLocationsArgs = {
  input: MapKisiLocksToRobinLocations;
};


export type MutationModifyDraftCollaboratorAccessLevelArgs = {
  draftAccessLevel: DraftCollaboratorAccessLevel;
  draftId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationModifyDraftCollaboratorAccessLevelV2Args = {
  draftAccessLevel: DraftCollaboratorAccessLevel;
  draftId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationMoveEventArgs = {
  input: MoveEventInput;
};


export type MutationNotifyAffectedUsersOnFloorsArgs = {
  draftId: Scalars['ID'];
  floorIds: Array<Scalars['ID']>;
  message?: InputMaybe<Scalars['String']>;
};


export type MutationParseDeliveryImageArgs = {
  base64Image: Scalars['String'];
};


export type MutationPersistBuildingNeighborhoodsFromDraftArgs = {
  floors: Array<FloorNeighborhoodInput>;
  locationId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type MutationPersistNeighborhoodsArgs = {
  floorId: Scalars['ID'];
  neighborhoods: Array<PersistNeighborhoodInput>;
  userId: Scalars['Int'];
};


export type MutationPublishDraftArgs = {
  id: Scalars['ID'];
  sendNotifications?: InputMaybe<Scalars['Boolean']>;
  version: Scalars['Int'];
};


export type MutationPublishDraftV2Args = {
  affectedAssigneesMessage?: InputMaybe<Scalars['String']>;
  exportCSVMessage?: InputMaybe<Scalars['String']>;
  exportCSVUserIds?: InputMaybe<Array<Scalars['ID']>>;
  floorIds: Array<Scalars['Int']>;
  id: Scalars['ID'];
  notifyAffectedAssignees?: InputMaybe<Scalars['Boolean']>;
  notifyAffectedReservees?: InputMaybe<Scalars['Boolean']>;
  sendNotifications?: InputMaybe<Scalars['Boolean']>;
  version: Scalars['Int'];
};


export type MutationPublishSharedScheduleForDeskArgs = {
  input: SharedDeskSchedulesInput;
};


export type MutationPublishVisitDraftArgs = {
  draftId: Scalars['ID'];
};


export type MutationRebootNeatPulseDeviceArgs = {
  input: RebootNeatPulseDeviceInput;
};


export type MutationReconnectOpenpathAccountArgs = {
  input: ReconnectOpenpathAccountInput;
};


export type MutationRefreshDeviceAuthorizationArgs = {
  refreshToken: Scalars['String'];
};


export type MutationRefreshDraftCachesForBuildingArgs = {
  buildingId: Scalars['ID'];
};


export type MutationRefreshDraftCachesForFloorArgs = {
  floorId: Scalars['ID'];
};


export type MutationRefreshJwtAuthTokenArgs = {
  refreshToken: Scalars['String'];
};


export type MutationRefreshTicketIntegrationAvailableTargetsArgs = {
  integrationId: Scalars['ID'];
};


export type MutationRegisterArrivalDisplayArgs = {
  key: Scalars['ArrivalDisplayRegistrationKey'];
  organizationId: Scalars['ID'];
};


export type MutationRegisterGuestFromArrivalDisplayArgs = {
  arrivalLocationId: Scalars['ID'];
  guestEmail: Scalars['String'];
  guestName: Scalars['String'];
  hostUserId: Scalars['ID'];
  startTime: Scalars['ISODateTime'];
  visitId?: InputMaybe<Scalars['ID']>;
  visitInviteId?: InputMaybe<Scalars['ID']>;
  visitType: VisitType;
};


export type MutationRegisterGuestFromDashboardArgs = {
  guests: Array<GuestInputType>;
  visitDetails: VisitInputType;
};


export type MutationRegisterGuestWithHcpFromArrivalDisplayArgs = {
  arrivalLocationId: Scalars['ID'];
  guestEmail: Scalars['String'];
  guestInviteId: Scalars['ID'];
  guestName: Scalars['String'];
  healthCheckpointId: Scalars['ID'];
  hostUserId: Scalars['ID'];
  startTime: Scalars['ISODateTime'];
  visitId: Scalars['ID'];
  visitType: VisitType;
};


export type MutationRegisterGuestWithHcpFromArrivalDisplayWithCustomVisitTypeArgs = {
  arrivalLocationId: Scalars['ID'];
  guestEmail: Scalars['String'];
  guestInviteId: Scalars['ID'];
  guestName: Scalars['String'];
  healthCheckpointId: Scalars['ID'];
  hostUserId: Scalars['ID'];
  startTime: Scalars['ISODateTime'];
  visitId: Scalars['ID'];
  visitType: Scalars['String'];
};


export type MutationRegisterGuestWithoutHcpFromArrivalDisplayArgs = {
  arrivalLocationId: Scalars['ID'];
  guestEmail: Scalars['String'];
  guestName: Scalars['String'];
  hostUserId: Scalars['ID'];
  startTime: Scalars['ISODateTime'];
  visitId: Scalars['ID'];
  visitInviteId: Scalars['ID'];
  visitType: VisitType;
};


export type MutationRegisterGuestWithoutHcpFromArrivalDisplayWithCustomVisitTypeArgs = {
  arrivalLocationId: Scalars['ID'];
  guestEmail: Scalars['String'];
  guestName: Scalars['String'];
  hostUserId: Scalars['ID'];
  startTime: Scalars['ISODateTime'];
  visitId: Scalars['ID'];
  visitInviteId: Scalars['ID'];
  visitType: Scalars['String'];
};


export type MutationRejectMeetingServiceRequestArgs = {
  input: RejectMeetingServiceRequestInput;
};


export type MutationRemoveAllDevicesForLocationArgs = {
  locationId: Scalars['ID'];
};


export type MutationRemoveArrivalDisplayArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveBadgePrinterArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveBookingWindowPolicyForLocationArgs = {
  input: RemoveBookingWindowPolicyInput;
};


export type MutationRemoveBuildingGeofenceArgs = {
  input: RemoveBuildingGeofenceInput;
};


export type MutationRemoveChatMessagesFromActivityArgs = {
  chatMessageIdentifiers: Array<Scalars['ID']>;
};


export type MutationRemoveCustomWorkingHoursArgs = {
  customWorkingHoursId: Scalars['ID'];
};


export type MutationRemoveDraftCollaboratorsV2Args = {
  draftId: Scalars['ID'];
  userIds: Array<Scalars['ID']>;
};


export type MutationRemoveEndpointRelationshipsArgs = {
  input: RemoveEndpointRelationshipsInput;
};


export type MutationRemoveHostFromVisitArgs = {
  hostUserId: Scalars['ID'];
  visitId: Scalars['ID'];
};


export type MutationRemoveOfficeAdminArgs = {
  locationId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationRemovePermissionOnRoleArgs = {
  actions: Array<HierarchyPermissionAction>;
  organizationId: Scalars['ID'];
  permissionHierarchyTarget: PermissionHierarchyTarget;
  permissionHierarchyTargetId: Scalars['ID'];
  resourceCategoryId: Scalars['ID'];
  roleIds: Array<Scalars['ID']>;
};


export type MutationRemovePinnedUserSpacesArgs = {
  spaceIds: Array<Scalars['String']>;
};


export type MutationRemoveSpaceFromEventArgs = {
  input: RemoveSpaceFromEventInput;
};


export type MutationRemoveTicketIntegrationEntityMappingsArgs = {
  input: RemoveTicketIntegrationEntityMappingsInput;
};


export type MutationRemoveTicketIntegrationFieldMappingsArgs = {
  input: RemoveTicketIntegrationFieldMappingsInput;
};


export type MutationRemoveTicketIntegrationTargetConfigArgs = {
  input: RemoveTicketIntegrationTargetConfigInput;
};


export type MutationRemoveTicketIntegrationWorkflowBindingArgs = {
  input: RemoveTicketIntegrationWorkflowBindingInput;
};


export type MutationRemoveUserFromFavoritesArgs = {
  userId: Scalars['String'];
};


export type MutationRemoveUserFromRoleArgs = {
  roleSlug: Scalars['String'];
  userId: Scalars['ID'];
};


export type MutationRemoveUsersFromAssignmentsQueueArgs = {
  id: Scalars['ID'];
  levelId?: InputMaybe<Scalars['ID']>;
  userIds: Array<Scalars['ID']>;
};


export type MutationRemoveUsersFromDraftCollaboratorsArgs = {
  draftId: Scalars['ID'];
  userIds: Array<Scalars['ID']>;
};


export type MutationRenewArrivalDisplayRegistrationArgs = {
  key: Scalars['ArrivalDisplayRegistrationKey'];
};


export type MutationReportDeviceStatusArgs = {
  arrivalDisplayStatus?: InputMaybe<DeviceStatusInput>;
  arrivalDisplayStatusMessage?: InputMaybe<Scalars['String']>;
  badgePrinterStatus?: InputMaybe<DeviceStatusInput>;
  badgePrinterStatusMessage?: InputMaybe<Scalars['String']>;
};


export type MutationReportIssueWithDeskArgs = {
  input: ReportIssueWithDeskInput;
};


export type MutationReportIssueWithSpaceArgs = {
  input: ReportIssueWithSpaceInput;
};


export type MutationReportMyPresenceViaMobileGeofenceEventArgs = {
  input: ReportMyPresenceViaMobileGeofenceEventInput;
};


export type MutationReportUserPresenceAtIpAddressArgs = {
  input: ReportUserPresenceAtIpAddressInput;
};


export type MutationReportUserPresenceFromWebClientArgs = {
  input: ReportUserPresenceFromWebClientInput;
};


export type MutationReportUserPresenceInBuildingAtTimeArgs = {
  input: ReportUserPresenceInBuildingAtTimeInput;
};


export type MutationRequestMeetingServiceForDraftEventAtSpaceArgs = {
  input: RequestMeetingServiceForDraftEventAtSpaceInput;
};


export type MutationRequestMeetingServiceForExistingEventAtSpaceArgs = {
  input: RequestMeetingServiceForExistingEventAtSpaceInput;
};


export type MutationResendCollaboratorInviteArgs = {
  draftId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationResendCollaboratorInviteV2Args = {
  draftId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationReserveDelegatedDeskArgs = {
  email: Scalars['String'];
  end: DateWithTimezone;
  notify?: InputMaybe<Scalars['Boolean']>;
  recurrence?: InputMaybe<Array<Scalars['String']>>;
  seatId: Scalars['Int'];
  start: DateWithTimezone;
  type: Scalars['String'];
  visibility?: InputMaybe<DeskReservationVisibility>;
};


export type MutationReserveDeskForMeArgs = {
  end: DateWithTimezone;
  notify?: InputMaybe<Scalars['Boolean']>;
  recurrence?: InputMaybe<Array<Scalars['String']>>;
  seatId: Scalars['Int'];
  start: DateWithTimezone;
  type: Scalars['String'];
  visibility?: InputMaybe<DeskReservationVisibility>;
};


export type MutationReserveSpaceArgs = {
  request: ReserveSpaceRequest;
};


export type MutationResourceRecurringAssignmentScheduleArgs = {
  clientType: ClientType;
  duration: Scalars['ISO8601_Duration'];
  endReservationIds?: InputMaybe<Array<Scalars['ID']>>;
  organizationId: Scalars['ID'];
  recurringReservationRequestExclusions?: InputMaybe<Array<RecurringReservationRequest>>;
  recurringReservationRequests: Array<RecurringReservationRequest>;
  requestReservationDates?: InputMaybe<Array<LocaleDateTimePair>>;
  reservationRequestDateExclusions?: InputMaybe<Array<LocaleDateTimePair>>;
  reservee: Scalars['ID'];
  resourceInstanceId: Scalars['ID'];
};


export type MutationResourceRecurringReservationScheduleArgs = {
  clientType: ClientType;
  duration: Scalars['ISO8601_Duration'];
  endReservationIds?: InputMaybe<Array<Scalars['ID']>>;
  organizationId: Scalars['ID'];
  recurringReservationRequestExclusions?: InputMaybe<Array<RecurringReservationRequest>>;
  recurringReservationRequests: Array<RecurringReservationRequest>;
  requestReservationDates?: InputMaybe<Array<LocaleDateTimePair>>;
  reservationRequestDateExclusions?: InputMaybe<Array<LocaleDateTimePair>>;
  reservee?: InputMaybe<Scalars['ID']>;
  resourceInstanceId: Scalars['ID'];
};


export type MutationResourceSetCategoryPolicyOnLocationArgs = {
  applyToExistingResources?: InputMaybe<Scalars['Boolean']>;
  locationId: Scalars['ID'];
  organizationId: Scalars['ID'];
  policyConfiguration: CustomResourcePolicyDocumentCommand;
  resourceCategoryId: Scalars['ID'];
};


export type MutationSaveMappedGoogleLocationsArgs = {
  input?: InputMaybe<Array<InputMaybe<GoogleToRobinInput>>>;
};


export type MutationSaveSurveyConfigurationArgs = {
  allowAnonymous: Scalars['Boolean'];
  buildingIds: Array<Scalars['String']>;
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
};


export type MutationScaffoldDemoFloorPlanArgs = {
  locationId: Scalars['ID'];
};


export type MutationScheduleEmployeeVisitAtLocationArgs = {
  employeeId: Scalars['ID'];
  endTime: Scalars['ISODateTime'];
  locationId: Scalars['ID'];
  source?: InputMaybe<Scalars['String']>;
  startTime: Scalars['ISODateTime'];
};


export type MutationScheduleSingleDayReservationArgs = {
  clientType: ClientType;
  date: Scalars['IsoDateOnlyString'];
  duration: Scalars['ISO8601_Duration'];
  endReservationIds?: InputMaybe<Array<Scalars['ID']>>;
  organizationId: Scalars['ID'];
  resourceInstanceId: Scalars['ID'];
  startTime: Scalars['IsoLocalTimeString'];
};


export type MutationSendChatOnActivityArgs = {
  activityID: Scalars['ID'];
  message: Scalars['String'];
};


export type MutationSendChatOnActivityWithIdArgs = {
  activityID: Scalars['ID'];
  message: Scalars['String'];
  messageID: Scalars['ID'];
};


export type MutationSendDeliveryNotificationToRecipientArgs = {
  id: Scalars['ID'];
};


export type MutationSendDeliveryNotificationsToRecipientsArgs = {
  deliveryIds: Array<Scalars['ID']>;
};


export type MutationSendEmailToAffectedDraftUsersArgs = {
  customMessage?: InputMaybe<Scalars['String']>;
  draftId: Scalars['ID'];
};


export type MutationSendEmailToAffectedDraftUsersV2Args = {
  customMessage?: InputMaybe<Scalars['String']>;
  draftId: Scalars['ID'];
};


export type MutationSendExportCsvChangesOnFloorsArgs = {
  draftId: Scalars['ID'];
  floorIds: Array<Scalars['ID']>;
  message?: InputMaybe<Scalars['String']>;
  userIds: Array<Scalars['ID']>;
};


export type MutationSetAutoDeskBookingArgs = {
  input: SetAutoDeskBookingInput;
};


export type MutationSetAutoDeskBookingForOrgArgs = {
  input: AutoDeskBookingOrgInput;
};


export type MutationSetBuildingCidrsArgs = {
  input: SetBuildingCidrsInput;
};


export type MutationSetBuildingGeofenceAsPointWithRadiusArgs = {
  input: SetBuildingGeofenceAsPointWithRadiusInput;
};


export type MutationSetChannelAndResourceIdsForUserCalendarArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  expiration?: InputMaybe<Scalars['String']>;
  resourceId?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};


export type MutationSetCompletedOnboardingStepsForOrgArgs = {
  steps: Array<CompletedOnboardingStep>;
};


export type MutationSetDefaultLocationForUserArgs = {
  levelId?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  organizationSlug?: InputMaybe<Scalars['String']>;
};


export type MutationSetDeliveryReminderIntervalArgs = {
  interval: Scalars['ISO8601Duration'];
};


export type MutationSetDistributionSendDataArgs = {
  distributionId: Scalars['ID'];
  recipientIds: Array<Scalars['ID']>;
};


export type MutationSetEmployeeVisitsEnabledForOrgArgs = {
  organizationId: Scalars['ID'];
  value?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSetGallagherEmailFieldIdentifierForIntegrationArgs = {
  input: SetGallagherEmailFieldIdentifierForIntegrationInput;
};


export type MutationSetGoogleWorkingLocationSyncSettingForOrgArgs = {
  organizationId: Scalars['ID'];
  value: Scalars['Boolean'];
};


export type MutationSetGoogleWorkingLocationSyncSettingForUserArgs = {
  organizationId: Scalars['String'];
  sourceOfTruth?: InputMaybe<GoogleWorkingLocationSourceOfTruth>;
  userId: Scalars['ID'];
};


export type MutationSetMyHomepageArgs = {
  input: SetMyHomepageInput;
};


export type MutationSetMyLanguageTagArgs = {
  input: SetMyLanguageTagInput;
};


export type MutationSetMyWorkingHoursArgs = {
  input: SetMyWorkingHoursInput;
};


export type MutationSetNotificationPreferenceForCurrentUserArgs = {
  isEnabled: Scalars['Boolean'];
  preferenceKey?: InputMaybe<NotificationPreferenceKey>;
};


export type MutationSetOpenpathCredentialProvisioningEnabledForIntegrationArgs = {
  input: SetOpenpathCredentialProvisioningEnabledForIntegrationInput;
};


export type MutationSetOpenpathPresenceReportingEnabledForIntegrationArgs = {
  input: SetOpenpathPresenceReportingEnabledForIntegrationInput;
};


export type MutationSetPermissionsOnHierarchyArgs = {
  organizationId: Scalars['ID'];
  permissionCommands: Array<HierarchyPermissionCommand>;
};


export type MutationSetPermissionsOnRoleArgs = {
  organizationId: Scalars['ID'];
  permissionCommands: Array<RolePermissionCommand>;
};


export type MutationSetRecurringAnnouncementDataArgs = {
  announcementId: Scalars['ID'];
  startAt: Scalars['String'];
};


export type MutationSetRequireReleaseSignatureArgs = {
  enabled: Scalars['Boolean'];
};


export type MutationSetShowWeekendsForMeArgs = {
  input: SetShowWeekendsForMeInput;
};


export type MutationSetSuggestedSpacesEnabledForOrgArgs = {
  organizationId: Scalars['ID'];
  value: Scalars['Boolean'];
};


export type MutationSetTeamMembershipByNameArgs = {
  teamMemberUserIds: Array<Scalars['String']>;
  teamName: Scalars['String'];
};


export type MutationSetTicketIntegrationDefaultTargetConfigArgs = {
  input: SetTicketIntegrationDefaultTargetConfigInput;
};


export type MutationSetTicketIntegrationSyncDirectionsArgs = {
  input: SetTicketIntegrationSyncDirectionsInput;
};


export type MutationSetTicketIntegrationTargetConfigTransitionFieldsArgs = {
  input: SetTicketIntegrationTargetConfigTransitionFieldsInput;
};


export type MutationSetTicketIntegrationWorkflowBindingArgs = {
  input: SetTicketIntegrationWorkflowBindingInput;
};


export type MutationSetUserNotificationSettingArgs = {
  input: SetUserNotificationSettingInput;
};


export type MutationSetVisitHostsArgs = {
  hosts: Array<VisitHostInput>;
  visitId: Scalars['ID'];
};


export type MutationStartTicketIntegrationObjectImportArgs = {
  integrationId: Scalars['ID'];
};


export type MutationTestTicketIntegrationArgs = {
  id: Scalars['ID'];
};


export type MutationToggleDraftLockArgs = {
  draftId: Scalars['ID'];
};


export type MutationToggleDraftLockV2Args = {
  draftId: Scalars['ID'];
};


export type MutationTriggerManualSyncOfSpaceCalendarArgs = {
  calendarId: Scalars['ID'];
};


export type MutationUnassignStickerArgs = {
  input: UnassignStickerRequest;
};


export type MutationUnassignUsersFromDraftArgs = {
  assignees: Array<AssigneeInput>;
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationUnjoinActivityArgs = {
  activityId: Scalars['ID'];
};


export type MutationUnlinkArrivalDisplayAndBadgePrinterArgs = {
  arrivalDisplayId: Scalars['ID'];
  badgePrinterId: Scalars['ID'];
};


export type MutationUnlinkKisiLockFromRobinLevelArgs = {
  input: UnlinkKisiLockFromRobinLevelInput;
};


export type MutationUnlinkKisiLockFromRobinLocationArgs = {
  input: UnlinkKisiLockFromRobinLocationInput;
};


export type MutationUnlinkLocationFromCustomFormsArgs = {
  locationId: Scalars['ID'];
};


export type MutationUnlockOpenpathDoorForProvisionedCredentialsArgs = {
  input: UnlockOpenpathDoorForProvisionedCredentialsInput;
};


export type MutationUpdateActivityArgs = {
  activityId: Scalars['ID'];
  input: UpdateActivityInput;
};


export type MutationUpdateAllocationMetadataArgs = {
  input: UpdateAllocationMetadataInput;
};


export type MutationUpdateAnnouncementArgs = {
  announcementId: Scalars['ID'];
  content: AnnouncementUpdateInput;
};


export type MutationUpdateArrivalDisplayArgs = {
  badgePrinterId?: InputMaybe<Scalars['String']>;
  guestImageCaptureEnabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  locationId: Scalars['ID'];
  name: Scalars['String'];
  selfRegistrationEnabled?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateBadgePrinterArgs = {
  arrivalDisplayIds?: InputMaybe<Array<Scalars['ID']>>;
  badgePrinterIPAddress?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  locationId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateBookingWindowPolicyForLocationArgs = {
  input: UpdateBookingWindowPolicyInput;
};


export type MutationUpdateCustomResourceTemplateAssociatedAmenitiesArgs = {
  associatedAmenityIds?: InputMaybe<Array<Scalars['ID']>>;
  organizationID: Scalars['ID'];
  templateId: Scalars['ID'];
};


export type MutationUpdateCustomResourceTemplateSubcategoriesArgs = {
  organizationId: Scalars['ID'];
  subcategoryUpdates: Array<SubcategoryUpdatePairInput>;
  templateId: Scalars['ID'];
};


export type MutationUpdateCustomVisitFormArgs = {
  id?: InputMaybe<Scalars['ID']>;
  update?: InputMaybe<CustomVisitFormInput>;
};


export type MutationUpdateCustomWorkingHoursArgs = {
  customWorkingHoursId: Scalars['ID'];
  customWorkingHoursUpdate: CustomWorkingHoursUpdateInput;
};


export type MutationUpdateDefaultPassArgs = {
  input: UpdateDefaultPassInput;
};


export type MutationUpdateDeliveryArgs = {
  clientOptions?: InputMaybe<ClientOptionsInput>;
  id: Scalars['ID'];
  input: UpdateDeliveryInput;
};


export type MutationUpdateDeliveryStatusByMagicLinkArgs = {
  base64Signature?: InputMaybe<Scalars['String']>;
  magicLink: Scalars['String'];
  status: DeliveryStatus;
};


export type MutationUpdateDeliveryZoneArgs = {
  id: Scalars['ID'];
  input: UpdateDeliveryZoneInput;
};


export type MutationUpdateDistributionsByAnnouncementIdArgs = {
  announcementId: Scalars['ID'];
  distributions: Array<DistributionInput>;
};


export type MutationUpdateDraftArgs = {
  changes: Array<DeskChangeInput>;
  id: Scalars['ID'];
  resolvingConflict?: InputMaybe<Scalars['Boolean']>;
  version: Scalars['Int'];
};


export type MutationUpdateDraftDataArgs = {
  id: Scalars['ID'];
  showPreview?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateDraftDataV2Args = {
  currentFloorId?: InputMaybe<Scalars['ID']>;
  draftId: Scalars['ID'];
  showPreview?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateDraftHeartbeatArgs = {
  eventUid: Scalars['String'];
};


export type MutationUpdateDraftMetadataArgs = {
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationUpdateDraftMetadataV2Args = {
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationUpdateDraftNeighborhoodArgs = {
  changes: Array<NeighborhoodChangeInput>;
  draftId: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationUpdateDraftNeighborhoodV2Args = {
  changes: Array<NeighborhoodChangeInputV2>;
  draftId: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationUpdateDraftV2Args = {
  changes: Array<DeskChangeInput>;
  id: Scalars['ID'];
  resolvingConflict?: InputMaybe<Scalars['Boolean']>;
  version: Scalars['Int'];
};


export type MutationUpdateEmailConfigurationArgs = {
  input: EmailConfigurationInput;
  locationId: Scalars['ID'];
};


export type MutationUpdateEventV2Args = {
  input: UpdateEventV2Input;
};


export type MutationUpdateFloorAllocationsArgs = {
  input: UpdateFloorAllocationsInput;
};


export type MutationUpdateGenericConnectorAccountArgs = {
  input: UpdateGenericConnectorAccountInput;
};


export type MutationUpdateHostSettingsArgs = {
  hostUserId: Scalars['ID'];
  isVisibleToGuests?: InputMaybe<Scalars['Boolean']>;
  sendNotifications?: InputMaybe<Scalars['Boolean']>;
  visitId: Scalars['ID'];
};


export type MutationUpdateInsightsAssistantFeedbackForMessageArgs = {
  conversationId: Scalars['ID'];
  input: InsightsAssistantFeedbackInputV1;
  messageId: Scalars['ID'];
};


export type MutationUpdateInsightsAssistantFeedbackForMessageV2Args = {
  conversationId: Scalars['ID'];
  input: InsightsAssistantFeedbackV2Input;
  messageId: Scalars['ID'];
};


export type MutationUpdateIssueReportArgs = {
  input: UpdateIssueReportInput;
};


export type MutationUpdateLayoutDraftArgs = {
  changes: DraftLayoutInputEntity;
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationUpdateMeetingServiceArgs = {
  input: UpdateMeetingServiceInput;
};


export type MutationUpdateMeetingServiceRequestStatusArgs = {
  input: UpdateMeetingServiceRequestStatusInput;
};


export type MutationUpdateMyReservationDeskAndTimeFrameArgs = {
  input: UpdateMyReservationDeskAndTimeFrameInput;
};


export type MutationUpdatePassArgs = {
  input?: InputMaybe<PassInput>;
};


export type MutationUpdatePassForPlacesArgs = {
  input?: InputMaybe<MultiPlacePassInput>;
};


export type MutationUpdateRecurringReservationDatesArgs = {
  endInstancesInProgress?: InputMaybe<Scalars['Boolean']>;
  seriesId: Scalars['ID'];
  updatedDates: Array<Scalars['Date']>;
};


export type MutationUpdateRecurringReservationRdateArgs = {
  rdateRule: Scalars['String'];
  sendNotification?: InputMaybe<Scalars['Boolean']>;
  seriesId: Scalars['ID'];
};


export type MutationUpdateReservationVisibilityArgs = {
  reservationId: Scalars['ID'];
  visibility?: InputMaybe<DeskReservationVisibility>;
};


export type MutationUpdateShowNeighborhoodColorArgs = {
  draftId: Scalars['ID'];
  showNeighborhoodColor: Scalars['Boolean'];
  version: Scalars['Int'];
};


export type MutationUpdateShowNeighborhoodColorV2Args = {
  draftId: Scalars['ID'];
  floorId: Scalars['ID'];
  showNeighborhoodColor: Scalars['Boolean'];
  version: Scalars['Int'];
};


export type MutationUpdateStackPlanAllocationArgs = {
  allocation: UpdateStackPlanAllocationInput;
};


export type MutationUpdateStackPlanMetadataArgs = {
  input: UpdateStackPlanMetadataInput;
};


export type MutationUpdateStandardWorkingHoursForLocationArgs = {
  locationId: Scalars['ID'];
  workingHours: Array<WorkingHoursInput>;
};


export type MutationUpdateSurveyConfigurationArgs = {
  allowAnonymous?: InputMaybe<Scalars['Boolean']>;
  buildingIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  surveyId: Scalars['ID'];
};


export type MutationUpdateVisitArgs = {
  arrivalInstructions?: InputMaybe<Scalars['String']>;
  arrivalLocationId?: InputMaybe<Scalars['ID']>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  hosts?: InputMaybe<Array<VisitHostInput>>;
  id: Scalars['ID'];
  provisionCredentials?: InputMaybe<Scalars['Boolean']>;
  sendEmailNotifications?: InputMaybe<Scalars['Boolean']>;
  startTime?: InputMaybe<Scalars['ISODateTime']>;
  visitType?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateWorkAreasArgs = {
  input: UpdateWorkAreasInput;
  levelId: Scalars['ID'];
};


export type MutationUpdateWorkPolicyArgs = {
  workPolicy: WorkPolicyInput;
  workPolicyId: Scalars['String'];
};


export type MutationUpsertTicketIntegrationEntityMappingsArgs = {
  input: UpsertTicketIntegrationEntityMappingsInput;
};


export type MutationUpsertTicketIntegrationFieldMappingsArgs = {
  input: UpsertTicketIntegrationFieldMappingsInput;
};


export type MutationUpsertTicketIntegrationObjectClassAssignmentsArgs = {
  input: UpsertTicketIntegrationObjectClassAssignmentsInput;
};


export type MutationViewAnnouncementArgs = {
  announcementId: Scalars['ID'];
  locationId: Scalars['ID'];
};


export type MutationViewAnnouncementForMultipleLocationsArgs = {
  announcementId: Scalars['ID'];
  locationIds: Array<Scalars['ID']>;
};


export type MutationVisitAddDocumentTaskArgs = {
  documentBody: Scalars['DocumentBody'];
  documentName: Scalars['String'];
  isSignatureRequired?: InputMaybe<Scalars['Boolean']>;
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
  notificationEmails?: InputMaybe<Array<Scalars['WorkflowEmail']>>;
  visitTypes?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationVisitArchiveDocumentArgs = {
  documentId: Scalars['ID'];
};


export type MutationVisitAsyncRequestStatusReportArgs = {
  errorText?: InputMaybe<Array<Scalars['String']>>;
  status: VisitAsyncRequestReport;
  visitId: Scalars['ID'];
};


export type MutationVisitChangeDocumentTaskAssociationsArgs = {
  documentId: Scalars['ID'];
  locationIds: Array<Scalars['ID']>;
  notificationEmails: Array<Scalars['WorkflowEmail']>;
  visitTypes: Array<Scalars['String']>;
};


export type MutationVisitChangeDocumentTaskAssociationsWithCustomVisitTypeArgs = {
  documentId: Scalars['ID'];
  isSignatureRequired?: InputMaybe<Scalars['Boolean']>;
  locationIds: Array<Scalars['ID']>;
  notificationEmails: Array<Scalars['WorkflowEmail']>;
  visitTypes: Array<Scalars['String']>;
};

export type MyAutoDeskBookingResponse = {
  __typename: 'MyAutoDeskBookingResponse';
  autoDeskBooking: Scalars['Boolean'];
};

export type MyHomepageResponse = {
  __typename: 'MyHomepageResponse';
  homepage: HomepageType;
};

export type MyLanguageTagResponse = {
  __typename: 'MyLanguageTagResponse';
  languageTag: Maybe<Scalars['String']>;
};

export type MyShowWeekendsResponse = {
  __typename: 'MyShowWeekendsResponse';
  showWeekends: Scalars['Boolean'];
};

/** A device from the Neat Pulse API. An Endpoint implementer. `id` is the catalog surrogate when the device resolves from the catalog, and the Neat vendor device id when it comes from the live Neat query — the live mutations pass that id straight to the vendor API, so it must keep resolving the value Neat knows. The room/region/location fields describe the vendor's own organization and are null for catalog rows, which record none of it. */
export type NeatPulseDevice = Endpoint & {
  __typename: 'NeatPulseDevice';
  connected: Maybe<Scalars['Boolean']>;
  firstSeenAt: Scalars['DateTime'];
  id: Scalars['ID'];
  inCallStatus: Maybe<Scalars['String']>;
  lastSeenAt: Scalars['DateTime'];
  locationId: Maybe<Scalars['ID']>;
  locationName: Maybe<Scalars['String']>;
  /** The raw model key as Neat Pulse reports it — a code such as NF23L1 — verbatim and stable, so a client can key behavior on it. */
  model: Maybe<Scalars['String']>;
  /** The product name for model, from the collector's product-name table — a label for people, which may change as the table learns better names. Key behavior on model, never on this. Null when the table does not know the model. */
  modelName: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  placement: Maybe<EndpointPlacement>;
  regionId: Maybe<Scalars['ID']>;
  regionName: Maybe<Scalars['String']>;
  relationships: Array<EndpointRelationship>;
  remoteId: Scalars['String'];
  roomId: Maybe<Scalars['ID']>;
  roomName: Maybe<Scalars['String']>;
  serial: Maybe<Scalars['String']>;
  source: EndpointSource;
  vendor: Maybe<Scalars['String']>;
};


/** A device from the Neat Pulse API. An Endpoint implementer. `id` is the catalog surrogate when the device resolves from the catalog, and the Neat vendor device id when it comes from the live Neat query — the live mutations pass that id straight to the vendor API, so it must keep resolving the value Neat knows. The room/region/location fields describe the vendor's own organization and are null for catalog rows, which record none of it. */
export type NeatPulseDeviceRelationshipsArgs = {
  kinds?: InputMaybe<Array<EndpointRelationshipKind>>;
};

export type NeatPulseDeviceSensorData = {
  __typename: 'NeatPulseDeviceSensorData';
  co2: Scalars['Float'];
  humidity: Scalars['Float'];
  illumination: Scalars['Float'];
  people: Scalars['Int'];
  shutterClosed: Scalars['Boolean'];
  temp: Scalars['Float'];
  voc: Scalars['Float'];
  vocIndex: Scalars['Float'];
};

/** A Neat Pulse room: the vendor's own grouping of endpoints. One room maps to at most one Robin space, and the room's devices are nested underneath it. */
export type NeatPulseRoom = {
  __typename: 'NeatPulseRoom';
  /** Confidence in an automatic mapping (0-1); 1 for a manual link. Null when unmapped. */
  confidence: Maybe<Scalars['Float']>;
  /** The Neat Pulse devices that belong to this room. */
  devices: Array<NeatPulseDevice>;
  /** How the room was mapped: 'manual' (an admin), 'serial_correlation' or 'name_match' (auto-discovery). Null when unmapped. */
  mappingMethod: Maybe<Scalars['String']>;
  /** The vendor room name. */
  name: Maybe<Scalars['String']>;
  /** The Robin space this room is mapped to, or null if unmapped. */
  robinSpaceId: Maybe<Scalars['Int']>;
  roomId: Scalars['ID'];
};

export type Neighborhood = {
  __typename: 'Neighborhood';
  /** @deprecated Use `colorDefinition` instead */
  color: Scalars['String'];
  colorDefinition: NeighborhoodColorDefinition;
  description: Maybe<Scalars['String']>;
  deskSchedulingAggregates: SchedulingAggregateOfDesks;
  hydratedResources: Maybe<Array<Maybe<HydratedNeighborhoodResource>>>;
  id: Scalars['ID'];
  levelId: Scalars['ID'];
  name: Scalars['String'];
  resources: Array<NeighborhoodResource>;
};

export type NeighborhoodChangeInput = {
  id: Scalars['ID'];
  state?: InputMaybe<NeighborhoodStateInput>;
};

export type NeighborhoodChangeInputV2 = {
  floorId: Scalars['ID'];
  id: Scalars['ID'];
  state?: InputMaybe<NeighborhoodStateInput>;
};

export type NeighborhoodColorChangedAuditMetadata = {
  __typename: 'NeighborhoodColorChangedAuditMetadata';
  neighborhoodName: Scalars['String'];
  newNeighborhoodColor: PublishedNeighborhoodColor;
  oldNeighborhoodColor: Maybe<PublishedNeighborhoodColor>;
};

export type NeighborhoodColorDefinition = {
  __typename: 'NeighborhoodColorDefinition';
  base: Scalars['String'];
  dark: PartialNeighborhoodColorDefinition;
  id: Scalars['ID'];
  label: NeighborhoodLabelColors;
  type: NeighborhoodColorType;
};

export type NeighborhoodColorDefinitionInput = {
  id: Scalars['ID'];
};

export enum NeighborhoodColorType {
  NH_A = 'NH_A',
  NH_B = 'NH_B',
  NH_C = 'NH_C',
  NH_D = 'NH_D',
  NH_E = 'NH_E',
  NH_F = 'NH_F',
  NH_G = 'NH_G',
  NH_H = 'NH_H',
  NH_I = 'NH_I',
  NH_J = 'NH_J',
  NH_K = 'NH_K',
  NH_L = 'NH_L',
  NH_M = 'NH_M',
  NH_N = 'NH_N'
}

export type NeighborhoodCreatedAuditMetadata = {
  __typename: 'NeighborhoodCreatedAuditMetadata';
  colorReference: PublishedNeighborhoodColor;
  neighborhoodName: Scalars['String'];
};

export type NeighborhoodCreationInput = {
  color: Scalars['String'];
  id: Scalars['ID'];
  levelId: Scalars['Int'];
  name: Scalars['String'];
  resources?: InputMaybe<Array<NeighborhoodResourceInput>>;
  rolloutId?: InputMaybe<Scalars['ID']>;
};

export type NeighborhoodDesksChangedAuditMetadata = {
  __typename: 'NeighborhoodDesksChangedAuditMetadata';
  desks: Maybe<Array<Maybe<MetadataDeskObject>>>;
  neighborhoodName: Scalars['String'];
};

export type NeighborhoodEntity = {
  __typename: 'NeighborhoodEntity';
  data: Maybe<NeighborhoodEntityData>;
  id: Scalars['ID'];
  previousState: Maybe<NeighborhoodEntityState>;
  state: Maybe<NeighborhoodEntityState>;
  type: EntityType;
};

export type NeighborhoodEntityData = {
  __typename: 'NeighborhoodEntityData';
  id: Scalars['ID'];
};

export type NeighborhoodEntityState = {
  __typename: 'NeighborhoodEntityState';
  color: Scalars['String'];
  colorDefinition: NeighborhoodColorDefinition;
  description: Maybe<Scalars['String']>;
  name: Scalars['String'];
  resources: Array<DraftNeighborhoodResource>;
};

export type NeighborhoodLabelColors = {
  __typename: 'NeighborhoodLabelColors';
  background: Scalars['String'];
  text: Scalars['String'];
};

export type NeighborhoodRemovedAuditMetadata = {
  __typename: 'NeighborhoodRemovedAuditMetadata';
  neighborhoodName: Scalars['String'];
};

export type NeighborhoodRenamedAuditMetadata = {
  __typename: 'NeighborhoodRenamedAuditMetadata';
  neighborhoodName: Scalars['String'];
  newNeighborhoodName: Maybe<Scalars['String']>;
  oldNeighborhoodName: Maybe<Scalars['String']>;
};

export type NeighborhoodResource = {
  __typename: 'NeighborhoodResource';
  resourceId: Scalars['ID'];
  type: NeighborhoodResourceType;
};

export type NeighborhoodResourceInput = {
  resourceId: Scalars['ID'];
  type: NeighborhoodResourceType;
};

export enum NeighborhoodResourceType {
  DESK = 'DESK'
}

export type NeighborhoodReviewModel = {
  __typename: 'NeighborhoodReviewModel';
  id: Scalars['ID'];
  new: Maybe<NeighborhoodReviewModelState>;
  previous: Maybe<NeighborhoodReviewModelState>;
};

export type NeighborhoodReviewModelState = {
  __typename: 'NeighborhoodReviewModelState';
  state: Maybe<NeighborhoodReviewState>;
  statistics: Maybe<Statistics>;
  totalDesks: Maybe<Scalars['Int']>;
};

export type NeighborhoodReviewState = {
  __typename: 'NeighborhoodReviewState';
  color: Maybe<Scalars['String']>;
  colorDefinition: ColorDefinition;
  name: Maybe<Scalars['String']>;
  resources: Maybe<Array<DraftNeighborhoodResource>>;
};

export type NeighborhoodStateColors = {
  __typename: 'NeighborhoodStateColors';
  available: Scalars['String'];
  busy: Scalars['String'];
  forbidden: Scalars['String'];
};

export type NeighborhoodStateInput = {
  color: Scalars['String'];
  colorDefinition: NeighborhoodColorDefinitionInput;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  resources: Array<NeighborhoodResourceInput>;
};

export type NextAvailableMeta = {
  __typename: 'NextAvailableMeta';
  end: Maybe<Scalars['String']>;
  start: Maybe<Scalars['String']>;
};

export enum NotificationPreferenceKey {
  WHOS_IN_DIGEST_EMAIL = 'WHOS_IN_DIGEST_EMAIL'
}

export type NotificationPreferences = {
  __typename: 'NotificationPreferences';
  isSubscribedToWhosInDigestEmail: Scalars['Boolean'];
};

export enum NotificationSettingType {
  EMAIL = 'EMAIL',
  PUSH = 'PUSH',
  SLACK = 'SLACK',
  TEAMS = 'TEAMS'
}

export type OfficeAccess = {
  __typename: 'OfficeAccess';
  /** @deprecated Deprecated. Please use `resolvedPlaces`. */
  campus: Maybe<Campus>;
  groups: Array<Group>;
  healthCheckpointRequired: Scalars['Boolean'];
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  /** @deprecated Deprecated. Please use `resolvedPlaces`. */
  location: Maybe<Location>;
  name: Maybe<Scalars['String']>;
  /** @deprecated Deprecated. Please use `resolvedPlaces`. */
  organization: Maybe<Organization>;
  permissions: OfficeAccessPermissions;
  /** @deprecated Deprecated in favor of places */
  place: Maybe<AccessPlace>;
  places: Maybe<Array<Maybe<AccessPlace>>>;
  resolvedPlaces: Maybe<Array<Maybe<AccessPassResolvedPlaces>>>;
  schedule: Array<Scalars['String']>;
  /** @deprecated Deprecated in favor of id */
  slug: Maybe<Scalars['String']>;
  theme: Theme;
  users: Array<User>;
};


export type OfficeAccessGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type OfficeAccessPermissions = {
  __typename: 'OfficeAccessPermissions';
  canManage: Scalars['Boolean'];
  canView: Scalars['Boolean'];
};

export enum OffsetStrategy {
  FIXED = 'FIXED'
}

export enum OnsiteConfirmationMethod {
  /** Badge Reader */
  BADGE_READER = 'BADGE_READER',
  /** Geofence */
  GEOFENCE = 'GEOFENCE',
  /** IP Address */
  IP_ADDRESS = 'IP_ADDRESS',
  /** Other */
  OTHER = 'OTHER',
  /** QR Code */
  QR_CODE = 'QR_CODE',
  /** Seat Confirmation */
  SEAT_CONFIRMATION = 'SEAT_CONFIRMATION'
}

export enum OnsiteType {
  ON_SITE_CONFIRMATION = 'ON_SITE_CONFIRMATION',
  REMOTE_CONFIRMATION = 'REMOTE_CONFIRMATION',
  SCHEDULED = 'SCHEDULED'
}

export type OnsitesLimit = {
  ceiling?: InputMaybe<Scalars['Int']>;
  floor?: InputMaybe<Scalars['Int']>;
  strategy: LimitStrategy;
  value?: InputMaybe<Scalars['Int']>;
};

export type OnsitesOffset = {
  strategy: OffsetStrategy;
  value: Scalars['Int'];
};

export enum OperatingSystem {
  ANDROID = 'ANDROID',
  IOS = 'IOS'
}

/** Specifies the direction of ordering for query results. */
export enum OrderDirection {
  /** Ascending order (A-Z, 0-9, false-true) */
  ASC = 'ASC',
  /** Descending order (Z-A, 9-0, true-false) */
  DESC = 'DESC'
}

export enum Ordinality {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type Organization = EventAuditLogActor & {
  __typename: 'Organization';
  /** Total desks on the floor - excluding inactive. */
  activeDeskCount: Maybe<Scalars['Int']>;
  avatar: Maybe<Scalars['String']>;
  campuses: Array<Campus>;
  createdAt: Maybe<Scalars['Date']>;
  /** Delivery settings for this organization. Individual fields are null if not configured. */
  deliverySettings: DeliverySettings;
  /**
   * Total number of booked desks within the organization
   * @deprecated Deprecated in favor of deskSchedulingAggregates
   */
  deskBookedTotal: Scalars['Int'];
  /** Total desks within the organization that fit within various scheduling type and status buckets */
  deskSchedulingAggregates: SchedulingAggregateOfDesks;
  /**
   * Total number of unavailable desks within the organization
   * @deprecated Deprecated in favor of deskSchedulingAggregates
   */
  deskUnavailableTotal: Scalars['Int'];
  features: Maybe<OrganizationFeatures>;
  /** Indicates if organization has active locations (meaning any locations added to an org). */
  hasActiveLocations: Scalars['Boolean'];
  /** Indicates if organization has at least one active map (floorplan). */
  hasActiveMaps: Scalars['Boolean'];
  /** Indicates if organization has uploaded/submitted at least a single map (floorplan). */
  hasUploadedMaps: Scalars['Boolean'];
  id: Scalars['ID'];
  locations: Array<Location>;
  logo: Maybe<Scalars['String']>;
  mapOnboardingStatus: OrganizationMapOnboardingStatus;
  monochromeLogo: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  /** Organization-level primary brand color (hex string) configured under Manage > Customization > Branding in the dashboard. Stored under organization setting slug `theme` as `{ primaryColor }`. Null when not set. */
  primaryColor: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
  /** @deprecated Use `activeDeskCount` instead */
  totalDesks: Scalars['Int'];
  updatedAt: Scalars['Date'];
  /** Stable identifier from robin-api, as 32 lowercase hex characters. Null for records that have not been assigned one yet. */
  uuid: Maybe<Scalars['ID']>;
};


export type OrganizationLocationsArgs = {
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
};

export type OrganizationExternalAccount = {
  __typename: 'OrganizationExternalAccount';
  accessToken: Maybe<Scalars['String']>;
  accountId: Scalars['ID'];
  domain: Maybe<Scalars['String']>;
  externalId: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  state: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
};

export type OrganizationFeatureLimits = {
  __typename: 'OrganizationFeatureLimits';
  activatedUsers: MeteredFeature;
  activeUsers: MeteredFeature;
  bookableSeats: MeteredFeature;
  bookableSpaces: MeteredFeature;
  campuses: MeteredFeature;
  exportableDataDays: MeteredFeature;
  invitedUsers: MeteredFeature;
  levels: MeteredFeature;
  locations: MeteredFeature;
  ripplingUsers: MeteredFeature;
  viewableDataDays: MeteredFeature;
  visitorManagementLocations: MeteredFeature;
  workplaceServicesLocations: MeteredFeature;
};

export type OrganizationFeatures = {
  __typename: 'OrganizationFeatures';
  adminOnlyBooking: Scalars['Boolean'];
  amenities: Scalars['Boolean'];
  announcements: Scalars['Boolean'];
  billingUIV1: Scalars['Boolean'];
  /** @deprecated Use `limits` instead */
  bookableSeatLimit: Maybe<Scalars['Int']>;
  /** @deprecated Use `limits` instead */
  bookableSpaceLimit: Maybe<Scalars['Int']>;
  campuses: Scalars['Boolean'];
  customLogo: Scalars['Boolean'];
  customRoles: Scalars['Boolean'];
  customThemes: Scalars['Boolean'];
  documentAgreements: Scalars['Boolean'];
  /** @deprecated Use `limits` instead */
  exportableDataLimitDays: Maybe<Scalars['Int']>;
  hotSeatReservations: Scalars['Boolean'];
  hoteledSeatReservations: Scalars['Boolean'];
  insights: Scalars['Boolean'];
  insightsExportsApi: Scalars['Boolean'];
  issueReporting: Scalars['Boolean'];
  levels: Scalars['Boolean'];
  limits: OrganizationFeatureLimits;
  maps: Scalars['Boolean'];
  meetingApprovals: Scalars['Boolean'];
  meetingServices: Scalars['Boolean'];
  meridianMapping: Scalars['Boolean'];
  noPersonalCalendars: Scalars['Boolean'];
  overProvisioning: Scalars['Boolean'];
  peopleDirectory: Scalars['Boolean'];
  /** @deprecated Use `prioritySupport` instead. */
  premierSupport: Scalars['Boolean'];
  prioritySupport: Scalars['Boolean'];
  reverseHoteling: Scalars['Boolean'];
  ripplingIntegration: Scalars['Boolean'];
  samlAuthentication: Scalars['Boolean'];
  scim: Scalars['Boolean'];
  statusBoards: Scalars['Boolean'];
  /** @deprecated Use `limits` instead */
  userLimit: Maybe<Scalars['Int']>;
  /** @deprecated Use `limits` instead */
  viewableDataLimitDays: Maybe<Scalars['Int']>;
  visitorManagement: Scalars['Boolean'];
  workweek: Scalars['Boolean'];
};

export type OrganizationIdHashResponse = {
  __typename: 'OrganizationIdHashResponse';
  hash: Maybe<Scalars['String']>;
};

export type OrganizationLocation = {
  __typename: 'OrganizationLocation';
  locationId: Maybe<Scalars['String']>;
  orgId: Maybe<Scalars['String']>;
};

/** Indicates the status for map upload onboarding. It also provides related entities which help drive the UIs. */
export type OrganizationMapOnboardingStatus = {
  __typename: 'OrganizationMapOnboardingStatus';
  level: Maybe<Level>;
  /** This location will be the one that has a level, if organization has a level at all. */
  location: Maybe<Location>;
  shouldShowSetup: Scalars['Boolean'];
};

export type OrganizationNotificationsSetting = {
  __typename: 'OrganizationNotificationsSetting';
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  values: Array<Maybe<NotificationSettingType>>;
};

/** Maps organization IDs to their work areas */
export type OrganizationWorkAreasMap = {
  __typename: 'OrganizationWorkAreasMap';
  organizationId: Scalars['ID'];
  workAreas: Array<WorkArea>;
};

export enum OwnerType {
  SEAT = 'SEAT',
  SPACE = 'SPACE',
  UNASSIGNED = 'UNASSIGNED'
}

export type PagedApiUserResult = {
  __typename: 'PagedApiUserResult';
  hasNextPage: Scalars['Boolean'];
  nextPageOffset: Maybe<Scalars['Int']>;
  users: Array<User>;
  usersTotal: Scalars['Int'];
};

export type PagedDepartmentsResult = {
  __typename: 'PagedDepartmentsResult';
  departments: Array<Department>;
  hasNextPage: Scalars['Boolean'];
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  total: Scalars['Int'];
};

export type PagedMeOrganizationResult = {
  __typename: 'PagedMeOrganizationResult';
  hasNextPage: Scalars['Boolean'];
  organizations: Array<MeOrganization>;
};

export type PagedPaginationResponse = {
  __typename: 'PagedPaginationResponse';
  hasMore: Scalars['Boolean'];
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type PagedUserFilterInput = {
  /** Filter to users added to the org within the last N days (by created_at). */
  addedWithinDays?: InputMaybe<Scalars['Int']>;
  /** Draft-scoped filtering: assignment status within a draft and/or restrict to the draft's queue. */
  assignmentDraft?: InputMaybe<AssignmentDraftFilter>;
  /** Filter to users whose department is any of these (free-text department values). */
  departments?: InputMaybe<Array<Scalars['String']>>;
  favoriteFilter?: InputMaybe<Scalars['Boolean']>;
  /** Filter to users who belong to this group. */
  groupId?: InputMaybe<Scalars['ID']>;
  hasActivity?: InputMaybe<Scalars['Boolean']>;
  /** Filter to users managed by any of these manager user ids. */
  managerIds?: InputMaybe<Array<Scalars['ID']>>;
  preferredLocationFilter?: InputMaybe<Scalars['ID']>;
  /** Filter to users who hold this role slug (directly or via a group). */
  roleSlug?: InputMaybe<Scalars['String']>;
  /** Filter to users whose membership status is any of these. Absent/empty defaults to everything EXCEPT DEACTIVATED (the historical default list). An explicit [ACTIVE] is strict: it excludes ADDED / INVITE_PENDING / INVITE_EXPIRED. */
  statuses?: InputMaybe<Array<UserStatus>>;
  userNameFilter?: InputMaybe<Scalars['String']>;
};

export type PagedUserResult = {
  __typename: 'PagedUserResult';
  accountUsers: Array<AccountUser>;
  accountUsersTotal: Scalars['Int'];
  hasNextPage: Scalars['Boolean'];
  nextPageOffset: Scalars['Int'];
  users: Array<User>;
};

export type PagedUserResultV2 = {
  __typename: 'PagedUserResultV2';
  accountUsers: Array<AccountUser>;
  accountUsersTotal: Scalars['Int'];
  hasNextPage: Scalars['Boolean'];
  nextPageOffset: Scalars['Int'];
};

export type PagedUserSort = {
  field: PagedUserSortField;
  order: UserSortOrder;
};

export enum PagedUserSortField {
  CREATED_AT = 'CREATED_AT',
  FAMILY_NAME = 'FAMILY_NAME',
  GIVEN_NAME = 'GIVEN_NAME'
}

export type PaginatedUnhealthyCalendarsForNotificationsResponse = {
  __typename: 'PaginatedUnhealthyCalendarsForNotificationsResponse';
  cursor: Maybe<Scalars['ID']>;
  orgCalendars: Array<GroupedUnhealthyCalendarOrg>;
};

export type ParsedDeliveryImage = {
  __typename: 'ParsedDeliveryImage';
  carrier: Maybe<Scalars['String']>;
  matchedUsers: Array<User>;
  parsedRecipients: Array<Scalars['String']>;
  trackingNumber: Maybe<Scalars['String']>;
};

export type ParsedDeliveryText = {
  __typename: 'ParsedDeliveryText';
  matchedUsers: Array<User>;
  parsedRecipients: Array<Scalars['String']>;
};

export type PartialNeighborhoodColorDefinition = {
  __typename: 'PartialNeighborhoodColorDefinition';
  base: Scalars['String'];
  label: NeighborhoodLabelColors;
};

export enum ParticipationStatus {
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  NOT_RESPONDED = 'NOT_RESPONDED',
  TENTATIVE = 'TENTATIVE',
  UNKNOWN = 'UNKNOWN'
}

export type PassInput = {
  groups: Array<Scalars['ID']>;
  healthCheckpointRequired?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  place: PassPlaceInput;
  schedule: Array<Scalars['String']>;
  userChanges?: InputMaybe<PassUsersInput>;
};

export type PassPlaceInput = {
  id: Scalars['ID'];
  type: AccessPlaceType;
};

export type PassUsersInput = {
  added?: InputMaybe<Array<Scalars['ID']>>;
  removed?: InputMaybe<Array<Scalars['ID']>>;
};

/** Which organ of a device an incident is about. One vocabulary with the endpoint status facets — the catalog's CHECK constraint — so a status row and an incident name the same thing the same way. REACHABILITY means the box itself; CALL that it went wrong mid-call; the rest are the named peripheral. */
export enum PeripheralKind {
  CALL = 'CALL',
  CAMERA = 'CAMERA',
  DISPLAY = 'DISPLAY',
  MICROPHONE = 'MICROPHONE',
  REACHABILITY = 'REACHABILITY',
  SPEAKER = 'SPEAKER',
  TOUCH_CONTROLLER = 'TOUCH_CONTROLLER'
}

export type Permission = {
  __typename: 'Permission';
  name: Scalars['String'];
  value: Scalars['Boolean'];
};

export enum PermissionHierarchyTarget {
  CAMPUS = 'CAMPUS',
  LEVEL = 'LEVEL',
  LOCATION = 'LOCATION',
  ORGANIZATION = 'ORGANIZATION',
  RESOURCE_GROUP = 'RESOURCE_GROUP',
  RESOURCE_INSTANCE = 'RESOURCE_INSTANCE'
}

export type PermissionScope = {
  __typename: 'PermissionScope';
  allowedLocationIds: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** @deprecated No longer supported */
  allowedOrgIds: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type PersistBuildingNeighborhoodsFromDraftResponse = {
  __typename: 'PersistBuildingNeighborhoodsFromDraftResponse';
  floors: Array<FloorNeighborhoodResult>;
};

export type PersistNeighborhoodInput = {
  color: Scalars['String'];
  colorReference: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  resources: Array<NeighborhoodResourceInput>;
};

export type PersistNeighborhoodsResponse = {
  __typename: 'PersistNeighborhoodsResponse';
  createdNeighborhoods: Array<Scalars['ID']>;
  deletedNeighborhoods: Array<Scalars['ID']>;
  updatedNeighborhoods: Array<Scalars['ID']>;
};

export type PinnedUserSpaceEntity = {
  __typename: 'PinnedUserSpaceEntity';
  locationId: Scalars['String'];
  spaceIds: Array<Scalars['String']>;
};

export type PlaceAvailability = {
  __typename: 'PlaceAvailability';
  status: PlaceAvailabilityType;
  unavailableReasons: Array<PlaceUnavailableReason>;
};

export enum PlaceAvailabilityType {
  AVAILABLE = 'AVAILABLE',
  UNAVAILABLE = 'UNAVAILABLE'
}

export enum PlaceType {
  LOCATION = 'location'
}

export enum PlaceUnavailableReason {
  /** The location is closed according to its working hours */
  BUILDING_CLOSED = 'BUILDING_CLOSED',
  /** The maxiumum number of flexible desks have been booked in this location */
  MAX_CAPACITY_REACHED = 'MAX_CAPACITY_REACHED',
  /** The user doesn't have a pass */
  NO_ACCESS = 'NO_ACCESS',
  /** The user has a pass but it doesn't grant access to the location */
  NO_LOCATION_ACCESS = 'NO_LOCATION_ACCESS',
  /** The user has a pass to the location, but it's not valid during the specified start and end times */
  SCHEDULE_VIOLATION = 'SCHEDULE_VIOLATION'
}

export type Policy = {
  __typename: 'Policy';
  is_allowed: Scalars['Boolean'];
  object_id: Scalars['String'];
  object_type: Scalars['String'];
  permission_operation: Scalars['String'];
};

export type PolicyEnabledWithDurationCommand = {
  duration?: InputMaybe<Scalars['ISO8601_Duration']>;
  enabled: Scalars['Boolean'];
};

export type PolicyEnabledWithDurationType = {
  __typename: 'PolicyEnabledWithDurationType';
  duration: Maybe<Scalars['ISO8601_Duration']>;
  enabled: Scalars['Boolean'];
};

export enum PolicyType {
  ABANDONED_RESOURCE_PROTECTION = 'ABANDONED_RESOURCE_PROTECTION',
  ADVANCED_BOOKING_THRESHOLD = 'ADVANCED_BOOKING_THRESHOLD',
  ADVANCE_CHECK_IN_WINDOW = 'ADVANCE_CHECK_IN_WINDOW',
  ALLOW_OVERLAPPING_BOOKINGS = 'ALLOW_OVERLAPPING_BOOKINGS',
  BOOKING_PRIVACY = 'BOOKING_PRIVACY',
  LOCAL_CHECK_IN_ONLY = 'LOCAL_CHECK_IN_ONLY',
  MAX_BOOKING_LENGTH = 'MAX_BOOKING_LENGTH',
  PREVENT_BOOKING_FROM_KIOSK = 'PREVENT_BOOKING_FROM_KIOSK',
  RECURRENCE = 'RECURRENCE',
  /** @deprecated This policy is deprecated */
  REQUIRE_CHECK_IN = 'REQUIRE_CHECK_IN',
  RESERVATION_TYPE = 'RESERVATION_TYPE',
  RESOURCE_BUSY = 'RESOURCE_BUSY',
  RESOURCE_SHARING = 'RESOURCE_SHARING',
  RESTRICT_BOOKING_TO_WORKING_HOURS = 'RESTRICT_BOOKING_TO_WORKING_HOURS'
}

export type PrebuiltSigmaWorkbooksMap = {
  __typename: 'PrebuiltSigmaWorkbooksMap';
  collab_score_demo: Scalars['String'];
  custom_resources: Scalars['String'];
  desk_insights: Scalars['String'];
  executive_insights_aa: Scalars['String'];
  future_year_reservations: Scalars['String'];
  inventory: Scalars['String'];
  landing_page: Scalars['String'];
  people_roster: Scalars['String'];
  presence: Scalars['String'];
  space_insights: Scalars['String'];
  stack_visualizations: Scalars['String'];
  workplace_insights: Scalars['String'];
};

export enum PreviewTicketIntegrationFieldRenderErrorReason {
  /** The sampleEntity does not exist in this tenant. */
  ENTITY_NOT_FOUND = 'ENTITY_NOT_FOUND',
  NOT_ACTIVE = 'NOT_ACTIVE',
  NOT_CONNECTED = 'NOT_CONNECTED',
  NOT_FOUND = 'NOT_FOUND',
  PROVIDER_CAPABILITY_MISSING = 'PROVIDER_CAPABILITY_MISSING',
  PROVIDER_UNREACHABLE = 'PROVIDER_UNREACHABLE',
  WORKFLOW_NOT_FOUND = 'WORKFLOW_NOT_FOUND'
}

export type PreviewTicketIntegrationFieldRenderErrorResponse = {
  __typename: 'PreviewTicketIntegrationFieldRenderErrorResponse';
  reason: PreviewTicketIntegrationFieldRenderErrorReason;
};

/** Supplied `mappings` failed the upsert's validation rules; nothing was rendered. Indexes refer to the `mappings` argument. */
export type PreviewTicketIntegrationFieldRenderInvalidMappingsResponse = {
  __typename: 'PreviewTicketIntegrationFieldRenderInvalidMappingsResponse';
  itemErrors: Array<UpsertTicketIntegrationFieldMappingsItemError>;
};

export type PreviewTicketIntegrationFieldRenderResponse = PreviewTicketIntegrationFieldRenderErrorResponse | PreviewTicketIntegrationFieldRenderInvalidMappingsResponse | PreviewTicketIntegrationFieldRenderSuccessResponse;

export type PreviewTicketIntegrationFieldRenderSuccessResponse = {
  __typename: 'PreviewTicketIntegrationFieldRenderSuccessResponse';
  renderedFields: Array<PreviewedTicketIntegrationField>;
  /** The entity the sample ticket was rendered for (echoes the request, or the server's pick when omitted). */
  sampleEntity: TicketIntegrationPreviewEntityRef;
  warnings: Array<PreviewTicketIntegrationFieldRenderWarning>;
};

export type PreviewTicketIntegrationFieldRenderWarning = {
  __typename: 'PreviewTicketIntegrationFieldRenderWarning';
  reason: PreviewTicketIntegrationFieldRenderWarningReason;
  /** Null for warnings not tied to one field. */
  targetFieldId: Maybe<Scalars['ID']>;
};

export enum PreviewTicketIntegrationFieldRenderWarningReason {
  /** A mappedPlace binding found no mapping (directly or via ancestors). */
  MAPPED_PLACE_MISSING = 'MAPPED_PLACE_MISSING',
  /** A binding rendered empty into a required field. */
  RENDERED_EMPTY_REQUIRED = 'RENDERED_EMPTY_REQUIRED',
  /** A required target field has no binding. */
  REQUIRED_UNBOUND = 'REQUIRED_UNBOUND',
  /** A value map matched no entry for the source value. */
  VALUE_MAP_MISS = 'VALUE_MAP_MISS'
}

export type PreviewedTicketIntegrationField = {
  __typename: 'PreviewedTicketIntegrationField';
  label: Scalars['String'];
  /** One value per rendered output: single-valued fields render one element, MULTI_SELECT/TAGS render several, an unbound field renders none. Every target field appears in `renderedFields`. */
  renderedValues: Array<Scalars['String']>;
  targetFieldId: Scalars['ID'];
};

export type PrimaryEmail = {
  __typename: 'PrimaryEmail';
  email: Maybe<Scalars['String']>;
  isVerified: Maybe<Scalars['Boolean']>;
};

export type PropertiesInput = {
  decorId: Scalars['ID'];
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  ownerType: Scalars['String'];
  placedOnMap: Scalars['Boolean'];
  updated: Scalars['Boolean'];
  zoneId?: InputMaybe<Scalars['ID']>;
};

/** Provider-specific error information (e.g., AADSTS codes from Microsoft) */
export type ProviderError = {
  __typename: 'ProviderError';
  code: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
};

export enum ProxiedEventResponseStatus {
  CANCELLED = 'CANCELLED',
  CONFIRMED = 'CONFIRMED',
  TENTATIVE = 'TENTATIVE',
  UNKNOWN = 'UNKNOWN'
}

export type PublicArrivalDisplay = {
  __typename: 'PublicArrivalDisplay';
  id: Scalars['ID'];
  location: PublicLocationOrDefault;
  name: Scalars['String'];
  organization: PublicOrganization;
};

export type PublicGuest = {
  __typename: 'PublicGuest';
  email: Scalars['String'];
  id: Scalars['ID'];
  imageURL: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type PublicLocationOrDefault = {
  __typename: 'PublicLocationOrDefault';
  address: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isHealthCheckpointRequired: Scalars['Boolean'];
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  timezone: Maybe<Scalars['String']>;
  /** Stable identifier from robin-api, as 32 lowercase hex characters. Null for records that have not been assigned one yet. */
  uuid: Maybe<Scalars['ID']>;
};

export type PublicOrganization = {
  __typename: 'PublicOrganization';
  id: Scalars['ID'];
  logo: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
  /** Stable identifier from robin-api, as 32 lowercase hex characters. Null for records that have not been assigned one yet. */
  uuid: Maybe<Scalars['ID']>;
};

export type PublicUserWithDefault = {
  __typename: 'PublicUserWithDefault';
  avatar: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Maybe<Scalars['String']>;
};

export type PublicUserWithEmail = {
  __typename: 'PublicUserWithEmail';
  avatar: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Maybe<Scalars['String']>;
};

/** A PublicVisitHost represents a host assigned to a public visit (e.g., arrival display) */
export type PublicVisitHost = {
  __typename: 'PublicVisitHost';
  /** Host robin user */
  host: PublicUserWithEmail;
  /** Host user ID */
  hostUserId: Scalars['ID'];
  /** Whether this host is visible to guests */
  isVisibleToGuests: Scalars['Boolean'];
};

/** PublicVisitResult represents the visit for a single GuestInvite. The result is "public" because it is available to the public via Arrival Display kiosk devices. A PublicVisitResult is the guest (GuestInvite) along with information about their associated Visit. */
export type PublicVisitResult = {
  __typename: 'PublicVisitResult';
  arrivalInstructions: Maybe<Scalars['String']>;
  arrivalLocation: PublicLocationOrDefault;
  arrivalLocationId: Scalars['String'];
  checkinOn: Maybe<Scalars['String']>;
  checkoutOn: Maybe<Scalars['String']>;
  customVisitType: Scalars['String'];
  guest: PublicGuest;
  healthCheckpointSurveyResponse: Maybe<GenericHealthCheckpointResponse>;
  /**
   * Legacy single host - deprecated in favor of hosts array
   * @deprecated Use hosts array instead to support multiple hosts per visit
   */
  host: PublicUserWithEmail;
  /** All hosts assigned to this visit with their settings */
  hosts: Array<PublicVisitHost>;
  /** The ID of the GuestInvite */
  id: Scalars['ID'];
  inviteCustomFields: Maybe<Array<CustomField>>;
  organization: PublicOrganization;
  startTime: Scalars['ISODateTime'];
  status: GuestInviteStatus;
  visitCustomFields: Maybe<Array<CustomField>>;
  /** The ID of the associated visit */
  visitId: Scalars['ID'];
  /** @deprecated replaced by the more flexible customVisitType */
  visitType: VisitType;
};

export type PublishedNeighborhoodColor = {
  __typename: 'PublishedNeighborhoodColor';
  base: Scalars['String'];
  id: Scalars['String'];
  type: Scalars['String'];
};

export type PublishedNeighborhoodColorDefinition = {
  __typename: 'PublishedNeighborhoodColorDefinition';
  base: Scalars['String'];
  id: Scalars['ID'];
};

export enum QueryVisitDocumentSortBy {
  ADDED_ON = 'ADDED_ON',
  NAME = 'NAME',
  STATUS = 'STATUS'
}

export enum QueryWorkflowSortOrder {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING'
}

export type Query = {
  __typename: 'Query';
  /** Allows arrival displays to self-rescue. If you know, you know. Vague by design. */
  arrivalDisplaySelfRescue: Array<Scalars['String']>;
  autoDeskBookingAttemptedForLocalDate: Array<AutoDeskBookingAttemptedResponseType>;
  /** Returns a array of AutoDeskBookingScheduleResponse based on the users schedule. It will search the full week starting from Sunday through Saturday and return the dates only in the users schedule and the auto desk booking status for that date, */
  autoDeskBookingAttemptsForUserSchedule: Array<AutoDeskBookingScheduleResponse>;
  /** Badge printer IP address */
  badgePrinterIPAddress: Scalars['String'];
  /** A building's durable record of one discovery run, keyed by run. Distinct from endpointDiscoveryStatus: that is tenant-scoped live progress for a polling screen, this is a building-scoped, durable, possibly-historical report — pass runId for a specific run, or omit it for the building's most recent. */
  buildingDiscoveryReport: BuildingDiscoveryReportResponse;
  /** Whether the caller can create a building draft for this building: scenario_plan:manage on it, and at least one floor with a map and active desks. */
  canUserCreateBuildingDraft: Scalars['Boolean'];
  canUserDelegateDesk: Scalars['Boolean'];
  checkOrganizationNameAvailability: Maybe<CheckOrganizationNameAvailabilityResponse>;
  /** Compare the stored mappings against the provider's live fields and report broken references (a renamed/deleted field or option). */
  checkTicketIntegrationFieldMappingDrift: CheckTicketIntegrationFieldMappingDriftResponse;
  checkUserEmails: EmailCheckResponse;
  /** Counts issue reports with the same visibility rules as listIssueReports. Can use with listIssueReports to get total result count for pagination. */
  countIssueReports: CountIssueReportsResponse;
  /** Requires permission to manage services in at least one place. Can use with listMeetingServiceRequests to get total result count for pagination. */
  countMeetingServiceRequests: CountMeetingServiceRequestsResponse;
  /** Requires permission to manage services in at least one place. Can use with listMeetingServices to get total result count for pagination. */
  countMeetingServices: CountMeetingServicesResponse;
  countMeetingServicesCategories: CountMeetingServicesCategoriesResponse;
  /** Total count of filtered visit documents */
  countVisitFilteredDocuments: Scalars['Int'];
  /** Provides policy configuration documents for the specified location, filtered to the categories specified. */
  customResourceLocationCategoryPolicies: Array<CustomResourcePolicyDocument>;
  /** Provides the policy document configuration for a resource, or default if not configured */
  customResourcePolicies: CustomResourcePolicyDocument;
  /** Provides the policy document configuration for a prospective resource, or default if not configured */
  customResourceProspectivePolicies: CustomResourcePolicyDocument;
  /** Returns whether CRC has finished processing a specific publication session and the session's published data is up to date. */
  customResourcePublicationSessionStatus: CustomResourcePublicationSessionStatusType;
  /** Query for reservations for a set of custom resources over a range of dates */
  customResourceReservations: CustomResourceReservationsRangeResponseType;
  /** Query for reservations within a date range for the current user */
  customResourceReservationsForCurrentUserGroupedByDate: CustomResourceReservationsGroupedByDateResponseType;
  /** Query for reservations for a set of custom resources by time over a list of dates */
  customResourceReservationsGroupedByDate: CustomResourceReservationsGroupedByDateResponseType;
  /** Provides the policy document configuration for many resource, or default if not configured. If defaults are returned, they represent the default policies for the Robin-provided templates which differ from user-defined template policies. */
  customResourcesPolicies: Array<CustomResourcePolicyDocument>;
  /** Provides the default policy configuration for Robin-provided custom resource templates */
  defaultRobinCustomResourcePolicies: CustomResourcePolicyDocument;
  /** Provides the default policy configuration for user-created custom resource templates */
  defaultUserCustomResourcePolicies: CustomResourcePolicyDocument;
  /** Tells you if the current user is allowed to report issues on a desk */
  deskAllowsIssueReports: ResourceAllowsIssueReportsResponse;
  doIHaveACalendar: Maybe<Scalars['Boolean']>;
  employeeVisit: EmployeeVisitQueries;
  /** How far along endpoint discovery is, for a screen that has to wait on it. */
  endpointDiscoveryStatus: EndpointDiscoveryStatusResponse;
  /** Signals for a box, a source record or a place. Current state for a box or a source record is backed today. A place subject and since (history) throw notImplemented until a store holds those signals. */
  endpointObservations: EndpointObservationsResponse;
  /** Relationships for one thing, or between two things. Give node alone for everything touching it. Give relatedTo as well to ask what the graph believes about that specific pair — including nothing, which is a real answer during onboarding rather than an error. The result mixes relationships the service stored with ones it worked out on the spot, and does not distinguish them. The service owns that merge so that the set of joins it can do can grow without every client changing. */
  endpointRelationships: EndpointRelationshipsResponse;
  /** Lists this tenant's endpoints: one entry per SOURCE RECORD, so one physical box known to two connected vendors' inventories appears once per source, joined by its IS_SAME_AS relationships. A Google Meet box that is also a ChromeOS device comes back once, as the ChromeOS device. A GOOGLE_MEET source filter returns every Meet box. Unpaginated, and O(tenant) to answer. That is the right trade for the onboarding and admin screens that read it and the wrong one for a hot path, which is why it is documented rather than quietly capped. */
  endpoints: EndpointsResponse;
  exportDraftChanges: Scalars['String'];
  exportDraftChangesV2: Scalars['String'];
  exportPublishedDraftChangesV2: Scalars['String'];
  /** The tenant's buildings and their floors, with per-floor room-health counts — the fleet dashboard's tree. Buildings are Robin Locations and floors are Levels, referenced by id; their names resolve from the place subgraph. */
  fleetBuildings: FleetBuildingsResponse;
  /** One call by id, scoped to the Tenant-Id header. Null when the call is not found for this tenant. */
  fleetCall: Maybe<Call>;
  /** The tenant's rooms and the hardware in them, optionally scoped to one building or floor. Each room is a Robin Space with its placed Endpoints and rolled-up health; the sensor and scoring fields are null until this service collects them. */
  fleetRooms: FleetRoomsResponse;
  /** The integrations the fleet depends on, and whether each is usable right now. */
  fleetServices: FleetServicesResponse;
  /** Tenant-wide fleet rollups for the dashboard header, optionally scoped to one building or floor. */
  fleetSummary: FleetSummary;
  /** One box by id, with everything known about it — the device drill-in. Scoped to the Tenant-Id header. */
  fusedEndpoint: FusedEndpointResponse;
  getAccountUsersByIds: Maybe<Array<Maybe<AccountUser>>>;
  /** Get all active announcements for a given location, within the specific location context & for current user. (e.g. viewedAt - when has the current user first viewed this announcement at provided location) */
  getActiveAnnouncementsByLocationId: Array<AnnouncementForLocation>;
  /** Get all active announcements for given locations, within the specific location context & for current user. (e.g. viewedAt - when has the current user first viewed this announcement at provided location) */
  getActiveAnnouncementsByLocationIds: Array<AnnouncementForLocation>;
  /** Get all active announcements for given locations, suitable for unattended status boards / kiosks. Returns no per-user state. Accepts any authenticated request with a tenant-id header (no user context required). */
  getActiveAnnouncementsByLocationIdsForStatusBoard: Array<AnnouncementForStatusBoard>;
  getActiveDistributionsByAuthorId: Array<Maybe<AnnouncementDistributionForLocation>>;
  getActiveDistributionsByOrganizationId: Array<Maybe<AnnouncementDistributionForLocation>>;
  /** Get list of active visit types for org */
  getActiveVisitTypesForOrg: Array<Scalars['String']>;
  getActivitiesSummaryForTimeRangeByLocationIds: Array<DailyActivitiesSummary>;
  /** Gets the latest messages for activity chat. Window from latest message ID. Retrieves messages newer than the referenced message. */
  getActivityChatNewerMessages: Array<ChatMessage>;
  /** Returns the set of message IDs in chat that have been removed after the specified timestamp. */
  getActivityChatRemovedMessagesSince: Array<Scalars['ID']>;
  /** Gets the latest messages for activity chat. Optional parameter @messagesPriorTo is the identity of the earliest ChatMessage of which the client is aware. Providing @messagesPriorTo retrieves the previous page of messages. Default @pageSize is 5. */
  getActivityChatTail: Array<ChatMessage>;
  getActivityCoverImages: GetActivityCoverImagesResponse;
  getActivityForCurrentUserById: ActivityForCurrentUser;
  getAllActivitiesForDateByLocationIds: Array<ActivitiesByLocation>;
  /** Get all activities for the given date and locations, suitable for unattended status boards / kiosks. Returns no per-user state. Accepts any authenticated request with a tenant-id header (no user context required). */
  getAllActivitiesForDateByLocationIdsForStatusBoard: Array<ActivitiesByLocationForStatusBoard>;
  getAllActivitiesForDateRangeByLocationIds: Array<ActivitiesByLocation>;
  getAllJoinedUsersByActivityId: Array<Maybe<User>>;
  getAllNeighborhoodColors: Array<NeighborhoodColorDefinition>;
  getAllOrganizationLocations: Array<Maybe<OrganizationLocation>>;
  /** Returns filtered view of all visit data for the organization specified in the tenant ID header */
  getAllVisits: Array<Visit>;
  /** One allocation draft with its split. Null when the id is not one. */
  getAllocation: Maybe<Allocation>;
  /** The allocation drafts under a stack plan, newest first. */
  getAllocations: Array<Allocation>;
  getAmenitiesByIds: Array<Amenity>;
  getAmenityById: Maybe<Amenity>;
  getAnalyticsAuthorizationToken: AnalyticsAuthorizationResponse;
  /** Get a single announcement by ID */
  getAnnouncementById: Maybe<Announcement>;
  /** Get a single announcement as type AnnouncementForLocation by ID */
  getAnnouncementForLocationById: Maybe<AnnouncementForLocation>;
  getAnnouncementViewAcknowledgeCount: Maybe<AnnouncementViewAcknowledgeCount>;
  /** Get all the announcements for an organization, filterable by location id and status */
  getAnnouncements: Array<Maybe<Announcement>>;
  getAnyDeskById: Maybe<Desk>;
  getAnyDesksByIds: Array<Desk>;
  /** Get a list of arrival displays registered to the organization of the requesting user */
  getArrivalDisplay: Maybe<ArrivalDisplay>;
  /** Arrival display settings (badge printer IP address, guest image capture enabled, guest self-registration enabled) */
  getArrivalDisplaySettings: ArrivalDisplaySettings;
  /** Get a list of arrival displays registered to the organization of the requesting user */
  getArrivalDisplays: Array<ArrivalDisplay>;
  getAuthedTeamUsersByName: Array<User>;
  /** Gets the auto desk booking setting for current (user) actor */
  getAutoDeskBooking: MyAutoDeskBookingResponse;
  /** Gets the auto desk booking setting for user */
  getAutoDeskBookingByUserId: AutoDeskBookingResponse;
  getAutoDeskBookingEnabledConfiguration: Array<AutoDeskBookingInternalResponse>;
  getAutoDeskBookingForOrg: AutoDeskBookingOrgResponse;
  getAvailableFloors: Array<Level>;
  /** Gets the status of a given badge CSV upload. */
  getBadgeCSVUploadStatus: GetBadgeCsvUploadStatusResponse;
  /** Gets a list of CSV uploads for the current tenant. */
  getBadgeCSVUploadsForCurrentTenant: GetBadgeCsvUploadsForCurrentTenantResponse;
  /** Paginated feed of badge-presence records for the current tenant, newest first. Source-agnostic so turnkey integrations can be surfaced here later. */
  getBadgePresenceAuditLogPage: GetBadgePresenceAuditLogPageResponse;
  /** All connected badge-presence integrations for the current tenant. Currently only the universal connector; turnkey integrations will be added later. */
  getBadgePresenceConnectionsForCurrentTenant: GetBadgePresenceConnectionsForCurrentTenantResponse;
  /** Gets a single badge printer via its id */
  getBadgePrinter: Maybe<BadgePrinter>;
  /** Get a list of badge printers registered to the organization of the requesting user */
  getBadgePrinters: Array<BadgePrinter>;
  /** Get a badge printers for organization by locationId */
  getBadgePrintersByLocationId: Array<BadgePrinter>;
  getBookingWindowPoliciesById: Array<Maybe<BookingWindowPolicy>>;
  getBookingWindowPoliciesForLocation: Array<BookingWindowPolicy>;
  getBookingWindowPolicyById: Maybe<BookingWindowPolicy>;
  /** Checks the Brivo account for current tenant */
  getBrivoAccountStatusForCurrentTenant: GetBrivoAccountStatusForCurrentTenant;
  /** Gets a list of Brivo locks for current tenant. */
  getBrivoLocksForCurrentTenant: GetBrivoLocksForCurrentTenant;
  /** Building drafts in a building that the caller can open, newest first, with the caller's access level on each. A planner sees every one; anyone else sees the drafts shared with them. Discarded and live-state drafts are left out. */
  getBuildingDraftsForUser: Array<BuildingDraftForUser>;
  getBuildingGeofence: GetBuildingGeofenceResponse;
  getBuildingsAtAPointForCurrentTenant: GetBuildingsAtAPointForCurrentTenantResponse;
  /** Get view count & acknowledge count for each given announcement ID */
  getBulkAnnouncementViewAcknowledgeCount: Array<AnnouncementViewAcknowledgeCountWithId>;
  getCampusById: Maybe<Campus>;
  getCampusesByIds: Array<Campus>;
  /** Return a list of visits given a guest's partial email */
  getCheckedInVisitsByPartialEmail: Array<PublicVisitResult>;
  getCompletedOnboardingStepsForOrg: Maybe<Array<CompletedOnboardingStep>>;
  getCoverImagesForActivities: ActivityCoverImagesObject;
  /** Gets credentials details for current tenant */
  getCredentialDetailsForCurrentTenant: GetCredentialDetailsForCurrentTenantResponse;
  /** Gets organization and location information for credentials and current tenant */
  getCredentialOrganizationAndLocationInfoForCurrentTenant: GetCredentialOrganizationAndLocationInfoForCurrentTenantResponse;
  /** Query to determine if current actor's permissions with regards to badge domain. */
  getCurrentActorBadgePermissionsForCurrentTenant: GetCurrentActorBadgePermissionsForCurrentTenantReponse;
  getCurrentUserAndOrgs: Maybe<CurrentUserAndOrgs>;
  /** Query custom resource templates by organization ID */
  getCustomResourceTemplates: Array<CustomResourceTemplate>;
  /** Used in conjunction with getCustomVisitForms for pagination */
  getCustomVisitFormCount: Maybe<Scalars['Int']>;
  getCustomVisitFormLocations: Maybe<CustomVisitFormLocationResponse>;
  getCustomVisitForms: Maybe<Array<CustomVisitForm>>;
  /** Get days of week for resource reservations for the next 90 days */
  getDaysOfWeekGroupedByResourceReservation: Array<DaysOfWeekGroupedByResourceReservation>;
  getDeliveries: Array<Delivery>;
  getDeliveriesCount: Scalars['Int'];
  getDeliveriesEnabledLocations: Array<DeliveryLocation>;
  /** Returns locations that the user is able to view and manage */
  getDeliveriesPermittedLocations: DeliveriesPermittedLocations;
  getDeliveryById: Maybe<Delivery>;
  /** Returns delivery confirmation context for a magic link. Used by the unauthenticated confirm page. */
  getDeliveryConfirmationInfo: DeliveryConfirmationInfo;
  getDeliveryZoneCount: Scalars['Int'];
  getDeliveryZones: Array<DeliveryZone>;
  getDepartmentDelimiterAnalysis: DepartmentDelimiterAnalysis;
  getDepartmentHierarchyAtDepartment: DepartmentHierarchyResult;
  getDepartmentsList: PagedDepartmentsResult;
  getDeskAvailabilityByLevelIdForMe: DeskAvailabilityByLevelId;
  getDeskById: Maybe<Desk>;
  getDeskExclusionById: Maybe<Exclusion>;
  getDeskExclusionsByIds: Array<Exclusion>;
  getDeskReservationById: Maybe<Reservation>;
  getDeskReservationInstancesById: Array<Reservation>;
  getDeskReservationInstancesBySeriesIds: Array<DeskReservationInstancesBySeriesId>;
  getDeskReservationsByIds: Array<Reservation>;
  getDeskReservationsByLevelId: LevelDeskReservation;
  getDeskReservationsByLocationId: LocationDeskReservation;
  getDeskReservationsBySeatId: Array<Reservation>;
  getDeskReservationsBySeatIds: Array<Reservation>;
  getDeskReservationsBySpaceIds: Array<ReservationsBySpacesForStatusBoard>;
  getDeskReservationsByUserId: UserDeskReservation;
  getDeskReservationsByUserIds: Array<UserDeskReservation>;
  getDeskReservationsByZoneId: ZoneDeskReservation;
  /** Query reservations for a set of users between two moments at a specific location. Results are grouped by date relative to the location ISO time offset. */
  getDeskReservationsForUsersAtLocationGroupedByDateAscending: DateGroupedUserReservations;
  /** Query reservations for a set of users between two moments. Results are grouped by date relative to the requesting users ISO time offset. */
  getDeskReservationsForUsersGroupedByDateAscending: DateGroupedUserReservations;
  getDesksByIds: Array<Desk>;
  getDesksWithAssigneesByLevelId: Array<DeskWithAssignees>;
  getDisabledDeskById: Maybe<Desk>;
  getDisabledDesksByIds: Array<Desk>;
  getDistributionById: AnnouncementDistribution;
  getDistributionsByAnnouncementId: Array<AnnouncementDistribution>;
  getDraftAssignmentClassification: DraftAssignmentClassification;
  getDraftAssignmentsForUsers: Array<DraftUserAssignments>;
  getDraftAuditLogs: DraftAuditLogsResponse;
  getDraftCollaborators: Array<AccountUser>;
  getDraftCollaboratorsV2: Array<AccountUser>;
  getDraftConflicts: Array<DraftConflict>;
  getDraftConflictsV2: Array<FloorConflicts>;
  getDraftNotificationMetadata: DraftNotificationMetadata;
  getDraftNotificationMetadataV2: DraftNotificationMetadata;
  getDraftQueueUserIds: Array<Scalars['ID']>;
  getDraftStatus: DraftStatusResponse;
  getDraftVersion: Scalars['Int'];
  getDraftsList: DraftPagingResult;
  getDraftsListV2: DraftPagingResultV2;
  /** Get all of an employee's visits during a specific time range at a specific location */
  getEmployeeVisitsAtLocationForEmployee: Array<EmployeeVisit>;
  /** Get all of the visits during a specific time range at a specific location for several employees */
  getEmployeeVisitsForUsersAtLocationGroupedByDateAscending: Array<EmployeeVisitsByDate>;
  /** Returns a very short-lived URL for downloading a file that has been scanned for malware. Only call this when the user indicates they want to download a file. Begin the download immediately. This should not be requested ahead of time or written to emails/HTML/etc. Clients that want to "permanently" link to a file should handle that themselves and make sure to have a fallback UI for the case where this fails. Returns an error if the file has not been scanned yet, failed to scan, or threats were found. */
  getEphemeralDownloadUrlForScannedTicketFile: GetEphemeralDownloadUrlForScannedTicketFileResponse;
  /** Get audit logs for events with filtering and pagination */
  getEventAuditLogs: GetEventAuditLogsPaginatedResponse;
  /** Get audit logs for a specific event by event ID */
  getEventAuditLogsByEventId: GetEventAuditLogsByEventIdResponse;
  getEventById: Maybe<Event>;
  /** One event as the event composer reads it: robin-api's v2 event with the actor's permissions, people and rooms as separate lists, and each room copy's check-in, buffers and approval. Use it before offering to change or cancel an event; the permissions say what the actor may do. An unknown id is a NOT_FOUND error. Events the actor may not read in full come back masked, not hidden. */
  getEventV2: EventV2;
  /** The events booked into one room between startTime and endTime, for callers that know the room's id and want its schedule in one query. Space.events is the same data reached through the Space entity. An event is included when it overlaps the window, so a meeting that began before startTime and is still running counts. titleContains keeps only events whose title contains the text anywhere, ignoring case. When given it must contain text; omit it to return every event. Bookings the caller may not see in full are still returned, with the title "Reserved" and no invitees, so "something is booked at 2pm that I cannot identify" stays distinguishable from "nothing is booked". Such a booking matches titleContains only on that word. Ranges longer than 31 days are rejected. An unknown spaceId is a NOT_FOUND error. */
  getEventsForSpace: Array<Event>;
  getEventsWithCheckInStatusForProxiedEventId: GetEventsWithCheckInStatusForProxiedEventIdReponse;
  /** Get the health status of a user's external account integration. Performs active token refresh validation and returns detailed status information. */
  getExternalAccountStatus: ExternalAccountStatus;
  getExternalEvents: Array<ExternalEvent>;
  /** Checks the Gallagher account for current tenant */
  getGallagherAccountForCurrentTenant: GetGallagherAccountForCurrentTenant;
  /** Gets a list of Gallagher locks by UUID. */
  getGallagherDoorsByIntegrationUuid: GetGallagherDoorsByIntegrationUuid;
  /** Checks the Genea account for current tenant */
  getGeneaAccountForCurrentTenant: GetGeneaAccountForCurrentTenant;
  /** Gets a list of Genea doors for current tenant. */
  getGeneaDoorsForCurrentTenant: GetGeneaDoorsForCurrentTenant;
  /** The configured source-to-Robin mappings for a universal connector integration. */
  getGenericConnectorSourceMappings: GetGenericConnectorSourceMappingsResponse;
  /** Checks the Genetec account for current tenant */
  getGenetecAccountForCurrentTenant: GetGenetecAccountForCurrentTenant;
  /** Gets the Genetec doors for the current tenant's account, when integrationUuid names that account. */
  getGenetecDoorsByIntegrationUuid: GetGenetecDoorsByIntegrationUuidResponse;
  /** Checks the Google account for current tenant */
  getGoogleAccountForCurrentTenant: GetGoogleAccountForCurrentTenant;
  /** Gets all Google buildings tied to the provided external account ID. */
  getGoogleBuildings: Maybe<Array<Maybe<GoogleBuilding>>>;
  /** Lists Google Meet devices for the current tenant's connected account. */
  getGoogleMeetDevicesForCurrentTenant: GetGoogleMeetDevicesForCurrentTenantResponse;
  getGoogleWorkingLocationSyncSettingForOrg: Scalars['Boolean'];
  /** Gets the sync google working locations setting user */
  getGoogleWorkingLocationSyncSettingForUser: GoogleWorkingLocationSyncSetting;
  getGroupsByKeyword: Array<Group>;
  getGuestInviteById: Maybe<GuestInvite>;
  /** Returns a count of guest invites matching criteria */
  getGuestInviteCount: Scalars['Int'];
  /** Returns the distinct hosts and guest names across guest invites matching the criteria, for populating filter options. Hosts union a visit's legacy single host with its multi-host relation. Callers are expected to pass a bounded date range and/or location; results are otherwise limited only by tenant and the caller's permissions. */
  getGuestInviteFilterOptions: GuestInviteFilterOptions;
  /** Returns filtered view of all guest invites */
  getGuestInvites: Array<GuestInvite>;
  /** Get a guest invite of a visit by its ID */
  getGuestVisitById: Maybe<PublicVisitResult>;
  /** Returns guests who visited specified locations based on a provided list of emails and location IDs */
  getGuestsByEmailsAndLocations: Array<PublicGuest>;
  /** @deprecated In office has been migrated to Whos In */
  getInOfficeDataByLocation: InOfficeData;
  /** @deprecated In office has been migrated to Whos In */
  getInOfficeDataByLocationByDay: Array<InOfficeDataByDay>;
  /** @deprecated In office has been migrated to Whos In */
  getInOfficeDataByUserIdsAndLocation: InOfficeData;
  getInitialWorkPolicyCreatedAt: Maybe<Scalars['ISODateTime']>;
  /** Gets a external integration by externalId */
  getIntegrationByExternalId: Maybe<Array<Maybe<ExternalIntegration>>>;
  /** Gets a external integration by id */
  getIntegrationById: Maybe<ExternalIntegration>;
  /** Gets a external integration by orgId */
  getIntegrationByOrgId: Maybe<Array<Maybe<ExternalIntegration>>>;
  getIssueReportByIdentifier: GetIssueReportByIdentifierResponse;
  /** Checks the Kisi account for current tenant */
  getKisiAccountStatusForCurrentTenant: GetKisiAccountStatusForCurrentTenant;
  /** Gets a list of Kisi locks for current tenant. */
  getKisiLocksForCurrentTenant: Maybe<GetKisiLocksForCurrentTenant>;
  /** Returns a legacy integration from ACL by its userId */
  getLegacyIntegrationByUserId: Maybe<LegacyIntegration>;
  /** Returns if a legacy integration exists for the user by the given type and resource-type Tenant ID is also taken into account */
  getLegacyIntegrationExistsByType: Maybe<Scalars['Boolean']>;
  /** Returns a legacy integrations from ACL by it orgId */
  getLegacyIntegrationsByOrgId: Maybe<Array<Maybe<LegacyIntegration>>>;
  getLevelById: Maybe<Level>;
  getLevelSettings: Array<Setting>;
  getLevelsByIds: Array<Level>;
  getLocationById: Maybe<Location>;
  getLocationByRemoteGoogleId: Maybe<SimpleLocation>;
  getLocationsByFiltersInCurrentTenant: Array<Location>;
  getLocationsByIds: Array<Location>;
  /** Checks the Logi Sync account for current tenant */
  getLogiSyncAccountForCurrentTenant: GetLogiSyncAccountForCurrentTenant;
  /** Returns the LogiSync place catalog (from the latest poll) for the current tenant, each annotated with its current Robin space mapping (if any). */
  getLogiSyncPlacesForCurrentTenant: GetLogiSyncPlacesForCurrentTenant;
  /** Allows getting archived meeting services */
  getMeetingServiceById: GetMeetingServiceByIdResponse;
  getMeetingServiceRequestByIdentifier: GetMeetingServiceRequestByIdentifierResponse;
  getMicrosoftGraphEnabled: Scalars['Boolean'];
  getMicrosoftGraphMigrationProgress: Maybe<MigrationProgress>;
  getMicrosoftGraphMigrationReport: Maybe<MigrationReportWithTotals>;
  getMobileGeofencesForMeInTenant: GetMobileGeofencesForMeInTenantResponse;
  getMyDefaultLocationOrFallback: Maybe<Location>;
  getMyEventsInTheRange: Array<Event>;
  getMyEventsInTheRangeWithCheckInStatus: Array<Event>;
  getMyHomepage: MyHomepageResponse;
  /** Gets a language tag for current (user) actor */
  getMyLanguageTag: MyLanguageTagResponse;
  getMyTeamNames: Array<Scalars['String']>;
  /** Returns the set of unacknowledged announcements for the requesting user for the given location. (Only PRIORITY announcements, as they can be acknowledged) */
  getMyUnacknowledgedActiveAnnouncementsByLocationId: Array<Announcement>;
  /** Returns the set of unacknowledged announcements for the requesting user for the given locations. (Only PRIORITY announcements, as they can be acknowledged) */
  getMyUnacknowledgedActiveAnnouncementsByLocationIds: Array<Announcement>;
  getMyWorkPolicyWithProgress: Maybe<WorkPolicyWithProgress>;
  /** Checks the Neat Pulse account for current tenant */
  getNeatPulseAccountForCurrentTenant: GetNeatPulseAccountForCurrentTenant;
  /** Gets sensor data for a single Neat Pulse device. */
  getNeatPulseDeviceSensorData: NeatPulseDeviceSensorData;
  /** Lists Neat Pulse rooms for the current tenant's connected account. */
  getNeatPulseRoomsForCurrentTenant: GetNeatPulseRoomsForCurrentTenantResponse;
  getNeighborhoodById: Maybe<GetNeighborhoodByIdResponse>;
  getNeighborhoodColorDefinitionById: Maybe<NeighborhoodColorDefinition>;
  getNeighborhoodsForFloor: FloorNeighborhoodsResponse;
  getOfficeAdmins: Array<User>;
  /** Checks the Openpath account for current tenant */
  getOpenpathAccountStatusForCurrentTenant: GetOpenpathAccountStatusForCurrentTenant;
  /** Gets a list of Openpath locks for current tenant. */
  getOpenpathLocksForCurrentTenant: GetOpenpathLocksForCurrentTenant;
  getOrSuggestMyDefaultLocationOrLevel: Maybe<DefaultLocationAndLevel>;
  getOrganizationById: Maybe<Organization>;
  /** Gets a legacy integration by externalId and type */
  getOrganizationByIntegration: Maybe<ApiOrganizationExternalAccount>;
  getOrganizationExternalAccount: Maybe<OrganizationExternalAccount>;
  /** Gets an encoded version of an organization ID */
  getOrganizationIdHash: OrganizationIdHashResponse;
  getOrganizationNotificationSettings: Maybe<Array<Maybe<OrganizationNotificationsSetting>>>;
  getOrganizationRootDepartmentId: Maybe<Scalars['ID']>;
  getOrganizationsByIds: Array<Organization>;
  getOrganizationsByUserEmail: Array<Maybe<MeOrganization>>;
  getPagedUsers: PagedUserResult;
  /** Get all survey responses with pagination based on the filters By default returns only completed responses. */
  getPaginatedSurveyResponses: Maybe<Array<Maybe<SurveyResponse>>>;
  getPaginatedSurveyResponsesTotalPageCount: Maybe<Scalars['Int']>;
  getPassesByOrganizationId: Array<OfficeAccess>;
  /** Get the most recent pending survey response for a user */
  getPendingSurveyResponseForUser: Maybe<SurveyResponse>;
  /** Get permissions for a specific role and resource category within a hierarchy type and hierarchy ID and organization */
  getPermissionsByHierarchyTypeAndId: Array<RolePermission>;
  getPermissionsByRoleIds: Array<RolePermission>;
  getPermissionsForCurrentUserByResourceIds: Array<ResourcePermissionCollection>;
  getPinnedUserSpacesByLocationIds: Array<PinnedUserSpaceEntity>;
  /** Returns a name, id mapping of the prebuilt workbooks */
  getPrebuiltSigmaWorkbookIds: Maybe<PrebuiltSigmaWorkbooksMap>;
  getPublishedDraft: GetPublishedDraftResponse;
  getPublishedDrafts: DraftPagingResult;
  getPublishedDraftsV2: DraftPagingResultV2;
  getRecipientById: Maybe<Recipient>;
  getRecipients: Array<Recipient>;
  getReservationExclusions: Array<Exclusion>;
  /** Get reservations by resource instance ID grouped by day of week for the next 90 days */
  getReservationsByResourceInstanceIdGroupedByDayOfWeek: Array<ResourceReservationGroupedByDayOfWeek>;
  /** Get all of a user's reservations */
  getReservationsForUser: Array<Reservation>;
  /** Checks seat availability for multidays ONLY allows max 31 dates of availability to be checked at once. There is a real performance limitation here which we query seat state api for each date. Please re-evaluate before using this for high frequency use cases. Currently, this is only used for updating a reservation in a 30 day calendar modal. */
  getReservationsMultiDayAvailabilities: Array<DeskAvailabilityByDate>;
  getReservationsToCancel: Maybe<Array<ReservationsToCancelResponse>>;
  getRipplingAccountState: Maybe<GetRipplingAccountStateResponse>;
  getRipplingWorkLocationsAndExistingMappings: Maybe<RipplingWorkLocationsWithMappings>;
  getRobinUserInfoBySlackId: Maybe<RobinUserInfoForSlack>;
  getRole: Maybe<Role>;
  /** Check if the current user has the specified role permission(s) */
  getRolePermissionsForCurrentUser: Array<UserRolePermissionResult>;
  /** The scenario drafts implementing an allocation — the building drafts that place people against its floor split. Newest first, discarded excluded. */
  getScenarioDrafts: Array<Draft>;
  getSeatIdByStickerShortCode: Maybe<Scalars['ID']>;
  getSharedDesksSchedules: Maybe<Array<Maybe<SharedDeskSchedule>>>;
  getShowNeighborhoodColorsSetting: Scalars['Boolean'];
  /**
   * Returns the appropriate embed mode for the user
   * @deprecated Use userHasAdvancedAnalyticsManage instead
   */
  getSigmaEmbedType: Maybe<SigmaEmbedType>;
  /** Constructs a Sigma embed URL */
  getSigmaEmbedUrl: Maybe<SigmaEmbedUrl>;
  /** Lists all favorited Sigma workbooks for a user */
  getSigmaFavorites: Maybe<Array<Maybe<SigmaFile>>>;
  /** Constructs a Sigma JWT embed URL */
  getSigmaJwtEmbedUrl: Maybe<SigmaEmbedUrl>;
  /** Returns the appropriate embed mode for the user */
  getSigmaMemberId: Maybe<Scalars['ID']>;
  /** Get a Sigma workbook */
  getSigmaWorkbook: Maybe<SigmaWorkbook>;
  /** Lists all Sigma workbooks accessable by a user */
  getSigmaWorkbooks: Maybe<Array<Maybe<SigmaFile>>>;
  /** Get all of an employee's one-off visits during a specific time range within a specific org */
  getSingleDayEmployeeVisitsForEmployee: Array<EmployeeVisit>;
  getSpaceById: Maybe<Space>;
  getSpaceCalendarsByOrgId: SpaceCalendarResponse;
  /** Returns user events which fall within the given time frame and which do not have a space associated with them. Also filters events which are not considered "meetings" and therefore do not warrent a space suggestion. Also makes sure the org has space suggestions enabled - if not, no events are returned. Also makes sure the specified building contains scheduled spaces. Finally, this also checks that the user has permission to modify the event, otherwise it will not be returned, as the use of this query is intended to inform the user that meetings are lacking spaces and to prompt them to add one. */
  getSpaceSuggestableEventsForUser: GetSpaceSuggestableEventsForUserResponse;
  getSpacesByIds: Array<Space>;
  /** One stack plan by id. Null when the id is not a stack plan. */
  getStackPlan: Maybe<StackPlan>;
  /** The BU-count variations a stack plan is weighing. */
  getStackPlanAllocations: Array<StackPlanAllocation>;
  /** Stack plans for a building, newest first. Excludes discarded plans. */
  getStackPlans: Array<StackPlan>;
  getStickerBatchById: Maybe<StickerBatch>;
  getStickerById: Maybe<Sticker>;
  getStickerByShortCode: Maybe<Sticker>;
  getStickersByOrgId: Array<Maybe<Sticker>>;
  getSuggestedDesksForUser: Array<SuggestedDesk>;
  /** Recommends meeting times for a draft event (HYDRA-473). Free-window model: the organizer's busy time is a HARD constraint (slots where the organizer is busy are never returned); other invitees and working hours are SOFT (they attach bylines and lower a slot's rank but never remove it). Free/busy is fetched directly from POST /free-busy/users/ by email. */
  getSuggestedMeetingTimes: SuggestedMeetingTimesResult;
  getSuggestedSpacesEnabledForOrg: Scalars['Boolean'];
  /** Given a set of event IDs and space filter criteria, return a suggested space matching that filter criteria for each event. All suggested spaces are simultaneously reservable by the current user. * All returned spaces are available for their event's timeframe. * If events overlap in time, we try our best to return distinct spaces per overlapping event, but can return null if impossible * No other policies (e.g. max duration) prevent reservation */
  getSuggestedSpacesForEvents: GetSuggestedSpacesForEventsResponse;
  /** This is a query which calls the same underlying suggested spaces algorithm as the above, but doesn't consider existing events when querying for suggested spaces. Every other condition is the same, and it uses the same datasource as the above query. Use this one if you don't have an event for which you are querying suggested spaces. */
  getSuggestedSpacesForTimeFrame: GetSuggestedSpacesForTimeFrameResponse;
  /** Get all survey configurations for an organization */
  getSurveyConfigurations: Maybe<Array<Maybe<Survey>>>;
  /** Get summary of the ratings of all survey responses with the given filters */
  getSurveyResponseRatingSummary: Maybe<SurveyResponseRatingSummary>;
  /** Get summary of the statuses of all survey responses with the given filters */
  getSurveyResponseStatusSummary: Maybe<SurveyResponseStatusSummary>;
  /** Get all survey responses based on the criteria. By default returns only completed responses. */
  getSurveyResponses: Maybe<Array<Maybe<SurveyResponse>>>;
  /** @deprecated Deprecated -- use getAuthedTeamUsersByName instead to avoid getting invalid favorites */
  getTeamUsersByName: Array<User>;
  getTeamsUserNotificationSettings: Maybe<Array<Maybe<UserNotificationsSetting>>>;
  /** Return associated tenant ID for a visit given a magic link */
  getTenantIdByMagicLink: Scalars['ID'];
  getTimeZonesForRipplingAddresses: GetTimeZonesForRipplingAddressesResponse;
  /** Gets publicly available information about a arrival display iff that display has not yet been registered */
  getUnauthorizedArrivalDisplayDetails: Maybe<PublicArrivalDisplay>;
  /** Fetches unhealthy calendars as a batch orgLimit is defaulted to 10 with a MAX of 10 */
  getUnhealthySpaceCalendarsForNotifications: PaginatedUnhealthyCalendarsForNotificationsResponse;
  /** Returns whether the current user has access to update the passed through events. This is currently used to see whether we should allow them to add a space to these events. All events should fall within the time window. */
  getUpdatePermissionsForEvents: GetUpdatePermissionsForEventsResponse;
  /** Get a static list of all supported access control vendors. */
  getUploadCSVVendorList: Array<Maybe<UploadCsvVendor>>;
  /** Check if a user has acknowledged an announcement in a given location */
  getUserAcknowledgementByAnnouncementId: Maybe<AnnouncementAcknowledgement>;
  getUserAssignments: Maybe<Array<Maybe<UserAssignment>>>;
  getUserById: Maybe<User>;
  /** Returns the user's desk reservations and visits per day. Should not be used in conjunction with Who's In queries beacuse those will not count deactivate users in its queries but getUserInOfficeDataByDay() will return a result for a deactivated user Reason being is the reservations and visits is not removed on deactivation. */
  getUserInOfficeDataByDay: Array<UserInOfficeByDay>;
  /** Get the notification preferences for the given user */
  getUserNotificationPreferences: Maybe<NotificationPreferences>;
  getUserNotificationSettings: Maybe<Array<Maybe<UserNotificationsSetting>>>;
  getUserSetting: Maybe<UserSetting>;
  /** Per-status user counts for the organization's User Management page tabs. INVITE_EXPIRED is derived at query time from stored INVITE_PENDING rows older than the 14-day invite expiration. */
  getUserStatusCounts: UserStatusCounts;
  getUserSyncStatus: Maybe<UserSyncStatus>;
  getUsersByEmails: Array<User>;
  getUsersByIds: Array<User>;
  getUsersByKeyword: Array<User>;
  getUsersByRole: Array<User>;
  getUsersForTeams: Array<Maybe<TeamsUserSearchResult>>;
  /** Returns desk reservations and visits per day for multiple users in a single request. Batch variant of getUserInOfficeDataByDay — reduces N HTTP round-trips to 1. Accepts at most 100 user ids per request. */
  getUsersInOfficeDataByDay: Array<UserInOfficeDataResult>;
  getUsersWithPermissionOnHierarchyResource: PagedApiUserResult;
  /** Checks the Verkada account for current tenant */
  getVerkadaAccountForCurrentTenant: GetVerkadaAccountForCurrentTenant;
  /** Gets a list of Verkada locks for current tenant. */
  getVerkadaDoorsForCurrentTenant: GetVerkadaDoorsForCurrentTenant;
  /** Gets the state of an asynchronous visit request */
  getVisitAsyncRequestStatus: VisitAsyncRequestStatusResponse;
  /** Get a visit by its ID */
  getVisitById: Maybe<Visit>;
  /** Return details for a visit given a magic link */
  getVisitByMagicLink: Maybe<UnauthenticatedVisitResult>;
  /** Returns a count of all visits matching the specified search. */
  getVisitCount: Scalars['Int'];
  /** Get list of visit types for org */
  getVisitTypeStates: Array<VisitTypeState>;
  /** Returns a user's visitor management permission scopes */
  getVisitorManagementPermissionScopes: Maybe<VisitorManagementPermissionScopes>;
  /** Returns a user's visitor management permissions, contextualized to a location if an id is provided. */
  getVisitorManagementPermissions: Maybe<VisitorManagementPermissions>;
  /** Return a list of visits given a guest's email */
  getVisitsByEmail: Array<PublicVisitResult>;
  /**
   * Get the waitlist and the status for current user.
   * @deprecated Use getWaitlistsForMe instead.
   */
  getWaitlistForMe: GetMyWaitlistResponse;
  /** Get the waitlists for current user, adjusted for given context. */
  getWaitlistsForMe: GetMyWaitlistsResponse;
  /** Retrieves onsite data for a specific level. Requires authentication and tenant ID header. */
  getWhoIsOnsiteByLevel: GetWhoIsOnsiteByLevelResponse;
  /** Retrieves onsite data for a specific location. Requires authentication and tenant ID header. */
  getWhoIsOnsiteByLocation: GetWhoIsOnsiteByLocationResponse;
  /** @deprecated Deprecated in favor of getWhosInDataByLocations */
  getWhosInDataByLocation: WhosInData;
  /** @deprecated Deprecated in favor of getWhosInDataByLocationsByDay */
  getWhosInDataByLocationByDay: Array<WhosInDataByDay>;
  getWhosInDataByLocationsByDay: Array<WhosInDataByDay>;
  getWhosInDataForLocations: WhosInData;
  getWorkAreaById: Maybe<WorkArea>;
  getWorkAreasByLevel: Array<WorkArea>;
  getWorkAreasByOrganizationIds: Array<OrganizationWorkAreasMap>;
  getWorkPoliciesForOrganization: Array<WorkPolicy>;
  getWorkPolicyById: Maybe<WorkPolicy>;
  /** Gets a single zone by its identifier */
  getZoneById: Maybe<Zone>;
  /** Gets several zones by their identifiers */
  getZonesByIds: Array<Zone>;
  /** Checks the Zoom Rooms account for current tenant */
  getZoomRoomsAccountForCurrentTenant: GetZoomRoomsAccountForCurrentTenant;
  /** Returns the live Zoom Rooms catalog for the current tenant, each room annotated with its current Robin space mapping (if any). */
  getZoomRoomsRoomsForCurrentTenant: GetZoomRoomsRoomsForCurrentTenant;
  globalSearch: GlobalSearchResult;
  globalSearchFilterOptions: GlobalSearchFilterOptions;
  /** @deprecated Replaced with getInitialWorkPolicyCreatedAt for that check */
  hasVirtualWorkPolicy: Scalars['Boolean'];
  insightsAssistantConversationsForOrganizationV2: Array<InsightsAssistantConversationV2>;
  insightsAssistantConversationsV2: Maybe<Array<InsightsAssistantConversationV2>>;
  /** Returns feedback for a given message if it exists. */
  insightsAssistantFeedbackV1: Maybe<InsightsAssistantFeedbackV1>;
  insightsPing: Scalars['String'];
  /** Internal query for reservations for a user in locations by UTC time. Automatically converts UTC to each location's local time before querying. This is intended for internal services (e.g., passive check-in lambda). */
  internalCustomResourceReservationsForUserInLocation: Array<ResourceReservation>;
  /** get internal model for user org permissions for action */
  internalPermissionUserOrgAction: Maybe<InternalPermissionUserOrgActions>;
  /** get internal model for resource identity. Null if not found. */
  internalResource: Maybe<InternalResource>;
  /** Returns whether or not advanced analytics is enabled for the particular organization. Includes the EAP allow list to grant individual users access to Sigma. */
  isAdvancedAnalyticsEnabled: Maybe<Scalars['Boolean']>;
  /** Returns if the organization is in trial mode. */
  isAdvancedAnalyticsTrial: Maybe<Scalars['Boolean']>;
  isAiEnabled: Scalars['Boolean'];
  /** Is the arrival display paired? Returns false if the device has been removed. */
  isArrivalDisplayPaired: Scalars['Boolean'];
  /** Checks if current tenant is integrated with Brivo. */
  isBrivoAccountConnectedForCurrentTenant: Scalars['Boolean'];
  /** Feature flag check to determine if Brivo integration is enabled for current tenant. */
  isBrivoIntegrationEnabledForCurrentTenant: IsBrivoIntegrationEnabledForCurrentTenantReponse;
  /** Feature flag check to determine if CSV upload is enabled for current tenant. */
  isCSVUploadEnabledForCurrentTenant: IsCsvUploadEnabledForCurrentTenantReponse;
  /**
   * Returns whether or not custom analytics is enabled for the particular organization. Includes the EAP allow list to grant individual users access to Sigma.
   * @deprecated Use isAdvancedAnalyticsEnabled instead
   */
  isCustomAnalyticsEnabled: Maybe<Scalars['Boolean']>;
  /**
   * Returns if the organization is in trial mode.
   * @deprecated Use isAdvancedAnalyticsTrial instead
   */
  isCustomAnalyticsTrial: Maybe<Scalars['Boolean']>;
  isFavoritesEnabled: Scalars['Boolean'];
  /** Is a feature available for a device's organization (guestUI, Arrival Display)? */
  isFeatureFlagEnabledForDeviceOrg: Scalars['Boolean'];
  isFeatureFlagEnabledForOrgOrMe: Scalars['Boolean'];
  /** Checks if current tenant is integrated with Gallagher. */
  isGallagherAccountConnectedForCurrentTenant: Scalars['Boolean'];
  /** Feature flag check to determine if Gallagher integration is enabled for current tenant. */
  isGallagherIntegrationEnabledForCurrentTenant: IsGallagherIntegrationEnabledForCurrentTenantReponse;
  /** Checks if current tenant is integrated with Genea. */
  isGeneaAccountConnectedForCurrentTenant: Scalars['Boolean'];
  /** Feature flag check to determine if Genea integration is enabled for current tenant. */
  isGeneaIntegrationEnabledForCurrentTenant: IsGeneaIntegrationEnabledForCurrentTenantReponse;
  /** Checks if current tenant is integrated with Genetec. */
  isGenetecAccountConnectedForCurrentTenant: Scalars['Boolean'];
  /** Feature flag check to determine if Genetec integration is enabled for current tenant. */
  isGenetecIntegrationEnabledForCurrentTenant: IsGenetecIntegrationEnabledForCurrentTenantReponse;
  /** Feature flag check to determine if Google integration is enabled for current tenant. */
  isGoogleIntegrationEnabledForCurrentTenant: IsGoogleIntegrationEnabledForCurrentTenantReponse;
  /** Is guest image capture enabled for a device? */
  isGuestImageCaptureEnabled: Scalars['Boolean'];
  /** Is guest self-registration enabled for a device? */
  isGuestSelfRegistrationEnabled: Scalars['Boolean'];
  /** Checks if current tenant is integrated with Kisi. */
  isKisiAccountConnectedForCurrentTenant: Scalars['Boolean'];
  /** Feature flag check to determine if Kisi integration is enabled for current tenant. */
  isKisiIntegrationEnabledForCurrentTenant: IsKisiIntegrationEnabledForCurrentTenantReponse;
  /** Feature flag check to determine if Logi Sync integration is enabled for current tenant. */
  isLogiSyncIntegrationEnabledForCurrentTenant: IsLogiSyncIntegrationEnabledForCurrentTenantReponse;
  /** Feature flag check to determine if Neat Pulse integration is enabled for current tenant. */
  isNeatPulseIntegrationEnabledForCurrentTenant: IsNeatPulseIntegrationEnabledForCurrentTenantReponse;
  /** Checks if current tenant is integrated with Openpath. */
  isOpenpathAccountConnectedForCurrentTenant: Scalars['Boolean'];
  /** Feature flag check to determine if Openpath integration is enabled for current tenant. */
  isOpenpathIntegrationEnabledForCurrentTenant: IsOpenpathIntegrationEnabledForCurrentTenantReponse;
  /** Feature flag check to determine if Openpath integration supports lock provisioning. */
  isOpenpathLockProvisioningEnabledForCurrentTenant: IsOpenpathLockProvisioningEnabledForCurrentTenantResponse;
  isPassiveCheckInFeatureEnabledForBuilding: Scalars['Boolean'];
  isRipplingAccountConnectedForOrganization: Scalars['Boolean'];
  /** Gets the show weekend setting for current (user) actor */
  isShowWeekendsEnabledForMe: MyShowWeekendsResponse;
  /** Checks if current tenant is integrated with Verkada. */
  isVerkadaAccountConnectedForCurrentTenant: Scalars['Boolean'];
  /** Feature flag check to determine if Verkada integration is enabled for current tenant. */
  isVerkadaIntegrationEnabledForCurrentTenant: IsVerkadaIntegrationEnabledForCurrentTenantReponse;
  /** Feature flag check to determine if Zoom Rooms integration is enabled for current tenant. */
  isZoomRoomsIntegrationEnabledForCurrentTenant: IsZoomRoomsIntegrationEnabledForCurrentTenantReponse;
  /** Returns latest change date for all reservations indicating the latest reservation state change. If the returned timestamp changes in subsequent requests, it indicates that either a desk or space reservation has been created since last fetch. NULL response when no reservations exist for the specified level */
  levelChangeDetectionToken: Maybe<Scalars['ISODateTime']>;
  listBuildingCidrs: ListBuildingCidrsResponse;
  listBuildingsWhereUserCanManageMeetingServices: ListBuildingsWhereUserCanManageMeetingServicesResponse;
  /** Returns only issue reports the current user is permitted to view: reports in buildings they administer, plus reports where they hold a role (requester or assignee). */
  listIssueReports: ListIssueReportsResponse;
  /** Requires permission to manage services in at least one place */
  listMeetingServiceRequests: ListMeetingServiceRequestsResponse;
  /** Requires permission to manage services in at least one place */
  listMeetingServices: ListMeetingServicesResponse;
  /** For showing a user which meeting services can be requested for a certain space. */
  listMeetingServicesAvailableInSpace: ListMeetingServicesAvailableInSpaceResponse;
  /** Requires permission to manage services in at least one place */
  listMeetingServicesCategories: ListMeetingServicesCategoriesResponse;
  /** The places in the provider where tickets can be created and that can be added as target configs: a Jira site's JSM request types, and the issue types of its projects without a service desk. Read from the integration's last target import, not the provider; `targetImport` says how recent it is. On `truncated: true`, narrow with `search` (matched against the label and the group). Only JSM request types are listed unless `includeJiraProjects`. */
  listTicketIntegrationAvailableTargets: ListTicketIntegrationAvailableTargetsResponse;
  /** List an integration's entity mappings, optionally filtered to one building's subtree. */
  listTicketIntegrationEntityMappings: ListTicketIntegrationEntityMappingsResponse;
  /** The external object classes a net-new external object can be created as — the catalog an admin picks an item's `externalObjectClassId` from on createTicketIntegrationExternalObjects. Typed providers (Jira Assets) list their classes across every schema; flat providers (ServiceNow, Zendesk) have one fixed target and return PROVIDER_CAPABILITY_MISSING. */
  listTicketIntegrationExternalObjectClasses: ListTicketIntegrationExternalObjectClassesResponse;
  /** List the external objects an integration's provider can reference on a ticket (e.g. ServiceNow `cmn_location` records). Reads the persisted object import snapshot, NOT a live provider fetch: until `startTicketIntegrationObjectImport` has filled the store this answers an empty list, and `objectImportStatus` on the success response is how a client tells that apart from "the provider has nothing". Narrow with `search` (a literal substring of the label, max 255 chars), `seedNames` (exact-match after normalization, same identity rule the matching phase uses) and/or `classIds` (ids from listTicketIntegrationExternalObjectClasses); `classIds` and `seedNames` each accept at most 200 entries. `seedNames`/`search` combine with OR when both are given, so a widen never drops the seeded rows. With no class filter the result is restricted to the classes that carry a place assignment. Keyset-paginated: `first` defaults to 50 and is capped at 200, and a full listing means following `forwardPageInfo.endCursor` rather than reading one response. A cursor is bound to the filters it was minted under; changing them mid-fetch is rejected rather than silently skipping rows. */
  listTicketIntegrationExternalObjects: ListTicketIntegrationExternalObjectsResponse;
  /** The integration's field mappings. `workflowId: null` reads the integration-level scope; a non-null `workflowId` reads the EFFECTIVE set — workflow overrides overlaid on the integration level, each row's `resolvedFrom` naming its scope. */
  listTicketIntegrationFieldMappings: ListTicketIntegrationFieldMappingsResponse;
  /** The Robin-side payload fields bindings and {{key}} templates can reference: the fixed `ticket.*`/`place.*` core plus `form.*` answers from the workflow's form, so the catalog is per integration + scope. */
  listTicketIntegrationSourceFields: ListTicketIntegrationSourceFieldsResponse;
  /** The target configs this integration creates tickets in, the default first flagged by `isDefault`. */
  listTicketIntegrationTargetConfigs: ListTicketIntegrationTargetConfigsResponse;
  /** The provider ticket fields the integration can fill on ticket creation. Fetched live; on `truncated: true`, narrow with `search`. `targetConfigId` null = the integration's default target object. */
  listTicketIntegrationTargetFields: ListTicketIntegrationTargetFieldsResponse;
  /** For each provider status a target config's workflow can move a ticket to, the fields its transition screens show, which are required, and the values Robin fills in (set with `setTicketIntegrationTargetConfigTransitionFields`). Read live from the workflow configuration, which Jira serves only to a connection a Jira administrator granted. */
  listTicketIntegrationTransitionFields: ListTicketIntegrationTransitionFieldsResponse;
  /** Robin places that can receive tickets for this integration's workflows but have no entity mapping of their own under the given building. Each row's `coverage` reports whether a mapped ancestor still supplies a location (INHERITED) or tickets there get none (UNCOVERED). Campus-tier coverage is a later, campus-axis surface. */
  listTicketIntegrationUnmappedEntities: ListTicketIntegrationUnmappedEntitiesResponse;
  /** The workflows bound to this integration — the legitimate origin of every `workflowId` the field-mapping ops accept. Fetch lazily when offering per-workflow overrides; the integration-level flow never needs it. */
  listTicketIntegrationWorkflowBindings: ListTicketIntegrationWorkflowBindingsResponse;
  /** Requires permission to manage services in at least one place List out all assignees for meeting services that match the filter. Intended for use in a filter panel for meeting services, so you can see all possible assignees and select the ones with which to filter meeting services. */
  listUniqueAssigneesForMeetingServices: ListUniqueAssigneesForMeetingServicesResponse;
  /** Intended for listing unique values for filters you can pass to listIssueReports. Same visibility rules as listIssueReports. */
  listUniqueIssueReportValues: ListUniqueIssueReportValuesResponse;
  /** Requires permission to manage services in at least one place. Intended for listing unique values for filters you can pass to listMeetingServiceRequests. */
  listUniqueMeetingServiceRequestValues: ListUniqueMeetingServiceRequestValuesResponse;
  /** Auto-match suggestions for the unmapped Robin places in one building: the imported objects the last finished matching phase paired with each place by name and hierarchy position. Writes nothing; apply accepted matches with `upsertTicketIntegrationEntityMappings`. Suggestions are as current as the last object import (see `ticketIntegrationObjectImportStatus`) and empty before the first one finishes. A place mapped, or an object claimed, since then is left out. Connection trouble shows up on the import status's `error`, not here: a revoked credential still returns the last suggestions. */
  matchTicketIntegrationEntityMappingCandidates: MatchTicketIntegrationEntityMappingCandidatesResponse;
  /** Distinct, non-empty department values across the organization's users — for the people-list department filter dropdown. */
  organizationDepartments: Array<Scalars['String']>;
  /** Distinct users referenced as a manager by some user in the organization — for the people-list manager filter dropdown. */
  organizationManagers: Array<AccountUser>;
  /** Everyone who reports to the given manager, directly or through other managers — their whole organization, walked through each person's manager. Depth 1 is a direct report. The walk stops at a deactivated person: they are not returned, and it does not continue through them to their own reports, because a manager_id still pointing at someone who has left is stale. A deactivated manager therefore has an empty chain rather than a resolved stale subtree. maxDepth bounds the walk and defaults to its maximum of 20 — deeper than any real org chart, so the default returns the whole chain and nothing is clipped unless a caller asks for a shallower one. */
  organizationReportingChain: ReportingChain;
  parseDeliveryText: ParsedDeliveryText;
  /** Server-side dry-run using the same rendering as ticket creation — the preview is authoritative. Renders the stored bindings, or `mappings` when supplied (previewing unsaved edits); supplied `mappings` are validated with the same rules as the upsert, and invalid ones fail with `PreviewTicketIntegrationFieldRenderInvalidMappingsResponse` instead of rendering. `sampleEntity` omitted, the server picks an entity and echoes its choice in the response. */
  previewTicketIntegrationFieldRender: PreviewTicketIntegrationFieldRenderResponse;
  /** Checks seats for multidate reservation availability. */
  reservationsMultiDayGroupedByDate: Array<DeskAvailabilityLocalizedDate>;
  /** Get resource details for individual resources by ID */
  resourceDetails: Array<CustomResource>;
  /** Get resource details for individual resources by floor ID */
  resourceDetailsByFloor: Array<CustomResource>;
  /** Fetches the query model event consistency values for specified event types */
  resourceEventConsistency: Array<ResourceEventConsistencyQueryType>;
  /** Validation/availability of a request for a recurring reservation with selectable desired booking types */
  resourceMixedTypeRecurringValidate: ResourceMixedTypeRecurringValidateResponseType;
  resourceReservationExclusions: Array<ResourceReservationExclusion>;
  /** Query for reservations for a set of custom resource reservation instances by reservation ID */
  resourceReservationInstancesGroupedByReservationId: Array<ResourceReservationInstancesResponseType>;
  /** Validation/availability of a request for a recurring reservation */
  resourceReservationRecurringValidate: Array<ResourceReservationRecurringValidateResponseType>;
  /** Request validation of a request for a single day reservation */
  resourceReservationSingleDayValidate: ResourceReservationValidationResponse;
  reviewDraft: ReviewDraftResponse;
  reviewDraftChanges: ReviewDraftChangesResponse;
  /** Search users by name/email using optimized search index. Returns AccountUser type for full field extension support. */
  searchUsers: SearchUsersResult;
  /** Tells you if the current user is allowed to report issues on a space */
  spaceAllowsIssueReports: ResourceAllowsIssueReportsResponse;
  /** Heuristic mapping proposals for unbound target fields. Pure computation — persists nothing; apply accepted rows with the upsert (like matchTicketIntegrationEntityMappingCandidates for places). */
  suggestTicketIntegrationFieldMappings: SuggestTicketIntegrationFieldMappingsResponse;
  /** Fetch a single ticket integration by id. */
  ticketIntegration: Maybe<TicketIntegration>;
  /** The current (or most recent) background object import for an integration — the status Hyperspace polls after `startTicketIntegrationObjectImport`. `status` is null when no run has ever existed for this integration ("never ran" is absence, not an enum value). */
  ticketIntegrationObjectImportStatus: TicketIntegrationObjectImportStatusResponse;
  /** List all ticket integrations for the tenant. */
  ticketIntegrations: Array<TicketIntegration>;
  /** State of a user bulk-action job — shared by all bulk user actions. Clients use it to complete a sync bulk mutation that returned IN_PROGRESS after outliving its resolver budget. Null when the job id is unknown to the org (bogus, or purged after the retention window). */
  userBulkActionJob: Maybe<UserBulkActionJob>;
  /** Is the user part of an organization with AA enabled and does that user have analytics:manage permissions */
  userHasAdvancedAnalyticsManage: Maybe<Scalars['Boolean']>;
  /** Fetch visit document with agreement from user based on visit invite ID */
  visitDocumentAgreement: VisitDocumentAgreementResponse;
  /** Query for visit and document information associated with a decision ID (assumed to be document accept) */
  visitDocumentByDecisionId: Maybe<VisitDocumentByDecisionResponse>;
  /** @deprecated Use visitDocumentByIdWithCustomVisitType instead */
  visitDocumentById: Maybe<VisitDocumentResponse>;
  visitDocumentByIdWithCustomVisitType: Maybe<VisitDocumentResponse>;
  /**
   * Query paged organizations documents available to workflows which can be applied to visits
   * @deprecated Use visitDocumentNameStatusAndTypesPageWithCustomVisitType instead
   */
  visitDocumentNameStatusAndTypesPage: Array<VisitDocumentNameStatusAndTypesQueryResponse>;
  /** Query paged organizations documents available to workflows which can be applied to visits */
  visitDocumentNameStatusAndTypesPageWithCustomVisitType: Array<VisitDocumentNameStatusAndTypesQueryResponse>;
  /**
   * Returns document agreement details for `documentID` or first document agreement if no `documentId` is specified. If response is NULL, no documents to agree with to for a visit.
   * @deprecated Use visitDocumentWithNextDocumentIdWithCustomVisitType instead
   */
  visitDocumentWithNextDocumentId: Maybe<VisitDocumentAgreementWithNextDocumentResponse>;
  /** Returns document agreement details for `documentID` or first document agreement if no `documentId` is specified. If response is NULL, no documents to agree with to for a visit. */
  visitDocumentWithNextDocumentIdWithCustomVisitType: Maybe<VisitDocumentAgreementWithNextDocumentResponse>;
  /**
   * Query for menu overview of documents required for a key pair of visit type and location ID.
   * @deprecated Use visitOverviewOfDocumentsWithCustomVisitType instead
   */
  visitOverviewOfDocuments: Maybe<VisitWorkflowOverview>;
  /** Batch variant of `visitOverviewOfDocumentsWithCustomVisitType`: returns the document overview for many visit invites in a single request, so callers can check a whole batch of guests without one request per guest. Results are returned per visit invite; match them by `visitInviteId` (order is not guaranteed). */
  visitOverviewOfDocumentsForVisitInvites: Array<VisitInviteDocumentOverview>;
  /** Query for menu overview of documents required for a key pair of visit type and location ID. */
  visitOverviewOfDocumentsWithCustomVisitType: Maybe<VisitWorkflowOverview>;
};


export type QueryAutoDeskBookingAttemptedForLocalDateArgs = {
  localStartDate: Scalars['LocalDate'];
  locationId: Scalars['ID'];
  numberOfDays: Scalars['Int'];
  userId: Scalars['ID'];
};


export type QueryAutoDeskBookingAttemptsForUserScheduleArgs = {
  locationId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QueryBuildingDiscoveryReportArgs = {
  robinLocationId: Scalars['ID'];
  runId?: InputMaybe<Scalars['ID']>;
};


export type QueryCanUserCreateBuildingDraftArgs = {
  buildingId: Scalars['ID'];
};


export type QueryCanUserDelegateDeskArgs = {
  deskId: Scalars['ID'];
  endTime: Scalars['ISODateTime'];
  startTime: Scalars['ISODateTime'];
};


export type QueryCheckOrganizationNameAvailabilityArgs = {
  name: Scalars['String'];
};


export type QueryCheckTicketIntegrationFieldMappingDriftArgs = {
  integrationId: Scalars['ID'];
  targetConfigId?: InputMaybe<Scalars['ID']>;
  workflowId?: InputMaybe<Scalars['ID']>;
};


export type QueryCheckUserEmailsArgs = {
  emails: Array<Scalars['String']>;
};


export type QueryCountIssueReportsArgs = {
  input: CountIssueReportsInput;
};


export type QueryCountMeetingServiceRequestsArgs = {
  input: CountMeetingServiceRequestsInput;
};


export type QueryCountMeetingServicesArgs = {
  input: CountMeetingServicesInput;
};


export type QueryCountMeetingServicesCategoriesArgs = {
  input: CountMeetingServicesCategoriesInput;
};


export type QueryCountVisitFilteredDocumentsArgs = {
  filters?: InputMaybe<Array<VisitDocumentNameStatusAndTypesFilter>>;
};


export type QueryCustomResourceLocationCategoryPoliciesArgs = {
  categoryIds: Array<Scalars['ID']>;
  locationId: Scalars['ID'];
  organizationId: Scalars['ID'];
};


export type QueryCustomResourcePoliciesArgs = {
  organizationId: Scalars['ID'];
  resourceId: Scalars['ID'];
};


export type QueryCustomResourceProspectivePoliciesArgs = {
  locationId: Scalars['ID'];
  organizationId: Scalars['ID'];
  resourceId: Scalars['ID'];
  templateId: Scalars['ID'];
};


export type QueryCustomResourcePublicationSessionStatusArgs = {
  mapId: Scalars['ID'];
  organizationId: Scalars['ID'];
  publicationSessionId: Scalars['ID'];
};


export type QueryCustomResourceReservationsArgs = {
  localRangeEndDate: Scalars['IsoDateOnlyString'];
  localRangeStartDate: Scalars['IsoDateOnlyString'];
  organizationId: Scalars['ID'];
  resourceInstanceIds: Array<Scalars['ID']>;
};


export type QueryCustomResourceReservationsForCurrentUserGroupedByDateArgs = {
  duration: Scalars['ISO8601_Duration'];
  localDates: Array<Scalars['IsoDateOnlyString']>;
  localStartTime: Scalars['IsoLocalTimeString'];
  organizationId: Scalars['ID'];
};


export type QueryCustomResourceReservationsGroupedByDateArgs = {
  duration: Scalars['ISO8601_Duration'];
  localDates: Array<Scalars['IsoDateOnlyString']>;
  localEndTime?: InputMaybe<Scalars['IsoLocalTimeString']>;
  localStartTime: Scalars['IsoLocalTimeString'];
  organizationId: Scalars['ID'];
  resourceInstanceIds: Array<Scalars['ID']>;
};


export type QueryCustomResourcesPoliciesArgs = {
  organizationId: Scalars['ID'];
  resourceIds: Array<Scalars['ID']>;
};


export type QueryDeskAllowsIssueReportsArgs = {
  deskId: Scalars['ID'];
};


export type QueryDoIHaveACalendarArgs = {
  cacheRefresh?: InputMaybe<Scalars['Boolean']>;
};


export type QueryEndpointObservationsArgs = {
  input: EndpointObservationsInput;
};


export type QueryEndpointRelationshipsArgs = {
  input?: InputMaybe<EndpointRelationshipsInput>;
};


export type QueryEndpointsArgs = {
  input?: InputMaybe<EndpointsInput>;
};


export type QueryExportDraftChangesArgs = {
  id: Scalars['ID'];
};


export type QueryExportDraftChangesV2Args = {
  floorIds?: InputMaybe<Array<Scalars['ID']>>;
  id: Scalars['ID'];
};


export type QueryExportPublishedDraftChangesV2Args = {
  draftId: Scalars['ID'];
};


export type QueryFleetCallArgs = {
  id: Scalars['ID'];
};


export type QueryFleetRoomsArgs = {
  input?: InputMaybe<FleetScopeInput>;
};


export type QueryFleetSummaryArgs = {
  input?: InputMaybe<FleetScopeInput>;
};


export type QueryFusedEndpointArgs = {
  id: Scalars['ID'];
};


export type QueryGetAccountUsersByIdsArgs = {
  filterBy?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sortByField?: InputMaybe<Array<InputMaybe<UserSortBy>>>;
  sortOrder?: InputMaybe<UserSortOrder>;
};


export type QueryGetActiveAnnouncementsByLocationIdArgs = {
  locationId: Scalars['ID'];
};


export type QueryGetActiveAnnouncementsByLocationIdsArgs = {
  locationIds: Array<Scalars['ID']>;
};


export type QueryGetActiveAnnouncementsByLocationIdsForStatusBoardArgs = {
  locationIds: Array<Scalars['ID']>;
};


export type QueryGetActiveDistributionsByAuthorIdArgs = {
  authorId: Scalars['ID'];
  service?: InputMaybe<Scalars['String']>;
};


export type QueryGetActiveDistributionsByOrganizationIdArgs = {
  organizationId: Scalars['ID'];
  service?: InputMaybe<Scalars['String']>;
};


export type QueryGetActiveVisitTypesForOrgArgs = {
  locationId?: InputMaybe<Scalars['String']>;
};


export type QueryGetActivitiesSummaryForTimeRangeByLocationIdsArgs = {
  input: ActivitiesForTimeRangeByLocationIdsInput;
  pagingInput?: InputMaybe<ActivitiesForTimeRangeByLocationIdsPagingInput>;
};


export type QueryGetActivityChatNewerMessagesArgs = {
  activityID: Scalars['ID'];
  messagesAfter: Scalars['ID'];
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryGetActivityChatRemovedMessagesSinceArgs = {
  activityID: Scalars['ID'];
  since: Scalars['ISODateTime'];
};


export type QueryGetActivityChatTailArgs = {
  activityID: Scalars['ID'];
  messagesPriorTo?: InputMaybe<Scalars['ID']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryGetActivityCoverImagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['ID']>;
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryGetActivityForCurrentUserByIdArgs = {
  id: Scalars['ID'];
  joinedLimit?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAllActivitiesForDateByLocationIdsArgs = {
  input?: InputMaybe<ActivitiesForDateByLocationIdsInput>;
};


export type QueryGetAllActivitiesForDateByLocationIdsForStatusBoardArgs = {
  input?: InputMaybe<ActivitiesForDateByLocationIdsInput>;
};


export type QueryGetAllActivitiesForDateRangeByLocationIdsArgs = {
  input?: InputMaybe<ActivitiesForDateRangeByLocationIdsInput>;
};


export type QueryGetAllJoinedUsersByActivityIdArgs = {
  activityId: Scalars['ID'];
};


export type QueryGetAllVisitsArgs = {
  dateFilter: DateFilterMandatoryInput;
  excludeCanceledVisits?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  locationIdFilter: Array<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAllocationArgs = {
  id: Scalars['ID'];
};


export type QueryGetAllocationsArgs = {
  stackPlanId: Scalars['ID'];
};


export type QueryGetAmenitiesByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetAmenityByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetAnalyticsAuthorizationTokenArgs = {
  organizationId: Scalars['ID'];
};


export type QueryGetAnnouncementByIdArgs = {
  announcementId: Scalars['ID'];
};


export type QueryGetAnnouncementForLocationByIdArgs = {
  announcementId: Scalars['ID'];
  locationId: Scalars['ID'];
};


export type QueryGetAnnouncementViewAcknowledgeCountArgs = {
  announcementId: Scalars['ID'];
};


export type QueryGetAnnouncementsArgs = {
  locationId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<AnnouncementStatus>;
};


export type QueryGetAnyDeskByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetAnyDesksByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetArrivalDisplayArgs = {
  id: Scalars['ID'];
};


export type QueryGetArrivalDisplaysArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  isLinkedWithBadgePrinter?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  seekKey?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
};


export type QueryGetAuthedTeamUsersByNameArgs = {
  teamName: Scalars['String'];
};


export type QueryGetAutoDeskBookingByUserIdArgs = {
  userId: Scalars['ID'];
};


export type QueryGetAvailableFloorsArgs = {
  buildingId: Scalars['ID'];
};


export type QueryGetBadgeCsvUploadStatusArgs = {
  input: GetBadgeCsvUploadStatusInput;
};


export type QueryGetBadgeCsvUploadsForCurrentTenantArgs = {
  pagination?: InputMaybe<GetBadgeCsvUploadsForCurrentTenantPagination>;
};


export type QueryGetBadgePresenceAuditLogPageArgs = {
  input?: InputMaybe<GetBadgePresenceAuditLogPageInput>;
};


export type QueryGetBadgePrinterArgs = {
  id: Scalars['ID'];
};


export type QueryGetBadgePrintersArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  seekKey?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
};


export type QueryGetBadgePrintersByLocationIdArgs = {
  locationId: Scalars['ID'];
};


export type QueryGetBookingWindowPoliciesByIdArgs = {
  locationId: Scalars['ID'];
  policyIds: Array<Scalars['ID']>;
};


export type QueryGetBookingWindowPoliciesForLocationArgs = {
  locationId: Scalars['ID'];
};


export type QueryGetBookingWindowPolicyByIdArgs = {
  locationId: Scalars['ID'];
  policyId: Scalars['ID'];
};


export type QueryGetBuildingDraftsForUserArgs = {
  buildingId: Scalars['ID'];
};


export type QueryGetBuildingGeofenceArgs = {
  input: GetBuildingGeofenceInput;
};


export type QueryGetBuildingsAtAPointForCurrentTenantArgs = {
  input: GetBuildingsAtAPointForCurrentTenantInput;
};


export type QueryGetBulkAnnouncementViewAcknowledgeCountArgs = {
  announcementIds: Array<Scalars['ID']>;
};


export type QueryGetCampusByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetCampusesByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetCheckedInVisitsByPartialEmailArgs = {
  email: Scalars['String'];
  includeCheckedOutVisits?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['String']>;
  minutesAfter?: InputMaybe<Scalars['Int']>;
  minutesBefore?: InputMaybe<Scalars['Int']>;
  resultLimiter?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCredentialDetailsForCurrentTenantArgs = {
  input: GetCredentialDetailsForCurrentTenantInput;
};


export type QueryGetCredentialOrganizationAndLocationInfoForCurrentTenantArgs = {
  input: GetCredentialOrganizationAndLocationInfoForCurrentTenantInput;
};


export type QueryGetCustomResourceTemplatesArgs = {
  organizationID: Scalars['ID'];
};


export type QueryGetCustomVisitFormCountArgs = {
  locationId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetCustomVisitFormsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<CustomVisitFormOrderBy>;
};


export type QueryGetDaysOfWeekGroupedByResourceReservationArgs = {
  organizationId: Scalars['ID'];
  reservationIds: Array<Scalars['ID']>;
};


export type QueryGetDeliveriesArgs = {
  filters?: InputMaybe<DeliveryFilterOptions>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DeliveriesOrderBy>;
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryGetDeliveriesCountArgs = {
  filters?: InputMaybe<DeliveryFilterOptions>;
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryGetDeliveryByIdArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryGetDeliveryConfirmationInfoArgs = {
  magicLink: Scalars['String'];
};


export type QueryGetDeliveryZoneCountArgs = {
  filters?: InputMaybe<DeliveryZoneFilterOptions>;
};


export type QueryGetDeliveryZonesArgs = {
  filters?: InputMaybe<DeliveryZoneFilterOptions>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetDepartmentDelimiterAnalysisArgs = {
  organizationId: Scalars['ID'];
};


export type QueryGetDepartmentHierarchyAtDepartmentArgs = {
  departmentId: Scalars['ID'];
  organizationId: Scalars['ID'];
};


export type QueryGetDepartmentsListArgs = {
  order?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};


export type QueryGetDeskAvailabilityByLevelIdForMeArgs = {
  filters?: InputMaybe<GetDeskAvailabilityByLevelIdFiltersInput>;
  scope: GetDeskAvailabilityByLevelIdScopeInput;
  viewOptions: GetDeskAvailabilityByLevelIdViewOptionsInput;
};


export type QueryGetDeskByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetDeskExclusionByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetDeskExclusionsByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetDeskReservationByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetDeskReservationInstancesByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetDeskReservationInstancesBySeriesIdsArgs = {
  seriesIds: Array<Scalars['ID']>;
};


export type QueryGetDeskReservationsByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetDeskReservationsByLevelIdArgs = {
  endTime: Scalars['Date'];
  levelId: Scalars['ID'];
  recurrence?: InputMaybe<Scalars['String']>;
  startTime: Scalars['Date'];
};


export type QueryGetDeskReservationsByLocationIdArgs = {
  endTime: Scalars['Date'];
  locationId: Scalars['ID'];
  recurrence?: InputMaybe<Scalars['String']>;
  startTime: Scalars['Date'];
};


export type QueryGetDeskReservationsBySeatIdArgs = {
  deskId: Scalars['ID'];
  duration: Scalars['Int'];
  filter?: InputMaybe<DeskReservationFilter>;
  startTime: Scalars['ISODateTime'];
};


export type QueryGetDeskReservationsBySeatIdsArgs = {
  deskIds: Array<Scalars['ID']>;
  duration: Scalars['Int'];
  filter?: InputMaybe<DeskReservationFilter>;
  startTime: Scalars['ISODateTime'];
};


export type QueryGetDeskReservationsBySpaceIdsArgs = {
  endTime: Scalars['ISODateTime'];
  spaceIds: Array<Scalars['ID']>;
  startTime: Scalars['ISODateTime'];
};


export type QueryGetDeskReservationsByUserIdArgs = {
  endTime: Scalars['Date'];
  id: Scalars['ID'];
  startTime: Scalars['Date'];
};


export type QueryGetDeskReservationsByUserIdsArgs = {
  endTime: Scalars['Date'];
  ids: Array<Scalars['ID']>;
  startTime: Scalars['Date'];
};


export type QueryGetDeskReservationsByZoneIdArgs = {
  endTime: Scalars['Date'];
  recurrence?: InputMaybe<Scalars['String']>;
  startTime: Scalars['Date'];
  zoneId: Scalars['ID'];
};


export type QueryGetDeskReservationsForUsersAtLocationGroupedByDateAscendingArgs = {
  endTime: Scalars['ISODateTime'];
  locationId: Scalars['ID'];
  startTime: Scalars['ISODateTime'];
  userIds: Array<Scalars['ID']>;
};


export type QueryGetDeskReservationsForUsersGroupedByDateAscendingArgs = {
  endTime: Scalars['Date'];
  ids: Array<Scalars['ID']>;
  startTime: Scalars['Date'];
};


export type QueryGetDesksByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetDesksWithAssigneesByLevelIdArgs = {
  levelId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QueryGetDisabledDeskByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetDisabledDesksByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetDistributionByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetDistributionsByAnnouncementIdArgs = {
  announcementId: Scalars['ID'];
};


export type QueryGetDraftAssignmentClassificationArgs = {
  draftId: Scalars['ID'];
};


export type QueryGetDraftAssignmentsForUsersArgs = {
  assignees: Array<AssigneeInput>;
  draftId: Scalars['ID'];
};


export type QueryGetDraftAuditLogsArgs = {
  draftId: Scalars['ID'];
  filters?: InputMaybe<DraftAuditLogFilters>;
  pagination?: InputMaybe<DraftAuditPaginationInput>;
};


export type QueryGetDraftCollaboratorsArgs = {
  draftId: Scalars['ID'];
};


export type QueryGetDraftCollaboratorsV2Args = {
  draftId: Scalars['ID'];
};


export type QueryGetDraftConflictsArgs = {
  draftId: Scalars['ID'];
};


export type QueryGetDraftConflictsV2Args = {
  draftId: Scalars['ID'];
};


export type QueryGetDraftNotificationMetadataArgs = {
  draftId: Scalars['ID'];
};


export type QueryGetDraftNotificationMetadataV2Args = {
  draftId: Scalars['ID'];
};


export type QueryGetDraftQueueUserIdsArgs = {
  draftId: Scalars['ID'];
  levelId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetDraftStatusArgs = {
  draftId: Scalars['ID'];
};


export type QueryGetDraftVersionArgs = {
  draftId: Scalars['ID'];
};


export type QueryGetDraftsListArgs = {
  filters?: InputMaybe<DraftFiltersInput>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  sortBy?: InputMaybe<DraftsSort>;
};


export type QueryGetDraftsListV2Args = {
  buildingId: Scalars['ID'];
  filters?: InputMaybe<DraftFiltersInputV2>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  sortBy?: InputMaybe<DraftsSort>;
};


export type QueryGetEmployeeVisitsAtLocationForEmployeeArgs = {
  employeeId: Scalars['ID'];
  endTime: Scalars['ISODateTime'];
  filterSetting?: InputMaybe<EmployeeVisitFilterSetting>;
  locationId: Scalars['ID'];
  startTime: Scalars['ISODateTime'];
};


export type QueryGetEmployeeVisitsForUsersAtLocationGroupedByDateAscendingArgs = {
  endTime: Scalars['ISODateTime'];
  locationId: Scalars['ID'];
  startTime: Scalars['ISODateTime'];
  userIds: Array<Scalars['ID']>;
};


export type QueryGetEphemeralDownloadUrlForScannedTicketFileArgs = {
  fileId: Scalars['String'];
  ticketIdentifier: TicketIdentifierInput;
};


export type QueryGetEventAuditLogsArgs = {
  input: GetEventAuditLogsInput;
};


export type QueryGetEventAuditLogsByEventIdArgs = {
  input: GetEventAuditLogsByEventIdInput;
};


export type QueryGetEventByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetEventV2Args = {
  id: Scalars['ID'];
};


export type QueryGetEventsForSpaceArgs = {
  endTime: Scalars['Date'];
  spaceId: Scalars['ID'];
  startTime: Scalars['Date'];
  titleContains?: InputMaybe<Scalars['String']>;
};


export type QueryGetEventsWithCheckInStatusForProxiedEventIdArgs = {
  externalAccountType: Scalars['String'];
  proxiedEventId: Scalars['ID'];
  timeContext: Scalars['String'];
};


export type QueryGetExternalAccountStatusArgs = {
  type: ExternalAccountType;
  userId: Scalars['ID'];
};


export type QueryGetExternalEventsArgs = {
  endDate?: InputMaybe<Scalars['Date']>;
  startDate?: InputMaybe<Scalars['Date']>;
};


export type QueryGetGallagherDoorsByIntegrationUuidArgs = {
  input: GetGallagherDoorsByIntegrationUuidInput;
};


export type QueryGetGenericConnectorSourceMappingsArgs = {
  input: GetGenericConnectorSourceMappingsInput;
};


export type QueryGetGenetecDoorsByIntegrationUuidArgs = {
  input: GetGenetecDoorsByIntegrationUuidInput;
};


export type QueryGetGoogleBuildingsArgs = {
  externalAccountId: Scalars['String'];
};


export type QueryGetGoogleWorkingLocationSyncSettingForUserArgs = {
  userId: Scalars['ID'];
};


export type QueryGetGroupsByKeywordArgs = {
  keyword: Scalars['String'];
  organizationId: Scalars['ID'];
};


export type QueryGetGuestInviteByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetGuestInviteCountArgs = {
  checkedIn?: InputMaybe<Scalars['Boolean']>;
  checkedOut?: InputMaybe<Scalars['Boolean']>;
  dateFilter?: InputMaybe<DateFilterOptionalInput>;
  displayStatuses?: InputMaybe<Array<GuestInviteDisplayStatus>>;
  excludeCanceled?: InputMaybe<Scalars['Boolean']>;
  guestSearch?: InputMaybe<Scalars['String']>;
  hostUserIds?: InputMaybe<Array<Scalars['ID']>>;
  locationIdFilter?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<GuestInviteStatus>;
  statuses?: InputMaybe<Array<GuestInviteStatus>>;
  visitId?: InputMaybe<Scalars['ID']>;
  visitTypes?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetGuestInviteFilterOptionsArgs = {
  dateFilter?: InputMaybe<DateFilterOptionalInput>;
  excludeCanceled?: InputMaybe<Scalars['Boolean']>;
  locationIdFilter?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryGetGuestInvitesArgs = {
  checkedIn?: InputMaybe<Scalars['Boolean']>;
  checkedOut?: InputMaybe<Scalars['Boolean']>;
  dateFilter?: InputMaybe<DateFilterOptionalInput>;
  displayStatuses?: InputMaybe<Array<GuestInviteDisplayStatus>>;
  excludeCanceled?: InputMaybe<Scalars['Boolean']>;
  guestSearch?: InputMaybe<Scalars['String']>;
  hostUserIds?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  locationIdFilter?: InputMaybe<Array<Scalars['ID']>>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GuestInviteOrderBy>;
  status?: InputMaybe<GuestInviteStatus>;
  statuses?: InputMaybe<Array<GuestInviteStatus>>;
  visitId?: InputMaybe<Scalars['ID']>;
  visitTypes?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetGuestVisitByIdArgs = {
  guestVisitId: Scalars['ID'];
};


export type QueryGetGuestsByEmailsAndLocationsArgs = {
  emails: Array<Scalars['String']>;
  locationIds: Array<Scalars['String']>;
};


export type QueryGetInOfficeDataByLocationArgs = {
  endTime: Scalars['ISODateTime'];
  locationId: Scalars['ID'];
  startTime: Scalars['ISODateTime'];
};


export type QueryGetInOfficeDataByLocationByDayArgs = {
  dateRanges: Array<DateRangeInput>;
  locationId: Scalars['ID'];
};


export type QueryGetInOfficeDataByUserIdsAndLocationArgs = {
  endTime: Scalars['ISODateTime'];
  locationId: Scalars['ID'];
  startTime: Scalars['ISODateTime'];
  userIds: Array<Scalars['ID']>;
};


export type QueryGetIntegrationByExternalIdArgs = {
  externalId: Scalars['ID'];
};


export type QueryGetIntegrationByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetIntegrationByOrgIdArgs = {
  orgId: Scalars['ID'];
};


export type QueryGetIssueReportByIdentifierArgs = {
  identifier: TicketIdentifierInput;
};


export type QueryGetLegacyIntegrationByUserIdArgs = {
  resourceType: Scalars['String'];
  type: Scalars['String'];
  userId: Scalars['ID'];
};


export type QueryGetLegacyIntegrationExistsByTypeArgs = {
  resourceType: LegacyIntegrationResourceType;
  type: LegacyIntegrationType;
};


export type QueryGetLegacyIntegrationsByOrgIdArgs = {
  orgId: Scalars['ID'];
  resourceType: Scalars['String'];
  type: Scalars['String'];
};


export type QueryGetLevelByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetLevelSettingsArgs = {
  levelId: Scalars['ID'];
};


export type QueryGetLevelsByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetLocationByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetLocationByRemoteGoogleIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetLocationsByFiltersInCurrentTenantArgs = {
  filters: LocationFilters;
};


export type QueryGetLocationsByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetMeetingServiceByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetMeetingServiceRequestByIdentifierArgs = {
  identifier: MeetingServiceRequestIdentifierInput;
};


export type QueryGetMicrosoftGraphMigrationProgressArgs = {
  organizationId: Scalars['ID'];
};


export type QueryGetMicrosoftGraphMigrationReportArgs = {
  orderBy: Scalars['String'];
  organizationId: Scalars['ID'];
  page: Scalars['Int'];
};


export type QueryGetMobileGeofencesForMeInTenantArgs = {
  input: GetMobileGeofencesForMeInTenantInput;
};


export type QueryGetMyEventsInTheRangeArgs = {
  endTime: Scalars['Date'];
  limit?: InputMaybe<Scalars['Int']>;
  startTime: Scalars['Date'];
};


export type QueryGetMyEventsInTheRangeWithCheckInStatusArgs = {
  endTime: Scalars['Date'];
  limit?: InputMaybe<Scalars['Int']>;
  startTime: Scalars['Date'];
  timeContext: Scalars['String'];
};


export type QueryGetMyUnacknowledgedActiveAnnouncementsByLocationIdArgs = {
  locationId: Scalars['ID'];
};


export type QueryGetMyUnacknowledgedActiveAnnouncementsByLocationIdsArgs = {
  locationIds: Array<Scalars['ID']>;
};


export type QueryGetMyWorkPolicyWithProgressArgs = {
  myTimezone: Scalars['String'];
};


export type QueryGetNeatPulseDeviceSensorDataArgs = {
  input: GetNeatPulseDeviceSensorDataInput;
};


export type QueryGetNeatPulseRoomsForCurrentTenantArgs = {
  input?: InputMaybe<GetNeatPulseRoomsForCurrentTenantInput>;
};


export type QueryGetNeighborhoodByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetNeighborhoodColorDefinitionByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetNeighborhoodsForFloorArgs = {
  floorId: Scalars['ID'];
};


export type QueryGetOfficeAdminsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locationId: Scalars['ID'];
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetOrganizationByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetOrganizationByIntegrationArgs = {
  externalId: Scalars['String'];
  type: Scalars['String'];
};


export type QueryGetOrganizationExternalAccountArgs = {
  externalId: Scalars['ID'];
  type?: InputMaybe<Scalars['String']>;
};


export type QueryGetOrganizationIdHashArgs = {
  organizationId: Scalars['ID'];
};


export type QueryGetOrganizationNotificationSettingsArgs = {
  organizationId: Scalars['ID'];
};


export type QueryGetOrganizationRootDepartmentIdArgs = {
  organizationId: Scalars['ID'];
};


export type QueryGetOrganizationsByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetOrganizationsByUserEmailArgs = {
  email: Scalars['String'];
};


export type QueryGetPagedUsersArgs = {
  filters?: InputMaybe<PagedUserFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['ID'];
  sort?: InputMaybe<PagedUserSort>;
};


export type QueryGetPaginatedSurveyResponsesArgs = {
  filters: GetSurveyResponsesFilters;
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  sortBy?: InputMaybe<GetSurveyResponsesSort>;
  surveyId: Scalars['ID'];
};


export type QueryGetPaginatedSurveyResponsesTotalPageCountArgs = {
  filters: GetSurveyResponsesFilters;
  perPage: Scalars['Int'];
  surveyId: Scalars['ID'];
};


export type QueryGetPassesByOrganizationIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetPendingSurveyResponseForUserArgs = {
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryGetPermissionsByHierarchyTypeAndIdArgs = {
  hierarchyId: Scalars['ID'];
  hierarchyType: PermissionHierarchyTarget;
  organizationId: Scalars['ID'];
  roleId: Scalars['ID'];
  targetCategory: Scalars['ID'];
};


export type QueryGetPermissionsByRoleIdsArgs = {
  organizationId: Scalars['ID'];
  roleIds: Array<Scalars['ID']>;
};


export type QueryGetPermissionsForCurrentUserByResourceIdsArgs = {
  organizationId: Scalars['ID'];
  resourceIds: Array<Scalars['ID']>;
};


export type QueryGetPinnedUserSpacesByLocationIdsArgs = {
  locationIds: Array<Scalars['ID']>;
};


export type QueryGetPublishedDraftArgs = {
  draftId: Scalars['ID'];
};


export type QueryGetPublishedDraftsArgs = {
  filters?: InputMaybe<DraftFiltersInput>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  sortBy?: InputMaybe<DraftsSort>;
};


export type QueryGetPublishedDraftsV2Args = {
  buildingId: Scalars['ID'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  sortBy?: InputMaybe<DraftsSort>;
};


export type QueryGetRecipientByIdArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryGetRecipientsArgs = {
  queryString?: InputMaybe<Scalars['String']>;
};


export type QueryGetReservationExclusionsArgs = {
  endDate: Scalars['Date'];
  reservationSeriesId: Scalars['ID'];
  startDate: Scalars['Date'];
};


export type QueryGetReservationsByResourceInstanceIdGroupedByDayOfWeekArgs = {
  organizationId: Scalars['ID'];
  resourceInstanceId: Scalars['ID'];
};


export type QueryGetReservationsForUserArgs = {
  from?: InputMaybe<Scalars['Date']>;
  to?: InputMaybe<Scalars['Date']>;
  userId: Scalars['ID'];
};


export type QueryGetReservationsMultiDayAvailabilitiesArgs = {
  dates: Array<Scalars['LocalDate']>;
  deskId: Scalars['ID'];
  durationInMinutes: Scalars['Int'];
  excludedReservationIds?: InputMaybe<Array<Scalars['ID']>>;
  startTime: Scalars['LocalTime'];
  timezone: Scalars['IANATimezone'];
  userId: Scalars['Int'];
};


export type QueryGetReservationsToCancelArgs = {
  deskInputs: Array<ReservationsToCancelInput>;
};


export type QueryGetRipplingAccountStateArgs = {
  organizationId: Scalars['ID'];
};


export type QueryGetRipplingWorkLocationsAndExistingMappingsArgs = {
  organizationId: Scalars['ID'];
};


export type QueryGetRobinUserInfoBySlackIdArgs = {
  externalId: Scalars['String'];
};


export type QueryGetRoleArgs = {
  organizationId: Scalars['ID'];
  roleSlug: Scalars['String'];
};


export type QueryGetRolePermissionsForCurrentUserArgs = {
  organizationId: Scalars['ID'];
  rolePermissionActions: Array<RolePermissionAction>;
};


export type QueryGetScenarioDraftsArgs = {
  allocationId: Scalars['ID'];
};


export type QueryGetSeatIdByStickerShortCodeArgs = {
  code: Scalars['String'];
};


export type QueryGetSharedDesksSchedulesArgs = {
  deskIds: Array<Scalars['ID']>;
};


export type QueryGetShowNeighborhoodColorsSettingArgs = {
  levelId: Scalars['ID'];
};


export type QueryGetSigmaEmbedUrlArgs = {
  edit?: InputMaybe<Scalars['Boolean']>;
  hideFolderNavigation?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  productionShadow?: InputMaybe<Scalars['Boolean']>;
  trial?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
  workbookUrlId: Scalars['String'];
};


export type QueryGetSigmaJwtEmbedUrlArgs = {
  edit?: InputMaybe<Scalars['Boolean']>;
  hideFolderNavigation?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  productionShadow?: InputMaybe<Scalars['Boolean']>;
  trial?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
  workbookUrlId: Scalars['String'];
};


export type QueryGetSigmaWorkbookArgs = {
  workbookId: Scalars['String'];
};


export type QueryGetSingleDayEmployeeVisitsForEmployeeArgs = {
  employeeId: Scalars['ID'];
  endTime: Scalars['ISODateTime'];
  startTime: Scalars['ISODateTime'];
};


export type QueryGetSpaceByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetSpaceCalendarsByOrgIdArgs = {
  filters?: InputMaybe<SpaceCalendarFiltersInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orgId: Scalars['ID'];
};


export type QueryGetSpaceSuggestableEventsForUserArgs = {
  buildingIdThatMustContainScheduledSpaces?: InputMaybe<Scalars['ID']>;
  endTime: Scalars['ISODateTime'];
  startTime: Scalars['ISODateTime'];
  userId: Scalars['ID'];
};


export type QueryGetSpacesByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetStackPlanArgs = {
  id: Scalars['ID'];
};


export type QueryGetStackPlanAllocationsArgs = {
  stackPlanId: Scalars['ID'];
};


export type QueryGetStackPlansArgs = {
  buildingId: Scalars['ID'];
};


export type QueryGetStickerBatchByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetStickerByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetStickerByShortCodeArgs = {
  code: Scalars['String'];
};


export type QueryGetStickersByOrgIdArgs = {
  orgId: Scalars['ID'];
};


export type QueryGetSuggestedDesksForUserArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locationId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QueryGetSuggestedMeetingTimesArgs = {
  input: SuggestedMeetingTimesInput;
};


export type QueryGetSuggestedSpacesForEventsArgs = {
  input: GetSuggestedSpacesForEventsInput;
};


export type QueryGetSuggestedSpacesForTimeFrameArgs = {
  input: GetSuggestedSpacesForTimeFrameInput;
};


export type QueryGetSurveyResponseRatingSummaryArgs = {
  filters: GetSurveyResponsesFilters;
  surveyId: Scalars['ID'];
};


export type QueryGetSurveyResponseStatusSummaryArgs = {
  filters: GetSurveyResponsesFilters;
  surveyId: Scalars['ID'];
};


export type QueryGetSurveyResponsesArgs = {
  buildingIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  inOfficeAtEnd: Scalars['ISODateTime'];
  inOfficeAtStart: Scalars['ISODateTime'];
  includeIncomplete?: InputMaybe<Scalars['Boolean']>;
  ratings?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sortBy?: InputMaybe<GetSurveyResponsesSort>;
  surveyId: Scalars['ID'];
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryGetTeamUsersByNameArgs = {
  teamName: Scalars['String'];
};


export type QueryGetTeamsUserNotificationSettingsArgs = {
  userId: Scalars['ID'];
};


export type QueryGetTenantIdByMagicLinkArgs = {
  magicLink: Scalars['String'];
};


export type QueryGetTimeZonesForRipplingAddressesArgs = {
  input: GetTimeZonesForRipplingAddressesInput;
};


export type QueryGetUnauthorizedArrivalDisplayDetailsArgs = {
  orgId: Scalars['ID'];
  registrationCode: Scalars['ArrivalDisplayRegistrationKey'];
};


export type QueryGetUnhealthySpaceCalendarsForNotificationsArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  orgLimit?: InputMaybe<Scalars['Int']>;
};


export type QueryGetUpdatePermissionsForEventsArgs = {
  endTime: Scalars['ISODateTime'];
  eventIds: Array<Scalars['ID']>;
  startTime: Scalars['ISODateTime'];
};


export type QueryGetUserAcknowledgementByAnnouncementIdArgs = {
  announcementId: Scalars['ID'];
  locationId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QueryGetUserAssignmentsArgs = {
  userIds: Array<InputMaybe<Scalars['ID']>>;
};


export type QueryGetUserByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetUserInOfficeDataByDayArgs = {
  dateRanges: Array<DateRangeInput>;
  id: Scalars['ID'];
};


export type QueryGetUserNotificationPreferencesArgs = {
  userId: Scalars['ID'];
};


export type QueryGetUserNotificationSettingsArgs = {
  userId: Scalars['ID'];
};


export type QueryGetUserSettingArgs = {
  settingSlug: Scalars['String'];
  userId: Scalars['ID'];
};


export type QueryGetUserStatusCountsArgs = {
  organizationId: Scalars['ID'];
};


export type QueryGetUserSyncStatusArgs = {
  syncId: Scalars['ID'];
};


export type QueryGetUsersByEmailsArgs = {
  emails: Array<Scalars['String']>;
};


export type QueryGetUsersByIdsArgs = {
  filterBy?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sortByField?: InputMaybe<Array<InputMaybe<UserSortBy>>>;
  sortOrder?: InputMaybe<UserSortOrder>;
};


export type QueryGetUsersByKeywordArgs = {
  keyword: Scalars['String'];
  organizationId: Scalars['ID'];
};


export type QueryGetUsersByRoleArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['ID'];
  roleQuery?: InputMaybe<Scalars['String']>;
  roleSlug?: InputMaybe<Scalars['String']>;
};


export type QueryGetUsersForTeamsArgs = {
  name: Scalars['String'];
  organizationId: Scalars['ID'];
};


export type QueryGetUsersInOfficeDataByDayArgs = {
  dateRanges: Array<DateRangeInput>;
  ids: Array<Scalars['ID']>;
};


export type QueryGetUsersWithPermissionOnHierarchyResourceArgs = {
  hierarchyType: Scalars['String'];
  orgId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  permission: Scalars['String'];
  resourceId: Scalars['ID'];
};


export type QueryGetVisitAsyncRequestStatusArgs = {
  visitId: Scalars['ID'];
};


export type QueryGetVisitByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetVisitByMagicLinkArgs = {
  magicLink: Scalars['String'];
};


export type QueryGetVisitCountArgs = {
  dateFilter: DateFilterMandatoryInput;
  excludeCanceledVisits?: InputMaybe<Scalars['Boolean']>;
  locationIdFilter: Array<Scalars['ID']>;
};


export type QueryGetVisitorManagementPermissionsArgs = {
  locationId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetVisitsByEmailArgs = {
  email: Scalars['String'];
  locationId?: InputMaybe<Scalars['String']>;
  minutesAfter?: InputMaybe<Scalars['Int']>;
  minutesBefore?: InputMaybe<Scalars['Int']>;
};


export type QueryGetWaitlistForMeArgs = {
  context?: InputMaybe<GetWaitlistForMeContext>;
};


export type QueryGetWaitlistsForMeArgs = {
  context?: InputMaybe<GetWaitlistsForMeContext>;
};


export type QueryGetWhoIsOnsiteByLevelArgs = {
  levelId: Scalars['ID'];
};


export type QueryGetWhoIsOnsiteByLocationArgs = {
  locationId: Scalars['ID'];
};


export type QueryGetWhosInDataByLocationArgs = {
  date?: InputMaybe<Scalars['LocalDate']>;
  locationId: Scalars['ID'];
};


export type QueryGetWhosInDataByLocationByDayArgs = {
  dates?: InputMaybe<Array<Scalars['LocalDate']>>;
  locationId: Scalars['ID'];
};


export type QueryGetWhosInDataByLocationsByDayArgs = {
  dates: Array<Scalars['LocalDate']>;
  locationIds: Array<Scalars['ID']>;
};


export type QueryGetWhosInDataForLocationsArgs = {
  date?: InputMaybe<Scalars['LocalDate']>;
  locationIds: Array<Scalars['ID']>;
};


export type QueryGetWorkAreaByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetWorkAreasByLevelArgs = {
  levelId: Scalars['ID'];
};


export type QueryGetWorkAreasByOrganizationIdsArgs = {
  organizationIds: Array<Scalars['ID']>;
};


export type QueryGetWorkPolicyByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetZoneByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetZonesByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGlobalSearchArgs = {
  input: GlobalSearchInput;
};


export type QueryGlobalSearchFilterOptionsArgs = {
  input: GlobalSearchFilterOptionsInput;
};


export type QueryInsightsAssistantConversationsForOrganizationV2Args = {
  organizationId: Scalars['ID'];
};


export type QueryInsightsAssistantConversationsV2Args = {
  createdAfter?: InputMaybe<Scalars['DateTime']>;
};


export type QueryInsightsAssistantFeedbackV1Args = {
  conversationId: Scalars['ID'];
  messageId: Scalars['ID'];
};


export type QueryInternalCustomResourceReservationsForUserInLocationArgs = {
  duration?: InputMaybe<Scalars['ISO8601_Duration']>;
  getAllReservationsForCampus?: InputMaybe<Scalars['Boolean']>;
  locationId: Scalars['ID'];
  organizationId: Scalars['ID'];
  unconfirmedOnly: Scalars['Boolean'];
  userId: Scalars['ID'];
  utcStartTime?: InputMaybe<Scalars['ISO8601Timestamp']>;
};


export type QueryInternalPermissionUserOrgActionArgs = {
  actions: Array<QueryablePermissionAction>;
  orgId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QueryInternalResourceArgs = {
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
};


export type QueryIsFeatureFlagEnabledForDeviceOrgArgs = {
  flagType?: InputMaybe<DeviceFeatureFlagType>;
};


export type QueryIsFeatureFlagEnabledForOrgOrMeArgs = {
  flagType?: InputMaybe<FeatureFlagType>;
};


export type QueryIsPassiveCheckInFeatureEnabledForBuildingArgs = {
  input: IsPassiveCheckInFeatureEnabledForBuildingInput;
};


export type QueryIsRipplingAccountConnectedForOrganizationArgs = {
  organizationId: Scalars['ID'];
};


export type QueryLevelChangeDetectionTokenArgs = {
  levelId: Scalars['ID'];
};


export type QueryListBuildingCidrsArgs = {
  input: ListBuildingCidrsInput;
};


export type QueryListIssueReportsArgs = {
  input: ListIssueReportsInput;
};


export type QueryListMeetingServiceRequestsArgs = {
  input: ListMeetingServiceRequestsInput;
};


export type QueryListMeetingServicesArgs = {
  input: ListMeetingServicesInput;
};


export type QueryListMeetingServicesAvailableInSpaceArgs = {
  input: ListMeetingServicesAvailableInSpaceInput;
};


export type QueryListMeetingServicesCategoriesArgs = {
  input: ListMeetingServicesCategoriesInput;
};


export type QueryListTicketIntegrationAvailableTargetsArgs = {
  includeJiraProjects?: Scalars['Boolean'];
  integrationId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryListTicketIntegrationEntityMappingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  buildingId?: InputMaybe<Scalars['ID']>;
  first: Scalars['Int'];
  integrationId: Scalars['ID'];
};


export type QueryListTicketIntegrationExternalObjectClassesArgs = {
  integrationId: Scalars['ID'];
};


export type QueryListTicketIntegrationExternalObjectsArgs = {
  after?: InputMaybe<Scalars['String']>;
  classIds?: InputMaybe<Array<Scalars['ID']>>;
  first?: InputMaybe<Scalars['Int']>;
  integrationId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  seedNames?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryListTicketIntegrationFieldMappingsArgs = {
  integrationId: Scalars['ID'];
  targetConfigId?: InputMaybe<Scalars['ID']>;
  workflowId?: InputMaybe<Scalars['ID']>;
};


export type QueryListTicketIntegrationSourceFieldsArgs = {
  integrationId: Scalars['ID'];
  workflowId?: InputMaybe<Scalars['ID']>;
};


export type QueryListTicketIntegrationTargetConfigsArgs = {
  integrationId: Scalars['ID'];
};


export type QueryListTicketIntegrationTargetFieldsArgs = {
  integrationId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  targetConfigId?: InputMaybe<Scalars['ID']>;
};


export type QueryListTicketIntegrationTransitionFieldsArgs = {
  integrationId: Scalars['ID'];
  targetConfigId: Scalars['ID'];
};


export type QueryListTicketIntegrationUnmappedEntitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  buildingId: Scalars['ID'];
  first: Scalars['Int'];
  integrationId: Scalars['ID'];
};


export type QueryListTicketIntegrationWorkflowBindingsArgs = {
  integrationId: Scalars['ID'];
};


export type QueryListUniqueAssigneesForMeetingServicesArgs = {
  input: ListUniqueAssigneesForMeetingServicesInput;
};


export type QueryListUniqueIssueReportValuesArgs = {
  input: ListUniqueIssueReportValuesInput;
};


export type QueryListUniqueMeetingServiceRequestValuesArgs = {
  input: ListUniqueMeetingServiceRequestValuesInput;
};


export type QueryMatchTicketIntegrationEntityMappingCandidatesArgs = {
  buildingId: Scalars['ID'];
  integrationId: Scalars['ID'];
};


export type QueryOrganizationReportingChainArgs = {
  managerId: Scalars['ID'];
  maxDepth?: InputMaybe<Scalars['Int']>;
};


export type QueryParseDeliveryTextArgs = {
  text: Scalars['String'];
  textType: DeliveryTextType;
};


export type QueryPreviewTicketIntegrationFieldRenderArgs = {
  integrationId: Scalars['ID'];
  mappings?: InputMaybe<Array<TicketIntegrationFieldMappingInput>>;
  sampleEntity?: InputMaybe<TicketIntegrationPreviewEntityRefInput>;
  targetConfigId?: InputMaybe<Scalars['ID']>;
  workflowId?: InputMaybe<Scalars['ID']>;
};


export type QueryReservationsMultiDayGroupedByDateArgs = {
  dates: Array<Scalars['LocalDate']>;
  deskIds: Array<Scalars['ID']>;
  durationInMinutes: Scalars['Int'];
  startTime: Scalars['LocalTime'];
  timezone: Scalars['IANATimezone'];
  userId: Scalars['Int'];
};


export type QueryResourceDetailsArgs = {
  organizationId: Scalars['ID'];
  resourceIds: Array<Scalars['ID']>;
};


export type QueryResourceDetailsByFloorArgs = {
  floorId: Scalars['ID'];
  organizationId: Scalars['ID'];
};


export type QueryResourceEventConsistencyArgs = {
  eventTypes: Array<Scalars['ID']>;
  organizationId: Scalars['ID'];
};


export type QueryResourceMixedTypeRecurringValidateArgs = {
  clientType: ClientType;
  duration: Scalars['ISO8601_Duration'];
  endReservationIds?: InputMaybe<Array<Scalars['ID']>>;
  organizationId: Scalars['ID'];
  recurringReservationRequestExclusions?: InputMaybe<Array<RecurringReservationRequest>>;
  recurringReservationRequests: Array<RecurringReservationRequest>;
  requestReservationDates?: InputMaybe<Array<LocaleDateTimePair>>;
  reservationRequestDateExclusions?: InputMaybe<Array<LocaleDateTimePair>>;
  reservee: Scalars['ID'];
  resourceInstanceIds: Array<Scalars['ID']>;
};


export type QueryResourceReservationExclusionsArgs = {
  endDate: Scalars['IsoDateOnlyString'];
  organizationId: Scalars['ID'];
  reservationId: Scalars['ID'];
  startDate: Scalars['IsoDateOnlyString'];
};


export type QueryResourceReservationInstancesGroupedByReservationIdArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['ID'];
  reservationQueries: Array<ReservationInstanceQueryInput>;
};


export type QueryResourceReservationRecurringValidateArgs = {
  clientType: ClientType;
  duration: Scalars['ISO8601_Duration'];
  endReservationIds?: InputMaybe<Array<Scalars['ID']>>;
  organizationId: Scalars['ID'];
  recurringReservationRequestExclusions?: InputMaybe<Array<RecurringReservationRequest>>;
  recurringReservationRequests: Array<RecurringReservationRequest>;
  requestReservationDates?: InputMaybe<Array<LocaleDateTimePair>>;
  reservationRequestDateExclusions?: InputMaybe<Array<LocaleDateTimePair>>;
  reservationRequestType?: InputMaybe<BookingType>;
  reservee: Scalars['ID'];
  resourceInstanceIds: Array<Scalars['ID']>;
};


export type QueryResourceReservationSingleDayValidateArgs = {
  clientType: ClientType;
  date: Scalars['IsoDateOnlyString'];
  duration: Scalars['ISO8601_Duration'];
  endReservationIds?: InputMaybe<Array<Scalars['ID']>>;
  organizationId: Scalars['ID'];
  reservee: Scalars['ID'];
  resourceInstanceId: Scalars['ID'];
  startTime: Scalars['IsoLocalTimeString'];
};


export type QueryReviewDraftArgs = {
  draftId: Scalars['ID'];
};


export type QueryReviewDraftChangesArgs = {
  draftId: Scalars['ID'];
};


export type QuerySearchUsersArgs = {
  input: SearchUsersInput;
};


export type QuerySpaceAllowsIssueReportsArgs = {
  spaceId: Scalars['ID'];
};


export type QuerySuggestTicketIntegrationFieldMappingsArgs = {
  integrationId: Scalars['ID'];
  targetConfigId?: InputMaybe<Scalars['ID']>;
  workflowId?: InputMaybe<Scalars['ID']>;
};


export type QueryTicketIntegrationArgs = {
  id: Scalars['ID'];
};


export type QueryTicketIntegrationObjectImportStatusArgs = {
  integrationId: Scalars['ID'];
};


export type QueryUserBulkActionJobArgs = {
  jobId: Scalars['ID'];
};


export type QueryVisitDocumentAgreementArgs = {
  documentId: Scalars['ID'];
  visitInviteId: Scalars['ID'];
};


export type QueryVisitDocumentByDecisionIdArgs = {
  decisionId: Scalars['ID'];
};


export type QueryVisitDocumentByIdArgs = {
  id: Scalars['ID'];
};


export type QueryVisitDocumentByIdWithCustomVisitTypeArgs = {
  id: Scalars['ID'];
};


export type QueryVisitDocumentNameStatusAndTypesPageArgs = {
  filters?: InputMaybe<Array<VisitDocumentNameStatusAndTypesFilter>>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sortByField?: InputMaybe<QueryVisitDocumentSortBy>;
  sortOrder?: InputMaybe<QueryWorkflowSortOrder>;
};


export type QueryVisitDocumentNameStatusAndTypesPageWithCustomVisitTypeArgs = {
  filters?: InputMaybe<Array<VisitDocumentNameStatusAndTypesFilter>>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sortByField?: InputMaybe<QueryVisitDocumentSortBy>;
  sortOrder?: InputMaybe<QueryWorkflowSortOrder>;
};


export type QueryVisitDocumentWithNextDocumentIdArgs = {
  documentId?: InputMaybe<Scalars['ID']>;
  visitInviteId: Scalars['ID'];
  visitLocationId: Scalars['ID'];
  visitType: Scalars['String'];
};


export type QueryVisitDocumentWithNextDocumentIdWithCustomVisitTypeArgs = {
  documentId?: InputMaybe<Scalars['ID']>;
  visitInviteId: Scalars['ID'];
  visitLocationId: Scalars['ID'];
  visitType: Scalars['String'];
};


export type QueryVisitOverviewOfDocumentsArgs = {
  locationId: Scalars['ID'];
  visitInviteId: Scalars['ID'];
  visitType: Scalars['String'];
};


export type QueryVisitOverviewOfDocumentsForVisitInvitesArgs = {
  lookups: Array<VisitInviteDocumentLookup>;
};


export type QueryVisitOverviewOfDocumentsWithCustomVisitTypeArgs = {
  locationId: Scalars['ID'];
  visitInviteId: Scalars['ID'];
  visitType: Scalars['String'];
};

export enum QueryablePermissionAction {
  ASSIGNMENT = 'ASSIGNMENT',
  /** @deprecated Use DELEGATE instead */
  ASSIGNMENT_DELEGATE = 'ASSIGNMENT_DELEGATE',
  BOOK = 'BOOK',
  BYPASS_BOOKING_POLICIES = 'BYPASS_BOOKING_POLICIES',
  CUSTOM_RESOURCE_CREATE = 'CUSTOM_RESOURCE_CREATE',
  DELEGATE = 'DELEGATE',
  MANAGE_OFFICE_AND_MAPS = 'MANAGE_OFFICE_AND_MAPS',
  SKIP_BOOKING_CONFIRMATION = 'SKIP_BOOKING_CONFIRMATION'
}

export type RebootNeatPulseDeviceInput = {
  deviceId: Scalars['ID'];
};

export type RebootNeatPulseDeviceResponse = {
  __typename: 'RebootNeatPulseDeviceResponse';
  deviceId: Scalars['ID'];
  requested: Scalars['Boolean'];
};

export type Recipient = {
  __typename: 'Recipient';
  email: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  user: Maybe<User>;
};

export type RecipientInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type ReconnectOpenpathAccountInput = {
  email: Scalars['String'];
  otp?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
};

export type ReconnectOpenpathAccountResponse = {
  __typename: 'ReconnectOpenpathAccountResponse';
  uuid: Scalars['ID'];
};

export enum RecurringReservationDayOfWeek {
  FRIDAY = 'FRIDAY',
  MONDAY = 'MONDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
  THURSDAY = 'THURSDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY'
}

export enum RecurringReservationFrequency {
  DAILY = 'DAILY',
  HOURLY = 'HOURLY',
  MINUTELY = 'MINUTELY',
  MONTHLY = 'MONTHLY',
  SECONDLY = 'SECONDLY',
  WEEKLY = 'WEEKLY',
  YEARLY = 'YEARLY'
}

export enum RecurringReservationMonth {
  APRIL = 'APRIL',
  AUGUST = 'AUGUST',
  DECEMBER = 'DECEMBER',
  FEBRUARY = 'FEBRUARY',
  JANUARY = 'JANUARY',
  JULY = 'JULY',
  JUNE = 'JUNE',
  MARCH = 'MARCH',
  MAY = 'MAY',
  NOVEMBER = 'NOVEMBER',
  OCTOBER = 'OCTOBER',
  SEPTEMBER = 'SEPTEMBER'
}

export type RecurringReservationRequest = {
  /** Hours to which the recurrence is applied. Default: undefined */
  byHour?: InputMaybe<Array<Scalars['Int']>>;
  /** Minutes to which the recurrence is applied. Default: undefined */
  byMinute?: InputMaybe<Array<Scalars['Int']>>;
  /** Months to which the recurrence is applied. Default: undefined */
  byMonth?: InputMaybe<Array<RecurringReservationMonth>>;
  /** Month-days to which the recurrence is applied. Default: undefined */
  byMonthDay?: InputMaybe<Array<Scalars['Int']>>;
  /** Seconds to which the recurrence is applied. Default: undefined */
  bySecond?: InputMaybe<Array<Scalars['Int']>>;
  /** Each given integer will specify an occurrence number, corresponding to the nth occurrence of the rule inside the frequency period. For example, a bySetPosition of [-1] if combined with a MONTHLY frequency, and a byWeekDay of [MONDAY, TUESDAY, WEDNESDAY, THURSDAY, FRIDAY], will result in the last work day of every month. */
  bySetPosition?: InputMaybe<Array<Scalars['Int']>>;
  /** Weekdays to which the recurrence is applied. Default: undefined */
  byWeekDay?: InputMaybe<Array<ByWeekDayValue>>;
  /** Week numbers to which the recurrence is applied. Default: undefined. Range 1 - 53. */
  byWeekNumber?: InputMaybe<Array<Scalars['Int']>>;
  /** Year-days to which the recurrence is applied. Default: undefined */
  byYearDay?: InputMaybe<Array<Scalars['Int']>>;
  /** Number of occurrences. Default 1 */
  count?: InputMaybe<Scalars['Int']>;
  endDateTime?: InputMaybe<LocaleDateTimePair>;
  frequency: RecurringReservationFrequency;
  /** Number of 'frequency' gaps between reservations. Default: 1 */
  interval?: InputMaybe<Scalars['Int']>;
  /** Default: Locale today, now */
  startDateTime?: InputMaybe<LocaleDateTimePair>;
  /** Default: MONDAY */
  weekStartDay?: InputMaybe<RecurringReservationDayOfWeek>;
};

export enum RefreshTicketIntegrationAvailableTargetsErrorReason {
  NOT_ACTIVE = 'NOT_ACTIVE',
  NOT_FOUND = 'NOT_FOUND',
  PROVIDER_CAPABILITY_MISSING = 'PROVIDER_CAPABILITY_MISSING'
}

export type RefreshTicketIntegrationAvailableTargetsErrorResponse = {
  __typename: 'RefreshTicketIntegrationAvailableTargetsErrorResponse';
  reason: RefreshTicketIntegrationAvailableTargetsErrorReason;
};

export type RefreshTicketIntegrationAvailableTargetsResponse = RefreshTicketIntegrationAvailableTargetsErrorResponse | RefreshTicketIntegrationAvailableTargetsSuccessResponse;

export type RefreshTicketIntegrationAvailableTargetsSuccessResponse = {
  __typename: 'RefreshTicketIntegrationAvailableTargetsSuccessResponse';
  targetImport: TicketIntegrationTargetImport;
};

export enum RejectMeetingServiceRequestErrorReason {
  CONFLICT = 'CONFLICT'
}

export type RejectMeetingServiceRequestErrorResponse = {
  __typename: 'RejectMeetingServiceRequestErrorResponse';
  reason: RejectMeetingServiceRequestErrorReason;
};

export type RejectMeetingServiceRequestInput = {
  comment?: InputMaybe<Scalars['String']>;
  latestChangeId: Scalars['ID'];
  meetingServiceRequestId: Scalars['ID'];
};

export type RejectMeetingServiceRequestResponse = RejectMeetingServiceRequestErrorResponse | RejectMeetingServiceRequestSuccessResponse;

export type RejectMeetingServiceRequestSuccessResponse = {
  __typename: 'RejectMeetingServiceRequestSuccessResponse';
  _: Maybe<Scalars['Void']>;
};

export enum RemoteTypeEnum {
  /** Microsoft Exchange Calendar integration */
  EXCHANGE = 'EXCHANGE',
  /** Google Calendar integration */
  GOOGLE = 'GOOGLE',
  /** Microsoft Office 365 Calendar integration */
  OFFICE_365 = 'OFFICE_365'
}

export type RemoveBookingWindowPolicyInput = {
  locationId: Scalars['ID'];
  policyId: Scalars['ID'];
};

export type RemoveBuildingGeofenceInput = {
  buildingId: Scalars['ID'];
};

/** Removes relationships by id, as returned by any read. Removing something the service inferred is DURABLE. Dropping the row is not enough — the crawl that derived it runs again and derives it again — so a removal is written as a MANUAL_UNLINK on that pair and kind, which outranks every derived reason. An admin who splits two endpoints Logitech reported under one serial should not watch them merge again five minutes later. That also covers the relationships that were never stored. A relationship the service worked out on the spot has no row to delete, and the MANUAL_UNLINK shadows the computation instead of chasing it. Removing a MANUAL relationship is the one case that deletes instead. A manual decision is not re-derived by any crawl, so deleting it is already durable — and it is how an operator takes a decision back, MANUAL_UNLINK included, letting the derived evidence speak again. This is what a negative kind would otherwise be for, and it is one mechanism instead of three: the same removal works on a false merge, a camera attached to the wrong host, and an endpoint placed in the wrong room. */
export type RemoveEndpointRelationshipsInput = {
  ids: Array<Scalars['ID']>;
};

export type RemoveEndpointRelationshipsResponse = {
  __typename: 'RemoveEndpointRelationshipsResponse';
  /** The endpoints affected, re-resolved. An endpoint whose manual placement was removed comes back placed by inference, or unplaced. */
  endpoints: Array<Endpoint>;
};

export type RemoveSpaceFromEventError = {
  __typename: 'RemoveSpaceFromEventError';
  message: Maybe<Scalars['String']>;
  reason: RemoveSpaceFromEventErrorReasons;
};

export enum RemoveSpaceFromEventErrorReasons {
  LACKING_EVENT_UPDATE_PERMISSIONS = 'LACKING_EVENT_UPDATE_PERMISSIONS',
  UNKNOWN = 'UNKNOWN'
}

export type RemoveSpaceFromEventInput = {
  eventId: Scalars['String'];
  spaceId: Scalars['String'];
};

export type RemoveSpaceFromEventResponse = {
  __typename: 'RemoveSpaceFromEventResponse';
  /** If the event has not been updated, an explanation will be provided */
  error: Maybe<RemoveSpaceFromEventError>;
  /** True if event has been updated */
  eventUpdated: Scalars['Boolean'];
  /** Updated event model */
  updatedEvent: Maybe<Event>;
};

export type RemoveTicketIntegrationEntityMappingsInput = {
  entities: Array<TicketIntegrationEntityRefInput>;
  integrationId: Scalars['ID'];
};

export type RemoveTicketIntegrationEntityMappingsResponse = {
  __typename: 'RemoveTicketIntegrationEntityMappingsResponse';
  removed: Array<TicketIntegrationEntityRef>;
};

export type RemoveTicketIntegrationFieldMappingsInput = {
  integrationId: Scalars['ID'];
  /** The target config to scope to; pass the config's id, the default one included. Null = the default-following scope (see TicketIntegrationFieldMapping.targetConfigId). */
  targetConfigId?: InputMaybe<Scalars['ID']>;
  targetFieldIds: Array<Scalars['ID']>;
  /** Null = the integration-level scope. */
  workflowId?: InputMaybe<Scalars['ID']>;
};

export type RemoveTicketIntegrationFieldMappingsResponse = {
  __typename: 'RemoveTicketIntegrationFieldMappingsResponse';
  removedTargetFieldIds: Array<Scalars['ID']>;
};

export enum RemoveTicketIntegrationTargetConfigErrorReason {
  /** Set another target config as the default first. */
  IS_DEFAULT = 'IS_DEFAULT',
  NOT_FOUND = 'NOT_FOUND',
  TARGET_CONFIG_NOT_FOUND = 'TARGET_CONFIG_NOT_FOUND'
}

export type RemoveTicketIntegrationTargetConfigErrorResponse = {
  __typename: 'RemoveTicketIntegrationTargetConfigErrorResponse';
  reason: RemoveTicketIntegrationTargetConfigErrorReason;
};

export type RemoveTicketIntegrationTargetConfigInput = {
  integrationId: Scalars['ID'];
  targetConfigId: Scalars['ID'];
};

export type RemoveTicketIntegrationTargetConfigResponse = RemoveTicketIntegrationTargetConfigErrorResponse | RemoveTicketIntegrationTargetConfigSuccessResponse;

export type RemoveTicketIntegrationTargetConfigSuccessResponse = {
  __typename: 'RemoveTicketIntegrationTargetConfigSuccessResponse';
  removedTargetConfigId: Scalars['ID'];
};

export enum RemoveTicketIntegrationWorkflowBindingErrorReason {
  /** No such integration, or the workflow has no active binding to it. */
  NOT_FOUND = 'NOT_FOUND'
}

export type RemoveTicketIntegrationWorkflowBindingErrorResponse = {
  __typename: 'RemoveTicketIntegrationWorkflowBindingErrorResponse';
  reason: RemoveTicketIntegrationWorkflowBindingErrorReason;
};

export type RemoveTicketIntegrationWorkflowBindingInput = {
  integrationId: Scalars['ID'];
  workflowId: Scalars['ID'];
};

export type RemoveTicketIntegrationWorkflowBindingResponse = RemoveTicketIntegrationWorkflowBindingErrorResponse | RemoveTicketIntegrationWorkflowBindingSuccessResponse;

export type RemoveTicketIntegrationWorkflowBindingSuccessResponse = {
  __typename: 'RemoveTicketIntegrationWorkflowBindingSuccessResponse';
  workflowId: Scalars['ID'];
};

export type ReportIssueInput = {
  description: Scalars['String'];
  /** Image-service URLs for photos of the issue, in the order they should display. Stored as the answer to the issue report workflow's photo question. */
  imageUrls?: InputMaybe<Array<Scalars['String']>>;
  isUnusable: Scalars['Boolean'];
  /** Omitted or null is MEDIUM. Only a manager of the building (workplace_services:manage) may set it; anyone else must omit it or pass null. */
  priority?: InputMaybe<TicketPriority>;
  /** Omitted or null titles the report after the space or desk it regards. */
  title?: InputMaybe<Scalars['String']>;
};

export type ReportIssueResponse = {
  __typename: 'ReportIssueResponse';
  id: Scalars['ID'];
};

export type ReportIssueWithDeskInput = {
  /** The amenity catalog IDs (Amenity.id) of the amenities on this desk that the issue regards, e.g. its monitor. Each must be on the desk. Omitted, null, or empty regards the desk as a whole. */
  amenityIds?: InputMaybe<Array<Scalars['ID']>>;
  deskId: Scalars['ID'];
  issue: ReportIssueInput;
};

export type ReportIssueWithSpaceInput = {
  /** The amenity catalog IDs (Amenity.id) of the amenities on this space that the issue regards, e.g. its TV. Each must be on the space. Omitted, null, or empty regards the space as a whole. */
  amenityIds?: InputMaybe<Array<Scalars['ID']>>;
  issue: ReportIssueInput;
  spaceId: Scalars['ID'];
};

export type ReportMyPresenceViaMobileGeofenceEventInput = {
  event: MobileGeofenceEventInput;
};

export type ReportMyPresenceViaMobileGeofenceEventLocationInput = {
  /** Device motion-activity when this location was recorded (eg: still, on_foot, in_vehicle). */
  activity: MobileGeofenceEventMotionActivityInput;
  /** The age of the location in milliseconds, relative to the Device system-time when the location was received. For example, if the reported age is 10000, that location was recorded 10s ago, relative to the system-time. location.timestamp + location.age = Device system-time when location was recorded. */
  age: Scalars['Int'];
  /** Device battery level when the location was recorded. */
  battery: MobileGeofenceEventBatteryInput;
  /** latitude, longitude, speed, heading, etc. */
  coords: MobileGeofenceEventCoordsInput;
  /** Event responsible for generating this location (motionchange, providerchange, geofence, heartbeat). */
  event?: InputMaybe<MobileLocationEvent>;
  /** Optional arbitrary meta-data attached to this location. */
  extras?: InputMaybe<Scalars['JSON']>;
  /** true if location was recorded while plugin is in the moving state. */
  is_moving: Scalars['Boolean'];
  /** Present (and true) if the location was generated by a "Fake Location" application or simulator. */
  mock?: InputMaybe<Scalars['Boolean']>;
  /** Distance-traveled in meters. */
  odometer: Scalars['Float'];
  /** true if the plugin is currently waiting for the best possible location to arrive. Samples are recorded when the plugin is transitioning between motion-states (moving vs stationary) or BackgroundGeolocation.getCurrentPosition. If you're manually posting location to your server, you should not persist these "samples". */
  sample?: InputMaybe<Scalars['Boolean']>;
  /** ISO-8601 UTC timestamp provided by the native location API. */
  timestamp: Scalars['ISODateTime'];
  /** Universally Unique Identifier. You can use this to match locations recorded at your server with those in the logs. It can also be used to ensure if the plugin has ever posted the same location twice. */
  uuid: Scalars['String'];
};

export type ReportMyPresenceViaMobileGeofenceEventResponse = {
  __typename: 'ReportMyPresenceViaMobileGeofenceEventResponse';
  uuid: Maybe<Scalars['ID']>;
};

export type ReportUserPresenceAtIpAddressInput = {
  /** Version of the app in use, e.g. 'v3.28.3 (v1)' */
  appVersion?: InputMaybe<Scalars['String']>;
  /** Unique identifier associated with user's personal device */
  deviceUuid: Scalars['ID'];
  /** Purely for logging/debugging, X-Forwarded-For or source IP is the source of truth */
  ipAddressGuess?: InputMaybe<Scalars['IPAddress']>;
  operatingSystem: OperatingSystem;
  /** e.g. the '10' in Android 10, but intentionally loose like a 'User-Agent' string. For logging/debugging. */
  operatingSystemVersion: Scalars['String'];
  /** Unique identifier for this request, for client/server log correlation */
  requestUuid: Scalars['ID'];
  /** Arbitrary string to describe what triggered this report, e.g. 'background fetch', 'background push', etc. */
  trigger?: InputMaybe<Scalars['String']>;
};

export type ReportUserPresenceAtIpAddressResponse = {
  __typename: 'ReportUserPresenceAtIPAddressResponse';
  /** Zero or more building IDs associated with this IP address. IP addresses can be assigned to multiple buildings. */
  buildingIds: Array<Scalars['ID']>;
  /** What we think the IP address is, ignoring the provided guess. Could be null if we get malformed headers (rare). */
  ipAddress: Maybe<Scalars['IPAddress']>;
  /** True if reported IP address matches a known IP address associated with a building */
  matchesBuilding: Scalars['Boolean'];
};

export type ReportUserPresenceFromWebClientInput = {
  clientName: Scalars['String'];
  /** Purely for logging/debugging, X-Forwarded-For or source IP is the source of truth */
  ipAddressGuess?: InputMaybe<Scalars['IPAddress']>;
};

export type ReportUserPresenceFromWebClientResponse = {
  __typename: 'ReportUserPresenceFromWebClientResponse';
  uuid: Maybe<Scalars['ID']>;
};

export type ReportUserPresenceInBuildingAtTimeInput = {
  buildingId: Scalars['ID'];
  timestamp: Scalars['ISODateTime'];
  trigger?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type ReportUserPresenceInBuildingAtTimeResponse = {
  __typename: 'ReportUserPresenceInBuildingAtTimeResponse';
  uuid: Maybe<Scalars['ID']>;
};

/** Everyone below a manager in the org chart, as walked through each person's manager. */
export type ReportingChain = {
  __typename: 'ReportingChain';
  managerId: Scalars['ID'];
  /** The depth the walk was bounded at: the request's maxDepth, or the default of 20. */
  maxDepth: Scalars['Int'];
  members: Array<ReportingChainMember>;
  total: Scalars['Int'];
};

/** One person in a manager's reporting chain. */
export type ReportingChainMember = {
  __typename: 'ReportingChainMember';
  /** 1 for a direct report, 2 for a report's report, and so on. */
  depth: Scalars['Int'];
  user: AccountUser;
};

export enum RequestMeetingServiceForDraftEventAtSpaceErrorReason {
  /** Admin could archive the service while requester is filling out form */
  MEETING_SERVICE_IS_ARCHIVED = 'MEETING_SERVICE_IS_ARCHIVED',
  /** Admin could change availability while requester is filling out form */
  MEETING_SERVICE_NOT_AVAILABLE = 'MEETING_SERVICE_NOT_AVAILABLE',
  /** Admin published a new version while requester is filling out form. Old versions are allowed to be created for a short period of time, but that time has passed. */
  MEETING_SERVICE_VERSION_OUTDATED = 'MEETING_SERVICE_VERSION_OUTDATED'
}

export type RequestMeetingServiceForDraftEventAtSpaceErrorResponse = {
  __typename: 'RequestMeetingServiceForDraftEventAtSpaceErrorResponse';
  reason: RequestMeetingServiceForDraftEventAtSpaceErrorReason;
};

export type RequestMeetingServiceForDraftEventAtSpaceInput = {
  /** The answers to the questions on the MeetingService */
  answers: Array<AnsweredTicketQuestionInput>;
  /** The expected end time of the event instance - okay if this is wrong, will be updated on sync */
  eventEnd: DateWithTimezone;
  /** The expected start time of the event instance - okay if this is wrong, will be updated on sync */
  eventStart: DateWithTimezone;
  /** The UID that the draft Event will be created with. It is *very* important that this same UID makes it onto the Event, otherwise we cannot sync changes on the Event back to the service request. */
  eventUid: Scalars['ID'];
  meetingServiceId: Scalars['ID'];
  /** If this is a recurring event, this identifies which instance the service is requested for. If this is omitted, it is assumed that the service is requested for the first instance. */
  recurrenceId?: InputMaybe<Scalars['ID']>;
  spaceId: Scalars['ID'];
  /** The version of the MeetingService you're requesting - could be different from the latest version */
  versionId: Scalars['ID'];
};

export type RequestMeetingServiceForDraftEventAtSpaceResponse = RequestMeetingServiceForDraftEventAtSpaceErrorResponse | RequestMeetingServiceForDraftEventAtSpaceSuccessResponse;

export type RequestMeetingServiceForDraftEventAtSpaceSuccessResponse = {
  __typename: 'RequestMeetingServiceForDraftEventAtSpaceSuccessResponse';
  meetingServiceRequestId: Scalars['ID'];
};

export enum RequestMeetingServiceForExistingEventAtSpaceErrorReason {
  /** Not fixable, must start over and create a new event. Ideally, client would prevent getting this far in the first place. */
  EVENT_HAS_NO_UID = 'EVENT_HAS_NO_UID',
  /** Admin could archive the service while requester is filling out form */
  MEETING_SERVICE_IS_ARCHIVED = 'MEETING_SERVICE_IS_ARCHIVED',
  /** Admin could change availability while requester is filling out form */
  MEETING_SERVICE_NOT_AVAILABLE = 'MEETING_SERVICE_NOT_AVAILABLE',
  /** Admin published a new version while requester is filling out form. Old versions are allowed to be created for a short period of time, but that time has passed. */
  MEETING_SERVICE_VERSION_OUTDATED = 'MEETING_SERVICE_VERSION_OUTDATED'
}

export type RequestMeetingServiceForExistingEventAtSpaceErrorResponse = {
  __typename: 'RequestMeetingServiceForExistingEventAtSpaceErrorResponse';
  reason: RequestMeetingServiceForExistingEventAtSpaceErrorReason;
};

export type RequestMeetingServiceForExistingEventAtSpaceInput = {
  /** The answers to the questions on the MeetingService */
  answers: Array<AnsweredTicketQuestionInput>;
  /** Event.id for the event that the service is being requested for. Could be an internal robin event ID or a proxied event ID. Must identify a specific instance - recurring service requests are not supported. */
  eventId: Scalars['ID'];
  meetingServiceId: Scalars['ID'];
  spaceId: Scalars['ID'];
  /** The version of the MeetingService you're requesting - could be different from the latest version */
  versionId: Scalars['ID'];
};

export type RequestMeetingServiceForExistingEventAtSpaceResponse = RequestMeetingServiceForExistingEventAtSpaceErrorResponse | RequestMeetingServiceForExistingEventAtSpaceSuccessResponse;

export type RequestMeetingServiceForExistingEventAtSpaceSuccessResponse = {
  __typename: 'RequestMeetingServiceForExistingEventAtSpaceSuccessResponse';
  meetingServiceRequestId: Scalars['ID'];
};

export type Reservation = {
  __typename: 'Reservation';
  accountReservee: Maybe<AccountReservee>;
  accountReserver: Maybe<AccountUser>;
  canCheckInNow: Maybe<Scalars['Boolean']>;
  confirmation: Maybe<DeskConfirmation>;
  creationType: Maybe<EventCreationType>;
  endTime: Maybe<Scalars['String']>;
  exclusions: Array<Exclusion>;
  hasStarted: Maybe<Scalars['Boolean']>;
  healthCheckpoint: Maybe<HealthCheckpoint>;
  /** Reservation Id */
  id: Scalars['ID'];
  isCheckedIn: Maybe<Scalars['Boolean']>;
  isDeclined: Maybe<Scalars['Boolean']>;
  isFullDay: Maybe<Scalars['Boolean']>;
  recurrence: Maybe<Scalars['String']>;
  /** @deprecated use the account reservee, it will be scoped to the reservations org */
  reservee: Maybe<Reservee>;
  seat: Desk;
  seriesId: Maybe<Scalars['ID']>;
  startTime: Scalars['String'];
  timeZone: Maybe<Scalars['String']>;
  type: Scalars['String'];
  visibility: DeskReservationVisibility;
};

export type ReservationEdge = {
  __typename: 'ReservationEdge';
  confirmation: Maybe<DeskConfirmation>;
  endTime: Maybe<Scalars['String']>;
  healthCheckpoint: Maybe<HealthCheckpoint>;
  /** Reservation Id */
  id: Scalars['ID'];
  recurrence: Maybe<Scalars['String']>;
  reservee: Maybe<Reservee>;
  seat: Desk;
  seriesId: Maybe<Scalars['ID']>;
  startTime: Scalars['String'];
  timeZone: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type ReservationInfo = {
  __typename: 'ReservationInfo';
  desk: Scalars['String'];
  deskId: Scalars['ID'];
  end: DateTimezone;
  neighborhood: Maybe<Scalars['String']>;
  reservee: Scalars['String'];
  start: DateTimezone;
  zone: Scalars['String'];
};

export type ReservationInstanceQueryInput = {
  /** For fetching the next page of a series, plug in the last returned cursor value to fetch the next set of data */
  fromCursor?: InputMaybe<Scalars['ID']>;
  /** ID of reservation to query */
  reservationId: Scalars['ID'];
};

/** Reservation invitee. One of the fields must be specified. */
export type ReservationInvitee = {
  /** Invitee email */
  email?: InputMaybe<Scalars['String']>;
  /** Invitee slug */
  slug?: InputMaybe<Scalars['String']>;
  /** Robin user ID */
  userId?: InputMaybe<Scalars['ID']>;
};

export type ReservationResourcePairInput = {
  reservationId: Scalars['ID'];
  resourceId: Scalars['ID'];
};

export type ReservationSummary = {
  __typename: 'ReservationSummary';
  reservationDatesConsecutive: Scalars['Boolean'];
  reservationDistinctTimePairs: Array<LocalTimePair>;
  reservationId: Scalars['ID'];
};

/** Visibility of reservation */
export enum ReservationVisibility {
  CONFIDENTIAL = 'CONFIDENTIAL',
  DEFAULT = 'DEFAULT',
  PERSONAL = 'PERSONAL',
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

/** The ID of the reservation and if it is visible to the current user. Intended use is by the Status Board to use as a reference for which reservations to hide */
export type ReservationsBySpacesForStatusBoard = {
  __typename: 'ReservationsBySpacesForStatusBoard';
  id: Scalars['ID'];
  visibility: DeskReservationVisibility;
};

export type ReservationsToCancelInput = {
  deskId: Scalars['ID'];
  isReservable: Scalars['Boolean'];
  reservationTypes: Array<DeskType>;
  schedules: Array<SharedScheduleInput>;
};

export type ReservationsToCancelResponse = {
  __typename: 'ReservationsToCancelResponse';
  deskId: Scalars['ID'];
  reservations: Array<Reservation>;
};

export type ReserveSpaceRequest = {
  /** Event end time (ISO format) */
  endTime?: InputMaybe<Scalars['Date']>;
  /** True if the event creator is invited to the event */
  eventCreatorIsInvited: Scalars['Boolean'];
  /** The description of the event. Defaults to empty string */
  eventDescription?: InputMaybe<Scalars['String']>;
  /** The title of the event. Defaults to empty string */
  eventTitle?: InputMaybe<Scalars['String']>;
  /** Set of included integration IDs */
  includedIntegrations: Array<Scalars['ID']>;
  /** Event invitees */
  invitees: Array<ReservationInvitee>;
  /** Is the event an all-day event? Default false */
  isAllDay?: InputMaybe<Scalars['Boolean']>;
  /** The name of the location where the event will take place. Defaults to empty string */
  locationName?: InputMaybe<Scalars['String']>;
  /** Is event pre-confirmed */
  preConfirm?: InputMaybe<Scalars['Boolean']>;
  /** ID of the reserved space */
  spaceId: Scalars['ID'];
  /** Event start time (ISO format) */
  startTime?: InputMaybe<Scalars['Date']>;
  /** Event visibility */
  visibility: ReservationVisibility;
};

/** Reservation response */
export type ReserveSpaceResponse = {
  __typename: 'ReserveSpaceResponse';
  /** If the space has not been reserved, an explanation will be provided */
  reason: Maybe<Scalars['String']>;
  /** True if space has been reserved */
  spaceReserved: Scalars['Boolean'];
};

export type Reservee = {
  __typename: 'Reservee';
  email: Scalars['String'];
  participationStatus: Maybe<ParticipationStatus>;
  user: Maybe<User>;
  visitorId: Maybe<Scalars['ID']>;
};

export type ResourceAllowsIssueReportsResponse = {
  __typename: 'ResourceAllowsIssueReportsResponse';
  allowed: Scalars['Boolean'];
};

export type ResourceEventConsistencyQueryType = {
  __typename: 'ResourceEventConsistencyQueryType';
  eventType: Scalars['ID'];
  organizationId: Scalars['ID'];
  value: Scalars['Int'];
};

export type ResourceGroupInput = {
  amenityIds?: InputMaybe<Array<Scalars['ID']>>;
  bookingType?: InputMaybe<ResourceWeeklyBookingTypeInput>;
  capacity?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  imageUrl?: InputMaybe<Scalars['String']>;
  isAccessible?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  policies?: InputMaybe<LayoutResourcePolicyInput>;
  subCategory?: InputMaybe<Scalars['String']>;
};

export type ResourceGroupSaveUpdateInput = {
  amenityIds: Array<Scalars['ID']>;
  bookingType?: InputMaybe<WeeklyBookingCommand>;
  capacity: Scalars['Int'];
  groupName?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isAccessible?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  policyConfiguration?: InputMaybe<CustomResourcePolicyDocumentCommand>;
  resourceGroupId: Scalars['ID'];
  subCategory?: InputMaybe<Scalars['String']>;
};

export type ResourceMixedTypeRecurringValidateResponseType = {
  __typename: 'ResourceMixedTypeRecurringValidateResponseType';
  assigned: Array<ResourceReservationRecurringValidateResponseType>;
  mapAvailability: Array<ResourceReservationRecurringValidateResponseType>;
  reservable: Array<ResourceReservationRecurringValidateResponseType>;
};

export type ResourceMutationResponseTrackingType = {
  __typename: 'ResourceMutationResponseTrackingType';
  eventType: Scalars['ID'];
  organizationId: Scalars['ID'];
  value: Scalars['Int'];
};

export type ResourcePermission = {
  __typename: 'ResourcePermission';
  action: ResourcePermissionAction;
  permit: Scalars['Boolean'];
};

export enum ResourcePermissionAction {
  ASSIGN = 'ASSIGN',
  BOOK = 'BOOK',
  DELEGATE = 'DELEGATE',
  SKIP_BOOKING_CONFIRMATION = 'SKIP_BOOKING_CONFIRMATION'
}

export type ResourcePermissionCollection = {
  __typename: 'ResourcePermissionCollection';
  permissions: Array<ResourcePermission>;
  resourceId: Scalars['ID'];
};

export type ResourcePolicy = {
  __typename: 'ResourcePolicy';
  abandonedResourceProtection: Maybe<ResourcePolicyEnabledWithDuration>;
  advanceCheckInWindow: Maybe<ResourcePolicyEnabledWithDuration>;
  advancedBookingThreshold: Maybe<ResourcePolicyEnabledWithDuration>;
  allowOverlappingBookings: Maybe<Scalars['Boolean']>;
  localCheckInOnly: Maybe<Scalars['Boolean']>;
  maxBookingLength: Maybe<ResourcePolicyEnabledWithDuration>;
  requireCheckIn: Maybe<Scalars['Boolean']>;
  resourceSharing: Maybe<Scalars['Boolean']>;
  restrictBookingToWorkingHours: Maybe<Scalars['Boolean']>;
};

export type ResourcePolicyDuration = {
  __typename: 'ResourcePolicyDuration';
  type: LayoutResourcePolicyDurationType;
  value: Scalars['Int'];
};

export type ResourcePolicyEnabledWithDuration = {
  __typename: 'ResourcePolicyEnabledWithDuration';
  duration: Maybe<ResourcePolicyDuration>;
  enabled: Scalars['Boolean'];
};

export type ResourceReservation = {
  __typename: 'ResourceReservation';
  accountReservedBy: AccountUser;
  accountReservee: AccountUser;
  confirmationClient: Maybe<ConfirmationClientType>;
  confirmationTimestamp: Maybe<Scalars['ISO8601Timestamp']>;
  confirmationValidationState: Maybe<ResourceReservationConfirmationErrorResponse>;
  date: Scalars['IsoDateOnlyString'];
  daysOfWeek: Array<RecurringReservationDayOfWeek>;
  duration: Scalars['ISO8601_Duration'];
  id: Scalars['ID'];
  isAssigned: Scalars['Boolean'];
  isConfirmed: Scalars['Boolean'];
  requestReservationDateEndDate: Maybe<Scalars['IsoDateOnlyString']>;
  requestReservationDateStartDate: Maybe<Scalars['IsoDateOnlyString']>;
  reservationClient: Maybe<ClientType>;
  /** @deprecated Use reservedByUser instead */
  reservedBy: Scalars['ID'];
  reservedById: Scalars['ID'];
  reservedByUser: User;
  /** @deprecated Use reserveeUser instead */
  reservee: Scalars['ID'];
  reserveeId: Scalars['ID'];
  reserveeUser: User;
  resource: CustomResource;
  resourceInstanceId: Scalars['ID'];
  startTime: Scalars['IsoLocalTimeString'];
};

export enum ResourceReservationConfirmationErrorCode {
  ADVANCED_CONFIRMATION_WINDOW_TOO_EARLY = 'ADVANCED_CONFIRMATION_WINDOW_TOO_EARLY',
  LOCAL_CONFIRMATION_REQUIRED = 'LOCAL_CONFIRMATION_REQUIRED',
  RESERVATION_ALREADY_CONFIRMED = 'RESERVATION_ALREADY_CONFIRMED',
  RESERVATION_CONFIRMATION_WINDOW_EXPIRED = 'RESERVATION_CONFIRMATION_WINDOW_EXPIRED',
  RESERVATION_DOES_NOT_EXIST = 'RESERVATION_DOES_NOT_EXIST',
  RESERVATION_PREVIOUSLY_CANCELED = 'RESERVATION_PREVIOUSLY_CANCELED',
  TIMEZONE_CONVERSION_FAILED = 'TIMEZONE_CONVERSION_FAILED'
}

export type ResourceReservationConfirmationErrorResponse = {
  __typename: 'ResourceReservationConfirmationErrorResponse';
  detailedErrors: Array<ResourceReservationDetailedErrors>;
  errorCodes: Array<ResourceReservationConfirmationErrorCode>;
  id: Scalars['ID'];
};

export type ResourceReservationConfirmationResponse = ResourceReservationConfirmationErrorResponse | ResourceReservationConfirmationSuccessResponse;

export type ResourceReservationConfirmationSuccessResponse = {
  __typename: 'ResourceReservationConfirmationSuccessResponse';
  /** eventType is null when no state is updated but result is still successful */
  eventType: Maybe<Scalars['ID']>;
  reservationId: Scalars['ID'];
  /** value is -1 when no state is updated but result is still successful */
  value: Scalars['Int'];
};

export type ResourceReservationDetailedErrors = {
  __typename: 'ResourceReservationDetailedErrors';
  failureCode: ResourceReservationConfirmationErrorCode;
  meta: Maybe<Scalars['String']>;
};

export type ResourceReservationExclusion = {
  __typename: 'ResourceReservationExclusion';
  id: Scalars['ID'];
  localDateTimePairs: Array<LocalDateTimePair>;
  reservationId: Scalars['ID'];
  reservee: Scalars['ID'];
};

export type ResourceReservationGroupedByDayOfWeek = {
  __typename: 'ResourceReservationGroupedByDayOfWeek';
  dayOfWeek: RecurringReservationDayOfWeek;
  reservationIds: Array<Scalars['ID']>;
};

export type ResourceReservationInstancesResponseType = {
  __typename: 'ResourceReservationInstancesResponseType';
  id: Scalars['ID'];
  /** Cursor used to load the next set of resource instance reservations. Null is returned at end of set. */
  nextCursor: Maybe<Scalars['ID']>;
  reservationId: Scalars['ID'];
  resourceInstanceReservations: Array<ResourceReservation>;
  /** Total number of reservations instances contained in this reservation */
  totalReservationInstanceCount: Scalars['Int'];
};

export type ResourceReservationRecurringValidateResponseType = {
  __typename: 'ResourceReservationRecurringValidateResponseType';
  resourceId: Scalars['ID'];
  validationResponse: ResourceReservationValidationResponse;
};

export type ResourceReservationValidationFailure = {
  __typename: 'ResourceReservationValidationFailure';
  /** Only one field exists for now. This will probably change later so leaving room for additions. */
  failureType: ResourceReservationValidationFailureType;
  id: Scalars['ID'];
  meta: Maybe<Scalars['String']>;
};

export enum ResourceReservationValidationFailureType {
  BOOKING_OVERLAPS = 'BOOKING_OVERLAPS',
  CANT_BOOK_FROM_KIOSK = 'CANT_BOOK_FROM_KIOSK',
  EXCEEDS_ADVANCED_BOOKING_THRESHOLD = 'EXCEEDS_ADVANCED_BOOKING_THRESHOLD',
  EXCEEDS_MAXIMUM_BOOKING_LENGTH = 'EXCEEDS_MAXIMUM_BOOKING_LENGTH',
  INCOHERENT_REQUEST_TO_EDIT_RESERVATION_SERIES = 'INCOHERENT_REQUEST_TO_EDIT_RESERVATION_SERIES',
  INVALID_REQUEST_TO_EDIT_PAST_RECURRING_RESERVATION_INSTANCE = 'INVALID_REQUEST_TO_EDIT_PAST_RECURRING_RESERVATION_INSTANCE',
  INVALID_REQUEST_TO_RESCHEDULE_RECURRING_RESERVATION = 'INVALID_REQUEST_TO_RESCHEDULE_RECURRING_RESERVATION',
  INVALID_REQUEST_TO_RESCHEDULE_SINGLE_DAY_RESERVATION = 'INVALID_REQUEST_TO_RESCHEDULE_SINGLE_DAY_RESERVATION',
  MISSING_BOOKING_PERMISSION = 'MISSING_BOOKING_PERMISSION',
  OUTSIDE_OF_WORKING_HOURS = 'OUTSIDE_OF_WORKING_HOURS',
  RECURRENCE_NOT_ALLOWED = 'RECURRENCE_NOT_ALLOWED',
  RESERVATION_DOES_NOT_EXIST = 'RESERVATION_DOES_NOT_EXIST',
  RESERVATION_HAS_ENDED = 'RESERVATION_HAS_ENDED',
  RESERVATION_TYPE_NOT_ALLOWED = 'RESERVATION_TYPE_NOT_ALLOWED',
  RESOURCE_BUSY = 'RESOURCE_BUSY',
  RESOURCE_DOES_NOT_EXIST = 'RESOURCE_DOES_NOT_EXIST',
  SCHEDULE_DOES_NOT_EXIST = 'SCHEDULE_DOES_NOT_EXIST',
  VIOLATES_MAXIMUM_BOOKING_THRESHOLD = 'VIOLATES_MAXIMUM_BOOKING_THRESHOLD'
}

export type ResourceReservationValidationResponse = {
  __typename: 'ResourceReservationValidationResponse';
  errors: Array<ResourceReservationValidationFailure>;
  id: Scalars['ID'];
  policiesEvaluated: Array<PolicyType>;
  userHasPermissionToReserve: Scalars['Boolean'];
};

export type ResourceWeeklyBookingType = {
  __typename: 'ResourceWeeklyBookingType';
  friday: BookingStatus;
  monday: BookingStatus;
  saturday: BookingStatus;
  sunday: BookingStatus;
  thursday: BookingStatus;
  tuesday: BookingStatus;
  wednesday: BookingStatus;
};

export type ResourceWeeklyBookingTypeInput = {
  friday: BookingStatus;
  monday: BookingStatus;
  saturday: BookingStatus;
  sunday: BookingStatus;
  thursday: BookingStatus;
  tuesday: BookingStatus;
  wednesday: BookingStatus;
};

export type ReviewDraftChangesResponse = {
  __typename: 'ReviewDraftChangesResponse';
  v1: ReviewDraftChangesV1Payload;
  v2: Maybe<ReviewDraftV2Payload>;
};

export type ReviewDraftChangesV1Payload = {
  __typename: 'ReviewDraftChangesV1Payload';
  assignments: Maybe<Array<UserAssignmentData>>;
  deskStatistics: Maybe<DeskStatistics>;
  desksCount: Maybe<Scalars['Int']>;
  neighborhoods: Maybe<Array<NeighborhoodReviewModel>>;
  reservationsToCancel: Maybe<Array<Maybe<ReservationInfo>>>;
  settings: Maybe<SettingsComparison>;
};

export type ReviewDraftFloorPayload = {
  __typename: 'ReviewDraftFloorPayload';
  assignments: Maybe<Array<UserAssignmentData>>;
  changeSummary: Maybe<DraftChangeSummary>;
  deskStatistics: Maybe<DeskStatistics>;
  desksCount: Maybe<Scalars['Int']>;
  floor: Level;
  hasChanges: Scalars['Boolean'];
  neighborhoods: Maybe<Array<NeighborhoodReviewModel>>;
  reservationsToCancel: Maybe<Array<Maybe<ReservationInfo>>>;
  settings: Maybe<SettingsComparison>;
};

export type ReviewDraftResponse = {
  __typename: 'ReviewDraftResponse';
  deskStatistics: DeskStatistics;
  desksCount: Scalars['Int'];
  entities: Array<Entity>;
  reservationsToCancel: Maybe<Array<Maybe<ReservationInfo>>>;
};

export type ReviewDraftV2Payload = {
  __typename: 'ReviewDraftV2Payload';
  floors: Array<ReviewDraftFloorPayload>;
};

export type RipplingAccount = {
  __typename: 'RipplingAccount';
  id: Scalars['ID'];
};

export type RipplingWorkLocationWithMappingToRobinBuilding = {
  __typename: 'RipplingWorkLocationWithMappingToRobinBuilding';
  ripplingWorkLocationAddress: Maybe<Scalars['String']>;
  ripplingWorkLocationId: Scalars['ID'];
  ripplingWorkLocationName: Scalars['String'];
  robinBuildingId: Maybe<Scalars['ID']>;
};

export type RipplingWorkLocationsWithMappings = {
  __typename: 'RipplingWorkLocationsWithMappings';
  locationsWithMappings: Array<RipplingWorkLocationWithMappingToRobinBuilding>;
};

/** A place in Robin, and never an endpoint. Narrower than EndpointOrPlace on purpose: a relationship can point at another endpoint, but a PLACEMENT cannot — an endpoint is not somewhere by being inside another endpoint, it is somewhere by being in a room. These are place-service's entities, so asking for a name here joins to place-service in the same request. That is why a placement returns the place rather than a bare type and id: every screen that renders one wants the name, and a reference would make each of them pay for a second call. */
export type RobinPlace = Campus | Level | Location | Space;

export type RobinPlaceRefInput = {
  id: Scalars['ID'];
  type: RobinPlaceType;
};

export enum RobinPlaceType {
  CAMPUS = 'CAMPUS',
  LEVEL = 'LEVEL',
  LOCATION = 'LOCATION',
  SPACE = 'SPACE'
}

export type RobinUserInfoForSlack = {
  __typename: 'RobinUserInfoForSlack';
  token: Scalars['String'];
  userId: Scalars['ID'];
};

export type Role = {
  __typename: 'Role';
  created_at: Scalars['String'];
  description: Maybe<Scalars['String']>;
  is_default: Scalars['Boolean'];
  name: Maybe<Scalars['String']>;
  organization_id: Scalars['ID'];
  policies: Array<Policy>;
  /** `schedule` is used to distinguish access roles from other roles, and has value of null (which may have distinguished meaning from empty array) by default. */
  schedule: Maybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
  updated_at: Maybe<Scalars['String']>;
};

export type RoleCreationInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  policies?: InputMaybe<Array<RolePolicyInput>>;
  slug: Scalars['String'];
};

export type RolePermission = {
  __typename: 'RolePermission';
  action: QueryablePermissionAction;
  categoryId: Maybe<Scalars['ID']>;
  permit: Scalars['Boolean'];
  roleId: Scalars['ID'];
  target: PermissionHierarchyTarget;
  targetId: Scalars['ID'];
};

export enum RolePermissionAction {
  CUSTOM_RESOURCE_CREATE = 'CUSTOM_RESOURCE_CREATE'
}

export type RolePermissionCommand = {
  /** The actions permitted or denied by this permission */
  permissionActions: Array<RolePermissionAction>;
  /** The hierarchical grouping of resources to which this permission applies */
  permissionHierarchyTarget: PermissionHierarchyTarget;
  /** The ID of the hierarchical element that this permission applies */
  permissionHierarchyTargetId: Scalars['ID'];
  /** Whether the specified actions are permitted (true) or explicitly denied (false). */
  permit: Scalars['Boolean'];
  /** Role IDs to which this permission applies */
  roleIds: Array<Scalars['ID']>;
};

export type RolePolicyInput = {
  is_allowed: Scalars['Boolean'];
  object_id: Scalars['ID'];
  object_type?: InputMaybe<Scalars['String']>;
  permission_operation: Scalars['String'];
};

export type ScheduleRecurringReservationResponseType = ResourceReservationValidationResponse | ScheduleRecurringReservationSuccessType;

export type ScheduleRecurringReservationSuccessType = {
  __typename: 'ScheduleRecurringReservationSuccessType';
  /** eventType is null when no state is updated but result is still successful */
  eventType: Maybe<Scalars['ID']>;
  reservationId: Scalars['ID'];
  totalReservationEvents: Scalars['Int'];
  /** value is -1 when no state is updated but result is still successful */
  value: Scalars['Int'];
};

export type ScheduleSingleDayReservationResponseType = ResourceReservationValidationResponse | ScheduleSingleDayReservationSuccessType;

export type ScheduleSingleDayReservationSuccessType = {
  __typename: 'ScheduleSingleDayReservationSuccessType';
  /** eventType is null when no state is updated but result is still successful */
  eventType: Maybe<Scalars['ID']>;
  reservationId: Scalars['ID'];
  /** value is -1 when no state is updated but result is still successful */
  value: Scalars['Int'];
};

export enum ScheduleSourceType {
  GOOGLE = 'google',
  USER = 'user'
}

export type SchedulingAggregateOfDesks = {
  __typename: 'SchedulingAggregateOfDesks';
  /** Total number of desks of type Assigned that are available within the parent */
  deskAssignedAvailableTotal: Scalars['Int'];
  /** Total number of desks of type Assigned that are booked within the parent */
  deskAssignedBookedTotal: Scalars['Int'];
  /** Total number of desks of type Assigned within the parent */
  deskAssignedTotal: Scalars['Int'];
  /** Total number of desks of type Assigned that are unavailable within the parent */
  deskAssignedUnavailableTotal: Scalars['Int'];
  /** Total number of available desks within the parent */
  deskAvailableTotal: Scalars['Int'];
  /** Total number of booked desks within the parent */
  deskBookedTotal: Scalars['Int'];
  /** Total number of desks of type Hot that are available within the parent */
  deskHotAvailableTotal: Scalars['Int'];
  /** Total number of desks of type Hot that are booked within the parent */
  deskHotBookedTotal: Scalars['Int'];
  /** Total number of desks of type Hot within the parent */
  deskHotTotal: Scalars['Int'];
  /** Total number of desks of type Hot that are unavailable within the parent */
  deskHotUnavailableTotal: Scalars['Int'];
  /** Total number of desks of type Hotel that are available within the parent */
  deskHotelAvailableTotal: Scalars['Int'];
  /** Total number of desks of type Hotel that are booked within the parent */
  deskHotelBookedTotal: Scalars['Int'];
  /** Total number of desks of type Hotel within the parent */
  deskHotelTotal: Scalars['Int'];
  /** Total number of desks of type Hotel that are unavailable within the parent */
  deskHotelUnavailableTotal: Scalars['Int'];
  /** Total number of desks of type Shared that are available within the parent */
  deskSharedAvailableTotal: Scalars['Int'];
  /** Total number of desks of type Shared that are booked within the parent */
  deskSharedBookedTotal: Scalars['Int'];
  /** Total number of desks of type Shared within the parent */
  deskSharedTotal: Scalars['Int'];
  /** Total number of desks of type Shared that are unavailable within the parent */
  deskSharedUnavailableTotal: Scalars['Int'];
  /** Total number of unavailable desks within the parent */
  deskUnavailableTotal: Scalars['Int'];
};

export type SearchUsersInput = {
  /** Include disabled users in results (default: false) */
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
  /** Include total count in response (default: false, adds latency) */
  includeTotal?: InputMaybe<Scalars['Boolean']>;
  /** Maximum number of results to return (default: 15, max: 100) */
  limit?: InputMaybe<Scalars['Int']>;
  /** Offset for pagination (default: 0) */
  offset?: InputMaybe<Scalars['Int']>;
  /** Search query string. Omit to list all users in the organization. */
  query?: InputMaybe<Scalars['String']>;
};

export type SearchUsersResult = {
  __typename: 'SearchUsersResult';
  /** Whether more results are available */
  hasNextPage: Scalars['Boolean'];
  /** Offset for next page of results */
  nextPageOffset: Scalars['Int'];
  /** Total count of matching users (only populated if includeTotal=true) */
  totalCount: Maybe<Scalars['Int']>;
  /** List of matching users */
  users: Array<AccountUser>;
};

export type SendEmailToAffectedDraftUsersResult = {
  __typename: 'SendEmailToAffectedDraftUsersResult';
  failed: Scalars['Int'];
  sent: Scalars['Int'];
};

export type ServiceNowIntegration = TicketIntegration & {
  __typename: 'ServiceNowIntegration';
  baseUrl: Maybe<Scalars['String']>;
  createdAt: Scalars['ISODateTime'];
  /** When the integration stopped after its provider kept refusing its credentials; set only for DEACTIVATED. */
  deactivatedAt: Maybe<Scalars['ISODateTime']>;
  id: Scalars['ID'];
  /** @deprecated Use status. */
  isActive: Scalars['Boolean'];
  providerType: TicketProviderType;
  status: TicketIntegrationStatus;
  /** Which directions sync runs in; each can be switched off without disconnecting. */
  syncDirections: TicketIntegrationSyncDirections;
};

export type SetAutoDeskBookingInput = {
  autoDeskBooking: Scalars['Boolean'];
};

export type SetBuildingCidrsInput = {
  buildingId: Scalars['ID'];
  cidrs: Array<Scalars['IPAddressCIDR']>;
};

export type SetBuildingCidrsResponse = {
  __typename: 'SetBuildingCidrsResponse';
  buildingCidrsUpdated: Scalars['Boolean'];
  invalidCidrErrors: Array<InvalidCidrError>;
};

export type SetBuildingGeofenceAsPointWithRadiusInput = {
  buildingId: Scalars['ID'];
  center: SetBuildingGeofenceAsPointWithRadiusInputCenter;
  radius: Scalars['Float'];
};

export type SetBuildingGeofenceAsPointWithRadiusInputCenter = {
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type SetBuildingGeofenceAsPointWithRadiusResponse = {
  __typename: 'SetBuildingGeofenceAsPointWithRadiusResponse';
  uuid: Maybe<Scalars['ID']>;
};

export type SetMyHomepageInput = {
  homepage: HomepageType;
};

export type SetMyLanguageTagInput = {
  languageTag: Scalars['String'];
};

export type SetMyWorkingHoursInput = {
  workingHours: Array<UserWorkingHourInput>;
};

export type SetOrganizationNotificationSettingInput = {
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  values: Array<InputMaybe<NotificationSettingType>>;
};

export type SetPassiveCheckInFeatureForBuildingInput = {
  buildingId: Scalars['ID'];
};

export type SetShowWeekendsForMeInput = {
  showWeekends: Scalars['Boolean'];
};

export enum SetTicketIntegrationDefaultTargetConfigErrorReason {
  NOT_FOUND = 'NOT_FOUND',
  TARGET_CONFIG_NOT_FOUND = 'TARGET_CONFIG_NOT_FOUND'
}

export type SetTicketIntegrationDefaultTargetConfigErrorResponse = {
  __typename: 'SetTicketIntegrationDefaultTargetConfigErrorResponse';
  reason: SetTicketIntegrationDefaultTargetConfigErrorReason;
};

export type SetTicketIntegrationDefaultTargetConfigInput = {
  integrationId: Scalars['ID'];
  targetConfigId: Scalars['ID'];
};

export type SetTicketIntegrationDefaultTargetConfigResponse = SetTicketIntegrationDefaultTargetConfigErrorResponse | SetTicketIntegrationDefaultTargetConfigSuccessResponse;

export type SetTicketIntegrationDefaultTargetConfigSuccessResponse = {
  __typename: 'SetTicketIntegrationDefaultTargetConfigSuccessResponse';
  targetConfigs: Array<TicketIntegrationTargetConfig>;
};

export enum SetTicketIntegrationSyncDirectionsErrorReason {
  NOT_FOUND = 'NOT_FOUND'
}

export type SetTicketIntegrationSyncDirectionsErrorResponse = {
  __typename: 'SetTicketIntegrationSyncDirectionsErrorResponse';
  reason: SetTicketIntegrationSyncDirectionsErrorReason;
};

export type SetTicketIntegrationSyncDirectionsInput = {
  /** Provider changes brought into Robin. */
  inbound?: InputMaybe<Scalars['Boolean']>;
  integrationId: Scalars['ID'];
  /** Robin changes sent to the provider. */
  outbound?: InputMaybe<Scalars['Boolean']>;
};

export type SetTicketIntegrationSyncDirectionsResponse = SetTicketIntegrationSyncDirectionsErrorResponse | SetTicketIntegrationSyncDirectionsSuccessResponse;

export type SetTicketIntegrationSyncDirectionsSuccessResponse = {
  __typename: 'SetTicketIntegrationSyncDirectionsSuccessResponse';
  syncDirections: TicketIntegrationSyncDirections;
};

export enum SetTicketIntegrationTargetConfigTransitionFieldsErrorReason {
  NOT_FOUND = 'NOT_FOUND',
  TARGET_CONFIG_NOT_FOUND = 'TARGET_CONFIG_NOT_FOUND'
}

export type SetTicketIntegrationTargetConfigTransitionFieldsErrorResponse = {
  __typename: 'SetTicketIntegrationTargetConfigTransitionFieldsErrorResponse';
  reason: SetTicketIntegrationTargetConfigTransitionFieldsErrorReason;
};

export type SetTicketIntegrationTargetConfigTransitionFieldsInput = {
  externalStatusId: Scalars['ID'];
  fields: Array<TicketIntegrationTransitionFieldValueInput>;
  integrationId: Scalars['ID'];
  targetConfigId: Scalars['ID'];
};

export type SetTicketIntegrationTargetConfigTransitionFieldsResponse = SetTicketIntegrationTargetConfigTransitionFieldsErrorResponse | SetTicketIntegrationTargetConfigTransitionFieldsSuccessResponse;

export type SetTicketIntegrationTargetConfigTransitionFieldsSuccessResponse = {
  __typename: 'SetTicketIntegrationTargetConfigTransitionFieldsSuccessResponse';
  targetConfig: TicketIntegrationTargetConfig;
};

export enum SetTicketIntegrationWorkflowBindingErrorReason {
  NOT_ACTIVE = 'NOT_ACTIVE',
  NOT_FOUND = 'NOT_FOUND',
  TARGET_CONFIG_NOT_FOUND = 'TARGET_CONFIG_NOT_FOUND',
  /** No such workflow, or it is not an issue report workflow. */
  WORKFLOW_NOT_FOUND = 'WORKFLOW_NOT_FOUND'
}

export type SetTicketIntegrationWorkflowBindingErrorResponse = {
  __typename: 'SetTicketIntegrationWorkflowBindingErrorResponse';
  reason: SetTicketIntegrationWorkflowBindingErrorReason;
};

export type SetTicketIntegrationWorkflowBindingInput = {
  integrationId: Scalars['ID'];
  /** Null = the integration's default target config. */
  targetConfigId?: InputMaybe<Scalars['ID']>;
  workflowId: Scalars['ID'];
};

export type SetTicketIntegrationWorkflowBindingResponse = SetTicketIntegrationWorkflowBindingErrorResponse | SetTicketIntegrationWorkflowBindingSuccessResponse;

export type SetTicketIntegrationWorkflowBindingSuccessResponse = {
  __typename: 'SetTicketIntegrationWorkflowBindingSuccessResponse';
  workflowBinding: TicketIntegrationWorkflowBinding;
};

export type SetUserNotificationSettingInput = {
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  values: Array<InputMaybe<NotificationSettingType>>;
};

export type SetWeeklyScheduleInput = {
  fri: Scalars['Boolean'];
  id?: InputMaybe<Scalars['ID']>;
  instanceEndTime?: InputMaybe<Scalars['LocalEndTime']>;
  instanceStartTime?: InputMaybe<Scalars['LocalEndTime']>;
  locationId: Scalars['String'];
  mon: Scalars['Boolean'];
  recurrenceEndDate?: InputMaybe<Scalars['LocalDate']>;
  recurrenceStartDate?: InputMaybe<Scalars['LocalDate']>;
  sat: Scalars['Boolean'];
  source: ScheduleSourceType;
  sun: Scalars['Boolean'];
  thu: Scalars['Boolean'];
  tue: Scalars['Boolean'];
  userId: Scalars['String'];
  wed: Scalars['Boolean'];
};

export type Setting = {
  __typename: 'Setting';
  slug: Scalars['String'];
  value: Scalars['String'];
};

export type SettingChange = {
  __typename: 'SettingChange';
  next: Scalars['Boolean'];
  previous: Scalars['Boolean'];
};

export enum SettingDataType {
  BOOLEAN = 'BOOLEAN',
  INTEGER = 'INTEGER',
  JSON = 'JSON',
  STRING = 'STRING'
}

export type SettingInput = {
  type: Scalars['String'];
  value: Scalars['String'];
};

export enum SettingOwnerType {
  USER = 'USER'
}

export enum SettingValueType {
  BOOLEAN = 'boolean',
  NUMBER = 'number',
  STRING = 'string'
}

export type SettingsComparison = {
  __typename: 'SettingsComparison';
  showNeighborhoodColor: Maybe<SettingChange>;
};

export type SharedDeskSchedule = {
  __typename: 'SharedDeskSchedule';
  id: Scalars['ID'];
  schedule: Array<DeskSchedule>;
};

export type SharedDeskSchedulesInput = {
  deskId: Scalars['ID'];
  notifyUnassigned: Scalars['Boolean'];
  sharedSchedules: Array<SharedScheduleInput>;
};

export type SharedScheduleInput = {
  email?: InputMaybe<Scalars['String']>;
  recurrence: Scalars['String'];
  userId?: InputMaybe<Scalars['ID']>;
};

export type ShowNeighborhoodColorSetting = {
  __typename: 'ShowNeighborhoodColorSetting';
  id: Scalars['ID'];
  value: Scalars['Boolean'];
};

export enum SigmaEmbedType {
  CREATOR = 'CREATOR',
  VIEWER = 'VIEWER'
}

export type SigmaEmbedUrl = {
  __typename: 'SigmaEmbedUrl';
  url: Maybe<Scalars['String']>;
};

export type SigmaFile = {
  __typename: 'SigmaFile';
  badge: Scalars['String'];
  createdAt: Scalars['String'];
  createdBy: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
  isArchived: Scalars['Boolean'];
  name: Scalars['String'];
  parentId: Scalars['String'];
  parentUrlId: Scalars['String'];
  path: Scalars['String'];
  permission: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['String'];
  updatedBy: Scalars['String'];
  urlId: Scalars['String'];
};

export enum SigmaLocationType {
  PERSONAL = 'PERSONAL',
  SHARED = 'SHARED'
}

export type SigmaTag = {
  __typename: 'SigmaTag';
  name: Scalars['String'];
  versionTagId: Scalars['String'];
};

export type SigmaWorkbook = {
  __typename: 'SigmaWorkbook';
  createdAt: Scalars['String'];
  createdBy: Scalars['String'];
  isArchived: Scalars['Boolean'];
  latestVersion: Scalars['Int'];
  name: Scalars['String'];
  path: Scalars['String'];
  tags: Maybe<Array<Maybe<SigmaTag>>>;
  updatedAt: Scalars['String'];
  updatedBy: Scalars['String'];
  url: Scalars['String'];
  workbookId: Scalars['String'];
  workbookUrlId: Scalars['String'];
};

export type SimpleLocation = {
  __typename: 'SimpleLocation';
  accountId: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  remoteGoogleId: Maybe<Scalars['String']>;
  remoteGoogleLabel: Maybe<Scalars['String']>;
  timeZone: Maybe<Scalars['String']>;
  /** Stable identifier from robin-api, as 32 lowercase hex characters. Null for records that have not been assigned one yet. */
  uuid: Maybe<Scalars['ID']>;
};

export type SlotAttendance = {
  __typename: 'SlotAttendance';
  availableCount: Scalars['Int'];
  availableInvitees: Array<InviteeRef>;
  organizerInWorkingHours: Scalars['Boolean'];
  /** Invitees free but outside their configured working hours. */
  outsideWorkingHoursInvitees: Array<InviteeRef>;
  totalSoftInvitees: Scalars['Int'];
  /** Soft invitees with a busy conflict at this slot. */
  unavailableInvitees: Array<InviteeRef>;
};

export enum SnapTo {
  FIFTEEN = 'FIFTEEN',
  SIXTY = 'SIXTY',
  THIRTY = 'THIRTY',
  ZERO = 'ZERO'
}

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

/** The order with which to sort */
export enum SortOrder {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING'
}

export type Space = {
  __typename: 'Space';
  amenities: Array<SpaceAmenity>;
  /** Availability of space for the next half hour. GREEN: available for the next half hour. YELLOW: event scheduled within the next thirty minutes. RED: Event currently being held */
  availableAt: Maybe<Availability>;
  behaviors: Array<Scalars['String']>;
  calendar: Maybe<Calendar>;
  /** Capacity is unsigned 32bit integer. */
  capacity: Maybe<Scalars['BigInt']>;
  /** @deprecated Deprecated in favor of confirmedAvailabilityMultiDay */
  confirmedAvailability: Maybe<SpaceAvailability>;
  confirmedAvailabilityMultiDay: Maybe<SpaceAvailability>;
  createdAt: Maybe<Scalars['Date']>;
  /** Whether the current user can request meeting services in this space. Note that this does not check if the user has permission to modify the event. This is okay if the user is working on a draft event, because they will be the organizer and have permission to do anything to that event. See currentUserCanRequestMeetingServicesForEvent. */
  currentUserCanRequestMeetingServices: Maybe<Scalars['Boolean']>;
  currentUserCanRequestMeetingServicesForEvent: Maybe<Scalars['Boolean']>;
  description: Maybe<Scalars['String']>;
  /** @deprecated Deprecated because this field is no longer retrievable from API */
  disabledAt: Maybe<Scalars['Date']>;
  discoveryRadius: Maybe<Scalars['Float']>;
  /** Endpoints that resolve into this Space. This is the "endpoints by space" convenience. It walks the same resolution the tenant-wide endpoint list does, so asking for many Spaces in one query costs what asking for the tenant costs — prefer endpoints when you want more than a handful. */
  endpoints: Array<Endpoint>;
  eventWithCheckInStatus: Maybe<EventWithCheckInStatus>;
  /** The events booked into this space between startTime and endTime, with their invitees — who is affected if the room becomes unusable. Bookings the caller may not see in full are still returned: robin-api gives them the title "Reserved" and an empty invitee list rather than dropping the row, so "something is booked at 2pm that I cannot identify" stays distinguishable from "nothing is booked". Only private and confidential events are masked this way; personal ones are returned in full. Ranges longer than 31 days are rejected. */
  events: Array<Event>;
  filteredDesksByAmenityIds: Array<Desk>;
  hasAnyAvailableMeetingServices: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  image: Maybe<Scalars['String']>;
  isAccessible: Maybe<Scalars['Boolean']>;
  isDisabled: Maybe<Scalars['Boolean']>;
  isManaged: Scalars['Boolean'];
  /** The number of unresolved issue reports regarding this space (issueReportStatus TODO, IN_PROGRESS, or BLOCKED). Any user who can see the space can see this count; the reports themselves (description, reporter, etc.) require issue report visibility - see listIssueReports. Finer-grained filtering would come as arguments on this field, not more fields. Intentionally nullable in case Ticket service is down. */
  issueReportCount: Maybe<Scalars['Int']>;
  /** The highest priority among the unresolved issue reports counted by issueReportCount - the one a map pin should take its colour from. Null when there are none, and when Ticket service is down. Same visibility as issueReportCount: anyone who can see the space can see it. */
  issueReportMaxPriority: Maybe<TicketPriority>;
  legacyAvailableWorkplaceServiceTypes: Array<Scalars['String']>;
  levelId: Maybe<Scalars['ID']>;
  locationId: Scalars['Int'];
  meetingRoomWindowedAvailability: Array<SpaceWindowAvailability>;
  /** Returns non-cancelled meeting service requests for this space on the given event. Excludes draft requests, except those requested by the current user. null if current user lacks permission to see requests */
  meetingServiceRequests: Maybe<Array<MeetingServiceRequest>>;
  /**
   * null if current user lacks permission to see requests
   * @deprecated Use meetingServiceRequests instead
   */
  meetingServiceRequestsForDraftEvent: Maybe<Array<MeetingServiceRequest>>;
  name: Scalars['String'];
  permissions: Array<Permission>;
  /** A MeetingService with kind=SPACE_REQUEST_FORM that describes the form that must be completed in order to request a space with scheduleConfiguration=REQUEST_ONLY. Clients should disallow events from being created without this form being filled out. The completed form for a given space/event can be found with Space.meetingServiceRequests. */
  requestForm: Maybe<MeetingService>;
  reservationPolicies: SpaceReservationPolicies;
  scheduleConfiguration: Maybe<SpaceScheduleConfiguration>;
  /** The total price of all meeting service requests in this space during the given event, after any surcharges/taxes. Multiple prices can be returned if the service requests are in different currencies - no currency conversion happens. Currency codes are unique. Empty list if none of the meeting service requests have prices. */
  totalPriceOfMeetingServiceRequests: Maybe<Array<Money>>;
  type: Maybe<SpaceType>;
  updatedAt: Maybe<Scalars['Date']>;
  /** Stable identifier from robin-api, as 32 lowercase hex characters. */
  uuid: Scalars['ID'];
  /** @deprecated Deprecated in favor of meetingRoomWindowedAvailability */
  windowedAvailability: Array<SpaceWindowAvailability>;
  zones: Array<Zone>;
};


export type SpaceAvailableAtArgs = {
  time?: InputMaybe<Scalars['Date']>;
};


export type SpaceConfirmedAvailabilityArgs = {
  durationInMinutes?: InputMaybe<Scalars['Int']>;
  time?: InputMaybe<Scalars['ISODateTime']>;
};


export type SpaceConfirmedAvailabilityMultiDayArgs = {
  dates?: InputMaybe<Array<InputMaybe<Scalars['ISODateTime']>>>;
  durationInMinutes?: InputMaybe<Scalars['Int']>;
  time?: InputMaybe<Scalars['ISODateTime']>;
};


export type SpaceCurrentUserCanRequestMeetingServicesForEventArgs = {
  eventInstance: EventInstanceReference;
};


export type SpaceEventsArgs = {
  endTime: Scalars['Date'];
  startTime: Scalars['Date'];
};


export type SpaceFilteredDesksByAmenityIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type SpaceMeetingRoomWindowedAvailabilityArgs = {
  firstWindowSplit?: InputMaybe<SnapTo>;
  meetingDurationInMinutes?: InputMaybe<Scalars['Int']>;
  numberOfWindows?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Date']>;
};


export type SpaceMeetingServiceRequestsArgs = {
  eventInstance: EventInstanceReference;
};


export type SpaceMeetingServiceRequestsForDraftEventArgs = {
  eventUid: Scalars['UUIDv4'];
  recurrenceId?: InputMaybe<Scalars['ID']>;
};


export type SpaceTotalPriceOfMeetingServiceRequestsArgs = {
  eventInstance: EventInstanceReference;
};


export type SpaceWindowedAvailabilityArgs = {
  firstWindowSplit?: InputMaybe<SnapTo>;
  intervalInMinutes?: InputMaybe<Scalars['Int']>;
  meetingDurationInMinutes?: InputMaybe<Scalars['Int']>;
  numberOfWindows?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Date']>;
};

export type SpaceAmenity = {
  __typename: 'SpaceAmenity';
  amenityId: Maybe<Scalars['Int']>;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  name: Scalars['String'];
  quantity: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

export enum SpaceAvailability {
  /** Currently available */
  AVAILABLE = 'AVAILABLE',
  /** Resource has been booked and confirmed */
  BOOKED_CONFIRMED = 'BOOKED_CONFIRMED',
  /** Resource has been booked and not confirmed */
  BOOKED_UNCONFIRMED = 'BOOKED_UNCONFIRMED',
  /** Resource marked as unavailable for booking */
  UNAVAILABLE = 'UNAVAILABLE',
  /** Resource schedule not found */
  UNKNOWN = 'UNKNOWN'
}

export type SpaceCalendar = {
  __typename: 'SpaceCalendar';
  calendarId: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  isHealthy: Maybe<Scalars['Boolean']>;
  lastNotifiedAt: Maybe<Scalars['String']>;
  lastSyncedAt: Maybe<Scalars['String']>;
  location: Maybe<Location>;
  remoteType: Scalars['String'];
  space: Maybe<Space>;
  spaceResourceEmail: Maybe<Scalars['String']>;
  spaceResourceId: Maybe<Scalars['String']>;
  subscriberChannelId: Maybe<Scalars['String']>;
  subscriberExpiresAt: Maybe<Scalars['String']>;
  subscriberId: Maybe<Scalars['String']>;
  subscriptionAttempts: Scalars['Int'];
};

/** Input type for filtering space calendars */
export type SpaceCalendarFiltersInput = {
  /** Filter by calendar health status */
  calendarHealth?: InputMaybe<CalendarHealthEnum>;
  /** Filter by whether space has an associated resource */
  hasResource?: InputMaybe<Scalars['Boolean']>;
  /** Filter by disabled status */
  isDisabled?: InputMaybe<Scalars['Boolean']>;
  /** Filter by level ID */
  levelId?: InputMaybe<Scalars['String']>;
  /** Filter by location ID */
  locationId?: InputMaybe<Scalars['String']>;
  /** Filter by remote calendar type */
  remoteType?: InputMaybe<RemoteTypeEnum>;
  /** Filter by space name (case-insensitive partial match) */
  spaceName?: InputMaybe<Scalars['String']>;
};

export type SpaceCalendarResponse = {
  __typename: 'SpaceCalendarResponse';
  calendarInfo: Array<SpaceCalendar>;
  offset: Scalars['Int'];
  total: Scalars['Int'];
};

export enum SpaceFilters {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
  SCHEDULING = 'SCHEDULING'
}

export type SpaceReservationPolicies = {
  __typename: 'SpaceReservationPolicies';
  /** Automatically remove ghost meetings from the room's calendar if nobody checks in. */
  abandonedMeetingProtection: Scalars['Boolean'];
  /** Time to wait before an unconfirmed meeting is canceled. */
  abandonedThreshold: Scalars['ISO8601Duration'];
  /** Restrict how far in advance this space can be booked. */
  advanceBookingThreshold: Maybe<Scalars['ISO8601Duration']>;
  allowRecurringEvents: Scalars['Boolean'];
  id: Scalars['ID'];
  maxReservationLength: Maybe<Scalars['ISO8601Duration']>;
  /** Show a check-in button for each meeting */
  meetingCheckins: Scalars['Boolean'];
  restrictBookingToWorkingHours: Scalars['Boolean'];
  /** The number of consecutive abandoned meetings before the space is permanently removed from the series. */
  strikesForRecurringEvents: Maybe<Scalars['Int']>;
};

export enum SpaceScheduleConfiguration {
  ON_DEMAND = 'ON_DEMAND',
  REQUEST_ONLY = 'REQUEST_ONLY',
  SCHEDULED = 'SCHEDULED'
}

export type SpaceSearchHit = GlobalSearchHit & {
  __typename: 'SpaceSearchHit';
  displayName: Scalars['String'];
  entityId: Scalars['ID'];
  entityType: GlobalSearchEntityType;
  id: Scalars['ID'];
  levelId: Maybe<Scalars['ID']>;
  levelName: Maybe<Scalars['String']>;
  locationId: Scalars['ID'];
  locationName: Maybe<Scalars['String']>;
  score: Scalars['Float'];
};

export enum SpaceType {
  BREAKOUT = 'BREAKOUT',
  BREAK_ROOM = 'BREAK_ROOM',
  CAFE = 'CAFE',
  CAFETERIA = 'CAFETERIA',
  CALL = 'CALL',
  CLASSROOM = 'CLASSROOM',
  CONFERENCE = 'CONFERENCE',
  EVENT = 'EVENT',
  FITNESS = 'FITNESS',
  HUDDLE = 'HUDDLE',
  INTERVIEW = 'INTERVIEW',
  KITCHEN = 'KITCHEN',
  LAB = 'LAB',
  LACTATION = 'LACTATION',
  LISTENING = 'LISTENING',
  LOBBY = 'LOBBY',
  LOUNGE = 'LOUNGE',
  MEETING = 'MEETING',
  OFFICE = 'OFFICE',
  OTHER = 'OTHER',
  PARKING = 'PARKING',
  PROJECT = 'PROJECT',
  RESTROOM = 'RESTROOM',
  RESTROOM_FEMALE = 'RESTROOM_FEMALE',
  RESTROOM_MALE = 'RESTROOM_MALE',
  STUDIO = 'STUDIO',
  STUDY_ROOM = 'STUDY_ROOM',
  THEATER = 'THEATER',
  UTILITY = 'UTILITY',
  WORK = 'WORK'
}

export type SpaceWindowAvailability = {
  __typename: 'SpaceWindowAvailability';
  end: Maybe<Scalars['Date']>;
  isConfirmed: Maybe<Scalars['Boolean']>;
  /** @deprecated Deprecated because the end becomes representing the pillEnd */
  pillEnd: Maybe<Scalars['Date']>;
  start: Maybe<Scalars['Date']>;
  status: Maybe<Availability>;
  unbookableReasons: Array<Maybe<UnbookableReasonType>>;
};

/** A stack-planning exercise: the intent and scope of a replan for one building. It owns allocation revisions and holds no desks or assignments itself, so it never appears in a drafts listing and is not publishable. A stack plan can exist with no allocations and no scenario drafts under it. */
export type StackPlan = {
  __typename: 'StackPlan';
  /** The caller's level on this plan: editor for somebody who can plan its building, otherwise the level it was shared with them at. */
  accessLevel: Maybe<DraftAccessLevel>;
  /** The building this plan covers. A stack plan never spans buildings. */
  buildingId: Scalars['ID'];
  description: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastUpdated: Maybe<DraftAuditInfo>;
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  owner: Maybe<DraftAuditInfo>;
  status: DraftStatus;
  /** Pass back when updating a variation, so a concurrent edit is not silently overwritten. */
  version: Scalars['Int'];
};

/** One named variation of how many seats each business unit needs across a building. A stack plan holds as many of these as it is weighing. */
export type StackPlanAllocation = {
  __typename: 'StackPlanAllocation';
  businessUnits: Array<BusinessUnitAllocation>;
  description: Maybe<Scalars['String']>;
  /** Identifies this variation. An allocation draft implementing it copies this id. */
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type StandardWorkingHours = DateSpecificWorkingHours & {
  __typename: 'StandardWorkingHours';
  date: Scalars['Date'];
  timeFrames: Array<TimeFrame>;
};

export enum StartTicketIntegrationObjectImportErrorReason {
  NOT_ACTIVE = 'NOT_ACTIVE',
  NOT_FOUND = 'NOT_FOUND'
}

export type StartTicketIntegrationObjectImportErrorResponse = {
  __typename: 'StartTicketIntegrationObjectImportErrorResponse';
  reason: StartTicketIntegrationObjectImportErrorReason;
};

export type StartTicketIntegrationObjectImportResponse = StartTicketIntegrationObjectImportErrorResponse | StartTicketIntegrationObjectImportSuccessResponse;

export type StartTicketIntegrationObjectImportSuccessResponse = {
  __typename: 'StartTicketIntegrationObjectImportSuccessResponse';
  /** False when this call joined a run that was already in flight rather than starting one. A joined run can be narrower than the full fetch this mutation asks for (an assignment save starts class-scoped runs), so a client showing "re-syncing everything" should check this. */
  created: Scalars['Boolean'];
  /** The classes the joined run is scoped to, or null when it fetches the whole estate. */
  scopedToClassIds: Maybe<Array<Scalars['ID']>>;
  /** The started (or joined in-flight) run's status. */
  status: TicketIntegrationObjectImportStatus;
};

export type Statistics = {
  __typename: 'Statistics';
  assigned: Maybe<Scalars['Int']>;
  assignedBookability: Maybe<AssignedBookability>;
  assignedToUsers: Maybe<Scalars['Int']>;
  available: Maybe<Scalars['Int']>;
  hot: Maybe<Scalars['Int']>;
  hoteled: Maybe<Scalars['Int']>;
  notAssignedToUsers: Maybe<Scalars['Int']>;
  unavailable: Maybe<Scalars['Int']>;
};

export type Sticker = {
  __typename: 'Sticker';
  /** @deprecated Use associatedType + associatedId instead */
  associatedDeskId: Maybe<Scalars['ID']>;
  associatedId: Maybe<Scalars['ID']>;
  associatedType: Maybe<StickerTargetType>;
  batchId: Scalars['ID'];
  /** @deprecated Deprecated due to the potential circular queries that can be made via the fields on this type. Please use the `associatedDeskId` field and make a second query for desk information. */
  desk: Maybe<Desk>;
  displayCode: Scalars['Int'];
  id: Scalars['ID'];
  shortCode: Scalars['String'];
  shortUrl: Scalars['String'];
};

export type StickerAssignment = {
  __typename: 'StickerAssignment';
  seatId: Scalars['Int'];
  stickerId: Scalars['ID'];
};

export type StickerAssignmentInput = {
  seatId: Scalars['Int'];
  stickerId: Scalars['ID'];
};

export type StickerBatch = {
  __typename: 'StickerBatch';
  id: Scalars['ID'];
  stickers: Array<Sticker>;
};

export enum StickerTargetType {
  CUSTOM_RESOURCE = 'CUSTOM_RESOURCE',
  DESK = 'DESK'
}

export type SubcategoryUpdatePairInput = {
  newValue: Scalars['CustomResourceSubCategoryType'];
  oldValue: Scalars['CustomResourceSubCategoryType'];
};

export enum SuggestTicketIntegrationFieldMappingsErrorReason {
  NOT_ACTIVE = 'NOT_ACTIVE',
  NOT_CONNECTED = 'NOT_CONNECTED',
  NOT_FOUND = 'NOT_FOUND',
  PROVIDER_CAPABILITY_MISSING = 'PROVIDER_CAPABILITY_MISSING',
  PROVIDER_REJECTED = 'PROVIDER_REJECTED',
  PROVIDER_UNREACHABLE = 'PROVIDER_UNREACHABLE',
  TARGET_CONFIG_NOT_FOUND = 'TARGET_CONFIG_NOT_FOUND',
  WORKFLOW_NOT_FOUND = 'WORKFLOW_NOT_FOUND'
}

export type SuggestTicketIntegrationFieldMappingsErrorResponse = {
  __typename: 'SuggestTicketIntegrationFieldMappingsErrorResponse';
  reason: SuggestTicketIntegrationFieldMappingsErrorReason;
};

export type SuggestTicketIntegrationFieldMappingsResponse = SuggestTicketIntegrationFieldMappingsErrorResponse | SuggestTicketIntegrationFieldMappingsSuccessResponse;

export type SuggestTicketIntegrationFieldMappingsSuccessResponse = {
  __typename: 'SuggestTicketIntegrationFieldMappingsSuccessResponse';
  suggestions: Array<TicketIntegrationSuggestedFieldMapping>;
};

export type SuggestedDesk = {
  __typename: 'SuggestedDesk';
  desk: Desk;
  locationId: Scalars['String'];
  organizationId: Scalars['String'];
  score: Maybe<Scalars['Int']>;
  userId: Scalars['String'];
};

export type SuggestedMeetingTimesEditContextInput = {
  currentEndTime: Scalars['ISODateTime'];
  currentStartTime: Scalars['ISODateTime'];
  eventId: Scalars['String'];
  uid?: InputMaybe<Scalars['String']>;
};

export type SuggestedMeetingTimesInput = {
  /** Optional ranking anchor. When present, slots closest to this time rank higher. */
  draftStartTime?: InputMaybe<Scalars['ISODateTime']>;
  durationMinutes: Scalars['Int'];
  /** Edit-mode: lets the server strip the event under edit from everyone's busy. */
  editContext?: InputMaybe<SuggestedMeetingTimesEditContextInput>;
  /** Soft participants. Excludes the organizer. Conflicts here never remove a slot. */
  inviteeEmails: Array<Scalars['String']>;
  /** Create-mode skip signals. Server cannot infer these without an event. */
  isAllDay: Scalars['Boolean'];
  isRecurring: Scalars['Boolean'];
  /** Authenticated user's email. HARD constraint: organizer must be free. */
  organizerEmail: Scalars['String'];
  searchWindow: SuggestedMeetingTimesWindowInput;
  /** IANA timezone for the event. Output slots are presented in this zone. */
  timeZone: Scalars['IANATimezone'];
};

export type SuggestedMeetingTimesResult = {
  __typename: 'SuggestedMeetingTimesResult';
  algorithm: Scalars['String'];
  /** Invitees whose free/busy could not be fetched (isolated, non-fatal failures). */
  fetchFailures: Array<InviteeFetchFailure>;
  partialResults: Scalars['Boolean'];
  searchWindowUsed: SuggestedMeetingTimesWindow;
  skippedReason: Maybe<SuggestionSkipReason>;
  suggestions: Array<SuggestedTimeSlot>;
};

export type SuggestedMeetingTimesWindow = {
  __typename: 'SuggestedMeetingTimesWindow';
  from: Scalars['ISODateTime'];
  to: Scalars['ISODateTime'];
};

export type SuggestedMeetingTimesWindowInput = {
  from: Scalars['ISODateTime'];
  to: Scalars['ISODateTime'];
};

export type SuggestedSpaceForEvent = {
  __typename: 'SuggestedSpaceForEvent';
  eventId: Scalars['ID'];
  space: Maybe<Space>;
  suggestedSpaceRecordId: Maybe<Scalars['String']>;
};

export type SuggestedTimeSlot = {
  __typename: 'SuggestedTimeSlot';
  attendance: SlotAttendance;
  bylines: Array<SuggestionByline>;
  endTime: Scalars['ISODateTime'];
  rank: Scalars['Int'];
  /** Desirability heuristic in [0,1]. Not a conflict-confidence score (unlike legacy). */
  score: Scalars['Float'];
  startTime: Scalars['ISODateTime'];
};

export type SuggestionByline = {
  __typename: 'SuggestionByline';
  code: SuggestionBylineCode;
  /** Which invitees this byline concerns (empty for organizer-only bylines). */
  invitees: Array<InviteeRef>;
  message: Scalars['String'];
};

export enum SuggestionBylineCode {
  INVITEE_ALL_DAY_EVENT = 'INVITEE_ALL_DAY_EVENT',
  INVITEE_BUSY = 'INVITEE_BUSY',
  ORGANIZER_OUTSIDE_WORKING_HOURS = 'ORGANIZER_OUTSIDE_WORKING_HOURS',
  OUTSIDE_USER_WORKING_HOURS = 'OUTSIDE_USER_WORKING_HOURS'
}

export enum SuggestionSkipReason {
  ALL_DAY_EVENT = 'ALL_DAY_EVENT',
  EVENT_IN_PAST = 'EVENT_IN_PAST',
  INVALID_DURATION = 'INVALID_DURATION',
  NO_INVITEES = 'NO_INVITEES',
  NO_ORGANIZER_AVAILABILITY = 'NO_ORGANIZER_AVAILABILITY',
  RECURRING_EVENT = 'RECURRING_EVENT',
  TOO_MANY_INVITEES = 'TOO_MANY_INVITEES'
}

/** Survey configuration */
export type Survey = {
  __typename: 'Survey';
  /** Boolean value indicating if the survey allows anonymous responses */
  allowAnonymous: Scalars['Boolean'];
  /** List of buildings associated with the survey */
  buildings: Maybe<Array<Maybe<Location>>>;
  /** Date the survey was created */
  createdAt: Scalars['ISODateTime'];
  /** User that created the survey */
  createdBy: User;
  /** Unique identifier */
  id: Scalars['ID'];
  /** Boolean value indicating if the survey is active */
  isActive: Scalars['Boolean'];
  /** Survey name */
  name: Scalars['String'];
  /** Organization associated with the survey */
  organization: Organization;
  /** Date the survey was last updated */
  updatedAt: Scalars['ISODateTime'];
  /** User that last updated the survey */
  updatedBy: User;
};

/** Survey configuration without building links */
export type SurveyEdge = {
  __typename: 'SurveyEdge';
  /** Boolean value indicating if the survey allows anonymous responses */
  allowAnonymous: Scalars['Boolean'];
  /** Date the survey was created */
  createdAt: Scalars['ISODateTime'];
  /** User that created the survey */
  createdBy: User;
  /** Unique identifier */
  id: Scalars['ID'];
  /** Boolean value indicating if the survey is active */
  isActive: Scalars['Boolean'];
  /** Survey name */
  name: Scalars['String'];
  /** Organization associated with the survey */
  organization: Organization;
  /** Date the survey was last updated */
  updatedAt: Scalars['ISODateTime'];
  /** User that last updated the survey */
  updatedBy: User;
};

/** Response to a sentiment survey */
export type SurveyResponse = {
  __typename: 'SurveyResponse';
  /** Building of the reservation */
  building: Maybe<Location>;
  /** Response comment */
  comment: Maybe<Scalars['String']>;
  /** Date the response was created */
  createdAt: Scalars['ISODateTime'];
  /** Unique identifier */
  id: Scalars['ID'];
  /** Date the user was in the office */
  inOfficeAt: Scalars['ISODateTime'];
  /** Boolean that indicates if the response was anonymous */
  isAnonymous: Scalars['Boolean'];
  /** Organization associated with the survey response */
  organization: Organization;
  /** Sentiment rating */
  rating: Maybe<Scalars['Int']>;
  /** Reservation associated with the survey response */
  reservation: Maybe<Reservation>;
  /** Status of the survey response */
  status: SurveyResponseStatus;
  /** Date the response was submitted */
  submittedAt: Maybe<Scalars['ISODateTime']>;
  /** Survey that was responded to */
  survey: SurveyEdge;
  /** Date the resopnse was last updated */
  updatedAt: Scalars['ISODateTime'];
  /** User that responded */
  user: Maybe<User>;
};

/** Survey response rating summary */
export type SurveyResponseRatingSummary = {
  __typename: 'SurveyResponseRatingSummary';
  /** Total number of negative responses */
  negativeCount: Scalars['Int'];
  /** Total number of neutral responses */
  neutralCount: Scalars['Int'];
  /** Total number of positive responses */
  positiveCount: Scalars['Int'];
  /** Total number of completed responses */
  totalCount: Scalars['Int'];
};

/** The key to sort survey responses by */
export enum SurveyResponseSortKey {
  IN_OFFICE_AT = 'IN_OFFICE_AT',
  RATING = 'RATING'
}

/** Status of the survey response */
export enum SurveyResponseStatus {
  COMPLETED = 'COMPLETED',
  DISMISSED = 'DISMISSED',
  EXPIRED = 'EXPIRED',
  PENDING = 'PENDING'
}

/** Survey response status summary */
export type SurveyResponseStatusSummary = {
  __typename: 'SurveyResponseStatusSummary';
  /** Total number of COMPLETED responses */
  completedCount: Scalars['Int'];
  /** Total number of DISMISSED responses */
  dismissedCount: Scalars['Int'];
  /** Total number of EXPIRED responses */
  expiredCount: Scalars['Int'];
  /** Total number of PENDING responses */
  pendingCount: Scalars['Int'];
  /** Total number of responses */
  totalCount: Scalars['Int'];
};

export enum SyncState {
  DONE = 'DONE',
  IN_PROGRESS = 'IN_PROGRESS',
  NEVER_HAPPENED = 'NEVER_HAPPENED'
}

export type TeamsUserSearchResult = {
  __typename: 'TeamsUserSearchResult';
  avatar: Maybe<Scalars['String']>;
  familyName: Maybe<Scalars['String']>;
  givenName: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Maybe<Scalars['String']>;
};

export enum TestTicketIntegrationErrorReason {
  NOT_ACTIVE = 'NOT_ACTIVE',
  NOT_CONNECTED = 'NOT_CONNECTED',
  NOT_FOUND = 'NOT_FOUND'
}

export type TestTicketIntegrationErrorResponse = {
  __typename: 'TestTicketIntegrationErrorResponse';
  reason: TestTicketIntegrationErrorReason;
};

export type TestTicketIntegrationResponse = TestTicketIntegrationErrorResponse | TestTicketIntegrationSuccessResponse;

export type TestTicketIntegrationSuccessResponse = {
  __typename: 'TestTicketIntegrationSuccessResponse';
  ok: Scalars['Boolean'];
};

export type Theme = {
  __typename: 'Theme';
  color: Maybe<Scalars['String']>;
  logo: Maybe<Scalars['String']>;
};

export type Ticket = {
  /** Can be null if nobody is assigned */
  assignees: Maybe<UsersAndGroups>;
  /** The workflow category this ticket was created under */
  category: WorkflowCategory;
  completedForm: Maybe<CompletedTicketForm>;
  id: Scalars['ID'];
  /** human-friendly identifier like 'CAT-123' */
  key: Scalars['String'];
  priority: TicketPriority;
  /** The entity this ticket regards. Every current ticket kind always regards something; nullable in case a future kind lacks the relationship, or the relationship itself fails to load. */
  regardsEntity: Maybe<TicketRegardsEntity>;
  requester: Maybe<User>;
  title: Scalars['String'];
};

export type TicketAnswerExpectingChoicesInput = {
  optionIds: Array<Scalars['ID']>;
  questionId: Scalars['ID'];
};

export type TicketAnswerExpectingFilesInput = {
  /** The same IDs passed in as input to beginFileUploadsForTicketAnswer */
  fileIds: Array<Scalars['ID']>;
  questionId: Scalars['ID'];
};

export type TicketAnswerExpectingImagesInput = {
  /** Image-service URLs from a direct upload, in the order they should display */
  images: Array<TicketImageInput>;
  questionId: Scalars['ID'];
};

export type TicketAnswerExpectingMenuChoicesInput = {
  choices: Array<TicketAnswerMenuChoiceInput>;
  questionId: Scalars['ID'];
};

export type TicketAnswerExpectingTextInput = {
  answer: Scalars['String'];
  questionId: Scalars['ID'];
};

export type TicketAnswerMenuChoice = {
  __typename: 'TicketAnswerMenuChoice';
  option: TicketQuestionMenuOption;
  /** Required if option.quantifiable is true */
  quantity: Maybe<Scalars['Int']>;
  /** The subtotal price for the entire quantity, before any surcharges/taxes. On a receipt, this is what shows up to the right of each line item: "3 Crab Rangoon: 7.50". */
  subtotalPrice: Maybe<Money>;
};

export type TicketAnswerMenuChoiceInput = {
  optionId: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Int']>;
};

export type TicketEntityInput = {
  entityType: TicketEntityType;
  id: Scalars['ID'];
};

/** The kinds of entities a ticket can regard. Expected to grow (custom resources, floors, buildings, map POIs, ...) - clients should tolerate unknown values. */
export enum TicketEntityType {
  DESK = 'DESK',
  SPACE = 'SPACE'
}

export type TicketEntityUnion = Desk | Space;

export type TicketFile = {
  __typename: 'TicketFile';
  id: Scalars['ID'];
  mimeType: Scalars['MimeType'];
  name: Scalars['String'];
  sizeBytes: Scalars['Int'];
};

/** Allows uploading the file with the given ID exactly once. Cannot be reused, or used with files with different IDs. */
export type TicketFileUploadDestination = {
  __typename: 'TicketFileUploadDestination';
  /** Upload must be completed before this time - will be short! */
  expiresAt: Scalars['ISODateTime'];
  /** The same ID passed in as input */
  id: Scalars['ID'];
  /** Form fields that must be included in the POST request */
  postFields: Array<FormDataField>;
  /** URL to POST the file contents to */
  postUrl: Scalars['String'];
};

/** Information about a file the client intends to upload. Must not change - if a new file is chosen, a new input must be used. */
export type TicketFileUploadInput = {
  /** Client-generated UUID to identify this file that client should keep for later */
  id: Scalars['UUIDv4'];
  /** MIME type of the file, e.g. image/jpeg */
  mimeType: Scalars['MimeType'];
  /** The filename of the file, e.g. image.jpg */
  name: Scalars['String'];
  /** Size of file in bytes */
  sizeBytes: Scalars['Int'];
};

export type TicketIdentifierInput = {
  id?: InputMaybe<Scalars['ID']>;
  key?: InputMaybe<Scalars['String']>;
};

/** An image answer holds image URL, not a file record. It renders directly; a client derives a sized rendition from it via the image server's /redirect endpoint, so no per-size URL is stored. */
export type TicketImage = {
  __typename: 'TicketImage';
  url: Scalars['String'];
};

/** One image in an image answer. The URL comes from the image service, returned when the client uploaded the image directly to it. */
export type TicketImageInput = {
  url: Scalars['String'];
};

export type TicketIntegration = {
  baseUrl: Maybe<Scalars['String']>;
  createdAt: Scalars['ISODateTime'];
  /** When the integration stopped after its provider kept refusing its credentials; set only for DEACTIVATED. */
  deactivatedAt: Maybe<Scalars['ISODateTime']>;
  id: Scalars['ID'];
  /** @deprecated Use status. */
  isActive: Scalars['Boolean'];
  providerType: TicketProviderType;
  status: TicketIntegrationStatus;
  /** Which directions sync runs in; each can be switched off without disconnecting. */
  syncDirections: TicketIntegrationSyncDirections;
};

/** A place in the provider where tickets can be created, as the last target import saw it. */
export type TicketIntegrationAvailableTarget = {
  __typename: 'TicketIntegrationAvailableTarget';
  externalTargetObject: Scalars['String'];
  /** Provider grouping, e.g. the Jira project name. */
  group: Maybe<Scalars['String']>;
  kind: TicketIntegrationTargetConfigKind;
  label: Scalars['String'];
  /** True when a complete target import no longer found this target. Listed only while a target config still points at it. */
  missingFromProvider: Scalars['Boolean'];
  /** Set when this target is already added as a target config. */
  targetConfigId: Maybe<Scalars['ID']>;
};

/** A mapping from a Robin place to an external object (Robin is the source of truth for the pairing). One mapping per place per integration; several places may map to the same external object, and the same place may be mapped independently in different integrations. */
export type TicketIntegrationEntityMapping = {
  __typename: 'TicketIntegrationEntityMapping';
  createdAt: Scalars['ISODateTime'];
  entityId: Scalars['ID'];
  entityType: TicketIntegrationEntityMappingEntityType;
  externalObject: TicketIntegrationExternalObject;
  id: Scalars['ID'];
  status: TicketIntegrationEntityMappingStatus;
  updatedAt: Scalars['ISODateTime'];
};

/** One unmapped Robin place and its competing external-object matches (ambiguous when more than one). */
export type TicketIntegrationEntityMappingCandidate = {
  __typename: 'TicketIntegrationEntityMappingCandidate';
  entityId: Scalars['ID'];
  entityType: TicketIntegrationEntityMappingEntityType;
  matches: Array<TicketIntegrationEntityMappingCandidateMatch>;
};

export enum TicketIntegrationEntityMappingCandidateConfidence {
  HIGH = 'HIGH',
  LOW = 'LOW'
}

export type TicketIntegrationEntityMappingCandidateMatch = {
  __typename: 'TicketIntegrationEntityMappingCandidateMatch';
  confidence: TicketIntegrationEntityMappingCandidateConfidence;
  externalObject: TicketIntegrationExternalObject;
  /** True when the names only nearly match (no imported object has the place's exact name). Always LOW confidence. */
  fuzzy: Scalars['Boolean'];
  parentAgreement: TicketIntegrationEntityMappingParentAgreement;
};

/** Whether a place without its own mapping still resolves to an external location through an ancestor. */
export enum TicketIntegrationEntityMappingCoverage {
  /** A mapped ancestor supplies the location; listed because the place has no mapping row of its own. */
  INHERITED = 'INHERITED',
  /** No mapping row and no mapped ancestor — tickets for this place sync without an external location. */
  UNCOVERED = 'UNCOVERED'
}

/** Robin place types that can be entity-mapping targets (RFC 0014: place hierarchy only). */
export enum TicketIntegrationEntityMappingEntityType {
  BUILDING = 'BUILDING',
  CAMPUS = 'CAMPUS',
  FLOOR = 'FLOOR',
  SPACE = 'SPACE'
}

export type TicketIntegrationEntityMappingInput = {
  entityId: Scalars['ID'];
  entityType: TicketIntegrationEntityMappingEntityType;
  externalObjectId: Scalars['ID'];
  /** Display label snapshot from `listTicketIntegrationExternalObjects` (the provider is not re-queried on write). */
  externalObjectLabel?: InputMaybe<Scalars['String']>;
  /** The concrete type the entity was returned as by `listTicketIntegrationExternalObjects`/match. */
  externalObjectType: TicketIntegrationExternalObjectType;
};

/** How the candidate's provider parent compares to the Robin place's parent. */
export enum TicketIntegrationEntityMappingParentAgreement {
  AGREES = 'AGREES',
  CONFLICTS = 'CONFLICTS',
  /** No parent signal on one side — neutral, not a conflict. */
  UNKNOWN = 'UNKNOWN'
}

/** Only ACTIVE mappings resolve tickets; a STALE/BROKEN mapping degrades to the nearest ACTIVE ancestor mapping at sync time and is flagged for admin attention. STALE/BROKEN are set by verification (on re-sync or a later verification run), never by the mutations here. */
export enum TicketIntegrationEntityMappingStatus {
  ACTIVE = 'ACTIVE',
  /** The external object is confirmed missing upstream. */
  BROKEN = 'BROKEN',
  /** The external object may have changed upstream since this mapping was verified. */
  STALE = 'STALE'
}

export type TicketIntegrationEntityRef = {
  __typename: 'TicketIntegrationEntityRef';
  entityId: Scalars['ID'];
  entityType: TicketIntegrationEntityMappingEntityType;
};

export type TicketIntegrationEntityRefInput = {
  entityId: Scalars['ID'];
  entityType: TicketIntegrationEntityMappingEntityType;
};

/** A record in the external system that a synced ticket can reference as its location. Which concrete type an integration yields is probed per integration (e.g. Jira Assets when licensed, otherwise select-field options; Zendesk custom objects, otherwise tags). */
export type TicketIntegrationExternalObject = {
  /** The Robin place entity type this record is detected to stand in for, when the provider exposes typed locations the port can align to one; null otherwise. */
  entityType: Maybe<TicketIntegrationEntityMappingEntityType>;
  /** Provider-side identifier (ServiceNow sys_id, Jira option id, Zendesk tag, ...). Unique only within one integration — cache on (integrationId, id). */
  id: Scalars['ID'];
  integrationId: Scalars['ID'];
  /** Display label; null for a stored mapping written without a label snapshot. */
  label: Maybe<Scalars['String']>;
};

/** One external object class the provider offers. Every non-abstract class the provider lists is returned — a read-only assignment (isCreateTarget:false) can point at any of them. Only classes with isCreateEligible:true can be a create target. */
export type TicketIntegrationExternalObjectClass = {
  __typename: 'TicketIntegrationExternalObjectClass';
  /** This integration's stored assignment for the class; null when unassigned. */
  assignedEntityType: Maybe<TicketIntegrationEntityMappingEntityType>;
  id: Scalars['ID'];
  /** Whether a net-new external object can be created as this class — false when the class has a required create field the create payload cannot supply. Read-only assignments (isCreateTarget:false) reach any class regardless of this flag. */
  isCreateEligible: Scalars['Boolean'];
  isCreateTarget: Scalars['Boolean'];
  /** True when this row is a stored assignment whose class id the live provider catalog no longer has (deleted/recreated in the provider) — id/name/schemaName/suggestedEntityType are synthesized, not from the catalog. */
  missingFromCatalog: Scalars['Boolean'];
  name: Scalars['String'];
  /** The provider schema the class lives in, for display (classes can share a name across schemas). */
  schemaName: Maybe<Scalars['String']>;
  /** Server-computed regex guess at this class's place entity type from its name; null when the name is not recognized as a location, and once the class is assigned or unassigned. */
  suggestedEntityType: Maybe<TicketIntegrationEntityMappingEntityType>;
};

/** Discriminator for an external object's provider representation. Carried on writes and validated against the provider's representation family (the set of types that provider can produce), so a cross-provider value is a rejected write (REPRESENTATION_MISMATCH), never a mis-typed row. A capability flip within one provider between listing and writing is not detected at write time. Reads derive the concrete type from the stored row, not from this. */
export enum TicketIntegrationExternalObjectType {
  JIRA_ASSET = 'JIRA_ASSET',
  JIRA_FIELD_OPTION = 'JIRA_FIELD_OPTION',
  SERVICENOW_LOCATION = 'SERVICENOW_LOCATION',
  ZENDESK_CUSTOM_OBJECT_RECORD = 'ZENDESK_CUSTOM_OBJECT_RECORD',
  ZENDESK_TAG = 'ZENDESK_TAG'
}

export type TicketIntegrationFieldBinding = TicketIntegrationFieldBindingMappedPlace | TicketIntegrationFieldBindingSourceField | TicketIntegrationFieldBindingStatic | TicketIntegrationFieldBindingTags | TicketIntegrationFieldBindingTemplate | TicketIntegrationFieldBindingValueMap;

export type TicketIntegrationFieldBindingInput = {
  mappedPlace?: InputMaybe<TicketIntegrationFieldBindingMappedPlaceInput>;
  sourceField?: InputMaybe<TicketIntegrationFieldBindingSourceFieldInput>;
  staticValue?: InputMaybe<TicketIntegrationFieldBindingStaticInput>;
  tags?: InputMaybe<TicketIntegrationFieldBindingTagsInput>;
  template?: InputMaybe<TicketIntegrationFieldBindingTemplateInput>;
  valueMap?: InputMaybe<TicketIntegrationFieldBindingValueMapInput>;
};

export type TicketIntegrationFieldBindingMappedPlace = {
  __typename: 'TicketIntegrationFieldBindingMappedPlace';
  fallbackToAncestor: Scalars['Boolean'];
};

/** Fill the field with the external record mapped to the ticket's place; `fallbackToAncestor` mirrors outbound sync. */
export type TicketIntegrationFieldBindingMappedPlaceInput = {
  fallbackToAncestor?: Scalars['Boolean'];
};

export type TicketIntegrationFieldBindingSourceField = {
  __typename: 'TicketIntegrationFieldBindingSourceField';
  key: Scalars['String'];
};

/** Pass the Robin source field's value through unchanged. */
export type TicketIntegrationFieldBindingSourceFieldInput = {
  key: Scalars['String'];
};

export type TicketIntegrationFieldBindingStatic = {
  __typename: 'TicketIntegrationFieldBindingStatic';
  value: Scalars['String'];
};

/** The same literal value on every ticket. DATE targets take ISO-8601 (YYYY-MM-DD); NUMBER targets take a decimal string. */
export type TicketIntegrationFieldBindingStaticInput = {
  value: Scalars['String'];
};

export type TicketIntegrationFieldBindingTags = {
  __typename: 'TicketIntegrationFieldBindingTags';
  templates: Array<Scalars['String']>;
};

/** Zendesk-style tag emission: each template renders to one tag (same template rules as the template binding). */
export type TicketIntegrationFieldBindingTagsInput = {
  templates: Array<Scalars['String']>;
};

export type TicketIntegrationFieldBindingTemplate = {
  __typename: 'TicketIntegrationFieldBindingTemplate';
  template: Scalars['String'];
};

/** Text with {{key}} placeholders over the source-field catalog. Strict substitution only: no helpers, subexpressions, partials, or raw/triple-stash — a key must exist in `listTicketIntegrationSourceFields` for the scope. A null or empty source value renders as the empty string. `{{` cannot be escaped; a literal `{{` is TEMPLATE_INVALID. */
export type TicketIntegrationFieldBindingTemplateInput = {
  template: Scalars['String'];
};

export type TicketIntegrationFieldBindingValueMap = {
  __typename: 'TicketIntegrationFieldBindingValueMap';
  entries: Array<TicketIntegrationFieldValueMapEntry>;
  sourceFieldKey: Scalars['String'];
};

/** Map an ENUM source field's values onto the target field's options. A source value that matches no entry surfaces as a VALUE_MAP_MISS warning; a default fallback is deferred. */
export type TicketIntegrationFieldBindingValueMapInput = {
  entries: Array<TicketIntegrationFieldValueMapEntryInput>;
  sourceFieldKey: Scalars['String'];
};

export type TicketIntegrationFieldMapping = {
  __typename: 'TicketIntegrationFieldMapping';
  binding: TicketIntegrationFieldBinding;
  direction: TicketIntegrationFieldMappingDirection;
  id: Scalars['ID'];
  /** True while the stored binding still equals the provider default it was seeded from. */
  isDefault: Scalars['Boolean'];
  /** Which scope this row came from when reading with a workflowId: a workflow override, or inherited from the integration level. */
  resolvedFrom: TicketIntegrationFieldMappingScope;
  /** Fill at ticket creation only; when false the field also re-syncs on outbound updates. */
  syncOnCreateOnly: Scalars['Boolean'];
  /** The target config the mapping belongs to. Null = a mapping that applies to whichever target config is the default, where that config has no mapping of its own for the field. */
  targetConfigId: Maybe<Scalars['ID']>;
  targetFieldId: Scalars['ID'];
  /** Display-label snapshot of the target field (the provider is not re-queried on write). */
  targetFieldLabel: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISODateTime'];
};

/** INBOUND and BIDIRECTIONAL apply to the source fields whose `supportedDirections` list them. */
export enum TicketIntegrationFieldMappingDirection {
  BIDIRECTIONAL = 'BIDIRECTIONAL',
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND'
}

export type TicketIntegrationFieldMappingDriftItem = {
  __typename: 'TicketIntegrationFieldMappingDriftItem';
  reason: TicketIntegrationFieldMappingDriftReason;
  targetFieldId: Scalars['ID'];
  /** The stored label snapshot, so the row is nameable even though the live field is gone. */
  targetFieldLabel: Maybe<Scalars['String']>;
};

export enum TicketIntegrationFieldMappingDriftReason {
  /** A referenced option no longer exists on the target field. */
  OPTION_MISSING = 'OPTION_MISSING',
  /** The stored target field no longer exists in the provider. */
  TARGET_FIELD_MISSING = 'TARGET_FIELD_MISSING',
  /** The target field's type changed, so the binding no longer fits it. */
  TARGET_FIELD_TYPE_CHANGED = 'TARGET_FIELD_TYPE_CHANGED'
}

export type TicketIntegrationFieldMappingInput = {
  binding: TicketIntegrationFieldBindingInput;
  direction?: TicketIntegrationFieldMappingDirection;
  /** Send this field only when the ticket is created, not on later updates. */
  syncOnCreateOnly?: Scalars['Boolean'];
  /** The target config to scope to; pass the config's id, the default one included. Null = the default-following scope (see TicketIntegrationFieldMapping.targetConfigId). */
  targetConfigId?: InputMaybe<Scalars['ID']>;
  targetFieldId: Scalars['ID'];
  /** Display-label snapshot from the target-fields listing; carried, never re-derived. */
  targetFieldLabel?: InputMaybe<Scalars['String']>;
};

export enum TicketIntegrationFieldMappingScope {
  INTEGRATION = 'INTEGRATION',
  WORKFLOW = 'WORKFLOW'
}

/** How much the server trusts a suggested field binding. Coarse by design: field matching has no strong anchor (no device serial, no place hierarchy), so HIGH is a confident name/type match and LOW is a weaker guess the admin should review. */
export enum TicketIntegrationFieldMappingSuggestionConfidence {
  HIGH = 'HIGH',
  LOW = 'LOW'
}

export type TicketIntegrationFieldOptionRef = {
  __typename: 'TicketIntegrationFieldOptionRef';
  id: Scalars['ID'];
  label: Maybe<Scalars['String']>;
};

/** A target-field option, with a display-label snapshot (the provider is not re-queried on write). */
export type TicketIntegrationFieldOptionRefInput = {
  id: Scalars['ID'];
  label?: InputMaybe<Scalars['String']>;
};

export type TicketIntegrationFieldValueMapEntry = {
  __typename: 'TicketIntegrationFieldValueMapEntry';
  externalValue: Maybe<Scalars['String']>;
  option: Maybe<TicketIntegrationFieldOptionRef>;
  sourceValue: Scalars['String'];
};

/** Exactly one of `option` / `externalValue`: `option` for an option-bearing target (SELECT), `externalValue` (<= 1024 chars) as a free string for text-like targets. The wrong pairing for the target field's type fails with BINDING_TYPE_MISMATCH. v1 maps each source value to a single option; ordered multi-option output for MULTI_SELECT is deferred to the outbound-sync storage work and returns additively (an `options` list alongside `option`). */
export type TicketIntegrationFieldValueMapEntryInput = {
  externalValue?: InputMaybe<Scalars['String']>;
  option?: InputMaybe<TicketIntegrationFieldOptionRefInput>;
  /** Matched case-sensitively against the source field's value. */
  sourceValue: Scalars['String'];
};

/** A Jira Assets object (requires the Assets feature on the Jira plan). */
export type TicketIntegrationJiraAsset = TicketIntegrationExternalObject & {
  __typename: 'TicketIntegrationJiraAsset';
  entityType: Maybe<TicketIntegrationEntityMappingEntityType>;
  id: Scalars['ID'];
  integrationId: Scalars['ID'];
  label: Maybe<Scalars['String']>;
  parentExternalObjectId: Maybe<Scalars['ID']>;
};

/** An option of the integration's location select field (the Jira tier without Assets). Flat: one select field is pinned per integration, and `id` is Jira's per-option id, so two options with the same label on different custom fields are distinct ids and only the pinned field's options are ever listed. */
export type TicketIntegrationJiraFieldOption = TicketIntegrationExternalObject & {
  __typename: 'TicketIntegrationJiraFieldOption';
  entityType: Maybe<TicketIntegrationEntityMappingEntityType>;
  id: Scalars['ID'];
  integrationId: Scalars['ID'];
  label: Maybe<Scalars['String']>;
};

export type TicketIntegrationObjectClassAssignmentItemInput = {
  /** null unassigns the class. */
  entityType?: InputMaybe<TicketIntegrationEntityMappingEntityType>;
  externalObjectClassId: Scalars['ID'];
  isCreateTarget?: Scalars['Boolean'];
};

/** What is happening to an in-flight run right now, as distinct from how far through the fetch it is (`TicketIntegrationObjectImportPhase`). A run waits in a service-wide queue between runs, so FETCHING on its own does not mean work is in progress. */
export enum TicketIntegrationObjectImportActivity {
  /** Waiting for a worker to pick it up. Counters do not move in this state. */
  QUEUED = 'QUEUED',
  /** A transient provider failure parked the run until `nextAttemptAt`. Counters do not move, and the wait grows to 15 minutes per attempt; show the wait rather than an unexplained stall. */
  RETRYING = 'RETRYING',
  /** A worker holds the lease and is fetching the provider now. */
  RUNNING = 'RUNNING'
}

/** The background object import's phase: `fetching` fetches the provider, `matching` matches imported objects against Robin places, `complete` and `failed` are terminal. There is no "not started" member — the absence of a run (a null `TicketIntegrationObjectImportStatus`) is how "never ran" reads. */
export enum TicketIntegrationObjectImportPhase {
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
  FETCHING = 'FETCHING',
  MATCHING = 'MATCHING'
}

/** Progress/status of one background object import. */
export type TicketIntegrationObjectImportStatus = {
  __typename: 'TicketIntegrationObjectImportStatus';
  /** Null once the run is COMPLETE or FAILED — a terminal run is not doing anything. Read alongside `phase`, not instead of it: `phase` is where the run got to, `activity` is whether anything is happening. */
  activity: Maybe<TicketIntegrationObjectImportActivity>;
  /** Classes finished out of the run's resolved scope — the progress fraction that works for every provider, since it needs no count from the provider. Both are null until the run's scope resolves (its first persisted write). `classesTotal` can legitimately be 0 (an integration with nothing assigned and nothing detected), so guard the division. `classesCompleted` is null on a FAILED run that had already finished its fetch, where the row no longer says how far it got. */
  classesCompleted: Maybe<Scalars['Int']>;
  classesTotal: Maybe<Scalars['Int']>;
  /** Why the run failed, as a stable machine token (`unreachable`, `rejected`, `capability_missing`, `not_connected`, `budget_exhausted`, `internal_error`, `stalled`). Set only when phase is FAILED. Provider and database text is logged, never returned. `stalled` means no worker advanced the run for a day, past every retry the ladder allows, so the next start request failed it and began a fresh fetch. It says the run was never driven, not that the provider misbehaved. `budget_exhausted` means the matching phase could not finish inside one run often enough to spend its attempts — the estate is too large for the current budget, not a provider problem. */
  error: Maybe<Scalars['String']>;
  /** Set once phase reaches COMPLETE or FAILED. */
  finishedAt: Maybe<Scalars['ISODateTime']>;
  /** Imported objects across the integration that the last matching phase paired with a place at HIGH confidence. A suggestion, not a mapping. It changes when a matching phase saves its results, at the same moment as the suggestions `matchTicketIntegrationEntityMappingCandidates` returns, so during an import it still describes the previous one. */
  highMatchCount: Scalars['Int'];
  importedCount: Scalars['Int'];
  /** When the run last advanced — a page landed, or a phase moved. A claim or a failed attempt does not bump it, so a client can tell a stalled run from a slow one without knowing the worker's cadence. */
  lastProgressAt: Scalars['ISODateTime'];
  /** As `highMatchCount`, at LOW confidence. */
  lowMatchCount: Scalars['Int'];
  /** The earliest time this import can be claimed again, not a promise that anything will claim it then: a parked import resumes on the next publish for this integration, or when the hourly refresh announces it again, up to an hour later. Null unless a transient failure parked it. */
  nextAttemptAt: Maybe<Scalars['ISODateTime']>;
  phase: TicketIntegrationObjectImportPhase;
  startedAt: Scalars['ISODateTime'];
  /** Best-effort total from the provider; null when the provider gives no count (render "N found so far"). */
  totalEstimate: Maybe<Scalars['Int']>;
  /** True when the fetch was cut short by a provider cap. */
  truncated: Scalars['Boolean'];
};

export enum TicketIntegrationObjectImportStatusErrorReason {
  NOT_FOUND = 'NOT_FOUND'
}

export type TicketIntegrationObjectImportStatusErrorResponse = {
  __typename: 'TicketIntegrationObjectImportStatusErrorResponse';
  reason: TicketIntegrationObjectImportStatusErrorReason;
};

export type TicketIntegrationObjectImportStatusResponse = TicketIntegrationObjectImportStatusErrorResponse | TicketIntegrationObjectImportStatusSuccessResponse;

export type TicketIntegrationObjectImportStatusSuccessResponse = {
  __typename: 'TicketIntegrationObjectImportStatusSuccessResponse';
  /** Null when no object import has ever existed for this integration. */
  status: Maybe<TicketIntegrationObjectImportStatus>;
};

export type TicketIntegrationPreviewEntityRef = {
  __typename: 'TicketIntegrationPreviewEntityRef';
  entityId: Scalars['ID'];
  entityType: TicketEntityType;
};

/** The entity the sample ticket regards. Typed on `TicketEntityType` (what a ticket can regard — desks included), NOT the entity-mapping enum, which is place-hierarchy-only. */
export type TicketIntegrationPreviewEntityRefInput = {
  entityId: Scalars['ID'];
  entityType: TicketEntityType;
};

/** A ServiceNow cmn_location record. */
export type TicketIntegrationServiceNowLocation = TicketIntegrationExternalObject & {
  __typename: 'TicketIntegrationServiceNowLocation';
  entityType: Maybe<TicketIntegrationEntityMappingEntityType>;
  id: Scalars['ID'];
  integrationId: Scalars['ID'];
  label: Maybe<Scalars['String']>;
  parentExternalObjectId: Maybe<Scalars['ID']>;
};

/** One Robin-side ticket payload field that bindings and {{key}} templates can reference. Keys are namespaced: `ticket.*` (summary, description, priority, reporter), `place.*` (building, floor, room), and `form.<mapping_key>` for the workflow's form answers — form mapping keys are unique per form only, so the namespace is what keeps them from colliding with core keys. */
export type TicketIntegrationSourceField = {
  __typename: 'TicketIntegrationSourceField';
  /** The value domain for ENUM fields (drives value-map editors); empty otherwise. */
  allowedValues: Array<TicketIntegrationSourceFieldValue>;
  fieldType: TicketIntegrationSourceFieldType;
  key: Scalars['String'];
  label: Scalars['String'];
  /** The directions a mapping from this field may take. INBOUND and BIDIRECTIONAL apply to sourceField and valueMap bindings only; every other binding kind is OUTBOUND. */
  supportedDirections: Array<TicketIntegrationFieldMappingDirection>;
};

export enum TicketIntegrationSourceFieldType {
  ENUM = 'ENUM',
  PLACE = 'PLACE',
  TEXT = 'TEXT',
  USER = 'USER'
}

/** One value an ENUM source field can take, for populating value-map editors. */
export type TicketIntegrationSourceFieldValue = {
  __typename: 'TicketIntegrationSourceFieldValue';
  label: Scalars['String'];
  value: Scalars['String'];
};

export enum TicketIntegrationStatus {
  ACTIVE = 'ACTIVE',
  /** Stopped because the provider kept refusing its credentials. Re-authorize it (beginTicketIntegrationOAuth) against the same site to make it active again, or delete it. For ServiceNow with a rotated client, first call createServiceNowIntegration with the same instanceUrl, then re-authorize the id it returns. */
  DEACTIVATED = 'DEACTIVATED',
  /** Created; OAuth has not completed. */
  PENDING = 'PENDING'
}

/** A proposed mapping; nothing is persisted — apply accepted rows with the upsert. */
export type TicketIntegrationSuggestedFieldMapping = {
  __typename: 'TicketIntegrationSuggestedFieldMapping';
  binding: TicketIntegrationFieldBinding;
  /** How much to trust this suggestion; drives the review UI's confidence badge. */
  confidence: TicketIntegrationFieldMappingSuggestionConfidence;
  targetFieldId: Scalars['ID'];
  targetFieldLabel: Scalars['String'];
};

export type TicketIntegrationSyncDirections = {
  __typename: 'TicketIntegrationSyncDirections';
  inbound: Scalars['Boolean'];
  integrationId: Scalars['ID'];
  outbound: Scalars['Boolean'];
};

/** A provider target object one integration creates tickets in (e.g. a ServiceNow table, a Jira request type). An integration can have several. */
export type TicketIntegrationTargetConfig = {
  __typename: 'TicketIntegrationTargetConfig';
  /** Opaque provider-defined identifier, e.g. the ServiceNow table name. */
  externalTargetObject: Scalars['String'];
  id: Scalars['ID'];
  integrationId: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  kind: TicketIntegrationTargetConfigKind;
  /** The provider's display name, e.g. `IT Help / Report an AV issue`. */
  label: Scalars['String'];
  /** Values filled in on provider transitions, per status the transition moves to. */
  transitionFields: Array<TicketIntegrationTransitionFieldValue>;
};

/** Which provider API a target config's tickets are created through. */
export enum TicketIntegrationTargetConfigKind {
  /** A Jira issue type, in a project without a service desk. */
  JIRA_ISSUE_TYPE = 'JIRA_ISSUE_TYPE',
  /** A Jira Service Management request type. */
  JSM_REQUEST_TYPE = 'JSM_REQUEST_TYPE',
  SERVICENOW_TABLE = 'SERVICENOW_TABLE'
}

/** One provider ticket field the integration can fill on ticket creation. */
export type TicketIntegrationTargetField = {
  __typename: 'TicketIntegrationTargetField';
  /** The provider-default binding for this field; null when the default set has none. Read-only — seeding writes it as an ordinary mapping. */
  defaultBinding: Maybe<TicketIntegrationFieldBinding>;
  fieldType: TicketIntegrationTargetFieldType;
  /** Provider-side grouping (Jira request type, ServiceNow catalog item). */
  group: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  integrationId: Scalars['ID'];
  /** Whether the field can hold a place's mapped external object (e.g. a Jira Assets field), which is what a mappedPlace binding needs. */
  isLocationCandidate: Scalars['Boolean'];
  label: Scalars['String'];
  /** Options for SELECT / MULTI_SELECT; empty for other field types. */
  options: Array<TicketIntegrationTargetFieldOption>;
  required: Scalars['Boolean'];
  /** The target config this field belongs to; null = the integration's default target. */
  targetConfigId: Maybe<Scalars['ID']>;
};

export type TicketIntegrationTargetFieldOption = {
  __typename: 'TicketIntegrationTargetFieldOption';
  id: Scalars['ID'];
  label: Scalars['String'];
};

export enum TicketIntegrationTargetFieldType {
  BOOLEAN = 'BOOLEAN',
  DATE = 'DATE',
  MULTILINE_TEXT = 'MULTILINE_TEXT',
  MULTI_SELECT = 'MULTI_SELECT',
  NUMBER = 'NUMBER',
  SELECT = 'SELECT',
  TAGS = 'TAGS',
  TEXT = 'TEXT',
  /** A provider field type this API cannot bind. Listed for visibility, never bindable. */
  UNSUPPORTED = 'UNSUPPORTED',
  USER = 'USER'
}

export type TicketIntegrationTargetImport = {
  __typename: 'TicketIntegrationTargetImport';
  /** When the last import finished, whether or not it succeeded. */
  finishedAt: Maybe<Scalars['ISODateTime']>;
  status: TicketIntegrationTargetImportStatus;
};

export enum TicketIntegrationTargetImportStatus {
  FAILED = 'FAILED',
  NOT_STARTED = 'NOT_STARTED',
  /** An import was asked for (a connect or a refresh) and no run has started it yet. */
  QUEUED = 'QUEUED',
  /** Listing the provider; a large site takes several runs, and the targets listed so far are already stored. */
  RUNNING = 'RUNNING',
  SUCCEEDED = 'SUCCEEDED'
}

/** The fields shown when a ticket moves to one provider status. */
export type TicketIntegrationTransition = {
  __typename: 'TicketIntegrationTransition';
  /** The provider status id, as a status value map's `externalValue`. */
  externalStatusId: Scalars['ID'];
  fields: Array<TicketIntegrationTransitionField>;
  statusName: Scalars['String'];
};

/** One field a transition screen shows. */
export type TicketIntegrationTransitionField = {
  __typename: 'TicketIntegrationTransitionField';
  fieldId: Scalars['ID'];
  fieldType: TicketIntegrationTargetFieldType;
  label: Scalars['String'];
  /** Options for SELECT / MULTI_SELECT; empty for other field types. */
  options: Array<TicketIntegrationTargetFieldOption>;
  /** A move to this status is skipped while a required field has no value. */
  required: Scalars['Boolean'];
  /** The value Robin fills in (an option id, or text); null when none is set. */
  value: Maybe<Scalars['String']>;
};

/** One value Robin fills in on the transition that moves a ticket to a provider status. */
export type TicketIntegrationTransitionFieldValue = {
  __typename: 'TicketIntegrationTransitionFieldValue';
  /** The provider status the transition moves to, as a status value mapping's `externalValue`. */
  externalStatusId: Scalars['ID'];
  /** The provider field id, e.g. `resolution` or `customfield_10060`. */
  fieldId: Scalars['ID'];
  /** The value in the provider's terms: an option id, account id, or text. */
  value: Scalars['String'];
};

export type TicketIntegrationTransitionFieldValueInput = {
  fieldId: Scalars['ID'];
  value: Scalars['String'];
};

export type TicketIntegrationUnmappedEntity = {
  __typename: 'TicketIntegrationUnmappedEntity';
  coverage: TicketIntegrationEntityMappingCoverage;
  /** The nearest mapped ancestor; null when UNCOVERED. */
  coveringAncestor: Maybe<TicketIntegrationEntityRef>;
  entityId: Scalars['ID'];
  entityType: TicketIntegrationEntityMappingEntityType;
};

/** One workflow bound to this integration (`workflow_integration_binding`). Ticket field mapping's workflow scope targets these — in v1 that means ISSUE_REPORT workflows, whose ids this is the first surface for; `kind` is exposed so clients never have to assume. */
export type TicketIntegrationWorkflowBinding = {
  __typename: 'TicketIntegrationWorkflowBinding';
  isActive: Scalars['Boolean'];
  /** The target config this workflow's tickets are created in; null = the integration's default. */
  targetConfigId: Maybe<Scalars['ID']>;
  workflowId: Scalars['ID'];
  workflowKind: TicketWorkflowKind;
  workflowName: Scalars['String'];
};

/** A Zendesk custom-object record. */
export type TicketIntegrationZendeskCustomObjectRecord = TicketIntegrationExternalObject & {
  __typename: 'TicketIntegrationZendeskCustomObjectRecord';
  entityType: Maybe<TicketIntegrationEntityMappingEntityType>;
  id: Scalars['ID'];
  integrationId: Scalars['ID'];
  label: Maybe<Scalars['String']>;
  parentExternalObjectId: Maybe<Scalars['ID']>;
};

/** A Zendesk tag (flat namespace; exists implicitly on first use). */
export type TicketIntegrationZendeskTag = TicketIntegrationExternalObject & {
  __typename: 'TicketIntegrationZendeskTag';
  entityType: Maybe<TicketIntegrationEntityMappingEntityType>;
  id: Scalars['ID'];
  integrationId: Scalars['ID'];
  label: Maybe<Scalars['String']>;
};

/** The product a ticket originated from - who filed it, not who may see it. Stamped when the ticket is created and immutable after that. */
export enum TicketOriginProduct {
  HYPERSPACE = 'HYPERSPACE',
  ROBIN = 'ROBIN'
}

/** How urgently a ticket needs attention */
export enum TicketPriority {
  CRITICAL = 'CRITICAL',
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM'
}

export enum TicketProviderType {
  JIRA = 'JIRA',
  SERVICENOW = 'SERVICENOW',
  ZENDESK = 'ZENDESK'
}

export type TicketQuestion = {
  id: Scalars['ID'];
  prompt: Scalars['String'];
  required: Scalars['Boolean'];
};

export type TicketQuestionExpectingChoices = AbstractTicketQuestionExpectingChoices & TicketQuestion & {
  __typename: 'TicketQuestionExpectingChoices';
  chooseOnlyOneOption: Scalars['Boolean'];
  id: Scalars['ID'];
  options: Array<TicketQuestionOption>;
  /** e.g. 'Which way do you want the room to be set up?' */
  prompt: Scalars['String'];
  required: Scalars['Boolean'];
};

export type TicketQuestionExpectingChoicesInput = {
  chooseOnlyOneOption: Scalars['Boolean'];
  options: Array<TicketQuestionOptionInput>;
  /** e.g. 'Which way do you want the room to be set up?' */
  prompt: Scalars['String'];
  required: Scalars['Boolean'];
};

export type TicketQuestionExpectingFiles = TicketQuestion & {
  __typename: 'TicketQuestionExpectingFiles';
  id: Scalars['ID'];
  prompt: Scalars['String'];
  required: Scalars['Boolean'];
};

export type TicketQuestionExpectingFilesInput = {
  /** 'Provide the purchase order PDF' */
  prompt: Scalars['String'];
  required: Scalars['Boolean'];
};

export type TicketQuestionExpectingImages = TicketQuestion & {
  __typename: 'TicketQuestionExpectingImages';
  id: Scalars['ID'];
  prompt: Scalars['String'];
  required: Scalars['Boolean'];
};

export type TicketQuestionExpectingImagesInput = {
  /** 'Attach photos of the damaged equipment' */
  prompt: Scalars['String'];
  required: Scalars['Boolean'];
};

export type TicketQuestionExpectingMenuChoices = AbstractTicketQuestionExpectingChoices & TicketQuestion & {
  __typename: 'TicketQuestionExpectingMenuChoices';
  chooseOnlyOneOption: Scalars['Boolean'];
  id: Scalars['ID'];
  options: Array<TicketQuestionMenuOption>;
  /** e.g. 'Which way do you want the room to be set up?' */
  prompt: Scalars['String'];
  required: Scalars['Boolean'];
};

export type TicketQuestionExpectingMenuChoicesInput = {
  chooseOnlyOneOption: Scalars['Boolean'];
  options: Array<TicketQuestionMenuOptionInput>;
  /** e.g. 'Appetizers' */
  prompt: Scalars['String'];
  required: Scalars['Boolean'];
};

export type TicketQuestionExpectingText = TicketQuestion & {
  __typename: 'TicketQuestionExpectingText';
  id: Scalars['ID'];
  multilineAnswer: Scalars['Boolean'];
  /** 'What is your expense code?' */
  prompt: Scalars['String'];
  required: Scalars['Boolean'];
};

export type TicketQuestionExpectingTextInput = {
  multilineAnswer: Scalars['Boolean'];
  /** 'What is your expense code?' */
  prompt: Scalars['String'];
  required: Scalars['Boolean'];
};

export type TicketQuestionInput = {
  expectingChoices?: InputMaybe<TicketQuestionExpectingChoicesInput>;
  expectingFiles?: InputMaybe<TicketQuestionExpectingFilesInput>;
  expectingImages?: InputMaybe<TicketQuestionExpectingImagesInput>;
  expectingMenuChoices?: InputMaybe<TicketQuestionExpectingMenuChoicesInput>;
  expectingText?: InputMaybe<TicketQuestionExpectingTextInput>;
};

export type TicketQuestionMenuOption = AbstractTicketQuestionOption & {
  __typename: 'TicketQuestionMenuOption';
  /** 'A perfectly adequate sandwich with cheese' */
  description: Maybe<Scalars['Markdown']>;
  id: Scalars['ID'];
  imageUrl: Maybe<Scalars['String']>;
  /** 'Sandwich' */
  name: Scalars['String'];
  quantifiable: Scalars['Boolean'];
  /** The price of each unit, such that the subtotalPrice for this choice is quantity * unitPrice. If the option is not quantifiable, this is a flat price like if quantity were always 1. The currency code will always match the one on the MeetingService. 0 - 99_999_999 major currency units. Amounts are rounded to the nearest minor currency unit. */
  unitPrice: Maybe<Money>;
};

export type TicketQuestionMenuOptionInput = {
  /** 'Two pieces of bread with meat in between - yum!' */
  description?: InputMaybe<Scalars['Markdown']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  /** 'Sandwich' */
  name: Scalars['String'];
  quantifiable: Scalars['Boolean'];
  /** The price of each unit, such that the total price for this option is quantity * unitPrice. If this option is not quantifiable, this is a flat price like if quantity were always 1. The currency code must match the one on the meeting service - you cannot mix currencies on the same service. */
  unitPrice?: InputMaybe<MoneyInput>;
};

export type TicketQuestionOption = AbstractTicketQuestionOption & {
  __typename: 'TicketQuestionOption';
  /** 'We'll set up tables facing in *one* direction, evenly spaced' */
  description: Maybe<Scalars['Markdown']>;
  id: Scalars['ID'];
  imageUrl: Maybe<Scalars['String']>;
  /** 'Classroom' */
  name: Scalars['String'];
};

export type TicketQuestionOptionInput = {
  /** 'We'll set up tables facing in *one* direction, evenly spaced' */
  description?: InputMaybe<Scalars['Markdown']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  /** 'Classroom' */
  name: Scalars['String'];
};

/** A specific amenity on the regarded entity, e.g. the monitor on a desk. An amenity belongs to its entity, so this can only exist within a TicketRegardsEntity - a ticket can never regard an amenity alone. */
export type TicketRegardsAmenity = {
  __typename: 'TicketRegardsAmenity';
  /** Resolves to name "Unknown Amenity" (isDefault: true) if the catalog entry was deleted; null only if the amenity service fails to resolve it. */
  amenity: Maybe<AmenityWithDefault>;
  /** The amenity CATALOG ID (Amenity.id), not the per-entity SpaceAmenity / DeskAmenity instance row. This is the ID amenity filters already speak in - Level.availableDeskAmenities lists it and filteredDesksByAmenityIds takes it - and space_amenities / seat_amenities are unique per (entity, amenity), so it identifies the instance on the regarded entity too. */
  amenityId: Scalars['ID'];
};

export type TicketRegardsEntity = {
  __typename: 'TicketRegardsEntity';
  /** The specific amenities on this entity the ticket regards. Empty when the ticket regards the entity as a whole. */
  amenities: Array<TicketRegardsAmenity>;
  /** Null if the entity has been deleted or fails to resolve */
  entity: Maybe<TicketEntityUnion>;
  entityId: Scalars['ID'];
  entityType: TicketEntityType;
};

export type TicketRegardsEventAtSpace = {
  __typename: 'TicketRegardsEventAtSpace';
  event: Maybe<Event>;
  eventEnd: Scalars['ISODateTime'];
  eventStart: Scalars['ISODateTime'];
  space: Maybe<Space>;
  /** null if ticket will still be changed when event changes. Actions like rejecting or cancelling a ticket will unsubscribe from event changes. This keeps a frozen record of what the ticket looked like when it was resolved. It also prevents people from getting emails about changes to events whose tickets are resolved. */
  unsubscribedAt: Maybe<Scalars['ISODateTime']>;
};

export enum TicketWorkflowKind {
  /** This workflow describes how issues are reported; reporting produces an IssueReport. */
  ISSUE_REPORT = 'ISSUE_REPORT',
  MEETING_SERVICE = 'MEETING_SERVICE',
  /** This workflow describes a form that must be completed in order to request a request-only space. */
  SPACE_REQUEST_FORM = 'SPACE_REQUEST_FORM'
}

export type TimeFrame = {
  __typename: 'TimeFrame';
  end: Scalars['String'];
  start: Scalars['String'];
};

export type TimeFrameInput = {
  end: Scalars['LocalEndTime'];
  start: Scalars['LocalEndTime'];
};

export enum TimeInclusivityType {
  EXCLUSIVE = 'EXCLUSIVE',
  INCLUSIVE = 'INCLUSIVE'
}

export type TimeRangeInput = {
  end: Scalars['ISODateTime'];
  start: Scalars['ISODateTime'];
};

export type ToggleDraftLockResponse = {
  __typename: 'ToggleDraftLockResponse';
  id: Scalars['ID'];
  isLocked: Scalars['Boolean'];
};

export type UnansweredTicketQuestion = AnsweredTicketQuestion & {
  __typename: 'UnansweredTicketQuestion';
  question: TicketQuestion;
};

export type UnansweredTicketQuestionInput = {
  questionId: Scalars['ID'];
};

export type UnassignStickerRequest = {
  stickerId: Scalars['ID'];
};

export type UnauthenticatedGuest = {
  __typename: 'UnauthenticatedGuest';
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** UnauthenticatedVisitResult represents the visit for a single GuestInvite. The result is "unauthenticated" because it is available to unauthenticated queries. A UnauthenticatedVisitResult is the guest (GuestInvite) along with information about their associated Visit. */
export type UnauthenticatedVisitResult = {
  __typename: 'UnauthenticatedVisitResult';
  arrivalInstructions: Maybe<Scalars['String']>;
  arrivalLocation: PublicLocationOrDefault;
  arrivalLocationId: Scalars['String'];
  checkinOn: Maybe<Scalars['String']>;
  checkoutOn: Maybe<Scalars['String']>;
  customVisitType: Scalars['String'];
  guest: UnauthenticatedGuest;
  healthCheckpointSurveyResponse: Maybe<GenericHealthCheckpointResponse>;
  host: PublicUserWithEmail;
  /** The ID of the GuestInvite */
  id: Scalars['ID'];
  organization: PublicOrganization;
  startTime: Scalars['ISODateTime'];
  status: GuestInviteStatus;
  /** The ID of the associated visit */
  visitId: Scalars['ID'];
  /** @deprecated replaced by the more flexible customVisitType */
  visitType: VisitType;
};

export enum UnbookableReasonType {
  ADMIN_ONLY_BOOKING = 'ADMIN_ONLY_BOOKING',
  CONFLICT_WITH_ANOTHER_MEETING = 'CONFLICT_WITH_ANOTHER_MEETING',
  LACKING_SPACE_BOOKING_PERMISSIONS = 'LACKING_SPACE_BOOKING_PERMISSIONS',
  OUTSIDE_WORKING_HOURS = 'OUTSIDE_WORKING_HOURS',
  OVER_MAX_LENGTH = 'OVER_MAX_LENGTH',
  RECURRENCE_NOT_ALLOWED = 'RECURRENCE_NOT_ALLOWED',
  TOO_FAR_IN_FUTURE = 'TOO_FAR_IN_FUTURE'
}

export type UnconfirmableReason = {
  __typename: 'UnconfirmableReason';
  reason: UnconfirmableReasonType;
  value: Maybe<Scalars['String']>;
};

export enum UnconfirmableReasonType {
  CANNOT_CONFIRM_SERIES_MASTER = 'CANNOT_CONFIRM_SERIES_MASTER',
  CANNOT_CONFIRM_SHARED_DESK = 'CANNOT_CONFIRM_SHARED_DESK',
  CHECKIN_DISABLED = 'CHECKIN_DISABLED',
  MISSING_RESERVATION_END_TIME = 'MISSING_RESERVATION_END_TIME',
  OUTSIDE_OF_CHECK_IN_WINDOW = 'OUTSIDE_OF_CHECK_IN_WINDOW'
}

export type UngroupedResourceSaveUpdateInput = {
  amenityIds: Array<Scalars['ID']>;
  bookingType: WeeklyBookingCommand;
  capacity: Scalars['Int'];
  customResourceInstanceId: Scalars['ID'];
  floorId: Scalars['ID'];
  imageUrl?: InputMaybe<Scalars['String']>;
  isAccessible?: InputMaybe<Scalars['Boolean']>;
  locationId: Scalars['ID'];
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  originatingCustomResourceTemplateId: Scalars['ID'];
  policyConfiguration?: InputMaybe<CustomResourcePolicyDocumentCommand>;
  subCategory: Scalars['String'];
};

export type UnhealthyCalendar = {
  __typename: 'UnhealthyCalendar';
  daysSinceSpaceUpdated: Scalars['Int'];
  daysSinceSynced: Scalars['Int'];
  id: Scalars['ID'];
  spaceId: Scalars['ID'];
  spaceName: Scalars['String'];
};

export type UniqueIssueReportValues = {
  __typename: 'UniqueIssueReportValues';
  assignees: Array<Maybe<UserOrGroupUnion>>;
  categories: Array<IssueReportCategory>;
  originProducts: Array<TicketOriginProduct>;
  regardingEntities: Array<Maybe<TicketEntityUnion>>;
  requesters: Array<Maybe<User>>;
};

export type UniqueMeetingServiceRequestValues = {
  __typename: 'UniqueMeetingServiceRequestValues';
  approvers: Array<Maybe<UserOrGroupUnion>>;
  assignees: Array<Maybe<UserOrGroupUnion>>;
  meetingServices: Array<MeetingService>;
  meetingServicesCategories: Array<MeetingServicesCategory>;
  regardingSpaces: Array<Maybe<Space>>;
  requesters: Array<Maybe<User>>;
};

export type Unknown = EventAuditLogActor & {
  __typename: 'Unknown';
  id: Maybe<Scalars['ID']>;
};

export type UnlinkKisiLockFromRobinLevelInput = {
  remoteLockId: Scalars['String'];
};

export type UnlinkKisiLockFromRobinLevelResponse = {
  __typename: 'UnlinkKisiLockFromRobinLevelResponse';
  uuid: Maybe<Scalars['ID']>;
};

export type UnlinkKisiLockFromRobinLocationInput = {
  remoteLockId: Scalars['String'];
};

export type UnlinkKisiLockFromRobinLocationResponse = {
  __typename: 'UnlinkKisiLockFromRobinLocationResponse';
  uuid: Maybe<Scalars['ID']>;
};

export type UnlockOpenpathDoorForProvisionedCredentialsInput = {
  doorId: Scalars['String'];
  linkToken: Scalars['String'];
};

export type UnlockOpenpathDoorForProvisionedCredentialsResponse = {
  __typename: 'UnlockOpenpathDoorForProvisionedCredentialsResponse';
  uuid: Scalars['ID'];
};

export type UnsatisfiedBusinessUnit = {
  __typename: 'UnsatisfiedBusinessUnit';
  /** What the floor split places. Below required is short, above is overprovisioned. */
  allocated: Scalars['Int'];
  businessUnitId: Scalars['ID'];
  /** What the variation asks for. */
  required: Scalars['Int'];
  type: AllocationResourceType;
};

export enum UpdatableMeetingServiceRequestStatus {
  BLOCKED = 'BLOCKED',
  CANCELLED = 'CANCELLED',
  DONE = 'DONE',
  IN_PROGRESS = 'IN_PROGRESS',
  TODO = 'TODO'
}

export type UpdateActivityInput = {
  activityLocation?: InputMaybe<Scalars['String']>;
  /** The ID of the image to link to the activity */
  coverImageId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  end: Scalars['ISODateTime'];
  start: Scalars['ISODateTime'];
  timezone: Scalars['String'];
  title: Scalars['String'];
  virtualLocation?: InputMaybe<Scalars['String']>;
};

export type UpdateAllocationMetadataInput = {
  allocationId: Scalars['ID'];
  /** Left alone when omitted; send null to clear it. */
  description?: InputMaybe<Scalars['String']>;
  /** Left alone when omitted. Null is refused: a draft has to be called something. */
  name?: InputMaybe<Scalars['String']>;
  /** The version last read. The update is refused if the draft has changed since, rather than overwriting whoever got there first. */
  version: Scalars['Int'];
};

export type UpdateBookingWindowPolicyInput = {
  locationId: Scalars['ID'];
  policy?: InputMaybe<BookingWindowPolicyDefinitionInput>;
  policyId: Scalars['ID'];
};

export type UpdateDefaultPassInput = {
  isDefaultAccessPassEnabled: Scalars['Boolean'];
};

export type UpdateDeliveryInput = {
  additionalNotes?: InputMaybe<Scalars['String']>;
  carrier?: InputMaybe<Scalars['String']>;
  deliveryZoneId?: InputMaybe<Scalars['String']>;
  recipient?: InputMaybe<RecipientInput>;
  status?: InputMaybe<DeliveryStatus>;
  trackingNumber?: InputMaybe<Scalars['String']>;
};

export type UpdateDeliveryZoneInput = {
  levelId?: InputMaybe<Scalars['ID']>;
  locationId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  spaceId?: InputMaybe<Scalars['ID']>;
};

export type UpdateDeskReservationResponse = {
  __typename: 'UpdateDeskReservationResponse';
  updatedReservations: Array<UpdatedReservation>;
};

export type UpdateDraftDataResponse = {
  __typename: 'UpdateDraftDataResponse';
  deskEntities: Array<Maybe<DeskEntity>>;
  draftAccessLevel: DraftAccessLevel;
  entities: Array<Maybe<Entity>>;
  floor: Level;
  id: Scalars['ID'];
  isAnonymityOn: Scalars['Boolean'];
  metadata: DraftMetadata;
  neighborhoodEntities: Array<Maybe<NeighborhoodEntity>>;
  queue: Array<Maybe<DraftAccountUser>>;
  reviewVersion: Scalars['Int'];
  settings: Array<DraftSettings>;
  showNeighborhoodColor: Scalars['Boolean'];
};

export type UpdateDraftDataV2Response = {
  __typename: 'UpdateDraftDataV2Response';
  deskEntities: Array<Maybe<DeskEntity>>;
  draftAccessLevel: DraftAccessLevel;
  draftFloors: Array<DraftFloorInfo>;
  entities: Array<Maybe<Entity>>;
  floor: Level;
  id: Scalars['ID'];
  isAnonymityOn: Scalars['Boolean'];
  metadata: DraftMetadata;
  neighborhoodEntities: Array<Maybe<NeighborhoodEntity>>;
  queue: Array<Maybe<DraftAccountUser>>;
  reviewVersion: Scalars['Int'];
  settings: Array<DraftSettings>;
  showNeighborhoodColor: ShowNeighborhoodColorSetting;
};

export type UpdateDraftMetadataV2Response = {
  __typename: 'UpdateDraftMetadataV2Response';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateDraftNeighborhoodResponse = {
  __typename: 'UpdateDraftNeighborhoodResponse';
  id: Scalars['ID'];
};

export type UpdateDraftResponse = {
  __typename: 'UpdateDraftResponse';
  affectedUsers: Array<Maybe<DraftAccountUser>>;
  autoUnassignments: Maybe<Array<AutoUnassignmentAction>>;
  entities: Array<Maybe<Entity>>;
  id: Scalars['ID'];
  metadata: DraftMetadata;
};

export type UpdateEventError = {
  __typename: 'UpdateEventError';
  message: Maybe<Scalars['String']>;
  reason: Maybe<EventUpdateFailReasons>;
};

/** Reservation response */
export type UpdateEventResponse = {
  __typename: 'UpdateEventResponse';
  /** If the event has not been updated, an explanation will be provided */
  error: Maybe<UpdateEventError>;
  /** True if event has been updated */
  eventUpdated: Scalars['Boolean'];
  /** Updated event model */
  updatedEvent: Maybe<Event>;
};

export type UpdateEventV2Error = {
  __typename: 'UpdateEventV2Error';
  message: Maybe<Scalars['String']>;
  reason: UpdateEventV2FailReason;
};

/** Why the update was rejected synchronously. Rooms accept or decline asynchronously after the update, so an UpdateEventV2Success does not guarantee every room accepted the new details. */
export enum UpdateEventV2FailReason {
  /** No event with that ID is visible to the actor. */
  EVENT_NOT_FOUND = 'EVENT_NOT_FOUND',
  /** robin-api rejected the request body. */
  INVALID_INPUT = 'INVALID_INPUT',
  /** The actor, or their calendar account, may not update this event. When the event is read to fill an attendee list this is decided before anything is written, from the same permissions the composer checks before opening an edit; otherwise robin-api decides on the write. */
  LACKING_PERMISSIONS = 'LACKING_PERMISSIONS',
  /** spaceInvitees left out the room whose calendar organizes the event. */
  ORGANIZER_SPACE_CHANGE_NOT_ALLOWED = 'ORGANIZER_SPACE_CHANGE_NOT_ALLOWED',
  /** recurrence was sent with scope THIS_EVENT. */
  RECURRENCE_NOT_ALLOWED_FOR_SCOPE = 'RECURRENCE_NOT_ALLOWED_FOR_SCOPE',
  /** A room is booked or its booking policy forbids the new window. */
  SPACE_UNAVAILABLE = 'SPACE_UNAVAILABLE',
  UNKNOWN = 'UNKNOWN'
}

/** Input for updateEventV2, a partial update. A field that is omitted is left as it is on the event. Lists replace the event's current list wholesale, so a person or room left out of a list is removed from the event. Mirrors the event composer's edit payload. */
export type UpdateEventV2Input = {
  /** Update acting as the room rather than the organizer, for actors who may update the room's copy of the event but not the event itself. */
  asSpace?: Scalars['Boolean'];
  /** Omit to leave unchanged; null clears the description. */
  description?: InputMaybe<Scalars['String']>;
  /** Omit or null to leave unchanged. See start. */
  end?: InputMaybe<DateWithTimezone>;
  eventId: Scalars['ID'];
  /** Replaces the event's people. Omit or null to leave them unchanged. robin-api replaces people and rooms together, so when only one list is sent the other is read from the event first and re-sent as it is, each person with their current RSVP; an edit made by someone else between that read and this update is overwritten. Send each retained person's responseStatus: when the set of people changes, robin-api rewrites every attendee on the calendar, and a person sent without a status reads as not having answered. A people-only edit also drops rooms that have declined, as the composer does. */
  invitees?: InputMaybe<Array<UpdateEventV2InviteeInput>>;
  /** Private events hide their details from other users. Omit or null to leave unchanged. */
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  /** Omit or null to leave the series recurrence unchanged. Rejected with RECURRENCE_NOT_ALLOWED_FOR_SCOPE when scope is THIS_EVENT: a single occurrence cannot carry a recurrence rule. */
  recurrence?: InputMaybe<UpdateEventV2RecurrenceInput>;
  scope: UpdateEventV2Scope;
  /** Replaces the event's rooms. Omit or null to leave them unchanged (see invitees for how the two lists are sent together; rooms are re-sent minus any that declined, except the organizing room, which always stays). The room whose calendar organizes the event must stay in the list: dropping it is rejected with ORGANIZER_SPACE_CHANGE_NOT_ALLOWED, because that room is changed with a move, not here. */
  spaceInvitees?: InputMaybe<Array<CreateEventV2SpaceInviteeInput>>;
  /** Omit or null to leave unchanged. When both bounds are sent, all-day is derived from them as on create: both at midnight in their time zone and spanning whole days means all-day, anything else means timed. A lone bound is read the way the event already is. */
  start?: InputMaybe<DateWithTimezone>;
  /** Omit to leave unchanged; null clears the title and robin-api assigns one. */
  title?: InputMaybe<Scalars['String']>;
};

/** A person on an update, with the RSVP they already gave. The event composer sends each person's current status back with every edit; without it the person is re-invited as if they had never answered. */
export type UpdateEventV2InviteeInput = {
  invitee: CreateEventV2InviteeInput;
  /** The person's current RSVP, as read from the event. Omit or null for someone being added, who has not responded yet. */
  responseStatus?: InputMaybe<EventResponseStatus>;
};

/** A recurrence change. Wrapping the rules in an input keeps three states apart: omit `recurrence` to leave the series as it is, send `{ rules: [] }` to make the event one-off, send `{ rules: [rule] }` to set the recurrence. */
export type UpdateEventV2RecurrenceInput = {
  rules: Array<Scalars['RecurrenceRule']>;
};

/** Either the updated event, or why the update failed. Never both. */
export type UpdateEventV2Response = UpdateEventV2Error | UpdateEventV2Success;

/** Which occurrences of a recurring event an update applies to. */
export enum UpdateEventV2Scope {
  /** Every occurrence in the series. */
  ALL_EVENTS = 'ALL_EVENTS',
  /** This occurrence and every later one. robin-api splits the series here and creates a new one, so the response carries a new event ID. */
  THIS_AND_FOLLOWING = 'THIS_AND_FOLLOWING',
  /** Only this event. For a recurring event, only this occurrence. */
  THIS_EVENT = 'THIS_EVENT'
}

export type UpdateEventV2Success = {
  __typename: 'UpdateEventV2Success';
  /** ID of the event as robin-api returned it. For THIS_AND_FOLLOWING this is the new series created at the split point, and callers must use it from now on. */
  eventId: Scalars['ID'];
};

export type UpdateFloorAllocationsInput = {
  allocationId: Scalars['ID'];
  /** Floors to write. Each replaces that floor's split outright. Floors left out are untouched — send a floor with an empty `businessUnits` to clear it. */
  floors: Array<FloorAllocationInput>;
  /** The version last read. The update is refused if the draft has changed since, rather than overwriting whoever got there first. */
  version: Scalars['Int'];
};

export type UpdateFloorAllocationsResponse = {
  __typename: 'UpdateFloorAllocationsResponse';
  id: Scalars['ID'];
  /** Business units the split still does not satisfy, after this write. */
  unsatisfied: Array<UnsatisfiedBusinessUnit>;
  /** Pass back on the next update. */
  version: Scalars['Int'];
};

export type UpdateGenericConnectorAccountInput = {
  integrationUuid: Scalars['ID'];
  isDisabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateGenericConnectorAccountResponse = {
  __typename: 'UpdateGenericConnectorAccountResponse';
  uuid: Scalars['ID'];
};

/** Omit fields to avoid changing them. Explicit nulls are disallowed on fields that cannot be set to null. A requester may only `setTitle`, `setDescription`, `setImageUrls`, change its amenities, and cancel their own report before anyone picks it up. Any other change is refused for them, and a call mixing permitted and forbidden changes is refused whole. */
export type UpdateIssueReportChangesInput = {
  /** Idempotent. Amenity catalog IDs (Amenity.id), each of which must be on the space or desk the report regards. */
  addAmenityIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Idempotent */
  addAssignees?: InputMaybe<UsersAndGroupsInput>;
  /** Idempotent. Applied first before addAmenityIds. */
  removeAmenityIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Idempotent. Applied first before addAssignees. */
  removeAssignees?: InputMaybe<UsersAndGroupsInput>;
  setDescription?: InputMaybe<EtaggedStringInput>;
  /** A set of image service URLs depicting the issue. */
  setImageUrls?: InputMaybe<EtaggedStringListInput>;
  setPriority?: InputMaybe<TicketPriority>;
  /** A requester may only move their own report from TODO to CANCELLED. An assignee can make any status transition. */
  setStatus?: InputMaybe<IssueReportStatus>;
  setTitle?: InputMaybe<Scalars['String']>;
};

export enum UpdateIssueReportErrorReason {
  /** A change's `ifMatch` no longer identifies the value it would have replaced. Read the report again, reconcile against what is there now, and retry. */
  PRECONDITION_FAILED = 'PRECONDITION_FAILED'
}

export type UpdateIssueReportErrorResponse = {
  __typename: 'UpdateIssueReportErrorResponse';
  /** Additional details suitable for debugging or logging */
  details: Maybe<Scalars['JSON']>;
  reason: UpdateIssueReportErrorReason;
};

export type UpdateIssueReportInput = {
  changes: UpdateIssueReportChangesInput;
  identifier: TicketIdentifierInput;
};

export type UpdateIssueReportResponse = UpdateIssueReportErrorResponse | UpdateIssueReportSuccessResponse;

export type UpdateIssueReportSuccessResponse = {
  __typename: 'UpdateIssueReportSuccessResponse';
  /** To allow clients to update description again without another round trip */
  descriptionEtag: Scalars['ETag'];
  imageUrlsEtag: Scalars['ETag'];
  updatedAt: Scalars['ISODateTime'];
};

export type UpdateLayoutDraftResponse = {
  __typename: 'UpdateLayoutDraftResponse';
  entities: Array<Maybe<LayoutChangeEntity>>;
  groupEntities: Array<Maybe<LayoutResourceGroupEntity>>;
  id: Scalars['ID'];
  metadata: DraftMetadata;
};

export type UpdateMeetingServiceChangesInput = {
  assignees?: InputMaybe<UsersAndGroupsInput>;
  /** Use null to make unavailable everywhere, omit to avoid changes. Unlike other collections on this input, this field supports partial updates. Buildings not listed here will be unchanged. To make unavailable in an entire building, send an empty array of space IDs for that building. To change the spaces in a building, send up the entire new array of space IDs for that building. This frees the client from grabbing every space ID in every building up front, which could be an expensive operation for services available in large orgs. To make sure these rules are understood by the client, empty array is not allowed and the name is different than the addMeetingService input. Omit the field to avoid changes. */
  availableInSpacesByBuildingChanges?: InputMaybe<Array<MeetingServiceAvailableInSpacesByBuildingInput>>;
  categoryId?: InputMaybe<Scalars['ID']>;
  currencyCode?: InputMaybe<Scalars['CurrencyCodeISO4217']>;
  description?: InputMaybe<Scalars['Markdown']>;
  multipleApprovers?: InputMaybe<UsersAndGroupsInput>;
  name?: InputMaybe<Scalars['String']>;
  /** Empty array and null have the same effect: remove all questions */
  questions?: InputMaybe<Array<TicketQuestionInput>>;
};

export type UpdateMeetingServiceErrorResponse = {
  __typename: 'UpdateMeetingServiceErrorResponse';
  reason: Maybe<UpdateMeetingServiceErrorResponseReason>;
};

export enum UpdateMeetingServiceErrorResponseReason {
  CATEGORY_MISSING = 'CATEGORY_MISSING',
  /** meeting service version ID is not the latest version for the meeting service */
  CONFLICT = 'CONFLICT',
  /** This meeting service has kind=SPACE_REQUEST_FORM, and one of its spaces already has a request form */
  SPACE_ALREADY_HAS_REQUEST_FORM = 'SPACE_ALREADY_HAS_REQUEST_FORM'
}

export type UpdateMeetingServiceInput = {
  changes: UpdateMeetingServiceChangesInput;
  meetingServiceId: Scalars['ID'];
  /** The latest version ID for the meeting service you want to change. If this is not the latest version, say because someone edited the service out from under you, then the update will fail. The user should consult the latest version to avoid blowing away updates made by other people. */
  meetingServiceVersionId: Scalars['ID'];
};

export enum UpdateMeetingServiceRequestStatusErrorReason {
  /** Events that have ended can only change to Canceled/Done */
  EVENT_ALREADY_ENDED = 'EVENT_ALREADY_ENDED',
  /** Cannot un-cancel status because event or space no longer exists */
  EVENT_OR_SPACE_NO_LONGER_EXISTS = 'EVENT_OR_SPACE_NO_LONGER_EXISTS',
  /** Another user already changed the status */
  STATUS_ALREADY_CHANGED = 'STATUS_ALREADY_CHANGED',
  /** The user is not assigned to the ticket */
  USER_NOT_ASSIGNEE = 'USER_NOT_ASSIGNEE'
}

export type UpdateMeetingServiceRequestStatusErrorResponse = {
  __typename: 'UpdateMeetingServiceRequestStatusErrorResponse';
  reason: UpdateMeetingServiceRequestStatusErrorReason;
};

export type UpdateMeetingServiceRequestStatusInput = {
  meetingServiceRequestId: Scalars['ID'];
  updatableMeetingServiceRequestStatus: UpdatableMeetingServiceRequestStatus;
};

export type UpdateMeetingServiceRequestStatusSuccessResponse = {
  __typename: 'UpdateMeetingServiceRequestStatusSuccessResponse';
  _: Maybe<Scalars['Void']>;
  /** @deprecated Does not change */
  meetingServiceRequestId: Scalars['ID'];
  /** @deprecated Refetch status with getMeetingServiceRequestByIdentifier instead */
  meetingServiceRequestStatus: MeetingServiceRequestStatus;
};

export type UpdateMeetingServiceResponse = UpdateMeetingServiceErrorResponse | UpdateMeetingServiceSuccessResponse;

export type UpdateMeetingServiceSuccessResponse = {
  __typename: 'UpdateMeetingServiceSuccessResponse';
  meetingServiceVersionId: Scalars['ID'];
};

/** Set a field to null to avoid changing it on the reservation. */
export type UpdateMyReservationDeskAndTimeFrameInput = {
  end?: InputMaybe<DateWithTimezone>;
  reservationId: Scalars['ID'];
  seatId?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<DateWithTimezone>;
};

export type UpdatePlanningDraftMetadataResponse = {
  __typename: 'UpdatePlanningDraftMetadataResponse';
  description: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Pass back on the next update. */
  version: Scalars['Int'];
};

export type UpdateShowNeighborhoodColorResponse = {
  __typename: 'UpdateShowNeighborhoodColorResponse';
  id: Scalars['ID'];
  showNeighborhoodColor: Scalars['Boolean'];
  version: Scalars['Int'];
};

export type UpdateShowNeighborhoodColorV2Response = {
  __typename: 'UpdateShowNeighborhoodColorV2Response';
  floorId: Scalars['ID'];
  id: Scalars['ID'];
  showNeighborhoodColor: Scalars['Boolean'];
  version: Scalars['Int'];
};

export type UpdateStackPlanAllocationInput = {
  /** Which variation to rewrite. Must already exist on the plan, and must not yet be implemented by an allocation draft. */
  allocationId: Scalars['ID'];
  businessUnits: Array<BusinessUnitAllocationInput>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  stackPlanId: Scalars['ID'];
  /** The stack plan version last read. The update is refused if the plan has changed since, rather than overwriting whoever got there first. */
  version: Scalars['Int'];
};

export type UpdateStackPlanAllocationResponse = {
  __typename: 'UpdateStackPlanAllocationResponse';
  allocation: StackPlanAllocation;
  /** Pass back on the next update. */
  version: Scalars['Int'];
};

export type UpdateStackPlanMetadataInput = {
  /** Left alone when omitted; send null to clear it. */
  description?: InputMaybe<Scalars['String']>;
  /** Left alone when omitted. Null is refused: a draft has to be called something. */
  name?: InputMaybe<Scalars['String']>;
  stackPlanId: Scalars['ID'];
  /** The version last read. The update is refused if the plan has changed since, rather than overwriting whoever got there first. */
  version: Scalars['Int'];
};

export type UpdateWorkAreaInput = {
  deskIds: Array<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateWorkAreasInput = {
  workAreasToCreate: Array<CreateWorkAreaInput>;
  workAreasToDelete: Array<Scalars['ID']>;
  workAreasToUpdate: Array<UpdateWorkAreaInput>;
};

export type UpdatedReservation = {
  __typename: 'UpdatedReservation';
  id: Scalars['ID'];
};

export type UploadCsvForcePushRecords = {
  uuid: Scalars['ID'];
};

export type UploadCsvVendor = {
  __typename: 'UploadCSVVendor';
  name: Scalars['ID'];
};

/** No mappings are written when any item is invalid (the upsert is all-or-nothing). */
export type UpsertTicketIntegrationEntityMappingsErrorResponse = {
  __typename: 'UpsertTicketIntegrationEntityMappingsErrorResponse';
  itemErrors: Array<UpsertTicketIntegrationEntityMappingsItemError>;
};

export type UpsertTicketIntegrationEntityMappingsInput = {
  entityMappings: Array<TicketIntegrationEntityMappingInput>;
  integrationId: Scalars['ID'];
};

export type UpsertTicketIntegrationEntityMappingsItemError = {
  __typename: 'UpsertTicketIntegrationEntityMappingsItemError';
  /** Index into the input `entityMappings` list. */
  index: Scalars['Int'];
  reason: UpsertTicketIntegrationEntityMappingsItemErrorReason;
};

export enum UpsertTicketIntegrationEntityMappingsItemErrorReason {
  /** The Robin entity does not exist in this tenant. */
  ENTITY_NOT_FOUND = 'ENTITY_NOT_FOUND',
  /** The supplied externalObjectType is not in the integration provider's representation family (re-list and retry). */
  REPRESENTATION_MISMATCH = 'REPRESENTATION_MISMATCH'
}

export type UpsertTicketIntegrationEntityMappingsResponse = UpsertTicketIntegrationEntityMappingsErrorResponse | UpsertTicketIntegrationEntityMappingsSuccessResponse;

export type UpsertTicketIntegrationEntityMappingsSuccessResponse = {
  __typename: 'UpsertTicketIntegrationEntityMappingsSuccessResponse';
  entityMappings: Array<TicketIntegrationEntityMapping>;
};

/** No rows are written when any item is invalid (the upsert is all-or-nothing). */
export type UpsertTicketIntegrationFieldMappingsErrorResponse = {
  __typename: 'UpsertTicketIntegrationFieldMappingsErrorResponse';
  itemErrors: Array<UpsertTicketIntegrationFieldMappingsItemError>;
};

export type UpsertTicketIntegrationFieldMappingsInput = {
  integrationId: Scalars['ID'];
  mappings: Array<TicketIntegrationFieldMappingInput>;
  /** Fill-if-absent: writes provider-default bindings for the seeded target config's fields that have no stored mapping, saved under that config's id, then applies `mappings`. Never overwrites an edited row, so retries are safe. */
  seedDefaults?: Scalars['Boolean'];
  /** The target config `seedDefaults` fills. Null = the integration's default target config. One the integration does not have is a user input error. */
  seedTargetConfigId?: InputMaybe<Scalars['ID']>;
  /** Null = the integration-level scope. */
  workflowId?: InputMaybe<Scalars['ID']>;
};

export type UpsertTicketIntegrationFieldMappingsItemError = {
  __typename: 'UpsertTicketIntegrationFieldMappingsItemError';
  /** Index into the binding's `entries` or `templates` when the reason is about one of them; null otherwise. */
  entryIndex: Maybe<Scalars['Int']>;
  /** Index into the submitted `mappings` array. */
  index: Scalars['Int'];
  reason: UpsertTicketIntegrationFieldMappingsItemErrorReason;
};

export enum UpsertTicketIntegrationFieldMappingsItemErrorReason {
  /** The binding kind is not yet supported on the write path. */
  BINDING_NOT_SUPPORTED = 'BINDING_NOT_SUPPORTED',
  /** The binding kind cannot fill the target field's type (e.g. tags into a SELECT). */
  BINDING_TYPE_MISMATCH = 'BINDING_TYPE_MISMATCH',
  /** INBOUND and BIDIRECTIONAL need a binding Robin can reverse: a sourceField, or a valueMap with one source value per option. */
  DIRECTION_NOT_SUPPORTED = 'DIRECTION_NOT_SUPPORTED',
  /** Two entries in one valueMap share a sourceValue. */
  DUPLICATE_SOURCE_VALUE = 'DUPLICATE_SOURCE_VALUE',
  /** Two mappings in one call address the same target field and scope. */
  DUPLICATE_TARGET_FIELD = 'DUPLICATE_TARGET_FIELD',
  /** A referenced option is not one of the target field's options. */
  OPTION_NOT_FOUND = 'OPTION_NOT_FOUND',
  /** A binding or template references a key missing from the source-field catalog. */
  SOURCE_FIELD_UNKNOWN = 'SOURCE_FIELD_UNKNOWN',
  /** A valueMap sourceValue is not in the ENUM source field's allowedValues. */
  SOURCE_VALUE_UNKNOWN = 'SOURCE_VALUE_UNKNOWN',
  /** A static value does not parse for the target field's type (e.g. non-numeric into NUMBER). */
  STATIC_VALUE_INVALID = 'STATIC_VALUE_INVALID',
  TARGET_CONFIG_NOT_FOUND = 'TARGET_CONFIG_NOT_FOUND',
  TARGET_FIELD_NOT_FOUND = 'TARGET_FIELD_NOT_FOUND',
  /** Unbalanced or unparseable {{placeholders}}, or forbidden template syntax. */
  TEMPLATE_INVALID = 'TEMPLATE_INVALID',
  /** A required text input is empty or whitespace-only. */
  VALUE_BLANK = 'VALUE_BLANK',
  /** A template, value, or key exceeds its length cap (255 for keys, 1024 for values). */
  VALUE_TOO_LONG = 'VALUE_TOO_LONG'
}

export enum UpsertTicketIntegrationFieldMappingsProviderErrorReason {
  NOT_CONNECTED = 'NOT_CONNECTED',
  PROVIDER_CAPABILITY_MISSING = 'PROVIDER_CAPABILITY_MISSING',
  PROVIDER_REJECTED = 'PROVIDER_REJECTED',
  PROVIDER_UNREACHABLE = 'PROVIDER_UNREACHABLE'
}

/** The provider's target fields could not be read, so nothing was checked or written. */
export type UpsertTicketIntegrationFieldMappingsProviderErrorResponse = {
  __typename: 'UpsertTicketIntegrationFieldMappingsProviderErrorResponse';
  reason: UpsertTicketIntegrationFieldMappingsProviderErrorReason;
};

export type UpsertTicketIntegrationFieldMappingsResponse = UpsertTicketIntegrationFieldMappingsErrorResponse | UpsertTicketIntegrationFieldMappingsProviderErrorResponse | UpsertTicketIntegrationFieldMappingsSuccessResponse;

export type UpsertTicketIntegrationFieldMappingsSuccessResponse = {
  __typename: 'UpsertTicketIntegrationFieldMappingsSuccessResponse';
  fieldMappings: Array<TicketIntegrationFieldMapping>;
};

export enum UpsertTicketIntegrationObjectClassAssignmentsErrorReason {
  /** An item failed validation: a blank class id, a non-place entity type, isCreateTarget:true with entityType:null, or an externalObjectClassId not in the provider's current catalog. */
  INVALID_INPUT = 'INVALID_INPUT',
  NOT_ACTIVE = 'NOT_ACTIVE',
  NOT_CONNECTED = 'NOT_CONNECTED',
  NOT_FOUND = 'NOT_FOUND',
  /** The provider has one fixed create target and no external object classes to choose from (ServiceNow, Zendesk). */
  PROVIDER_CAPABILITY_MISSING = 'PROVIDER_CAPABILITY_MISSING',
  /** The provider was reached and refused the request (auth/permissions) — check the connection's access, not the network. */
  PROVIDER_REJECTED = 'PROVIDER_REJECTED',
  PROVIDER_UNREACHABLE = 'PROVIDER_UNREACHABLE'
}

export type UpsertTicketIntegrationObjectClassAssignmentsErrorResponse = {
  __typename: 'UpsertTicketIntegrationObjectClassAssignmentsErrorResponse';
  message: Scalars['String'];
  reason: UpsertTicketIntegrationObjectClassAssignmentsErrorReason;
};

export type UpsertTicketIntegrationObjectClassAssignmentsInput = {
  integrationId: Scalars['ID'];
  items: Array<TicketIntegrationObjectClassAssignmentItemInput>;
};

export type UpsertTicketIntegrationObjectClassAssignmentsResponse = UpsertTicketIntegrationObjectClassAssignmentsErrorResponse | UpsertTicketIntegrationObjectClassAssignmentsSuccessResponse;

export type UpsertTicketIntegrationObjectClassAssignmentsSuccessResponse = {
  __typename: 'UpsertTicketIntegrationObjectClassAssignmentsSuccessResponse';
  objectClasses: Array<TicketIntegrationExternalObjectClass>;
};

export type User = EventAuditLogActor & {
  __typename: 'User';
  avatar: Maybe<Scalars['String']>;
  canAndShouldAskForPresencePermissionInMobile: CanAndShouldAskForPresencePermissionInMobileResponse;
  createdAt: Maybe<Scalars['String']>;
  defaultLocation: Maybe<Scalars['String']>;
  /** @deprecated Deprecated in favor of primary_email */
  email: Maybe<Scalars['String']>;
  familyName: Maybe<Scalars['String']>;
  geofenceFeatureEnabled: Scalars['Boolean'];
  givenName: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  locationState: LocationState;
  name: Maybe<Scalars['String']>;
  notificationPreferences: NotificationPreferences;
  officeAccess: Array<OfficeAccess>;
  primaryEmail: Maybe<Email>;
  reservations: Array<Reservation>;
  reservationsAtLocationGroupedByDateAscending: Array<UserDeskReservationByDate>;
  reservationsGroupedByDate: Array<UserDeskReservationByDate>;
  slug: Maybe<Scalars['String']>;
  timeZone: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['String']>;
  /** Stable identifier from robin-api, as 32 lowercase hex characters. Null for records that have not been assigned one yet. */
  uuid: Maybe<Scalars['ID']>;
  workingHours: Maybe<Array<Maybe<UserWorkingHour>>>;
};


export type UserLocationStateArgs = {
  campusId?: InputMaybe<Scalars['ID']>;
  endTime: Scalars['Date'];
  locationId: Scalars['ID'];
  recurrence?: InputMaybe<Scalars['String']>;
  startTime: Scalars['Date'];
};


export type UserReservationsArgs = {
  endTime: Scalars['Date'];
  startTime: Scalars['Date'];
};


export type UserReservationsAtLocationGroupedByDateAscendingArgs = {
  endTime: Scalars['ISODateTime'];
  locationId: Scalars['ID'];
  startTime: Scalars['ISODateTime'];
};


export type UserReservationsGroupedByDateArgs = {
  endTime: Scalars['Date'];
  startTime: Scalars['Date'];
};

export type UserAssignment = {
  __typename: 'UserAssignment';
  assignments: Array<Maybe<DeskAssignmentSchedule>>;
  avatarUrl: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName: Maybe<Scalars['String']>;
};

export type UserAssignmentChangedAuditMetadata = {
  __typename: 'UserAssignmentChangedAuditMetadata';
  desk: MetadataDeskObject;
  recurrence: Maybe<Scalars['String']>;
  user: AuditUserObject;
};

export type UserAssignmentData = {
  __typename: 'UserAssignmentData';
  assignee: Assignee;
  id: Scalars['ID'];
  schedules: Array<AssignmentData>;
};

/** A per-item failure inside a bulk user-action job. The batch itself continues. */
export type UserBulkActionItemError = {
  __typename: 'UserBulkActionItemError';
  /** Set for invite items, which are keyed by email rather than user id. */
  email: Maybe<Scalars['String']>;
  error: Scalars['String'];
  /** Activate jobs only: set when the user's organization deactivation was undone but they remain effectively disabled via SCIM or billing. */
  stillDisabled: Maybe<Array<UserBulkActionStillDisabledReason>>;
  /** Set for the id-based actions (deactivate / activate / remove). */
  userId: Maybe<Scalars['ID']>;
};

/** An asynchronous bulk user-action job, shared by all four bulk user actions. */
export type UserBulkActionJob = {
  __typename: 'UserBulkActionJob';
  actionType: UserBulkActionType;
  errors: Array<UserBulkActionItemError>;
  failureCount: Scalars['Int'];
  id: Scalars['ID'];
  /** Invite jobs only (null otherwise): successes that created and invited a new user. Null — not 0 — until the first poll reports back. */
  invitedCount: Maybe<Scalars['Int']>;
  /** Running count of submitted items processed so far — progress, not successes. */
  processedCount: Scalars['Int'];
  /** Invite jobs only (null otherwise): successes that re-sent a pending user's invitation with a fresh token. Null — not 0 — until the first poll reports back. */
  resentCount: Maybe<Scalars['Int']>;
  status: UserBulkActionJobStatus;
  successCount: Scalars['Int'];
  /** Number of items submitted with the job (user ids, or invites after dedupe). */
  totalCount: Scalars['Int'];
};

/** Lifecycle of an asynchronous bulk user-action job in robin-api. A job with any per-item failures alongside successes ends PARTIALLY_FAILED; FAILED means no item succeeded. */
export enum UserBulkActionJobStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  PARTIALLY_FAILED = 'PARTIALLY_FAILED',
  PENDING = 'PENDING'
}

/** A disable flow that survives a bulk activation. `disabled_at` is effectively COALESCE(billing, scim, organization) on the API side; bulk activation clears only the organization component — and only when it predates the job. ORGANIZATION appears when the user was re-disabled at the organization level after the job was submitted, which the job deliberately leaves intact. */
export enum UserBulkActionStillDisabledReason {
  BILLING = 'BILLING',
  ORGANIZATION = 'ORGANIZATION',
  SCIM = 'SCIM'
}

/** Which bulk user action a job performs. One job table serves all four. */
export enum UserBulkActionType {
  ACTIVATE = 'ACTIVATE',
  DEACTIVATE = 'DEACTIVATE',
  DELETE = 'DELETE',
  INVITE = 'INVITE'
}

/** One entry of a bulk invite. Email is the item's identity within the job. */
export type UserBulkInviteInput = {
  department?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  managerId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  /** IETF language tag for the invitation email, e.g. en-US. */
  preferredLanguage?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export enum UserDefaultRoleSlug {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
  OWNER = 'OWNER'
}

export type UserDeskReservation = {
  __typename: 'UserDeskReservation';
  reservations: Array<Reservation>;
  userId: Scalars['ID'];
};

export type UserDeskReservationByDate = {
  __typename: 'UserDeskReservationByDate';
  date: Scalars['Date'];
  reservations: Array<UserTruncatedReservation>;
};

export type UserInOffice = {
  __typename: 'UserInOffice';
  deskReservations: Array<Reservation>;
  employeeVisits: Array<EmployeeVisit>;
  userId: Scalars['ID'];
};

export type UserInOfficeByDay = {
  __typename: 'UserInOfficeByDay';
  date: Scalars['String'];
  userInOffice: Maybe<UserInOffice>;
};

export type UserInOfficeDataResult = {
  __typename: 'UserInOfficeDataResult';
  byDay: Array<UserInOfficeByDay>;
  userId: Scalars['ID'];
};

export type UserNotificationsSetting = {
  __typename: 'UserNotificationsSetting';
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  values: Array<Maybe<NotificationSettingType>>;
};

export type UserOrGroup = {
  __typename: 'UserOrGroup';
  userOrGroup: Maybe<UserOrGroupUnion>;
};

/** Either a group ID or a user ID is required */
export type UserOrGroupInput = {
  groupId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type UserOrGroupUnion = Group | User;

export type UserRolePermissionResult = {
  __typename: 'UserRolePermissionResult';
  action: RolePermissionAction;
  permit: Scalars['Boolean'];
};

export type UserSearchHit = GlobalSearchHit & {
  __typename: 'UserSearchHit';
  avatarUrl: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  email: Maybe<Scalars['String']>;
  entityId: Scalars['ID'];
  entityType: GlobalSearchEntityType;
  id: Scalars['ID'];
  score: Scalars['Float'];
};

export type UserSetting = {
  __typename: 'UserSetting';
  dataType: SettingDataType;
  ownerId: Scalars['ID'];
  ownerType: SettingOwnerType;
  slug: Scalars['String'];
  value: Maybe<Scalars['String']>;
};

export enum UserSortBy {
  FAVORITE = 'FAVORITE',
  NAME = 'NAME'
}

export enum UserSortOrder {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING'
}

export enum UserStatus {
  /** Completed registration or verified via SSO/SCIM; not deactivated. */
  ACTIVE = 'ACTIVE',
  /** In the org but never invited (bulk adds without emails, SCIM users awaiting first SSO login). */
  ADDED = 'ADDED',
  DEACTIVATED = 'DEACTIVATED',
  /** Has an invite older than the 14-day expiration. Derived at query time from INVITE_PENDING + last_invited_at; never stored. A resend returns the user to INVITE_PENDING. */
  INVITE_EXPIRED = 'INVITE_EXPIRED',
  /** Has an outstanding invite enqueued within the last 14 days. */
  INVITE_PENDING = 'INVITE_PENDING'
}

/** Per-status membership counts for an organization, served by one indexed GROUP BY over the user_status table. Independent of getPagedUsers pagination/filters and of its joins — a membership not yet backfilled into user_status, or missing a primary email, is absent here but may appear in getPagedUsers (and vice versa), so totals can differ slightly from accountUsersTotal during the backfill window. */
export type UserStatusCounts = {
  __typename: 'UserStatusCounts';
  active: Scalars['Int'];
  added: Scalars['Int'];
  deactivated: Scalars['Int'];
  inviteExpired: Scalars['Int'];
  invitePending: Scalars['Int'];
};

export type UserSyncStatus = {
  __typename: 'UserSyncStatus';
  state: SyncState;
  userCount: Scalars['Int'];
};

export type UserTimeFrame = {
  __typename: 'UserTimeFrame';
  end: Maybe<Scalars['Date']>;
  start: Maybe<Scalars['Date']>;
};

export type UserTimeFrameInput = {
  end: Scalars['String'];
  start: Scalars['String'];
};

export type UserTruncatedDeskConfirmation = {
  __typename: 'UserTruncatedDeskConfirmation';
  confirmedAt: Maybe<Scalars['String']>;
  deviceId: Maybe<Scalars['ID']>;
  seatReservationId: Scalars['ID'];
};

export type UserTruncatedReservation = {
  __typename: 'UserTruncatedReservation';
  /** @deprecated Broken, use `truncatedConfirmation` */
  confirmation: Maybe<DeskConfirmation>;
  endTime: Maybe<Scalars['String']>;
  healthCheckpointAnsweredAt: Maybe<Scalars['String']>;
  healthCheckpointStatus: Maybe<HealthCheckpointStatus>;
  /** Reservation Id */
  id: Scalars['ID'];
  recurrence: Maybe<Scalars['String']>;
  reservee: UserTruncatedReservee;
  seat: Desk;
  seriesId: Maybe<Scalars['ID']>;
  startTime: Scalars['String'];
  truncatedConfirmation: Maybe<UserTruncatedDeskConfirmation>;
  type: Scalars['String'];
  visibility: DeskReservationVisibility;
};

export type UserTruncatedReservee = {
  __typename: 'UserTruncatedReservee';
  email: Scalars['String'];
  participationStatus: Maybe<ParticipationStatus>;
  userId: Maybe<Scalars['ID']>;
  visitorId: Maybe<Scalars['ID']>;
};

export type UserWithDefault = {
  __typename: 'UserWithDefault';
  avatar: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['String']>;
  defaultLocation: Maybe<Scalars['String']>;
  familyName: Maybe<Scalars['String']>;
  givenName: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** If true, no user by this ID can be found in the user system */
  isDefault: Scalars['Boolean'];
  name: Maybe<Scalars['String']>;
  primaryEmail: Maybe<Email>;
  slug: Maybe<Scalars['String']>;
  timeZone: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['String']>;
  workingHours: Maybe<Array<Maybe<UserWorkingHour>>>;
};

export type UserWorkingHour = {
  __typename: 'UserWorkingHour';
  day: Maybe<Scalars['Int']>;
  timeFrames: Array<Maybe<UserTimeFrame>>;
};

export type UserWorkingHourInput = {
  day: Scalars['Int'];
  timeFrames: Array<UserTimeFrameInput>;
};

export type UsersAndGroups = {
  __typename: 'UsersAndGroups';
  groups: Array<Maybe<Group>>;
  /** Users and Groups in one list - use fragments to select fields */
  usersAndGroups: Array<Maybe<UserOrGroupUnion>>;
  /** groups also contain users, but these are in addition to the users from the groups */
  usersOutsideOfGroups: Array<Maybe<User>>;
};

export type UsersAndGroupsInput = {
  groupIds: Array<Scalars['ID']>;
  userIds: Array<Scalars['ID']>;
};

export enum VisitDocumentStatus {
  ARCHIVED = 'ARCHIVED',
  INACTIVE = 'INACTIVE',
  LIVE = 'LIVE'
}

export enum VerkadaTenancy {
  AU = 'AU',
  EU = 'EU',
  GOV = 'GOV',
  US = 'US'
}

export type Visit = {
  __typename: 'Visit';
  /** What does the guest need to do when they arrive?. Default to null */
  arrivalInstructions: Maybe<Scalars['String']>;
  /** Arrival location */
  arrivalLocation: Location;
  /** ID of the location where the guests should arrive and check-in */
  arrivalLocationId: Scalars['ID'];
  /** The custom fields for the visit */
  customFields: Maybe<Array<CustomField>>;
  /** Custom reason for this visit */
  customVisitType: Maybe<Scalars['String']>;
  /** A custom email configuration associated with the visit's location */
  emailConfiguration: Maybe<EmailConfiguration>;
  /** Number of guests in the visit */
  guestCount: Maybe<Scalars['Int']>;
  /** Guest invitations */
  guestInvites: Array<GuestInvite>;
  /** Guests for this visit */
  guests: Array<Guest>;
  /**
   * Host robin user
   * @deprecated Use hosts field instead for multiple host support
   */
  host: UserWithDefault;
  /**
   * ID of user acting as host for this visit
   * @deprecated Use hosts field instead for multiple host support
   */
  hostUserId: Scalars['ID'];
  /** Hosts for this visit with configurable settings */
  hosts: Array<VisitHost>;
  /** Visit unique identifier */
  id: Scalars['ID'];
  /** Organization */
  organization: Organization;
  /** How was the visit created? */
  organizer: VisitOrganizer;
  /** Start time of visit represented by ISO 8601 date-time */
  startTime: Scalars['ISODateTime'];
  /**
   * Reason for this visit
   * @deprecated replaced by the more flexible customVisitType
   */
  visitType: VisitType;
};


export type VisitGuestInvitesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type VisitGuestsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export enum VisitAsyncRequestReport {
  DONE = 'DONE',
  ERROR = 'ERROR',
  HCP_CREATED = 'HCP_CREATED',
  VISIT_CREATED = 'VISIT_CREATED'
}

export enum VisitAsyncRequestStatus {
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
  IN_PROGRESS = 'IN_PROGRESS',
  REQUEST_RECEIVED = 'REQUEST_RECEIVED'
}

export type VisitAsyncRequestStatusResponse = {
  __typename: 'VisitAsyncRequestStatusResponse';
  errorText: Array<Scalars['String']>;
  status: Maybe<VisitAsyncRequestStatus>;
};

export type VisitDocumentAgreementOutcome = {
  __typename: 'VisitDocumentAgreementOutcome';
  id: Scalars['ID'];
  outcome: VisitDocumentAgreementStatus;
};

export type VisitDocumentAgreementResponse = {
  __typename: 'VisitDocumentAgreementResponse';
  completionStatus: VisitDocumentCompletionStatus;
  documentBody: Scalars['DocumentBody'];
  documentName: Scalars['String'];
  id: Scalars['ID'];
  isRequired: Scalars['Boolean'];
  /** Whether the guest must provide a drawn signature when agreeing to this document */
  isSignatureRequired: Scalars['Boolean'];
  possibleOutcomes: Array<VisitDocumentAgreementOutcome>;
  selectedOutcome: Maybe<VisitDocumentAgreementOutcome>;
};

export enum VisitDocumentAgreementStatus {
  ACCEPT = 'ACCEPT'
}

export type VisitDocumentAgreementWithNextDocumentResponse = {
  __typename: 'VisitDocumentAgreementWithNextDocumentResponse';
  completionStatus: VisitDocumentCompletionStatus;
  documentBody: Scalars['DocumentBody'];
  documentName: Scalars['String'];
  id: Scalars['ID'];
  isRequired: Scalars['Boolean'];
  /** Whether the guest must provide a drawn signature when agreeing to this document */
  isSignatureRequired: Scalars['Boolean'];
  /** If NULL, there is no next document */
  nextDocumentId: Maybe<Scalars['ID']>;
  possibleOutcomes: Array<VisitDocumentAgreementOutcome>;
  selectedOutcome: Maybe<VisitDocumentAgreementOutcome>;
  workflowId: Scalars['ID'];
};

export type VisitDocumentByDecisionResponse = {
  __typename: 'VisitDocumentByDecisionResponse';
  /** Date and time the document was accepted for specified decision */
  agreedOn: Scalars['ISODateTime'];
  /** Document body */
  body: Scalars['DocumentBody'];
  /** ID of document associated with descition */
  id: Scalars['ID'];
  /** Document name */
  name: Scalars['String'];
  /** Email addresses of individuals notified via email */
  notificationEmails: Array<Scalars['String']>;
  /** URL of the signature image captured when the document was agreed to, if any */
  signatureImageUrl: Maybe<Scalars['String']>;
  /** Associated visit model */
  visit: VisitOrDefault;
};

export enum VisitDocumentCompletionStatus {
  COMPLETE = 'COMPLETE',
  INCOMPLETE = 'INCOMPLETE'
}

export enum VisitDocumentNameStatusAndTypesField {
  LOCATION_ID = 'LOCATION_ID',
  STATUS = 'STATUS',
  VISIT_TYPE = 'VISIT_TYPE'
}

export type VisitDocumentNameStatusAndTypesFilter = {
  filterOn: VisitDocumentNameStatusAndTypesField;
  filterValues: Array<Scalars['String']>;
};

export type VisitDocumentNameStatusAndTypesQueryResponse = {
  __typename: 'VisitDocumentNameStatusAndTypesQueryResponse';
  /** ISO encoded timestamp representing date/time when this document was added */
  addedOn: Scalars['ISODateTime'];
  id: Scalars['ID'];
  /** Name of the document */
  name: Scalars['String'];
  /** Association status of this document to active or archived workflows */
  status: VisitDocumentStatus;
  /** The types of visits, if any, which are actively associated with this document */
  visitTypes: Array<Scalars['String']>;
};

export type VisitDocumentResponse = {
  __typename: 'VisitDocumentResponse';
  /** The full body text of the document. */
  documentBody: Scalars['String'];
  /** The unique name of the document */
  documentName: Scalars['String'];
  id: Scalars['ID'];
  /** Whether the guest must provide a drawn signature when agreeing to this document */
  isSignatureRequired: Scalars['Boolean'];
  /** The locations which are associated with this document */
  locationIds: Array<Scalars['String']>;
  /** Notification emails associated with document */
  notificationEmails: Array<Scalars['String']>;
  /** Association status of this document to active or archived workflows */
  status: VisitDocumentStatus;
  /** The types of visits which are associated with this document */
  visitTypes: Array<Scalars['String']>;
};

export enum VisitEventAcknowledgement {
  VISIT_STARTING_SOON = 'VISIT_STARTING_SOON'
}

/** A VisitHost represents a host assigned to a visit with configurable settings */
export type VisitHost = {
  __typename: 'VisitHost';
  /** Host robin user */
  host: UserWithDefault;
  /** Host user ID */
  hostUserId: Scalars['ID'];
  /** Whether this host is visible to guests */
  isVisibleToGuests: Scalars['Boolean'];
  /** Whether this host receives notifications */
  sendNotifications: Scalars['Boolean'];
};

/** Input type for configuring a visit host */
export type VisitHostInput = {
  /** ID of user acting as host for this visit */
  hostUserId: Scalars['ID'];
  /** Whether this host is visible to guests */
  isVisibleToGuests?: InputMaybe<Scalars['Boolean']>;
  /** Whether this host receives notifications */
  sendNotifications?: InputMaybe<Scalars['Boolean']>;
};

export type VisitInputType = {
  /** What does the guest need to do when they arrive?. Default to null */
  arrivalInstructions?: InputMaybe<Scalars['String']>;
  /** ID of the location where the guests should arrive and check-in */
  arrivalLocationId: Scalars['ID'];
  /** ID of user acting as host for this visit */
  hostUserId: Scalars['ID'];
  /** Start time of visit represented by ISO 8601 date-time */
  startTime: Scalars['ISODateTime'];
  /** Reason for this visit */
  visitType: VisitType;
};

/** Identifies one visit invite to look up documents for, with its visit type and location. */
export type VisitInviteDocumentLookup = {
  locationId: Scalars['ID'];
  visitInviteId: Scalars['ID'];
  visitType: Scalars['String'];
};

/** Document overview for a single visit invite within a batch lookup. */
export type VisitInviteDocumentOverview = {
  __typename: 'VisitInviteDocumentOverview';
  /** Workflow documents for this visit invite (empty if the visit has no document workflow) */
  documents: Array<WorkflowDocumentOverviewForVisitor>;
  /** The visit invite these documents belong to */
  visitInviteId: Scalars['ID'];
};

export type VisitMagicLinkAuthResponse = {
  __typename: 'VisitMagicLinkAuthResponse';
  id: Scalars['ID'];
  tenantId: Scalars['String'];
  token: Scalars['String'];
  type: Scalars['String'];
};

export type VisitOrDefault = {
  __typename: 'VisitOrDefault';
  /** What does the guest need to do when they arrive?. Default to null */
  arrivalInstructions: Maybe<Scalars['String']>;
  /** Arrival location */
  arrivalLocation: Maybe<Location>;
  /** Visit unique identifier */
  arrivalLocationId: Maybe<Scalars['ID']>;
  /** Number of guests in the visit */
  guestCount: Maybe<Scalars['Int']>;
  /** Guest invitations */
  guestInvites: Maybe<Array<GuestInvite>>;
  /** Guests for this visit */
  guests: Maybe<Array<Guest>>;
  /** Host robin user */
  host: Maybe<UserWithDefault>;
  /** ID of user acting as host for this visit */
  hostUserId: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  /** Organization */
  organization: Maybe<Organization>;
  /** How was the visit created? */
  organizer: Maybe<VisitOrganizer>;
  /** Start time of visit represented by ISO 8601 date-time */
  startTime: Maybe<Scalars['ISODateTime']>;
  /** Reason for this visit */
  visitType: Maybe<VisitType>;
};


export type VisitOrDefaultGuestInvitesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type VisitOrDefaultGuestsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type VisitOrganizer = {
  __typename: 'VisitOrganizer';
  /** The arrival display that the visit was created on, if exists */
  arrivalDisplay: Maybe<PublicArrivalDisplay>;
  /** The ID of the entity from where the visit was created */
  id: Scalars['ID'];
  /** How the visit was created */
  type: VisitOrganizerType;
};

export enum VisitOrganizerType {
  ARRIVAL_DISPLAY = 'ARRIVAL_DISPLAY',
  ORGANIZATION_INTEGRATION = 'ORGANIZATION_INTEGRATION',
  USER = 'USER'
}

export enum VisitType {
  CUSTOMER_VISIT = 'CUSTOMER_VISIT',
  EVENT = 'EVENT',
  JOB_INTERVIEW = 'JOB_INTERVIEW',
  MAINTENANCE = 'MAINTENANCE',
  OTHER = 'OTHER',
  VIP_VISIT = 'VIP_VISIT'
}

export enum VisitTypeSource {
  DEFAULT = 'DEFAULT',
  LOCATION = 'LOCATION',
  ORGANIZATION = 'ORGANIZATION'
}

export type VisitTypeState = {
  __typename: 'VisitTypeState';
  activeLocationOverrides: Array<Scalars['ID']>;
  id: Scalars['ID'];
  inactiveLocationOverrides: Array<Scalars['ID']>;
  isActiveOrgWide: Scalars['Boolean'];
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
};

export type VisitWithIdInputType = {
  /** ID of the location where the guests should arrive and check-in */
  arrivalLocationId: Scalars['ID'];
  /** ID of user acting as host for this visit */
  hostUserId: Scalars['ID'];
  /** ID of the visit */
  id: Scalars['ID'];
  /** Start time of visit represented by ISO 8601 date-time */
  startTime: Scalars['ISODateTime'];
  /** Reason for this visit */
  visitType: VisitType;
};

export type VisitWorkflowOverview = {
  __typename: 'VisitWorkflowOverview';
  /** Workflow documents */
  documents: Array<WorkflowDocumentOverviewForVisitor>;
  /** Workflow ID */
  id: Scalars['ID'];
};

export type VisitorManagementPermissionScopes = {
  __typename: 'VisitorManagementPermissionScopes';
  /** A user with this permission has read/write access to any visit */
  canManageAllVisits: Maybe<PermissionScope>;
  /** A user with this permission has read/write access to any visit they host */
  canManageOwnVisits: Maybe<PermissionScope>;
  /** A user with this permission can manage visitor management itself */
  canManageVisits: Maybe<PermissionScope>;
  /** A user with this permission has read access to any visit */
  canViewAllVisits: Maybe<PermissionScope>;
  /** A user with this permission has read access to any visit they host */
  canViewOwnVisits: Maybe<PermissionScope>;
};

export type VisitorManagementPermissions = {
  __typename: 'VisitorManagementPermissions';
  canManageAllVisits: Maybe<Scalars['Boolean']>;
  canManageOwnVisits: Maybe<Scalars['Boolean']>;
  canManageVisits: Maybe<Scalars['Boolean']>;
  canViewAllVisits: Maybe<Scalars['Boolean']>;
  canViewOwnVisits: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  canViewVisits: Maybe<Scalars['Boolean']>;
};

export type WeeklyBookingCommand = {
  friday: BookingType;
  monday: BookingType;
  saturday: BookingType;
  sunday: BookingType;
  thursday: BookingType;
  tuesday: BookingType;
  wednesday: BookingType;
};

export type WeeklyBookingType = {
  __typename: 'WeeklyBookingType';
  friday: BookingType;
  monday: BookingType;
  saturday: BookingType;
  sunday: BookingType;
  thursday: BookingType;
  tuesday: BookingType;
  wednesday: BookingType;
};

export type WeeklyScheduleResult = {
  __typename: 'WeeklyScheduleResult';
  fri: Scalars['Boolean'];
  id: Scalars['String'];
  instanceEndTime: Scalars['UtcTime'];
  instanceStartTime: Scalars['UtcTime'];
  location: Maybe<Location>;
  mon: Scalars['Boolean'];
  sat: Scalars['Boolean'];
  sun: Scalars['Boolean'];
  thu: Scalars['Boolean'];
  tue: Scalars['Boolean'];
  wed: Scalars['Boolean'];
};

export type WhosInData = {
  __typename: 'WhosInData';
  byLocation: Maybe<Array<WhosInDataByLocation>>;
  totalNumberOfWhosIn: Scalars['Int'];
  whosIn: Maybe<Array<WhosInUser>>;
};


export type WhosInDataTotalNumberOfWhosInArgs = {
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type WhosInDataWhosInArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  preferredUserIds?: InputMaybe<Array<Scalars['ID']>>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type WhosInDataByDay = {
  __typename: 'WhosInDataByDay';
  date: Scalars['ISODateTime'];
  whosInData: Maybe<WhosInData>;
  /** @deprecated Deprecated in favor of whosInData.byLocation */
  whosInDataByLocation: Maybe<Array<WhosInDataByLocation>>;
};

export type WhosInDataByLocation = {
  __typename: 'WhosInDataByLocation';
  locationId: Scalars['ID'];
  totalNumberOfWhosIn: Scalars['Int'];
  whosIn: Maybe<Array<WhosInUser>>;
  /** @deprecated Deprecated in favor of totalNumberOfWhosIn and whosIn */
  whosInData: WhosInData;
};


export type WhosInDataByLocationWhosInArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  preferredUserIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type WhosInUser = {
  __typename: 'WhosInUser';
  deskReservationIds: Array<Scalars['String']>;
  employeeVisitId: Maybe<Scalars['String']>;
  isAnonymous: Scalars['Boolean'];
  locationId: Scalars['ID'];
  userEmail: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['String']>;
};

export type WindowAvailability = {
  __typename: 'WindowAvailability';
  end: Maybe<Scalars['Date']>;
  /** @deprecated Deprecated because the end becomes representing the pillEnd */
  pillEnd: Maybe<Scalars['Date']>;
  start: Maybe<Scalars['Date']>;
  status: Maybe<Availability>;
};

export type WorkArea = {
  __typename: 'WorkArea';
  /** Total desks within the level that fit within various scheduling type and status buckets */
  deskSchedulingAggregates: SchedulingAggregateOfDesks;
  desks: Array<Desk>;
  id: Scalars['ID'];
  level: Level;
  name: Scalars['String'];
};

export type WorkPolicy = {
  __typename: 'WorkPolicy';
  createdAt: Maybe<Scalars['ISODateTime']>;
  id: Scalars['ID'];
  interval: WorkPolicyInterval;
  isDefault: Scalars['Boolean'];
  message: Maybe<Scalars['String']>;
  name: Scalars['String'];
  rank: Maybe<Scalars['Int']>;
  status: WorkPolicyStatus;
  tooltipMessage: Maybe<Scalars['String']>;
};

export type WorkPolicyInput = {
  interval: WorkPolicyIntervalInput;
  message?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  status: WorkPolicyStatus;
  tooltipMessage?: InputMaybe<Scalars['String']>;
};

export type WorkPolicyInterval = {
  __typename: 'WorkPolicyInterval';
  frequency: Maybe<Scalars['Int']>;
  intervalType: WorkPolicyIntervalType;
  specificDays: Maybe<Array<Scalars['Int']>>;
};

export type WorkPolicyIntervalInput = {
  frequency?: InputMaybe<Scalars['Int']>;
  intervalType: WorkPolicyIntervalType;
  specificDays?: InputMaybe<Array<Scalars['Int']>>;
};

export enum WorkPolicyIntervalType {
  MONTHLY = 'MONTHLY',
  SPECIFIC_DAYS = 'SPECIFIC_DAYS',
  WEEKLY = 'WEEKLY'
}

export enum WorkPolicyStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  SCHEDULED = 'SCHEDULED'
}

export type WorkPolicyWithProgress = {
  __typename: 'WorkPolicyWithProgress';
  id: Scalars['ID'];
  interval: WorkPolicyInterval;
  message: Maybe<Scalars['String']>;
  minimumDaysProgress: Maybe<Scalars['Int']>;
  /** @deprecated Use minimumDaysProgress instead. */
  progress: Scalars['Int'];
  specificDaysProgress: Maybe<Array<Scalars['Int']>>;
  tooltipMessage: Maybe<Scalars['String']>;
};

/** A named grouping of workflows that a requester browses to find the one they want. Tickets created under a category share a key prefix (e.g. 'CAT-123'). Each concrete kind of workflow has its own kind of category - a meeting service never shares a category with an issue report workflow. */
export type WorkflowCategory = {
  id: Scalars['ID'];
  /** 'CAT' in ticket keys like 'CAT-123' */
  key: Scalars['String'];
  name: Scalars['String'];
};

export type WorkflowDocumentOverviewForVisitor = {
  __typename: 'WorkflowDocumentOverviewForVisitor';
  /** Is document complete for this visit */
  completionStatus: VisitDocumentCompletionStatus;
  id: Scalars['ID'];
  /** Is document required in workflow */
  isRequired: Scalars['Boolean'];
  /** Whether the guest must provide a drawn signature when agreeing to this document */
  isSignatureRequired: Scalars['Boolean'];
  /** Name of the document */
  name: Scalars['String'];
};

export type WorkingHours = {
  __typename: 'WorkingHours';
  day: Maybe<Scalars['Int']>;
  timeFrames: Array<TimeFrame>;
};

export type WorkingHoursInput = {
  day?: InputMaybe<DayOfWeek>;
  timeFrames: Array<TimeFrameInput>;
};

export type ZendeskIntegration = TicketIntegration & {
  __typename: 'ZendeskIntegration';
  baseUrl: Maybe<Scalars['String']>;
  createdAt: Scalars['ISODateTime'];
  /** When the integration stopped after its provider kept refusing its credentials; set only for DEACTIVATED. */
  deactivatedAt: Maybe<Scalars['ISODateTime']>;
  id: Scalars['ID'];
  /** @deprecated Use status. */
  isActive: Scalars['Boolean'];
  providerType: TicketProviderType;
  status: TicketIntegrationStatus;
  subdomain: Maybe<Scalars['String']>;
  /** Which directions sync runs in; each can be switched off without disconnecting. */
  syncDirections: TicketIntegrationSyncDirections;
};

/** A zone is an area within a space that represents a collection of desks or a table */
export type Zone = {
  __typename: 'Zone';
  desks: Array<Desk>;
  filteredDesksByAmenityIds: Array<Desk>;
  /** Zone ID is a unique identifier for the zone */
  id: Scalars['ID'];
  /** Name of the zone */
  name: Scalars['String'];
  /** Identifies the type of this zone. Zones can be Pods or Table */
  type: ZoneType;
  /** Stable identifier from robin-api, as 32 lowercase hex characters. Null for records that have not been assigned one yet. */
  uuid: Maybe<Scalars['ID']>;
};


/** A zone is an area within a space that represents a collection of desks or a table */
export type ZoneDesksArgs = {
  filters?: InputMaybe<Array<DeskFilters>>;
};


/** A zone is an area within a space that represents a collection of desks or a table */
export type ZoneFilteredDesksByAmenityIdsArgs = {
  ids: Array<Scalars['ID']>;
};

export type ZoneDeskReservation = {
  __typename: 'ZoneDeskReservation';
  reservations: Array<Reservation>;
  zoneId: Scalars['ID'];
};

/** Describes the type of zone */
export enum ZoneType {
  /** A pod is a collection of desks */
  POD = 'POD',
  /** A zone with the table type is typically a large table with many seats */
  TABLE = 'TABLE'
}

export enum ZoomOAuthHost {
  ZOOM_EU = 'ZOOM_EU',
  ZOOM_GOV = 'ZOOM_GOV',
  ZOOM_US = 'ZOOM_US'
}

export type CanAndShouldAskForPresencePermissionInMobileResponse = {
  __typename: 'canAndShouldAskForPresencePermissionInMobileResponse';
  shouldAsk: Scalars['Boolean'];
};

export type ForceResolveCsvUploadRecordsResponse = {
  __typename: 'forceResolveCSVUploadRecordsResponse';
  status: Scalars['String'];
  uuid: Scalars['String'];
};

export type SetGallagherEmailFieldIdentifierForIntegrationInput = {
  emailFieldIdentifier: Scalars['String'];
  integrationUuid: Scalars['ID'];
};

export type SetGallagherEmailFieldIdentifierForIntegrationResponse = {
  __typename: 'setGallagherEmailFieldIdentifierForIntegrationResponse';
  uuid: Scalars['ID'];
};

export type SetOpenpathCredentialProvisioningEnabledForIntegrationInput = {
  integrationUuid: Scalars['ID'];
  isEnabled: Scalars['Boolean'];
};

export type SetOpenpathCredentialProvisioningEnabledForIntegrationResponse = {
  __typename: 'setOpenpathCredentialProvisioningEnabledForIntegrationResponse';
  uuid: Scalars['ID'];
};

export type SetOpenpathPresenceReportingEnabledForIntegrationInput = {
  integrationUuid: Scalars['ID'];
  isEnabled: Scalars['Boolean'];
};

export type SetOpenpathPresenceReportingEnabledForIntegrationResponse = {
  __typename: 'setOpenpathPresenceReportingEnabledForIntegrationResponse';
  uuid: Scalars['ID'];
};

export type UpdateMeetingServiceRequestStatusResponse = UpdateMeetingServiceRequestStatusErrorResponse | UpdateMeetingServiceRequestStatusSuccessResponse;
